webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TARGET_TYPE; });
/* unused harmony export TARGET_TYPE_FILTER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DESTINATIONS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DESTINATIONS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DESTINATION_OBJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SOURCES_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VIEWING_STREAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STREAMING_OPTIONS; });
/* unused harmony export FIELDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TARGET_TYPES_INTEGERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LAS_TYPES; });
/* unused harmony export LAS_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ATT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ATT_SELECT_TYPE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FREQUENCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EXPORT_DAY_OF_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TARGET_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FREQUENCY_OPTION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MARKETPLACE_ENDPOINTS; });
/* unused harmony export EXTERNAL_ENDPOINTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LAS_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADDRESSABLE_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DIGITAL_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DDL_DESTINATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_destinations_LiveRamp_Default_png__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_destinations_LiveRamp_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_destinations_LiveRamp_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_destinations_LiveRamp_Selected_png__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_destinations_LiveRamp_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_destinations_LiveRamp_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_destinations_Symphony_Default_png__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_destinations_Symphony_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_destinations_Symphony_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_destinations_Symphony_Selected_png__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_destinations_Symphony_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_destinations_Symphony_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_destinations_Krux_Default_png__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_destinations_Krux_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_destinations_Krux_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_destinations_Krux_Selected_png__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_destinations_Krux_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_destinations_Krux_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_destinations_DirecTV_Default_png__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_destinations_DirecTV_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_destinations_DirecTV_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_destinations_DirecTV_Selected_png__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_destinations_DirecTV_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_destinations_DirecTV_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_destinations_Vizio_Default_png__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_destinations_Vizio_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_destinations_Vizio_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_destinations_Vizio_Selected_png__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_destinations_Vizio_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_destinations_Vizio_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_destinations_Canoe_Default_png__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_destinations_Canoe_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_destinations_Canoe_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_destinations_Canoe_Selected_png__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_destinations_Canoe_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_destinations_Canoe_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_destinations_Canoe_VOD_Default_png__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_destinations_Canoe_VOD_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_destinations_Canoe_VOD_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_destinations_Canoe_VOD_Selected_png__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_destinations_Canoe_VOD_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_destinations_Canoe_VOD_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_destinations_Foresite_Default_png__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_destinations_Foresite_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_destinations_Foresite_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_destinations_Foresite_Selected_png__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_destinations_Foresite_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_destinations_Foresite_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_destinations_Lake5_Default_png__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_destinations_Lake5_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_destinations_Lake5_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_destinations_Lake5_Selected_png__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_destinations_Lake5_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_destinations_Lake5_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_destinations_Freewheel_Default_png__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_destinations_Freewheel_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_destinations_Freewheel_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_destinations_Freewheel_Selected_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_destinations_Freewheel_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_destinations_Freewheel_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_destinations_GAM_Default_png__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_destinations_GAM_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_destinations_GAM_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_destinations_GAM_Selected_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_destinations_GAM_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_destinations_GAM_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_destinations_Videoamp_Default_png__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_destinations_Videoamp_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_destinations_Videoamp_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_destinations_Videoamp_Selected_png__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_destinations_Videoamp_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_destinations_Videoamp_Selected_png__);


























var ACTIVATION_STATUS = {
  DRAFT: 'DRAFT',
  NEW: 'NEW',
  WORKING: 'WORKING',
  ASSIGNED: 'ASSIGNED',
  ACTIVATED: 'ACTIVATED',
  POSTED: 'FORECASTED',
  SUBMITTED: 'SUBMITTED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  LIVE: 'LIVE',
  MODELING: 'MODELING',
  MODELED: 'MODELED',
  MODEL_FAILED: 'MODEL FAILED'
};

var ATT_STATUS = {
  PLANNING: 'Planning',
  ORDERED: 'Ordered',
  CANCELLED: 'Cancelled'
};

var TARGET_TYPE = {
  LAS: 'linear_ad_sales',
  SD: 'social_digital',
  AD: 'audience_discovery',
  COMSCORE_TV: 'comscore_tv',
  NPOWER: 'npower',
  PID: 'pid',
  ATT: 'att-dtv',
  XANDR_SEGMENT: 'xandr_segment',
  COMSCORE: 'comscore',
  ADSTRA: 'adstra',
  PRISM: 'prism',
  DNB: 'dnb',
  MAX: 'max',
  BYOD: 'byod',
  VIDEOAMP: 'videoamp',
  TVE: 'tve',
  EPSILON: 'epsilon',
  EPSILON_EXPANDABLE: 'epsilon_expandable',
  DISCOVERY_PLUS: 'd+',
  DCR: 'dcr',
  DC_COMICS: 'dc_comics',
  LIVERAMP: 'liveramp',
  WBGAMES: 'wbgames',
  RETARGETING: 'retargeting',
  FREEWHEEL: 'FreeWheel',
  GOOGLE_AD_MANAGER: 'GoogleAdManager',
  LAL: 'LAL',
  CNN: 'cnn',
  MOSAIC: 'mosaic'
};

var TARGET_TYPE_FILTER = {
  LAS: {
    name: 'Linear Ad Sales',
    value: 'linear_ad_sales',
    checked: true,
    visible: true
  },
  SD: {
    name: 'Social Digital',
    value: 'social_digital',
    checked: true,
    visible: true
  },
  AD: {
    name: 'Audience Discovery',
    value: 'audience_discovery',
    checked: true,
    visible: true
  },
  NPOWER: {
    name: 'Npower',
    value: 'npower',
    checked: true,
    visible: true
  },
  PID: {
    name: 'PID',
    value: 'pid',
    checked: true,
    visible: true
  },
  ATT: {
    name: 'Xandr File',
    value: 'att-dtv',
    checked: true,
    visible: true
  },
  XANDR_SEGMENT: {
    name: 'Xandr Linear',
    value: 'xandr_segment',
    checked: true,
    visible: true
  },
  ADSTRA: {
    name: 'Adstra',
    value: 'adstra',
    checked: true,
    visible: true
  },
  COMSCORE: {
    name: 'Custom',
    value: 'comscore',
    checked: true,
    visible: true
  },
  OPENAP: {
    name: 'OpenAP',
    value: 'openap',
    checked: true,
    visible: true
  }
};

var SOURCES_FILTER = {
  AMRLD: {
    name: 'AMRLD',
    value: 'amrld',
    checked: true,
    visible: true
  },
  MRI: {
    name: 'MRI',
    value: 'mri',
    checked: true,
    visible: true
  },
  NIELSEN: {
    name: 'NPOWER',
    value: 'npower',
    checked: true,
    visible: true
  },
  OPENAP: {
    name: 'OPENAP',
    value: 'openap',
    checked: true,
    visible: true
  },
  EPSILON: {
    name: 'Epsilon Legacy',
    value: 'epsilon',
    checked: true,
    visible: true
  },
  EPSILON_EXPANDABLE: {
    name: 'Epsilon',
    value: 'epsilon_expandable',
    checked: true,
    visible: true
  },
  NCS: {
    name: 'NCS',
    value: 'ncs',
    checked: true,
    visible: true
  },
  PID: {
    name: 'PID',
    value: 'pid',
    checked: true,
    visible: true
  },
  ADSTRA: {
    name: 'ADSTRA',
    value: 'adstra',
    checked: true,
    visible: true
  },
  COMSCORE: {
    name: 'COMSCORE',
    value: 'comscore',
    checked: true,
    visible: true
  },
  COMSCORE_TV: {
    name: 'COMSCORE_TV',
    value: 'comscore_tv',
    checked: true,
    visible: true
  },
  PRISM: {
    name: 'PRISM',
    value: 'prism',
    checked: true,
    visible: true
  },
  DNB: {
    name: 'DNB',
    value: 'dnb',
    checked: true,
    visible: true
  },
  MAX: {
    name: 'MAX',
    value: 'max',
    checked: true,
    visible: true
  },
  TVE: {
    name: 'TVE',
    value: 'tve',
    checked: true,
    visible: true
  },
  DCR: {
    name: 'DCR',
    value: 'dcr',
    checked: true,
    visible: true
  },
  DC_COMICS: {
    name: 'DC_COMICS',
    value: 'dc_comics',
    checked: true,
    visible: true
  },
  BYOD: {
    name: 'BYOD',
    value: 'byod',
    checked: true,
    visible: true
  },
  VIDEOAMP: {
    name: 'VIDEOAMP',
    value: 'videoamp',
    checked: true,
    visible: true
  },
  DISCOVERY_PLUS: {
    name: 'D+',
    value: 'd+',
    checked: true,
    visible: true
  },
  LIVERAMP: {
    name: 'LIVERAMP',
    value: 'liveramp',
    checked: true,
    visible: true
  },
  WBGAMES: {
    name: 'WBGAMES',
    value: 'wbgames',
    checked: true,
    visible: true
  },
  RETARGETING: {
    name: 'RETARGETING',
    value: 'retargeting',
    checked: true,
    visible: true
  },
  FREEWHEEL: {
    name: 'FreeWheel',
    value: 'FreeWheel',
    checked: true,
    visible: true
  },
  GOOGLE_AD_MANAGER: {
    name: 'Google Ad Manager',
    value: 'GoogleAdManager',
    checked: true,
    visible: true
  },
  LAL: {
    name: 'LAL',
    value: 'LAL',
    checked: true,
    visible: true
  },
  CNN: {
    name: 'CNN',
    value: 'cnn',
    checked: true,
    visible: true
  },
  MOSAIC: {
    name: 'MOSAIC',
    value: 'mosaic',
    checked: true,
    visible: true
  }
};

var TARGET_TYPES_INTEGERS = {
  LAS: 1,
  AD: 2,
  SD: 3,
  NPOWER: 4,
  PID: 5,
  ATT: 6,
  COMSCORE_TV: 7,
  XANDR_SEGMENT_ADVERTISING: 8,
  XANDR_SEGMENT_RESEARCH: 9,
  XANDR_SEGMENT_MARKETING: 10,
  COMSCORE: 11,
  ADSTRA: 12,
  PRISM: 13,
  BYOD: 14,
  DNB: 15,
  MAX: 16,
  TVE: 17,
  VIDEOAMP: 19,
  DISCOVERY_PLUS: 18,
  DCR: 21,
  LIVERAMP: 22,
  WBGAMES: 23,
  RETARGETING: 24,
  FREEWHEEL: 25,
  GOOGLE_AD_MANAGER: 26,
  LAL: 27,
  DC_COMICS: 28,
  CNN: 29,
  MOSAIC: 30,
  EPSILON_EXPANDABLE: 31
};

var actions = {
  ALL_TARGETS: 'ALL_TARGETS',
  MY_OPEN_AP: 'MY_OPEN_AP',
  OPEN_AP: 'ALL_OPEN_AP',
  MY_TARGETS: 'MY_TARGETS',
  ARCHIVED_TARGETS: 'ARCHIVED_TARGETS',
  MY_ARCHIVED_TARGETS: 'MY_ARCHIVED_TARGETS'
};

var DESTINATIONS = {
  SYMPHONY: 'Symphony',
  KRUX: 'Krux',
  LIVERAMP: 'LiveRamp',
  DIRECTV: 'DirecTV',
  ATT_TV: 'AT&T-TV',
  VIZIO: 'Vizio',
  CANOE_LINEAR: 'CanoeLinear',
  CANOE_VOD: 'CanoeVOD',
  FORESITE: 'Foresite',
  FREEWHEEL: 'FreeWheel',
  GOOGLE_AD_MANAGER: 'GoogleAdManager',
  BLANK: 'Blank',
  LAKE5: 'Lake5',
  VIDEOAMP: 'VideoAmp'
};

var DESTINATIONS_ID = {
  DIRECTV_49: '49',
  DIRECTV_350: '350',
  VIZIO: '103'
};

var DESTINATIONS_FILTER = {
  SYMPHONY: {
    name: 'Symphony',
    value: 'Symphony',
    checked: true,
    visible: true
  },
  KRUX: {
    name: 'Krux',
    value: 'Krux',
    checked: true,
    visible: true
  },
  LIVERAMP: {
    name: 'LiveRamp',
    value: 'LiveRamp',
    checked: true,
    visible: true
  },
  FREEWHEEL: {
    name: 'FreeWheel',
    value: 'FreeWheel',
    checked: true,
    visible: true
  },
  GOOGLE_AD_MANAGER: {
    name: 'Google Ad Manager',
    value: 'GoogleAdManager',
    checked: true,
    visible: true
  },
  DIGITAL: {
    name: 'Digital',
    value: ['FreeWheel', 'GoogleAdManager'],
    checked: true,
    visible: true
  },
  SOCIAL_DIGITAL: {
    name: 'Social Digital',
    value: ['Krux', 'LiveRamp'],
    checked: true,
    visible: true
  },
  DIRECTV: {
    name: 'DirecTV',
    value: 'DirecTV',
    checked: true,
    visible: true
  },
  VIZIO: {
    name: 'Vizio',
    value: 'Vizio',
    checked: true,
    visible: true
  },
  CANOE_LINEAR: {
    name: 'Canoe Linear',
    value: 'CanoeLinear',
    checked: true,
    visible: true
  },
  CANOE_VOD: {
    name: 'Canoe VOD',
    value: 'CanoeVOD',
    checked: true,
    visible: true
  },
  ADDRESSABLE: {
    name: 'Addressable',
    value: ['DirecTV', 'Vizio', 'CanoeLinear', 'CanoeVOD'],
    checked: true,
    visible: true
  },
  FORESITE: {
    name: 'Foresite',
    value: 'Foresite',
    checked: true,
    visible: true
  },
  BLANK: {
    name: '(Blanks)',
    value: 'Blank',
    checked: true,
    visible: true
  },
  LAKE5: {
    name: 'Lake5',
    value: 'Lake5',
    checked: true,
    visible: true
  },
  VIDEOAMP: {
    name: 'VideoAmp',
    value: 'VideoAmp',
    checked: true,
    visible: true
  }
};

var DESTINATION_OBJECTS = [{
  id: DESTINATIONS.SYMPHONY,
  img: {
    default: __WEBPACK_IMPORTED_MODULE_3__assets_destinations_Symphony_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_4__assets_destinations_Symphony_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.KRUX,
  img: {
    default: __WEBPACK_IMPORTED_MODULE_5__assets_destinations_Krux_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_6__assets_destinations_Krux_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.LIVERAMP,
  img: {
    default: __WEBPACK_IMPORTED_MODULE_1__assets_destinations_LiveRamp_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_2__assets_destinations_LiveRamp_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.VIZIO,
  label: DESTINATIONS.VIZIO + ' (OAR)',
  img: {
    default: __WEBPACK_IMPORTED_MODULE_9__assets_destinations_Vizio_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_10__assets_destinations_Vizio_Selected_png___default.a
  },
  isDisabled: false,
  isHidden: !true
}, {
  id: DESTINATIONS.DIRECTV,
  img: {
    default: __WEBPACK_IMPORTED_MODULE_7__assets_destinations_DirecTV_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_8__assets_destinations_DirecTV_Selected_png___default.a
  },
  isDisabled: false,
  isHidden: !true
}, {
  id: DESTINATIONS.CANOE_LINEAR,
  label: 'Canoe Linear',
  img: {
    default: __WEBPACK_IMPORTED_MODULE_11__assets_destinations_Canoe_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_12__assets_destinations_Canoe_Selected_png___default.a
  },
  isDisabled: false,
  isHidden: !true
}, {
  id: DESTINATIONS.CANOE_VOD,
  label: 'Canoe VOD',
  img: {
    default: __WEBPACK_IMPORTED_MODULE_13__assets_destinations_Canoe_VOD_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_14__assets_destinations_Canoe_VOD_Selected_png___default.a
  },
  isDisabled: false,
  isHidden: !true
}, {
  id: DESTINATIONS.FORESITE,
  label: 'Foresite',
  img: {
    default: __WEBPACK_IMPORTED_MODULE_15__assets_destinations_Foresite_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_16__assets_destinations_Foresite_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.FREEWHEEL,
  img: {
    default: __WEBPACK_IMPORTED_MODULE_19__assets_destinations_Freewheel_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_20__assets_destinations_Freewheel_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.GOOGLE_AD_MANAGER,
  img: {
    default: __WEBPACK_IMPORTED_MODULE_21__assets_destinations_GAM_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_22__assets_destinations_GAM_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.LAKE5,
  label: 'Lake5',
  img: {
    default: __WEBPACK_IMPORTED_MODULE_17__assets_destinations_Lake5_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_18__assets_destinations_Lake5_Selected_png___default.a
  },
  isDisabled: false
}, {
  id: DESTINATIONS.VIDEOAMP,
  label: 'VideoAmp',
  img: {
    default: __WEBPACK_IMPORTED_MODULE_23__assets_destinations_Videoamp_Default_png___default.a,
    selected: __WEBPACK_IMPORTED_MODULE_24__assets_destinations_Videoamp_Selected_png___default.a
  },
  isDisabled: false
}];

var VIEWING_STREAMS = {
  LIVE: 'live',
  LSD: 'lsd',
  C3: 'c3',
  C7: 'c7',
  LIVE3: 'l3'
};

var LAS_TYPES = {
  ATT: 'AT&T',
  AM: 'Audience Matters',
  NPOWER: 'NPOWER',
  COMSCORE: 'COMSCORE',
  PID: 'PID',
  XANDR: 'Xandr'
};

var LAS_OPTIONS = [{ Name: 'Xandr Upload', value: LAS_TYPES.XANDR }, { Name: 'Audience Matters', value: LAS_TYPES.AM }, { Name: 'NPower Upload', value: LAS_TYPES.NPOWER }, { Name: 'PID Upload', value: LAS_TYPES.PID }, { Name: 'Xandr', value: LAS_TYPES.XANDR }];

var STREAMING_OPTIONS = [{ Name: 'Live', value: VIEWING_STREAMS.LIVE }, { Name: 'Live Same Day', value: VIEWING_STREAMS.LSD }, { Name: 'C7', value: VIEWING_STREAMS.C7 }, { Name: 'C3', value: VIEWING_STREAMS.C3 }];

var FREQUENCIES = {
  ONE_TIME: 'ONE TIME',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY'
};

var EXPORT_DAY_OF_WEEK = [{ Name: 'Sunday', value: 0 }, { Name: 'Thursday', value: 4 }, { Name: 'Friday', value: 5 }, { Name: 'Saturday', value: 6 }];

var FIELDS = {
  targetType: 'target',
  lastUpdated: 'last_update',
  activationStatus: 'activation_status',
  datasources: 'target_datasource',
  viewingStream: 'viewing_stream',
  destinations: 'destinations'
};

var ATT_SELECT_TYPE_OPTIONS = {
  DAILY: 1,
  AD_HOC: 2,
  AUDIENCE_BUILDER: 3
};

var TARGET_ACTIONS = {
  DUPLICATE: 'Duplicate',
  UPDATE: 'Update',
  UPDATE_CAMPAIGN: 'Update Campaign',
  NEW: 'New',
  SEGMENT_INFO: 'Segment Info',
  ACTIVATE: 'Activate'
};

var INTENTS = {
  Marketing: {
    Name: 'Marketing',
    IntentId: 1,
    IsActive: true
  },
  Sales: {
    Name: 'Sales',
    IntentId: 2,
    IsActive: true
  },
  Research: {
    Name: 'Research',
    IntentId: 3,
    IsActive: true
  }
};

var FREQUENCY_OPTION_SET = {
  LINEAR: 1,
  XANDR_SOCIAL_DIGITAL: 3,
  DIRECTV: 4,
  VIZIO: 5,
  CANOE_LINEAR: 6,
  CANOE_VOD: 7,
  ADSTRA: 8,
  DIGITAL: 9,
  VIDEOAMP: 10
};

var MARKETPLACE_ENDPOINTS = {
  DIRECTV: 'DirecTV',
  VIZIO: 'OAR',
  CANOE_LINEAR: 'Canoe Linear',
  CANOE_VOD: 'Canoe VOD'
};

var EXTERNAL_ENDPOINTS = {
  DIRECTV: '3',
  VIZIO: '6',
  CANOE_LINEAR: '8',
  CANOE_VOD: '9'
};

var LAS_DESTINATIONS = [DESTINATIONS.FORESITE];

var ADDRESSABLE_DESTINATIONS = [DESTINATIONS.DIRECTV, DESTINATIONS.VIZIO].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()( true ? [DESTINATIONS.CANOE_LINEAR] : []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()( true ? [DESTINATIONS.CANOE_VOD] : []));

var DIGITAL_DESTINATIONS = [DESTINATIONS.FREEWHEEL, DESTINATIONS.GOOGLE_AD_MANAGER];

var DDL_DESTINATIONS = [DESTINATIONS.VIDEOAMP];



/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgIcon_vue__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SvgIcon_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SvgIcon_vue___default.a);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHeaders */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authorizedAPIs; });
/* unused harmony export refreshToken */
/* harmony export (immutable) */ __webpack_exports__["S"] = refreshIDMToken;
/* harmony export (immutable) */ __webpack_exports__["U"] = getUserPermissions;
/* unused harmony export fetchSMTargetConfig */
/* harmony export (immutable) */ __webpack_exports__["q"] = fetchNetworksConfig;
/* unused harmony export login */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return fetchEsDateRanges; });
/* unused harmony export fetchPostData */
/* unused harmony export assignOpenAPTarget */
/* unused harmony export importOpenAPTarget */
/* unused harmony export saveOpenAPTarget */
/* unused harmony export getOpenAPTarget */
/* unused harmony export fetchTargetMetrics */
/* unused harmony export fetchTargetAudienceSize */
/* unused harmony export fetchTargetHistoricalViewership */
/* unused harmony export callSegmentation */
/* unused harmony export fetchTargetUniverse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchTargetDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return fetchAgeDistribution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return fetchIncomeDistribution; });
/* harmony export (immutable) */ __webpack_exports__["t"] = fetchTargetData;
/* unused harmony export fetchAdTargetMetrics */
/* unused harmony export fetchAdTargetAudienceSize */
/* unused harmony export fetchAdTargetHistoricalViewership */
/* unused harmony export fetchAdTargetUniverse */
/* harmony export (immutable) */ __webpack_exports__["_5"] = fetchAdTargetData;
/* harmony export (immutable) */ __webpack_exports__["_7"] = fetchSmTargetData;
/* harmony export (immutable) */ __webpack_exports__["Z"] = fetchTargets;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchSingleTarget;
/* harmony export (immutable) */ __webpack_exports__["_4"] = getTargetHistory;
/* harmony export (immutable) */ __webpack_exports__["_3"] = appendTargetHistory;
/* harmony export (immutable) */ __webpack_exports__["V"] = searchAdvertisers;
/* harmony export (immutable) */ __webpack_exports__["W"] = fetchMarketingNetworks;
/* harmony export (immutable) */ __webpack_exports__["j"] = deleteTarget;
/* harmony export (immutable) */ __webpack_exports__["O"] = parseNPowerFile;
/* harmony export (immutable) */ __webpack_exports__["P"] = parseComscoreFile;
/* harmony export (immutable) */ __webpack_exports__["x"] = uploadNPowerSegments;
/* harmony export (immutable) */ __webpack_exports__["z"] = sendNPowerDownstream;
/* harmony export (immutable) */ __webpack_exports__["A"] = sendComscoreDownstream;
/* harmony export (immutable) */ __webpack_exports__["y"] = uploadComscoreSegments;
/* harmony export (immutable) */ __webpack_exports__["_1"] = updateTargetUE;
/* harmony export (immutable) */ __webpack_exports__["k"] = archiveTarget;
/* harmony export (immutable) */ __webpack_exports__["l"] = unArchiveTarget;
/* harmony export (immutable) */ __webpack_exports__["m"] = createTarget;
/* harmony export (immutable) */ __webpack_exports__["r"] = saveTarget;
/* harmony export (immutable) */ __webpack_exports__["C"] = activateTarget;
/* harmony export (immutable) */ __webpack_exports__["n"] = duplicateTarget;
/* harmony export (immutable) */ __webpack_exports__["_6"] = submitToDC;
/* harmony export (immutable) */ __webpack_exports__["o"] = notifyAdCity;
/* harmony export (immutable) */ __webpack_exports__["_0"] = sendToLake5;
/* unused harmony export getTargetUploadUrl */
/* unused harmony export createTargetWithNoActuals */
/* harmony export (immutable) */ __webpack_exports__["F"] = uploadTargetFile;
/* harmony export (immutable) */ __webpack_exports__["v"] = getUploadTargetData;
/* harmony export (immutable) */ __webpack_exports__["B"] = moveStagedFileToUpload;
/* harmony export (immutable) */ __webpack_exports__["H"] = getTargetPidLists;
/* harmony export (immutable) */ __webpack_exports__["_2"] = downloadFile;
/* harmony export (immutable) */ __webpack_exports__["Y"] = getTargetsByTargetType;
/* harmony export (immutable) */ __webpack_exports__["X"] = deleteTargetResource;
/* harmony export (immutable) */ __webpack_exports__["G"] = uploadFile;
/* harmony export (immutable) */ __webpack_exports__["N"] = exportTargetDefinition;
/* harmony export (immutable) */ __webpack_exports__["Q"] = checkPIDComplete;
/* harmony export (immutable) */ __webpack_exports__["w"] = overwritePIDFiles;
/* harmony export (immutable) */ __webpack_exports__["i"] = editTarget;
/* harmony export (immutable) */ __webpack_exports__["g"] = postTarget;
/* harmony export (immutable) */ __webpack_exports__["h"] = validateLASDataAvailable;
/* harmony export (immutable) */ __webpack_exports__["p"] = validateTargetName;
/* unused harmony export validateCampaignName */
/* harmony export (immutable) */ __webpack_exports__["D"] = getTargetResources;
/* unused harmony export sendPostData */
/* harmony export (immutable) */ __webpack_exports__["K"] = rePostTarget;
/* harmony export (immutable) */ __webpack_exports__["J"] = getDroppedAttributesByQuarter;
/* harmony export (immutable) */ __webpack_exports__["u"] = logXandrAction;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRoles;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPermissions;
/* harmony export (immutable) */ __webpack_exports__["T"] = getUserPermissionsWithAuth;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateRolePermissions;
/* harmony export (immutable) */ __webpack_exports__["b"] = logIntoIDM;
/* unused harmony export batchLimitMaxCalls */
/* harmony export (immutable) */ __webpack_exports__["E"] = getComscoreDemos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_format__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elasticsearch_LAS_age__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elasticsearch_LAS_broadcastDates__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__elasticsearch_LAS_historicalViewership__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elasticsearch_LAS_income__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__elasticsearch_LAS_metrics__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__elasticsearch_LAS_targetDefinition__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__elasticsearch_LAS_universeEstimate__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_ConfigAPI__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__NotificationAPI__ = __webpack_require__(688);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_21__NotificationAPI__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PermissionsAPI__ = __webpack_require__(83);
/* unused harmony reexport PermissionAPI */


























var API_ROOT_TARGET_MANAGER = "https://api.audiencematters.turnerapps.com/workbench";
var API_V2_ROOT = "https://api.audiencematters.turnerapps.com/v2";
var API_ROOT_TARGET_MANAGER_NODE = "https://api.audiencematters.turnerapps.com/node";
var API_ROOT_LAS = "https://api.audiencematters.turnerapps.com/las";
var API_ROOT_SM = "https://api.audiencematters.turnerapps.com/sm";
var LOAD_BALANCER = "https://prod.lb.api.audiencematters.turnerapps.com";
var API_FOR_XANDR = "https://api.audiencematters.turnerapps.com/xandr";

var getHeaders = function getHeaders() {
  var headers = {
    Authorization: JSON.parse(localStorage['okta-token-storage']).accessToken.accessToken,
    'X-Username': __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.auth.username
  };
  return headers;
};

var runAuthorizationAPI = function runAuthorizationAPI(runFunc, timesRun) {
  timesRun = timesRun || 1;
  if (timesRun > 15) {
    return runFunc();
  }
  return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var hasToken = __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.auth.token;

    if (hasToken) {
      resolve(runFunc());
    } else {
      setTimeout(function () {
        resolve(runAuthorizationAPI(runFunc, timesRun + 1));
      }, 150);
    }
  });
};

var postAuthorization = function postAuthorization(url, payload) {
  return runAuthorizationAPI(function () {
    return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(url, payload, {
      headers: getHeaders()
    });
  });
};

var putAuthorization = function putAuthorization(url, payload) {
  return runAuthorizationAPI(function () {
    return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(url, payload, {
      headers: getHeaders()
    });
  });
};

var getAuthorization = function getAuthorization(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return runAuthorizationAPI(function () {
    return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, params, {
      headers: getHeaders()
    }));
  });
};

var deleteAuthorization = function deleteAuthorization(url) {
  return runAuthorizationAPI(function () {
    return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.delete(url, {
      headers: getHeaders()
    });
  });
};

var authorizedAPIs = {
  post: postAuthorization,
  put: putAuthorization,
  get: getAuthorization,
  delete: deleteAuthorization
};

function refreshToken() {
  var url = API_ROOT_TARGET_MANAGER + '/RefreshToken';
  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(url, { refresh_token: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.auth.refreshToken });
}

function refreshIDMToken() {
  var url = API_ROOT_TARGET_MANAGER_NODE + '/IDMToken/Refresh';
  return postAuthorization(url, { refreshToken: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.idmAuth.refreshToken }).then(function (resp) {
    return resp.data;
  });
}

function getUserPermissions() {
  var url = API_ROOT_TARGET_MANAGER_NODE + '/UserPermissions';
  return postAuthorization(url, { username: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.auth.username });
}

function fetchSMTargetConfig() {
  return __WEBPACK_IMPORTED_MODULE_20__api_ConfigAPI__["a" /* default */].getConfigFilesForConfigType('sm-target-config.json').fetchConfig();
}

function fetchNetworksConfig() {
  return __WEBPACK_IMPORTED_MODULE_20__api_ConfigAPI__["a" /* default */].getConfigFilesForConfigType('networks').fetchConfig();
}

function login(credentials) {
  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(API_ROOT_TARGET_MANAGER_NODE + '/Login', credentials);
}

var fetchEsDateRanges = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
    var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'amrld';
    var result, aggs, dateRanges, mriLatestMonth, ncsLatestMonth;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__elasticsearch_LAS_broadcastDates__["a" /* default */])(dataSource);

          case 2:
            result = _context.sent;
            aggs = result.data.aggregations;
            dateRanges = aggs.months.buckets.map(function (m) {
              return {
                name: m.key_as_string,
                from: m.start_date.value_as_string,
                to: m.end_date.value_as_string
              };
            });
            mriLatestMonth = aggs.mri.latest_month.value_as_string;
            ncsLatestMonth = aggs.ncs.latest_month.value_as_string;
            return _context.abrupt('return', { dateRanges: dateRanges, mriLatestMonth: mriLatestMonth, ncsLatestMonth: ncsLatestMonth });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchEsDateRanges() {
    return _ref.apply(this, arguments);
  };
}();

function fetchPostData(args) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/PostInfo', args).catch(function (error) {
    console.log(error);
  });
}

function assignOpenAPTarget(_ref2) {
  var target_id = _ref2.target_id,
      assignor = _ref2.assignor,
      owner = _ref2.owner;

  return postAuthorization(API_ROOT_TARGET_MANAGER + '/OpenAP/AssignTarget', {
    target_id: target_id,
    assignor: assignor,
    username: owner
  }).catch(function (error) {
    console.log(error);
  });
}

function importOpenAPTarget(_ref3) {
  var segment_id = _ref3.segment_id,
      username = _ref3.username,
      target_id = _ref3.target_id,
      viewing_stream = _ref3.viewing_stream,
      advertiser = _ref3.advertiser,
      history_start_date = _ref3.history_start_date,
      history_end_date = _ref3.history_end_date;

  return postAuthorization(API_ROOT_TARGET_MANAGER + '/OpenAP/ImportTarget', {
    segment_id: segment_id,
    username: username,
    target_id: target_id,
    viewing_stream: viewing_stream,
    advertiser: advertiser,
    history_start_date: history_start_date,
    history_end_date: history_end_date
  }).catch(function (error) {
    console.log(error);
  });
}

function saveOpenAPTarget(_ref4) {
  var name = _ref4.name,
      username = _ref4.username,
      segment_id = _ref4.segment_id,
      viewing_stream = _ref4.viewing_stream,
      advertiser = _ref4.advertiser,
      history_start_date = _ref4.history_start_date,
      history_end_date = _ref4.history_end_date;

  return postAuthorization(API_ROOT_TARGET_MANAGER + '/OpenAP/SaveTarget', {
    name: name,
    username: username,
    segment_id: segment_id,
    viewing_stream: viewing_stream,
    advertiser: advertiser,
    history_start_date: history_start_date,
    history_end_date: history_end_date
  }).catch(function (error) {
    console.log(error);
  });
}

function getOpenAPTarget(segmentId) {
  return getAuthorization(API_ROOT_TARGET_MANAGER + '/OpenAP/Target?target_id=' + segmentId);
}

var fetchTargetMetrics = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(args) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__elasticsearch_LAS_metrics__["a" /* default */])(args);

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchTargetMetrics(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

function fetchTargetAudienceSize(args) {
  return postAuthorization(API_ROOT_LAS + '/LAS/TargetAudience', args).catch(function (error) {
    console.log(error);
  });
}

var fetchTargetHistoricalViewership = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(args) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__elasticsearch_LAS_historicalViewership__["a" /* default */])(args);

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function fetchTargetHistoricalViewership(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

function callSegmentation(promiseCall, data, segmentLimit) {
  var collectionOfResponses = [];
  var turns = [];
  for (var i = 0; i < data.length; i += segmentLimit) {
    turns.push(data.slice(i, i + segmentLimit));
  }
  return callPromiseSegment(promiseCall, turns, 0, collectionOfResponses);
}

var callPromiseSegment = function callPromiseSegment(promise, turns, currentTurn, responses) {
  return promise(turns[currentTurn]).then(function (resp) {
    responses.push(resp);
    currentTurn += 1;
    if (turns.length === currentTurn) {
      return responses;
    } else {
      return callPromiseSegment(promise, turns, currentTurn, responses);
    }
  });
};

var fetchTargetUniverse = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(args) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__elasticsearch_LAS_universeEstimate__["a" /* default */])(args);

          case 2:
            return _context4.abrupt('return', _context4.sent);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function fetchTargetUniverse(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

var fetchTargetDefinition = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9) {
    var startDate = _ref9.startDate,
        endDate = _ref9.endDate,
        query = _ref9.query,
        viewSource = _ref9.viewSource;
    var args;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            args = convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource });
            _context5.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__elasticsearch_LAS_targetDefinition__["a" /* default */])(args);

          case 3:
            return _context5.abrupt('return', _context5.sent);

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function fetchTargetDefinition(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

var fetchAgeDistribution = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(_ref11) {
    var query = _ref11.query,
        startDate = _ref11.startDate,
        endDate = _ref11.endDate,
        viewSource = _ref11.viewSource;
    var args;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            args = convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource });
            _context6.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__elasticsearch_LAS_age__["a" /* default */])(args);

          case 3:
            return _context6.abrupt('return', _context6.sent);

          case 4:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function fetchAgeDistribution(_x7) {
    return _ref10.apply(this, arguments);
  };
}();

var fetchIncomeDistribution = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(_ref13) {
    var query = _ref13.query,
        startDate = _ref13.startDate,
        endDate = _ref13.endDate,
        viewSource = _ref13.viewSource;
    var args;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            args = convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource });
            _context7.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__elasticsearch_LAS_income__["a" /* default */])(args);

          case 3:
            return _context7.abrupt('return', _context7.sent);

          case 4:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function fetchIncomeDistribution(_x8) {
    return _ref12.apply(this, arguments);
  };
}();

function fetchTargetData(_ref14) {
  var query = _ref14.query,
      startDate = _ref14.startDate,
      endDate = _ref14.endDate,
      networks = _ref14.networks,
      viewSource = _ref14.viewSource;

  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.all([fetchTargetMetrics(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource })), fetchTargetHistoricalViewership(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, networks: networks, viewSource: viewSource })), fetchTargetUniverse(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query }))]).then(__WEBPACK_IMPORTED_MODULE_8_axios___default.a.spread(function () {
    var metricsResp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: undefined };
    var historicalResp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { data: undefined };
    var universeResp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { data: undefined };

    return {
      metrics: metricsResp.data,
      audienceSize: universeResp.data,
      historicalViewership: historicalResp.data,
      universe: universeResp.data
    };
  }));
}

function fetchAdTargetMetrics(args) {
  return postAuthorization(API_ROOT_LAS + '/AD/Metrics', args).catch(function (error) {
    console.log(error);
  });
}

function fetchAdTargetAudienceSize(args) {
  return postAuthorization(API_ROOT_LAS + '/AD/TargetAudience', args).catch(function (error) {
    console.log(error);
  });
}

function fetchAdTargetHistoricalViewership(args) {
  return postAuthorization(API_ROOT_LAS + '/AD/HistoricalViewership', args).catch(function (error) {
    console.log(error);
  });
}

function fetchAdTargetUniverse(args) {
  return postAuthorization(API_ROOT_LAS + '/AD/UniverseEstimate', args).catch(function (error) {
    console.log(error);
  });
}

function fetchAdTargetData(_ref15) {
  var query = _ref15.query,
      startDate = _ref15.startDate,
      endDate = _ref15.endDate,
      networks = _ref15.networks,
      viewSource = _ref15.viewSource;

  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.all([fetchAdTargetMetrics(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource })), fetchAdTargetAudienceSize(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource })), fetchAdTargetHistoricalViewership(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, networks: networks, viewSource: viewSource })), fetchAdTargetUniverse(convertLasArgsToRequestParams({ startDate: startDate, endDate: endDate, query: query, viewSource: viewSource }))]).then(__WEBPACK_IMPORTED_MODULE_8_axios___default.a.spread(function () {
    var metricsResp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: undefined };
    var audienceSizeResp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { data: undefined };
    var historicalResp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { data: undefined };
    var universeResp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { data: undefined };

    return {
      metrics: metricsResp.data,
      audienceSize: audienceSizeResp.data,
      historicalViewership: historicalResp.data,
      universe: universeResp.data
    };
  }));
}

function fetchSmTargetData(definition) {
  definition = {
    query: definition.query,
    view_source: definition.viewSource
  };
  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.all([postAuthorization(API_ROOT_SM + '/SM/Metrics', definition).catch(function (error) {
    console.log(error);
  }), postAuthorization(API_ROOT_SM + '/SM/Audience', definition).catch(function (error) {
    console.log(error);
  }), postAuthorization(API_ROOT_SM + '/SM/TspAttributes', definition).catch(function (error) {
    console.log(error);
  }), postAuthorization(API_ROOT_SM + '/SM/SocialAffinity', definition).catch(function (error) {
    console.log(error);
  }), postAuthorization(API_ROOT_SM + '/SM/Reach', definition).catch(function (error) {
    console.log(error);
  })]).then(__WEBPACK_IMPORTED_MODULE_8_axios___default.a.spread(function () {
    var metricsResp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: undefined };
    var audienceSizeResp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { data: undefined };
    var topTspResp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { data: undefined };
    var topSocialAffinityResp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { data: undefined };
    var reachResp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { data: undefined };

    return {
      metrics: metricsResp.data,
      audienceSize: audienceSizeResp.data,
      topTsp: topTspResp.data,
      topSocialAffinity: topSocialAffinityResp.data,
      reach: reachResp.data
    };
  }));
}

function convertLasArgsToRequestParams(_ref16) {
  var startDate = _ref16.startDate,
      endDate = _ref16.endDate,
      query = _ref16.query,
      networks = _ref16.networks,
      viewSource = _ref16.viewSource;

  return { 'start-date': startDate, 'end-date': endDate, query: query, networks: networks, view_source: viewSource };
}

function fetchTargets(agGridModel) {
  var username = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var archived = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/Targets' + (username ? '/' + username : '') + '?archived=' + archived, agGridModel);
}

function fetchSingleTarget(_ref17) {
  var target_id = _ref17.target_id;

  return getAuthorization(API_V2_ROOT + '/Targets/' + target_id);
}

function getTargetHistory(target_id) {
  return getAuthorization(API_V2_ROOT + '/Targets/' + target_id + '/Revisions');
}

function appendTargetHistory(target_id, _ref18) {
  var branch_id = _ref18.branch_id,
      move = _ref18.move,
      target_definition = _ref18.target_definition,
      label = _ref18.label,
      target_data = _ref18.target_data,
      audience = _ref18.audience;

  return postAuthorization(API_V2_ROOT + '/Targets/' + target_id + '/Revisions', {
    branch_id: branch_id,
    move: move,
    target_definition: target_definition,
    label: label,
    target_data: target_data,
    audience: audience
  });
}

function searchAdvertisers(search) {
  return getAuthorization(API_V2_ROOT + '/Advertisers/' + search);
}

function fetchMarketingNetworks() {
  return getAuthorization(API_ROOT_TARGET_MANAGER + '/Networks').then(function (resp) {
    return resp.data;
  });
}

function deleteTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UpdateTargetStatus', {
    field: 'deleted',
    target: target
  });
}

function parseNPowerFile(_ref19) {
  var bucket = _ref19.bucket,
      key = _ref19.key;

  return postAuthorization(LOAD_BALANCER + '/npower/parsefile', { bucket: bucket, key: key });
}

function parseComscoreFile(_ref20) {
  var bucket = _ref20.bucket,
      key = _ref20.key;

  return postAuthorization(LOAD_BALANCER + '/comscore/parsefile', { bucket: bucket, key: key });
}

function uploadNPowerSegments(params) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UploadNPowerSegments', {
    segmentData: params.segmentData,
    target_id: params.target_id,
    marketDemos: params.marketDemos
  });
}

function sendNPowerDownstream(params) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/SendNPowerDownstream', {
    target_id: params.target_id
  });
}

function sendComscoreDownstream(params) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/SendComscoreDownstream', {
    target_id: params.target_id
  });
}

function uploadComscoreSegments(params) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UploadComscoreSegments', {
    segmentData: params.segmentData,
    target_id: params.target_id,
    username: params.username,
    marketDemos: params.marketDemos
  });
}

function updateTargetUE(params) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UpdateTargetUE', {
    targetId: params.targetId,
    ue: params.ue
  });
}

function archiveTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UpdateTargetStatus', {
    field: 'archived',
    target: target
  }).catch(function (err) {
    return { Error: err.response && err.response.data && err.response.data || err };
  });
}

function unArchiveTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UpdateTargetStatus', {
    field: 'unarchived',
    target: target
  });
}

function createTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/SaveTarget', { target: target });
}

function saveTarget(target) {
  return putAuthorization(API_V2_ROOT + '/Targets/' + target.id, target);
}

function activateTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/Activate', { target: target });
}

function duplicateTarget(_ref21) {
  var target = _ref21.target,
      duplicate_id = _ref21.duplicate_id;

  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/Duplicate', { target: target, duplicate_id: duplicate_id });
}

function submitToDC(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/SubmitToDC', target);
}

function notifyAdCity(targetId) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/NotifyAdCity', { target_id: targetId });
}

function sendToLake5(target) {
  return postAuthorization(API_V2_ROOT + '/airflow/Lake5/' + target.id, target);
}

function getTargetUploadUrl(params) {
  return getAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/GetTargetUploadUrl', { params: params });
}

function createTargetWithNoActuals(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/CreateTarget', target);
}

function uploadTargetFile(_ref22) {
  var target = _ref22.target,
      file = _ref22.file,
      options = _ref22.options;

  options = options || {};
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/UploadTarget', { target: target, file: file, options: options });
}

function getUploadTargetData(_ref23) {
  var target_type = _ref23.target_type,
      id = _ref23.id;

  var url = API_ROOT_TARGET_MANAGER_NODE + '/Audience/UploadTarget/' + target_type + '/' + id;
  return getAuthorization(url);
}

function moveStagedFileToUpload(_ref24) {
  var target = _ref24.target;

  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/MoveStagedFile', { target: target });
}

function getTargetPidLists(id) {
  var url = API_ROOT_TARGET_MANAGER_NODE + '/Audience/PIDLists/' + id;
  return getAuthorization(url);
}

function downloadFile(url, filename) {
  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, { responseType: 'blob' }).then(function (r) {
    return __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(new Blob([r.data]), filename);
  });
}

function getTargetsByTargetType(_ref25) {
  var target_type = _ref25.target_type;

  var url = API_ROOT_TARGET_MANAGER + '/Audience/Targets?target_type=' + target_type;
  return getAuthorization(url);
}

function deleteTargetResource(_ref26) {
  var target_id = _ref26.target_id;

  var url = API_ROOT_TARGET_MANAGER + '/Audience/DeleteTargetResource?target_id=' + target_id;
  return getAuthorization(url);
}

function uploadFile(url, file) {
  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(url, file, { headers: { 'Content-Type': '' } });
}

function exportTargetDefinition(_ref27) {
  var targetId = _ref27.targetId,
      targetDefinition = _ref27.targetDefinition,
      audienceSize = _ref27.audienceSize;

  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/Audience/exportTargetDefinition', {
    targetId: targetId,
    targetDefinition: targetDefinition,
    audienceSize: audienceSize
  }).then(function (response) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;charset=utf-16le;base64,' + encodeURIComponent(response.data));
    element.setAttribute('download', 'target definition.pdf');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  });
}

function checkPIDComplete(_ref28) {
  var target_id = _ref28.target_id;

  var url = API_ROOT_TARGET_MANAGER + '/Audience/PID/checkFileResource';
  return postAuthorization(url, { target_id: target_id });
}

function overwritePIDFiles(_ref29) {
  var target_id = _ref29.target_id,
      overriddens = _ref29.overriddens;

  var url = API_ROOT_TARGET_MANAGER + '/Audience/PID/OverWriteFiles';
  return postAuthorization(url, { target_id: target_id, overriddens: overriddens });
}

function editTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/SaveTarget', { target: target });
}

function postTarget(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/Post', target);
}

function validateLASDataAvailable(targetId) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/ValidateLASDataAvailable', { id: targetId });
}

function validateTargetName(payload) {
  var query = payload.isCaseSensitive ? '?isCaseSensitive=true' : '';
  var url = API_ROOT_TARGET_MANAGER_NODE + '/Audience/ValidateTargetName/' + payload.display_name + query;
  return getAuthorization(url);
}

function validateCampaignName(campaignName) {
  var url = API_ROOT_TARGET_MANAGER_NODE + '/Audience/ValidateCampaignName/' + campaignName;
  return getAuthorization(url);
}

function getTargetResources(targetId) {
  var url = API_ROOT_TARGET_MANAGER_NODE + '/Audience/Resources?targetId=' + targetId;
  return getAuthorization(url);
}

function sendPostData(target) {
  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/PostData', target);
}

function rePostTarget(_ref30) {
  var target_id = _ref30.target_id,
      start_date = _ref30.start_date;

  return postAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/RePost', { target_id: target_id, start_date: start_date });
}

function getDroppedAttributesByQuarter(_ref31) {
  var target_id = _ref31.target_id;

  return getAuthorization(API_ROOT_TARGET_MANAGER + '/Audience/Target/DroppedAttributes?target_id=' + target_id);
}

function logXandrAction(body) {
  return postAuthorization(API_FOR_XANDR + '/Xandr/Log', body);
}

function getRoles() {
  return getAuthorization(API_V2_ROOT + '/Roles');
}

function getPermissions() {
  return getAuthorization(API_V2_ROOT + '/Permissions');
}

function getUserPermissionsWithAuth() {
  return getAuthorization(API_V2_ROOT + '/UserPermissions');
}

function updateRolePermissions(role) {
  return postAuthorization(API_V2_ROOT + '/Role', role);
}

function logIntoIDM(username, password) {
  return postAuthorization(API_ROOT_TARGET_MANAGER_NODE + '/IDMToken', { username: username, password: password }).then(function (resp) {
    return resp.data;
  });
}

function batchLimitMaxCalls(apiCall, batches, limitNumber) {
  var newBatches = [];
  var responseCollection = [];
  for (var i = 0; i < batches.length; i += limitNumber) {
    newBatches.push(batches.slice(i, i + limitNumber));
  }
  return __limitMaxCalls(apiCall, newBatches, 0, responseCollection);
}

function getComscoreDemos() {
  return getAuthorization(API_V2_ROOT + '/Datasets/LAS/comscore').then(function (resp) {
    return resp.data;
  });
}

var __limitMaxCalls = function __limitMaxCalls(api, newBatches, currentBatch, responseCollection) {
  var promises = newBatches[currentBatch].map(function (data) {
    return api(data);
  });
  return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.all(promises).then(function (resps) {
    resps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["flattenDeep"])(resps);
    currentBatch += 1;
    responseCollection.push.apply(responseCollection, resps);
    if (newBatches.length === currentBatch) {
      return responseCollection;
    } else {
      return __limitMaxCalls(api, newBatches, currentBatch, responseCollection);
    }
  });
};

var restartAPIGenerator = function restartAPIGenerator(api, dataSegment) {
  var restartAPI = function restartAPI(data) {
    var halfPayload = function halfPayload(apiFunc, data) {
      var segmentedData = data;
      if (dataSegment) {
        segmentedData = data[dataSegment];
      }
      var half = segmentedData.length / 2;
      var data1 = segmentedData.slice(0, half);
      var data2 = segmentedData.slice(half, segmentedData.length);
      if (dataSegment) {
        data1 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, data, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, dataSegment, data1));
        data2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, data, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, dataSegment, data2));
      }
      var promise1 = restartAPI(data1);
      var promise2 = restartAPI(data2);
      return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.all([promise1, promise2]).then(function (resps) {
        return flattenIfArray(resps);
      });
    };

    return __restartAPIcall(api, data, halfPayload).then(function (resps) {
      return flattenIfArray(resps);
    });
  };
  return restartAPI;
};

var flattenIfArray = function flattenIfArray(ar) {
  if (Array.isArray(ar)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["flattenDeep"])(ar);
  } else {
    return ar;
  }
};

var __restartAPIcall = function __restartAPIcall(api, data, restartFunction) {
  return api(data).catch(function () {
    return restartFunction(api, data);
  });
};

var dataSourceArmldOnly = function dataSourceArmldOnly(args) {
  var queryValue = args['query'];
  var dataSource = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
  checkArray(queryValue, dataSource);
  if (dataSource.has('household')) {
    dataSource.delete('household');
  }
  if (dataSource.has('respondent')) {
    dataSource.delete('respondent');
  }
  var armldOnly = dataSource.size <= 0;
  return armldOnly;
};

var checkArray = function checkArray(array, dataSource) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(array).forEach(function (element) {
    if (isObject(element)) {
      dataSource.add(element['dataset']);
    } else if (isArray(element)) {
      checkArray(element, dataSource);
    } else {}
  });
};

var isObject = function isObject(arg) {
  return arg !== null && (typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arg)) === 'object' && !Array.isArray(arg);
};

var isArray = function isArray(arg) {
  return arg && (typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arg)) === 'object' && arg.constructor === Array;
};

var formatTargetToSend = function formatTargetToSend(target, action) {
  return {
    caeId: target.cae_id,
    username: target.username,
    submittedBy: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.auth.username,
    timestamp: __WEBPACK_IMPORTED_MODULE_11_date_fns_format___default()(new Date(), 'YYYY-MM-DD HH:mm:ss'),
    queryCounts: target.xandr_data && target.xandr_data.query || {},
    targetDefinition: target.target_definition.query,
    action: action,
    id: target.id
  };
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertAttributeToDisplay */
/* harmony export (immutable) */ __webpack_exports__["e"] = createDisplayName;
/* harmony export (immutable) */ __webpack_exports__["h"] = definitionAsString;
/* unused harmony export definitionAsHtml */
/* unused harmony export definitionToListOfTraits */
/* unused harmony export createNamespaceStripper */
/* harmony export (immutable) */ __webpack_exports__["d"] = commaFormatString;
/* harmony export (immutable) */ __webpack_exports__["k"] = dateFormatter;
/* unused harmony export getUTCcorrectedDate */
/* unused harmony export getUTCTimeNow */
/* unused harmony export yearMonthDateFormat */
/* unused harmony export titelizeString */
/* harmony export (immutable) */ __webpack_exports__["c"] = isDecimal;
/* unused harmony export createTarget */
/* unused harmony export isJsonString */
/* unused harmony export targetCanBeActivated */
/* unused harmony export SmTargetCanBeActivated */
/* unused harmony export lasActivationBlocked */
/* unused harmony export smActivationBlocked */
/* unused harmony export adActivationBlocked */
/* harmony export (immutable) */ __webpack_exports__["f"] = isActivationBlocked;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isTargetOwnedBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return filterTargetOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return targetTypeToAbbrev; });
/* unused harmony export postDataEnabled */
/* harmony export (immutable) */ __webpack_exports__["a"] = targetRouteHandler;
/* unused harmony export downloadFile */
/* unused harmony export convertArrayOfObjectsToCSV */
/* unused harmony export delayPromise */
/* unused harmony export formatNode */
/* unused harmony export formatQuery */
/* unused harmony export splitArrayIntoSizeN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return formatSmallMoney; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return smallNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return newSmallNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return formatSmallNumber; });
/* unused harmony export formatAndRoundSmallNumber */
/* unused harmony export formatDollars */
/* unused harmony export formatCommas */
/* unused harmony export getDateString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flatten; });
/* unused harmony export guid */
/* harmony export (immutable) */ __webpack_exports__["l"] = copyTextToClipboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);









var SELECT = __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].SELECT,
    RANGE = __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].RANGE,
    RANGE_SELECT = __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].RANGE_SELECT;


function convertAttributeToDisplay(attr) {
  var result = null;
  switch (attr.type) {
    case SELECT:
      result = attr.options ? attr.options.find(function (option) {
        return option.value === attr.value;
      }).name : attr.value;
      break;
    case RANGE:
    case RANGE_SELECT:
      result = attr.value.min + ' - ' + attr.value.max;
      break;
    default:
      result = typeof attr.value === 'string' ? attr.value : '-';
  }
  return result;
}

function createDisplayName(attr) {
  var name = '';
  if (attr.parent) {
    name = attr.parent + ' - ';
  }
  var convertValue = convertAttributeToDisplay(attr);
  var extention = convertValue === '-' ? '' : ' - (' + convertValue + ')';
  if (!attr.type) {
    return '' + name + attr.id + extention;
  }
  return '' + name + attr.name + extention;
}

function definitionAsString(definition) {
  var reducer = function reducer(acc, attr) {
    if (attr.type || attr.id && attr.value) {
      acc.push(createDisplayName(attr));
    }

    if (Array.isArray(attr)) {
      acc.push('(');

      acc.concat(attr.reduce(reducer, acc));

      acc.push(')');
    }

    if (typeof attr === 'string') {
      acc.push(attr);
    }

    return acc;
  };
  return definition.reduce(reducer, []);
}

function definitionAsHtml(definition) {
  var level = 1;
  var colors = ['#a0a7ac', '#4da3c2', '#9e5fa8', '#4a3f57'];

  var reducer = function reducer(acc, attr, index, arr) {
    if (attr.type || attr.id && attr.value) {
      acc.push('<span style="color: ' + colors[level] + ';">');
      acc.push(createDisplayName(attr));
      acc.push('</span>');
    }

    if (Array.isArray(attr)) {
      level++;

      acc.push('<span style="color: ' + colors[level] + '; font-weight: bold;">(</span>');

      acc.concat(attr.reduce(reducer, acc));

      acc.push('<span style="color: ' + colors[level] + '; font-weight: bold;">)</span>');
      level--;
    }

    if (typeof attr === 'string') {
      acc.push('<span style="color: ' + colors[level - 1] + ';"> ');
      if (level === 1) {
        acc.push('<br/>');
      }
      acc.push(attr === 'AND' ? '&' : attr);
      acc.push(' </span>');
    }

    return acc;
  };
  return definition.reduce(reducer, []).join('');
}

function definitionToListOfTraits(definition) {
  var reducer = function reducer(acc, attr, index, arr) {
    if (attr.type || attr.id && attr.value) {
      acc.push(attr);
    }

    if (Array.isArray(attr)) {
      acc.concat(attr.reduce(reducer, acc));
    }

    return acc;
  };
  return definition.reduce(reducer, []);
}

function createNamespaceStripper(namespace) {
  return function (fullConst) {
    if (namespace.lastIndexOf('/') === -1) {
      namespace += '/';
    }
    return fullConst.replace(namespace, '');
  };
}

function commaFormatString(string) {
  return Number(string).toLocaleString('en');
}

function dateFormatter(date) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var options = { year: 'numeric', month: 'short', day: 'numeric' };
  var d = new Date(date).toLocaleString('en-us', utc ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, options, { timeZone: 'UTC' }) : options);
  return d;
}

function getUTCcorrectedDate(dateString) {
  var start = new Date(dateString);
  var offset = start.getTimezoneOffset();
  start.setTime(start.getTime() + 1000 * 60 * offset);
  return start;
}

function getUTCTimeNow() {
  return new Date(new Date().getTime() + new Date().getTimezoneOffset() * 1000 * 60);
}

function yearMonthDateFormat(date) {
  return date.toISOString().split('T')[0];
}

function titelizeString(str) {
  if (typeof str !== 'string') {
    return '';
  }
  var frags = str.split('_');
  for (var i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
}

function isDecimal(num) {
  return num % 1 !== 0;
}

function createTarget(_ref) {
  var username = _ref.username,
      display_name = _ref.display_name,
      target = _ref.target,
      advertiser = _ref.advertiser,
      target_datasource = _ref.target_datasource,
      target_definition = _ref.target_definition,
      networks = _ref.networks,
      viewing_stream = _ref.viewing_stream;

  return {
    username: username,
    display_name: display_name,
    target: target,
    advertiser: advertiser,
    target_datasource: target_datasource,
    target_definition: target_definition,
    networks: networks,
    viewing_stream: viewing_stream
  };
}

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function targetCanBeActivated(target) {
  return target.workbench_data.universe && target.workbench_data.viewership_historical && target.workbench_data.metrics;
}
function SmTargetCanBeActivated(target) {
  return target.workbench_data.metrics && target.workbench_data.audience_size && target.workbench_data.brand_reach && (target.workbench_data.target_definition || target.target_definition);
}

function lasActivationBlocked() {
  return false;
}

function smActivationBlocked() {
  return false;
}

function adActivationBlocked() {
  return true;
}

function isActivationBlocked(targetType) {
  return targetType === 'linear_ad_sales' ? lasActivationBlocked() : targetType === 'social_digital' ? smActivationBlocked() : targetType === 'audience_discovery' ? adActivationBlocked() : true;
}

var isTargetOwnedBy = function isTargetOwnedBy(target, username) {
  return target.username && target.username.toLowerCase() === username.toLowerCase();
};

var filterTargetOptions = function filterTargetOptions(targetOptions, remove) {
  return targetOptions.filter(function (t) {
    return remove.indexOf(t.name) === -1;
  });
};

var targetTypeToAbbrev = {
  'linear_ad_sales': 'las',
  'social_digital': 'sm',
  'audience_discovery': 'ad'
};

function postDataEnabled() {
  return true;
}

function targetRouteHandler(action, target) {
  if (action === 'OPEN') {
    if (target.metadata.intents && target.metadata.intents.some(function (i) {
      return i['Name'] === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Sales']['Name'];
    }) && target.activation_status === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'NewWorkbench', params: { id: target.id } });
    } else {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: targetTypeToAbbrev[target.target] + '-workbench', params: { id: target.id } });
    }
  } else if (action === 'ACTIVATE') {
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: targetTypeToAbbrev[target.target] + '-activate-target', params: { target: target.target, id: target.id } });
  } else if (action === 'CONFIRM-ACTIVATION') {
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: targetTypeToAbbrev[target.target] + '-confirm-activation', params: { target: target.target, id: target.id } });
  } else if (action === 'DELETE') {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_6__views_audienceHub_store_actions__["a" /* DELETE_TARGET */], target);
  } else if (action === 'SETTINGS') {
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: targetTypeToAbbrev[target.target] + '-edit-target', params: { target: target.target, id: target.id } });
  } else if (action === 'DUPLICATE') {
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: targetTypeToAbbrev[target.target] + '-duplicate-target', params: { target: target.target, id: target.id } });
  }
}

function downloadFile(_ref2) {
  var dataString = _ref2.dataString,
      filename = _ref2.filename,
      format = _ref2.format;

  var data = encodeURI('data:' + format + ';charset=utf-8,' + dataString);

  var link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', filename);
  link.click();
}

function convertArrayOfObjectsToCSV(args) {
  var data = args.data || null;
  if (data == null || !data.length) {
    return null;
  }

  var columnDelimiter = args.columnDelimiter || ',';
  var lineDelimiter = args.lineDelimiter || '\n';

  var keys = args.keys || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]);

  var result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  data.forEach(function (item) {
    var ctr = 0;
    keys.forEach(function (key) {
      if (ctr > 0) result += columnDelimiter;

      var property = item[key].toString().replace(/"/g, '\\"');
      result += '"' + property + '"';
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function delayPromise(t) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(resolve, t);
  });
}

function formatNode(_ref3) {
  var parent = _ref3.parent,
      path = _ref3.path,
      value = _ref3.value,
      type = _ref3.type,
      name = _ref3.name;

  var leadString = parent ? path + ' - ' : '';
  var booleanLeadString = parent ? path + ': ' : '';
  if (type === 'range') {
    return leadString + name + ': ' + ('(' + value.min + '-' + value.max + ')');
  } else if (type === 'boolean') {
    return booleanLeadString + name;
  } else if (type === 'select') {
    return leadString + name + ': ' + value;
  }
}

function formatQuery(query) {
  var lvl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var string = '';
  var spaces = '   ';

  query.forEach(function (el) {
    if (typeof el === 'string') {
      string += '\n' + spaces.repeat(lvl) + el;
    } else if (Array.isArray(el)) {
      string += '\n' + spaces.repeat(lvl) + '[' + '\n' + spaces.repeat(lvl + 1) + formatQuery(el, lvl + 1) + '\n' + spaces.repeat(lvl) + ']';
    } else {
      string += '\n' + spaces.repeat(lvl) + formatNode(el);
    }
  });

  return string.trim();
}

function splitArrayIntoSizeN(arr, n) {
  var output = [];
  var itr = 0;

  while (itr < arr.length) {
    output.push(arr.slice(itr, itr + n));
    itr += n;
  }

  return output;
}

var formatSmallMoney = function formatSmallMoney(value) {
  if (value.length <= 3) {
    return formatDollars(value);
  } else {
    var s = smallNumber(value);
    return '$' + s;
  }
};

var smallNumber = function smallNumber(value) {
  var decimalPlace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  value = String(Math.floor(Number(value)));
  value = value.split('.')[0];
  if (value.length <= 3) {
    return value;
  } else {
    var length = value.length;
    var s = '';
    var decimal = '';
    var suffix = '';
    if (length > 3 && length < 7) {
      var digits = length - 3;
      s = value.substr(0, digits);
      suffix = 'T';
      decimal = value.substr(digits, decimalPlace);
    } else if (length > 6 && length < 10) {
      var _digits = length - 6;
      s = value.substr(0, _digits);
      suffix = 'M';
      decimal = value.substr(_digits, decimalPlace);
    }
    if (decimalPlace > 0) {
      return s + '.' + decimal + ' ' + suffix;
    }
    return '' + s + suffix;
  }
};

var newSmallNumber = function newSmallNumber(value, decimalPlaces) {
  var currentPlace = 0;
  var places = ['', 'K', 'M', 'B'];
  var v = value;
  while (v >= 1000) {
    v = v / 1000;
    currentPlace += 1;
  }
  var decimalPower = Math.pow(10, decimalPlaces);
  v = Math.round(v * decimalPower) / decimalPower;
  if (v >= 1000) {
    currentPlace += 1;
    v = v / 1000;
  }
  return currentPlace > 0 ? v + ' ' + places[currentPlace] : '' + v;
};

var formatSmallNumber = function formatSmallNumber(value) {
  value = String(Math.floor(Number(value)));
  value = value.split('.')[0];
  var length = value.length;
  var s = '';
  if (length > 3 && length < 7) {
    s = value.substr(0, length - 3) + ' K';
  } else if (length > 6 && length < 10) {
    s = value.substr(0, length - 6) + ' M';
  }
  return s;
};

var formatAndRoundSmallNumber = function formatAndRoundSmallNumber(value) {
  value = String(Math.round(Number(value)));
  value = value.split('.')[0];
  var length = value.length;
  var s = '';
  if (length > 3 && length < 7) {
    s = value.substr(0, length - 3) + ' K';
  } else if (length > 6 && length < 10) {
    s = value.substr(0, length - 6) + ' M';
  }
  return s;
};

var formatDollars = function formatDollars(value) {
  if (value) {
    var negative = value < 0 ? '-' : '';
    var money = negative + '$' + formatCommas(value);
    return money;
  } else {
    return '';
  }
};

var formatCommas = function formatCommas(value) {
  var numberString = String(Math.abs(value)).split('').reverse();
  var s = [];
  for (var i in numberString) {
    var valid = Number(i) % 3 === 0 && Number(i) !== 0;
    if (valid) {
      s.push(',');
    }
    s.push(numberString[i]);
  }
  return s.reverse().join('', '');
};

var getDateString = function getDateString(date) {
  var dateInfo = date.split('-');
  var year = dateInfo[0].substring(2, 4);
  var month = Number(dateInfo[1]);
  if (month === 1) {
    month = 'Q1';
  } else if (month === 4) {
    month = 'Q2';
  } else if (month === 7) {
    month = 'Q3';
  } else if (month === 10) {
    month = 'Q4';
  }
  return month + year;
};

var flatten = function flatten(arr) {
  var _ref4;

  return (_ref4 = []).concat.apply(_ref4, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arr.map(function (v) {
    return Array.isArray(v) ? flatten(v) : v;
  })));
};

var guid = function guid() {
  var s4 = function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was', msg);
  } catch (err) {
    console.error('Fallback: Unable to copy:', err);
  }

  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
    console.log('Copying to clipboard was successful!');
  }).catch(function (err) {
    console.error('Could not copy text:', err);
  });
}

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CURRENT_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SELECTED_VIEWERSHIP_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SELECTED_VIEWERSHIP_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_NETWORK_DAY_PART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REMOVE_FROM_SELECTED_DAY_PART_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADD_TO_SELECTED_DAY_PART_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLOSE_DAY_PARTS_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SHOW_DELETE_TARGET_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SHOW_APPEND_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_SHOW_PID_DOWNLOAD_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_TARGET_REPOST_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_TARGET_SEGMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_TARGET_PID_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RESET_TARGET_PID_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RESET_TARGET_SEGMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DELETE_CURRENT_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_LOADING_VALUE; });
/* unused harmony export SELECT_MARKET_DEMO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_CURRENT_TARGET_DEFINITION; });
/* unused harmony export SET_UPLOAD_MODAL_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SHOW_REPOSSTING_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REPOST_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_TARGET_DROPPED_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TARGET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_TARGET_ADVERTISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SHOW_DROPPED_ATTRIBUTES_MODEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NPOWER_TARGET_UPLOAD_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DOWNLOAD_LAS_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DOWNLOAD_TARGET_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IS_DOWNLOADING_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REMOVE_IS_DOWNLOADING_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IS_COMPLETED_DOWNLOAING_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLEAR_TARGET_DOWNLOAD; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_marketBreaks_IncomeMarketBreaks__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_marketBreaks_AgeMarketBreaks__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DownloadTarget__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);


var _actions;

















var module = 'CURRENT_TARGET_';

var SET_CURRENT_TARGET = module + 'SET_CURRENT_TARGET';

var SET_SELECTED_VIEWERSHIP_NETWORKS = module + 'SET_SELECTED_VIEWERSHIP_NETWORKS';
var UPDATE_SELECTED_VIEWERSHIP_NETWORKS = module + 'UPDATE_SELECTED_VIEWERSHIP_NETWORKS';
var SELECT_NETWORK_DAY_PART = module + 'SELECT_NETWORK_DAY_PART';
var REMOVE_FROM_SELECTED_DAY_PART_NETWORKS = module + 'REMOVE_FROM_SELECTED_DAY_PART_NETWORKS';
var ADD_TO_SELECTED_DAY_PART_NETWORKS = module + 'ADD_TO_SELECTED_DAY_PART_NETWORKS';
var CLOSE_DAY_PARTS_SECTION = module + 'CLOSE_DAY_PARTS_SECTION';
var SHOW_DELETE_TARGET_MODAL = module + 'SHOW_DELETE_TARGET_MODAL';
var SET_SHOW_APPEND_MODAL = module + 'SET_SHOW_APPEND_MODAL';
var SET_SHOW_PID_DOWNLOAD_MODAL = module + 'SET_SHOW_PID_DOWNLOAD_MODAL';
var SET_TARGET_REPOST_DATES = module + 'SET_TARGET_REPOST_DATES';
var SET_TARGET_SEGMENTS = module + 'SET_TARGET_SEGMENTS';
var SET_TARGET_PID_LISTS = module + 'SET_TARGET_PID_LISTS';
var RESET_TARGET_PID_LISTS = module + 'RESET_TARGET_PID_LISTS';
var RESET_TARGET_SEGMENTS = module + 'RESET_TARGET_SEGMENTS';
var DELETE_CURRENT_TARGET = module + 'DELETE_CURRENT_TARGET';
var SET_LOADING_VALUE = module + 'SET_LOADING_VALUE';
var SELECT_MARKET_DEMO = module + 'SELECT_MARKET_DEMO';
var SET_CURRENT_TARGET_DEFINITION = module + 'SET_CURRENT_TARGET_DEFINITION';
var SET_UPLOAD_MODAL_OPTIONS = module + 'SET_UPLOAD_MODAL_OPTIONS';
var SHOW_REPOSSTING_MODAL = module + 'SHOW_REPOSSTING_MODAL';
var REPOST_TARGET = module + 'REPOST_TARGET';
var SET_TARGET_DROPPED_ATTRIBUTES = module + 'SET_TARGET_DROPPED_ATTRIBUTES';
var SET_TARGET_NAME = module + 'SET_TARGET_NAME';
var SET_TARGET_ADVERTISER = module + 'SET_TARGET_ADVERTISER';
var SHOW_DROPPED_ATTRIBUTES_MODEL = module + 'SHOW_DROPPED_ATTRIBUTES_MODEL';
var NPOWER_TARGET_UPLOAD_FAILED = module + 'NPOWER_TARGET_UPLOAD_FAILED';

var DOWNLOAD_LAS_TARGET = module + 'DOWNLOAD_LAS_TARGET';
var DOWNLOAD_TARGET_DEFINITION = module + 'DOWNLOAD_TARGET_DEFINITION';
var IS_DOWNLOADING_TARGET = module + 'IS_DOWNLOADING_TARGET';
var REMOVE_IS_DOWNLOADING_TARGET = module + 'REMOVE_IS_DOWNLOADING_TARGET';
var IS_COMPLETED_DOWNLOAING_TARGET = module + 'IS_COMPLETED_DOWNLOAING_TARGET';
var CLEAR_TARGET_DOWNLOAD = module + 'CLEAR_TARGET_DOWNLOAD';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_CURRENT_TARGET, function (context, target) {
  context.commit(SET_CURRENT_TARGET, target);
  context.dispatch(SET_SELECTED_VIEWERSHIP_NETWORKS);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CLOSE_DAY_PARTS_SECTION, function (_ref) {
  var commit = _ref.commit;

  commit(CLOSE_DAY_PARTS_SECTION);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_SELECTED_VIEWERSHIP_NETWORKS, function (context) {
  var target = context.state.currentTarget;
  var networks = context.getters.networks;
  if (target.workbench_data) {
    var selectedNetworks = target.workbench_data.networks ? target.workbench_data.networks : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(networks, function (network) {
      return network.turner;
    }), function (network) {
      return network.id;
    });
    context.commit(SET_SELECTED_VIEWERSHIP_NETWORKS, selectedNetworks);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_SELECTED_VIEWERSHIP_NETWORKS, function (_ref2, networks) {
  var commit = _ref2.commit,
      state = _ref2.state,
      dispatch = _ref2.dispatch;

  var missingSelectedDayPartNetworks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["difference"])(state.selectedDayPartNetworks, networks);
  if (missingSelectedDayPartNetworks.length > 0) {
    missingSelectedDayPartNetworks.forEach(function (network) {
      dispatch(SELECT_NETWORK_DAY_PART, network);
    });
  }
  commit(SET_SELECTED_VIEWERSHIP_NETWORKS, networks);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SELECT_NETWORK_DAY_PART, function (_ref3, network) {
  var commit = _ref3.commit,
      state = _ref3.state;

  var alreadySelectedIndex = state.selectedDayPartNetworks.indexOf(network);
  if (alreadySelectedIndex > -1) {
    commit(REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, alreadySelectedIndex);
  } else {
    commit(ADD_TO_SELECTED_DAY_PART_NETWORKS, network);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_DELETE_TARGET_MODAL, function (context) {
  context.commit(SHOW_DELETE_TARGET_MODAL);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_SHOW_APPEND_MODAL, function (context, _ref4) {
  var target = _ref4.target,
      showModal = _ref4.showModal;

  showModal = !(showModal === false);
  if (!showModal && !target) {
    context.commit(SET_SHOW_APPEND_MODAL);
  } else if (target.target === __WEBPACK_IMPORTED_MODULE_12__Constants__["c" /* TARGET_TYPE */].NPOWER || target.target === __WEBPACK_IMPORTED_MODULE_12__Constants__["c" /* TARGET_TYPE */].COMSCORE) {
    context.commit(SET_LOADING_VALUE, true);
    if (showModal) {
      context.commit(SET_SHOW_APPEND_MODAL, target);
    } else {
      context.commit(SET_CURRENT_TARGET, target);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["v" /* getUploadTargetData */])({ target_type: target.target, id: target.id }).then(function (response) {
      context.commit(SET_LOADING_VALUE, false);
      if (response.error) {
        __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({
          title: 'Error:',
          message: 'There was an error getting uploaded data of your target.',
          timeout: 7000
        });
        context.commit(SET_SHOW_APPEND_MODAL, false);
      } else {
        context.commit(SET_TARGET_SEGMENTS, response.data);
      }
    }).catch(function (e) {
      console.error(e);
      context.commit(SET_LOADING_VALUE, false);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, NPOWER_TARGET_UPLOAD_FAILED, function (context, targetId) {
  context.commit(__WEBPACK_IMPORTED_MODULE_1__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
  context.dispatch(SET_SHOW_APPEND_MODAL, { showModal: false });
  context.dispatch(__WEBPACK_IMPORTED_MODULE_13__appLogic_targets_createTarget_store_actions__["n" /* UPDATE_TARGET_STATUS */], { targetId: targetId, activation_status: __WEBPACK_IMPORTED_MODULE_12__Constants__["b" /* ACTIVATION_STATUS */].FAILED }).then(function () {
    context.dispatch(__WEBPACK_IMPORTED_MODULE_1__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], true);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_SHOW_PID_DOWNLOAD_MODAL, function (context, target) {
  context.commit(SET_LOADING_VALUE, true);
  context.commit(SET_SHOW_PID_DOWNLOAD_MODAL, target);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["H" /* getTargetPidLists */])(target.id).then(function (response) {
    context.commit(SET_LOADING_VALUE, false);
    context.commit(SET_TARGET_PID_LISTS, response.data);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET_TARGET_PID_LISTS, function (context) {
  context.commit(SET_TARGET_PID_LISTS, []);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET_TARGET_SEGMENTS, function (context) {
  context.commit(SET_TARGET_SEGMENTS, []);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DELETE_CURRENT_TARGET, function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* targetRouteHandler */])('DELETE', context.state.currentTarget);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, IS_COMPLETED_DOWNLOAING_TARGET, function (context, targetId) {
  context.commit(REMOVE_IS_DOWNLOADING_TARGET, targetId);
  context.commit(IS_COMPLETED_DOWNLOAING_TARGET, targetId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CLEAR_TARGET_DOWNLOAD, function (context) {
  context.commit(CLEAR_TARGET_DOWNLOAD);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_CURRENT_TARGET_DEFINITION, function (context, td) {
  context.commit(SET_CURRENT_TARGET_DEFINITION, td);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_REPOSSTING_MODAL, function (context, target) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_index__["I" /* fetchEsDateRanges */])(target.target_datasource).then(function (dates) {
    context.dispatch(SET_CURRENT_TARGET, target);
    context.commit(SET_TARGET_REPOST_DATES, dates.dateRanges);
    context.commit(SHOW_REPOSSTING_MODAL);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_DROPPED_ATTRIBUTES, function (context, target) {
  context.commit(SET_LOADING_VALUE, true);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["J" /* getDroppedAttributesByQuarter */])({ target_id: target.id }).then(function (resp) {
    context.commit(SET_TARGET_DROPPED_ATTRIBUTES, resp.data);
    context.commit(SET_LOADING_VALUE, false);
  }).catch(function (resp) {
    context.commit(SET_LOADING_VALUE, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_DROPPED_ATTRIBUTES_MODEL, function (context, shouldShow) {
  context.commit(SHOW_DROPPED_ATTRIBUTES_MODEL, shouldShow);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REPOST_TARGET, function (context, start_date) {
  var target = context.state.currentTarget;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["K" /* rePostTarget */])({ target_id: target.id, start_date: start_date }).then(function (response) {
    context.commit(__WEBPACK_IMPORTED_MODULE_1__views_audienceHub_store_actions__["l" /* UPDATE_TARGET */], { id: response.data.id, updatedTarget: response.data });
    __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].success({
      title: 'Re-forecasting successful',
      message: 'The target "' + target.display_name + '", has been re-forecasted starting from ' + start_date
    });
  }).catch(function (er) {
    __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({
      title: 'Error Re-forecasting',
      message: 'There was an error re-forecasting the target "' + target.display_name + '"'
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DOWNLOAD_LAS_TARGET, function (context, target) {
  __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].info({ title: 'Downloading the Target Package', message: 'Your download is in progress, will notify you on completion.' });
  context.commit(IS_DOWNLOADING_TARGET, target.id);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["f" /* fetchSingleTarget */])({
    target_id: target.id
  }).then(function (_ref5) {
    var data = _ref5.data;

    var targetDefinition = data.target_definition.query;
    if (targetDefinition) {
      __WEBPACK_IMPORTED_MODULE_6_bluebird___default.a.join(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["t" /* fetchTargetData */])(data.target_definition), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["L" /* fetchAgeDistribution */])(data.target_definition), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["M" /* fetchIncomeDistribution */])(data.target_definition), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["q" /* fetchNetworksConfig */])(), function (data, age, income, networksResp) {
        var networks = networksResp.networks;
        var audienceSize = data.audienceSize && data.audienceSize.audience;
        var universe = data.universe;
        var viewershipData = data.historicalViewership;
        var ageData = age.data.data;
        var incomeData = income.data.data;
        var ageMarketData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__appLogic_marketBreaks_AgeMarketBreaks__["a" /* marketBreakAveragesGraphData */])(ageData);
        var ageDistribution = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__appLogic_marketBreaks_AgeMarketBreaks__["b" /* ageDistributionGraphData */])(ageData);
        var meanAge = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__appLogic_marketBreaks_AgeMarketBreaks__["c" /* getMeanOfAges */])(ageData);
        var incomeDistribution = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__appLogic_marketBreaks_IncomeMarketBreaks__["a" /* incomeGraphData */])(incomeData);
        var universeData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_lasGraphs_chartDataHelpers__["a" /* transformUniverseDataForGraph */])(universe);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__DownloadTarget__["a" /* default */])({ target: target, audienceSize: audienceSize, targetDefinition: targetDefinition, viewershipData: viewershipData, networks: networks, universeData: universeData, ageMarketData: ageMarketData, meanAge: meanAge, ageDistribution: ageDistribution, incomeDistribution: incomeDistribution }).then(function (filename) {
          context.dispatch(IS_COMPLETED_DOWNLOAING_TARGET, target.id);
          __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].success({ title: 'Target Download Complete', message: 'Completed downloading the file ' + filename + '.' });
        });
      });
    } else {
      context.dispatch(IS_COMPLETED_DOWNLOAING_TARGET, target.id);
      __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({ title: 'Target Definition Missing', message: 'Cannot Download because the target is missing its Target Definition.' });
    }
  }).catch(function (err) {
    context.dispatch(IS_COMPLETED_DOWNLOAING_TARGET, target.id);
    __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({ title: 'Error has occurred', message: 'Error: ' + err.message });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DOWNLOAD_TARGET_DEFINITION, function (context, payload) {
  __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].info({ title: 'Downloading Target Definition', message: 'Your download is in progress, will notify you on completion.' });
  console.log(payload);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["N" /* exportTargetDefinition */])(payload).then(function () {
    return __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].success({ title: 'Successfully Downloaded Target Definition', message: 'Your download is complete!' });
  }).catch(function (err) {
    console.error(err);
    __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({ title: 'Error Downloading Target Definition', message: err.message });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_NAME, function (context, name) {
  context.commit(SET_TARGET_NAME, name);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_ADVERTISER, function (context, name) {
  context.commit(SET_TARGET_ADVERTISER, name);
}), _actions);

/* harmony default export */ __webpack_exports__["e"] = (actions);

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionButton_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ActionButton_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ActionButton_vue___default.a);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return popoverTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPopover; });
/* unused harmony export createListPopover */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Forms; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePickerPopover__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePickerPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DatePickerPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StepperPopover__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StepperPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StepperPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SingleStepperPopover__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SingleStepperPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SingleStepperPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectPopover__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SelectPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListPopover__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ListPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OperatorPopover__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OperatorPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OperatorPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RangeSlider__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RangeSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__RangeSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RangeSelectPopover__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RangeSelectPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__RangeSelectPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__factory__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_InputFormPopover__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forms_InputFormPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__forms_InputFormPopover__);
/* unused harmony reexport RangeSlider */
/* unused harmony reexport PopoverBox */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__factory__["a"]; });















function choosePopover(_ref) {
  var attribute = _ref.attribute,
      type = _ref.type;

  if (type === popoverTypes.ATTRIBUTE) {
    if (attribute.type === __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].SELECT) return __WEBPACK_IMPORTED_MODULE_4__SelectPopover___default.a;
    if (attribute.type === __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].RANGE) {
      if (attribute.unit === 'int') {
        return __WEBPACK_IMPORTED_MODULE_2__StepperPopover___default.a;
      } else if (attribute.unit === 'date') {
        return __WEBPACK_IMPORTED_MODULE_1__DatePickerPopover___default.a;
      }
    }
    if (attribute.type === __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].RANGE_SELECT) {
      return __WEBPACK_IMPORTED_MODULE_10__RangeSelectPopover___default.a;
    }
  } else if (type === popoverTypes.OPERATOR) {
    return __WEBPACK_IMPORTED_MODULE_6__OperatorPopover___default.a;
  } else if (type === popoverTypes.TEXTLIST) {
    return __WEBPACK_IMPORTED_MODULE_5__ListPopover___default.a;
  } else if (type === popoverTypes.COUNT_GROUP) {
    return __WEBPACK_IMPORTED_MODULE_3__SingleStepperPopover___default.a;
  }
  throw new Error(type + ' is not a valid Popover type.');
}

var createPopover = function createPopover(_ref2) {
  var direction = _ref2.direction,
      attribute = _ref2.attribute,
      parent = _ref2.parent,
      type = _ref2.type,
      list = _ref2.list,
      _ref2$align = _ref2.align,
      align = _ref2$align === undefined ? 'center' : _ref2$align;

  var el = document.createElement('div');
  el.style.overflow = 'hidden';
  document.body.appendChild(el);

  var Popover = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(choosePopover({
    attribute: attribute, type: type, list: list
  }));

  var popoverBox = new Popover({
    el: el,
    propsData: {
      direction: direction,
      attribute: attribute,
      list: list,
      parent: parent,
      type: type,
      align: align
    }
  });

  return popoverBox;
};

var createListPopover = function createListPopover(_ref3) {
  var direction = _ref3.direction,
      parent = _ref3.parent,
      type = _ref3.type,
      list = _ref3.list,
      _ref3$align = _ref3.align,
      align = _ref3$align === undefined ? 'center' : _ref3$align,
      options = _ref3.options;

  var el = document.createElement('div');
  el.style.overflow = 'hidden';
  document.body.appendChild(el);

  var Popover = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5__ListPopover___default.a);
  var popoverBox = new Popover({
    el: el,
    propsData: {
      direction: direction,
      list: list,
      parent: parent,
      type: type,
      align: align,
      options: options
    }
  });

  return popoverBox;
};

var popoverTypes = {
  ATTRIBUTE: 'ATTRIBUTE',
  TEXTLIST: 'TEXTLIST',
  OPERATOR: 'OPERATOR',
  COUNT_GROUP: 'COUNT_GROUP'
};

var Forms = {
  InputForm: __WEBPACK_IMPORTED_MODULE_12__forms_InputFormPopover___default.a
};



/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToastFactory__ = __webpack_require__(328);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ToastFactory__["a" /* default */]);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SHOW_MODAL_STEPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_UPDATING_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_STEPPER_DATA_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APPEND_PID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CREATE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return IS_DIGITAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_TARGET_NO_ACTUALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPLOAD_TARGET_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return OVERWRITE_PID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPLOAD_NPOWER_SEGMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SEND_NPOWER_DOWNSTREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SEND_COMSCORE_DOWNSTREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_UPLOAD_MODAL_OPTIONS; });
/* unused harmony export GET_SEGMENT_UPLOAD_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPLOAD_MODAL_SET_APPEND_TYPE; });
/* unused harmony export SUBMIT_ATT_TARGET */
/* unused harmony export CREATE_TARGET_PURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ACTIVATE_PID_NPOWER; });
/* unused harmony export MOVE_STAGED_FILE_TO_UPLOAD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SUBMITTING_PID_NPOWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RESET_THE_LAS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_INITIAL_TARGET_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_INITIAL_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DUPLICATE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_INTENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_DEMOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_TARGET_STATUS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_tableMap_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_toasts_RecurringToast__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_ATTCreation__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_uploadingTarget_UploadTargetFile__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_U_D__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);



var _actions;














var module = 'CREATE_TARGET_';

var SET_SHOW_MODAL_STEPPER = module + 'SET_SHOW_MODAL_STEPPER';
var SET_UPDATING_TARGET = module + 'SET_UPDATING_TARGET';
var SET_STEPPER_DATA_SOURCE = module + 'SET_STEPPER_DATA_SOURCE';
var APPEND_PID = module + 'APPEND_PID';
var CREATE_TARGET = module + 'CREATE_TARGET';
var IS_DIGITAL = module + 'IS_DIGITAL';
var CREATE_TARGET_NO_ACTUALS = module + 'CREATE_TARGET_NO_ACTUALS';
var UPLOAD_TARGET_FILE = module + 'UPLOAD_TARGET_FILE';
var OVERWRITE_PID = module + 'OVERWRITE_PID';
var UPLOAD_NPOWER_SEGMENTS = module + 'UPLOAD_NPOWER_SEGMENTS';
var SEND_NPOWER_DOWNSTREAM = module + 'SEND_NPOWER_DOWNSTREAM';
var SEND_COMSCORE_DOWNSTREAM = module + 'SEND_COMSCORE_DOWNSTREAM';
var SET_LOADING = module + 'SET_LOADING';
var SET_UPLOAD_MODAL_OPTIONS = module + 'SET_UPLOAD_MODAL_OPTIONS';
var GET_SEGMENT_UPLOAD_DATA = module + 'GET_SEGMENT_UPLOAD_DATA';
var UPLOAD_MODAL_SET_APPEND_TYPE = module + 'UPLOAD_MODAL_SET_APPEND_TYPE';
var SUBMIT_ATT_TARGET = module + 'SUBMIT_ATT_TARGET';
var CREATE_TARGET_PURE = module + 'CREATE_TARGET_PURE';
var ACTIVATE_PID_NPOWER = module + 'ACTIVATE_PID_NPOWER';
var MOVE_STAGED_FILE_TO_UPLOAD = module + 'MOVE_STAGED_FILE_TO_UPLOAD';
var SUBMITTING_PID_NPOWER = module + 'SUBMITTING_PID_NPOWER';
var RESET_THE_LAS_MODAL = module + 'RESET_THE_LAS_MODAL';
var SET_INITIAL_TARGET_ACTION = module + 'SET_INITIAL_TARGET_ACTION';
var SET_INITIAL_TARGET = module + 'SET_INITIAL_TARGET';
var DUPLICATE_TARGET = module + 'DUPLICATE_TARGET';
var SET_INTENTS = module + 'SET_INTENTS';
var GET_DEMOS = module + 'GET_DEMOS';
var UPDATE_TARGET_STATUS = module + 'UPDATE_TARGET_STATUS';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, APPEND_PID, function (context) {
  context.commit(APPEND_PID);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_SHOW_MODAL_STEPPER, function (context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { targetAction: __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].NEW };

  context.commit(SET_INITIAL_TARGET_ACTION, payload.targetAction);
  context.commit(SET_SHOW_MODAL_STEPPER, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_STEPPER_DATA_SOURCE, function (context, _ref) {
  var option = _ref.option,
      target_id = _ref.target_id,
      targetAction = _ref.targetAction;

  var target = void 0;
  var nielsenDatasources = context.rootGetters.getNielsenDatasources;
  var fetchAudience = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if ((option === nielsenDatasources.FILE || option === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR || option === nielsenDatasources.AMRLD || option === nielsenDatasources.NCS || option === nielsenDatasources.MRI || option === nielsenDatasources.AUDIENCE_DISCOVERY) && target_id) {
      context.commit(SET_LOADING, true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["f" /* fetchSingleTarget */])({ target_id: target_id }).then(function (resp) {
        target = resp.data;
        target.created = new Date(target.created);
        var isAnUploadedFileOrXandrNative = (option === nielsenDatasources.FILE || option === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR) && target.am_data;
        if (isAnUploadedFileOrXandrNative) {
          target.am_data.flightStartDate = target.am_data.flightStartDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_U_D__["d" /* correctToUTCTime */])(target.am_data.flightStartDate) : target.am_data.flightStartDate;
          target.am_data.flightEndDate = target.am_data.flightEndDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_U_D__["d" /* correctToUTCTime */])(target.am_data.flightEndDate) : target.am_data.flightEndDate;
          target.am_data.AEFlightEndDate = target.am_data.AEFlightEndDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_U_D__["d" /* correctToUTCTime */])(target.am_data.AEFlightEndDate) : null;
          if (target.am_data.submitted_timestamp) {
            target.am_data.submitted_timestamp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_U_D__["d" /* correctToUTCTime */])(new Date(target.am_data.submitted_timestamp));
          }
        }
        if (targetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE) {
          if (target.destinations && target.destinations.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY) && target.am_data) {
            target.am_data.flightStartDate = null;
            target.am_data.flightEndDate = null;
            target.am_data.AEFlightStartDate = null;
            target.am_data.AEFlightEndDate = null;
          }
          context.dispatch(SET_INITIAL_TARGET, target);
          context.commit(SET_SHOW_MODAL_STEPPER, { step: 3, target: target });
        } else if (targetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE || targetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE_CAMPAIGN || targetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].SEGMENT_INFO) {
          context.dispatch(SET_UPDATING_TARGET, target);
          context.commit(SET_SHOW_MODAL_STEPPER, { step: 2, target: target });
          context.commit(SET_STEPPER_DATA_SOURCE, option);
        }
        context.commit(SET_INITIAL_TARGET_ACTION, targetAction);
        context.commit(SET_LOADING, false);
        resolve();
      }).catch(function (err) {
        console.error(err);
        context.commit(SET_LOADING, false);
        reject(err);
      });
    } else {
      if (option === null) {
        context.commit(SET_STEPPER_DATA_SOURCE, option);
      }
      resolve();
    }
  });

  fetchAudience.then(function () {
    if (targetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE_CAMPAIGN) {
      context.commit(IS_DIGITAL, true);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_UPDATING_TARGET, function (context, target) {
  context.commit(SET_UPDATING_TARGET, target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INITIAL_TARGET, function (context, target) {
  context.commit(SET_INITIAL_TARGET, target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INITIAL_TARGET_ACTION, function (context, targetAction) {
  context.commit(SET_INITIAL_TARGET_ACTION, targetAction);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GET_SEGMENT_UPLOAD_DATA, function (context, target) {
  context.commit(SET_LOADING, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["v" /* getUploadTargetData */])({ target_type: target.target, id: target.id }).then(function (response) {
    context.commit(SET_LOADING, false);
    return response.data;
  }).catch(function (e) {
    console.error(e);
    context.commit(SET_LOADING, false);
    return null;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ACTIVATE_PID_NPOWER, function (context, _ref2) {
  var target = _ref2.target,
      file = _ref2.file;

  return context.dispatch(CREATE_TARGET_PURE, target).then(function (createdTarget) {
    context.commit(SET_LOADING, true);
    if (file) {
      return context.dispatch(UPLOAD_TARGET_FILE, {
        target: createdTarget,
        file: file,
        options: { staged: true }
      }).then(function (res) {
        context.commit(SET_LOADING, false);
        return createdTarget;
      });
    } else {
      context.commit(SET_LOADING, false);
      return createdTarget;
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_UPLOAD_MODAL_OPTIONS, function (context, options) {
  context.commit(SET_UPLOAD_MODAL_OPTIONS, options);
  if (options) {
    var nielsenDatasources = context.rootGetters.getNielsenDatasources;
    context.commit(SET_STEPPER_DATA_SOURCE, nielsenDatasources.FILE);
    context.commit(SET_SHOW_MODAL_STEPPER, options.target);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, OVERWRITE_PID, function (context, _ref3) {
  var targetId = _ref3.targetId,
      overwrites = _ref3.overwrites;

  context.commit(SET_LOADING, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["w" /* overwritePIDFiles */])({ target_id: targetId, overriddens: overwrites }).then(function (res) {
    context.commit(SET_LOADING, false);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].success({ title: 'Appending File', message: 'File successfully Appended.' });
    return null;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPLOAD_TARGET_FILE, function (context, _ref4) {
  var target = _ref4.target,
      file = _ref4.file,
      options = _ref4.options,
      isAppend = _ref4.isAppend;

  var uploader = new __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_uploadingTarget_UploadTargetFile__["a" /* default */](context, file, options, target, isAppend);
  return uploader.run();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPLOAD_NPOWER_SEGMENTS, function (context, payload) {
  context.commit(SET_LOADING, true);
  var uploader = void 0;
  if (payload.segmentData.DataProvider === 'NPOWER') {
    uploader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["x" /* uploadNPowerSegments */])(payload);
  } else {
    uploader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["y" /* uploadComscoreSegments */])(payload);
  }
  return uploader.then(function (res) {
    context.commit(SET_LOADING, false);

    context.dispatch(__WEBPACK_IMPORTED_MODULE_13__appLogic_targets_currentTarget_store_actions__["b" /* SET_SHOW_APPEND_MODAL */], { showModal: false });
    var target = res.data;
    console.log('successfully uploaded ' + payload.segmentData.DataProvider + ' segments! updated target:', target);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].success({
      title: 'Audience Segments Uploaded',
      message: 'The audience segments have been successfully added to your target!',
      timeout: 10000
    });
    context.commit(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["l" /* UPDATE_TARGET */], { id: payload.target_id, updatedTarget: target });
    return res.data;
  }).catch(function (e) {
    console.error(e);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].error({
      title: 'Error Uploading Audience Segments',
      message: 'There was an error adding the audience segments to your target.',
      timeout: 10000
    });
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SEND_NPOWER_DOWNSTREAM, function (context, payload) {
  context.commit(SET_LOADING, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["z" /* sendNPowerDownstream */])(payload).then(function (res) {
    context.commit(SET_LOADING, false);
    var target = res.data;
    console.log('successfully sent segments downstream! updated target:', target);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].success({
      title: 'Audience Segments Sent Downstream',
      message: 'The audience segments have been successfully sent downstream!',
      timeout: 10000
    });
    context.commit(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["l" /* UPDATE_TARGET */], { id: payload.target_id, updatedTarget: target });
    return res.data;
  }).catch(function (e) {
    var message = (e.response || {}).data;
    console.error(message || e);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].error({
      title: 'Error Sending Audience Segments Downstream',
      message: message || 'There was an error sending the audience segments downstream.',
      timeout: 10000
    });
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SEND_COMSCORE_DOWNSTREAM, function (context, payload) {
  context.commit(SET_LOADING, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["A" /* sendComscoreDownstream */])(payload).then(function (res) {
    context.commit(SET_LOADING, false);
    var target = res.data;
    console.log('successfully sent segments downstream! updated target:', target);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].success({
      title: 'Audience Segments Sent Downstream',
      message: 'The audience segments have been successfully sent downstream!',
      timeout: 10000
    });
    context.commit(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["l" /* UPDATE_TARGET */], { id: payload.target_id, updatedTarget: target });
    return res.data;
  }).catch(function (e) {
    var message = (e.response || {}).data;
    console.error(message || e);
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].error({
      title: 'Error Sending Audience Segments Downstream',
      message: message || 'There was an error sending the audience segments downstream.',
      timeout: 10000
    });
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, MOVE_STAGED_FILE_TO_UPLOAD, function (context, _ref5) {
  var target = _ref5.target;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["B" /* moveStagedFileToUpload */])({ target: target }).then(function (res) {
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].success({
      title: 'Staged upload file being processed',
      message: 'The staged file is now being processed',
      timeout: 10000
    });
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_5__components_common_toasts___["a" /* default */].error({
      title: 'Error Moving staged file to Upload location',
      message: 'There was something wrong with moving the staged file to be processed',
      timeout: 10000
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, IS_DIGITAL, function (context, value) {
  context.commit(IS_DIGITAL, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CREATE_TARGET, function (context, target) {
  context.commit(SET_LOADING, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["m" /* createTarget */])(target).then(function (response) {
    context.commit(SET_LOADING, false);

    adobeAnalytics.createTarget({
      username: target.username,
      target: {
        name: target.display_name,
        type: target.target,
        id: response.data.id
      }
    });
    target = response.data;
    if (target.target === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD || target.target === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].AD) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: __WEBPACK_IMPORTED_MODULE_4__router_tableMap_js__["a" /* tableMap */][target.target], params: { id: target.id } });
    }
    return target;
  }).catch(function () {
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CREATE_TARGET_NO_ACTUALS, function (context, target) {
  context.commit(SET_LOADING, true);
  context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["C" /* activateTarget */])(target).then(function (response) {
    context.commit(SET_LOADING, false);
    var createdTarget = response.data;
    context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["g" /* ADD_TARGET_TO_TARGET_LIST */], createdTarget);
  }).catch(function () {
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CREATE_TARGET_PURE, function (context, target) {
  context.commit(SET_LOADING, true);
  context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["m" /* createTarget */])(target).then(function (response) {
    context.commit(SET_LOADING, false);

    adobeAnalytics.createTarget({
      username: target.username,
      target: {
        name: target.display_name,
        type: target.target,
        id: response.data.id
      }
    });
    target = response.data;
    context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["g" /* ADD_TARGET_TO_TARGET_LIST */], target);
    return target;
  }).catch(function () {
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_TARGET_STATUS, function (context, _ref6) {
  var targetId = _ref6.targetId,
      activation_status = _ref6.activation_status;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["r" /* saveTarget */])({ 'id': targetId, 'activation_status': activation_status });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SUBMITTING_PID_NPOWER, function (context, _ref7) {
  var target = _ref7.target,
      file = _ref7.file,
      onComplete = _ref7.onComplete;

  onComplete = onComplete || function () {};
  context.commit(SET_LOADING, true);
  var targetExists = target.id;
  context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["m" /* createTarget */])(target).then(function (res) {
    target = res.data;
    if (!targetExists) {
      context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["g" /* ADD_TARGET_TO_TARGET_LIST */], target);
    }
    if (file) {
      return context.dispatch(UPLOAD_TARGET_FILE, { target: target, file: file }).then(function (res) {
        if (res.Error) {
          return context.dispatch(UPDATE_TARGET_STATUS, { targetId: target.id, activation_status: __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED }).then(function (r) {
            context.commit(SET_LOADING, false);
            context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], true);
            onComplete(target);
          });
        }
        if (!res.Error) {
          context.commit(SET_LOADING, false);
          context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["h" /* FORECAST_TARGET_TO_TARGET_LIST */], target.id);
          onComplete(target, res);
        }
      });
    } else {
      return context.dispatch(MOVE_STAGED_FILE_TO_UPLOAD, { target: target }).then(function (res) {
        var getNpowerResource = function getNpowerResource() {
          var rt = new __WEBPACK_IMPORTED_MODULE_6__components_common_toasts_RecurringToast__["a" /* default */]({
            type: 'info',
            title: 'Waiting for Segement Info',
            message: 'Currently retrieving Segment Information',
            interval: 5000
          });
          rt.start();
          var recursiveFunc = function recursiveFunc() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["D" /* getTargetResources */])(target.id).then(function (resp) {
              if (resp.data.length === 0) {
                setTimeout(recursiveFunc, 5000);
              } else {
                rt.stop();
                context.commit(SET_LOADING, false);
                context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["h" /* FORECAST_TARGET_TO_TARGET_LIST */], target.id);
                onComplete(target, { target: target, irisResponse: resp.data[0].data });
              }
            });
          };
          recursiveFunc();
        };
        if (target.target_type === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].NPOWER || target.target_type === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].COMSCORE) {
          getNpowerResource();
        } else {
          context.commit(SET_LOADING, false);
          context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["h" /* FORECAST_TARGET_TO_TARGET_LIST */], target.id);
          onComplete(target);
        }
      });
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DUPLICATE_TARGET, function (context, _ref8) {
  var target = _ref8.target,
      duplicate_id = _ref8.duplicate_id;

  context.commit(SET_LOADING, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["n" /* duplicateTarget */])({ target: target, duplicate_id: duplicate_id }).then(function (response) {
    adobeAnalytics.createTarget({
      username: target.username,
      target: {
        name: target.display_name,
        type: target.target,
        id: response.data.id
      }
    });
    context.commit(CREATE_TARGET, response.data);
    context.commit(SET_LOADING, false);
    return response.data;
  }).catch(function (reason) {
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SUBMIT_ATT_TARGET, function (context, _ref9) {
  var target = _ref9.target,
      isNew = _ref9.isNew,
      activate = _ref9.activate,
      submitted = _ref9.submitted,
      submittingOrHasSubmittedFile = _ref9.submittingOrHasSubmittedFile;

  context.commit(SET_LOADING, true);
  context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
  var createAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_ATTCreation__["a" /* createATTCreation */])({ target: target, isNew: isNew, activate: activate, submitted: submitted, submittingOrHasSubmittedFile: submittingOrHasSubmittedFile }, {
    afterCreate: function afterCreate(createdTarget) {
      return context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["g" /* ADD_TARGET_TO_TARGET_LIST */], createdTarget);
    },
    afterSave: function afterSave(createdTarget) {
      return context.dispatch(__WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__["m" /* REPLACE_TARGET */], createdTarget);
    }
  });
  return createAction.run().then(function (createdTraget) {
    context.commit(SET_LOADING, false);
  }).catch(function (ex) {
    context.commit(SET_LOADING, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPLOAD_MODAL_SET_APPEND_TYPE, function (context, appendType) {
  context.commit(UPLOAD_MODAL_SET_APPEND_TYPE, appendType);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET_THE_LAS_MODAL, function (context) {
  context.dispatch(SET_STEPPER_DATA_SOURCE, { option: null, targetAction: null });
  context.dispatch(UPLOAD_MODAL_SET_APPEND_TYPE, null);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INTENTS, function (context, value) {
  context.commit(SET_INTENTS, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GET_DEMOS, function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["E" /* getComscoreDemos */])().then(function (response) {
    context.commit(GET_DEMOS, response);
  });
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1245)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1936),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_FAMILY_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_FAMILY_DATASETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_INTERFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ON_CREATE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TARGET_CREATE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_TARGET; });
/* unused harmony export ON_CREATE_REGISTER_MODULES_TO_STORE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_TARGET_DEFINITION_RELATED_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_SLOTTED_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SAVE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_ENABLE_SAVE_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_ENABLE_DOWN_STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_ENABLE_DEFINITION_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SUBMIT_DOWNSTREAM; });
/* unused harmony export SET_TARGET_DEFINITION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return QUERY_FOR_DATA; });
/* unused harmony export SET_TARGET_DEFAULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_LOADING_WORKBENCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_TARGET_DEFINITION_DIRTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return INITIALIZE_TARGET_DEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLEAR_ATTRIBUTES; });
/* unused harmony export GO_TO_DASHBOARD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SHOW_AUP_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ADVERTISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_DATASET_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_TARGET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_AVAILABLE_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFY_ADCITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MODEL_LAL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_targetDefinition__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_targetDefinition_services_serializer__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_TargetLogic__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_plugins_undoHistory__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_store_actions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appLogic_workbench_common_attributeTransformation__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers__ = __webpack_require__(8);






var _actions;













var module = 'COMMON_WORKBENCH_ACTIONS_';
var STORE_NAME = 'workbench';
var SET_ATTRIBUTES = module + 'SET_ATTRIBUTES';
var SET_FAMILY_ATTRIBUTES = module + 'SET_FAMILY_ATTRIBUTES';
var RESET_FAMILY_DATASETS = module + 'RESET_FAMILY_DATASETS';
var SET_INTERFACE = module + 'SET_INTERFACE';
var ON_CREATE_ACTION = module + 'ON_CREATE_ACTION';
var SET_TARGET_CREATE_ACTION = module + 'SET_TARGET_CREATE_ACTION';
var SET_TARGET = module + 'SET_TARGET';
var ON_CREATE_REGISTER_MODULES_TO_STORE = module + 'ON_CREATE_REGISTER_MODULES_TO_STORE';
var UPDATE_TARGET_DEFINITION_RELATED_INFORMATION = module + 'UPDATE_TARGET_DEFINITION_RELATED_INFORMATION';
var SET_SLOTTED_VALUE = module + 'SET_SLOTTED_VALUE';
var SAVE_TARGET = module + 'SAVE_TARGET';
var SET_ENABLE_SAVE_BUTTON = module + 'SET_ENABLE_SAVE_BUTTON';
var SET_ENABLE_DOWN_STREAM = module + 'SET_ENABLE_DOWN_STREAM';
var SET_ENABLE_DEFINITION_ACTIONS = module + 'SET_ENABLE_DEFINITION_ACTIONS';
var SUBMIT_DOWNSTREAM = module + 'SUBMIT_DOWNSTREAM';
var SET_TARGET_DEFINITION = module + 'SET_TARGET_DEFINITION';
var QUERY_FOR_DATA = module + 'QUERY_FOR_DATA';
var SET_TARGET_DEFAULT = module + 'SET_TARGET_DEFAULT';
var SET_LOADING_WORKBENCH = module + 'SET_LOADING_WORKBENCH';
var SET_TARGET_DEFINITION_DIRTY = module + 'SET_TARGET_DEFINITION_DIRTY';
var RESET_STORE = module + 'RESET_STORE';
var INITIALIZE_TARGET_DEF = module + 'INITIALIZE_TARGET_DEF';
var CLEAR_ATTRIBUTES = module + 'CLEAR_ATTRIBUTES';
var GO_TO_DASHBOARD = module + 'GO_TO_DASHBOARD';

var SHOW_AUP_MODAL = module + 'SHOW_AUP_MODAL';
var SET_ADVERTISER = module + 'SET_ADVERTISER';
var SET_DATASET_FAMILY = module + 'SET_DATASET_FAMILY';
var UPDATE_TARGET_NAME = module + 'UPDATE_TARGET_NAME';
var SET_AVAILABLE_DESTINATIONS = module + 'SET_AVAILABLE_DESTINATIONS';
var NOTIFY_ADCITY = module + 'NOTIFY_ADCITY';
var MODEL_LAL = module + 'MODEL_LAL';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ON_CREATE_REGISTER_MODULES_TO_STORE, function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store__["b" /* registerIfNotExist */])([STORE_NAME, 'targetDefinition'], function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_targetDefinition__["a" /* createModule */])(STORE_NAME);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET_FAMILY_DATASETS, function (context) {
  var validDatasets = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(context.rootState.appRes.datasetFamilies.datasetRelationships);
  var td = context.getters.newTargetDefinition;
  var wbTarget = context.getters.newWorkbenchTarget;
  var tdFlattened = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers__["b" /* flatten */])(td);
  var datasets = tdFlattened.map(function (x) {
    return x.rootFamily;
  }).filter(function (x) {
    return x !== undefined && validDatasets.includes(x);
  });
  if (datasets.length === 0) {
    datasets = tdFlattened.map(function (x) {
      return x.dataset;
    }).filter(function (x) {
      return x !== undefined && validDatasets.includes(x);
    });
  }

  var setFamilyAttributesPayload = {
    context: context
  };
  if (td.length === 0) {
    setFamilyAttributesPayload.family = null;
    context.commit(SET_FAMILY_ATTRIBUTES, setFamilyAttributesPayload);
  } else if (datasets.length > 0) {
    setFamilyAttributesPayload.family = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(datasets)));
    context.commit(SET_FAMILY_ATTRIBUTES, setFamilyAttributesPayload);
  } else if (wbTarget.target) {
    setFamilyAttributesPayload.family = wbTarget.target === 'xandr_segment' || wbTarget.target === 'adstra' ? ['adstra'] : ['amrld'];
    context.commit(SET_FAMILY_ATTRIBUTES, setFamilyAttributesPayload);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_AVAILABLE_DESTINATIONS, function (context, value) {
  context.commit(SET_AVAILABLE_DESTINATIONS, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ATTRIBUTES, function (context) {
  var appRes = context.rootState.appRes;
  var setUntilDatasetsAreRetrieved = function setUntilDatasetsAreRetrieved() {
    setTimeout(function () {
      if (appRes.datasets && appRes.datasetFamilies) {
        context.commit(SET_ATTRIBUTES, appRes.datasets);
        context.commit(SET_DATASET_FAMILY, appRes.datasetFamilies);
        context.dispatch(SET_TARGET_DEFINITION);
      } else {
        setUntilDatasetsAreRetrieved();
      }
    }, 10);
  };
  setUntilDatasetsAreRetrieved();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_DEFINITION, function (context) {
  var td = context.state.workbenchTarget.target_definition;
  if (td) {
    context.commit(__WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["a" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_targetDefinition_services_serializer__["a" /* default */].deserialize(td.query));
    context.dispatch(RESET_FAMILY_DATASETS);
  } else {
    context.commit(__WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["a" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_targetDefinition_services_serializer__["a" /* default */].deserialize([]));
  }
  context.dispatch(INITIALIZE_TARGET_DEF, context.getters.getDefinition);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INTERFACE, function (context, inter) {
  context.commit(SET_INTERFACE, inter);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_CREATE_ACTION, function (context, action) {
  context.commit(SET_TARGET_CREATE_ACTION, action);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET, function (context, targetInfo) {
  var inter = context.state.interface;
  if (!inter) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["f" /* fetchSingleTarget */])({ target_id: targetInfo.id }).then(function (resp) {
      context.commit(SET_TARGET, resp.data);
    });
  } else {
    return context.state.interface.getTarget(targetInfo).then(function (resp) {
      if (targetInfo.advertiser && resp.advertiser && targetInfo.advertiser.Advertiser_id !== resp.advertiser.Advertiser_id) {
        resp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, resp, { advertiser: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, targetInfo.advertiser) });
      }
      context.commit(SET_TARGET, resp);
      context.state.interface.onSetTarget(resp, context);
      return resp;
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_DEFAULT, function (context, defaultTarget) {
  context.commit(SET_TARGET, defaultTarget);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SUBMIT_DOWNSTREAM, function (context) {
  context.state.interface.sendDownStream({
    context: context,
    targetId: context.state.workbenchTarget.id
  });
  context.commit(SET_ENABLE_DOWN_STREAM, false);
  context.commit(SET_ENABLE_SAVE_BUTTON, false);
  context.commit(__WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["b" /* SET_VIEW_ONLY */], true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ON_CREATE_ACTION, function (context, targetInfo) {
  context.dispatch(ON_CREATE_REGISTER_MODULES_TO_STORE).then(function (resp) {
    context.dispatch(INITIALIZE_TARGET_DEF, null);

    if (targetInfo.targetId === 'new') {
      context.dispatch(SET_ATTRIBUTES);

      var currentTarget = context.rootGetters.currentTarget ? context.rootGetters.currentTarget : { advertiser: { Name: null }, display_name: '' };

      var td = currentTarget.target_definition;

      if (td && td.query && td.query.length > 0) {
        context.state.interface.onDuplicate(context);
      }
      context.dispatch(SET_TARGET_DEFAULT, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, currentTarget));
    } else {
      context.dispatch(SET_TARGET, targetInfo).then(function (resp) {
        context.dispatch(SET_ATTRIBUTES);
        var inter = context.state.interface;
        if (inter) {
          context.state.interface.onCreate(context);
        }
      });
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_TARGET_DEFINITION_RELATED_INFORMATION, function (context) {
  var initialLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var inter = context.state.interface;
  if (inter) {
    inter.onTargetDefinitionChange({
      context: context,
      targetDefinition: context.getters.newTargetDefinition,
      initialLoad: initialLoad
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, QUERY_FOR_DATA, function (context) {
  var inter = context.state.interface;
  return inter.queryForData({
    context: context,
    targetDefinition: context.getters.newTargetDefinition,
    caeId: context.getters.newWorkbenchTarget.cae_id || 0
  }).then(function (resp) {
    if (resp.slottedValue) {
      context.commit(SET_SLOTTED_VALUE, resp.slottedValue);
    }
    return resp;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SAVE_TARGET, function (context, _ref) {
  var target = _ref.target,
      ignoreSavePrompt = _ref.ignoreSavePrompt;

  if (target && !target.username) {
    target.username = context.rootGetters.username;
  }
  var onSave = function onSave() {
    context.commit(SET_ENABLE_DOWN_STREAM, false);
    context.commit(SET_ENABLE_SAVE_BUTTON, false);
    var newTargetDefinition = context.getters.newTargetDefinition;
    return context.state.interface.saveTarget({
      target: target,
      context: context,
      targetDefinition: newTargetDefinition,
      ignoreSavePrompt: ignoreSavePrompt
    }).then(function (resp) {
      if (newTargetDefinition.length > 0) {
        context.commit(SET_ENABLE_DOWN_STREAM, true);
      }
    }).catch(function (err) {
      console.log(err);
      context.commit(SET_ENABLE_SAVE_BUTTON, true);
    });
  };
  if (target.id) {
    return onSave();
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_TargetLogic__["a" /* validateTargetName */])(target.display_name, target.target).then(function (resp) {
      if (resp) {
        onSave();
      } else {
        context.commit(SET_ENABLE_SAVE_BUTTON, true);
      }
    }).catch(function (resp) {
      context.commit(SET_ENABLE_SAVE_BUTTON, true);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ENABLE_SAVE_BUTTON, function (context, value) {
  context.commit(SET_ENABLE_SAVE_BUTTON, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_LOADING_WORKBENCH, function (context, value) {
  context.commit(SET_LOADING_WORKBENCH, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_DEFINITION_DIRTY, function (context, value) {
  context.commit(SET_TARGET_DEFINITION_DIRTY, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ENABLE_DOWN_STREAM, function (context, value) {
  context.commit(SET_ENABLE_DOWN_STREAM, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET_STORE, function (context) {
  if (context.state.interface) {
    context.state.interface.reset(context);
  }
  context.commit(__WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["a" /* SET_DEFINITION */], []);
  context.dispatch(INITIALIZE_TARGET_DEF, null);
  context.commit(CLEAR_ATTRIBUTES);
  context.commit(RESET_STORE);
  context.commit(__WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["b" /* SET_VIEW_ONLY */], false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, INITIALIZE_TARGET_DEF, function (context, targetDef) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_11__store_plugins_undoHistory__["a" /* actions */].INITIALIZE, targetDef);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ENABLE_DEFINITION_ACTIONS, function (context, value) {
  context.commit(SET_ENABLE_DEFINITION_ACTIONS, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GO_TO_DASHBOARD, function (context) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_12__router_store_actions__["a" /* GO_TO_DASHBOARD */], null, { root: true });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_AUP_MODAL, function (context, value) {
  context.commit(SHOW_AUP_MODAL, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ADVERTISER, function (context, advertiser) {
  context.commit(SET_ADVERTISER, advertiser);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_TARGET_NAME, function (context, targetName) {
  context.commit(UPDATE_TARGET_NAME, targetName);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, NOTIFY_ADCITY, function (context, targetId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["o" /* notifyAdCity */])(targetId).then(function (response) {
    return response;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, MODEL_LAL, function (context) {
  context.state.interface.modelLAL(context);
}), _actions);

/* harmony default export */ __webpack_exports__["c"] = (actions);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createStoreConnector;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return registerIfNotExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unregisterIfExists; });
/* unused harmony export setState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_auth__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_idmAuth__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_applicationResources__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_currentTarget_store__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_notifications_store__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_route_store__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appLogic_permissions_store__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appLogic_workbench_common_store__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_store__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_networks_store_index__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_audienceHub_store__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_auth_constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_applicationResources_constants__ = __webpack_require__(129);
/* unused harmony reexport authConstants */
/* unused harmony reexport appResourceConstants */

























__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_6__modules_auth__["a" /* default */],
    idmAuth: __WEBPACK_IMPORTED_MODULE_7__modules_idmAuth__["a" /* default */],
    appRes: __WEBPACK_IMPORTED_MODULE_8__modules_applicationResources__["a" /* default */],
    currentTarget: __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_currentTarget_store__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_11__appLogic_notifications_store__["a" /* default */],
    createTarget: __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store__["a" /* default */],
    route: __WEBPACK_IMPORTED_MODULE_12__appLogic_route_store__["a" /* default */],
    permissions: __WEBPACK_IMPORTED_MODULE_13__appLogic_permissions_store__["a" /* default */],
    workbench: __WEBPACK_IMPORTED_MODULE_14__appLogic_workbench_common_store__["a" /* default */],
    routerStore: __WEBPACK_IMPORTED_MODULE_15__router_store__["a" /* default */],
    networks: __WEBPACK_IMPORTED_MODULE_16__appLogic_networks_store_index__["a" /* default */],
    audienceHub: __WEBPACK_IMPORTED_MODULE_17__views_audienceHub_store__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

var modulesToDelete = null;

function createStoreConnector(path, modules, _ref) {
  var _ref$onRegistered = _ref.onRegistered,
      onRegistered = _ref$onRegistered === undefined ? function () {} : _ref$onRegistered,
      _ref$onUnregistered = _ref.onUnregistered,
      onUnregistered = _ref$onUnregistered === undefined ? function () {} : _ref$onUnregistered;

  return function (Component) {
    var newMixins = [];
    newMixins = newMixins.concat([{
      created: function created() {
        if (modulesToDelete) {
          store.unregisterModule(modulesToDelete.path);
          onUnregistered(store, modulesToDelete.modules);
        }
        modulesToDelete = { modules: modules, path: path };
        store.registerModule(path, modules);
        onRegistered(store, modules);
      }
    }]);
    Component.mixins = Component.mixins || [];
    newMixins = newMixins.concat(Component.mixins);
    Component.mixins = newMixins;
    return Component;
  };
}

var RegisterModIfNotExistClass = function () {
  function RegisterModIfNotExistClass(modulePath, mods) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RegisterModIfNotExistClass);

    this.modulePath = modulePath;
    this.currentMod = mods;
    this.currentPath = 0;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RegisterModIfNotExistClass, [{
    key: 'doesItExist',
    value: function doesItExist() {
      var currentModName = this.modulePath[this.currentPath];
      this.currentPath = this.currentPath + 1;
      this.currentMod = this.currentMod[currentModName];
      if (this.modulePath.length === this.currentPath) {
        if (!this.currentMod) {
          return false;
        } else {
          return true;
        }
      } else {
        this.currentMod = this.currentMod._children;
        return this.doesItExist();
      }
    }
  }]);

  return RegisterModIfNotExistClass;
}();

var isFunction = function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

var registerIfNotExist = function registerIfNotExist(modulePath, moduleToRegister) {
  var mods = store._modules.root._children;
  var exists = new RegisterModIfNotExistClass(modulePath, mods).doesItExist();
  if (!exists) {
    if (isFunction(moduleToRegister)) {
      store.registerModule(modulePath, moduleToRegister());
    } else {
      store.registerModule(modulePath, moduleToRegister);
    }
  }
};

var unregisterIfExists = function unregisterIfExists(modulePath) {
  var mods = store._modules.root._children;
  var exists = new RegisterModIfNotExistClass(modulePath, mods).doesItExist();
  if (exists) {
    store.unregisterModule(modulePath);
  }
};

function setState(state, record) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(record)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      state[key] = record[key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ADD_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SELECT_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_DROPPED_ATTRIBUTES_IN_TD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MOVE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TARGET_HAD_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_OPERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNGROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CREATE_COUNT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REMOVE_COUNT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_VIEW_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_TO_VIEW_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REMOVE_VIEW_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_DRAG_DROP_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ACTIVATE_DRAG_DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DEACTIVATE_DRAG_DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_DRAG_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return START_DRAG_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REMOVE_DRAG_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UNDO_TARGET_DEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDO_TARGET_DEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return INITIALIZE_TARGET_DEF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__ = __webpack_require__(105);


var _UNDO_TARGET_DEF$REDO;




var module = 'OLD_WORKBENCH_TARGET_DEF__';

var ADD_ATTRIBUTE = module + 'ADD_ATTRIBUTE';
var REMOVE_ATTRIBUTE = module + 'REMOVE_ATTRIBUTE';
var UPDATE_ATTRIBUTE = module + 'UPDATE_ATTRIBUTE';
var SELECT_ATTRIBUTE = module + 'SELECT_ATTRIBUTE';
var CLEAR_SELECTION = module + 'CLEAR_SELECTION';
var CLEAR_DEFINITION = module + 'CLEAR_DEFINITION';
var SET_DEFINITION = module + 'SET_DEFINITION';
var SET_DROPPED_ATTRIBUTES_IN_TD = module + 'SET_DROPPED_ATTRIBUTES_IN_TD';
var MOVE_ATTRIBUTE = module + 'MOVE_ATTRIBUTE';
var SET_TARGET_HAD_CHANGED = module + 'SET_TARGET_HAD_CHANGED';

var UPDATE_OPERATOR = module + 'UPDATE_OPERATOR';

var GROUP = module + 'GROUP';
var UNGROUP = module + 'UNGROUP';
var CREATE_COUNT_GROUP = module + 'CREATE_COUNT_GROUP';
var REMOVE_COUNT_GROUP = module + 'REMOVE_COUNT_GROUP';

var SET_VIEW_ONLY = module + 'SET_VIEW_ONLY';
var SET_TO_VIEW_ONLY = module + 'SET_TO_VIEW_ONLY';
var REMOVE_VIEW_ONLY = module + 'REMOVE_VIEW_ONLY';

var SET_DRAG_DROP_MODE = module + 'SET_DRAG_DROP_MODE';
var ACTIVATE_DRAG_DROP = module + 'ACTIVATE_DRAG_DROP';
var DEACTIVATE_DRAG_DROP = module + 'DEACTIVATE_DRAG_DROP';

var SET_DRAG_ITEM = module + 'SET_DRAG_ITEM';
var START_DRAG_ITEM = module + 'START_DRAG_ITEM';
var REMOVE_DRAG_ITEM = module + 'REMOVE_DRAG_ITEM';

var UNDO_TARGET_DEF = module + 'UNDO_TARGET_DEF';
var REDO_TARGET_DEF = module + 'REDO_TARGET_DEF';
var INITIALIZE_TARGET_DEF = module + 'INITIALIZE_TARGET_DEF';

/* harmony default export */ __webpack_exports__["y"] = (_UNDO_TARGET_DEF$REDO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UNDO_TARGET_DEF, function (context) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__["a" /* actions */].UNDO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REDO_TARGET_DEF, function (context) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__["a" /* actions */].REDO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, INITIALIZE_TARGET_DEF, function (context, targetDef) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__["a" /* actions */].INITIALIZE, targetDef);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SET_TO_VIEW_ONLY, function (_ref) {
  var commit = _ref.commit;

  commit(SET_VIEW_ONLY, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_VIEW_ONLY, function (_ref2) {
  var commit = _ref2.commit;

  commit(SET_VIEW_ONLY, false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SET_DEFINITION, function (_ref3, definition) {
  var commit = _ref3.commit;

  commit(SET_DEFINITION, definition);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, ADD_ATTRIBUTE, function (_ref4, attribute) {
  var commit = _ref4.commit,
      state = _ref4.state;

  if (attribute.options) {
    var selectedAttribute = attribute.options.find(function (op) {
      return op.name === attribute.value || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"])(op.value, attribute.value);
    });
    if (selectedAttribute.type === 'custom') {
      attribute.type = selectedAttribute.type;
      attribute.query = selectedAttribute.query;
    } else if (selectedAttribute.type === 'query') {
      attribute = selectedAttribute.query;
    }
  }
  if (state.viewOnly) return;
  commit(SET_TARGET_HAD_CHANGED);
  commit(ADD_ATTRIBUTE, attribute);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UPDATE_ATTRIBUTE, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(SET_TARGET_HAD_CHANGED);
  commit(UPDATE_ATTRIBUTE, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UPDATE_OPERATOR, function (_ref6, payload) {
  var commit = _ref6.commit;

  commit(SET_TARGET_HAD_CHANGED);
  commit(UPDATE_OPERATOR, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_ATTRIBUTE, function (_ref7) {
  var commit = _ref7.commit,
      getters = _ref7.getters;

  if (getters.selectedCount > 0) {
    commit(SET_TARGET_HAD_CHANGED);
    commit(REMOVE_ATTRIBUTE);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SELECT_ATTRIBUTE, function (_ref8, attribute) {
  var commit = _ref8.commit,
      state = _ref8.state;

  if (state.viewOnly) return;
  commit(SELECT_ATTRIBUTE, attribute);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, CLEAR_SELECTION, function (_ref9) {
  var commit = _ref9.commit;

  commit(CLEAR_SELECTION);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, GROUP, function (_ref10) {
  var commit = _ref10.commit,
      getters = _ref10.getters;

  if (getters.selectedCanBeGrouped) {
    commit(SET_TARGET_HAD_CHANGED);
    commit(GROUP);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UNGROUP, function (_ref11) {
  var commit = _ref11.commit,
      getters = _ref11.getters;

  if (getters.selectedCanBeUngrouped) {
    commit(SET_TARGET_HAD_CHANGED);
    commit(UNGROUP);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, CLEAR_DEFINITION, function (_ref12) {
  var commit = _ref12.commit,
      state = _ref12.state;

  if (state.viewOnly) {
    return;
  } else {
    commit(SET_TARGET_HAD_CHANGED);
    commit(CLEAR_DEFINITION);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SET_DRAG_DROP_MODE, function (_ref13, newState) {
  var commit = _ref13.commit;

  commit(SET_DRAG_DROP_MODE, newState);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, ACTIVATE_DRAG_DROP, function (_ref14) {
  var commit = _ref14.commit;

  commit(CLEAR_SELECTION);
  commit(SET_DRAG_DROP_MODE, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, DEACTIVATE_DRAG_DROP, function (_ref15) {
  var commit = _ref15.commit;

  commit(SET_DRAG_DROP_MODE, false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, START_DRAG_ITEM, function (_ref16, value) {
  var commit = _ref16.commit;

  commit(SET_DRAG_ITEM, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_DRAG_ITEM, function (_ref17) {
  var commit = _ref17.commit;

  commit(SET_DRAG_ITEM, null);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, MOVE_ATTRIBUTE, function (_ref18, value) {
  var commit = _ref18.commit;

  commit(SET_TARGET_HAD_CHANGED);
  commit(MOVE_ATTRIBUTE, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, CREATE_COUNT_GROUP, function (_ref19, value) {
  var commit = _ref19.commit;

  commit(CREATE_COUNT_GROUP, value);
  commit(CLEAR_SELECTION);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_COUNT_GROUP, function (_ref20, value) {
  var commit = _ref20.commit;

  commit(REMOVE_COUNT_GROUP, value);
  commit(CLEAR_SELECTION);
}), _UNDO_TARGET_DEF$REDO);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADD_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SELECT_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLEAR_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MOVE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_TARGET_HAD_CHANGED; });
/* unused harmony export UNDO_TARGET_DEF */
/* unused harmony export REDO_TARGET_DEF */
/* unused harmony export INITIALIZE_TARGET_DEF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_OPERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNGROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_COUNT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return REMOVE_COUNT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_VIEW_ONLY; });
/* unused harmony export SET_TO_VIEW_ONLY */
/* unused harmony export REMOVE_VIEW_ONLY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_DRAG_DROP_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ACTIVATE_DRAG_DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DEACTIVATE_DRAG_DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_DRAG_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return START_DRAG_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REMOVE_DRAG_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_DROPPED_ATTRIBUTES_IN_TD; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__ = __webpack_require__(105);


var _UNDO_TARGET_DEF$REDO;




var ADD_ATTRIBUTE = 'ADD_ATTRIBUTE';
var REMOVE_ATTRIBUTE = 'REMOVE_ATTRIBUTE';
var UPDATE_ATTRIBUTE = 'UPDATE_ATTRIBUTE';
var SELECT_ATTRIBUTE = 'SELECT_ATTRIBUTE';
var CLEAR_SELECTION = 'CLEAR_SELECTION';
var CLEAR_DEFINITION = 'CLEAR_DEFINITION';
var SET_DEFINITION = 'SET_DEFINITION';
var MOVE_ATTRIBUTE = 'MOVE_ATTRIBUTE';
var SET_TARGET_HAD_CHANGED = 'SET_TARGET_HAD_CHANGED';
var UNDO_TARGET_DEF = 'UNDO_TARGET_DEF';
var REDO_TARGET_DEF = 'REDO_TARGET_DEF';
var INITIALIZE_TARGET_DEF = 'INITIALIZE_TARGET_DEF';

var UPDATE_OPERATOR = 'UPDATE_OPERATOR';

var GROUP = 'GROUP';
var UNGROUP = 'UNGROUP';
var CREATE_COUNT_GROUP = 'CREATE_COUNT_GROUP';
var REMOVE_COUNT_GROUP = 'REMOVE_COUNT_GROUP';

var SET_VIEW_ONLY = 'SET_VIEW_ONLY';
var SET_TO_VIEW_ONLY = 'SET_TO_VIEW_ONLY';
var REMOVE_VIEW_ONLY = 'REMOVE_VIEW_ONLY';

var SET_DRAG_DROP_MODE = 'SET_DRAG_DROP_MODE';
var ACTIVATE_DRAG_DROP = 'ACTIVATE_DRAG_DROP';
var DEACTIVATE_DRAG_DROP = 'DEACTIVATE_DRAG_DROP';

var SET_DRAG_ITEM = 'SET_DRAG_ITEM';
var START_DRAG_ITEM = 'START_DRAG_ITEM';
var REMOVE_DRAG_ITEM = 'REMOVE_DRAG_ITEM';
var SET_DROPPED_ATTRIBUTES_IN_TD = 'SET_DROPPED_ATTRIBUTES_IN_TD';

/* harmony default export */ __webpack_exports__["w"] = (_UNDO_TARGET_DEF$REDO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UNDO_TARGET_DEF, function (context) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__["a" /* actions */].UNDO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REDO_TARGET_DEF, function (context) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__["a" /* actions */].REDO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, INITIALIZE_TARGET_DEF, function (context, targetDef) {
  context.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_plugins_undoHistory__["a" /* actions */].INITIALIZE, targetDef);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SET_TO_VIEW_ONLY, function (_ref) {
  var commit = _ref.commit;

  commit(SET_VIEW_ONLY, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_VIEW_ONLY, function (_ref2) {
  var commit = _ref2.commit;

  commit(SET_VIEW_ONLY, false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SET_DEFINITION, function (_ref3, definition) {
  var commit = _ref3.commit;

  commit(SET_DEFINITION, definition);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, ADD_ATTRIBUTE, function (_ref4, attribute) {
  var commit = _ref4.commit,
      state = _ref4.state;

  if (attribute.options) {
    var selectedAttribute = attribute.options.find(function (op) {
      return op.name === attribute.value || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"])(op.value, attribute.value);
    });
    if (selectedAttribute.type === 'custom') {
      attribute.type = selectedAttribute.type;
      attribute.query = selectedAttribute.query;
    } else if (selectedAttribute.type === 'query') {
      attribute = selectedAttribute.query;
    }
  }
  if (state.viewOnly) return;
  commit(SET_TARGET_HAD_CHANGED);
  commit(ADD_ATTRIBUTE, attribute);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UPDATE_ATTRIBUTE, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(SET_TARGET_HAD_CHANGED);
  commit(UPDATE_ATTRIBUTE, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UPDATE_OPERATOR, function (_ref6, payload) {
  var commit = _ref6.commit;

  commit(SET_TARGET_HAD_CHANGED);
  commit(UPDATE_OPERATOR, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_ATTRIBUTE, function (_ref7) {
  var commit = _ref7.commit,
      getters = _ref7.getters;

  if (getters.selectedCount > 0) {
    commit(SET_TARGET_HAD_CHANGED);
    commit(REMOVE_ATTRIBUTE);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SELECT_ATTRIBUTE, function (_ref8, attribute) {
  var commit = _ref8.commit,
      state = _ref8.state;

  if (state.viewOnly) return;
  commit(SELECT_ATTRIBUTE, attribute);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, CLEAR_SELECTION, function (_ref9) {
  var commit = _ref9.commit;

  commit(CLEAR_SELECTION);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, GROUP, function (_ref10) {
  var commit = _ref10.commit,
      getters = _ref10.getters;

  if (getters.selectedCanBeGrouped) {
    commit(SET_TARGET_HAD_CHANGED);
    commit(GROUP);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, UNGROUP, function (_ref11) {
  var commit = _ref11.commit,
      getters = _ref11.getters;

  if (getters.selectedCanBeUngrouped) {
    commit(SET_TARGET_HAD_CHANGED);
    commit(UNGROUP);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, CLEAR_DEFINITION, function (_ref12) {
  var commit = _ref12.commit,
      state = _ref12.state;

  if (state.viewOnly) {
    return;
  } else {
    commit(SET_TARGET_HAD_CHANGED);
    commit(CLEAR_DEFINITION);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, SET_DRAG_DROP_MODE, function (_ref13, newState) {
  var commit = _ref13.commit;

  commit(SET_DRAG_DROP_MODE, newState);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, ACTIVATE_DRAG_DROP, function (_ref14) {
  var commit = _ref14.commit;

  commit(CLEAR_SELECTION);
  commit(SET_DRAG_DROP_MODE, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, DEACTIVATE_DRAG_DROP, function (_ref15) {
  var commit = _ref15.commit;

  commit(SET_DRAG_DROP_MODE, false);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, START_DRAG_ITEM, function (_ref16, value) {
  var commit = _ref16.commit;

  commit(SET_DRAG_ITEM, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_DRAG_ITEM, function (_ref17) {
  var commit = _ref17.commit;

  commit(SET_DRAG_ITEM, null);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, MOVE_ATTRIBUTE, function (_ref18, value) {
  var commit = _ref18.commit;

  commit(SET_TARGET_HAD_CHANGED);
  commit(MOVE_ATTRIBUTE, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, CREATE_COUNT_GROUP, function (_ref19, value) {
  var commit = _ref19.commit;

  commit(CREATE_COUNT_GROUP, value);
  commit(CLEAR_SELECTION);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNDO_TARGET_DEF$REDO, REMOVE_COUNT_GROUP, function (_ref20, value) {
  var commit = _ref20.commit;

  commit(REMOVE_COUNT_GROUP, value);
  commit(CLEAR_SELECTION);
}), _UNDO_TARGET_DEF$REDO);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollPanel_vue__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ScrollPanel_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ScrollPanel_vue___default.a);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INIT_WORKBENCH_FOR_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_DATA_FROM_TARGET; });
/* unused harmony export SELECT_NETWORK_DAY_PART */
/* unused harmony export UPDATE_SELECTED_VIEWERSHIP_NETWORKS */
/* unused harmony export CLOSE_DAY_PARTS_SECTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_DATA_FROM_TARGET_FOR_GRAPHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_STREAMING_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_STREAMING_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_TARGET_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TARGET_ENVIRONMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SUBMIT_TO_DC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_TARGET_DEFINITION_DIRTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_TARGET_HISTORY_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_IS_DROPPED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);













var module = 'WORKBENCH_';

var INIT_WORKBENCH_FOR_TARGET = module + 'INIT_WORKBENCH_FOR_TARGET';
var SAVE_TARGET = module + 'SAVE_TARGET';
var SET_DATA_FROM_TARGET = module + 'SET_DATA_FROM_TARGET';
var SELECT_NETWORK_DAY_PART = module + 'SELECT_NETWORK_DAY_PART';
var UPDATE_SELECTED_VIEWERSHIP_NETWORKS = module + 'UPDATE_SELECTED_VIEWERSHIP_NETWORKS';
var CLOSE_DAY_PARTS_SECTION = module + 'CLOSE_DAY_PARTS_SECTION';
var FETCH_DATA_FROM_TARGET_FOR_GRAPHS = module + 'FETCH_DATA_FROM_TARGET_FOR_GRAPHS';
var UPDATE_STREAMING_OPTION = module + 'UPDATE_STREAMING_OPTION';
var SET_STREAMING_CHANGED = module + 'SET_STREAMING_CHANGED';
var SET_TARGET_DEFINITION = module + 'SET_TARGET_DEFINITION';
var SET_TARGET_ENVIRONMENT = module + 'SET_TARGET_ENVIRONMENT';
var SUBMIT_TO_DC = module + 'SUBMIT_TO_DC';
var SET_TARGET_DEFINITION_DIRTY = __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* SET_TARGET_DEFINITION_DIRTY */];
var SHOW_TARGET_HISTORY_PANEL = __WEBPACK_IMPORTED_MODULE_4__mutations__["b" /* SHOW_TARGET_HISTORY_PANEL */];
var SET_IS_DROPPED = __WEBPACK_IMPORTED_MODULE_4__mutations__["c" /* SET_IS_DROPPED */];

var WorkbenchWCanvasSlotActionsGenerator = function () {
  function WorkbenchWCanvasSlotActionsGenerator() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WorkbenchWCanvasSlotActionsGenerator);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WorkbenchWCanvasSlotActionsGenerator, [{
    key: 'setNamespace',
    value: function setNamespace(namespace) {
      this.namespace = namespace;
    }
  }, {
    key: 'createInitAction',
    value: function createInitAction() {
      var functionBody = this.initActionBody;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, INIT_WORKBENCH_FOR_TARGET, function (store, id) {
        functionBody(store, id);
      });
    }
  }, {
    key: 'initActionBody',
    value: function initActionBody() {
      throw new Error('You must write your init Action for the workbench');
    }
  }, {
    key: 'createSaveTargetAction',
    value: function createSaveTargetAction() {
      var getTargetData = this.targetDataToSave;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SAVE_TARGET, function (_ref2) {
        var dispatch = _ref2.dispatch,
            commit = _ref2.commit,
            state = _ref2.state,
            getters = _ref2.getters,
            rootState = _ref2.rootState;

        if (getters.isSaving) return;
        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* SET_SAVING */], true);
        var dataToSave = getTargetData({ state: state, getters: getters });

        var workbenchDataValues = ['income_data', 'age_data', 'viewership_historical', 'metrics', 'universe', 'audience_size', 'social_affinity', 'tsp_attributes', 'activation_path', 'brand_reach', 'networks', 'activation_path'];
        var workbenchData = {};
        for (var key in dataToSave) {
          if (workbenchDataValues.includes(key)) {
            workbenchData[key] = dataToSave[key];
          }
        }
        dataToSave.workbench_data = workbenchData;
        if (!dataToSave.activation_status || dataToSave.activation_status && dataToSave.activation_status === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
          dataToSave.activation_status = __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
        }
        var targetAdvertiser = this.state.currentTarget.currentTarget.advertiser;
        dataToSave.advertiser = targetAdvertiser;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api__["r" /* saveTarget */])(dataToSave).then(function (res) {
          var display_name = dataToSave.display_name,
              id = dataToSave.id,
              target = dataToSave.target;

          adobeAnalytics.saveTarget({
            username: rootState.auth.username,
            target: {
              name: display_name,
              id: id,
              type: target
            }
          });

          dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["v" /* SET_CURRENT_TARGET_DEFINITION */], getters.targetDefinition);
          dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], res.data);
          commit(SET_TARGET_DEFINITION_DIRTY, true);
          commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["e" /* SET_LOADING */], false);
          commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* SET_SAVING */], false);
        });
      });
    }
  }, {
    key: 'targetDataToSave',
    value: function targetDataToSave(_ref4) {
      var state = _ref4.state,
          getters = _ref4.getters;

      throw new Error('You have to pass data to save the target');
    }
  }, {
    key: 'createFetchDataFromTargetForGraphs',
    value: function createFetchDataFromTargetForGraphs() {
      var retrieveDataFromTarget = this.fetchDataFromTargetForGraphs;
      var that = this;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, FETCH_DATA_FROM_TARGET_FOR_GRAPHS, function (store) {
        if (store.getters.isFetchingTarget && !that.hitOnce) {
          that.hitOnce = true;
          return;
        }
        store.commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["f" /* FLAG_REQUEST_NUMBER */]);
        return retrieveDataFromTarget(store);
      });
    }
  }, {
    key: 'fetchDataFromTargetForGraphs',
    value: function fetchDataFromTargetForGraphs() {
      throw new Error('Override "fetchDataFromTargetForGraphs" this with a function that retrieves all of the data for the workbench, (graphs, metrics....)');
    }
  }, {
    key: 'createSetDataFromTarget',
    value: function createSetDataFromTarget(store, data) {
      var setDataFnc = this.dataFromTargetToSet;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SET_DATA_FROM_TARGET, function (_ref6, data) {
        var commit = _ref6.commit;

        setDataFnc(commit, data);
      });
    }
  }, {
    key: 'dataFromTargetToSet',
    value: function dataFromTargetToSet() {
      throw new Error('Override this with a function that commits all of the data for the canvas/charts');
    }
  }, {
    key: 'createTargetDirtyAction',
    value: function createTargetDirtyAction() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SET_TARGET_DEFINITION_DIRTY, function (_ref8, value) {
        var commit = _ref8.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* SET_TARGET_DEFINITION_DIRTY */], value);
      });
    }
  }, {
    key: 'additionalActions',
    value: function additionalActions() {
      return {};
    }
  }, {
    key: 'createSetStreamingOptionAction',
    value: function createSetStreamingOptionAction() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, UPDATE_STREAMING_OPTION, function (_ref10, streamingOption) {
        var commit = _ref10.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["g" /* SET_STREAMING_OPTION */], streamingOption);
      });
    }
  }, {
    key: 'createSetStreamingChanged',
    value: function createSetStreamingChanged() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SET_STREAMING_CHANGED, function (_ref12) {
        var commit = _ref12.commit;

        commit(__WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_targetDefinition_store_actions__["a" /* SET_TARGET_HAD_CHANGED */]);
      });
    }
  }, {
    key: 'createRevisionHistoryAction',
    value: function createRevisionHistoryAction() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutations__["b" /* SHOW_TARGET_HISTORY_PANEL */], function (context, value) {
        context.commit(SHOW_TARGET_HISTORY_PANEL, value);
      });
    }
  }, {
    key: 'createActions',
    value: function createActions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.createInitAction(), this.createSaveTargetAction(), this.createTargetDirtyAction(), this.createFetchDataFromTargetForGraphs(), this.createSetDataFromTarget(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, SET_IS_DROPPED, function (_ref15, value) {
        var commit = _ref15.commit;

        commit(SET_IS_DROPPED, value);
      }), this.createSetStreamingOptionAction(), this.createSetStreamingChanged(), this.createRevisionHistoryAction(), this.additionalActions(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutations__["h" /* SET_FETCHING_TARGET */], function (context, value) {
        context.commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["h" /* SET_FETCHING_TARGET */], value);
      }));
    }
  }]);

  return WorkbenchWCanvasSlotActionsGenerator;
}();

/* harmony default export */ __webpack_exports__["m"] = (WorkbenchWCanvasSlotActionsGenerator);

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\"><path d=\"M1.6 0L0 1.625 4.8 6.5 0 11.375 1.6 13 8 6.5z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_SINGLE_TARGET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_SINGLE_AUDIENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TOGGLE_TARGET_ARCHIVE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return POST_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRE_ACTIVATION_EDIT_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATE_TARGET; });
/* unused harmony export DUPLICATE_TARGET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_LOADING_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_ACTIVATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVE_TARGET_FROM_TARGET_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_TARGET_TO_TARGET_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FORECAST_TARGET_TO_TARGET_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_TARGET_TO_TARGET_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REFRESH_TARGET_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ARCHIVE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UNARCHIVE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REPLACE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REFRESH_TABLE; });
/* unused harmony export VALIDATE_LAS_DATA_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_LAS_DATA_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGED_ON_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_REFRESH_TABLE_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_TARGET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_COLUMN_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REMOVE_COLUMN_FILTER_VALUES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_toasts__ = __webpack_require__(25);




var _actions;







var module = 'TARGET_MANAGER_';

var FETCH_SINGLE_TARGET = module + 'FETCH_SINGLE_TARGET';
var FETCH_SINGLE_AUDIENCE = module + 'FETCH_SINGLE_AUDIENCE';

var TOGGLE_TARGET_ARCHIVE_STATE = module + 'TOGGLE_TARGET_ARCHIVE_STATE';

var POST_TARGET = module + 'POST_TARGET';
var PRE_ACTIVATION_EDIT_TARGET = module + 'PRE_ACTIVATION_EDIT';
var DELETE_TARGET = module + 'DELETE_TARGET';
var UPDATE_TARGET = module + 'UPDATE_TARGET';
var CREATE_TARGET = module + 'CREATE_TARGET';
var DUPLICATE_TARGET = module + 'DUPLICATE_TARGET';
var SET_LOADING_VALUE = module + 'SET_LOADING_VALUE';
var SET_ACTIVATION_FAILED = module + 'SET_ACTIVATION_FAILED';
var REMOVE_TARGET_FROM_TARGET_LIST = module + 'REMOVE_TARGET_FROM_TARGET_LIST';
var ADD_TARGET_TO_TARGET_LIST = module + 'FORECAST_TARGET_TO_TARGET_LIST';
var FORECAST_TARGET_TO_TARGET_LIST = module + 'FORECAST_TARGET';
var UPDATE_TARGET_TO_TARGET_LIST = module + 'UPDATE_TARGET_TO_TARGET_LIST';
var REFRESH_TARGET_LIST = module + 'REFRESH_TARGET_LIST';
var ARCHIVE_TARGET = module + 'ARCHIVE_TARGET';
var UNARCHIVE_TARGET = module + 'UNARCHIVE_TARGET';
var REPLACE_TARGET = module + 'REPLACE_TARGET';
var REFRESH_TABLE = module + 'REFRESH_TABLE';
var VALIDATE_LAS_DATA_AVAILABLE = module + 'VALIDATE_LAS_DATA_AVAILABLE';
var SET_LAS_DATA_AVAILABLE = module + 'SET_LAS_DATA_AVAILABLE';

var CHANGED_ON_FILTER = module + 'CHANGED_ON_FILTER';
var SET_REFRESH_TABLE_FLAG = module + 'SET_REFRESH_TABLE_FLAG';
var SET_TARGET_STATUS = module + 'SET_TARGET_STATUS';
var SET_COLUMN_FILTERS = module + 'SET_COLUMN_FILTERS';
var REMOVE_COLUMN_FILTER_VALUES = module + 'REMOVE_COLUMN_FILTER_VALUES';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CHANGED_ON_FILTER, function (context, previousFilter) {
  context.commit(CHANGED_ON_FILTER, previousFilter);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_SINGLE_TARGET, function (context, params) {
  context.commit(SET_LOADING_VALUE, true);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["f" /* fetchSingleTarget */])({ target_id: params.id }).then(function (response) {
    var target = response.data;
    context.dispatch(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], response.data);
    context.commit(SET_LOADING_VALUE, false);
  }).catch(function (reason) {
    context.commit(SET_LOADING_VALUE, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, FETCH_SINGLE_AUDIENCE, function (context, params) {
  var cacheKey = 'audience_' + params.id;

  if (context.state.pendingRequests && context.state.pendingRequests[cacheKey]) {
    return context.state.pendingRequests[cacheKey];
  }

  var promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["f" /* fetchSingleTarget */])({ target_id: params.id }).then(function (response) {
      resolve(response.data);
    }).catch(function (reason) {
      return reject(reason);
    }).finally(function () {
      if (context.state.pendingRequests) {
        delete context.state.pendingRequests[cacheKey];
      }
    });
  });

  if (!context.state.pendingRequests) {
    context.state.pendingRequests = {};
  }
  context.state.pendingRequests[cacheKey] = promise;

  return promise;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, POST_TARGET, function (context, target) {
  context.commit(SET_LOADING_VALUE, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["g" /* postTarget */])(target).then(function (response) {
    adobeAnalytics.generateForcast({
      username: context.rootState.auth.username,
      target: {
        name: target.display_name,
        id: target.id,
        type: target.target
      }
    });
    context.commit(POST_TARGET, target);
    context.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_common_store_actions__["a" /* NOTIFY_ADCITY */], target.id);
    context.commit(SET_LOADING_VALUE, false);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* targetRouteHandler */])('OPEN', target);
  }).catch(function (reason) {
    context.commit(SET_LOADING_VALUE, false);
    context.commit(SET_ACTIVATION_FAILED, true);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, VALIDATE_LAS_DATA_AVAILABLE, function (context, targetId) {
  context.commit(SET_LAS_DATA_AVAILABLE, true);
  context.commit(SET_LOADING_VALUE, true);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["h" /* validateLASDataAvailable */])(targetId).then(function (response) {
    context.commit(SET_LAS_DATA_AVAILABLE, response['data']['12_months_data_available']);
    context.commit(SET_LOADING_VALUE, false);
  }).catch(function (reason) {
    context.commit(SET_LAS_DATA_AVAILABLE, true);
    context.commit(SET_LOADING_VALUE, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, PRE_ACTIVATION_EDIT_TARGET, function (context, _ref) {
  var originalTarget = _ref.originalTarget,
      newTarget = _ref.newTarget;

  context.commit(SET_LOADING_VALUE, true);

  var target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, originalTarget, newTarget);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["i" /* editTarget */])(target).then(function (response) {
    var resTarget = response.data.Target;
    context.commit(PRE_ACTIVATION_EDIT_TARGET, { originalTarget: originalTarget, newTarget: resTarget });
    context.commit(SET_LOADING_VALUE, false);
  }).catch(function (reason) {
    context.commit(SET_LOADING_VALUE, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DELETE_TARGET, function (context, target) {
  context.commit(SET_REFRESH_TABLE_FLAG, false);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["j" /* deleteTarget */])(target).then(function (response) {
    context.commit(REMOVE_TARGET_FROM_TARGET_LIST, target);
    context.commit(SET_REFRESH_TABLE_FLAG, true);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ARCHIVE_TARGET, function (context, target) {
  context.commit(SET_REFRESH_TABLE_FLAG, false);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["k" /* archiveTarget */])(target).then(function (response) {
    if (response && response.Error) {
      __WEBPACK_IMPORTED_MODULE_7__components_common_toasts__["a" /* default */].error({ title: 'Error has occurred', message: '' + response.Error });
    } else {
      context.commit(TOGGLE_TARGET_ARCHIVE_STATE, target);
      context.commit(REFRESH_TARGET_LIST);
      context.commit(SET_REFRESH_TABLE_FLAG, true);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UNARCHIVE_TARGET, function (context, target) {
  context.commit(SET_REFRESH_TABLE_FLAG, false);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["l" /* unArchiveTarget */])(target).then(function (response) {
    context.commit(TOGGLE_TARGET_ARCHIVE_STATE, target);
    context.commit(REFRESH_TARGET_LIST);
    context.commit(SET_REFRESH_TABLE_FLAG, true);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REFRESH_TABLE, function (context, value) {
  context.commit(SET_REFRESH_TABLE_FLAG, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REMOVE_TARGET_FROM_TARGET_LIST, function (context, target) {
  context.commit(REMOVE_TARGET_FROM_TARGET_LIST, target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ADD_TARGET_TO_TARGET_LIST, function (context, target) {
  context.commit(ADD_TARGET_TO_TARGET_LIST, target);
  context.commit(REFRESH_TARGET_LIST);
  context.commit(SET_REFRESH_TABLE_FLAG, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, FORECAST_TARGET_TO_TARGET_LIST, function (context, targetId) {
  context.commit(FORECAST_TARGET_TO_TARGET_LIST, targetId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_TARGET_TO_TARGET_LIST, function (context, target) {
  context.commit(UPDATE_TARGET_TO_TARGET_LIST, target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CREATE_TARGET, function (context, target) {
  context.commit(SET_LOADING_VALUE, true);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["m" /* createTarget */])(target).then(function (response) {
    adobeAnalytics.createTarget({
      username: target.username,
      target: {
        name: target.display_name,
        type: target.target,
        id: response.data.id
      }
    });
    context.commit(CREATE_TARGET, response.data);
    context.commit(SET_LOADING_VALUE, false);
    return response;
  }).catch(function (reason) {
    context.commit(SET_LOADING_VALUE, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DUPLICATE_TARGET, function (context, _ref2) {
  var target = _ref2.target,
      duplicate_id = _ref2.duplicate_id;

  context.commit(SET_LOADING_VALUE, true);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["n" /* duplicateTarget */])({ target: target, duplicate_id: duplicate_id }).then(function (response) {
    adobeAnalytics.createTarget({
      username: target.username,
      target: {
        name: target.display_name,
        type: target.target,
        id: response.data.id
      }
    });
    context.commit(CREATE_TARGET, response.data);
    context.commit(SET_LOADING_VALUE, false);
  }).catch(function (reason) {
    context.commit(SET_LOADING_VALUE, false);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REPLACE_TARGET, function (context, target) {
  context.commit(REPLACE_TARGET, target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_REFRESH_TABLE_FLAG, function (context, value) {
  context.commit(SET_REFRESH_TABLE_FLAG, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_COLUMN_FILTERS, function (context, value) {
  context.commit(SET_COLUMN_FILTERS, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REMOVE_COLUMN_FILTER_VALUES, function (context) {
  context.commit(REMOVE_COLUMN_FILTER_VALUES);
}), _actions);

/* harmony default export */ __webpack_exports__["b"] = (actions);

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionModal__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ActionModal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ActionModal___default.a; });



/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__Modal_vue___default.a);



/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoaderDots__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoaderDots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LoaderDots__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LoaderDots___default.a);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_OKTALoginPage__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_OKTALoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_login_OKTALoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_workbench_SM__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_workbench_AD__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_workbenchConvergence_WorkbenchConvergence__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_workbenchConvergence_WorkbenchConvergence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_workbenchConvergence_WorkbenchConvergence__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_devPage_devPage__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_devPage_devPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_devPage_devPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__okta_okta_auth_js__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__okta_okta_auth_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__okta_okta_auth_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__okta_okta_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_audienceHub__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_audienceHub_AudienceHubDashboard__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_audienceHub_AudienceHubDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_audienceHub_AudienceHubDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_permissions_UsersView__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_permissions_UsersView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_permissions_UsersView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_permissions_AdminLogin__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_permissions_AdminLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_permissions_AdminLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_permissions_AdminView__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_permissions_AdminView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_permissions_AdminView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_permissions_PermissionsView__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_permissions_PermissionsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_permissions_PermissionsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_targets__ = __webpack_require__(768);





















var OKTA_ISSUER_URL = "https://sso.wbd.com";
var OKTA_CLIENT_ID = "0oarr68epfFF3IoGY0x7";

var oktaAuth = new __WEBPACK_IMPORTED_MODULE_7__okta_okta_auth_js__["OktaAuth"]({
  issuer: OKTA_ISSUER_URL,
  clientId: OKTA_CLIENT_ID,
  redirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  tokenManager: {
    autoRenew: true,
    expireEarlySeconds: 5 * 60 }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__okta_okta_vue__["a" /* default */], { oktaAuth: oktaAuth });

var ROUTES = {
  PERMISSIONS: {
    path: 'permissions',
    name: 'Permissions'
  },
  USERS: {
    path: 'users',
    name: 'Users'
  },
  ADMIN: {
    path: '/admin',
    name: 'Admin'
  }
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/logout',
    name: 'LOGOUT',
    component: __WEBPACK_IMPORTED_MODULE_9__views_audienceHub__["a" /* AudienceHub */]
  }, {
    path: '/',
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_9__views_audienceHub__["a" /* AudienceHub */]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_login_OKTALoginPage___default.a
  }, {
    path: '/workbench/sm/:id',
    name: __WEBPACK_IMPORTED_MODULE_15__helpers_targets__["a" /* TARGET_CONSTANTS */].sd.workbench,
    component: __WEBPACK_IMPORTED_MODULE_3__views_workbench_SM__["a" /* default */]
  }, {
    path: '/workbench/ad/:id',
    name: __WEBPACK_IMPORTED_MODULE_15__helpers_targets__["a" /* TARGET_CONSTANTS */].ad.workbench,
    component: __WEBPACK_IMPORTED_MODULE_4__views_workbench_AD__["a" /* default */]
  }, {
    path: '/aw/:id',
    name: 'NewWorkbench',
    component: __WEBPACK_IMPORTED_MODULE_5__views_workbenchConvergence_WorkbenchConvergence___default.a
  }, {
    path: '/newworkbench/adstra/:id',
    name: 'XandrWorkbench',
    component: __WEBPACK_IMPORTED_MODULE_5__views_workbenchConvergence_WorkbenchConvergence___default.a
  }, {
    path: '/audience-hub/',
    name: 'audience-hub',
    component: __WEBPACK_IMPORTED_MODULE_9__views_audienceHub__["a" /* AudienceHub */],
    children: [{
      path: 'targets/:name?',
      name: 'user-audience-hub',
      component: __WEBPACK_IMPORTED_MODULE_10__views_audienceHub_AudienceHubDashboard___default.a,
      props: function props(route) {
        return { query: route.query };
      }
    }]
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_13__views_permissions_AdminView___default.a,
    children: [{
      path: 'permissions',
      name: 'Permissions',
      component: __WEBPACK_IMPORTED_MODULE_14__views_permissions_PermissionsView___default.a
    }, {
      path: 'users',
      name: 'Users',
      component: __WEBPACK_IMPORTED_MODULE_11__views_permissions_UsersView___default.a
    }]
  }, {
    path: '/admin/idmlogin',
    name: 'AdminLogin',
    component: __WEBPACK_IMPORTED_MODULE_12__views_permissions_AdminLogin___default.a
  }, {
    path: '/dev/workingpage',
    component: __WEBPACK_IMPORTED_MODULE_6__views_devPage_devPage___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isAttribute;

/* harmony default export */ __webpack_exports__["a"] = ({
  SELECT: 'select',
  BOOLEAN: 'boolean',
  RANGE: 'range',
  RANGE_SELECT: 'rangeSelect'
});

function isAttribute(attribute) {
  return typeof attribute.type !== 'undefined';
}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clientLogic_apis_WebAPI__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(32);







var getConfig = function getConfig() {
  var headers = {
    'x-api-key': __webpack_require__.i({"NODE_ENV":"production","CONFIG_BUCKET":"audiencematters-config-prod","API_V2_ROOT":"https://api.audiencematters.turnerapps.com/v2","API_ROOT":"https://api.audiencematters.turnerapps.com/workbench","API_ROOT_NODE":"https://api.audiencematters.turnerapps.com/node","API_ROOT_LAS":"https://api.audiencematters.turnerapps.com/las","API_ROOT_SM":"https://api.audiencematters.turnerapps.com/sm","API_ROOT_XANDR_NODE":"https://api.audiencematters.turnerapps.com/xandr","API_ROOT_OPEN_AP":"https://api.audiencematters.turnerapps.com/workbench","API_ROOT_ES":"https://api.audiencematters.turnerapps.com/v2/es","API_LOAD_BALANCER":"https://prod.lb.api.audiencematters.turnerapps.com","ES_URL":"https://vpc-audiencematters-prod-7x-vsdtcn2yueq4telfnekg4i3ntq.us-east-1.es.amazonaws.com","ES_AUTH":"","LAS_INDEX":"linearadsales","UE_INDEX":"universe_estimate","OKTA_ISSUER_URL":"https://sso.wbd.com","OKTA_CLIENT_ID":"0oarr68epfFF3IoGY0x7","IDENTITY_POOL_ID":"us-east-1:86716e1a-6193-47c6-97fd-d8bb1dc1abf8","ENABLE_AUTHORIZATION":true,"ENABLE_XANDR_MOCK_DATA_BUTTON":false,"ENABLE_FREQUENCIES":false,"ENABLE_ADDRESSABLE":true,"CONVERT_TO_TURNER_EMAIL":false,"ENABLE_XD_FLIGHT_OVERLAP":false,"ENABLE_CANOE_LINEAR":true,"ENABLE_CANOE_VOD":true}).API_KEY,
    'x-access-token': __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.auth.token,
    'x-username': __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.auth.username,
    'Access-Control-Request-Headers': 'text/plain'
  };

  return {
    headers: headers
  };
};

var WebAPI = function (_OtherWebAPI) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(WebAPI, _OtherWebAPI);

  function WebAPI(_ref) {
    var baseURL = _ref.baseURL;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WebAPI);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WebAPI)).call(this, { sessionFunc: getConfig, baseURL: baseURL }));
  }

  return WebAPI;
}(__WEBPACK_IMPORTED_MODULE_4__clientLogic_apis_WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (WebAPI);

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export determineSizeOfBubble */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return transformHistoricalViewershipGraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return topAttributesAxises; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return historicalViewershipGraphAxises; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return extractDayPartsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return transformViewershipDataForDayParts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transformUniverseDataForGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return transformTopAttributesForGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return transformReachDataForGraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters_truncateAmount__ = __webpack_require__(128);







var chartConfig = {
  bubbleSizes: {
    viewership: {
      min: 15,
      max: 90
    },
    dayParts: {
      min: 5,
      max: 30
    }
  }
};

var findMaxValue = function findMaxValue(data, propName) {
  var startingPoint = 0;
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).length > 0) {
    startingPoint = data[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(data)[0]][propName];
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["reduce"])(data, function (result, value) {
    return result > value[propName] ? result : value[propName];
  }, startingPoint);
};

var findMinValue = function findMinValue(data, propName) {
  var startingPoint = 0;
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).length > 0) {
    startingPoint = data[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(data)[0]][propName];
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["reduce"])(data, function (result, value) {
    return result < value[propName] ? result : value[propName];
  }, startingPoint);
};

var determineSizeOfBubble = function determineSizeOfBubble(data, audienceSize, bubbleSize) {
  var maxBubbleRadius = bubbleSize.max;
  var minBubbleRadius = bubbleSize.min;
  var maxValue = findMaxValue(data, 'size');
  var minValue = findMinValue(data, 'size');
  if (maxValue === minValue) {
    return bubbleSize.max;
  } else {
    var valueRange = maxValue - minValue;
    var bubbleSizeRange = maxBubbleRadius - minBubbleRadius;

    return (audienceSize - minValue) / valueRange * bubbleSizeRange + minBubbleRadius;
  }
};

var transformHistoricalViewershipGraphData = function transformHistoricalViewershipGraphData(networks, data, networksToHighlight, overrideBubbleSize) {
  if (overrideBubbleSize) {
    chartConfig.bubbleSizes.viewership = overrideBubbleSize;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(data)) {
    return {
      datasets: []
    };
  }
  return {
    datasets: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(data, function (value, key) {
      var network = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(networks, function (network) {
        return network.id === key;
      });
      if (!network || !data.hasOwnProperty(network.id)) {
        network = {
          id: key,
          name: key
        };
      }
      var bgColor = network.turner ? 'rgba(0, 82, 231, 0.8)' : 'rgba(255, 112, 0, 0.8)';
      var hoverBgColor = network.turner ? 'rgba(76, 190, 231, 1)' : 'rgba(255, 194, 0, 1)';
      if (networksToHighlight.indexOf(network.id) > -1) {
        bgColor = hoverBgColor;
      }
      return {
        network: network.id,
        label: network.name + ' - ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* commaFormatString */])(String(data[network.id].size)),
        backgroundColor: bgColor,
        hoverBackgroundColor: hoverBgColor,
        dataLabels: {
          image: network.url,
          label: network.name,
          options: {
            color: '#fff'
          }
        },
        data: [{
          x: value.rating,
          y: value.index,
          r: determineSizeOfBubble(data, value.size, chartConfig.bubbleSizes.viewership)
        }],
        hoverRadius: 0
      };
    }).sort(function (a, b) {
      return a.data[0].r - b.data[0].r;
    })
  };
};

var calcGraphAxises = function calcGraphAxises(data, xValue, yValue, shiftLeft) {
  var xMinValue = findMinValue(data, xValue);
  var xMaxValue = findMaxValue(data, xValue);
  var xValueRange = xMaxValue - xMinValue;
  var shiftBy = shiftLeft ? xValueRange * shiftLeft : null;
  var yMinValue = findMinValue(data, yValue);
  var yMaxValue = findMaxValue(data, yValue);
  var yValueRange = yMaxValue - yMinValue;
  var xOffset = xValueRange * 0.2;
  var yOffset = yValueRange * 0.2;
  if (xOffset === 0) {
    xOffset = 0.5;
  }
  if (yOffset === 0) {
    yOffset = 10;
  }
  return {
    x: {
      min: xMinValue - (shiftBy ? xOffset - shiftBy : xOffset),
      max: xMaxValue + (shiftBy ? xOffset + shiftBy : xOffset)
    },
    y: {
      min: yMinValue - yOffset,
      max: yMaxValue + yOffset
    }
  };
};

var topAttributesAxises = function topAttributesAxises(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(data) ? { x: { min: 0, max: 6 }, y: { min: 0, max: 1 } } : calcGraphAxises(data, 'coverage', 'index', 0.1);
};

var historicalViewershipGraphAxises = function historicalViewershipGraphAxises(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(data) ? { x: { min: 0, max: 1 }, y: { min: 0, max: 200 } } : calcGraphAxises(data, 'rating', 'index');
};

var extractDayPartsData = function extractDayPartsData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["remove"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["flatMap"])(data, function (network) {
    return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(network.day_parts));
  }), function (network) {
    return network.hasOwnProperty('index') && network.hasOwnProperty('rating');
  });
};

var transformViewershipDataForDayParts = function transformViewershipDataForDayParts(viewershipData, networks, config) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(viewershipData) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(networks)) {
    return networks.map(function (network) {
      return {
        network: network.id,
        name: network.name,
        data: {
          datasets: []
        }
      };
    });
  }
  return networks.map(function (network) {
    var data = viewershipData[network.id];
    if (!data) return null;
    var allDayParts = extractDayPartsData(viewershipData);
    return {
      network: network.id,
      name: network.name,
      data: {
        datasets: data.day_parts.map(function (part) {
          var partData = data.day_parts.find(function (dayPart) {
            return dayPart.id === part.id;
          });
          var dayPart = config.find(function (dayPart) {
            return dayPart.id === part.id;
          });
          var bgColor = '#4CBEE7';
          if (dayPart && dayPart.color) {
            bgColor = dayPart.color;
          }
          return {
            title: partData.id,
            label: partData.size,
            backgroundColor: bgColor,
            data: [{
              x: partData.rating,
              y: partData.index,
              r: determineSizeOfBubble(allDayParts, partData.size, chartConfig.bubbleSizes.dayParts)
            }],
            hoverRadius: 0
          };
        }).sort(function (a, b) {
          return a.data[0].r - b.data[0].r;
        })
      }
    };
  }).filter(function (n) {
    return n !== null;
  });
};

var transformUniverseDataForGraph = function transformUniverseDataForGraph(universeData) {
  if (!universeData || universeData && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(universeData.universe)) {
    return {
      labels: [],
      datasets: []
    };
  }
  var labels = universeData.universe.map(function (monthObj) {
    var date = new Date(monthObj.date);
    return date.toLocaleString('en-us', { month: 'short', year: '2-digit', timeZone: 'UTC' });
  });
  var chartData = universeData.universe.map(function (monthObj) {
    return monthObj.size;
  });
  var backgroundColors = universeData.universe.map(function (bar) {
    return !bar.new ? 'rgba(0, 82, 231, 0.8)' : 'rgba(204, 104, 220, 0.8)';
  });
  var hoverBackgroundColors = universeData.universe.map(function (bar) {
    return !bar.new ? 'rgba(76, 190, 231, 1)' : 'rgba(180, 64, 250, 1)';
  });
  var data = {
    label: 'Audience Size',
    backgroundColor: backgroundColors,
    data: chartData,
    hoverBackgroundColor: hoverBackgroundColors
  };
  var datasets = [data];
  return {
    labels: labels,
    datasets: datasets
  };
};

var transformTopAttributesForGraph = function transformTopAttributesForGraph(attributeData, bubbleSizeRange) {
  if (!bubbleSizeRange) {
    bubbleSizeRange = { min: 15, max: 90 };
  }
  return attributeData ? {
    datasets: attributeData.map(function (attribute) {
      var _attribute$attribute = attribute.attribute,
          id = _attribute$attribute.id,
          attr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_attribute$attribute, ['id']);

      return {
        label: attribute.attribute.parent + ' ' + attribute.attribute.name,
        id: attribute.id,
        attribute: attr,
        backgroundColor: 'rgba(0, 82, 231, 0.8)',
        hoverBackgroundColor: 'rgba(76, 190, 231, 1)',
        data: [{
          x: attribute.coverage,
          y: attribute.index,
          r: determineSizeOfBubble(attributeData, attribute.size, bubbleSizeRange)
        }],
        dataLabels: {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__filters_truncateAmount__["a" /* default */])(attribute.size),
          rightLabel: attribute.attribute.parent + ' ' + attribute.attribute.name
        },
        hoverRadius: 0
      };
    })
  } : {
    datasets: []
  };
};




var transformReachDataForGraph = function transformReachDataForGraph(data) {
  if (!data) {
    return {
      labels: [],
      datasets: []
    };
  }
  var labels = data.map(function (brandData) {
    return brandData.name;
  });
  var engagementData = data.map(function (brandData) {
    return brandData.engagement;
  });
  var reachData = data.map(function (brandData) {
    return brandData.reach;
  });
  return {
    labels: labels,
    datasets: [{
      label: 'Engagement',
      backgroundColor: 'rgba(0, 82, 231, 0.4)',
      data: engagementData,
      stack: 'stack 0'
    }, {
      label: 'Reach',
      backgroundColor: 'rgba(0, 82, 231, 1)',
      data: reachData,
      stack: 'stack 1'
    }]
  };
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOGGLE_PERMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_CATEGORY_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CATEGORY_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_ROOT_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SELECTED_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_DELETE_USER_MODAL; });
/* unused harmony export SET_NETWORKS */
var module = 'PERMISSION_';

var TOGGLE_PERMISSION = module + 'TOGGLE_PERMISSION';
var TOGGLE_CATEGORY_PERMISSIONS = module + 'TOGGLE_CATEGORY_PERMISSIONS';
var SET_CATEGORY_PERMISSIONS = module + 'SET_CATEGORY_PERMISSIONS';
var SET_CATEGORIES = module + 'SET_CATEGORIES';
var SET_ROLES = module + 'SET_ROLES';
var SET_PERMISSIONS = module + 'SET_PERMISSIONS';
var SET_ROOT_CATEGORY = module + 'SET_ROOT_CATEGORY';
var SET_SELECTED_PERMISSIONS = module + 'SET_SELECTED_PERMISSIONS';
var SET_USERS = module + 'SET_USERS';
var SHOW_DELETE_USER_MODAL = module + 'SHOW_DELETE_USER_MODAL';
var SET_NETWORKS = module + 'SET_NETWORKS';

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_BACK_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BACK_ROUTE_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROUTE_BACK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(58);


var _actions;


var module = 'ROUTE_';
var SET_BACK_ROUTE = module + 'SET_BACK_ROUTE';
var SET_BACK_ROUTE_OVERRIDE = module + 'SET_BACK_ROUTE_OVERRIDE';
var ROUTE_BACK = module + 'ROUTE_BACK';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_BACK_ROUTE, function (context, route) {
  context.commit(SET_BACK_ROUTE, route);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_BACK_ROUTE_OVERRIDE, function (context, route) {
  context.commit(SET_BACK_ROUTE_OVERRIDE, route);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ROUTE_BACK, function (context) {
  var route = context.state.routeBack;
  var routeOverride = context.state.routeBackOverride;

  if (routeOverride) {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push(routeOverride).catch(function (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
    context.commit(SET_BACK_ROUTE_OVERRIDE, null);
    return;
  }
  if (route === 'user-audience-hub' || route === 'user-target-manager') {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: route, params: { name: context.getters.username } }).catch(function (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push(route).catch(function (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  }
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertViewingStreamForDisplay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertViewingStreamForAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertViewingStreamForES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertViewingStreamFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertTargetToTargetType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(3);



var convertViewingStreamForDisplay = function convertViewingStreamForDisplay(stream) {
  var l = stream ? stream.toLowerCase() : '-';
  var rt = l;
  switch (l) {
    case 'live':
      rt = 'Live';
      break;
    case 'c3':
      rt = 'C3';
      break;
    case 'c7':
      rt = 'C7';
      break;
    case 'lsd':
      rt = 'LSD';
      break;
    case 'l3':
      rt = 'L3';
      break;
  }
  return rt;
};

var convertViewingStreamForAM = function convertViewingStreamForAM(stream) {
  var l = stream ? stream.toLowerCase() : stream;
  var rt = l;
  switch (l) {
    case 'aalive':
      rt = 'live';
      break;
    case 'aalive3':
      rt = 'c3';
      break;
    case 'aalive7':
      rt = 'c7';
      break;
    case 'aalivesd':
      rt = 'lsd';
      break;
  }
  return rt;
};

var convertViewingStreamForES = function convertViewingStreamForES(stream) {
  var l = stream ? stream.toLowerCase() : 'lsd';
  var rt = l;
  switch (l) {
    case 'live':
      rt = 'aalive';
      break;
    case 'c3':
      rt = 'aalive3';
      break;
    case 'c7':
      rt = 'aalive7';
      break;
    case 'lsd':
      rt = 'aalivesd';
      break;
  }
  return rt;
};

var convertViewingStreamFullName = function convertViewingStreamFullName(stream) {
  console.log(stream);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1__Constants__["j" /* STREAMING_OPTIONS */]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var vs = _step.value;

      if (vs.value === stream.toLowerCase()) {
        return vs.Name;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
};

var convertTargetToTargetType = function convertTargetToTargetType(t) {
  if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].LAS) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].AD) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].AD;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].SD) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].SD;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].ATT) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].ATT;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].NPOWER) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].NPOWER;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].COMSCORE) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].COMSCORE;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].PID) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].PID;
  } else if (t === __WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* TARGET_TYPE */].COMSCORE_TV) {
    return __WEBPACK_IMPORTED_MODULE_1__Constants__["d" /* TARGET_TYPES_INTEGERS */].COMSCORE_TV;
  }
};



/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getQuarterString; });
/* unused harmony export addDays */
/* unused harmony export getQuarters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isAtLeastDaysOld; });
/* unused harmony export isDaysPriorTo */
/* unused harmony export convertLocalStringToLocal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLocalDateStringFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return correctToUTCTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addDaysToDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addMonthsToDate; });
/* unused harmony export isSameDay */
/* unused harmony export isInTheFuture */
/* unused harmony export isInDaysRangeFromToday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCampaignQuarters; });
var QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];

var getQuarterString = function getQuarterString(d) {
  var dateInfo = [];
  if (typeof d === 'string') {
    dateInfo = d.split('-');
  } else {
    var splits = d.toLocaleDateString().split('/');
    dateInfo.push(splits[2]);
    dateInfo.push(splits[1]);
  }
  var year = dateInfo[0].substring(2, 4);
  var month = Number(dateInfo[1]);
  if (month === 1) {
    month = 'Q1';
  } else if (month === 4) {
    month = 'Q2';
  } else if (month === 7) {
    month = 'Q3';
  } else if (month === 10) {
    month = 'Q4';
  }
  return month + year;
};


var addDays = function addDays(days, fromDate) {
  if (fromDate) {
    fromDate = new Date(fromDate.valueOf());
  } else {
    fromDate = new Date();
  }
  fromDate.setDate(fromDate.getDate() + days);
  return fromDate;
};

var getQuarters = function getQuarters() {
  var yearsBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var yearsForward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var d = new Date();
  var y = d.getFullYear();
  var m = d.getMonth();
  var options = [];
  if (yearsBack <= 0) {
    QUARTERS.slice(parseInt(m / 3), QUARTERS.length).forEach(function (q) {
      return options.push(q + (y - yearsBack));
    });
  }

  var _loop = function _loop(yr) {
    QUARTERS.forEach(function (q) {
      return options.push(q + yr);
    });
  };

  for (var yr = y - yearsBack; yr <= y + yearsForward; yr++) {
    _loop(yr);
  }
  options = options.map(function (f) {
    var q = f.charAt(1);
    var y = f.slice(2);
    var firstDate = new Date(y, (q - 1) * 3, 1);
    var endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);
    return {
      name: f,
      from: firstDate.toISOString().split('T')[0],
      to: endDate.toISOString().split('T')[0],
      sorting: q + y
    };
  });
  return options;
};

var isAtLeastDaysOld = function isAtLeastDaysOld(d, daysOld) {
  var today = new Date();
  var daysFromToday = new Date(d);
  daysFromToday.setDate(daysFromToday.getDate() + daysOld);
  daysFromToday.setHours(0, 0, 0, 0);
  return today >= daysFromToday;
};
var isDaysPriorTo = function isDaysPriorTo(d, days) {
  var today = new Date();
  var daysFromToday = new Date(d);
  daysFromToday.setDate(daysFromToday.getDate() - days);
  daysFromToday.setHours(0, 0, 0, 0);
  return today >= daysFromToday;
};

var convertLocalStringToLocal = function convertLocalStringToLocal(dateString) {
  var x = new Date(dateString);
  var userTimezoneOffset = x.getTimezoneOffset() * 60000;
  return new Date(x.getTime() + userTimezoneOffset);
};

var getLocalDateStringFormatted = function getLocalDateStringFormatted(d) {
  var options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'America/New_York' };
  return new Date(d).toLocaleDateString('en-US', options);
};

var stdTimezoneOffset = function stdTimezoneOffset(date) {
  var jan = new Date(date.getFullYear(), 0, 1);
  var jul = new Date(date.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

var isDst = function isDst(date) {
  return date.getTimezoneOffset() < stdTimezoneOffset(date);
};

var correctToUTCTime = function correctToUTCTime(d) {
  var now = new Date();
  var dat = new Date(d);
  var currentHoursOffset = now.getTimezoneOffset() / 60;
  var timeHoursOffset = dat.getTimezoneOffset() / 60;
  dat.setHours(dat.getHours() + (currentHoursOffset - timeHoursOffset + (!isDst(dat) && isDst(now) ? 1 : 0)));
  return dat;
};

var getCurrentDate = function getCurrentDate() {
  var d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

var addDaysToDate = function addDaysToDate(d, days) {
  var copiedDate = new Date(d);
  copiedDate.setDate(d.getDate() + days);
  return copiedDate;
};

var addMonthsToDate = function addMonthsToDate(d, months) {
  var copiedDate = new Date(d);
  copiedDate.setMonth(d.getMonth() + months);
  return copiedDate;
};

var isSameDay = function isSameDay(day1, day2) {
  var oldDate = new Date(day1);
  var newdata = new Date(day2);
  return oldDate.getFullYear() === newdata.getFullYear() && oldDate.getMonth() === newdata.getMonth() && oldDate.getDate() === newdata.getDate();
};

var isInTheFuture = function isInTheFuture(d) {
  var today = new Date();
  return d && (d === '' || today < new Date(d));
};

var isInDaysRangeFromToday = function isInDaysRangeFromToday(d, days) {
  if (!d) return false;
  var dat = new Date(d);
  var today = new Date();
  var diffTime = Math.abs(today - dat);
  var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return days >= diffDays;
};

var getCampaignQuarters = function getCampaignQuarters() {
  function getQuarterString(quarterNumber) {
    return quarterNumber + 'Q';
  }

  var d = new Date();
  var y = d.getFullYear() % 100;
  var previousYear = y - 1 === -1 ? '00' : y - 1;
  var nextYear = y + 1 === 100 ? '00' : y + 1;
  y = ('0' + y).slice(-2);
  var m = d.getMonth();
  var options = [];
  var currentQuarter = parseInt(m / 3) + 1;

  var q = currentQuarter % 4 + 1;
  if (q < currentQuarter) {
    options.push(getQuarterString(q) + nextYear);
  } else {
    options.push(getQuarterString(q) + y);
  }

  options.push(getQuarterString(currentQuarter) + y);

  for (var i = 2; i <= 5; i++) {
    var _q = (currentQuarter - i + 16) % 4 + 1;
    if (_q >= currentQuarter) {
      options.push(getQuarterString(_q) + previousYear);
    } else {
      options.push(getQuarterString(_q) + y);
    }
  }
  options = options.map(function (f) {
    return {
      name: f,
      value: f
    };
  });
  return options;
};

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WebAPI__ = __webpack_require__(64);









var API_ROOT_ES = "https://api.audiencematters.turnerapps.com/v2/es";

var ElasticsearchAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ElasticsearchAPI, _WebAPI);

  function ElasticsearchAPI() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ElasticsearchAPI);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ElasticsearchAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ElasticsearchAPI)).call(this, { baseURL: API_ROOT_ES }));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ElasticsearchAPI, [{
    key: 'universeEstimate',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.__post({
                  extensionURL: '/UniverseEstimate',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function universeEstimate(_x) {
        return _ref.apply(this, arguments);
      }

      return universeEstimate;
    }()
  }, {
    key: 'targetDefinition',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.__post({
                  extensionURL: '/TargetDefinition',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function targetDefinition(_x2) {
        return _ref2.apply(this, arguments);
      }

      return targetDefinition;
    }()
  }, {
    key: 'historicalViewership',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.__post({
                  extensionURL: '/HistoricalViewership',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function historicalViewership(_x3) {
        return _ref3.apply(this, arguments);
      }

      return historicalViewership;
    }()
  }, {
    key: 'age',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.__post({
                  extensionURL: '/Age',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function age(_x4) {
        return _ref4.apply(this, arguments);
      }

      return age;
    }()
  }, {
    key: 'income',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.__post({
                  extensionURL: '/Income',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function income(_x5) {
        return _ref5.apply(this, arguments);
      }

      return income;
    }()
  }, {
    key: 'metrics',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', this.__post({
                  extensionURL: '/Metrics',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function metrics(_x6) {
        return _ref6.apply(this, arguments);
      }

      return metrics;
    }()
  }, {
    key: 'broadcastDates',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(payload) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.__post({
                  extensionURL: '/BroadcastDates',
                  payload: payload
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function broadcastDates(_x7) {
        return _ref7.apply(this, arguments);
      }

      return broadcastDates;
    }()
  }]);

  return ElasticsearchAPI;
}(__WEBPACK_IMPORTED_MODULE_7__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new ElasticsearchAPI());

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(32);








var API_ROOT_PERMISSION = "https://api.audiencematters.turnerapps.com/xandr";

var PermissionsAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PermissionsAPI, _WebAPI);

  function PermissionsAPI() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PermissionsAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PermissionsAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PermissionsAPI)).call(this, { baseURL: API_ROOT_PERMISSION }));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PermissionsAPI, [{
    key: 'getCategories',
    value: function getCategories() {
      return this.__get({ extensionURL: '/Permissions/Categories' });
    }
  }, {
    key: 'getCategoryHierarchy',
    value: function getCategoryHierarchy(id) {
      return this.__get({ extensionURL: '/Permissions/Hierarchy/' + id });
    }
  }, {
    key: 'upsertCategory',
    value: function upsertCategory(category) {
      return this.__post({ extensionURL: '/Permissions/Category', payload: { category: category } });
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions() {
      return this.__get({ extensionURL: '/Permissions' });
    }
  }, {
    key: 'upsertPermission',
    value: function upsertPermission(permission) {
      return this.__post({ extensionURL: '/Permissions', payload: { permission: permission } });
    }
  }, {
    key: 'getRoles',
    value: function getRoles() {
      return this.__get({ extensionURL: '/Permissions/Roles' });
    }
  }, {
    key: 'upsertRole',
    value: function upsertRole(role) {
      return this.__post({ extensionURL: '/Permissions/Roles', payload: { role: role } });
    }
  }, {
    key: 'deleteRole',
    value: function deleteRole(id) {
      return this.__delete({ extensionURL: '/Permissions/Roles/' + id });
    }
  }, {
    key: 'getUsers',
    value: function getUsers() {
      return this.__get({ extensionURL: '/Permissions/Users' });
    }
  }, {
    key: 'upsertUser',
    value: function upsertUser(user) {
      var IDMToken = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.idmAuth.token;
      return this.__post({ extensionURL: '/Permissions/Users', payload: { user: user, IDMToken: IDMToken } });
    }
  }, {
    key: 'deleteUser',
    value: function deleteUser(id) {
      return this.__delete({ extensionURL: '/Permissions/Users/' + id });
    }
  }]);

  return PermissionsAPI;
}(__WEBPACK_IMPORTED_MODULE_5__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new PermissionsAPI());

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WebAPI__ = __webpack_require__(64);








var API_V2_ROOT = "https://api.audiencematters.turnerapps.com/v2";
var API_FOR_XANDR = "https://api.audiencematters.turnerapps.com/xandr";
var LONG_RUNNING_XANDR_API = "https://prod.lb.api.audiencematters.turnerapps.com";

var LongRunningXandrAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LongRunningXandrAPI, _WebAPI);

  function LongRunningXandrAPI() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, LongRunningXandrAPI);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LongRunningXandrAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(LongRunningXandrAPI)).call(this, { baseURL: LONG_RUNNING_XANDR_API }));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(LongRunningXandrAPI, [{
    key: 'getQueryCount',
    value: function getQueryCount(_ref) {
      var targetDefinition = _ref.targetDefinition,
          type = _ref.type,
          user = _ref.user,
          caeId = _ref.caeId,
          audienceExpansion = _ref.audienceExpansion;

      return this.__post({
        extensionURL: '/xandr/targetDefinitionQueryCount',
        payload: { targetDefinition: targetDefinition, user: user, type: type, caeId: caeId, audienceExpansion: audienceExpansion },
        config: { timeout: 60 * 12 * 1000 }
      });
    }
  }]);

  return LongRunningXandrAPI;
}(__WEBPACK_IMPORTED_MODULE_6__WebAPI__["a" /* default */]);

var XandrConfigAPI = function (_WebAPI2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(XandrConfigAPI, _WebAPI2);

  function XandrConfigAPI() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, XandrConfigAPI);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (XandrConfigAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(XandrConfigAPI)).call(this, { baseURL: API_V2_ROOT }));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(XandrConfigAPI, [{
    key: 'getConfig',
    value: function getConfig(traitType) {
      return this.__get({ extensionURL: '/Datasets/Digital/' + traitType }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getPrimaryInsightsConfig',
    value: function getPrimaryInsightsConfig() {
      return this.__get({ extensionURL: '/SSM/Parameter/Config' }).then(function (resp) {
        return resp.data.primaryInsights;
      });
    }
  }, {
    key: 'getDatasourcesConfig',
    value: function getDatasourcesConfig() {
      return this.__get({ extensionURL: '/SSM/Datasources/Config' }).then(function (resp) {
        return resp.data;
      });
    }
  }]);

  return XandrConfigAPI;
}(__WEBPACK_IMPORTED_MODULE_6__WebAPI__["a" /* default */]);

var XandrAPI = function (_WebAPI3) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(XandrAPI, _WebAPI3);

  function XandrAPI() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, XandrAPI);

    var _this3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (XandrAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(XandrAPI)).call(this, { baseURL: API_FOR_XANDR }));

    _this3.long = new LongRunningXandrAPI();
    _this3.config = new XandrConfigAPI();
    return _this3;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(XandrAPI, [{
    key: 'getTraits',
    value: function getTraits(type) {
      return this.__get({ extensionURL: '/Xandr/Traits' + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getTrait',
    value: function getTrait(id, type) {
      return this.__get({ extensionURL: '/Xandr/Trait/' + id + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getSegments',
    value: function getSegments(type) {
      return this.__get({ extensionURL: '/Xandr/Segments' + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getSegment',
    value: function getSegment(id, type) {
      return this.__get({ extensionURL: '/Xandr/Segment/' + id + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getCampaigns',
    value: function getCampaigns(type) {
      var filterByExportEndDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      type = type || 'advertising';
      return this.__get({ extensionURL: '/Xandr/Campaign' + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      }).then(function (d) {
        if (filterByExportEndDate) {
          var filteredList = [];
          var filterOutlist = [];
          var todaysDate = new Date();
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(d), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var c = _step.value;

              if (c.exportSchedule) {
                if (todaysDate < new Date(c.exportSchedule.exportEndDate)) {
                  filteredList.push(c);
                }
              } else {
                filterOutlist.push(c);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return filteredList;
        }
        return d;
      });
    }
  }, {
    key: 'getCampaign',
    value: function getCampaign(id, type) {
      type = type || 'advertising';
      return this.__get({ extensionURL: '/Xandr/Campaign/' + id + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getDestinations',
    value: function getDestinations(type) {
      return this.__get({ extensionURL: '/Xandr/Destinations' + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getDestinationsConfig',
    value: function getDestinationsConfig() {
      return this.__get({ extensionURL: '/Xandr/Destinations/Config' }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getPrimaryInsightsConfig',
    value: function getPrimaryInsightsConfig() {
      return this.config.getPrimaryInsightsConfig();
    }
  }, {
    key: 'getDatasourcesConfig',
    value: function getDatasourcesConfig() {
      return this.config.getDatasourcesConfig();
    }
  }, {
    key: 'getContext',
    value: function getContext(type) {
      return this.__get({ extensionURL: '/Xandr/Context' + (type ? '?type=' + type : '') }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'getXandrTracing',
    value: function getXandrTracing(d, id) {
      var idString = id ? '&id=' + id : '';
      return this.__get({ extensionURL: '/Xandr/Tracing?date=' + d.getTime() + idString }).then(function (d) {
        return d.data;
      });
    }
  }, {
    key: 'getTopLevelTracing',
    value: function getTopLevelTracing(d) {
      return this.__get({ extensionURL: '/Xandr/Tracing/Top?date=' + d.getTime() }).then(function (d) {
        return d.data;
      });
    }
  }, {
    key: 'getQueryCount',
    value: function getQueryCount(_ref2) {
      var targetDefinition = _ref2.targetDefinition,
          type = _ref2.type,
          user = _ref2.user,
          caeId = _ref2.caeId,
          audienceExpansion = _ref2.audienceExpansion;

      return this.long.getQueryCount({ targetDefinition: targetDefinition, type: type, user: user, caeId: caeId, audienceExpansion: audienceExpansion });
    }
  }, {
    key: 'getQueryCountFromQueryId',
    value: function getQueryCountFromQueryId(_ref3) {
      var queryId = _ref3.queryId,
          type = _ref3.type,
          user = _ref3.user;

      return this.long.__post({
        extensionURL: '/xandr/queryIdQueryCount',
        payload: { queryId: queryId, user: user, type: type },
        config: { timeout: 60 * 12 * 1000 }
      });
    }
  }, {
    key: 'getSegmentationTraits',
    value: function getSegmentationTraits(path) {
      return this.config.getConfig(path);
    }
  }, {
    key: 'sendDownStream',
    value: function sendDownStream(_ref4) {
      var targetId = _ref4.targetId,
          user = _ref4.user,
          type = _ref4.type;

      return this.__post({ extensionURL: '/Xandr/Downstream', payload: { target: { targetId: targetId }, user: user, type: type } });
    }
  }, {
    key: 'getXanderTargetList',
    value: function getXanderTargetList() {
      return this.__get({
        extensionURL: '/Xandr/TargetList'
      });
    }
  }, {
    key: 'modelLAL',
    value: function modelLAL(_ref5) {
      var target = _ref5.target;

      return this.__post({
        extensionURL: '/Xandr/ModelLAL',
        payload: { target: target }
      });
    }
  }, {
    key: 'getVideoAmpAudienceList',
    value: function getVideoAmpAudienceList() {
      return this.__get({ extensionURL: '/Xandr/GetVideoAmpAudiencesList' }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'requestVideoAmpAudienceIntake',
    value: function requestVideoAmpAudienceIntake(id, type) {
      type = type || 'advertising';
      return this.__post({
        extensionURL: '/Xandr/RequestVideoAmpAudienceIntake?id=' + id + (type ? '&type=' + type : '')
      });
    }
  }, {
    key: 'retargetingRequest',
    value: function retargetingRequest(_ref6) {
      var placementId = _ref6.placementId,
          requestName = _ref6.requestName,
          startDate = _ref6.startDate,
          endDate = _ref6.endDate,
          type = _ref6.type;

      type = type || 'advertising';
      return this.__post({
        extensionURL: '/Xandr/RequestRetargetingAudience' + (type ? '?type=' + type : ''),
        payload: { placementId: placementId, requestName: requestName, startDate: startDate, endDate: endDate }
      });
    }
  }]);

  return XandrAPI;
}(__WEBPACK_IMPORTED_MODULE_6__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new XandrAPI());

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return definitionPartTypes; });
/* unused harmony export first */
/* harmony export (immutable) */ __webpack_exports__["f"] = recursiveFilter;
/* harmony export (immutable) */ __webpack_exports__["d"] = findDefinitionPartById;
/* harmony export (immutable) */ __webpack_exports__["e"] = isGroup;
/* harmony export (immutable) */ __webpack_exports__["b"] = isCountGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__ = __webpack_require__(208);




var _mutations;







var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* SET_DRAG_DROP_MODE */], function (state, value) {
  state.dragAndDrop.active = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* SET_DRAG_ITEM */], function (state, value) {
  state.dragAndDrop.draggingItem = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* SET_VIEW_ONLY */], function (state, value) {
  state.viewOnly = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* SET_DEFINITION */], function (state, definition) {
  state.definition.children = definition;

  walk(state.definition, createDefinitionId);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* SET_DROPPED_ATTRIBUTES_IN_TD */], function (state, definition) {
  var p = walkAllAroundOther(state.definition, { children: definition }, updateRemove);
  if (p) {
    state.updateLasTD = state.updateLasTD + 1;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["o" /* ADD_ATTRIBUTE */], function (state, attribute) {
  if (attribute.type === __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN) {
    attribute.value = true;
  }
  state.definition.children.push(createDefaultBooleanOperator(), createDefinitionId(attribute));
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].ADD_ATTRIBUTE,
    data: attribute
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["p" /* UPDATE_ATTRIBUTE */], function (state, _ref) {
  var attribute = _ref.attribute,
      update = _ref.update;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(attribute, update);
  state.definition.children = cleanDefinition(state.definition.children);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* SET_TARGET_HAD_CHANGED */], function (state) {
  state.lastTimeTargetWasChanged = new Date();
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* UPDATE_OPERATOR */], function (state, _ref2) {
  var operator = _ref2.operator,
      update = _ref2.update;

  operator.value = update.value;
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].CHANGED_OPERATOR,
    data: operator
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* REMOVE_ATTRIBUTE */], function (state) {
  var dropped = dropParts(state.definition.children, state.selected.map(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["partial"])(findDefinitionPartById, state.definition)));
  clearSelected(state);
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].REMOVED_ATTRIBUTE,
    data: dropped
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["q" /* SELECT_ATTRIBUTE */], function (state, attr) {
  if (state.dragAndDrop.active) return;
  toggleSelected(state, attr.definitionId);
  if (isGroup(attr)) {
    walk(attr, function (child) {
      if (child.definitionId !== attr.definitionId) removeFromSelected(state, child.definitionId);
    });
  }

  var _findIndexParentForDe = findIndexParentForDefinitionId(state.definition, attr.definitionId),
      parent = _findIndexParentForDe.parent;

  if (isGroup(parent) && !parent.root) {
    getPath(state.definition, attr.definitionId).forEach(function (inPath) {
      return removeFromSelected(state, inPath.definitionId);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* CLEAR_SELECTION */], function (state) {
  state.selected = [];
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* GROUP */], function (state) {
  var firstSelectedDefinition = state.selected[0];
  var selectedAttributesAndOperators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["flatten"])(state.selected.slice(1).map(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["partial"])(findDefinitionPartWithOperatorById, state.definition)));

  dropParts(state.definition.children, selectedAttributesAndOperators);

  var _findIndexParentForDe2 = findIndexParentForDefinitionId(state.definition, firstSelectedDefinition),
      insertAt = _findIndexParentForDe2.index,
      parent = _findIndexParentForDe2.parent;

  var firstDefinitionPartInSelection = parent.children[insertAt];
  selectedAttributesAndOperators.unshift(firstDefinitionPartInSelection);

  dropDefinitionPart(state.definition.children, firstSelectedDefinition);

  parent.children.splice(insertAt, 0, createGroup(cleanDefinition(selectedAttributesAndOperators)));
  state.definition.children = cleanDefinition(state.definition.children);
  clearSelected(state);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].GROUPED_ATTRIBUTES
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* UNGROUP */], function (state) {
  state.selected.forEach(function (selectedId) {
    return ungroup(state, selectedId);
  });
  clearSelected(state);
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].UNGROUPED_ATTRIBUTES
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["r" /* CREATE_COUNT_GROUP */], function (state, _ref3) {
  var groupId = _ref3.groupId,
      mustMatch = _ref3.mustMatch;

  var defPart = findDefinitionPartById(state.definition, groupId);
  __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(defPart, 'mustMatch', mustMatch);
  defPart.children.forEach(function (part) {
    if (isOperator(part)) part.value = 'OR';
  });
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].CREATED_COUNT
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["s" /* REMOVE_COUNT_GROUP */], function (state, groupId) {
  var defPart = findDefinitionPartById(state.definition, groupId);
  defPart.mustMatch = null;
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].REMOVED_COUNT
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* CLEAR_DEFINITION */], function (state) {
  state.definition.children = [];
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].CLEARED
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["t" /* MOVE_ATTRIBUTE */], function (state, _ref4) {
  var droppedId = _ref4.droppedId,
      moveToId = _ref4.moveToId,
      defType = _ref4.defType;

  if (droppedId === moveToId) return;
  var droppedDefinitionPart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(first(state.definition.children, function (attr) {
    return attr.definitionId === droppedId;
  }));
  dropDefinitionPart(state.definition.children, droppedId);
  addDefinitionPartAt(state.definition, droppedDefinitionPart, moveToId, defType);
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_7__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].MOVED_ATTRIBUTE
  };
}), _mutations);

var definitionPartTypes = {
  ATTRIBUTE: 'ATTRIBUTE',
  OPERATOR: 'OPERATOR',
  GROUP_BEGINNING: 'GROUP_BEGINNING',
  GROUP_ENDING: 'GROUP_ENDING',
  DROP_ZONE: 'DROP_ZONE',
  COUNT_GROUP: 'COUNT_GROUP'
};

function first(tree, predicate) {
  var found = void 0;
  for (var i = 0; i < tree.length; i++) {
    if (predicate(tree[i])) {
      return tree[i];
    } else if (tree[i].children) {
      found = first(tree[i].children, predicate);
      if (found) break;
    }
  }
  return found;
}

function walkAllAroundOther(def, other, invoke) {
  var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var i = function i(o) {
    var passed = invoke(def, o, parent);
    return passed;
  };
  var p = walk(other, i);
  if (def.children) {
    def.children.forEach(function (child) {
      p = walkAllAroundOther(child, other, invoke, def) || p;
    });
  }
  return p;
}

function walk(definition, invoke) {
  var p = invoke(definition);
  if (definition.children) {
    definition.children.forEach(function (child) {
      p = walk(child, invoke) || p;
    });
  }
  return p;
}

function addDefinitionPartAt(definition, newDefinitionPart, locationId, locationType) {
  if (locationType === definitionPartTypes.DROP_ZONE) {
    definition.children.push(createDefaultBooleanOperator());
    definition.children.push(newDefinitionPart);
    return;
  }
  var found = false;
  walk(definition, function (definitionPart) {
    if (found) return;
    if (definitionPart.hasOwnProperty('children')) {
      var indexToInsert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(definitionPart.children, function (node) {
        return node.definitionId === locationId;
      });
      if (indexToInsert > -1) {
        if (locationType === definitionPartTypes.ATTRIBUTE) {
          definitionPart.children.splice(indexToInsert, 0, newDefinitionPart);
          definitionPart.children.splice(indexToInsert + 1, 0, createDefaultBooleanOperator());
        } else if (locationType === definitionPartTypes.OPERATOR) {
          definitionPart.children.splice(indexToInsert, 0, createDefaultBooleanOperator());
          definitionPart.children.splice(indexToInsert + 1, 0, newDefinitionPart);
        } else {
          if (locationType === definitionPartTypes.GROUP_BEGINNING) {
            definitionPart.children.splice(indexToInsert, 0, newDefinitionPart);
            definitionPart.children.splice(indexToInsert + 1, 0, createDefaultBooleanOperator());
          } else if (locationType === definitionPartTypes.GROUP_ENDING) {
            definitionPart.children[indexToInsert].children.push(createDefaultBooleanOperator());
            definitionPart.children[indexToInsert].children.push(newDefinitionPart);
          }
        }
        found = true;
      }
    }
  });
}

function recursiveFilter(definition, predicate) {
  var filtered = [];
  walk(definition, function (node) {
    if (predicate(node)) filtered.push(node);
  });
  return filtered;
}

function getPath(definition, id) {
  var path = [];
  var found = false;
  walk(definition, function (child) {
    if (found) return;
    if (child.children && child.definitionId !== id) path.push(child);
    found = child.definitionId === id;
  });

  return path.reverse();
}

function toggleSelected(state, definitionId) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(state.selected, function (selected) {
    return selected === definitionId;
  })) {
    removeFromSelected(state, definitionId);
  } else {
    addToSelected(state, definitionId);
  }
}

function removeFromSelected(state, definitionId) {
  var foundIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(state.selected, function (selected) {
    return selected === definitionId;
  });
  if (foundIndex > -1) {
    state.selected.splice(foundIndex, 1);
  }
}

function addToSelected(state, definitionId) {
  var newSelected = [].concat(state.selected).concat(definitionId);

  newSelected = recursiveFilter(state.definition, function (child) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["includes"])(newSelected, child.definitionId);
  }).map(function (selected) {
    return selected.definitionId;
  });
  state.selected = newSelected;
}

function ungroup(state, groupId) {
  var _parent$children;

  var _findIndexParentForDe3 = findIndexParentForDefinitionId(state.definition, groupId),
      index = _findIndexParentForDe3.index,
      parent = _findIndexParentForDe3.parent;

  var group = parent.children[index];

  parent.children.splice(index, 1);

  (_parent$children = parent.children).splice.apply(_parent$children, [index, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(group.children)));
}

function findDefinitionPartWithOperatorById(definition, definitionId) {
  var _findIndexParentForDe4 = findIndexParentForDefinitionId(definition, definitionId),
      index = _findIndexParentForDe4.index,
      parent = _findIndexParentForDe4.parent;

  var found = [];
  if (index > 0) {
    found.push(parent.children[index - 1]);
  } else {
    found.push(createDefaultBooleanOperator());
  }
  found.push(parent.children[index]);
  return found;
}

function findDefinitionPartById(definition, definitionId) {
  return first(definition.children, function (attr) {
    return attr.definitionId === definitionId;
  });
}

function findIndexParentForDefinitionId(definition, definitionId) {
  var tree = Array.isArray(definition) ? definition : definition.children;
  for (var i = 0; i < tree.length; i++) {
    if (tree[i].definitionId === definitionId) return { index: i, parent: definition };
    if (tree[i].children) {
      var found = findIndexParentForDefinitionId(tree[i], definitionId);
      if (found) return found;
    }
  }

  return false;
}

function dropParts(definition, parts) {
  var dropped = [];
  parts.forEach(function (part) {
    dropped = dropped.concat(dropDefinitionPart(definition, part.definitionId));
  });
  return dropped;
}

function clearSelected(state) {
  state.selected = [];
}

function dropDefinitionPart(dropFrom, dropAttrId) {
  var dropped = [];
  dropFrom.forEach(function (attr, index) {
    if (attr.children) {
      dropped = dropped.concat(dropDefinitionPart(attr.children, dropAttrId));
    }
    if (attr.definitionId === dropAttrId) {
      dropped.push(dropFrom.splice(index, 1));
    }
  });
  return dropped;
}

function cleanDefinition(definition) {
  var cleanDefParts = [];

  definition.forEach(function (value) {
    if (value.children) {
      value.children = cleanDefinition(value.children);

      if (value.children.length === 1 && !isOperator(value.children[0])) {
        value = value.children[0];
        cleanDefParts.push(value);
      } else if (value.children.length === 0) {
        if (isOperator(cleanDefParts[cleanDefParts.length - 1])) {
          cleanDefParts.splice(cleanDefParts.length - 1, 1);
        }
      } else {
        cleanDefParts.push(value);
      }
    } else {
      cleanDefParts.push(value);
    }
  });

  var retDef = [];

  cleanDefParts.forEach(function (part, index) {
    var nextPart = cleanDefParts[index + 1];
    if (!isOperator(part)) {
      retDef.push(part);
    } else if (retDef.length > 0 && nextPart && !isOperator(nextPart)) {
      retDef.push(part);
    }
  });

  return retDef;
}

function createGroup(children) {
  return createDefinitionId({
    children: children
  });
}

function isOperator(maybeOperator) {
  return !!(maybeOperator && maybeOperator.operator === true);
}

function isGroup(maybeGroup) {
  return !!(maybeGroup && maybeGroup.children);
}

function isCountGroup(maybeCountGroup) {
  return !!(maybeCountGroup && maybeCountGroup.children && maybeCountGroup.mustMatch);
}

function createDefaultBooleanOperator() {
  return createDefinitionId({
    operator: true,
    value: 'OR'
  });
}

function createDefinitionId(definitionPart) {
  if (definitionPart.definitionId !== undefined) return definitionPart;
  definitionPart.definitionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniqueId"])(Date.now().toString());
  return definitionPart;
}

function updateRemove(definitionPart, other, parent) {
  var passed = false;
  if (definitionPart.id && other.id && definitionPart.id === other.id && parent) {
    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];
      if (child.id === other.id && !(child.removed === other.removed)) {
        parent.children[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(other);
        parent.children[i].definitionId = child.definitionId;
        passed = true;
      }
    }
  }
  return passed;
}

/* harmony default export */ __webpack_exports__["c"] = (mutations);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return definitionPartTypes; });
/* unused harmony export first */
/* harmony export (immutable) */ __webpack_exports__["f"] = recursiveFilter;
/* harmony export (immutable) */ __webpack_exports__["d"] = findDefinitionPartById;
/* harmony export (immutable) */ __webpack_exports__["e"] = isGroup;
/* harmony export (immutable) */ __webpack_exports__["b"] = isCountGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);




var _mutations;









var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* SET_DRAG_DROP_MODE */], function (state, value) {
  state.dragAndDrop.active = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* SET_DRAG_ITEM */], function (state, value) {
  state.dragAndDrop.draggingItem = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* SET_VIEW_ONLY */], function (state, value) {
  state.viewOnly = value;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* SET_DEFINITION */], function (state, definition) {
  state.definition.children = definition;

  walk(state.definition, createDefinitionId);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* SET_DROPPED_ATTRIBUTES_IN_TD */], function (state, definition) {
  var p = walkAllAroundOther(state.definition, { children: definition }, updateRemove);
  if (p) {
    state.updateLasTD = state.updateLasTD + 1;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* ADD_ATTRIBUTE */], function (state, attribute) {
  if (attribute.type === __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN) {
    attribute.value = true;
  }
  state.definition.children.push(createDefaultBooleanOperator(), createDefinitionId(attribute));
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].ADD_ATTRIBUTE,
    data: attribute
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* UPDATE_ATTRIBUTE */], function (state, _ref) {
  var attribute = _ref.attribute,
      update = _ref.update;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(attribute, update);
  state.definition.children = cleanDefinition(state.definition.children);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* SET_TARGET_HAD_CHANGED */], function (state) {
  state.lastTimeTargetWasChanged = new Date();
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* UPDATE_OPERATOR */], function (state, _ref2) {
  var operator = _ref2.operator,
      update = _ref2.update;

  operator.value = update.value;
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].CHANGED_OPERATOR,
    data: operator
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* REMOVE_ATTRIBUTE */], function (state) {
  var dropped = dropParts(state.definition.children, state.selected.map(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["partial"])(findDefinitionPartById, state.definition)));
  clearSelected(state);
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].REMOVED_ATTRIBUTE,
    data: dropped
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* SELECT_ATTRIBUTE */], function (state, attr) {
  if (state.dragAndDrop.active) return;
  toggleSelected(state, attr.definitionId);
  if (isGroup(attr)) {
    walk(attr, function (child) {
      if (child.definitionId !== attr.definitionId) removeFromSelected(state, child.definitionId);
    });
  }

  var _findIndexParentForDe = findIndexParentForDefinitionId(state.definition, attr.definitionId),
      parent = _findIndexParentForDe.parent;

  if (isGroup(parent) && !parent.root) {
    getPath(state.definition, attr.definitionId).forEach(function (inPath) {
      return removeFromSelected(state, inPath.definitionId);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* CLEAR_SELECTION */], function (state) {
  state.selected = [];
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* GROUP */], function (state) {
  var firstSelectedDefinition = state.selected[0];
  var selectedAttributesAndOperators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["flatten"])(state.selected.slice(1).map(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["partial"])(findDefinitionPartWithOperatorById, state.definition)));

  dropParts(state.definition.children, selectedAttributesAndOperators);

  var _findIndexParentForDe2 = findIndexParentForDefinitionId(state.definition, firstSelectedDefinition),
      insertAt = _findIndexParentForDe2.index,
      parent = _findIndexParentForDe2.parent;

  var firstDefinitionPartInSelection = parent.children[insertAt];
  selectedAttributesAndOperators.unshift(firstDefinitionPartInSelection);

  dropDefinitionPart(state.definition.children, firstSelectedDefinition);

  parent.children.splice(insertAt, 0, createGroup(cleanDefinition(selectedAttributesAndOperators)));
  state.definition.children = cleanDefinition(state.definition.children);
  clearSelected(state);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].GROUPED_ATTRIBUTES
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* UNGROUP */], function (state) {
  state.selected.forEach(function (selectedId) {
    return ungroup(state, selectedId);
  });
  clearSelected(state);
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].UNGROUPED_ATTRIBUTES
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["o" /* CREATE_COUNT_GROUP */], function (state, _ref3) {
  var groupId = _ref3.groupId,
      mustMatch = _ref3.mustMatch;

  var defPart = findDefinitionPartById(state.definition, groupId);
  __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(defPart, 'mustMatch', mustMatch);
  defPart.children.forEach(function (part) {
    if (isOperator(part)) part.value = 'OR';
  });
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].CREATED_COUNT
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["p" /* REMOVE_COUNT_GROUP */], function (state, groupId) {
  var defPart = findDefinitionPartById(state.definition, groupId);
  defPart.mustMatch = null;
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].REMOVED_COUNT
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["q" /* CLEAR_DEFINITION */], function (state) {
  state.definition.children = [];
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].CLEARED
  };
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["r" /* MOVE_ATTRIBUTE */], function (state, _ref4) {
  var droppedId = _ref4.droppedId,
      moveToId = _ref4.moveToId,
      defType = _ref4.defType;

  if (droppedId === moveToId) return;
  var droppedDefinitionPart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(first(state.definition.children, function (attr) {
    return attr.definitionId === droppedId;
  }));
  dropDefinitionPart(state.definition.children, droppedId);
  addDefinitionPartAt(state.definition, droppedDefinitionPart, moveToId, defType);
  state.definition.children = cleanDefinition(state.definition.children);
  state.lastAttributeCommand = {
    command: __WEBPACK_IMPORTED_MODULE_6__appLogic_targetDefinition_attributeActionConstants__["a" /* COMMANDS */].MOVED_ATTRIBUTE
  };
}), _mutations);

var definitionPartTypes = {
  ATTRIBUTE: 'ATTRIBUTE',
  OPERATOR: 'OPERATOR',
  GROUP_BEGINNING: 'GROUP_BEGINNING',
  GROUP_ENDING: 'GROUP_ENDING',
  DROP_ZONE: 'DROP_ZONE',
  COUNT_GROUP: 'COUNT_GROUP'
};

function first(tree, predicate) {
  var found = void 0;
  for (var i = 0; i < tree.length; i++) {
    if (predicate(tree[i])) {
      return tree[i];
    } else if (tree[i].children) {
      found = first(tree[i].children, predicate);
      if (found) break;
    }
  }
  return found;
}

function walkAllAroundOther(def, other, invoke) {
  var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var i = function i(o) {
    var passed = invoke(def, o, parent);
    return passed;
  };
  var p = walk(other, i);
  if (def.children) {
    def.children.forEach(function (child) {
      p = walkAllAroundOther(child, other, invoke, def) || p;
    });
  }
  return p;
}

function walk(definition, invoke) {
  var p = invoke(definition);
  if (definition.children) {
    definition.children.forEach(function (child) {
      p = walk(child, invoke) || p;
    });
  }
  return p;
}

function addDefinitionPartAt(definition, newDefinitionPart, locationId, locationType) {
  if (locationType === definitionPartTypes.DROP_ZONE) {
    definition.children.push(createDefaultBooleanOperator());
    definition.children.push(newDefinitionPart);
    return;
  }
  var found = false;
  walk(definition, function (definitionPart) {
    if (found) return;
    if (definitionPart.hasOwnProperty('children')) {
      var indexToInsert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["findIndex"])(definitionPart.children, function (node) {
        return node.definitionId === locationId;
      });
      if (indexToInsert > -1) {
        if (locationType === definitionPartTypes.ATTRIBUTE) {
          definitionPart.children.splice(indexToInsert, 0, newDefinitionPart);
          definitionPart.children.splice(indexToInsert + 1, 0, createDefaultBooleanOperator());
        } else if (locationType === definitionPartTypes.OPERATOR) {
          definitionPart.children.splice(indexToInsert, 0, createDefaultBooleanOperator());
          definitionPart.children.splice(indexToInsert + 1, 0, newDefinitionPart);
        } else {
          if (locationType === definitionPartTypes.GROUP_BEGINNING) {
            definitionPart.children.splice(indexToInsert, 0, newDefinitionPart);
            definitionPart.children.splice(indexToInsert + 1, 0, createDefaultBooleanOperator());
          } else if (locationType === definitionPartTypes.GROUP_ENDING) {
            definitionPart.children[indexToInsert].children.push(createDefaultBooleanOperator());
            definitionPart.children[indexToInsert].children.push(newDefinitionPart);
          }
        }
        found = true;
      }
    }
  });
}

function recursiveFilter(definition, predicate) {
  var filtered = [];
  walk(definition, function (node) {
    if (predicate(node)) filtered.push(node);
  });
  return filtered;
}

function getPath(definition, id) {
  var path = [];
  var found = false;
  walk(definition, function (child) {
    if (found) return;
    if (child.children && child.definitionId !== id) path.push(child);
    found = child.definitionId === id;
  });

  return path.reverse();
}

function toggleSelected(state, definitionId) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(state.selected, function (selected) {
    return selected === definitionId;
  })) {
    removeFromSelected(state, definitionId);
  } else {
    addToSelected(state, definitionId);
  }
}

function removeFromSelected(state, definitionId) {
  var foundIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["findIndex"])(state.selected, function (selected) {
    return selected === definitionId;
  });
  if (foundIndex > -1) {
    state.selected.splice(foundIndex, 1);
  }
}

function addToSelected(state, definitionId) {
  var newSelected = [].concat(state.selected).concat(definitionId);

  newSelected = recursiveFilter(state.definition, function (child) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["includes"])(newSelected, child.definitionId);
  }).map(function (selected) {
    return selected.definitionId;
  });
  state.selected = newSelected;
}

function ungroup(state, groupId) {
  var _parent$children;

  var _findIndexParentForDe3 = findIndexParentForDefinitionId(state.definition, groupId),
      index = _findIndexParentForDe3.index,
      parent = _findIndexParentForDe3.parent;

  var group = parent.children[index];

  parent.children.splice(index, 1);

  (_parent$children = parent.children).splice.apply(_parent$children, [index, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(group.children)));
}

function findDefinitionPartWithOperatorById(definition, definitionId) {
  var _findIndexParentForDe4 = findIndexParentForDefinitionId(definition, definitionId),
      index = _findIndexParentForDe4.index,
      parent = _findIndexParentForDe4.parent;

  var found = [];
  if (index > 0) {
    found.push(parent.children[index - 1]);
  } else {
    found.push(createDefaultBooleanOperator());
  }
  found.push(parent.children[index]);
  return found;
}

function findDefinitionPartById(definition, definitionId) {
  return first(definition.children, function (attr) {
    return attr.definitionId === definitionId;
  });
}

function findIndexParentForDefinitionId(definition, definitionId) {
  var tree = Array.isArray(definition) ? definition : definition.children;
  for (var i = 0; i < tree.length; i++) {
    if (tree[i].definitionId === definitionId) return { index: i, parent: definition };
    if (tree[i].children) {
      var found = findIndexParentForDefinitionId(tree[i], definitionId);
      if (found) return found;
    }
  }

  return false;
}

function dropParts(definition, parts) {
  var dropped = [];
  parts.forEach(function (part) {
    dropped = dropped.concat(dropDefinitionPart(definition, part.definitionId));
  });
  return dropped;
}

function clearSelected(state) {
  state.selected = [];
}

function dropDefinitionPart(dropFrom, dropAttrId) {
  var dropped = [];
  dropFrom.forEach(function (attr, index) {
    if (attr.children) {
      dropped = dropped.concat(dropDefinitionPart(attr.children, dropAttrId));
    }
    if (attr.definitionId === dropAttrId) {
      dropped.push(dropFrom.splice(index, 1));
    }
  });
  return dropped;
}

function cleanDefinition(definition) {
  var cleanDefParts = [];

  definition.forEach(function (value) {
    if (value.children) {
      value.children = cleanDefinition(value.children);

      if (value.children.length === 1 && !isOperator(value.children[0])) {
        value = value.children[0];
        cleanDefParts.push(value);
      } else if (value.children.length === 0) {
        if (isOperator(cleanDefParts[cleanDefParts.length - 1])) {
          cleanDefParts.splice(cleanDefParts.length - 1, 1);
        }
      } else {
        cleanDefParts.push(value);
      }
    } else {
      cleanDefParts.push(value);
    }
  });

  var retDef = [];

  cleanDefParts.forEach(function (part, index) {
    var nextPart = cleanDefParts[index + 1];
    if (!isOperator(part)) {
      retDef.push(part);
    } else if (retDef.length > 0 && nextPart && !isOperator(nextPart)) {
      retDef.push(part);
    }
  });

  return retDef;
}

function createGroup(children) {
  return createDefinitionId({
    children: children
  });
}

function isOperator(maybeOperator) {
  return !!(maybeOperator && maybeOperator.operator === true);
}

function isGroup(maybeGroup) {
  return !!(maybeGroup && maybeGroup.children);
}

function isCountGroup(maybeCountGroup) {
  return !!(maybeCountGroup && maybeCountGroup.children && maybeCountGroup.mustMatch);
}

function createDefaultBooleanOperator() {
  return createDefinitionId({
    operator: true,
    value: 'OR'
  });
}

function createDefinitionId(definitionPart) {
  if (definitionPart.definitionId !== undefined) return definitionPart;
  definitionPart.definitionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["uniqueId"])(Date.now().toString());
  return definitionPart;
}

function updateRemove(definitionPart, other, parent) {
  var passed = false;
  if (definitionPart.id && other.id && definitionPart.id === other.id && parent) {
    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];
      if (child.id === other.id && !(child.removed === other.removed)) {
        parent.children[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(other);
        parent.children[i].definitionId = child.definitionId;
        passed = true;
      }
    }
  }
  return passed;
}

/* harmony default export */ __webpack_exports__["c"] = (mutations);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    direction: {
      type: String,
      default: 'top'
    },
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    }
  },
  mounted: function mounted() {
    var _this = this;

    var popover = this.$refs.popover;
    popover.$on('dismiss', function () {
      return _this.$emit('dismiss');
    });
    popover.$on('reposition', function () {
      return _this.$emit('reposition');
    });
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SIGN_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_LOADING_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REFRESH_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_USER_PERMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_STATE_OFF_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OKTA_OIDC_INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OKTA_OIDC_SIGN_IN; });
/* unused harmony export SET_PERMISSIONS_AND_ROLES */
var module = 'AUTH_';

var SIGN_OUT = module + 'SIGN_OUT';

var SET_ERROR = module + 'SET_ERROR';

var SET_LOADING_VALUE = module + 'SET_LOADING_VALUE';

var REFRESH_TOKEN = module + 'REFRESH_TOKEN';
var SET_USER_PERMISSION = module + 'SET_USER_PERMISSION';
var SET_STATE_OFF_COOKIE = module + 'SET_STATE_OFF_COOKIE';

var OKTA_OIDC_INITIALIZE = module + 'OKTA_OIDC_INITIALIZE';
var OKTA_OIDC_SIGN_IN = module + 'OKTA_OIDC_SIGN_IN';
var SET_PERMISSIONS_AND_ROLES = module + 'SET_PERMISSIONS_AND_ROLES';

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cancel\"><path d=\"M8.813 0L5 3.813 1.187 0 0 1.187 3.813 5 0 8.813 1.187 10 5 6.187 8.813 10 10 8.813 6.187 5 10 1.187z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1914),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1118)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1804),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1276)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(1968),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WebAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);










var API_V2_ROOT = "https://api.audiencematters.turnerapps.com/v2";
var LAS_CONFIG_PATHS = ['amrld/household', 'amrld/respondent', 'amrld/programs', 'ncs', 'mri'];
var v2API = new __WEBPACK_IMPORTED_MODULE_7__WebAPI__["a" /* default */]({ baseURL: API_V2_ROOT });

var getSegmentationTraits = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(traitTypes) {
    var resp, traitsPromise;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (traitTypes) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_6__XandrAPI__["a" /* default */].getDatasourcesConfig();

          case 3:
            resp = _context.sent;

            traitTypes = resp.TRAIT_TYPE;

          case 5:
            traitsPromise = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(traitTypes).map(function (key) {
              return __WEBPACK_IMPORTED_MODULE_6__XandrAPI__["a" /* default */].getSegmentationTraits(traitTypes[key]);
            });
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(traitsPromise));

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSegmentationTraits(_x) {
    return _ref.apply(this, arguments);
  };
}();

var distributeAMRLDDatasets = function distributeAMRLDDatasets(datasets) {
  var AMRLD_DATASET_IDS = ['shows', 'household', 'respondent'];
  var amrldDatasets = datasets.filter(function (x) {
    return AMRLD_DATASET_IDS.includes(x.id);
  });
  var nonAmrldDatasets = datasets.filter(function (x) {
    return !AMRLD_DATASET_IDS.includes(x.id);
  });
  var amrldDataset = {
    children: amrldDatasets,
    id: 'amrld',
    name: 'AMRLD'
  };
  nonAmrldDatasets.push(amrldDataset);
  return nonAmrldDatasets;
};

var changeCatalinaToNCS = function changeCatalinaToNCS(datasets) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(datasets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var d = _step.value;

      if (d.name === 'Catalina') {
        d.name = 'NCS';
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return datasets;
};

var sortDatasets = function sortDatasets(datasets) {
  datasets.sort(function (a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  });
  return datasets;
};

var fetchAllWorkbenchConfigs = function fetchAllWorkbenchConfigs(traitTypes) {
  var promises = LAS_CONFIG_PATHS.map(function (k) {
    return v2API.__get({ extensionURL: '/Datasets/LAS/' + k }).then(function (resp) {
      return resp.data;
    });
  });
  return getSegmentationTraits(traitTypes).then(function (traits) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(traits), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(promises))).then(distributeAMRLDDatasets).then(changeCatalinaToNCS).then(sortDatasets);
  });
};

var fetchDatasetFamilies = function fetchDatasetFamilies() {
  return v2API.__get({ extensionURL: '/Datasets/mappings' }).then(function (resp) {
    return resp.data;
  });
};

var getConfigFilesForConfigType = function getConfigFilesForConfigType(cfgKey) {
  return {
    fetchConfig: function fetchConfig() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var path;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                path = cfgKey === 'las' ? 'LAS/config' : '' + cfgKey;
                return _context2.abrupt('return', v2API.__get({ extensionURL: '/Datasets/' + path }).then(function (resp) {
                  return resp.data;
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    fetchDatasets: function fetchDatasets(datasets, datasetId) {
      var selectedDataset = datasetId && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["find"])(datasets, { id: datasetId }) || [];

      var keys = datasets.filter(function (dataset) {
        return !dataset.optional;
      }).concat(selectedDataset).map(function (d) {
        return d.id;
      });
      var promises = keys.map(function (k) {
        return v2API.__get({ extensionURL: '/Datasets/LAS/' + k }).then(function (resp) {
          return resp.data;
        });
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises);
    }
  };
};

function extractFileName(url) {
  var parts = url.split('/');
  return parts[parts.length - 1] + '.gz';
}
/* harmony default export */ __webpack_exports__["a"] = ({
  fetchAllWorkbenchConfigs: fetchAllWorkbenchConfigs,
  fetchDatasetFamilies: fetchDatasetFamilies,
  getConfigFilesForConfigType: getConfigFilesForConfigType
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_REVISION_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FORWARD_REVISION_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_BRANCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CURRENT_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CURRENT_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FORWARD_CURRENT_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_NEW_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TARGET_BRANCH; });
/* unused harmony export SET_CURRENT_BRANCH_AUDIENCE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ADD_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_PRIMARY_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_MISSING_BRANCH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_RevisionHistoryAPI__ = __webpack_require__(689);



var _actions;



var module = 'REVISION_HISTORY_';

var GET_REVISION_HISTORY = module + 'SET_REVISION_HISTORY';
var FORWARD_REVISION_HISTORY = module + 'FORWARD_REVISION_HISTORY';
var SET_BRANCHES = module + 'SET_BRANCHES';
var SET_CURRENT_BRANCH = module + 'SET_CURRENT_BRANCH';
var SET_CURRENT_MOVE = module + 'SET_CURRENT_MOVE';
var FORWARD_CURRENT_BRANCH = module + 'FORWARD_CURRENT_BRANCH';
var CREATE_NEW_BRANCH = module + 'CREATE_NEW_BRANCH';
var SET_TARGET_BRANCH = module + 'SET_TARGET_BRANCH';
var SET_CURRENT_BRANCH_AUDIENCE = module + 'SET_CURRENT_BRANCH_AUDIENCE';
var ADD_BRANCH = module + 'ADD_BRANCH';
var DELETE_BRANCH = module + 'DELETE_BRANCH';
var SET_PRIMARY_BRANCH = module + 'SET_PRIMARY_BRANCH';
var SET_MISSING_BRANCH = module + 'SET_MISSING_BRANCH';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DELETE_BRANCH, function (context, _ref) {
  var id = _ref.id;

  __WEBPACK_IMPORTED_MODULE_2__api_RevisionHistoryAPI__["a" /* default */].deleteBranch({ branchId: id }).then(function (data) {
    context.commit(DELETE_BRANCH, id);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GET_REVISION_HISTORY, function (context, _ref2) {
  var targetId = _ref2.targetId;

  return __WEBPACK_IMPORTED_MODULE_2__api_RevisionHistoryAPI__["a" /* default */].getRevisionHistoryForTarget({ target_id: targetId }).then(function (data) {
    context.commit(SET_BRANCHES, data.branches);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_MISSING_BRANCH, function (context, _ref3) {
  var id = _ref3.id,
      display_name = _ref3.display_name;

  return __WEBPACK_IMPORTED_MODULE_2__api_RevisionHistoryAPI__["a" /* default */].createMissingBranch({ id: id, display_name: display_name }).then(function (data) {
    context.commit(SET_BRANCHES, [{
      id: data.branch_id,
      label: display_name,
      histories: []
    }]);
    context.dispatch(SET_TARGET_BRANCH, { name: display_name });
    context.dispatch(SET_PRIMARY_BRANCH, { name: display_name });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_BRANCH, function (context, _ref4) {
  var name = _ref4.name;

  var currentBranch = context.state.branches.find(function (b) {
    return b.label === name;
  });
  if (currentBranch) {
    context.dispatch(SET_CURRENT_BRANCH, currentBranch);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_PRIMARY_BRANCH, function (context, _ref5) {
  var name = _ref5.name;

  var primaryBranch = context.state.branches.find(function (b) {
    return b.label === name;
  });
  context.commit(SET_PRIMARY_BRANCH, primaryBranch);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_CURRENT_BRANCH, function (context, branch) {
  context.commit(SET_CURRENT_BRANCH, branch);
  if (branch.histories.length > 0) {
    var currentRevision = branch.histories[0];
    context.commit(SET_CURRENT_MOVE, currentRevision);
    return currentRevision;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CREATE_NEW_BRANCH, function (context, _ref6) {
  var label = _ref6.label,
      audience = _ref6.audience,
      targetId = _ref6.targetId;

  var branchOff = {
    label: label,
    branch_off_id: context.state.currentBranch.id,
    duplicate_up_to_move: context.state.currentMove.move,
    audience: audience,
    target_id: targetId
  };
  var newBranch = {
    label: label,
    audience: audience
  };
  __WEBPACK_IMPORTED_MODULE_2__api_RevisionHistoryAPI__["a" /* default */].branchOffRevisionBranch(branchOff).then(function (data) {
    newBranch.id = data.created_branch_id;
    newBranch.histories = data.revision_history_of_branch;
    context.commit(ADD_BRANCH, newBranch);
    context.dispatch(SET_CURRENT_BRANCH, newBranch);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, FORWARD_REVISION_HISTORY, function (context, targetInfo) {
  var nextMove = context.state.currentMove ? context.state.currentMove.move + 1 : 1;
  var dataToSend = {
    id: context.state.currentBranch.id,
    move: nextMove,
    target_definition: targetInfo.targetDefinition,
    label: targetInfo.label,
    target_data: targetInfo.targetData,
    audience: parseInt(targetInfo.audience),
    targetId: context.getters.targetInfo.id
  };
  var revision = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataToSend, {
    id: null
  });

  __WEBPACK_IMPORTED_MODULE_2__api_RevisionHistoryAPI__["a" /* default */].forwardRevision(dataToSend).then(function (resp) {
    revision.id = resp.revision_id;
    context.dispatch(FORWARD_CURRENT_BRANCH, revision);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, FORWARD_CURRENT_BRANCH, function (context, revisionHistory) {
  context.commit(FORWARD_CURRENT_BRANCH, revisionHistory);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_CURRENT_MOVE, function (context, revision) {
  context.commit(SET_CURRENT_MOVE, revision);
}), _actions);

/* harmony default export */ __webpack_exports__["j"] = (actions);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_INTERFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INCREMENT_REQUEST_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TARGET_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_AUDIENCE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_HISTORICAL_VIEWERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_UNIVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_SELECTED_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_DAY_PART_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_SELECTED_VIEWERSHIP_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REMOVE_FROM_SELECTED_DAY_PART_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return REMOVE_ALL_DAY_PART_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_VIEWING_STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _actions;

var module = 'LAS_WORKBENCH_ACTIONS_INTERFACE_';

var STORE_NAME = 'las_workbench';

var SET_INTERFACE = module + 'SET_INTERFACE';
var INCREMENT_REQUEST_NUMBER = module + 'INCREMENT_REQUEST_NUMBER';
var SET_TARGET_DATA = module + 'SET_TARGET_DATA';
var SET_METRICS = module + 'SET_METRICS';
var SET_AUDIENCE_SIZE = module + 'SET_AUDIENCE_SIZE';
var SET_HISTORICAL_VIEWERSHIP = module + 'SET_HISTORICAL_VIEWERSHIP';
var SET_UNIVERSE = module + 'SET_UNIVERSE';
var SET_SELECTED_NETWORKS = module + 'SET_SELECTED_NETWORKS';
var SET_DAY_PART_NETWORKS = module + 'SET_DAY_PART_NETWORKS';
var SET_SELECTED_VIEWERSHIP_NETWORKS = module + 'SET_SELECTED_VIEWERSHIP_NETWORKS';
var REMOVE_FROM_SELECTED_DAY_PART_NETWORKS = module + 'REMOVE_FROM_SELECTED_DAY_PART_NETWORKS';
var REMOVE_ALL_DAY_PART_NETWORKS = module + 'REMOVE_ALL_DAY_PART_NETWORKS';
var SET_LOADING = module + 'SET_LOADING';
var SET_VIEWING_STREAM = module + 'SET_VIEWING_STREAM';
var RESET = module + 'RESET';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INTERFACE, function (context, inter) {
  context.commit(SET_INTERFACE, inter);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, INCREMENT_REQUEST_NUMBER, function (context) {
  context.commit(INCREMENT_REQUEST_NUMBER);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_TARGET_DATA, function (context, data) {
  var metrics = data.metrics,
      audienceSize = data.audienceSize,
      historicalViewership = data.historicalViewership,
      universe = data.universe;

  context.commit(SET_METRICS, metrics);
  context.commit(SET_AUDIENCE_SIZE, audienceSize);
  context.commit(SET_HISTORICAL_VIEWERSHIP, historicalViewership);
  context.commit(SET_UNIVERSE, universe);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_SELECTED_NETWORKS, function (context, networks) {
  context.commit(SET_DAY_PART_NETWORKS, networks);
  context.commit(SET_SELECTED_VIEWERSHIP_NETWORKS, networks);
  var inter = context.state.interface;
  if (inter) {
    inter.onTargetDefinitionChange({
      context: context,
      targetDefinition: context.getters.newTargetDefinition
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, function (_ref, network) {
  var commit = _ref.commit;

  commit(REMOVE_FROM_SELECTED_DAY_PART_NETWORKS, network);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REMOVE_ALL_DAY_PART_NETWORKS, function (context) {
  context.commit(REMOVE_ALL_DAY_PART_NETWORKS);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_LOADING, function (_ref2, v) {
  var commit = _ref2.commit;

  commit(SET_LOADING, v);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_VIEWING_STREAM, function (_ref3, v) {
  var commit = _ref3.commit;

  commit(SET_VIEWING_STREAM, v);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET, function (context) {
  context.commit(RESET);
}), _actions);
/* harmony default export */ __webpack_exports__["h"] = (actions);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMutationType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createUndoHistoryModule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var MODULE_NAME = 'undoHistory';

var types = {
  SET_PAST: 'SET_PAST',
  SET_PRESENT: 'SET_PRESENT',
  SET_FUTURE: 'SET_FUTURE'
};

var actionNames = {
  PUSH: 'PUSH',
  UNDO: 'UNDO',
  REDO: 'REDO',
  INITIALIZE: 'INITIALIZE'
};

var actions = {
  PUSH: MODULE_NAME + '/' + actionNames.PUSH,
  UNDO: MODULE_NAME + '/' + actionNames.UNDO,
  REDO: MODULE_NAME + '/' + actionNames.REDO,
  INITIALIZE: MODULE_NAME + '/' + actionNames.INITIALIZE
};

var isMutationType = function isMutationType(mutations) {
  return function (mutation) {
    return mutations.indexOf(mutation.type) !== -1;
  };
};

function createUndoHistoryModule(store, _ref, _ref2) {
  var _getters, _mutations, _actions;

  var _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === undefined ? null : _ref$initialValue,
      _ref$filter = _ref.filter,
      filter = _ref$filter === undefined ? function (mutation, state) {
    return true;
  } : _ref$filter,
      _ref$reducer = _ref.reducer,
      reducer = _ref$reducer === undefined ? function (state) {
    return state;
  } : _ref$reducer,
      restoreState = _ref.restoreState,
      _ref$undoLevels = _ref.undoLevels,
      undoLevels = _ref$undoLevels === undefined ? 20 : _ref$undoLevels;
  var namespace = _ref2.namespace,
      add = _ref2.add;

  var ns = '';
  var getterNames = {
    canUndo: ns + 'canUndo',
    canNotUndo: ns + 'canNotUndo',
    canRedo: ns + 'canRedo',
    canNotRedo: ns + 'canNotRedo'
  };
  var mutationNames = {
    setPast: ns + types.SET_PAST,
    setPresent: ns + types.SET_PRESENT,
    setFuture: ns + types.SET_FUTURE
  };
  store.subscribe(function (mutation, state) {
    var n = add && namespace ? namespace + '/' : '';
    if (filter(mutation, state) && !!state[namespace]) {
      store.dispatch(n + actions.PUSH, reducer(state));
    }
  });
  return {
    module: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, MODULE_NAME, {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, createHistoryState(initialValue)),
      getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, getterNames.canUndo, function (state) {
        return state.past.length > 0;
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, getterNames.canNotUndo, function (state, getters) {
        return !getters[getterNames.canUndo];
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, getterNames.canRedo, function (state) {
        return state.future.length > 0;
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, getterNames.canNotRedo, function (state, getters) {
        return !getters[getterNames.canRedo];
      }), _getters),
      mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationNames.setPast, function (state, value) {
        state.past = value;
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationNames.setPresent, function (state, value) {
        state.present = value;
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, mutationNames.setFuture, function (state, value) {
        state.future = value;
      }), _mutations),
      actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, actionNames.INITIALIZE, function (_ref3, value) {
        var commit = _ref3.commit,
            state = _ref3.state;

        var _createHistoryState = createHistoryState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(value)),
            past = _createHistoryState.past,
            present = _createHistoryState.present,
            future = _createHistoryState.future;

        commit(mutationNames.setPast, past);
        commit(mutationNames.setPresent, present);
        commit(mutationNames.setFuture, future);
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, actionNames.PUSH, function (_ref4, value) {
        var commit = _ref4.commit,
            state = _ref4.state;
        var past = state.past,
            present = state.present;

        if (present === value) return;
        if (present !== null) {
          commit(mutationNames.setPast, limitHistorySteps([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(past), [present]), undoLevels));
        }
        commit(mutationNames.setPresent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(value));
        commit(mutationNames.setFuture, []);
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, actionNames.UNDO, function (_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state;
        var past = state.past,
            present = state.present,
            future = state.future;

        var previous = past[past.length - 1];
        var newPast = past.slice(0, past.length - 1);
        commit(mutationNames.setPast, newPast);
        commit(mutationNames.setPresent, previous);
        commit(mutationNames.setFuture, [present].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(future)));
        restoreState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(state.present));
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, actionNames.REDO, function (_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state;
        var past = state.past,
            present = state.present,
            future = state.future;

        var next = future[0];
        var newFuture = future.slice(1);
        commit(mutationNames.setPast, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(past), [present]));
        commit(mutationNames.setPresent, next);
        commit(mutationNames.setFuture, newFuture);
        restoreState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(state.present));
      }), _actions)
    })
  };
}

var createHistoryState = function createHistoryState(initialValue) {
  return {
    past: [],
    present: initialValue,
    future: []
  };
};

var limitHistorySteps = function limitHistorySteps(history, steps) {
  return history.slice(-steps);
};

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export handleEmptyQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDataSources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);






function parseQuery(q) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { view_source: 'aalive7' };

  var stepZero = customSubstitution(q, body);

  if (Array.isArray(stepZero)) {
    if (stepZero.length === 1) {
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(stepZero[0]) === 'object' && !Array.isArray(stepZero[0])) {
        return { bool: { must: [tokenToTerm(stepZero[0])] } };
      }
    }
  }
  var stepOne = prefix(stepZero);
  return parser(stepOne);
}

function customSubstitution(target, body) {
  var newTarget = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(target), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var current = _step.value;

      if ((typeof current === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(current)) === 'object' && !Array.isArray(current)) {
        if (current.hasOwnProperty('type')) {
          if (current.type === 'custom') {
            if (current.query.length === 1) newTarget.push(current.query[0]);else newTarget.push(current.query);
          } else if (current.id === 'liteviewer' && current.dataset === 'shortcuts') {
            if (body.hasOwnProperty('view_source')) current.id = 'liteviewer_' + body.view_source;else current.id = 'liteviewer_aalivesd';
            newTarget.push(current);
          } else newTarget.push(current);
        } else newTarget.push(current);
      } else if (Array.isArray(current)) newTarget.push(customSubstitution(current, body));else newTarget.push(current);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return newTarget;
}

function prefix(target) {
  if ((typeof target === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(target)) === 'object' && !Array.isArray(target)) return target;

  var i = target.length - 1;
  var output = [];
  var operators = [];

  while (i >= 0) {
    var current = target[i];
    if (['number', 'object'].includes(typeof current === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(current)) && !Array.isArray(current)) output.push(current);
    if (typeof current === 'string') {
      var flag = true;
      while (flag) {
        if (operators.length > 0) {
          var top = operators[0];
          if (compareTo(top, current)) {
            output.push(top);
            operators.shift();
          } else flag = false;
        } else flag = false;
      }
      operators.unshift(current);
    }
    if (Array.isArray(current)) output.push(prefix(current));
    i -= 1;
  }
  var j = 0;
  while (j < operators.length) {
    output.push(operators[j]);
    j += 1;
  }
  var newOutput = [];
  while (output.length > 0) {
    newOutput.unshift(output.shift());
  }return newOutput;
}

function compareTo(opt1, opt2) {
  var code = ['MIN', 'OR', 'AND', 'NOT'];
  return code.indexOf(opt1) > code.indexOf(opt2);
}

function parser(target) {
  var response = {};
  if (target.length === 0) return response;

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(response, { bool: { should: [], must: [], must_not: [] } });

  if (Array.isArray(target)) {
    if (target) {
      var current = target.shift();
      if (typeof current === 'string') {
        var LHS = parser(target);
        var RHS = parser(target);

        if (current === 'OR') {
          if (LHS.hasOwnProperty('bool')) {
            if (LHS.bool.hasOwnProperty('should')) {
              var _response$bool$should;

              if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.should.push(LHS);else (_response$bool$should = response.bool.should).push.apply(_response$bool$should, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(LHS.bool.should));
            } else response.bool.should.push(LHS);
          } else response.bool.should.push(LHS);

          if (RHS.hasOwnProperty('bool')) {
            if (RHS.bool.hasOwnProperty('should')) {
              var _response$bool$should2;

              if (RHS.bool.hasOwnProperty('minimum_should_match')) response.bool.should.push(RHS);else (_response$bool$should2 = response.bool.should).push.apply(_response$bool$should2, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(RHS.bool.should));
            } else response.bool.should.push(RHS);
          } else if (RHS) response.bool.should.push(RHS);
        } else if (current === 'AND') {
          if (LHS.hasOwnProperty('bool')) {
            var _response$bool$must_n;

            if (LHS.bool.hasOwnProperty('must')) {
              var _response$bool$must;

              if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.must.push(LHS);else (_response$bool$must = response.bool.must).push.apply(_response$bool$must, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(LHS.bool.must));
            }
            if (LHS.bool.hasOwnProperty('must_not')) (_response$bool$must_n = response.bool.must_not).push.apply(_response$bool$must_n, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(LHS.bool.must_not));else response.bool.must.push(LHS);
          } else response.bool.must.push(LHS);

          if (RHS.hasOwnProperty('bool')) {
            var _response$bool$must_n2;

            if (RHS.bool.hasOwnProperty('must')) {
              var _response$bool$must2;

              if (RHS.bool.hasOwnProperty('minimum_should_match')) response.bool.must.push(RHS);else (_response$bool$must2 = response.bool.must).push.apply(_response$bool$must2, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(RHS.bool.must));
            }
            if (RHS.bool.hasOwnProperty('must_not')) (_response$bool$must_n2 = response.bool.must_not).push.apply(_response$bool$must_n2, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(RHS.bool.must_not));else response.bool.must.push(RHS);
          } else response.bool.must.push(RHS);
        } else if (current === 'NOT') {
          if (LHS.hasOwnProperty('bool')) {
            var _response$bool$must3, _response$bool$must_n3, _response$bool$should3;

            if (LHS.bool.hasOwnProperty('must')) (_response$bool$must3 = response.bool.must).push.apply(_response$bool$must3, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(LHS.bool.must));
            if (LHS.bool.hasOwnProperty('must_not')) (_response$bool$must_n3 = response.bool.must_not).push.apply(_response$bool$must_n3, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(LHS.bool.must_not));
            if (LHS.bool.hasOwnProperty('should')) (_response$bool$should3 = response.bool.should).push.apply(_response$bool$should3, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(LHS.bool.should));
            if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.minimum_should_match = LHS.bool.minimum_should_match;
          } else {
            response.bool.must.push(LHS);
          }

          if (RHS.hasOwnProperty('bool')) {
            var _response$bool$must_n4;

            if (RHS.bool.hasOwnProperty('must_not')) (_response$bool$must_n4 = response.bool.must_not).push.apply(_response$bool$must_n4, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(RHS.bool.must_not));else if (RHS) response.bool.must_not.push(RHS);
          } else if (RHS) response.bool.must_not.push(RHS);
        } else if (current === 'MIN') {
          if (typeof LHS === 'number') {
            if (RHS.hasOwnProperty('bool')) {
              RHS.bool.minimum_should_match = LHS;
              if (RHS.bool.hasOwnProperty('should')) response.bool.should = RHS.bool.should;
              if (RHS.bool.hasOwnProperty('must')) response.bool.must = RHS.bool.must;
              if (RHS.bool.hasOwnProperty('must_not')) response.bool.must_not = RHS.bool.must_not;
              if (RHS.bool.hasOwnProperty('minimum_should_match')) response.bool.minimum_should_match = RHS.bool.minimum_should_match;
            } else response = RHS;
          } else if (typeof RHS === 'number') {
            if (LHS.hasOwnProperty('bool')) {
              LHS.bool.minimum_should_match = RHS;
              if (LHS.bool.hasOwnProperty('should')) response.bool.should = LHS.bool.should;
              if (LHS.bool.hasOwnProperty('must')) response.bool.must = LHS.bool.must;
              if (LHS.bool.hasOwnProperty('must_not')) response.bool.must_not = LHS.bool.must_not;
              if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.minimum_should_match = LHS.bool.minimum_should_match;
            } else {
              response = LHS;
              response.minimum_should_match = RHS;
            }
          }
        } else console.error('BAD TOKEN!');
      }
      if (Array.isArray(current)) return parser(current);
      if ((typeof current === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(current)) === 'object' && !Array.isArray(current)) return tokenToTerm(current);
      if (typeof current === 'number') return current;
    }
  }
  if (response.hasOwnProperty('bool')) {
    if (response.bool.hasOwnProperty('should') && response.bool.should.length === 0) delete response.bool.should;
    if (response.bool.hasOwnProperty('must') && response.bool.must.length === 0) delete response.bool.must;
    if (response.bool.hasOwnProperty('must_not') && response.bool.must_not.length === 0) delete response.bool.must_not;
  }
  return response;
}

function tokenToTerm(token) {
  var term = {};
  var attribPath = token.dataset + '.' + token.id;
  if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(token.value) === 'object' && !Array.isArray(token.value)) {
    var rangeValue = token.value;
    var regex = /(\d{4})-(\d{2})-(\d{2})/;

    if (rangeValue.hasOwnProperty('min')) {
      var match = regex.exec(rangeValue.min.toString());
      if (match) rangeValue.min = [match[1], match[2], match[3]].join('');
    }
    if (rangeValue.hasOwnProperty('max')) {
      var _match = regex.exec(rangeValue.max.toString());
      if (_match) rangeValue.max = [_match[1], _match[2], _match[3]].join('');
    }
    if (rangeValue.hasOwnProperty('min') && rangeValue.hasOwnProperty('max')) {
      term = {
        range: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, attribPath, { gte: rangeValue.min, lte: rangeValue.max })
      };
    } else if (rangeValue.hasOwnProperty('min')) term = { range: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, attribPath, { gte: rangeValue.min }) };else if (rangeValue.hasOwnProperty('max')) term = { range: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, attribPath, { lte: rangeValue.max }) };
  } else {
    if (token.value === true) {
      var datasetAttr = token.dataset + '.' + token.dataset + '_yes';
      term = { term: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, datasetAttr, token.id) };
    } else if (token.value === false) {
      var _datasetAttr = token.dataset + '.' + token.dataset + '_no';
      term = { term: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, _datasetAttr, token.id) };
    } else term = { term: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, attribPath, token.value) };
  }
  return term;
}

function handleEmptyQuery(startDate, endDate) {
  return {
    bool: {
      must: {
        range: {
          broadcastdate: { gte: startDate, lte: endDate }
        }
      }
    }
  };
}

function getEsQuery() {
  var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { view_source: 'aalive7' };

  var startDate = body['start-date'];
  var endDate = body['end-date'];
  var esSearch = { size: 0 };
  if (q.length === 0) esSearch.query = handleEmptyQuery(startDate, endDate);else {
    var finalQuery = parseQuery(q, body);
    if (finalQuery.hasOwnProperty('bool') && !finalQuery.bool.hasOwnProperty('minimum_should_match')) {
      finalQuery.bool.minimum_should_match = '0<1';
    }
    finalQuery.bool.filter = {
      bool: {
        must: [{
          range: {
            broadcastdate: { gte: startDate, lte: endDate, format: 'yyyy-MM-dd' }
          }
        }, {
          range: {
            'respondent.age': { gte: 18 }
          }
        }]
      }
    };
    esSearch.query = finalQuery;
  }
  return esSearch;
}

function getDataSources() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(query.flat(Infinity).filter(function (n) {
    return n.dataset;
  }).map(function (n) {
    return n.dataset;
  }));
}



/* harmony default export */ __webpack_exports__["a"] = (getEsQuery);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_INTERFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SEND_DOWN_STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ENABLE_UPDATE_INSIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ENABLE_UPDATE_TARGET_HEADER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHOW_UE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_LOADING_INSIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LOG_XANDR_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TOGGLE_MOCK_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOW_SAVING_LIVE_DIGITAL_PROMPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_CONTROL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_QUERY_ERRORED_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_TRAITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SHOW_MODELING_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_AUDIENCE_EXPANSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONFIGURE_AUDIENCE_EXPANSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_INSIGHTS_REFRESHED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_U__ = __webpack_require__(124);




var _this = this,
    _actions;




var module = 'XANDR_WORKBENCH_ACTIONS_';
var STORE_NAME = 'xandr_workbench';

var SET_INTERFACE = module + 'SET_INTERFACE';
var SEND_DOWN_STREAM = module + 'SEND_DOWN_STREAM';
var SET_ENABLE_UPDATE_INSIGHTS = module + 'SET_ENABLE_UPDATE_INSIGHTS';
var SET_ENABLE_UPDATE_TARGET_HEADER_DATA = module + 'SET_ENABLE_UPDATE_TARGET_HEADER_DATA';
var SHOW_UE_MODAL = module + 'SHOW_UE_MODAL';
var SET_LOADING_INSIGHTS = module + 'SET_LOADING_INSIGHTS';
var LOG_XANDR_ACTION = module + 'LOG_XANDR_ACTION';
var TOGGLE_MOCK_DATA = module + 'TOGGLE_MOCK_DATA';
var SET_QUERY = module + 'SET_QUERY';
var RESET = module + 'RESET';
var SHOW_SAVING_LIVE_DIGITAL_PROMPT = 'SHOW_SAVING_LIVE_DIGITAL_PROMPT';
var SET_CONTROL_URL = 'SET_CONTROL_URL';
var SET_QUERY_ERRORED_OUT = module + 'SET_QUERY_ERRORED_OUT';
var SET_TRAITS = module + 'SET_TRAITS';
var SHOW_MODELING_MODAL = module + 'SHOW_MODELING_MODAL';
var SET_AUDIENCE_EXPANSION = module + 'SET_AUDIENCE_EXPANSION';
var SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE = module + 'SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE';
var CONFIGURE_AUDIENCE_EXPANSION = module + 'CONFIGURE_AUDIENCE_EXPANSION';
var SET_INSIGHTS_REFRESHED = module + 'SET_INSIGHTS_REFRESHED';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_MODELING_MODAL, function (context) {
  context.commit(SHOW_MODELING_MODAL);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INTERFACE, function (context, inter) {
  context.commit(SET_INTERFACE, inter);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SEND_DOWN_STREAM, function (context) {
  context.state.interface.__sendDownStream({
    context: context,
    targetId: context.getters.newWorkbenchTarget.id
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ENABLE_UPDATE_INSIGHTS, function (context, setValue) {
  context.commit(SET_ENABLE_UPDATE_INSIGHTS, setValue);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ENABLE_UPDATE_TARGET_HEADER_DATA, function (context, setValue) {
  context.commit(SET_ENABLE_UPDATE_TARGET_HEADER_DATA, setValue);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_UE_MODAL, function (context) {
  context.commit(SHOW_UE_MODAL);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SHOW_SAVING_LIVE_DIGITAL_PROMPT, function (context) {
  context.commit(SHOW_SAVING_LIVE_DIGITAL_PROMPT);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_LOADING_INSIGHTS, function (context, value) {
  context.commit(SET_LOADING_INSIGHTS, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, TOGGLE_MOCK_DATA, function (context, value) {
  context.commit(TOGGLE_MOCK_DATA, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_QUERY, function (context, value) {
  context.commit(SET_QUERY, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, RESET, function (context) {
  context.commit(RESET);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, LOG_XANDR_ACTION, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(context, value) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["u" /* logXandrAction */])(value);

          case 2:
            context.commit(LOG_XANDR_ACTION, value);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_QUERY_ERRORED_OUT, function (context, value) {
  context.commit(SET_QUERY_ERRORED_OUT, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_INSIGHTS_REFRESHED, function (context, value) {
  context.commit(SET_INSIGHTS_REFRESHED, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_AUDIENCE_EXPANSION, function (context, value) {
  context.commit(SET_AUDIENCE_EXPANSION, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE, function (context, value) {
  context.commit(SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CONFIGURE_AUDIENCE_EXPANSION, function (context, targetDefinition) {
  var uniqueRootFamilies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_U__["a" /* getAllDatasetsRootFamilyFromQuery */])(targetDefinition || []);

  var sourceConstants = context.rootGetters.getConstants;
  var audienceExpansionConfig = sourceConstants && sourceConstants.AUDIENCE_EXPANSION ? sourceConstants.AUDIENCE_EXPANSION : {};
  var C360Datasources = context.rootGetters.getC360Datasources;

  var audienceExpansionValue = false;
  var allowToggle = false;

  var findDatasourceKeyByRootFamily = function findDatasourceKeyByRootFamily(datasources, rootFamily) {
    if (!datasources) return 'DEFAULT';

    for (var datasourceKey in datasources) {
      if (datasources[datasourceKey] === rootFamily) {
        return datasourceKey;
      }
    }
    return 'DEFAULT';
  };

  if (uniqueRootFamilies.length === 0) {
    var defaultConfig = audienceExpansionConfig.DEFAULT || { default: true, allowToggle: false };
    audienceExpansionValue = defaultConfig.default;
    allowToggle = defaultConfig.allowToggle;
  } else if (uniqueRootFamilies.length === 1) {
    var datasourceKey = findDatasourceKeyByRootFamily(C360Datasources, uniqueRootFamilies[0]);
    var datasourceConfig = audienceExpansionConfig[datasourceKey] || audienceExpansionConfig.DEFAULT || { default: true, allowToggle: false };
    audienceExpansionValue = datasourceConfig.default;
    allowToggle = datasourceConfig.allowToggle;
  } else {
    var _defaultConfig = audienceExpansionConfig.DEFAULT || { default: true, allowToggle: false };
    audienceExpansionValue = _defaultConfig.default;
    allowToggle = _defaultConfig.allowToggle;
  }

  context.dispatch(SET_AUDIENCE_EXPANSION, audienceExpansionValue);
  context.dispatch(SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE, allowToggle);

  return {
    uniqueRootFamilies: uniqueRootFamilies,
    audienceExpansionValue: audienceExpansionValue,
    allowToggle: allowToggle
  };
}), _actions);

/* harmony default export */ __webpack_exports__["n"] = (actions);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export queryStringToJSON */
/* unused harmony export getADCode */
/* unused harmony export makeid */
/* unused harmony export passPruneInspection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllDatasetsRootFamilyFromQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






var CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

var queryStringToJSON = function queryStringToJSON() {
  var pairs = location.search.slice(1).split('&');
  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(result));
};

var getADCode = function getADCode() {
  var url = window.location.href;
  if (url && url.includes('code') && url.includes('state')) {
    var splits = url.split('?');
    var authCodeSplit = splits[1];
    var endOfAuthCode = authCodeSplit.split('#/');
    return queryStringToJSON(endOfAuthCode);
  }
};

var makeid = function makeid(length) {
  var result = '';
  var charactersLength = CHARACTERS.length;
  for (var i = 0; i < length; i++) {
    result += CHARACTERS.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

var passPruneInspection = function passPruneInspection() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var numberOfPercents = str.split('%').length - 1;
  var newString = str.replace(/ /g, '-').replace(/[?”"/'’>.<,;:{[}\]+=()*&^%$#@!~`]/g, '');
  var prunedNumOfPercents = encodeURI(newString).split('%').length - 1;
  if (prunedNumOfPercents > numberOfPercents) {
    return false;
  } else {
    return true;
  }
};

var getAllDatasetsRootFamilyFromQuery = function getAllDatasetsRootFamilyFromQuery(query) {
  var dataSetsRootFamilies = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(query), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      if (Array.isArray(el)) {
        var dtsFamily = getAllDatasetsRootFamilyFromQuery(el);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dtsFamily), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var df = _step2.value;

            dataSetsRootFamilies.add(df);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else if (typeof el === 'string') {} else {
        dataSetsRootFamilies.add(el.rootFamily);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(dataSetsRootFamilies);
};

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformAttributes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tree_model__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tree_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tree_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




function transformAttributes(dataSource, dataId) {
  var treeModel = new __WEBPACK_IMPORTED_MODULE_1_tree_model___default.a();
  var node = treeModel.parse(dataSource);
  var attributes = [];
  node.walk({ strategy: 'post' }, function (node) {
    var attr = node.model;
    if (attr.type) {
      attr.dataset = dataId;

      attr.path = node.getPath().map(function (pathNode) {
        return pathNode.model !== node.model && !pathNode.isRoot() ? pathNode.model.name : undefined;
      }).filter(function (n) {
        return n !== undefined;
      }).join(' / ');

      attr.parent = node.getPath().length > 2 ? node.parent.model.name : '';
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(attr);
      attributes.push(attr);
    }
    if (typeof attr.id === 'undefined') {
      attr.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniqueId"])(dataId);
    }
  });
  return {
    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(dataSource),
    flat: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
      name: dataSource.name,
      attributes: attributes
    })
  };
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OvalLabel__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OvalLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OvalLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OvalButton__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OvalButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OvalButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__OvalLabel___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__OvalButton___default.a; });




/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    direction: {
      type: String,
      default: 'top'
    },
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    }
  },
  mounted: function mounted() {
    var _this = this;

    var popover = this.$refs.popover;
    popover.$on('reposition', function () {
      return _this.$emit('reposition');
    });
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = truncateAmount;

function truncateAmount(amount) {
  if (amount >= 1000000) {
    var quotient = amount / 1000000;
    return (isDecimal(quotient) ? quotient.toFixed(quotient > 10 ? 1 : 2) : quotient) + 'M';
  } else if (amount >= 1000) {
    var _quotient = amount / 1000;
    return (isDecimal(_quotient) ? _quotient.toFixed(1) : _quotient) + 'K';
  } else {
    return isDecimal(amount) ? amount.toFixed(1) : amount;
  }
}

function isDecimal(num) {
  return num % 1 !== 0;
}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_DASHBOARD_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_DASHBOARD_TARGET_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DATASETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PRIMARY_INSIGHTS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_DATASET_FAMILIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_DAY_PARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_QUICK_ADD_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_DATE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_BYOD_DATASET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SOURCE_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_MVPDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_VIDEOAMP_AUDIENCE_LIST; });
var module = 'APP_RES_';

var SET_USERS = module + 'SET_USERS';
var SET_DASHBOARD_FILTER = module + 'SET_DASHBOARD_FILTER';
var SET_DASHBOARD_TARGET_FILTER = module + 'SET_DASHBOARD_TARGET_FILTER';
var SET_DATASETS = module + 'SET_DATASETS';
var SET_PRIMARY_INSIGHTS_FILTER = module + 'SET_PRIMARY_INSIGHTS_FILTER';
var SET_DATASET_FAMILIES = module + 'SET_DATASET_FAMILIES';
var SET_DAY_PARTS = module + 'SET_DAY_PARTS';
var SET_QUICK_ADD_ATTRIBUTES = module + 'SET_QUICK_ADD_ATTRIBUTES';
var SET_DATE_RANGE = module + 'SET_DATE_RANGE';
var SET_BYOD_DATASET = module + 'SET_BYOD_DATASET';
var SET_SOURCE_CONSTANTS = module + 'SET_SOURCE_CONSTANTS';
var SET_MVPDS = module + 'SET_MVPDS';
var SET_VIDEOAMP_AUDIENCE_LIST = module + 'SET_VIDEOAMP_AUDIENCE_LIST';

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TARGET_DEFINITION_DIRTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_IS_DROPPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SAVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_FETCHING_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_FETCHING_WORKBENCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_QUICK_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_STREAMING_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_TARGET_HISTORY_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FLAG_REQUEST_NUMBER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_conversions__ = __webpack_require__(71);


var _SET_TARGET_DEFINITIO;



var SET_TARGET_DEFINITION_DIRTY = 'SET_TARGET_DEFINITION_DIRTY';
var SET_IS_DROPPED = 'SET_IS_DROPPED';
var SET_METRICS = 'SET_METRICS';
var SET_LOADING = 'SET_LOADING';
var SET_SAVING = 'SET_SAVING';
var SET_FETCHING_TARGET = 'SET_FETCHING_TARGET';
var SET_FETCHING_WORKBENCH_DATA = 'SET_FETCHING_WORKBENCH_DATA';
var SET_QUICK_ADD = 'SET_QUICK_ADD';
var SET_STREAMING_OPTION = 'SET_STREAMING_OPTION';
var SHOW_TARGET_HISTORY_PANEL = 'SHOW_TARGET_HISTORY_PANEL';
var FLAG_REQUEST_NUMBER = 'FLAG_REQUEST_NUMBER';

/* harmony default export */ __webpack_exports__["l"] = (_SET_TARGET_DEFINITIO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_TARGET_DEFINITION_DIRTY, function (state, value) {
  state.dirty = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_IS_DROPPED, function (state, value) {
  state.isDropped = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_FETCHING_TARGET, function (state, value) {
  state.fetchingTarget = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_FETCHING_WORKBENCH_DATA, function (state, value) {
  state.fetchingWorkbenchData = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_LOADING, function (state, value) {
  state.loading = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_SAVING, function (state, value) {
  state.saving = value;
  if (state.saving) {
    state.lastTimeSaved = new Date();
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_METRICS, function (state, value) {
  state.metrics = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_QUICK_ADD, function (state, value) {
  state.quickAddAttributes = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SET_STREAMING_OPTION, function (state, value) {
  state.streamingOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__appLogic_targets_conversions__["a" /* convertViewingStreamForES */])(value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, SHOW_TARGET_HISTORY_PANEL, function (state, value) {
  state.showTargetHistoryPanel = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TARGET_DEFINITIO, FLAG_REQUEST_NUMBER, function (state) {
  state.requestNumber = state.requestNumber + 1;
}), _SET_TARGET_DEFINITIO);

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1882),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(931),
  /* template */
  __webpack_require__(1832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INIT_DATE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_END_DATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(307);


var _INIT_DATE_RANGE$UPDA;





var module = 'DATE_RANGE_';

var INIT_DATE_RANGE = module + 'initDateRange';
var UPDATE_START_DATE = module + 'updateStartDate';
var UPDATE_END_DATE = module + 'updateEndDate';

/* harmony default export */ __webpack_exports__["c"] = (_INIT_DATE_RANGE$UPDA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_DATE_RANGE$UPDA, INIT_DATE_RANGE, function (_ref, configDates) {
  var commit = _ref.commit,
      state = _ref.state;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* SET_AVAILABLE_DATES */], configDates);
  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_START_DATE */], state.availableDates[Math.max(state.availableDates.length - 12, 0)]);
  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_END_DATE */], state.availableDates[state.availableDates.length - 1]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_DATE_RANGE$UPDA, UPDATE_START_DATE, function (_ref2, startDateFrom) {
  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      state = _ref2.state;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_START_DATE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["find"])(state.availableDates, function (date) {
    return date.from === startDateFrom;
  }));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_DATE_RANGE$UPDA, UPDATE_END_DATE, function (_ref3, endDateTo) {
  var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      state = _ref3.state;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_END_DATE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["find"])(state.availableDates, function (date) {
    return date.to === endDateTo;
  }));
}), _INIT_DATE_RANGE$UPDA);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDraggable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canDropHere: function canDropHere() {
      return this.$store.getters.hasOwnProperty('canDraggingItemDropHere') ? this.$store.getters.canDraggingItemDropHere(this.definitionId, this.level) : true;
    }
  },
  methods: {
    dragStartHandler: function dragStartHandler(e) {
      e.dataTransfer.setData('text/plain', this.definitionId);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_store_actions__["u" /* START_DRAG_ITEM */], this.definitionId);
      if (this.hoverOverPopover && this.hoverOverPopover.selectOption) {
        this.hoverOverPopover.selectOption();
      }
    },
    dragOverHandler: function dragOverHandler(e) {
      e.preventDefault();
      if (this.canDropHere) {
        e.dataTransfer.dropEffect = 'copy';
        e.currentTarget.classList.add('cursor-left');
      } else {
        e.dataTransfer.dropEffect = 'none';
      }
    },
    dragLeaveHandler: function dragLeaveHandler(e) {
      e.preventDefault();
      e.currentTarget.classList.remove('cursor-left');
    },
    dropHandler: function dropHandler(e) {
      e.preventDefault();
      if (this.canDropHere) {
        e.currentTarget.classList.remove('cursor-left');
        var data = e.dataTransfer.getData('text');
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_store_actions__["t" /* MOVE_ATTRIBUTE */], {
          droppedId: data,
          moveToId: this.definitionId,
          defType: this.defType
        });
      }
    },
    dragEndHandler: function dragEndHandler(e) {
      e.preventDefault();
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_store_actions__["v" /* REMOVE_DRAG_ITEM */]);
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = ({
  serialize: function serialize(definition) {
    if (!definition) return [];
    return serializeChildren(definition.children);
  },
  deserialize: function deserialize() {
    var serializedDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var storeGetters = arguments[1];

    return parse(serializedDefinition, storeGetters);
  }
});

function parse(definition, storeGetters) {
  return definition.map(function (part) {
    if (part.id !== undefined) {
      var attribute = void 0;
      if (storeGetters) {
        var foundPart = storeGetters.getAttributeForIdDataset({ id: part.id, dataset: part.dataset });
        attribute = foundPart ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, foundPart) : part;
      } else {
        attribute = part;
      }
      attribute.value = part.value;
      return attribute;
    }
    if (Array.isArray(part)) {
      if (typeof part[0] === 'number' && part[1] === 'MIN') {
        return {
          mustMatch: part[0],
          children: parse(part.slice(2), storeGetters)
        };
      }
      return {
        children: parse(part, storeGetters)
      };
    }
    if (typeof part === 'string') {
      return {
        operator: true,
        value: part
      };
    }
    return null;
  });
}

function serializeChildren(definition) {
  return definition.reduce(function (parts, part) {
    if (typeof part === 'number' || part === 'MIN') parts.push(part);
    if (part.operator) parts.push(part.value);
    if (part.type !== undefined) {
      parts.push(serializeAttribute(part));
    }
    if (part.mustMatch) parts.push(serializeChildren([Number(part.mustMatch), 'MIN'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(part.children))));else if (part.children) parts.push(serializeChildren(part.children));
    return parts;
  }, []);
}

function serializeAttribute(_ref) {
  var id = _ref.id,
      value = _ref.value,
      dataset = _ref.dataset,
      path = _ref.path,
      parent = _ref.parent,
      name = _ref.name,
      type = _ref.type,
      query = _ref.query;

  return { id: id, value: value, dataset: dataset, path: path, parent: parent, name: name, type: type, query: query };
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDraggable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canDropHere: function canDropHere() {
      var dragFunc = this.$store.getters['workbench/canDraggingItemDropHere'];
      return dragFunc ? dragFunc(this.definitionId, this.level) : true;
    }
  },
  methods: {
    dragStartHandler: function dragStartHandler(e) {
      e.dataTransfer.setData('text/plain', this.definitionId);
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_targetDefinition_store_actions__["s" /* START_DRAG_ITEM */], this.definitionId);
      if (this.hoverOverPopover && this.hoverOverPopover.selectOption) {
        this.hoverOverPopover.selectOption();
      }
    },
    dragOverHandler: function dragOverHandler(e) {
      e.preventDefault();
      if (this.canDropHere) {
        e.dataTransfer.dropEffect = 'copy';
        e.currentTarget.classList.add('cursor-left');
      } else {
        e.dataTransfer.dropEffect = 'none';
      }
    },
    dragLeaveHandler: function dragLeaveHandler(e) {
      e.preventDefault();
      e.currentTarget.classList.remove('cursor-left');
    },
    dropHandler: function dropHandler(e) {
      e.preventDefault();
      if (this.canDropHere) {
        e.currentTarget.classList.remove('cursor-left');
        var data = e.dataTransfer.getData('text');
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_targetDefinition_store_actions__["r" /* MOVE_ATTRIBUTE */], {
          droppedId: data,
          moveToId: this.definitionId,
          defType: this.defType
        });
      }
    },
    dragEndHandler: function dragEndHandler(e) {
      e.preventDefault();
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_targetDefinition_store_actions__["t" /* REMOVE_DRAG_ITEM */]);
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_and_svg__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_or_svg__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_not_svg__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_minus_svg__ = __webpack_require__(1556);





var operator = {
  OR: {
    value: 'OR',
    icon: {
      class: 'operator-icon--or',
      svg: __WEBPACK_IMPORTED_MODULE_1__assets_svg_or_svg__["a" /* default */],
      width: 18,
      height: 18
    }
  },
  AND: {
    value: 'AND',
    icon: {
      class: 'operator-icon--and',
      svg: __WEBPACK_IMPORTED_MODULE_0__assets_svg_and_svg__["a" /* default */],
      width: 14,
      height: 14
    }
  },
  NOT: {
    value: 'NOT',
    icon: {
      class: 'operator-icon--not',
      svg: __WEBPACK_IMPORTED_MODULE_2__assets_svg_not_svg__["a" /* default */],
      width: 18,
      height: 18
    }
  },
  "-": {
    value: '-',
    icon: {
      class: 'operator-icon--minus',
      svg: __WEBPACK_IMPORTED_MODULE_3__assets_svg_minus_svg__["a" /* default */],
      width: 18,
      height: 18
    }
  },
  get default() {
    return this.or;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (operator);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_NETWORKS_GROUPINGS; });
var module = 'USER_RESOURCES_';

var SET_NETWORKS = module + 'SET_NETWORKS';
var SET_NETWORKS_GROUPINGS = module + 'SET_NETWORKS_GROUPINGS';

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPES; });
var CON = {
  TYPE_OPEN_AP: 'OPENAP',
  TYPE_AUDIENCE_MATTERS: 'AM',
  TYPE_USER: 'USER',
  STATUS_NEW: 'NEW',
  STATUS_READ: 'READ',
  STATUS_DELETED: 'DELETED',
  STATUS_ARCHIVED: 'ARCHIVED',
  ALERT_ERROR: 'ERROR',
  ALERT_WARNING: 'WARNING',
  ALERT_SUCCESS: 'SUCCESS',
  ALERT_INFO: 'INFO'
};

var TYPES = {
  ASSIGNED_OPEN_AP: 'openap',
  USER: 'user',
  ATT_ASSIGN: 'att-assign',
  ATT_RESPONSE: 'att-response'
};

/* harmony default export */ __webpack_exports__["a"] = (CON);



/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeedbackModal__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeedbackModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FeedbackModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorModal__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ErrorModal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ErrorModal___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__FeedbackModal___default.a; });





/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleButton__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SimpleButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InteractiveSimpleButton__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InteractiveSimpleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__InteractiveSimpleButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__InteractiveSimpleButton___default.a; });



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SimpleButton___default.a);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_vue__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tabs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tab_vue__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tab_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  Tabs: __WEBPACK_IMPORTED_MODULE_0__Tabs_vue___default.a,
  Tab: __WEBPACK_IMPORTED_MODULE_1__Tab_vue___default.a
});

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1283)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1975),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1175)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(970),
  /* template */
  __webpack_require__(1863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDataForBubblesPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);


var data = void 0;
var renderedImages = [];

__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.canvasHelpers.defaultDrawPoint = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.canvasHelpers.drawPoint;
__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.canvasHelpers.drawPoint = function (ctx, pointStyle, radius, x, y) {
  if (pointStyle === undefined || pointStyle === 'circle') {
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, Math.PI * 2);
    ctx.closePath();
    ctx.fill();
    if (data) {
      var datasetPoint = data.find(function (data) {
        return data.data[0].r === radius;
      });
      if (datasetPoint && datasetPoint.dataLabels) {
        if (datasetPoint.dataLabels.image) {
          renderImageURLLabel(ctx, datasetPoint.dataLabels.image, { r: radius, x: x, y: y });
          return;
        }
        if (datasetPoint.dataLabels.label) {
          renderTextLabel(ctx, datasetPoint.dataLabels.label, { r: radius, x: x, y: y });
        }
        if (datasetPoint.dataLabels.rightLabel) {
          renderTextLabelRight(ctx, datasetPoint.dataLabels.rightLabel.replace('&AMP;', '&').replace('&amp;', '&'), { r: radius, x: x, y: y });
        }
      }
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.canvasHelpers.defaultDrawPoint(ctx, pointStyle, radius, x, y);
  }
};

var setDataForBubblesPlugin = function setDataForBubblesPlugin(newData) {
  data = newData;
};

var renderImageURLLabel = function renderImageURLLabel(ctx, url, _ref) {
  var r = _ref.r,
      x = _ref.x,
      y = _ref.y;

  var cachedImage = renderedImages.find(function (_ref2) {
    var src = _ref2.src;
    return src === url;
  });
  if (cachedImage) {
    var newSize = findMaxSizeForImage(cachedImage, r);
    ctx.drawImage(cachedImage, x - newSize.width / 2, y - newSize.height / 2, newSize.width, newSize.height);
  } else {
    var image = new Image();
    image.src = url;
    image.crossOrigin = 'Anonymous';
    image.onload = function () {
      var _this = this;

      setTimeout(function () {
        if (renderedImages.find(function (_ref3) {
          var src = _ref3.src;
          return src === _this.src;
        })) return;
        var newSize = findMaxSizeForImage(_this, r);
        ctx.drawImage(image, x - newSize.width / 2, y - newSize.height / 2, newSize.width, newSize.height);
        renderedImages.push(image);
      }, 0);
    };
  }
};

var renderTextLabel = function renderTextLabel(ctx, label, _ref4) {
  var r = _ref4.r,
      x = _ref4.x,
      y = _ref4.y;

  if (!label) return;

  ctx.font = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.helpers.fontString(__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontSize, 'bold', __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontFamily);
  var defaultLabelWidth = ctx.measureText(label).width;
  var desiredWidth = r * 2 * 0.7;
  var newFontSizeToReachDesiredWidth = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontSize * (desiredWidth / defaultLabelWidth);

  if (newFontSizeToReachDesiredWidth > desiredWidth) {
    newFontSizeToReachDesiredWidth = desiredWidth;
  }

  ctx.font = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.helpers.fontString(newFontSizeToReachDesiredWidth, 'bold', __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontFamily);
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = '#fff';
  ctx.fillText(label, x, y);
};

var renderTextLabelRight = function renderTextLabelRight(ctx, label, _ref5) {
  var r = _ref5.r,
      x = _ref5.x,
      y = _ref5.y;

  if (!label) return;

  ctx.font = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.helpers.fontString(10, 'bold', __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontFamily);
  ctx.textAlign = 'left';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = '#435262';
  ctx.fillText(label, x + r + 5, y);
};

var findMaxSizeForImage = function findMaxSizeForImage(image, maxSize) {
  var width = void 0,
      height = void 0,
      ratio = void 0;
  if (image.width > image.height) {
    ratio = image.height / image.width;
    width = maxSize;
    height = maxSize * ratio;
  } else {
    ratio = image.width / image.height;
    width = maxSize * ratio;
    height = maxSize;
  }
  return {
    height: height,
    width: width
  };
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_DATE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_END_DATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(312);


var _INIT_DATE_RANGE$UPDA;



var module = 'DATE_RANGE_';

var INIT_DATE_RANGE = module + 'initDateRange';
var UPDATE_START_DATE = module + 'updateStartDate';
var UPDATE_END_DATE = module + 'updateEndDate';



/* harmony default export */ __webpack_exports__["c"] = (_INIT_DATE_RANGE$UPDA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_DATE_RANGE$UPDA, INIT_DATE_RANGE, function (_ref, dateRange, startDate) {
  var commit = _ref.commit,
      state = _ref.state;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* SET_AVAILABLE_DATES */], dateRange);
  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_START_DATE */], startDate);
  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_END_DATE */], dateRange[dateRange.length - 1]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_DATE_RANGE$UPDA, UPDATE_START_DATE, function (_ref2, startDateFrom) {
  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      state = _ref2.state;

  var newStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["find"])(state.availableDates, function (date) {
    return date.from === startDateFrom;
  });
  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_START_DATE */], newStartDate);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_DATE_RANGE$UPDA, UPDATE_END_DATE, function (_ref3, endDateTo) {
  var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      state = _ref3.state;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_END_DATE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["find"])(state.availableDates, function (date) {
    return date.to === endDateTo;
  }));
}), _INIT_DATE_RANGE$UPDA);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  serialize: function serialize(definition) {
    if (!definition) return [];
    return serializeChildren(definition.children);
  },
  deserialize: function deserialize() {
    var serializedDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var storeGetters = arguments[1];

    return parse(serializedDefinition, storeGetters);
  }
});

function parse(definition, storeGetters) {
  return definition.map(function (part) {
    if (part.id !== undefined) {
      var attribute = void 0;
      if (storeGetters) {} else {
        attribute = part;
      }
      attribute.value = part.value;
      return attribute;
    }
    if (Array.isArray(part)) {
      if (typeof part[0] === 'number' && part[1] === 'MIN') {
        return {
          mustMatch: part[0],
          children: parse(part.slice(2), storeGetters)
        };
      }
      return {
        children: parse(part, storeGetters)
      };
    }
    if (typeof part === 'string') {
      return {
        operator: true,
        value: part
      };
    }
    return null;
  });
}

function serializeChildren(definition) {
  return definition.reduce(function (parts, part) {
    if (typeof part === 'number' || part === 'MIN') parts.push(part);
    if (part.operator) parts.push(part.value);
    if (part.type !== undefined) {
      parts.push(serializeAttribute(part));
    }
    if (part.mustMatch) parts.push(serializeChildren([Number(part.mustMatch), 'MIN'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(part.children))));else if (part.children) parts.push(serializeChildren(part.children));
    return parts;
  }, []);
}

function serializeAttribute(_ref) {
  var id = _ref.id,
      value = _ref.value,
      dataset = _ref.dataset,
      rootFamily = _ref.rootFamily,
      path = _ref.path,
      parent = _ref.parent,
      name = _ref.name,
      type = _ref.type,
      query = _ref.query,
      isLal = _ref.isLal,
      advertiserId = _ref.advertiserId,
      brdOwner = _ref.brdOwner,
      subCategory = _ref.subCategory;

  return { id: id, value: value, dataset: dataset, rootFamily: rootFamily, path: path, parent: parent, name: name, type: type, query: query, isLal: isLal, advertiserId: advertiserId, brdOwner: brdOwner, subCategory: subCategory };
}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_NOTIFICATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notificationConstants__ = __webpack_require__(159);


var _actions;






var module = 'NOTIFICATIONS_';

var SET_NOTIFICATIONS = module + 'SET_NOTIFICATIONS';
var REMOVE_NOTIFICATION = module + 'REMOVE_NOTIFICATION';
var DELETE_NOTIFICATION = module + 'DELETE_NOTIFICATION';
var UPDATE_NOTIFICATION = module + 'UPDATE_NOTIFICATION';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, DELETE_NOTIFICATION, function (context, notification) {
  notification.user_id = context.rootState.auth.username;
  __WEBPACK_IMPORTED_MODULE_1__api__["R" /* NotificationAPI */].deleteNotification(notification);
  context.commit(DELETE_NOTIFICATION, notification);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, UPDATE_NOTIFICATION, function (context, notification) {
  context.commit(UPDATE_NOTIFICATION, notification);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_NOTIFICATIONS, function (context, user) {
  __WEBPACK_IMPORTED_MODULE_1__api__["R" /* NotificationAPI */].getNotifications({ user_id: user }).then(function (data) {
    context.commit(SET_NOTIFICATIONS, {
      notifications: data,
      user: user
    });
    if (data.notification_type === __WEBPACK_IMPORTED_MODULE_3__notificationConstants__["b" /* TYPES */].ATT_RESPONSE) {
      context.commit(__WEBPACK_IMPORTED_MODULE_2__views_audienceHub_store_actions__["r" /* SET_TARGET_STATUS */], JSON.parse(data.body));
    }
  });
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__ = __webpack_require__(208);


var generateLabel = function generateLabel(lastMove) {
  var move = 'A move was made';
  switch (lastMove.command) {
    case __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__["a" /* COMMANDS */].ADD_ATTRIBUTE:
      move = '"' + lastMove.data.parent + ' - ' + lastMove.data.name + '" was added.';
      break;
    case __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__["a" /* COMMANDS */].REMOVED_ATTRIBUTE:
      if (lastMove.data.length > 0) {
        move = '';
        lastMove.data.forEach(function (data) {
          move += '"' + data[0].parent + ' - ' + data[0].name + '" was removed. ';
        });
      } else {
        move = 'An attribute was removed.';
      }
      break;
    case __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__["a" /* COMMANDS */].CHANGED_OPERATOR:
      move = 'A operator was changed.';
      break;
    case __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__["a" /* COMMANDS */].GROUPED_ATTRIBUTES:
      move = 'You grouped attributes together.';
      break;
    case __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__["a" /* COMMANDS */].UNGROUPED_ATTRIBUTES:
      move = 'You ungrouped attributes.';
      break;
    case __WEBPACK_IMPORTED_MODULE_0__attributeActionConstants__["a" /* COMMANDS */].CHANGED_DATE:
      move = 'You changed the date.';
      break;
  }
  return move;
};

/* harmony default export */ __webpack_exports__["a"] = (generateLabel);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMMANDS; });
var COMMANDS = {
  ADD_ATTRIBUTE: 1,
  REMOVED_ATTRIBUTE: 2,
  MOVED_ATTRIBUTE: 3,
  CHANGED_OPERATOR: 5,
  GROUPED_ATTRIBUTES: 10,
  UNGROUPED_ATTRIBUTES: 11,
  CLEARED: 15,
  CREATED_COUNT: 20,
  REMOVED_COUNT: 21,
  CHANGED_DATE: 30
};



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAttributes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tree_model__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tree_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tree_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var transformAttributes = function transformAttributes(dataSource, dataId, rootFamily) {
  var freeze = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var treeModel = new __WEBPACK_IMPORTED_MODULE_1_tree_model___default.a();
  var node = treeModel.parse(dataSource);
  var attributes = [];
  node.walk({ strategy: 'post' }, function (node) {
    var attr = node.model;
    if (attr.type) {
      if (!attr.dataset && dataId) {
        attr.dataset = dataId;
      }
      if (!attr.rootFamily && rootFamily) {
        attr.rootFamily = rootFamily;
      }

      attr.path = node.getPath().map(function (pathNode) {
        return pathNode.model !== node.model && !pathNode.isRoot() ? pathNode.model.name : undefined;
      }).filter(function (n) {
        return n !== undefined;
      }).join(' / ');

      attr.parent = node.getPath().length > 2 ? node.parent.model.name : '';
      if (freeze) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(attr);
      }
      attributes.push(attr);
    }
    if (typeof attr.id === 'undefined') {
      attr.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniqueId"])(dataId);
    }
  });
  var data = dataSource;
  var flat = {
    name: dataSource.name,
    attributes: attributes
  };
  if (freeze) {
    flat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(flat);
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(data);
  }
  return { data: data, flat: flat };
};

/* harmony default export */ __webpack_exports__["a"] = (transformAttributes);

var getAttributes = function getAttributes(dataSource) {
  var treeModel = new __WEBPACK_IMPORTED_MODULE_1_tree_model___default.a();
  var node = treeModel.parse(dataSource);
  var attributes = [];
  node.walk({ strategy: 'post' }, function (node) {
    var attr = node.model;
    if (attr.type) {
      attributes.push(attr);
    }
  });
  return attributes;
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PositiveityIndicator__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PositiveityIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PositiveityIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositiveCircle__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositiveCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PositiveCircle__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__PositiveityIndicator___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__PositiveCircle___default.a; });




/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioButton__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RadioButton__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RadioButton___default.a);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StyledTable_vue__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StyledTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StyledTable_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_StyledTable_vue___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StyledEmptyTableLayout_vue__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StyledEmptyTableLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_StyledEmptyTableLayout_vue__);
/* unused harmony reexport StyledEmptyTable */



/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toast__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToastFactory__ = __webpack_require__(328);






var RecurringToast = function () {
  function RecurringToast(setupOptions) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RecurringToast);

    this.setupOptions = setupOptions;
    this.run = false;
    this.interval = null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RecurringToast, [{
    key: 'start',
    value: function start() {
      if (this.interval) {
        this.stop();
      }
      this.interval = setInterval(this.speak.bind(this), this.setupOptions.interval);
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = null;
    }
  }, {
    key: 'speak',
    value: function speak() {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, { timeout: this.setupOptions.interval - 1000 });
      switch (this.setupOptions.type) {
        case __WEBPACK_IMPORTED_MODULE_3__Toast__["a" /* CONSTANTS */].TYPE.SUCCESS:
          __WEBPACK_IMPORTED_MODULE_4__ToastFactory__["a" /* default */].success(options);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__Toast__["a" /* CONSTANTS */].TYPE.WARNING:
          __WEBPACK_IMPORTED_MODULE_4__ToastFactory__["a" /* default */].warning(options);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__Toast__["a" /* CONSTANTS */].TYPE.INFO:
          __WEBPACK_IMPORTED_MODULE_4__ToastFactory__["a" /* default */].info(options);
          break;
        case __WEBPACK_IMPORTED_MODULE_3__Toast__["a" /* CONSTANTS */].TYPE.ERROR:
          __WEBPACK_IMPORTED_MODULE_4__ToastFactory__["a" /* default */].error(options);
          break;
        default:
          __WEBPACK_IMPORTED_MODULE_4__ToastFactory__["a" /* default */].info(options);
      }
    }
  }]);

  return RecurringToast;
}();

/* harmony default export */ __webpack_exports__["a"] = (RecurringToast);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Toast; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast_dist_css_iziToast_min_css__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_izitoast_dist_css_iziToast_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_izitoast_dist_css_iziToast_min_css__);






var CONSTANTS = {
  POSITIONS: {
    BOTTOM_RIGHT: 'bottomRight',
    BOTTOM_LEFT: 'bottomLeft',
    BOTTOM_CENTER: 'bottomCenter',
    TOP_RIGHT: 'topRight',
    TOP_LEFT: 'topLeft',
    TOP_CENTER: 'topCenter',
    CENTER: 'center'
  },
  THEME: {
    LIGHT: 'light',
    DARK: 'dark'
  },
  color: {
    BLUE: 'blue',
    RED: 'red',
    GREEN: 'green',
    YELLOW: 'yellow'
  },
  TYPE: {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info'
  }
};

var Toast = function () {
  function Toast(setupOptions) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Toast);

    this.setupOptions = setupOptions;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Toast, [{
    key: 'success',
    value: function success(options) {
      __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.success(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'warning',
    value: function warning(options) {
      __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.warning(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'error',
    value: function error(options) {
      __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'info',
    value: function info(options) {
      __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.info(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      __WEBPACK_IMPORTED_MODULE_3_izitoast___default.a.destroy();
    }
  }]);

  return Toast;
}();



/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);





var types = {
  NORMAL: 'NORMAL',
  PERCENTAGE: 'PERCENTAGE'
};

var constructDatasets = function constructDatasets(datasets) {
  var newDatasets = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(datasets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var d = _step.value;

      if (d.addMean) {
        var mean = d.addMean.mean;
        if (!d.addMean.mean) {
          var sum = d.data.reduce(function (acc, val) {
            return acc + val;
          });
          mean = sum / d.data.length;
        }
        var data = [];
        for (var i = 0; i < d.data.length; i++) {
          data.push(mean);
        }
        newDatasets.push({
          label: 'Mean ' + d.label,
          type: 'line',
          data: data,
          fillColor: 'rgba(220,220,220,0.0)',
          strokeColor: 'rgba(220,220,220,1)',
          pointColor: 'rgba(220,220,220,1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(220,220,220,1)',
          yAxisID: 'lineGraph'
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (newDatasets.length > 0) {
    var original = datasets.splice(0, 1);
    datasets.push.apply(datasets, newDatasets);
    datasets.push.apply(datasets, original);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bar"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  props: {
    labelFunc: Function,
    type: {
      type: String,
      default: types.NORMAL
    }
  },
  computed: {
    options: function options() {
      var that = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1,
            maxBarThickness: 300,
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              fontSize: 14,
              display: true
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              zeroLineColor: '#0052E7'
            }
          }]
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function label(tooltip, data) {
              if (that.labelFunc) {
                return that.labelFunc(tooltip, data);
              } else {
                var s = data.datasets[tooltip.datasetIndex].label + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* commaFormatString */])(String(tooltip.yLabel));
                if (that.type === types.NORMAL) {
                  return s;
                } else if (that.type === types.PERCENTAGE) {
                  return s + '%';
                }
              }
            }
          }
        }
      };
    }
  },
  mounted: function mounted() {
    constructDatasets(this.chartData.datasets);
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_TO_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CURRENT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GO_TO_DASHBOARD; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _actions;




var module = 'ROUTER_MOVES_';
var STORE_NAME = 'router';

var ADD_TO_HISTORY = module + 'ADD_TO_HISTORY';
var SET_CURRENT_URL = module + 'SET_CURRENT_URL';
var CLEAR_HISTORY = module + 'CLEAR_HISTORY';
var GO_TO_DASHBOARD = module + 'GO_TO_DASHBOARD';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, ADD_TO_HISTORY, function (context, from) {
  context.commit(ADD_TO_HISTORY, from);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SET_CURRENT_URL, function (context, currentURL) {
  context.commit(SET_CURRENT_URL, currentURL);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, CLEAR_HISTORY, function (context) {
  context.commit(CLEAR_HISTORY);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GO_TO_DASHBOARD, function (context) {
  var current = context.state.history;
  var hit = false;
  while (current) {
    if (current.url.name.includes('audience-hub')) {
      hit = true;
      __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(current.url)).catch(function (err) {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
      break;
    }
    current = current.previous;
  }
  if (!hit) {
    __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].push('/audience-hub/targets/' + context.getters.username).catch(function (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  }
}), _actions);

/* harmony default export */ __webpack_exports__["b"] = (actions);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGN_INTO_IDM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REFRESH_IDM_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ALL_PERMISSIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);


var _actions;



var module = 'IDM_MODULE_';

var SIGN_INTO_IDM = module + 'SIGN_INTO_IDM';
var REFRESH_IDM_TOKEN = module + 'REFRESH_IDM_TOKEN';
var GET_ALL_PERMISSIONS = module + 'GET_ALL_PERMISSIONS';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, SIGN_INTO_IDM, function (context, userinfo) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* logIntoIDM */])(userinfo.username, userinfo.password).then(function (resp) {
    context.commit(SIGN_INTO_IDM, resp);
    return true;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, GET_ALL_PERMISSIONS, function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["c" /* getPermissions */])().then(function (resp) {
    context.commit(GET_ALL_PERMISSIONS, resp.data);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, REFRESH_IDM_TOKEN, function (context, refreshInfo) {
  context.commit(REFRESH_IDM_TOKEN, refreshInfo);
}), _actions);

/* harmony default export */ __webpack_exports__["c"] = (actions);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DAY_PARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_AUDIENCE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_HISTORICAL_VIEWERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_UNIVERSE; });
/* unused harmony export SET_PREVIEW_TABLE_OPEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_AGE_DISTRIBUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_INCOME_DISTRIBUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_DROPPED_ATTRIBUTES_MODEL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkbenchActions__ = __webpack_require__(786);



var _extends2;




var SET_DAY_PARTS = 'SET_DAY_PARTS';
var SET_DATA_SOURCES = 'SET_DATA_SOURCES';
var SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE';
var SET_HISTORICAL_VIEWERSHIP = 'SET_HISTORICAL_VIEWERSHIP';
var SET_UNIVERSE = 'SET_UNIVERSE';
var SET_PREVIEW_TABLE_OPEN = 'SET_PREVIEW_TABLE_OPEN';
var SET_AGE_DISTRIBUTION = 'SET_AGE_DISTRIBUTION';
var SET_INCOME_DISTRIBUTION = 'SET_INCOME_DISTRIBUTION';
var SHOW_DROPPED_ATTRIBUTES_MODEL = 'SHOW_DROPPED_ATTRIBUTES_MODEL';

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store__["a" /* default */].mutations, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_DAY_PARTS, function (state, value) {
  state.dayParts = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_DATA_SOURCES, function (state, value) {
  state.dataSources = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_AUDIENCE_SIZE, function (state, value) {
  state.audienceSize = value || 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_UNIVERSE, function (state, value) {
  state.universe = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_HISTORICAL_VIEWERSHIP, function (state, value) {
  state.historicalViewership = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_PREVIEW_TABLE_OPEN, function (state, bool) {
  state.previewTableOpen = bool;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_AGE_DISTRIBUTION, function (state, data) {
  data.sort(function (a, b) {
    return a.age - b.age;
  });
  state.ageDistribution = data.map(function (d) {
    d.value = Math.floor(d.value);
    return d;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SET_INCOME_DISTRIBUTION, function (state, data) {
  data = data.filter(function (d) {
    return d !== null;
  }).map(function (d) {
    d.startIncome = Math.floor(Number(d.startIncome));
    d.finishIncome = Math.floor(Number(d.finishIncome));
    d.value = Math.floor(d.value);
    return d;
  });
  data.sort(function (a, b) {
    return a.startIncome - b.startIncome;
  });
  state.incomeDistribution = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, SHOW_DROPPED_ATTRIBUTES_MODEL, function (state) {
  if (state.showDroppedAttributeModel) {
    state.showDroppedAttributeModel = state.showDroppedAttributeModel + 1;
  } else {
    state.showDroppedAttributeModel = 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, __WEBPACK_IMPORTED_MODULE_3__WorkbenchActions__["a" /* SET_TRIGGERED_ONCE */], function (state) {
  state.triggeredOnce = true;
}), _extends2)));

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "Check",
  "use": "Check-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Check\"><path d=\"M9.9 0L3.667 6.234 1.1 3.667 0 4.767l3.667 3.666L11 1.1z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ncs-Selected.f082172.png";

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GAM-Selected.fcabcf7.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1830),
  /* scopeId */
  "data-v-1c030ba9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1300)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1993),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1275)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(1967),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1263)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1955),
  /* scopeId */
  "data-v-7484d8ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1289)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1981),
  /* scopeId */
  "data-v-9ab46f92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1252)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(1944),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1292)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1984),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(991),
  /* template */
  __webpack_require__(1821),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1151)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1003),
  /* template */
  __webpack_require__(1837),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);






var graphId = 'universe-graph';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_vue_chartjs__["Bar"].extend({
  props: {
    data: {
      type: Object,
      required: true
    },
    chartId: {
      type: String,
      default: graphId
    }
  },
  data: function data() {
    return {
      backgroundColor: null,
      hoverBackgroundColor: null
    };
  },

  computed: {
    chartData: function chartData() {
      return this.data;
    },
    options: function options() {
      var ticks = {
        padding: 4,
        fontSize: 13,
        callback: function callback(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* commaFormatString */])(String(value));
        }
      };
      if (!this.data || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.data) || this.data.datasets.length === 0) {
        ticks.min = 0;
        ticks.max = 500000;
      }
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1,
            maxBarThickness: 80,
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              fontSize: 13
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              zeroLineColor: '#0052E7'
            },
            ticks: ticks
          }]
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function label(tooltip, data) {
              return data.datasets[tooltip.datasetIndex].label + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* commaFormatString */])(String(tooltip.yLabel));
            }
          }
        }
      };
    }
  },
  mounted: function mounted() {
    var chart = document.getElementById(this.chartId);
    var ctx = document.getElementById(this.chartId).getContext('2d');
    var gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
    gradient.addColorStop(0, 'rgba(117, 227, 255, 0.7)');
    gradient.addColorStop(0.1, 'rgba(117, 227, 255, 0.7)');
    gradient.addColorStop(1, 'rgba(0, 82, 255, 0.9)');
    this.backgroundColor = gradient;
    var hoverGradient = ctx.createLinearGradient(0, 0, 0, chart.height);
    hoverGradient.addColorStop(0, 'rgba(117, 227, 255, 1)');
    hoverGradient.addColorStop(0.1, 'rgba(117, 227, 255, 1)');
    hoverGradient.addColorStop(1, 'rgba(0, 82, 255, 1)');
    this.hoverBackgroundColor = hoverGradient;
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    'chartData': {
      handler: function handler(newData, oldData) {
        if (oldData) {
          var chart = this._chart;

          var newDatasetLabels = newData.datasets.map(function (dataset) {
            return dataset.label;
          });

          var oldDatasetLabels = oldData.datasets.map(function (dataset) {
            return dataset.label;
          });

          var oldLabels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(oldDatasetLabels);
          var newLabels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newDatasetLabels);

          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
            newData.datasets.forEach(function (dataset, i) {
              var oldDatasetKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(oldData.datasets[i]);
              var newDatasetKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataset);

              var deletionKeys = oldDatasetKeys.filter(function (key) {
                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
              });

              deletionKeys.forEach(function (deletionKey) {
                delete chart.data.datasets[i][deletionKey];
              });

              for (var attribute in dataset) {
                if (dataset.hasOwnProperty(attribute)) {
                  chart.data.datasets[i][attribute] = dataset[attribute];
                }
              }
            });

            chart.data.labels = newData.labels;
            chart.update();
          } else {
            chart.destroy();
            this.renderChart(this.chartData, this.options);
          }
        }
      }
    }
  }
}));

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue___default.a);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateRange_vue__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateRange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DateRange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DateRange_vue___default.a);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_AVAILABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_END_DATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _SET_AVAILABLE_DATES$;

var SET_AVAILABLE_DATES = 'SET_AVAILABLE_DATES';
var SET_START_DATE = 'SET_START_DATE';
var SET_END_DATE = 'SET_END_DATE';

/* harmony default export */ __webpack_exports__["d"] = (_SET_AVAILABLE_DATES$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_AVAILABLE_DATES$, SET_AVAILABLE_DATES, function (state, value) {
  state.availableDates = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_AVAILABLE_DATES$, SET_START_DATE, function (state, value) {
  state.startDate = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_AVAILABLE_DATES$, SET_END_DATE, function (state, value) {
  state.endDate = value;
}), _SET_AVAILABLE_DATES$);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TargetDefinition_vue__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TargetDefinition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TargetDefinition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TargetDefinition_vue___default.a);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    attribute: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSelected: function isSelected() {
      return this.$store.getters.hasOwnProperty('isAttributeSelected') ? this.$store.getters.isAttributeSelected(this.attribute) : false;
    }
  },
  methods: {
    select: function select(attribute) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_store_actions__["q" /* SELECT_ATTRIBUTE */], attribute);
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UniverseStability_vue__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UniverseStability_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UniverseStability_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_UniverseStability_vue___default.a);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STORE_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(312);



var STORE_NAME = "date_range_workbench";

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    availableDates: [],
    startDate: null,
    endDate: null
  },
  getters: {
    startDate: function startDate(state) {
      return state.startDate;
    },
    endDate: function endDate(state) {
      return state.endDate;
    },
    isValidStartDate: function isValidStartDate(state) {
      return function (startDate) {
        return state.availableDates.filter(function (date) {
          return date.from === startDate;
        }).length > 0;
      };
    },
    dateRange: function dateRange(state) {
      return {
        availableDates: state.availableDates,
        startDate: state.startDate,
        endDate: state.endDate
      };
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* default */]
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_AVAILABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_END_DATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _SET_AVAILABLE_DATES$;

var SET_AVAILABLE_DATES = 'SET_AVAILABLE_DATES';
var SET_START_DATE = 'SET_START_DATE';
var SET_END_DATE = 'SET_END_DATE';

/* harmony default export */ __webpack_exports__["d"] = (_SET_AVAILABLE_DATES$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_AVAILABLE_DATES$, SET_AVAILABLE_DATES, function (state, value) {
  state.availableDates = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_AVAILABLE_DATES$, SET_START_DATE, function (state, value) {
  state.startDate = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_AVAILABLE_DATES$, SET_END_DATE, function (state, value) {
  state.endDate = value;
}), _SET_AVAILABLE_DATES$);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    attribute: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSelected: function isSelected() {
      var isAttributeSelected = this.$store.getters['workbench/isAttributeSelected'];
      return isAttributeSelected ? isAttributeSelected(this.attribute) : false;
    }
  },
  methods: {
    select: function select(attribute) {
      if (!this.disabled) {
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_targetDefinition_store_actions__["n" /* SELECT_ATTRIBUTE */], attribute);
      }
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TargetDefinition_vue__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TargetDefinition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TargetDefinition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });



/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__components_TargetDefinition_vue___default.a);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GRAPH_COLORS; });
var GRAPH_COLORS = {
  DARK_BLUE: 'rgba(0, 82, 231, 0.8)',
  LIGHT_BLUE: 'rgba(76, 190, 231, 1)',
  BORDER_COLOR: 'rgb(255, 99, 132)'
};



/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(727);



function state() {
  return {
    selectedDayPartNetworks: [],
    networks: [],
    groupings: [],
    userResources: [],
    isRunningResourcePoll: false,
    isGettingUserResources: false
  };
}

var getters = {
  networkGroupings: function networkGroupings(state) {
    return state.groupings;
  },
  networks: function networks(state) {
    return state.networks;
  },
  officialNetworks: function officialNetworks(state) {
    return state.networks ? state.networks.filter(function (net) {
      return net.turner || net.category.length > 0 && !net.name.includes('(');
    }) : state.networks;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CATEGORIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROLES; });


var CATEGORIES = {
  AD_SALES_ACTIONS: 101,
  MARKETING_ACTIONS: 102,
  RESEARCH_ACTIONS: 103,
  AD_SALES_MRI_DATA_SOURCES: 104,
  AD_SALES_NCS_DATA_SOURCES: 105,
  AD_SALES_AMRLD_DATA_SOURCES: 106,
  AD_SALES_XANDR_DATA_SOURCES: 107,
  AD_SALES_EPSILON_DATA_SOURCES: 108,
  MARKETING_AMRLD_DATA_SOURCES: 109,
  MARKETING_XANDR_DATA_SOURCES: 110,
  RESEARCH_XANDR_DATA_SOURCES: 111,
  AD_SALES_ALL_DATA_SOURCES: 112,
  MARKETING_ALL_DATA_SOURCES: 113,
  RESEARCH_ALL_DATA_SOURCES: 114,
  AM_AD_SALES: 115,
  AM_MARKETING: 116,
  AM_RESEARCH: 117,
  ROOT: 118,
  AD_SALES_ADSTRA_DATA_SOURCES: 119
};

var ROLES = [{ name: 'Admin', value: 1 }, { name: 'Audience Activation Profile', value: 2 }, { name: 'Sandbox Profile', value: 3 }];



/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(734);



var state = function state() {
  return {
    branches: [],
    currentBranch: null,
    currentMove: null,
    primaryBranch: null
  };
};

var getters = {
  revisionHistoryBranches: function revisionHistoryBranches(state) {
    return state.branches;
  },
  revisionHistoryCurrentBranch: function revisionHistoryCurrentBranch(state) {
    return state.currentBranch;
  },
  revisionHistoryCurrentMove: function revisionHistoryCurrentMove(state) {
    return state.currentMove;
  },
  revisionHistoryPrimaryMove: function revisionHistoryPrimaryMove(state) {
    var pb = state.primaryBranch;
    var hasPrimaryBranchHistory = pb && pb.histories;
    var hasARevision = hasPrimaryBranchHistory && pb.histories.length > 0;
    if (hasARevision) {
      return pb.histories[0];
    } else {
      return null;
    }
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasRemovedAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateTargetName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);







var getAllAttributesFromQuery = function getAllAttributesFromQuery(query) {
  var attributes = [];
  for (var i in query) {
    var current = query[i];
    if (Array.isArray(current)) {
      attributes.push.apply(attributes, getAllAttributesFromQuery(current));
    } else if ((typeof current === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(current)) === 'object') {
      attributes.push(current);
    }
  }
  return attributes;
};

var hasRemovedAttributes = function hasRemovedAttributes(query) {
  var attributes = getAllAttributesFromQuery(query);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(attributes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var at = _step.value;

      if (at['removed']) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};

var validateTargetName = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(targetName, type) {
    var validRegex;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            validRegex = new RegExp(/^[^~`'”^,@={}\\|\[\];"?!:#%]+$/);

            if (!validRegex.test(targetName)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api__["p" /* validateTargetName */])({ display_name: targetName, targetType: type }).then(function (res) {
              if (res.data.passNameLookup === true && res.data.passedPruning === true) {
                return true;
              } else if (res.data.passNameLookup === false) {
                __WEBPACK_IMPORTED_MODULE_4__components_common_toasts__["a" /* default */].error({
                  title: 'Target Name Error',
                  message: 'Duplicate Target Name: Please re-enter a unique target name and try again.',
                  timeout: 15000
                });
                return false;
              } else if (res.data.passedPruning === false) {
                __WEBPACK_IMPORTED_MODULE_4__components_common_toasts__["a" /* default */].error({
                  title: 'Target Name Error',
                  message: 'You have invalid characters in your name "' + targetName + '". Please remove them and try again.',
                  timeout: 15000
                });
                return false;
              }
            }));

          case 5:
            __WEBPACK_IMPORTED_MODULE_4__components_common_toasts__["a" /* default */].error({
              title: 'Target Name Error',
              message: 'You have invalid characters in your name "' + targetName + '". Please remove them and try again.',
              timeout: 15000
            });
            return _context.abrupt('return', false);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function validateTargetName(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();



/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validatePidFile; });
var validatePidFile = function validatePidFile(pidFile, onValidate) {
  var reader = new FileReader();
  var isValid = true;
  reader.onload = function (e) {
    var rows = e.target.result.split('\n');
    for (var r in rows) {
      if (parseInt(r) === 0) continue;
      if (rows[r] === '') {
        continue;
      }
      var household_id = rows[r].split(',')[0];
      var respondents = rows[r].split(',')[1];
      var effective_date = rows[r].split(',')[2];
      if (household_id === undefined || respondents === undefined || effective_date === undefined || isNaN(household_id) || isNaN(respondents) || isNaN(Date.parse(effective_date))) {
        isValid = false;
        break;
      }
    }
    onValidate(isValid);
  };
  reader.readAsText(pidFile);
};



/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_STATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(746);




var DEFAULT_STATE = {
  interface: null,

  requestNumber: 0,
  viewingSource: 'aalive3',
  metrics: null,
  audienceSize: null,
  hisoricalViewership: null,
  universe: null,
  selectedDayPartNetworks: [],
  selectedViewershipNetworks: ["ADSM", "HLN", "CNN", "TNT", "TRU", "TBSC", "TOON", "BOOM", "NBAT"],
  loading: false,

  validStreamingOptions: ['C3']
};

var state = function state() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE);
};

var getters = {
  viewingStream: function viewingStream(state) {
    return state.viewingSource;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_STATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);





var DEFAULT_STATE = {
  interface: undefined,
  enableUpdateInsights: false,
  enableUpdateTargetHeaderData: true,
  loadingInsights: false,
  useMockData: false,
  query: null,
  ueModalShower: 0,
  liveDigitalPromptShower: 0,
  queryErroredOut: false,
  traits: null,
  showModelingModal: 0,
  audienceExpansion: false,
  allowAudienceExpansionToggle: true,
  insightsRefreshed: false
};

var state = function state() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE);
};

var getters = {
  xandrUEModalShower: function xandrUEModalShower(state) {
    return state.ueModalShower;
  },
  xandrLiveDigitalPromptShower: function xandrLiveDigitalPromptShower(state) {
    return state.liveDigitalPromptShower;
  },
  xandrUpdateInsightsEnabled: function xandrUpdateInsightsEnabled(state) {
    return state.enableUpdateInsights;
  },
  xandrLoadingInsights: function xandrLoadingInsights(state) {
    return state.loadingInsights;
  },
  xandrUseMockData: function xandrUseMockData(state) {
    return state.useMockData;
  },
  xandrQuery: function xandrQuery(state) {
    return state.query;
  },
  xandrInterface: function xandrInterface(state) {
    return state.interface;
  },
  xandrIsLiveAndHasUnsubmittedChanges: function xandrIsLiveAndHasUnsubmittedChanges(state, getters) {
    var target = getters.newWorkbenchTarget;
    return getters.workbenchTargetIsLive && (getters.saveXandrSegmentEnabled || (target || {}).activation_date !== (target || {}).last_update);
  },
  xandrIsDigitalSocialDestination: function xandrIsDigitalSocialDestination(state, getters) {
    var destinations = (getters.newWorkbenchTarget || {}).destinations || [];
    return destinations.some(function (destination) {
      return [__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX, __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP].includes(destination);
    });
  },
  audienceExpansion: function audienceExpansion(state) {
    return state.audienceExpansion;
  },
  allowAudienceExpansionToggle: function allowAudienceExpansionToggle(state) {
    return state.allowAudienceExpansionToggle;
  },
  insightsRefreshed: function insightsRefreshed(state) {
    return state.insightsRefreshed;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_U__ = __webpack_require__(124);






var WorkbenchInterface = function () {
  function WorkbenchInterface() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WorkbenchInterface);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(WorkbenchInterface, [{
    key: 'setInterface',
    value: function setInterface(context) {
      throw Error('Not Implemented');
    }
  }, {
    key: 'getTargetAndDatasourceInformation',
    value: function getTargetAndDatasourceInformation(query) {
      var DATASET_TO_TARGET = {
        amrld: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS,
        mri: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS,
        ncs: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS,
        xandr: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT,
        adstra: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA,
        prism: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PRISM,
        dnb: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DNB,
        max: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MAX,
        byod: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].BYOD,
        tve: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].TVE,
        epsilon: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON,
        epsilon_expandable: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON_EXPANDABLE,
        'd+': __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DISCOVERY_PLUS,
        dcr: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DCR,
        videoamp: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP,
        liveramp: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LIVERAMP,
        wbgames: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].WBGAMES,
        retargeting: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].RETARGETING,
        FreeWheel: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].FREEWHEEL,
        GoogleAdManager: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].GOOGLE_AD_MANAGER,
        LAL: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAL,
        dc_comics: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DC_COMICS,
        cnn: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].CNN,
        mosaic: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MOSAIC
      };
      var DATASET_TO_TARGET_TYPE = {
        mri: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS,
        amrld: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS,
        ncs: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS,
        xandr: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].ADSTRA,
        adstra: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].ADSTRA,
        prism: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].PRISM,
        dnb: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].DNB,
        max: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].MAX,
        byod: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].BYOD,
        tve: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].TVE,
        epsilon: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].EPSILON,
        epsilon_expandable: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].EPSILON_EXPANDABLE,
        'd+': __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].DISCOVERY_PLUS,
        dcr: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].DCR,
        videoamp: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].VIDEOAMP,
        liveramp: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LIVERAMP,
        wbgames: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].WBGAMES,
        retargeting: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].RETARGETING,
        FreeWheel: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].FREEWHEEL,
        GoogleAdManager: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].GOOGLE_AD_MANAGER,
        LAL: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAL,
        dc_comics: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].DC_COMICS,
        cnn: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].CNN,
        mosaic: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].MOSAIC
      };

      var R_DATASETS = ['mri', 'ncs', 'dnb', 'max', 'byod', 'tve'];

      var datasetFamilies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_U__["a" /* getAllDatasetsRootFamilyFromQuery */])(query);
      if (datasetFamilies.length >= 1) {
        var df = datasetFamilies.find(function (ds) {
          return R_DATASETS.includes(ds);
        }) || datasetFamilies[0];
        return {
          target: DATASET_TO_TARGET[df],
          target_datasource: df,
          target_type: DATASET_TO_TARGET_TYPE[df]
        };
      } else {
        throw Error("Couldn't find target datasource from the definition");
      }
    }
  }, {
    key: 'getTarget',
    value: function getTarget(targetInfo) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["f" /* fetchSingleTarget */])({ target_id: targetInfo.id }).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: 'saveTarget',
    value: function saveTarget(targetInfo) {
      throw Error('Not Implemented');
    }
  }, {
    key: 'onTargetDefinitionChange',
    value: function onTargetDefinitionChange(targetDefinition) {
      throw Error('Not Implemented');
    }
  }, {
    key: 'getTargetDefinition',
    value: function getTargetDefinition(getters) {
      throw Error('Not Implemented');
    }
  }, {
    key: 'submitDownstream',
    value: function submitDownstream() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'queryForData',
    value: function queryForData() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'sendDownStream',
    value: function sendDownStream() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'onSetTarget',
    value: function onSetTarget() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'reset',
    value: function reset(context) {
      throw Error('Not Implemented');
    }
  }, {
    key: 'getStoreModules',
    value: function getStoreModules() {
      return [];
    }
  }, {
    key: 'getDefaultTarget',
    value: function getDefaultTarget(targetInfo) {
      return {};
    }
  }, {
    key: 'onDuplicate',
    value: function onDuplicate() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'onCreate',
    value: function onCreate() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'model',
    value: function model() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'onSetAdvertiser',
    value: function onSetAdvertiser() {
      throw Error('onSetAdvertiser not Implemented');
    }
  }]);

  return WorkbenchInterface;
}();

/* harmony default export */ __webpack_exports__["a"] = (WorkbenchInterface);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_STATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_targetDefinition__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(8);







var DEFAULT_STATE = {
  interface: null,
  attributes: null,
  slottedValue: null,
  enableSaving: null,
  enableDownstream: true,

  workbenchTarget: null,
  targetCreateAction: null,
  enableDefinitionActions: true,
  loadingWorkbench: false,
  dirty: false,
  showAUPModal: false,
  showModelingModal: 0,
  availableDestinations: [],
  selectedFamilyDataset: null,
  availableAttributes: null,
  selectedDatasets: null,
  datasetFamilies: null };

var state = function state() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE);
};

var getters = {
  selectedFamilyDataset: function selectedFamilyDataset(state) {
    return state.selectedFamilyDataset;
  },
  availableDestinations: function availableDestinations(state) {
    return state.availableDestinations;
  },
  workbenchAttributes: function workbenchAttributes(state) {
    return state.attributes;
  },
  newTargetDefinition: function newTargetDefinition(state, getters) {
    return state.interface ? state.interface.getTargetDefinition(getters) : getters.serializedDefinition;
  },
  targetCreateAction: function targetCreateAction(state) {
    return state.targetCreateAction;
  },
  newDictOfTargetAttributes: function newDictOfTargetAttributes(state, getters) {
    var td = getters.newTargetDefinition;
    return td ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_targetDefinition__["a" /* getDictOfAttributes */])(td, function (el) {
      return el.value;
    }) : null;
  },
  newWorkbenchTarget: function newWorkbenchTarget(state) {
    return state.workbenchTarget;
  },
  saveXandrSegmentEnabled: function saveXandrSegmentEnabled(state) {
    return state.enableSaving;
  },
  enableDefinitionActions: function enableDefinitionActions(state) {
    return state.enableDefinitionActions;
  },
  workbenchTargetIsLive: function workbenchTargetIsLive(state) {
    return (state.workbenchTarget || {}).activation_status === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
  },
  showAUPModal: function showAUPModal(state) {
    return false;
  },
  showModelingModal: function showModelingModal(state) {
    return state.showModelingModal;
  },
  newWorkbenchTargetIsDigital: function newWorkbenchTargetIsDigital(state) {
    var t = state.workbenchTarget;
    return t.destinations.includes(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX) || t.destinations.includes(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP);
  },
  datasetFilter: function datasetFilter(state) {
    if (state.selectedDatasets) {
      return state.selectedDatasets;
    } else {
      return [];
    }
  },

  showGenerateEstimate: function showGenerateEstimate(state, getters, rootState, rootGetters) {
    var target = state.workbenchTarget;
    if (target && target.display_name) {
      var activationBlocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["f" /* isActivationBlocked */])(target.target);
      var cantShow = target.activated || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["g" /* isTargetOwnedBy */])(target, rootGetters.username) || activationBlocked;
      return !cantShow;
    } else {
      return false;
    }
  }
};

var module = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);



/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationPoint__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationPoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NotificationPoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationsBellPoint__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationsBellPoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NotificationsBellPoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Notification__);
/* unused harmony reexport NotificationPoint */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__NotificationsBellPoint___default.a; });






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__Notification___default.a);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alertLevels; });

var alerts = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

var alertLevels = {
  computed: {
    isInfo: function isInfo() {
      return this.notification.alert_level === alerts.INFO;
    },
    isSuccess: function isSuccess() {
      return this.notification.alert_level === alerts.SUCCESS;
    },
    isWarning: function isWarning() {
      return this.notification.alert_level === alerts.WARNING;
    },
    isError: function isError() {
      return this.notification.alert_level === alerts.ERROR;
    }
  }
};



/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchInput_vue__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SearchInput_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SearchInput_vue___default.a);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Toast__ = __webpack_require__(214);






var defaultSettings = {
  position: __WEBPACK_IMPORTED_MODULE_4__Toast__["a" /* CONSTANTS */].POSITIONS.TOP_RIGHT
};

var ToastFactory = function (_Toast) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ToastFactory, _Toast);

  function ToastFactory(setupOptions) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ToastFactory);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ToastFactory.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ToastFactory)).call(this, setupOptions || defaultSettings));
  }

  return ToastFactory;
}(__WEBPACK_IMPORTED_MODULE_4__Toast__["b" /* Toast */]);

/* harmony default export */ __webpack_exports__["a"] = (new ToastFactory());

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleButton__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ToggleButton__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ToggleButton___default.a);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dataSource: Array,
    size: {
      type: Number,
      required: true
    },
    isPinned: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100%'
    },
    remain: {
      type: Number,
      required: true
    },
    rtag: {
      type: String,
      default: 'div'
    },
    wtag: {
      type: String,
      default: 'div'
    },
    onScroll: Function
  },

  delta: {
    start: 0,
    end: 0,
    total: 0,
    keeps: 0,
    viewHeight: 0,
    allPadding: 0,
    paddingTop: 0 },
  methods: {
    scrollToIndex: function scrollToIndex(index) {
      var scrollTop = Math.min(index, this.$slots.default.length - 1) * this.size;
      this.scrollTo(scrollTop);
    },
    scrollTo: function scrollTo(scrollTop) {
      this.$refs.container.scrollTop = scrollTop;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.container.scrollTop;
    },

    handleScroll: function handleScroll(e) {
      var scrollTop = this.$refs.container.scrollTop;

      this.updateZone(scrollTop);

      if (this.onScroll) {
        this.onScroll(e, scrollTop);
      }
    },
    updateZone: function updateZone(offset) {
      var delta = this.$options.delta;
      var overs = Math.floor(offset / this.size);

      if (offset === 0 && delta.total) {
        this.$emit('reached-top');
      }

      var start = overs;
      var end = overs ? overs + delta.keeps : delta.keeps;
      var isOverflow = delta.total - delta.keeps > 0;

      if (isOverflow && overs + delta.keeps >= delta.total) {
        end = delta.total;
        start = delta.total - delta.keeps;
        this.$emit('reached-bottom');
      }

      delta.end = end;
      delta.start = start;

      this.$forceUpdate();
    },
    filter: function filter(slots) {
      var delta = this.$options.delta;

      if (!slots) {
        slots = [];
        delta.start = 0;
      }

      delta.total = slots.length;
      delta.paddingTop = this.size * delta.start;
      delta.allPadding = Math.max(0, this.size * (slots.length - delta.keeps));
      return slots.filter(function (slot, index) {
        return index >= delta.start && index <= delta.end;
      });
    }
  },
  watch: {
    dataSource: function dataSource() {
      this.updateZone(0);
    }
  },
  mounted: function mounted() {
    var delta = this.$options.delta;
    delta.viewHeight = this.$refs.container.clientHeight;
    delta.start = 0;
    delta.end = Math.round(delta.viewHeight / this.size) + this.remain;
    delta.keeps = delta.end;

    this.$forceUpdate();
  },
  render: function render(createElement) {
    var showList = this.filter(this.$slots.default);
    var delta = this.$options.delta;
    var style = {
      'display': 'block',
      'overflow-y': 'auto',
      'height': this.height
    };
    if (this.isPinned) {
      style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
        'position': 'absolute',
        'top': '0',
        'right': '0',
        'bottom': '0',
        'left': '0',
        'height': 'auto'
      });
    }
    return createElement(this.rtag, {
      'ref': 'container',
      'class': 'scroll-panel',
      style: style,
      'on': {
        'scroll': this.handleScroll
      }
    }, [createElement(this.wtag, {
      'style': {
        'display': 'block',
        'padding-top': delta.paddingTop + 'px',
        'padding-bottom': delta.allPadding - delta.paddingTop + 'px'
      }
    }, showList)]);
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tableMap; });
var tableMap = {
  'linear_ad_sales': 'las-workbench',
  'social_digital': 'sm-workbench',
  'audience_discovery': 'ad-workbench'
};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var ROLES = {
  ADMIN: 1,
  AUDIENCE_ACTIVATION: 2
};

var Roles = function () {
  function Roles(roles) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Roles);

    this.roles = {};
    if (roles) {
      this.setRoles(roles);
    }
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Roles, [{
    key: "setRoles",
    value: function setRoles(roles) {
      this.roles = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(roles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;

          this.roles[r] = true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "hasAdminRole",
    value: function hasAdminRole() {
      return this.roles[ROLES.ADMIN];
    }
  }, {
    key: "hasAudienceActivationProfile",
    value: function hasAudienceActivationProfile() {
      return this.roles[ROLES.AUDIENCE_ACTIVATION];
    }
  }]);

  return Roles;
}();

/* harmony default export */ __webpack_exports__["a"] = (Roles);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_INDEX_OBJECT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_js__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Roles__ = __webpack_require__(332);






var DEFAULT_INDEX_OBJECT = {
  oidcAuth: null,
  username: null,
  token: null,
  error: null,
  loading: false,
  refreshToken: null,
  expires: null,
  loggingOut: false,
  userPermissions: [],
  roles: new __WEBPACK_IMPORTED_MODULE_4__Roles__["a" /* default */]()
};

function state() {
  var cookie = __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('auth');
  var credentials = {};
  if (cookie) {
    credentials = JSON.parse(cookie);

    adobeAnalytics.login(credentials.username);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_INDEX_OBJECT, credentials);
}

var getters = {
  username: function username(state) {
    return state.username ? state.username.toLowerCase() : state.username;
  },
  userPermissions: function userPermissions(state) {
    return state.userPermissions;
  },

  userRoles: function userRoles(state) {
    return state.roles;
  },
  hasPublishPermissions: function hasPublishPermissions(state, rootState) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.some(function (p) {
      return [PERMISSIONS.ADSTRA_PUBLISH, PERMISSIONS.AMRLD_PUBLISH, PERMISSIONS.BYOD_PUBLISH, PERMISSIONS.COMSCORE_PUBLISH, PERMISSIONS.COMSCORE_TV_PUBLISH, PERMISSIONS.DNB_PUBLISH, PERMISSIONS.MAX_PUBLISH, PERMISSIONS.MRI_PUBLISH, PERMISSIONS.NCS_PUBLISH, PERMISSIONS.NPOWER_PUBLISH, PERMISSIONS.PID_PUBLISH, PERMISSIONS.PRISM_PUBLISH, PERMISSIONS.VIDEOAMP_PUBLISH, PERMISSIONS.TVE_PUBLISH, PERMISSIONS.EPSILON_PUBLISH, PERMISSIONS.EPSILON_EXPANDABLE_PUBLISH, PERMISSIONS.DISCOVERY_PLUS_PUBLISH, PERMISSIONS.DCR_PUBLISH, PERMISSIONS.LIVERAMP_PUBLISH, PERMISSIONS.WBGAMES_PUBLISH, PERMISSIONS.RETARGETING_PUBLISH, PERMISSIONS.FREEWHEEL_PUBLISH, PERMISSIONS.GOOGLE_AD_MANAGER_PUBLISH, PERMISSIONS.LAL_PUBLISH, PERMISSIONS.DC_COMICS_PUBLISH, PERMISSIONS.CNN_PUBLISH, PERMISSIONS.MOSAIC_PUBLISH].includes(p);
    });
  },
  hasArchivePermissions: function hasArchivePermissions(state, rootState) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.some(function (p) {
      return [PERMISSIONS.ADSTRA_ARCHIVE, PERMISSIONS.AMRLD_ARCHIVE, PERMISSIONS.BYOD_ARCHIVE, PERMISSIONS.COMSCORE_ARCHIVE, PERMISSIONS.COMSCORE_TV_ARCHIVE, PERMISSIONS.DNB_ARCHIVE, PERMISSIONS.MAX_ARCHIVE, PERMISSIONS.MRI_ARCHIVE, PERMISSIONS.NCS_ARCHIVE, PERMISSIONS.NPOWER_ARCHIVE, PERMISSIONS.PID_ARCHIVE, PERMISSIONS.PRISM_ARCHIVE, PERMISSIONS.VIDEOAMP_ARCHIVE, PERMISSIONS.TVE_ARCHIVE, PERMISSIONS.EPSILON_ARCHIVE, PERMISSIONS.EPSILON_EXPANDABLE_ARCHIVE, PERMISSIONS.DISCOVERY_PLUS_ARCHIVE, PERMISSIONS.DCR_ARCHIVE, PERMISSIONS.LIVERAMP_ARCHIVE, PERMISSIONS.WBGAMES_ARCHIVE, PERMISSIONS.RETARGETING_ARCHIVE, PERMISSIONS.FREEWHEEL_ARCHIVE, PERMISSIONS.GOOGLE_AD_MANAGER_ARCHIVE, PERMISSIONS.LAL_ARCHIVE, PERMISSIONS.DC_COMICS_ARCHIVE, PERMISSIONS.CNN_ARCHIVE, PERMISSIONS.MOSAIC_ARCHIVE].includes(p);
    });
  },
  hasCreateEditPermissions: function hasCreateEditPermissions(state, rootState, rootGetters) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.some(function (p) {
      return [PERMISSIONS.ADSTRA_CREATE_EDIT, PERMISSIONS.AMRLD_CREATE_EDIT, PERMISSIONS.BYOD_CREATE_EDIT, PERMISSIONS.COMSCORE_CREATE_EDIT, PERMISSIONS.COMSCORE_TV_CREATE_EDIT, PERMISSIONS.DNB_CREATE_EDIT, PERMISSIONS.MAX_CREATE_EDIT, PERMISSIONS.MRI_CREATE_EDIT, PERMISSIONS.NCS_CREATE_EDIT, PERMISSIONS.NPOWER_CREATE_EDIT, PERMISSIONS.PID_CREATE_EDIT, PERMISSIONS.PRISM_CREATE_EDIT, PERMISSIONS.VIDEOAMP_CREATE_EDIT, PERMISSIONS.TVE_CREATE_EDIT, PERMISSIONS.EPSILON_CREATE_EDIT, PERMISSIONS.EPSILON_EXPANDABLE_CREATE_EDIT, PERMISSIONS.DISCOVERY_PLUS_CREATE_EDIT, PERMISSIONS.DCR_CREATE_EDIT, PERMISSIONS.LIVERAMP_CREATE_EDIT, PERMISSIONS.WBGAMES_CREATE_EDIT, PERMISSIONS.RETARGETING_CREATE_EDIT, PERMISSIONS.FREEWHEEL_CREATE_EDIT, PERMISSIONS.GOOGLE_AD_MANAGER_CREATE_EDIT, PERMISSIONS.LAL_CREATE_EDIT, PERMISSIONS.DC_COMICS_CREATE_EDIT, PERMISSIONS.CNN_CREATE_EDIT, PERMISSIONS.MOSAIC_CREATE_EDIT].includes(p);
    });
  },
  hasViewPermissions: function hasViewPermissions(state, rootState) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.some(function (p) {
      return [PERMISSIONS.ADSTRA_VIEW, PERMISSIONS.AMRLD_VIEW, PERMISSIONS.BYOD_VIEW, PERMISSIONS.COMSCORE_VIEW, PERMISSIONS.COMSCORE_TV_VIEW, PERMISSIONS.DNB_VIEW, PERMISSIONS.MAX_VIEW, PERMISSIONS.MRI_VIEW, PERMISSIONS.NCS_VIEW, PERMISSIONS.NPOWER_VIEW, PERMISSIONS.PID_VIEW, PERMISSIONS.PRISM_VIEW, PERMISSIONS.VIDEOAMP_VIEW, PERMISSIONS.TVE_VIEW, PERMISSIONS.EPSILON_VIEW, PERMISSIONS.EPSILON_EXPANDABLE_VIEW, PERMISSIONS.DISCOVERY_PLUS_VIEW, PERMISSIONS.DCR_VIEW, PERMISSIONS.LIVERAMP_VIEW, PERMISSIONS.WBGAMES_VIEW, PERMISSIONS.RETARGETING_VIEW, PERMISSIONS.FREEWHEEL_VIEW, PERMISSIONS.GOOGLE_AD_MANAGER_VIEW, PERMISSIONS.LAL_VIEW, PERMISSIONS.DC_COMICS_VIEW, PERMISSIONS.CNN_VIEW, PERMISSIONS.MOSAIC_VIEW].includes(p);
    });
  },
  hasAdminPagePermission: function hasAdminPagePermission(state, rootState) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.includes(PERMISSIONS.ADMIN_VIEW);
  },
  hasAdminEditUserPermission: function hasAdminEditUserPermission(state, rootState) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.includes(PERMISSIONS.ADMIN_CREATE_EDIT_USERS);
  },
  hasAdminEditRolesPermission: function hasAdminEditRolesPermission(state, rootState) {
    var PERMISSIONS = rootState.appPermissions || {};
    return state.userPermissions.includes(PERMISSIONS.ADMIN_CREATE_EDIT_ROLES);
  }
};

var module = {
  state: state,
  getters: getters,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations_js__ = __webpack_require__(781);






var state = {
  targets: [],
  displayOptions: {
    sortBy: 'created',
    sortDir: -1
  },
  loading: false,
  openAPTargets: [],
  ignoredOpenAPTargets: [],
  activatedFailed: false,
  targetSearch: '',
  assignedOpenAP: [],
  showOpenAPImportModal: false,
  showOpenAPAssignModal: false,
  previousFilter: {},
  refreshTable: false,
  columnFilters: {},
  pendingRequests: {}
};

var getters = {
  nonIgnoredTargets: function nonIgnoredTargets(state) {
    if (state.ignoredOpenAPTargets.length > 0) {
      var dict = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.openAPTargets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var t = _step.value;

          dict[t.segment_id] = t;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.ignoredOpenAPTargets), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var sID = _step2.value;

          if (dict[sID]) {
            delete dict[sID];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(dict);
    } else {
      return state.openAPTargets;
    }
  },
  targetDefinition: function targetDefinition(state, getters) {
    return getters.currentTarget ? getters.currentTarget.target_definition : {};
  },
  targetAdvertisers: function targetAdvertisers(state) {
    var s = {};
    var targets = state.targets;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t.advertiser) {
        if (t.advertiser.Advertiser_id) {
          s[t.advertiser.Advertiser_id] = t.advertiser;
        }
      }
    }
    var values = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(s);
    values.sort(function (a, b) {
      var nameA = a.Name.toUpperCase();
      var nameB = b.Name.toUpperCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    return values;
  },
  refreshTable: function refreshTable(state) {
    return state.refreshTable;
  },
  columnFilters: function columnFilters(state) {
    if (state.columnFilters && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.columnFilters).length > 0) {
      return state.columnFilters;
    } else {
      return JSON.parse(localStorage.getItem('DASHBOARD_COLUMN_FILTER_VALUES'));
    }
  }
};

var module = {
  state: state,
  getters: getters,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions_js__["b" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DAY_PARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_AUDIENCE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_HISTORICAL_VIEWERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_UNIVERSE; });
/* unused harmony export SET_PREVIEW_TABLE_OPEN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _SET_DAY_PARTS$SET_DA;

var SET_DAY_PARTS = 'SET_DAY_PARTS';
var SET_DATA_SOURCES = 'SET_DATA_SOURCES';
var SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE';
var SET_HISTORICAL_VIEWERSHIP = 'SET_HISTORICAL_VIEWERSHIP';
var SET_UNIVERSE = 'SET_UNIVERSE';
var SET_PREVIEW_TABLE_OPEN = 'SET_PREVIEW_TABLE_OPEN';

/* harmony default export */ __webpack_exports__["a"] = (_SET_DAY_PARTS$SET_DA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_DAY_PARTS$SET_DA, SET_DAY_PARTS, function (state, value) {
  state.dayParts = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_DAY_PARTS$SET_DA, SET_DATA_SOURCES, function (state, value) {
  state.dataSources = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_DAY_PARTS$SET_DA, SET_AUDIENCE_SIZE, function (state, value) {
  state.audienceSize = value || 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_DAY_PARTS$SET_DA, SET_UNIVERSE, function (state, value) {
  state.universe = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_DAY_PARTS$SET_DA, SET_HISTORICAL_VIEWERSHIP, function (state, value) {
  state.historicalViewership = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_DAY_PARTS$SET_DA, SET_PREVIEW_TABLE_OPEN, function (state, bool) {
  state.previewTableOpen = bool;
}), _SET_DAY_PARTS$SET_DA);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_AUDIENCE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_TOP_TSP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TOP_SOCIAL_AFFINITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_REACH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _SET_TOP_TSP$SET_TOP_;

var SET_DATA_SOURCES = 'SET_DATA_SOURCES';
var SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE';
var SET_TOP_TSP = 'SET_TOP_TSP';
var SET_TOP_SOCIAL_AFFINITY = 'SET_TOP_SOCIAL_AFFINITY';
var SET_REACH = 'SET_REACH';

/* harmony default export */ __webpack_exports__["a"] = (_SET_TOP_TSP$SET_TOP_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TOP_TSP$SET_TOP_, SET_TOP_TSP, function (state, value) {
  state.canvas.topTsp = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TOP_TSP$SET_TOP_, SET_TOP_SOCIAL_AFFINITY, function (state, value) {
  state.canvas.topSocialAffinity = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TOP_TSP$SET_TOP_, SET_REACH, function (state, value) {
  state.canvas.reach = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TOP_TSP$SET_TOP_, SET_DATA_SOURCES, function (state, value) {
  state.dataSources = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_TOP_TSP$SET_TOP_, SET_AUDIENCE_SIZE, function (state, value) {
  state.canvas.audienceSize = value || 0;
}), _SET_TOP_TSP$SET_TOP_);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_auth_constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_route_store_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);









var commonMixins = {
  computed: {
    username: function username() {
      return this.$store.getters.username;
    },
    currentTarget: function currentTarget() {
      return this.$store.getters.currentTarget;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    toolbarMetrics: function toolbarMetrics() {
      return this.$store.getters.metrics;
    },
    targetName: function targetName() {
      return this.$store.getters.targetName;
    },
    activated: function activated() {
      return this.$store.getters.isTargetActivated;
    },
    activateLabel: function activateLabel() {
      return this.currentTarget && this.currentTarget.target === __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD ? 'Activate' : 'Generate Estimate';
    },
    dynamicHeaderMenu: function dynamicHeaderMenu() {
      var headerMenu = this.headerMenu;
      if (this.headerMenu.length === 0) {
        headerMenu = [];
      } else if (this.currentTarget.activated || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["g" /* isTargetOwnedBy */])(this.currentTarget, this.username)) {
        headerMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["o" /* filterTargetOptions */])(headerMenu, [this.activateLabel, 'Edit']);
      } else if (this.currentTarget.activation_status === 'ACTIVATED') {
        headerMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["o" /* filterTargetOptions */])(headerMenu, ['Edit']);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["f" /* isActivationBlocked */])(this.currentTarget.target)) {
        headerMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["o" /* filterTargetOptions */])(headerMenu, [this.activateLabel]);
      }
      if (!this.hasPermissionToGenerateEstimate()) {
        headerMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["o" /* filterTargetOptions */])(headerMenu, [this.activateLabel]);
      }
      return headerMenu;
    },
    headerMenu: function headerMenu() {
      var targetType = this.currentTarget && this.currentTarget.target;
      var targetId = this.currentTarget && this.currentTarget.id;
      var currentUsername = this.username;
      var target = this.currentTarget;

      return targetId && targetType && currentUsername ? [{
        name: 'My Targets',
        value: {
          action: function action() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__appLogic_route_store_actions__["d" /* ROUTE_BACK */]);
          }
        }
      }, {
        name: 'Edit',
        value: {
          action: function action() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* targetRouteHandler */])('SETTINGS', target);
          }
        }
      }, {
        name: targetType === __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD ? 'Activate' : 'Generate Estimate',
        value: {
          action: function action() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* targetRouteHandler */])('ACTIVATE', target);
          }
        }
      }, {
        name: 'Duplicate',
        value: {
          action: function action() {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* targetRouteHandler */])('DUPLICATE', target);
          }
        }
      }, {
        name: 'History',
        value: {
          action: function action() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["a" /* SHOW_TARGET_HISTORY_PANEL */], true);
          }
        }
      }, {
        name: 'Sign Out',
        value: {
          action: function action() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_2__store_modules_auth_constants__["e" /* SIGN_OUT */]);
            this.$auth.signOut();
          }
        }
      }] : [];
    }
  },
  methods: {
    hasPermissionToGenerateEstimate: function hasPermissionToGenerateEstimate() {
      return true;
    },
    initWorkbenchForTarget: function initWorkbenchForTarget(id) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["b" /* INIT_WORKBENCH_FOR_TARGET */], id);
    }
  },
  created: function created() {
    var _this = this;

    this.initWorkbenchForTarget(this.$route.params.id);

    window.onbeforeunload = function (e) {
      if (_this.$store.getters.isSaveEnabled) {
        return 'Are you sure?';
      }
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.fetchTargetData(to.params.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!this.$store.getters.targetDefinitionHasChanged) {
      if (this.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api__["j" /* deleteTarget */])(this.currentTarget).then(function (response) {
          console.log(response);
        }).catch(function (reason) {
          console.log(reason);
        });
      }

      next();
      return;
    }
    this.$refs.confirmModal.open(next);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4_css_element_queries__["ResizeSensor"].detach(this.canvasEl);
  },
  destroyed: function destroyed() {
    document.querySelector('html').classList.remove('workbench-resize');
    window.onbeforeunload = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (commonMixins);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_targetDefinition__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_networks_store__ = __webpack_require__(316);








var WorkbenchWCanvasBaseStore = function () {
  function WorkbenchWCanvasBaseStore(namespace) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WorkbenchWCanvasBaseStore);

    this.namespace = namespace;
    this.state = __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].state;
    this.getters = __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].getters;
    this.mutations = __WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */].mutations;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WorkbenchWCanvasBaseStore, [{
    key: 'additionalState',
    value: function additionalState() {
      throw new Error('Please override this and return an object with the additional state for your new workbench');
    }
  }, {
    key: 'additionalGetters',
    value: function additionalGetters() {
      throw new Error('Please override this and return an object with the additional getters for your new workbench');
    }
  }, {
    key: 'additionalMutations',
    value: function additionalMutations() {
      throw new Error('Please override this and return an object with the additional mutations for your new workbench');
    }
  }, {
    key: 'createActions',
    value: function createActions() {
      var baseActions = new __WEBPACK_IMPORTED_MODULE_4__WorkbenchWCanvasSlotActionsGenerator__["m" /* default */]();
      return baseActions.generateActions();
    }
  }, {
    key: 'additionalModules',
    value: function additionalModules() {
      return false;
    }
  }, {
    key: 'createModules',
    value: function createModules() {
      if (!this.namespace) {
        throw new Error('WorkbenchWCanvasBaseStore target definition module needs a namespace ex: "las", "sm"');
      }
      var targetDefinition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_targetDefinition__["b" /* createModule */])(this.namespace);
      var modules = {
        targetDefinition: targetDefinition,
        networks: __WEBPACK_IMPORTED_MODULE_6__appLogic_networks_store__["a" /* default */]
      };
      var additional = this.additionalModules();
      if (additional) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, modules, additional);
      }
      return modules;
    }
  }, {
    key: 'create',
    value: function create() {
      var base = this;
      return {
        state: function state() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, base.state, base.additionalState());
        },

        getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getters, this.additionalGetters()),
        mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.mutations, this.additionalMutations()),
        actions: this.createActions(),
        modules: this.createModules()
      };
    }
  }]);

  return WorkbenchWCanvasBaseStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (WorkbenchWCanvasBaseStore);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_conversions__ = __webpack_require__(71);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    metrics: null,
    quickAddAttributes: [],
    fetchingTarget: false,
    fetchingWorkbenchData: false,
    loading: false,
    saving: false,
    dirty: false,
    isDropped: false,
    streamingOption: 'aalivesd',
    lastTimeSaved: null,
    showTargetHistoryPanel: false,
    requestNumber: 0
  },
  getters: {
    streamingOption: function streamingOption(state, getters) {
      if (getters.currentTarget.viewing_stream) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_conversions__["a" /* convertViewingStreamForES */])(getters.currentTarget.viewing_stream);
      } else {
        return state.streamingOption ? state.streamingOption : 'aalivesd';
      }
    },
    metrics: function metrics(state) {
      return state.metrics;
    },
    loading: function loading(state) {
      return state.loading;
    },
    targetName: function targetName(state, getters) {
      return getters.currentTarget.display_name;
    },
    quickAddAttributes: function quickAddAttributes(state, getters) {
      return state.quickAddAttributes.map(getters.getAttributeForIdDataset);
    },
    isSaveEnabled: function isSaveEnabled(state) {
      return state.dirty && !state.loading;
    },
    isSaving: function isSaving(state) {
      return state.saving;
    },
    isFetchingTarget: function isFetchingTarget(state) {
      return state.fetchingTarget;
    },
    isFetchingWorkbenchData: function isFetchingWorkbenchData(state) {
      return state.fetchingWorkbenchData;
    },

    isTargetActivated: function isTargetActivated(state, getters) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(getters.currentTarget)) return false;
      return getters.currentTarget.activated;
    },
    isTargetArchived: function isTargetArchived(state, getters) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(getters.currentTarget)) return false;
      return getters.currentTarget.archived;
    },

    targetDefinitionHasChanged: function targetDefinitionHasChanged(state, getters) {
      var lastChange = getters.lastTimeTargetWasChanged;
      var lastSaved = state.lastTimeSaved;
      if (lastChange) {
        return lastSaved ? lastChange > lastSaved : true;
      } else {
        return false;
      }
    },
    targetInfo: function targetInfo(state, getters) {
      var t = getters.currentTarget;
      return {
        name: t.display_name,
        id: t.id,
        type: t.target
      };
    },
    startQ: function startQ(state) {
      return state.dateRange ? state.dateRange.startDate ? state.dateRange.startDate.name : '' : '';
    },
    endQ: function endQ(state) {
      return state.dateRange ? state.dateRange.endDate ? state.dateRange.endDate.name : '' : '';
    },
    getAttributeForIdDataset: function getAttributeForIdDataset(state) {
      return function (_ref) {
        var id = _ref.id,
            dataset = _ref.dataset;

        var dataSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["find"])(state.dataSources, { data: { id: dataset } });
        function findRecursive(dataSource) {
          for (var i = 0; i < dataSource.length; i++) {
            if (dataSource[i].id === id) return dataSource[i];
            if (dataSource[i].children) {
              var found = findRecursive(dataSource[i].children);
              if (found) return found;
            }
          }

          return false;
        }

        return findRecursive(dataSource.data.children);
      };
    },
    universeData: function universeData(state) {
      return state.universe;
    },
    viewershipData: function viewershipData(state) {
      return state.historicalViewership;
    },
    showGenerateEstimate: function showGenerateEstimate(state, getters) {
      var target = getters.currentTarget;
      if (target.display_name) {
        var activationBlocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* isActivationBlocked */])(target.target);
        var cantShow = target.activated || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["g" /* isTargetOwnedBy */])(target, getters.username) || activationBlocked;
        return !cantShow;
      } else {
        return false;
      }
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["l" /* default */]
});

/***/ }),
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "arrows",
  "use": "arrows-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrows\"><title>Group 2</title><path d=\"M14.12 16.31a1.07 1.07 0 0 0-1.513 0l-1.036 1.036v-3.31a1.07 1.07 0 1 0-2.141 0v3.311L8.393 16.31a1.07 1.07 0 1 0-1.513 1.514l2.863 2.862c.05.05.104.095.163.134.013.008.028.014.041.023.046.027.093.054.143.075.02.008.04.012.061.02.045.015.09.032.139.041a1.015 1.015 0 0 0 .422 0c.049-.01.095-.026.14-.042.02-.008.041-.011.06-.02.051-.02.098-.048.145-.076.013-.008.026-.013.039-.022.059-.04.113-.083.163-.133l2.863-2.863a1.07 1.07 0 0 0-.002-1.513zM8.392 4.691L9.43 3.654v3.313a1.07 1.07 0 1 0 2.14 0V3.654l1.037 1.037a1.067 1.067 0 0 0 1.514 0 1.07 1.07 0 0 0 0-1.513L11.257.315a1.008 1.008 0 0 0-.162-.133c-.013-.009-.027-.014-.04-.022a1.141 1.141 0 0 0-.144-.077c-.02-.008-.04-.012-.06-.019-.046-.015-.091-.033-.14-.042a1.013 1.013 0 0 0-.423 0c-.048.01-.093.026-.138.042-.02.007-.042.01-.062.02-.05.02-.097.047-.142.074-.014.009-.028.014-.042.023a1.082 1.082 0 0 0-.162.134L6.878 3.177a1.07 1.07 0 1 0 1.514 1.514zM17.346 9.435h-3.312a1.07 1.07 0 1 0 0 2.141h3.312l-1.037 1.037a1.07 1.07 0 1 0 1.514 1.513l2.863-2.864c.1-.099.18-.218.233-.35.003-.006.003-.011.005-.016.048-.121.076-.253.076-.39 0-.138-.028-.27-.076-.39-.002-.005-.002-.012-.005-.017a1.076 1.076 0 0 0-.233-.35l-2.863-2.863a1.07 1.07 0 1 0-1.513 1.513l1.036 1.036zM3.654 11.576h3.311a1.07 1.07 0 1 0 0-2.14h-3.31L4.69 8.398a1.07 1.07 0 1 0-1.513-1.514L.314 9.748c-.1.1-.18.219-.233.35-.003.006-.003.012-.005.017a1.071 1.071 0 0 0-.076.39c0 .138.029.268.076.39.002.005.002.01.005.015.054.133.134.252.233.351l2.863 2.864c.21.21.483.313.757.313s.548-.104.757-.313a1.07 1.07 0 0 0 0-1.513l-1.037-1.036z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "audience",
  "use": "audience-usage",
  "viewBox": "0 0 56 33",
  "content": "<symbol viewBox=\"0 0 56 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"audience\"><path d=\"M51.656 17.855c4.315 1.278 3.576 4.436 3.563 6.554H44.452c-.387-1.282-1.343-2.479-3.627-3.151l-.722-.218c-3.022-.887-4.64-1.365-5.063-2.326-.103-.346-.072-.73.935-1.1 3.239-.95 4.88-1.447 5.267-2.67h.204a1.662 1.662 0 0 1-.16-.156c-1.6-1.556-2.821-4.592-2.821-7.043C38.465 4.278 41.096 2 43.586 2c2.49 0 4.994 2.46 4.994 5.932 0 2.452-1.36 5.392-3.03 6.896.344 1.415 2.222 1.878 6.106 3.027\" /><path d=\"M44.625 32.052H11.178c-.02-.337-.041-.675-.082-1.073-.103-1.333-.206-2.704.164-3.958.452-1.47 1.623-2.763 4.334-3.56l1.048-.337c4.766-1.372 7.314-2.147 8.156-3.957l.268-.456-.02-.577a.752.752 0 0 1-.185-.18 10.044 10.044 0 0 1-.843-.952c-1.849-2.368-3.164-6.026-3.164-9.047C20.854 4.095 23.69 0 27.921 0c3.308 0 6.863 3.301 6.863 8.232 0 3.143-1.623 7.038-3.842 9.326-.144.16-.308.297-.451.438l-.267.239.082.359c.575 2.265 3.163 3.04 8.36 4.532l1.069.338c2.692.796 3.965 2.109 4.52 3.559h.02c.515 1.411.452 2.944.39 4.375-.02.216-.02.455-.04.654\" /><path d=\"M3.619 17.855C-.701 19.133.045 22.291.056 24.41h10.762c.39-1.282 1.343-2.479 3.632-3.151l.72-.218c3.024-.887 4.643-1.365 5.063-2.326-.115-.381.094-.953-.938-1.1-3.236-.95-4.877-1.447-5.263-2.67h-.203c.055-.049.11-.097.159-.156 1.6-1.556 2.823-4.592 2.823-7.043C16.81 4.278 14.18 2 11.689 2 9.197 2 6.695 4.46 6.695 7.932c0 2.452 1.354 5.392 3.025 6.896-.343 1.415-2.223 1.878-6.101 3.027\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "count-group",
  "use": "count-group-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"count-group\"><title>count group</title><defs><path d=\"M12 12v6H0V6h6V0h12v12h-6z\" id=\"count-group_a\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"matrix(1 0 0 -1 0 18)\"><mask id=\"count-group_b\" fill=\"#fff\"><use xlink:href=\"#count-group_a\" /></mask><use fill=\"#FFF\" xlink:href=\"#count-group_a\" /><g mask=\"url(#count-group_b)\" fill=\"#FFF\"><path d=\"M-11-11h40v40h-40z\" /></g></g><text font-family=\"TamilMN-Bold, Tamil MN\" font-size=\"14\" font-weight=\"bold\" fill=\"#000\" transform=\"translate(0 -2)\"><tspan x=\"2\" y=\"12\">#</tspan></text></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "group",
  "use": "group-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"group\"><path d=\"M12 12h6V0H6v6H0v12h12v-6z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "home-outline",
  "use": "home-outline-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home-outline\"><path d=\"M10.5 15.5v-3.089l-.031-.084a3.565 3.565 0 0 0-.554-.957c-.532-.669-1.176-1.008-1.915-1.008-.739 0-1.383.339-1.915 1.008a3.58 3.58 0 0 0-.554.956l-.031.085V15.5h-5V6.25L8 .625l7.5 5.625v9.25h-5z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "left-bracket",
  "use": "left-bracket-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-bracket\"><path d=\"M19 0H9.994C4.477 0 0 4.477 0 10v10c0 5.525 4.474 10 9.994 10H19c-5.354-2.863-8.996-8.505-8.996-15 0-6.494 3.642-12.137 8.996-15z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "left-parenthesis",
  "use": "left-parenthesis-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-parenthesis\"><path d=\"M19 0h-3.994C6.716 0 0 6.716 0 15c0 8.286 6.719 15 15.006 15H19c-5.354-2.863-8.996-8.505-8.996-15 0-6.494 3.642-12.137 8.996-15z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "remove-count-group",
  "use": "remove-count-group-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"remove-count-group\"><title>un-count group</title><defs><path id=\"remove-count-group_a\" d=\"M6 6h12v12H6z\" /><path id=\"remove-count-group_b\" d=\"M0 0h12v12H0z\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><g><use fill-opacity=\"0\" fill=\"#FFF\" xlink:href=\"#remove-count-group_a\" /><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M7 7h10v10H7z\" /></g><g><use fill=\"#FFF\" xlink:href=\"#remove-count-group_b\" /><path stroke=\"#FFF\" d=\"M.5.5h11v11H.5z\" /></g><text font-family=\"TamilMN-Bold, Tamil MN\" font-size=\"14\" font-weight=\"bold\" fill=\"#000\" transform=\"translate(0 -2)\"><tspan x=\"2\" y=\"12\">#</tspan></text></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "right-bracket",
  "use": "right-bracket-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right-bracket\"><path d=\"M0 30h9.006C14.526 30 19 25.525 19 20V10c0-5.523-4.477-10-9.994-10H0c5.354 2.863 8.996 8.506 8.996 15 0 6.495-3.642 12.137-8.996 15z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "right-parenthesis",
  "use": "right-parenthesis-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right-parenthesis\"><path d=\"M0 30h3.994C12.28 30 19 23.286 19 15 19 6.716 12.283 0 3.994 0H0c5.354 2.863 8.996 8.506 8.996 15 0 6.495-3.642 12.137-8.996 15z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"trash\"><path d=\"M1.317 18H13.61V3.512H1.317V18zm4.17-18l-.466 1.317H0v1.317h14.927V1.317H9.87L9.44 0H5.488z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "ungroup",
  "use": "ungroup-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ungroup\"><path d=\"M6 6V0h12v12h-6v6H0V6h6zm0 2H2v8h8v-4H6V8z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" id=\"upload\"><defs><linearGradient id=\"upload_b\" gradientUnits=\"userSpaceOnUse\" x1=\"50\" y1=\"98\" x2=\"50\" y2=\"2\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\".1\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".5\" /></linearGradient><linearGradient id=\"upload_c\" gradientUnits=\"userSpaceOnUse\" x1=\"50\" y1=\"70\" x2=\"50\" y2=\"6\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\"0\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".4\" /></linearGradient><linearGradient id=\"upload_e\" gradientUnits=\"userSpaceOnUse\" x1=\"37\" y1=\"24\" x2=\"92\" y2=\"57\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\"0\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".4\" /></linearGradient><linearGradient id=\"upload_d\" gradientUnits=\"userSpaceOnUse\" x1=\"63\" y1=\"57\" x2=\"8\" y2=\"24\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\"0\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".4\" /></linearGradient><path fill=\"url(#upload_a)\" d=\"M96.1 30.55q-3.85-8.95-10.75-15.9-6.9-6.9-15.85-10.7Q60.2 0 50.05 0q-10.2 0-19.5 3.95-9 3.8-15.9 10.7-6.9 6.95-10.7 15.9Q0 39.85 0 50.05 0 60.2 3.95 69.5q3.8 8.95 10.7 15.85 6.9 6.9 15.9 10.75 9.3 3.9 19.5 3.9 10.15 0 19.45-3.9 8.95-3.85 15.85-10.75T96.1 69.5q3.9-9.3 3.9-19.45 0-10.2-3.9-19.5z\" id=\"upload_f\" /><path fill=\"url(#upload_b)\" d=\"M94.1 31.45q-3.65-8.6-10.25-15.25Q77.2 9.6 68.65 6q-8.9-3.8-18.6-3.8Q40.3 2.2 31.4 6q-8.6 3.6-15.2 10.2-6.6 6.65-10.25 15.25Q2.2 40.3 2.2 50.05q0 9.7 3.75 18.6Q9.6 77.2 16.2 83.85q6.6 6.6 15.2 10.25 8.9 3.75 18.65 3.75 9.7 0 18.6-3.75 8.55-3.65 15.2-10.25 6.6-6.65 10.25-15.2 3.75-8.9 3.75-18.6 0-9.75-3.75-18.6m-11.6-13.9q6.35 6.35 9.9 14.6Q96 40.7 96 50.05q0 9.35-3.6 17.85-3.55 8.25-9.9 14.6-6.35 6.35-14.6 9.9Q59.4 96 50.05 96q-9.35 0-17.9-3.6-8.25-3.55-14.6-9.9-6.4-6.35-9.9-14.6-3.6-8.5-3.6-17.85 0-9.35 3.6-17.9 3.5-8.25 9.9-14.6 6.35-6.4 14.6-9.85 8.55-3.65 17.9-3.65 9.35 0 17.85 3.65 8.25 3.45 14.6 9.85z\" id=\"upload_g\" /><mask id=\"upload_h\"><path fill=\"#FFF\" d=\"M96.1 30.5q-3.85-8.95-10.75-15.85Q78.45 7.7 69.5 3.9 60.2 0 50.05 0q-10.2 0-19.5 3.9-9 3.8-15.9 10.75-6.9 6.9-10.7 15.85Q0 39.85 0 50t3.95 19.45q3.8 8.95 10.7 15.85 6.9 6.95 15.9 10.75 9.3 3.95 19.5 3.95 10.15 0 19.45-3.95 8.95-3.8 15.85-10.75 6.9-6.9 10.75-15.85Q100 60.15 100 50q0-10.15-3.9-19.5z\" /></mask><path fill=\"url(#upload_c)\" d=\"M81.5 40.8q2.7-4.75 2.7-9.9 0-5.2-2.7-9.9-2.55-4.6-7.3-8.1-10-7.45-24.15-7.45-14.25 0-24.25 7.45t-10 18q0 10.55 10 18 10 7.45 24.25 7.45 14.15 0 24.15-7.45 4.75-3.5 7.3-8.1z\" id=\"upload_k\" /><linearGradient id=\"upload_a\" y2=\"1\" x2=\"0\"><stop stop-color=\"#4ADCFD\" offset=\"0%\" /><stop stop-color=\"#0634A7\" offset=\"100%\" /></linearGradient><path d=\"M16.4 22.6h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zm-2 2c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4c0 .3-.2.5-.5.5zm8.6-2h-.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.7c3.2 0 5.8-2.6 5.8-5.8S26.3 10 23 10c-.3 0-.6-.2-.6-.4-.6-4-4.1-7.1-8.2-7.1C9.7 2.5 6 6.1 6 10.8v1.6s-.3.2-.4.2h-.1C3 12.5 1 14.5 1 17s2 4.5 4.5 4.5h1c.3 0 .5.2.5.5s-.2.5-.5.5h-1C2.4 22.5 0 20 0 17c0-2.9 2.2-5.2 5.1-5.5v-.8c0-5.1 4.2-9.3 9.3-9.3 4.5 0 8.3 3.2 9.2 7.5 3.5.2 6.4 3.1 6.4 6.7-.1 4-3.2 7-7 7zm-8.6 6c-3.6 0-6.5-2.9-6.5-6.5s2.9-6.5 6.5-6.5 6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5zm0-12c-3 0-5.5 2.5-5.5 5.5s2.5 5.5 5.5 5.5 5.5-2.5 5.5-5.5-2.5-5.5-5.5-5.5z\" transform=\"matrix(3.33333 0 0 3.33333 0 0)\" id=\"upload_i\" /><linearGradient id=\"upload_j\" y2=\"1\" x2=\"0\"><stop stop-color=\"#fff\" offset=\"0%\" /><stop stop-color=\"#e5eff9\" offset=\"100%\" /></linearGradient></defs><use xlink:href=\"#upload_f\" fill=\"url(#upload_a)\" /><use xlink:href=\"#upload_g\" /><g mask=\"url(#upload_h)\"><use xlink:href=\"#upload_i\" fill=\"url(#upload_j)\" transform=\"matrix(.5 0 0 .5 25 25)\" /></g><use xlink:href=\"#upload_k\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CNN-Selected.52c21c2.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DC_Comics-Selected.36ec36c.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Epsilon-Selected.2800883.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mosaic-Selected.036a09d.png";

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Canoe-Selected.1e11595.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Canoe_VOD-Selected.9d01658.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DirecTV-Selected.b0ffdb1.png";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Foresite-Selected.a1d6c57.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Krux-Selected.0abfb17.png";

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LiveRamp-Selected.eef45d9.png";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Symphony-Selected.0d64bfc.png";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Videoamp-Selected.e189d41.png";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Vizio-Selected.3b4365b.png";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Comscore-Selected.74b1438.png";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NPower-Selected.825f884.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PID-Selected.0f0efaf.png";

/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1254)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1946),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1874),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1287)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1979),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1313)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(2006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1818),
  /* scopeId */
  "data-v-118c9718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1258)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1950),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1911),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1295)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1987),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1246)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(1937),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1277)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1969),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1840),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1903),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1270)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1962),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1812),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1926),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1148)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1834),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1149)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1835),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1312)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(934),
  /* template */
  __webpack_require__(2005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(1803),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(941),
  /* template */
  __webpack_require__(1797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1314)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(2007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1130)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(1816),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1251)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(1943),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(1879),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(1878),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1282)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(981),
  /* template */
  __webpack_require__(1974),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1165)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(1852),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1241)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1932),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WebAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_U_D__ = __webpack_require__(72);









var API_FOR_ATT = "https://api.audiencematters.turnerapps.com/node";

var AttTargetAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AttTargetAPI, _WebAPI);

  function AttTargetAPI() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AttTargetAPI);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AttTargetAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AttTargetAPI)).call(this, { baseURL: API_FOR_ATT }));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AttTargetAPI, [{
    key: 'assignAtt',
    value: function assignAtt(_ref) {
      var username = _ref.username,
          id = _ref.id;

      return this.__post({
        extensionURL: '/Audience/assign/ATT',
        payload: { username: username, id: id }
      });
    }
  }, {
    key: 'importAtt',
    value: function importAtt(_ref2) {
      var viewing_stream = _ref2.viewing_stream,
          id = _ref2.id,
          advertiser = _ref2.advertiser,
          username = _ref2.username;

      return this.__post({
        extensionURL: '/Audience/import/ATT',
        payload: { viewing_stream: viewing_stream, id: id, advertiser: advertiser, username: username }
      });
    }
  }, {
    key: 'getATT',
    value: function getATT(_ref3) {
      var id = _ref3.id;

      return this.__get({
        query: { id: id },
        extensionURL: '/Audience/ATT'
      });
    }
  }, {
    key: 'submitATTCampaign',
    value: function submitATTCampaign(_ref4) {
      var display_name = _ref4.display_name,
          target_id = _ref4.target_id,
          advertiserName = _ref4.advertiserName,
          startDate = _ref4.startDate,
          endDate = _ref4.endDate,
          cae_id = _ref4.cae_id,
          viewing_stream = _ref4.viewing_stream,
          file = _ref4.file;

      var payload = {
        campaignName: display_name,
        clientName: advertiserName,
        startDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_U_D__["e" /* getLocalDateStringFormatted */])(startDate),
        endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_U_D__["e" /* getLocalDateStringFormatted */])(endDate),
        externalId: cae_id,
        dsTypeCd: viewing_stream.toUpperCase(),
        targetDefinition: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({}),
        targetLabel: display_name,
        networkKey: ['13', '15', '21', '59', '77', '97', '103', '105'],
        audTypeCode: ['ATT_FULL', 'ATT_RPD', 'US_FULL'],
        programmerName: 'TURNER',
        status: 'PLANNING',
        targetFile: [{
          fileName: file.name,
          action: file.action,
          fileTypeCd: 'Custom List'
        }],
        target_id: target_id
      };
      return this.__post({
        extensionURL: '/Audience/ATT/submitCampaign',
        payload: payload
      }, true);
    }
  }, {
    key: 'updateATTCampaign',
    value: function updateATTCampaign(_ref5) {
      var status = _ref5.status,
          startDate = _ref5.startDate,
          endDate = _ref5.endDate,
          cae_id = _ref5.cae_id;

      return this.__post({
        extensionURL: '/Audience/ATT/updateCampaign',
        payload: {
          status: status,
          startDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_U_D__["e" /* getLocalDateStringFormatted */])(startDate),
          endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_U_D__["e" /* getLocalDateStringFormatted */])(endDate),
          externalId: cae_id
        }
      });
    }
  }]);

  return AttTargetAPI;
}(__WEBPACK_IMPORTED_MODULE_6__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new AttTargetAPI());

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebAPI__ = __webpack_require__(64);







var API_ROOT_NODE = "https://api.audiencematters.turnerapps.com/node";

var UserAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UserAPI, _WebAPI);

  function UserAPI() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UserAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UserAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UserAPI)).call(this, { baseURL: API_ROOT_NODE + '/DataCity' }));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UserAPI, [{
    key: 'getMVPDs',
    value: function getMVPDs() {
      return this.__get({ extensionURL: '/MVPD' }).then(function (resp) {
        return resp.data;
      });
    }
  }]);

  return UserAPI;
}(__WEBPACK_IMPORTED_MODULE_5__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new UserAPI());

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WebAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appLogic_notifications_notificationConstants__ = __webpack_require__(159);









var API_ROOT_OPEN_AP = "https://api.audiencematters.turnerapps.com/workbench";

var NotificationAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NotificationAPI, _WebAPI);

  function NotificationAPI() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NotificationAPI);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotificationAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(NotificationAPI)).call(this, { baseURL: API_ROOT_OPEN_AP }));

    _this.CON = __WEBPACK_IMPORTED_MODULE_7__appLogic_notifications_notificationConstants__["a" /* default */];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NotificationAPI, [{
    key: 'getNotifications',
    value: function getNotifications() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          notification_type = _ref.notification_type,
          user_id = _ref.user_id,
          target_id = _ref.target_id,
          status = _ref.status;

      return this.__post({
        payload: { notification_type: notification_type, user_id: user_id, target_id: target_id, status: status },
        extensionURL: '/Audience/GetNotifications',
        addSession: true
      }).catch(function (error) {
        console.log(error);
        return [];
      });
    }
  }, {
    key: 'saveNotifications',
    value: function saveNotifications(notification) {
      return this.__post({ payload: notification, extensionURL: '/Audience/SaveNotification', addSession: true });
    }
  }, {
    key: 'updateNotification',
    value: function updateNotification(_ref2) {
      var notification_id = _ref2.notification_id,
          user_id = _ref2.user_id,
          status = _ref2.status;

      if (!user_id) {
        throw new Error('to update a Notification, you must provide the User_id');
      }
      return this.__post({
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          notification_id: notification_id,
          user_id: user_id,
          status: status
        }),
        extensionURL: '/Audience/UpdateNotificationStatus',
        addSession: true
      });
    }
  }, {
    key: 'deleteNotification',
    value: function deleteNotification(notification) {
      var updateNotification = {
        notification_id: notification.id,
        status: __WEBPACK_IMPORTED_MODULE_7__appLogic_notifications_notificationConstants__["a" /* default */].STATUS_DELETED,
        user_id: notification.user_id
      };
      return this.updateNotification(updateNotification);
    }
  }]);

  return NotificationAPI;
}(__WEBPACK_IMPORTED_MODULE_6__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new NotificationAPI());

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebAPI__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_index__ = __webpack_require__(7);








var API_FOR_WORKBENCH = "https://api.audiencematters.turnerapps.com/workbench";

var RevisionHistoryAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RevisionHistoryAPI, _WebAPI);

  function RevisionHistoryAPI() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RevisionHistoryAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RevisionHistoryAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RevisionHistoryAPI)).call(this, { baseURL: API_FOR_WORKBENCH }));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RevisionHistoryAPI, [{
    key: 'deleteBranch',
    value: function deleteBranch(_ref) {
      var branchId = _ref.branchId;

      return this.__post({
        extensionURL: '/RevisionHistory/DeleteBranch',
        payload: { branch_id: branchId },
        addSession: true
      });
    }
  }, {
    key: 'forwardRevision',
    value: function forwardRevision(_ref2) {
      var id = _ref2.id,
          move = _ref2.move,
          target_definition = _ref2.target_definition,
          label = _ref2.label,
          target_data = _ref2.target_data,
          audience = _ref2.audience,
          targetId = _ref2.targetId;

      var payload = { branch_id: id, move: move, target_definition: target_definition, label: label, target_data: target_data, audience: audience };
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_index__["_3" /* appendTargetHistory */])(targetId, payload).then(function (r) {
        return r.data;
      });
    }
  }, {
    key: 'branchOffRevisionBranch',
    value: function branchOffRevisionBranch(_ref3) {
      var branch_off_id = _ref3.branch_off_id,
          duplicate_up_to_move = _ref3.duplicate_up_to_move,
          label = _ref3.label,
          audience = _ref3.audience,
          target_id = _ref3.target_id;

      return this.__post({
        extensionURL: '/RevisionHistory/CreateNewBranch',
        payload: { branch_off_id: branch_off_id, duplicate_up_to_move: duplicate_up_to_move, label: label, audience: audience, target_id: target_id },
        addSession: true
      });
    }
  }, {
    key: 'getRevisionHistoryForTarget',
    value: function getRevisionHistoryForTarget(_ref4) {
      var target_id = _ref4.target_id;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_index__["_4" /* getTargetHistory */])(target_id).then(function (r) {
        return r.data;
      });
    }
  }, {
    key: 'createMissingBranch',
    value: function createMissingBranch(_ref5) {
      var id = _ref5.id,
          display_name = _ref5.display_name;

      return this.__post({
        extensionURL: '/RevisionHistory/CreateMissingRevisionHistory',
        payload: { id: id, display_name: display_name },
        addSession: true
      });
    }
  }]);

  return RevisionHistoryAPI;
}(__WEBPACK_IMPORTED_MODULE_5__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new RevisionHistoryAPI());

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WebAPI__ = __webpack_require__(64);







var API_ROOT_OPEN_AP = "https://api.audiencematters.turnerapps.com/workbench";

var UserAPI = function (_WebAPI) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UserAPI, _WebAPI);

  function UserAPI() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UserAPI);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UserAPI.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UserAPI)).call(this, { baseURL: API_ROOT_OPEN_AP }));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UserAPI, [{
    key: 'getUsers',
    value: function getUsers() {
      return this.__get({ extensionURL: '/Users' }).then(function (resp) {
        return resp.data;
      });
    }
  }]);

  return UserAPI;
}(__WEBPACK_IMPORTED_MODULE_5__WebAPI__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new UserAPI());

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__esParser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElasticsearchAPI__ = __webpack_require__(82);



var age = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var jsonQuery, esSearch, response, results, aggregations, numMonths, data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonQuery = payload['query'];
            esSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__esParser__["a" /* default */])(jsonQuery, payload);

            esSearch.aggs = getAgeAggregation();

            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3__ElasticsearchAPI__["a" /* default */].age(esSearch);

          case 5:
            response = _context.sent;
            results = response;
            aggregations = results.aggregations;
            numMonths = aggregations.months.buckets.length;
            data = aggregations.ages.buckets.map(function (a) {
              return { age: a.key, value: a.ue.value / numMonths };
            });
            return _context.abrupt('return', { data: { data: data } });

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function age(_x) {
    return _ref.apply(this, arguments);
  };
}();




function getAgeAggregation() {
  return {
    months: {
      date_histogram: {
        field: 'broadcastdate',
        interval: 'month',
        format: 'yyyy-MM'
      }
    },
    ages: {
      terms: {
        field: 'respondent.age'
      },
      aggs: {
        ue: {
          sum: {
            field: 'intabweight'
          }
        }
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (age);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElasticsearchAPI__ = __webpack_require__(82);



var broadcastDates = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var dataset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var esSearch, response, results, months;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            esSearch = {
              'size': 0,
              'aggs': {
                'months': {
                  'terms': {
                    'field': 'broadcastdate',
                    'format': 'yyyy-MM',
                    'size': 50,
                    'order': { '_key': 'asc' }
                  },
                  'aggs': {
                    'start_date': {
                      'max': {
                        'field': 'broadcastmonthstartdate',
                        'format': 'yyyy-MM-dd'
                      }
                    },
                    'end_date': {
                      'max': {
                        'field': 'broadcastmonthenddate',
                        'format': 'yyyy-MM-dd'
                      }
                    }
                  }
                },
                'mri': {
                  'filter': {
                    'exists': {
                      'field': 'mri.mri_yes'
                    }
                  },
                  'aggs': {
                    'latest_month': {
                      'max': {
                        'field': 'broadcastdate',
                        'format': 'yyyy-MM'
                      }
                    }
                  }
                },
                'ncs': {
                  'filter': {
                    'exists': {
                      'field': 'ncs.ncs_yes'
                    }
                  },
                  'aggs': {
                    'latest_month': {
                      'max': {
                        'field': 'broadcastdate',
                        'format': 'yyyy-MM'
                      }
                    }
                  }
                }
              }
            };

            if (dataset && dataset !== 'amrld') esSearch.query = { 'bool': { 'must': { 'exists': { 'field': dataset + '.' + dataset + '_yes' } } } };

            _context.prev = 2;
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_2__ElasticsearchAPI__["a" /* default */].broadcastDates(esSearch);

          case 5:
            response = _context.sent;
            results = response;
            months = results.aggregations.months.buckets;

            results.aggregations.months.buckets = months.slice(-24);
            return _context.abrupt('return', { data: results });

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](2);

            console.error('Error fetching broadcast dates:', _context.t0);
            return _context.abrupt('return', { data: null });

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 12]]);
  }));

  return function broadcastDates() {
    return _ref.apply(this, arguments);
  };
}();



/* harmony default export */ __webpack_exports__["a"] = (broadcastDates);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__esParser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ElasticsearchAPI__ = __webpack_require__(82);






var historicalViewership = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var jsonQuery, networks, esSearch, p18search, _ref2, _ref3, qResponse, p18Response, qResults, p18results, netRtg, dpRtg, numP18months, p18universe, aggregation, networkP18, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, network, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _network, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, daypart, result, networkBuckets, daypartBuckets, monthCnt, universeBucket, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _network2, networkName, _loop, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _network3;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonQuery = payload['query'];
            networks = ['TNT', 'TBSC', 'CNN', 'TOON', 'ADSM', 'TRU', 'HLN', 'BOOM', 'NBAT'];

            payload.networks = networks || payload.networks;

            esSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__esParser__["a" /* default */])(jsonQuery, payload);

            esSearch.aggs = getHistoryAggregation(payload.viewSource, payload.networks);
            p18search = getP18query(payload['start-date'], payload['end-date'], payload.view_source, payload.networks);
            _context.next = 8;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_6__ElasticsearchAPI__["a" /* default */].historicalViewership(esSearch), __WEBPACK_IMPORTED_MODULE_6__ElasticsearchAPI__["a" /* default */].historicalViewership(p18search)]);

          case 8:
            _ref2 = _context.sent;
            _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
            qResponse = _ref3[0];
            p18Response = _ref3[1];
            qResults = qResponse;
            p18results = p18Response;
            netRtg = [];
            dpRtg = [];
            numP18months = -1;
            p18universe = 1;


            if (p18results.aggregations) {
              aggregation = p18results.aggregations;

              if (aggregation.network_path) netRtg = aggregation['network_path']['NETWORK']['buckets'];
              if (aggregation.daypart_path) dpRtg = aggregation['daypart_path']['NETWORK']['buckets'];
              numP18months = aggregation.months.buckets.length;
              p18universe = aggregation.universe_estimate.value;
            }
            networkP18 = {};
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 23;

            for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(netRtg); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              network = _step.value;

              networkP18[network.key] = { rating: getRating(network.sum_avg_aud.value / numP18months, p18universe) };
            }
            _context.next = 31;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context['catch'](23);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 31:
            _context.prev = 31;
            _context.prev = 32;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 34:
            _context.prev = 34;

            if (!_didIteratorError) {
              _context.next = 37;
              break;
            }

            throw _iteratorError;

          case 37:
            return _context.finish(34);

          case 38:
            return _context.finish(31);

          case 39:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context.prev = 42;
            _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dpRtg);

          case 44:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context.next = 69;
              break;
            }

            _network = _step2.value;

            networkP18[_network.key].dayparts = {};
            _iteratorNormalCompletion5 = true;
            _didIteratorError5 = false;
            _iteratorError5 = undefined;
            _context.prev = 50;
            for (_iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_network.DAYPART.buckets); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              daypart = _step5.value;

              networkP18[_network.key].dayparts[daypart.key] = getRating(daypart.daypart_aa.value / numP18months, p18universe);
            }
            _context.next = 58;
            break;

          case 54:
            _context.prev = 54;
            _context.t1 = _context['catch'](50);
            _didIteratorError5 = true;
            _iteratorError5 = _context.t1;

          case 58:
            _context.prev = 58;
            _context.prev = 59;

            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }

          case 61:
            _context.prev = 61;

            if (!_didIteratorError5) {
              _context.next = 64;
              break;
            }

            throw _iteratorError5;

          case 64:
            return _context.finish(61);

          case 65:
            return _context.finish(58);

          case 66:
            _iteratorNormalCompletion2 = true;
            _context.next = 44;
            break;

          case 69:
            _context.next = 75;
            break;

          case 71:
            _context.prev = 71;
            _context.t2 = _context['catch'](42);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t2;

          case 75:
            _context.prev = 75;
            _context.prev = 76;

            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }

          case 78:
            _context.prev = 78;

            if (!_didIteratorError2) {
              _context.next = 81;
              break;
            }

            throw _iteratorError2;

          case 81:
            return _context.finish(78);

          case 82:
            return _context.finish(75);

          case 83:
            result = {};
            networkBuckets = [];
            daypartBuckets = [];
            monthCnt = -1;
            universeBucket = 1;


            if (qResults.aggregations.universe_estimate.value) {
              if (qResults.aggregations.network_path) networkBuckets = qResults.aggregations.network_path.NETWORK.buckets;
              if (qResults.aggregations.daypart_path) daypartBuckets = qResults.aggregations.daypart_path.NETWORK.buckets;
              monthCnt = qResults.aggregations.months.buckets.length;
              universeBucket = qResults.aggregations.universe_estimate.value;
            }
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context.prev = 92;
            for (_iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(networkBuckets); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              _network2 = _step3.value;
              networkName = _network2.key;

              result[networkName] = { size: _network2.sum_avg_aud.value / monthCnt };
              result[networkName].rating = getRating(result[networkName].size, universeBucket);
              result[networkName].index = getIndex(result[networkName].rating, networkP18[networkName].rating);
            }
            _context.next = 100;
            break;

          case 96:
            _context.prev = 96;
            _context.t3 = _context['catch'](92);
            _didIteratorError3 = true;
            _iteratorError3 = _context.t3;

          case 100:
            _context.prev = 100;
            _context.prev = 101;

            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }

          case 103:
            _context.prev = 103;

            if (!_didIteratorError3) {
              _context.next = 106;
              break;
            }

            throw _iteratorError3;

          case 106:
            return _context.finish(103);

          case 107:
            return _context.finish(100);

          case 108:
            _loop = function _loop(_network3) {
              var networkName = _network3.key;
              result[networkName].day_parts = _network3.DAYPART.buckets.map(function (daypart) {
                var aaDaypart = daypart.daypart_aa.value / monthCnt;
                var rating = getRating(aaDaypart, universeBucket);
                var val = { id: daypart.key, rating: rating };

                if (networkP18[networkName].day_parts) {
                  val.index = getIndex(rating, networkP18[networkName].day_parts[val.id]);
                  val.size = Math.round(aaDaypart);
                }
                return val;
              });
            };

            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context.prev = 112;
            for (_iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(daypartBuckets); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              _network3 = _step4.value;

              _loop(_network3);
            }
            _context.next = 120;
            break;

          case 116:
            _context.prev = 116;
            _context.t4 = _context['catch'](112);
            _didIteratorError4 = true;
            _iteratorError4 = _context.t4;

          case 120:
            _context.prev = 120;
            _context.prev = 121;

            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }

          case 123:
            _context.prev = 123;

            if (!_didIteratorError4) {
              _context.next = 126;
              break;
            }

            throw _iteratorError4;

          case 126:
            return _context.finish(123);

          case 127:
            return _context.finish(120);

          case 128:
            return _context.abrupt('return', { data: result });

          case 129:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[23, 27, 31, 39], [32,, 34, 38], [42, 71, 75, 83], [50, 54, 58, 66], [59,, 61, 65], [76,, 78, 82], [92, 96, 100, 108], [101,, 103, 107], [112, 116, 120, 128], [121,, 123, 127]]);
  }));

  return function historicalViewership(_x) {
    return _ref.apply(this, arguments);
  };
}();




function getRating(aaImpressions, ue) {
  return ue !== 0 ? aaImpressions / ue * 100 : 0;
}

function getIndex(targetRtg, baselineRtg) {
  return baselineRtg !== 0 ? Math.round(targetRtg / baselineRtg * 100) : 0;
}

function getHistoryAggregation() {
  var viewSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'aalivesd';
  var networks = arguments[1];

  return {
    months: {
      date_histogram: { field: 'broadcastdate', interval: 'month', format: 'yyyy-MM' },
      aggs: { ue: { sum: { field: 'intabweight' } } }
    },
    universe_estimate: { avg_bucket: { buckets_path: 'months>ue' } },
    network_path: {
      nested: { path: 'network' },
      aggs: {
        NETWORK: {
          terms: {
            field: 'network.networklabel',
            include: networks
          },
          aggs: {
            sum_avg_aud: {
              sum: {
                field: 'network.' + viewSource
              }
            }
          }
        }
      }
    },
    daypart_path: {
      nested: { path: 'daypart' },
      aggs: {
        NETWORK: {
          terms: {
            field: 'daypart.networklabel',
            include: networks
          },
          aggs: {
            DAYPART: {
              terms: { field: 'daypart.reporteddaypart' },
              aggs: { daypart_aa: { sum: { field: 'daypart.' + viewSource } } }
            }
          }
        }
      }
    }
  };
}

function getP18query(startDate, endDate, viewSource, networks) {
  return {
    size: 0,
    query: {
      bool: {
        must: [{
          range: {
            broadcastmonthstartdate: { gte: startDate, lte: endDate, format: 'yyyy-MM-dd' }
          }
        }, { range: { 'respondent.age': { gte: 18 } } }]
      }
    },
    aggs: {
      months: {
        date_histogram: { field: 'broadcastdate', interval: 'month', format: 'yyyy-MM' },
        aggs: { ue: { sum: { field: 'intabweight' } } }
      },
      universe_estimate: { avg_bucket: { buckets_path: 'months>ue' } },
      network_path: {
        nested: { path: 'network' },
        aggs: {
          NETWORK: {
            terms: {
              field: 'network.networklabel',
              include: networks
            },
            aggs: {
              sum_avg_aud: {
                sum: {
                  field: 'network.' + viewSource
                }
              }
            }
          }
        }
      },
      daypart_path: {
        nested: { path: 'daypart' },
        aggs: {
          NETWORK: {
            terms: {
              field: 'daypart.networklabel',
              include: networks
            },
            aggs: {
              DAYPART: {
                terms: { field: 'daypart.reporteddaypart' },
                aggs: { daypart_aa: { sum: { field: 'daypart.' + viewSource } } }
              }
            }
          }
        }
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (historicalViewership);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__esParser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ElasticsearchAPI__ = __webpack_require__(82);




var income = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var jsonQuery, esSearch, response, results, aggregations, monthCnt, data;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonQuery = payload.query;
            esSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__esParser__["a" /* default */])(jsonQuery, payload);

            esSearch.aggs = getIncomeAggregation();

            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_4__ElasticsearchAPI__["a" /* default */].income(esSearch);

          case 5:
            response = _context.sent;
            results = response;
            aggregations = results.aggregations;
            monthCnt = aggregations.months.buckets.length;
            data = aggregations.incomes.buckets.filter(function (b) {
              return b !== '';
            }).map(function (income) {
              var incomeRng = getIncomeRange(income);
              incomeRng.value = income.ue.value / monthCnt;
              return incomeRng;
            });
            return _context.abrupt('return', { data: { data: data } });

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function income(_x) {
    return _ref.apply(this, arguments);
  };
}();




function getIncomeRange(income) {
  if (income.key === '< $10,000') return { startIncome: 0, finishIncome: 10000 };
  if (income.key === '$200,000+') return { startIncome: 200000, finishIncome: 300000 };

  var _income$key$replaceAl = income.key.replaceAll(/[$,]/g, '').split(' to ').map(function (i) {
    return parseInt(i);
  }),
      _income$key$replaceAl2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_income$key$replaceAl, 2),
      start = _income$key$replaceAl2[0],
      finish = _income$key$replaceAl2[1];

  return { startIncome: start, finishIncome: finish };
}

function getIncomeAggregation() {
  return {
    months: {
      date_histogram: {
        field: 'broadcastdate',
        interval: 'month',
        format: 'yyyy-MM'
      }
    },
    incomes: {
      terms: {
        field: 'household.householdincomerangesdetailed'
      },
      aggs: {
        ue: {
          sum: {
            field: 'intabweight'
          }
        }
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (income);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__esParser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ElasticsearchAPI__ = __webpack_require__(82);




var metrics = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var jsonQuery, esSearch, response, results, aggregations, totalAudience;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonQuery = payload.query;
            esSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__esParser__["a" /* default */])(jsonQuery, payload);

            esSearch.aggs = getMetricsAggregation();

            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_4__ElasticsearchAPI__["a" /* default */].metrics(esSearch);

          case 5:
            response = _context.sent;
            results = response;
            aggregations = results.aggregations;
            totalAudience = aggregations.UNIVERSE.value;

            if (!(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(totalAudience) && totalAudience > 0)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return', {
              data: {
                male: parseInt(aggregations.no_of_male.value) / totalAudience * 100,
                female: parseInt(aggregations.no_of_female.value) / totalAudience * 100,
                kids: parseInt(aggregations.no_of_children.value) / totalAudience * 100,
                house: parseInt(aggregations.home_owners.value) / totalAudience * 100,
                income: aggregations.avg_income.value * 1000
              }
            });

          case 11:
            return _context.abrupt('return', { data: { male: 0, female: 0, kids: 0, house: 0, income: 0 } });

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function metrics(_x) {
    return _ref.apply(this, arguments);
  };
}();




function getMetricsAggregation() {
  return {
    METRICS: {
      date_histogram: { field: 'broadcastdate', interval: 'month', format: 'yyyy-MM' },
      aggs: {
        Avg_income: { avg: { field: 'household.householdincome' } },
        Home_owners: {
          filter: { term: { 'household.homeownershipstatus': 'Owned' } },
          aggs: { home_owners_count: { sum: { field: 'intabweight' } } }
        },
        No_of_children: {
          filter: { range: { 'household.numberofchildren': { gt: 0 } } },
          aggs: { children_count: { sum: { field: 'intabweight' } } }
        },
        No_of_female: {
          filter: { term: { 'respondent.gender': 'F' } },
          aggs: { female_count: { sum: { field: 'intabweight' } } }
        },
        Marriage_count: {
          filter: { range: { 'household.numberofchildren': { gt: 0 } } },
          aggs: { married_people: { sum: { field: 'dayaa.aalivesd' } } }
        },
        No_of_male: {
          filter: { term: { 'respondent.gender': 'M' } },
          aggs: { male_count: { sum: { field: 'intabweight' } } }
        }
      }
    },
    UNIVERSE_MONTHLY: {
      date_histogram: { field: 'broadcastdate', interval: 'month', format: 'yyyy-MM' },
      aggs: { SUM_AVG_UE: { sum: { field: 'intabweight' } } }
    },
    UNIVERSE: { avg_bucket: { buckets_path: 'UNIVERSE_MONTHLY>SUM_AVG_UE' } },
    avg_income: { avg_bucket: { buckets_path: 'METRICS>Avg_income' } },
    home_owners: { avg_bucket: { buckets_path: 'METRICS>Home_owners>home_owners_count' } },
    no_of_children: { avg_bucket: { buckets_path: 'METRICS>No_of_children>children_count' } },
    no_of_female: { avg_bucket: { buckets_path: 'METRICS>No_of_female>female_count' } },
    no_of_male: { avg_bucket: { buckets_path: 'METRICS>No_of_male>male_count' } }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (metrics);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_months__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_parse__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ElasticsearchAPI__ = __webpack_require__(82);








var targetDefinition = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var jsonQuery, attributeSet, esQuery, response, results;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonQuery = payload.query;
            attributeSet = parserSet(jsonQuery, []);

            if (!(attributeSet.length === 0)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return', parserLite(jsonQuery, attributeSet));

          case 4:
            esQuery = getEsQuery(attributeSet, payload['start-date'], payload['end-date']);
            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_11__ElasticsearchAPI__["a" /* default */].targetDefinition(esQuery);

          case 7:
            response = _context.sent;
            results = response;
            return _context.abrupt('return', { data: parserLite(jsonQuery, esDictionary(results, attributeSet)) });

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function targetDefinition(_x) {
    return _ref.apply(this, arguments);
  };
}();







function esDictionary(queryResults, attributeSet) {
  if (!queryResults.aggregations) return [];
  var aggregations = queryResults.aggregations;
  var monthCnt = aggregations.months.buckets.length || 1;
  var values = [];
  var addedAttributes = [];

  var getDictionaryVals = function getDictionaryVals(dataset) {
    var dsUe = aggregations[dataset + '_ue'].buckets;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(dsUe), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        var key = item.key;
        addedAttributes.push(key);

        var monthsWithDocs = item.ue_by_month.buckets.filter(function (m) {
          return m.doc_count > 0;
        });
        var hasAllMonths = Math.floor(monthsWithDocs.length / monthCnt);
        var ue = item.atsg.avg_ue.value;
        values.push({ id: key, all_months: hasAllMonths, ue: ue });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(attributeSet.filter(function (a) {
        return !addedAttributes.includes(a.id) && a.dataset === dataset;
      })), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var a = _step2.value;

        values.push({ id: a.id, all_months: 0, ue: 0 });
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return values;
  };
  if (aggregations.mri_ue) values.push.apply(values, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(getDictionaryVals('mri')));
  if (aggregations.ncs_ue) values.push.apply(values, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(getDictionaryVals('ncs')));
  return values;
}

function getEsQuery(attributeSet, startDate, endDate) {
  var mriIds = [];
  var ncsIds = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(attributeSet), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var attr = _step3.value;

      if (attr.dataset === 'mri') mriIds.push(attr.id);
      if (attr.dataset === 'ncs') ncsIds.push(attr.id);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  function getDatasetQuery(datasetIds, startDate, endDate, dataset) {
    var _aggs;

    var atsgStart = __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default()(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_months___default()(__WEBPACK_IMPORTED_MODULE_10_date_fns_parse___default()(endDate), -3), 1);
    return {
      'size': 0,
      'query': {
        'bool': {
          'must': [{ 'match': { 'rec_type': dataset } }, {
            'range': {
              'broadcastmonthstartdate': { 'gte': startDate, 'lte': endDate, 'format': 'yyyy-MM-dd' }
            }
          }]
        }
      },
      'aggs': (_aggs = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_aggs, dataset + '_ue', {
        'terms': { 'field': 'id', 'include': datasetIds, 'size': datasetIds.length },
        'aggs': {
          'avg_ue': { 'avg_bucket': { 'buckets_path': 'ue_by_month>total_ue' } },
          'ue_by_month': {
            'date_histogram': {
              'field': 'broadcastdate',
              'interval': 'month',
              'format': 'yyyy-MM-dd'
            },
            'aggs': { 'total_ue': { 'sum': { 'field': dataset + '_ue' } } }
          },
          'atsg': {
            'filter': {
              'range': {
                'broadcastdate': {
                  'gte': __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(atsgStart, 'YYYY-MM-DD')
                }
              }
            },
            'aggs': {
              'ue_by_month': {
                'date_histogram': {
                  'field': 'broadcastdate',
                  'interval': 'month',
                  'format': 'yyyy-MM'
                },
                'aggs': { 'total_ue': { 'sum': { 'field': dataset + '_ue' } } }
              },
              'avg_ue': {
                'avg_bucket': {
                  'buckets_path': 'ue_by_month>total_ue'
                }
              }
            }
          }
        }
      }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_aggs, 'months', {
        'terms': {
          'field': 'broadcastdate',
          'format': 'yyyy-MM',
          'size': 50,
          'order': {
            '_key': 'asc'
          }
        },
        'aggs': {
          'start_date': {
            'max': {
              'field': 'broadcastmonthstartdate',
              'format': 'yyyy-MM-dd'
            }
          },
          'end_date': {
            'max': {
              'field': 'broadcastmonthenddate',
              'format': 'yyyy-MM-dd'
            }
          }
        }
      }), _aggs)
    };
  }

  if (mriIds.length > 0) return getDatasetQuery(mriIds, startDate, endDate, 'mri');
  if (ncsIds.length > 0) return getDatasetQuery(ncsIds, startDate, endDate, 'ncs');
  return { size: 0 };
}

function parserLite(targetDefinition, values) {
  var _loop = function _loop(attr) {
    if ((typeof attr === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(attr)) === 'object' && !Array.isArray(attr)) {
      if (['mri', 'ncs'].includes(attr.dataset)) __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attr, { ue: 0, removed: false });
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(values.filter(function (v) {
          return v.id === attr.id;
        })), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var val = _step5.value;

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attr, { ue: val.ue, removed: val.all_months < 1 });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    } else if (Array.isArray(attr)) parserLite(attr, values);
  };

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(targetDefinition), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var attr = _step4.value;

      _loop(attr);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return targetDefinition;
}

function parserSet(targetDefinition, result) {
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(targetDefinition), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var attr = _step6.value;

      if ((typeof attr === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(attr)) === 'object' && !Array.isArray(attr)) result.push({ dataset: attr.dataset, id: attr.id });else if (Array.isArray(attr)) parserSet(attr, result);
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (targetDefinition);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__esParser__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElasticsearchAPI__ = __webpack_require__(82);



var universeEstimate = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
    var jsonQuery, esSearch, response, results, aggregations, datasources, filterFn, monthBuckets, averageUniverse, monthResult, ueValues, ueStability;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonQuery = payload.query;
            esSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__esParser__["a" /* default */])(jsonQuery, payload);

            esSearch.aggs = getUeAggregation(jsonQuery);

            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3__ElasticsearchAPI__["a" /* default */].universeEstimate(esSearch);

          case 5:
            response = _context.sent;
            results = response;
            aggregations = results.aggregations;

            if (!(!aggregations || !aggregations.average_universe || !aggregations.average_universe.value)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt('return', { data: { stable: false, universe: [], audience: 0 } });

          case 10:
            datasources = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__esParser__["b" /* getDataSources */])(jsonQuery);

            filterFn = function filterFn(b) {
              return b;
            };

            if (datasources.has('mri') && datasources.has('ncs')) {
              filterFn = function filterFn(b) {
                return b.mri.doc_count > 0 && b.ncs.doc_count > 0;
              };
            } else if (datasources.has('mri')) filterFn = function filterFn(b) {
              return b.mri.doc_count > 0;
            };else if (datasources.has('ncs')) filterFn = function filterFn(b) {
              return b.ncs.doc_count > 0;
            };

            monthBuckets = aggregations.by_month.buckets;
            averageUniverse = getAverage(monthBuckets.filter(filterFn).map(function (b) {
              return b.monthly_universe.value;
            }).slice(-3));
            monthResult = monthBuckets.map(function (m) {
              return { date: m.key_as_string + '-01', size: m.monthly_universe.value };
            });
            ueValues = monthResult.map(function (m) {
              return m.size;
            });
            ueStability = 1;

            if (ueValues.length >= 2) ueStability = getStandardDeviation(ueValues) / getAverage(ueValues);
            return _context.abrupt('return', {
              data: {
                audience: averageUniverse,
                stable: ueStability < 1 && averageUniverse > 10000000,
                universe: monthResult
              }
            });

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function universeEstimate(_x) {
    return _ref.apply(this, arguments);
  };
}();




function getStandardDeviation(arr) {
  if (!arr || arr.length === 0) return 0;
  var n = arr.length;
  var mean = arr.reduce(function (a, b) {
    return a + b;
  }) / n;
  return Math.sqrt(arr.map(function (x) {
    return Math.pow(x - mean, 2);
  }).reduce(function (a, b) {
    return a + b;
  }) / n);
}

function getAverage(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }) / arr.length;
}

function getUeAggregation() {
  return {
    'by_month': {
      'date_histogram': { 'field': 'broadcastdate', 'interval': 'month', 'format': 'yyyy-MM' },
      'aggs': {
        'monthly_universe': { 'sum': { 'field': 'intabweight' } },
        'mri': {
          'filter': {
            'exists': {
              'field': 'mri.mri_yes'
            }
          }
        },
        'ncs': {
          'filter': {
            'exists': {
              'field': 'ncs.ncs_yes'
            }
          }
        }
      }
    },
    'average_universe': { 'avg_bucket': { 'buckets_path': 'by_month>monthly_universe' } }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (universeEstimate);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_index__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bubble"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: {
    axises: {
      type: Object,
      required: true
    }
  },
  computed: {
    options: function options() {
      var _this = this;

      return {
        onClick: function onClick(event, elements) {
          if (elements.length === 0) return;
          var attribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(_this.chartData.datasets[elements[0]._datasetIndex].attribute);
          if (attribute.type === 'boolean') {
            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__["o" /* ADD_ATTRIBUTE */], attribute);
          } else if (attribute.type === 'range') {
            attribute.value = {
              min: attribute.min,
              max: attribute.max
            };
            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__["o" /* ADD_ATTRIBUTE */], attribute);
          } else {
            console.log('ERROR: I don\'t know what to do with ' + attribute.type);
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 30,
            right: 25,
            top: 20,
            bottom: 10
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              fontSize: 13,
              min: this.axises.x.min,
              max: this.axises.x.max,
              callback: function callback(value, index, values) {
                return index === values.length - 1 || index === 0 && value !== 0 ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_index__["c" /* isDecimal */])(value) ? value.toFixed(1) + '%' : value + '%';
              }
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              padding: 2,
              fontSize: 13,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function callback(value, index, values) {
                return index === values.length - 1 || index === 0 && value !== 0 ? '' : value === 0 ? 0 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_index__["c" /* isDecimal */])(value) ? value.toFixed(2) : value;
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontStyle: 'bold',
          footerFontStyle: 'normal',
          displayColors: false,
          callbacks: {
            label: function label(tooltip, data) {
              return '' + data.datasets[tooltip.datasetIndex].label;
            },
            footer: function footer(tooltip, data) {
              return 'Coverage: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_index__["d" /* commaFormatString */])(String(tooltip[0].xLabel)) + ' Index to average: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_index__["d" /* commaFormatString */])(String(tooltip[0].yLabel));
            }
          }
        }
      };
    }
  },
  methods: {
    renderChartOnDataChange: function renderChartOnDataChange() {
      this.renderChart(this.chartData, this.options);
    }
  },
  mounted: function mounted() {
    this.renderChartOnDataChange();
  }
}));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bubble"].extend({
  props: {
    chartId: {
      type: String,
      default: 'viewership-graph'
    },
    chartData: {
      type: Object,
      required: true
    },
    axises: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function
    }
  },
  computed: {
    options: function options() {
      var _this = this;

      return {
        onClick: function onClick(event, elements) {
          if (elements.length === 0) return;
          if (_this.onClick) {
            _this.onClick(_this.chartData.datasets[elements[0]._datasetIndex].network);
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 25,
            top: 20,
            bottom: 0
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              fontSize: 13,
              min: this.axises.x.min,
              max: this.axises.x.max,
              callback: function callback(value, index, values) {
                return index === values.length - 1 || index === 0 && value !== 0 ? '' : value === 0 ? 0 : value.toFixed(3);
              }
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              padding: 2,
              fontSize: 13,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function callback(value, index, values) {
                return index === values.length - 1 || index === 0 && value !== 0 ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* isDecimal */])(value) ? value.toFixed(1) : value;
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontStyle: 'bold',
          footerFontStyle: 'normal',
          displayColors: false,
          callbacks: {
            label: function label(tooltip, data) {
              return '' + data.datasets[tooltip.datasetIndex].label;
            },
            footer: function footer(tooltip, data) {
              return 'Rating: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip[0].xLabel.toFixed(3))) + ' Index: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip[0].yLabel));
            }
          }
        }
      };
    }
  },
  methods: {
    renderChartOnDataChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      this._chart ? this._chart.destroy() : undefined;
      this.renderChart(this.chartData, this.options);
    }, 100)
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    'chartData': function chartData() {
      this.renderChartOnDataChange();
    },
    'options': function options() {
      this.renderChartOnDataChange();
    }
  }
}));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatAudienceSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);


var formatIndex = function formatIndex(index) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* commaFormatString */])(String(index));
};

var formatRating = function formatRating(rating) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* commaFormatString */])(String(rating.toFixed(3)));
};

var formatAudienceSize = function formatAudienceSize(size) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* commaFormatString */])(size);
};

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tree_model__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tree_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tree_model__);




var AttributeTree = function () {
  function AttributeTree() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AttributeTree);

    this._treeModel = new __WEBPACK_IMPORTED_MODULE_2_tree_model___default.a();
    this.root = this._treeModel.parse({
      name: 'Data Sources',
      children: []
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AttributeTree, [{
    key: 'addDataSource',
    value: function addDataSource(dataSource) {
      var node = this._treeModel.parse(dataSource);
      this.root.addChild(node);
    }
  }]);

  return AttributeTree;
}();

/* harmony default export */ __webpack_exports__["a"] = (AttributeTree);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_search__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_search__);




var SearchService = function () {
  function SearchService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SearchService);

    this.dataSources = [];
    this.initialized = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SearchService, [{
    key: 'addDataSource',
    value: function addDataSource(_ref) {
      var name = _ref.name,
          attributes = _ref.attributes;

      this.dataSources.push({
        name: name,
        attributes: attributes
      });
    }
  }, {
    key: 'init',
    value: function init() {
      this.dataSources = this.dataSources.map(function (dataSource) {
        var s = new __WEBPACK_IMPORTED_MODULE_2_js_search__["Search"]('id');
        s.searchIndex = new __WEBPACK_IMPORTED_MODULE_2_js_search__["UnorderedSearchIndex"]();
        s.addIndex('search');
        s.addDocuments(dataSource.attributes);
        return {
          name: dataSource.name,
          searchIndex: s
        };
      });
    }
  }, {
    key: 'search',
    value: function search(term) {
      if (!this.initialized) {
        this.init();
        this.initialized = true;
      }
      return this.dataSources.map(function (dataSource) {
        return {
          name: dataSource.name,
          results: dataSource.searchIndex.search(term)
        };
      });
    }
  }]);

  return SearchService;
}();

/* harmony default export */ __webpack_exports__["a"] = (SearchService);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(307);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    availableDates: [],
    startDate: null,
    endDate: null
  },
  getters: {
    startDate: function startDate(state) {
      return state.startDate;
    },
    endDate: function endDate(state) {
      return state.endDate;
    },
    isValidStartDate: function isValidStartDate(state) {
      return function (startDate) {
        return state.availableDates.filter(function (date) {
          return date.from === startDate;
        }).length > 0;
      };
    },
    dateRange: function dateRange(state) {
      return {
        availableDates: state.availableDates,
        startDate: state.startDate,
        endDate: state.endDate
      };
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* default */]
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bubble"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: {
    axises: {
      type: Object,
      required: true
    }
  },
  computed: {
    options: function options() {
      return {
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 10,
            bottom: 0
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              tickMarkLength: 5,
              color: '#000'
            },
            ticks: {
              fontSize: 10,
              min: this.axises.x.min,
              max: this.axises.x.max
            }
          }],
          yAxes: [{
            gridLines: {
              tickMarkLength: 5,
              color: '#000'
            },
            ticks: {
              fontSize: 10,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function callback(value, index, values) {
                return index === 0 ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* isDecimal */])(value) ? value.toFixed(1) : value;
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontSize: 10,
          bodySpacing: 1,
          displayColors: false,
          footerFontSize: 9,
          footerFontStyle: 'normal',
          titleFontSize: 10,
          titleSpacing: 0,
          titleMarginBottom: 2,
          labelFontSize: 10,
          footerMarginTop: 3,
          xPadding: 4,
          yPadding: 4,
          cornerRadius: 3,
          callbacks: {
            title: function title(tooltip, data) {
              return '' + data.datasets[tooltip[0].datasetIndex].title;
            },
            label: function label(tooltip, data) {
              return '' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(data.datasets[tooltip.datasetIndex].label));
            },
            footer: function footer(tooltip, data) {
              return 'Rating: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(tooltip[0].xLabel.toFixed(3)) + ' Index: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip[0].yLabel));
            }
          }
        }
      };
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_truncateAmount__ = __webpack_require__(128);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  mixins: [reactiveProp],
  data: function data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0
        },
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 15,
            top: 0,
            bottom: 10
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.6,
            barSpacing: 20,
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              callback: function callback(value) {
                return value;
              }
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              zeroLineColor: '#0052E7'
            },
            ticks: {
              padding: 4,
              fontSize: 12,
              callback: function callback(value) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* isDecimal */])(value) ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__filters_truncateAmount__["a" /* default */])(value);
              }
            }
          }]
        },
        tooltips: {
          displayColors: false,
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function label(tooltip, data) {
              return data.datasets[tooltip.datasetIndex].label + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip.yLabel));
            }
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_popover__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showUEHoverOver: function showUEHoverOver(e) {
      if (!this.hoverOverPopover && this.hasHoverOverMessage) {
        this.hoverOverPopover = __WEBPACK_IMPORTED_MODULE_0__components_common_popover__["a" /* PopoverFactory */].createListBoxWithHoverOver({
          direction: 'top',
          list: [{ value: true, name: 'Path: ' + this.attribute.dataset + ' / ' + this.attribute.path + ' /' }, { value: true, name: this.hoverOverMessage }],
          parent: e.currentTarget,
          hoverOver: this.$el
        });
        this.popover = this.hoverOverPopover;
      }
    },
    hideUEHoverOver: function hideUEHoverOver(e) {
      if (this.hoverOverPopover) {
        this.hoverOverPopover = null;
      }
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_services_serializer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);





var MAX_NESTING_LEVEL = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  canNotUndo: function canNotUndo(state, getters) {
    return getters['undoHistory/canNotUndo'];
  },
  canNotRedo: function canNotRedo(state, getters) {
    return getters['undoHistory/canNotRedo'];
  },
  getDefinition: function getDefinition(state) {
    return state.definition.children;
  },
  aDefinition: function aDefinition(state) {
    return state.definition;
  },
  selected: function selected(state) {
    return state.selected;
  },
  targetDefinitionLastAttributeCommand: function targetDefinitionLastAttributeCommand(state) {
    return state.lastAttributeCommand;
  },
  selectedCount: function selectedCount(state) {
    return state.selected.length;
  },
  hasDefinition: function hasDefinition(state) {
    return state.definition.children.length > 0;
  },
  serializedDefinition: function serializedDefinition(state) {
    return __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].serialize(state.definition);
  },
  lastTimeTargetWasChanged: function lastTimeTargetWasChanged(state) {
    return state.lastTimeTargetWasChanged;
  },
  selectedCanBeGrouped: function selectedCanBeGrouped(state, getters) {
    return getters.hasDefinition && getters.selectedCount > 1 && findMaxDepth(state.definition.children, state.selected[0]) + Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.selected.map(function (selected) {
      return getDepthCount(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, selected));
    }))) < MAX_NESTING_LEVEL;
  },
  selectedCanBeUngrouped: function selectedCanBeUngrouped(state, getters) {
    return getters.hasDefinition && getters.selectedCount > 0 && state.selected.every(function (selectedId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, selectedId));
    });
  },
  selectedCanBecomeCountGroup: function selectedCanBecomeCountGroup(state, getters) {
    return getters.hasDefinition && getters.selectedCount === 1 && state.selected.every(function (selectedId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, selectedId));
    });
  },
  selectedCanBeDeleted: function selectedCanBeDeleted(state, getters) {
    return getters.hasDefinition && getters.selectedCount > 0;
  },
  isAttributeSelected: function isAttributeSelected(state, getters) {
    return function (attr) {
      return state.selected.some(function (selectedId) {
        return attr.definitionId === selectedId;
      }) || getters.isAttributeInSelectedGroup(attr);
    };
  },
  isAttributeInSelectedGroup: function isAttributeInSelectedGroup(state, getters) {
    return function (attr) {
      return state.selected.filter(function (selected) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(getters.getDefinitionPartById(selected));
      }).map(getters.getDefinitionPartById).some(function (group) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(group, attr.definitionId);
      });
    };
  },
  isTargetEditable: function isTargetEditable(state) {
    return !state.viewOnly;
  },
  getDefinitionPartById: function getDefinitionPartById(state) {
    return function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, id);
    };
  },
  canDraggingItemDropHere: function canDraggingItemDropHere(state, getters) {
    return function (id, depth) {
      var draggingItemId = state.dragAndDrop.draggingItem;

      if (draggingItemId === id) {
        return false;
      }
      var draggingItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, draggingItemId);
      var dropArea = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, id);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(draggingItem) && depth === MAX_NESTING_LEVEL || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["b" /* isCountGroup */])(dropArea) || getters.isInACountGroup(id)) return false;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(draggingItem)) {
        var isInCurrentDraggingGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["f" /* recursiveFilter */])(draggingItem, function (def) {
          return def.definitionId === id;
        }).length > 0;
        if (isInCurrentDraggingGroup) return false;
      }
      return true;
    };
  },
  disableDefinitionPart: function disableDefinitionPart(state, getters) {
    return function (id) {
      if (!getters.isTargetEditable) return true;
      return false;
    };
  },
  isDragAndDropActive: function isDragAndDropActive(state) {
    return state.dragAndDrop.active;
  },
  isDraggingPart: function isDraggingPart(state) {
    return !!state.dragAndDrop.draggingItem;
  },
  selectedAttributes: function selectedAttributes(state) {
    if (state.selected.length > 0) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.selected)).map(function (partId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, partId);
      });
    }
    return [];
  },
  isInACountGroup: function isInACountGroup(state, getters) {
    return function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["f" /* recursiveFilter */])(state.definition, function (part) {
        var found = false;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["b" /* isCountGroup */])(part)) {
          found = part.children.find(function (child) {
            return child.definitionId === id;
          });
        }
        return found;
      }).length > 0;
    };
  },
  updateLasTD: function updateLasTD(state) {
    return state.updateLasTD;
  }
});

function getDepthCount(node) {
  return !(node && node.children) ? 0 : Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(node.children.map(function (child) {
    return getDepthCount(child);
  }))) + 1;
}

function findMaxDepth(definition, definitionId) {
  var startingDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  for (var i = 0; i < definition.length; i++) {
    if (definition[i].definitionId === definitionId) {
      return startingDepth;
    }
    if (definition[i].children) {
      var foundDepth = findMaxDepth(definition[i].children, definitionId, startingDepth + 1);
      if (foundDepth > -1) return foundDepth;
    }
  }
  return -1;
}

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_plugins_undoHistory__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(34);








var createModule = function createModule(namespace) {
  return {
    state: function state() {
      return {
        selected: [],
        definition: {
          root: true,
          children: []
        },
        viewOnly: false,
        dragAndDrop: {
          active: false,
          draggingItem: null
        },
        lastTimeTargetWasChanged: null,
        lastAttributeCommand: null,
        updateLasTD: 0
      };
    },

    getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["c" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_5__actions__["y" /* default */],
    modules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_plugins_undoHistory__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], {
      filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_plugins_undoHistory__["c" /* isMutationType */])([__WEBPACK_IMPORTED_MODULE_5__actions__["o" /* ADD_ATTRIBUTE */], __WEBPACK_IMPORTED_MODULE_5__actions__["e" /* REMOVE_ATTRIBUTE */], __WEBPACK_IMPORTED_MODULE_5__actions__["p" /* UPDATE_ATTRIBUTE */], __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* UPDATE_OPERATOR */], __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* CLEAR_DEFINITION */], __WEBPACK_IMPORTED_MODULE_5__actions__["f" /* GROUP */], __WEBPACK_IMPORTED_MODULE_5__actions__["g" /* UNGROUP */], __WEBPACK_IMPORTED_MODULE_5__actions__["t" /* MOVE_ATTRIBUTE */]]),
      initialValue: [],
      reducer: function reducer(state) {
        return state[namespace].targetDefinition.definition.children;
      },
      restoreState: function restoreState(state) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["m" /* SET_DEFINITION */], state);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* CLEAR_SELECTION */]);
      }
    }, { namespace: namespace }).module)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createModule);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: {
    definition: {
      type: Array,
      required: true
    },
    enableDragAndDrop: {
      type: Boolean,
      default: false
    },
    isDraggingPart: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, context) {
    var renderThis = flattenedDefinitionComponents(h, context.props.definition, context.props.enableDragAndDrop);
    if (context.props.enableDragAndDrop && context.props.isDraggingPart) {
      renderThis.push(h(__WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue___default.a));
    }
    return h('div', {
      attrs: {
        id: 'target-definition-statement',
        class: 'target-definition-statement'
      },
      style: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
      }
    }, renderThis);
  }
});

function flattenedDefinitionComponents(h, definition, enableDragAndDrop) {
  var level = 0;
  var reducer = function reducer(acc, attr, index, arr) {
    if (attr.type || attr.id && attr.value) {
      acc.push(h(__WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue___default.a, {
        props: {
          definitionId: attr.definitionId,
          attribute: attr,
          inGroup: level > 0,
          isFirst: index === 0,
          isLast: index === arr.length - 1,
          isDraggable: enableDragAndDrop,
          level: level
        }
      }));
    }

    if (attr.children) {
      level++;
      var isSuperGroup = attr.children.filter(function (a) {
        return a.children;
      }).length;

      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.left,
        bracketType: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        level: level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.left,
        isDraggable: enableDragAndDrop,
        attribute: attr,
        level: level
      }));

      acc.concat(attr.children.reduce(reducer, acc));

      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.right,
        bracketType: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        level: level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.right,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        level: level
      }));
      level--;
    }

    if (attr.operator) {
      acc.push(h(__WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue___default.a, {
        props: {
          definitionId: attr.definitionId,
          operator: attr,
          isDraggable: enableDragAndDrop,
          level: level
        }
      }));
    }

    return acc;
  };
  return definition.reduce(reducer, []);
}

function createBracketIcon(h, _ref) {
  var definitionId = _ref.definitionId,
      direction = _ref.direction,
      _ref$bracketType = _ref.bracketType,
      bracketType = _ref$bracketType === undefined ? __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.BRACKET_TYPE.normal : _ref$bracketType,
      attribute = _ref.attribute,
      isDraggable = _ref.isDraggable,
      level = _ref.level;

  return h(__WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a, {
    props: {
      definitionId: definitionId,
      direction: direction,
      bracketType: bracketType,
      attribute: attribute,
      isDraggable: isDraggable,
      level: level
    }
  });
}

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AttributePanel_vue__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AttributePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AttributePanel_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_AttributePanel_vue___default.a);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tree_model__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tree_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tree_model__);






var AttributeTree = function () {
  function AttributeTree() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AttributeTree);

    this._treeModel = new __WEBPACK_IMPORTED_MODULE_4_tree_model___default.a();
    this.droppedNodes = null;
    this.root = this._treeModel.parse({
      name: 'Data Sources',
      children: []
    });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AttributeTree, [{
    key: 'addDataSource',
    value: function addDataSource(dataSource) {
      var node = this._treeModel.parse(dataSource);
      this.root.addChild(node);
    }
  }, {
    key: 'addBackDroppedDatasets',
    value: function addBackDroppedDatasets() {
      if (this.droppedNodes) {
        var listOfAllNodes = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.root.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var n = _step.value;

            listOfAllNodes.push(n);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listOfAllNodes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _n = _step2.value;

            _n.drop();
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        listOfAllNodes = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(listOfAllNodes), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.droppedNodes));
        listOfAllNodes.sort(function (a, b) {
          return a.model.name.toLowerCase().localeCompare(b.model.name.toLowerCase());
        });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listOfAllNodes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var d = _step3.value;

            this.root.addChild(d);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        this.droppedNodes = null;
      }
    }
  }, {
    key: 'dropNodes',
    value: function dropNodes(datasets) {
      var nodesToDrop = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.root.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var node = _step4.value;

          if (!datasets.includes(node.model.id)) {
            nodesToDrop.push(node);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(nodesToDrop), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var n = _step5.value;

          n.drop();
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (nodesToDrop.length > 0) {
        this.droppedNodes = nodesToDrop;
      }
    }
  }]);

  return AttributeTree;
}();

/* harmony default export */ __webpack_exports__["a"] = (AttributeTree);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_search__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_search__);




var SearchService = function () {
  function SearchService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SearchService);

    this.dataSources = [];
    this.preSearchedDataSources = [];
    this.originalDataSources = [];
    this.filter = [];
    this.initialized = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SearchService, [{
    key: 'addDataSource',
    value: function addDataSource(_ref) {
      var name = _ref.name,
          attributes = _ref.attributes;

      this.originalDataSources.push({
        name: name,
        attributes: attributes
      });
    }
  }, {
    key: 'init',
    value: function init() {
      this.filterDatasets();
      this.dataSources = this.preSearchedDataSources.map(function (dataSource) {
        var s = new __WEBPACK_IMPORTED_MODULE_2_js_search__["Search"]('id');
        s.searchIndex = new __WEBPACK_IMPORTED_MODULE_2_js_search__["UnorderedSearchIndex"]();
        s.addIndex('search');
        s.addDocuments(dataSource.attributes);
        return {
          name: dataSource.name,
          searchIndex: s
        };
      });
      this.initialized = true;
    }
  }, {
    key: 'filterDatasets',
    value: function filterDatasets(filterset) {
      var _this = this;

      this.filter = filterset || this.filter;
      if (this.filter.length > 0) {
        var filteredDataSources = this.originalDataSources.filter(function (x) {
          return !_this.filter.includes(x.name);
        });
        this.preSearchedDataSources = filteredDataSources;
        this.dataSources = [];
        this.initialized = false;
      } else {
        this.preSearchedDataSources = this.originalDataSources;
      }
    }
  }, {
    key: 'resetDatasets',
    value: function resetDatasets() {
      this.preSearchedDataSources = this.originalDataSources;
      this.filter = [];
      this.dataSources = [];
      this.initialized = false;
    }
  }, {
    key: 'search',
    value: function search(term) {
      if (!this.initialized) {
        this.init();
      }
      return this.dataSources.map(function (dataSource) {
        return {
          name: dataSource.name,
          results: dataSource.searchIndex.search(term)
        };
      });
    }
  }]);

  return SearchService;
}();

/* harmony default export */ __webpack_exports__["a"] = (SearchService);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AudienceSize_vue__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AudienceSize_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AudienceSize_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_AudienceSize_vue___default.a);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bubble"].extend({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: {
    axises: {
      type: Object,
      required: true
    }
  },
  computed: {
    options: function options() {
      return {
        layout: {
          padding: {
            left: 0,
            right: 10,
            top: 10,
            bottom: 0
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              tickMarkLength: 5,
              color: '#000'
            },
            ticks: {
              fontSize: 10,
              min: this.axises.x.min,
              max: this.axises.x.max
            }
          }],
          yAxes: [{
            gridLines: {
              tickMarkLength: 5,
              color: '#000'
            },
            ticks: {
              fontSize: 10,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function callback(value, index, values) {
                return index === 0 ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* isDecimal */])(value) ? value.toFixed(1) : value;
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontSize: 10,
          bodySpacing: 1,
          displayColors: false,
          footerFontSize: 9,
          footerFontStyle: 'normal',
          titleFontSize: 10,
          titleSpacing: 0,
          titleMarginBottom: 2,
          labelFontSize: 10,
          footerMarginTop: 3,
          xPadding: 4,
          yPadding: 4,
          cornerRadius: 3,
          callbacks: {
            title: function title(tooltip, data) {
              return '' + data.datasets[tooltip[0].datasetIndex].title;
            },
            label: function label(tooltip, data) {
              return '' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(data.datasets[tooltip.datasetIndex].label));
            },
            footer: function footer(tooltip, data) {
              return 'Rating: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(tooltip[0].xLabel.toFixed(3)) + ' Index: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip[0].yLabel));
            }
          }
        }
      };
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DayParts_vue__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DayParts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DayParts_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_DayParts_vue___default.a);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bubble"].extend({
  props: {
    chartId: {
      type: String,
      default: 'viewership-graph'
    },
    chartData: {
      type: Object,
      required: true
    },
    axises: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function
    }
  },
  computed: {
    options: function options() {
      var _this = this;

      return {
        onClick: function onClick(event, elements) {
          if (elements.length === 0) return;
          if (_this.onClick) {
            _this.onClick(_this.chartData.datasets[elements[0]._datasetIndex].network);
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 25,
            top: 20,
            bottom: 0
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              fontSize: 13,
              min: this.axises.x.min,
              max: this.axises.x.max,
              callback: function callback(value, index, values) {
                return index === values.length - 1 || index === 0 && value !== 0 ? '' : value === 0 ? 0 : value.toFixed(3);
              }
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              padding: 2,
              fontSize: 13,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function callback(value, index, values) {
                return index === values.length - 1 || index === 0 && value !== 0 ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* isDecimal */])(value) ? value.toFixed(1) : value;
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontStyle: 'bold',
          footerFontStyle: 'normal',
          displayColors: false,
          callbacks: {
            label: function label(tooltip, data) {
              return '' + data.datasets[tooltip.datasetIndex].label;
            },
            footer: function footer(tooltip, data) {
              return 'Rating: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip[0].xLabel.toFixed(3))) + ' Index: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(String(tooltip[0].yLabel));
            }
          }
        }
      };
    }
  },
  methods: {
    renderChartOnDataChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
      this._chart ? this._chart.destroy() : undefined;
      this.renderChart(this.chartData, this.options);
    }, 100)
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    'chartData': function chartData() {
      this.renderChartOnDataChange();
    },
    'options': function options() {
      this.renderChartOnDataChange();
    }
  }
}));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DateRange_vue__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DateRange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DateRange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(311);
/* unused harmony reexport module */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_DateRange_vue___default.a);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatAudienceSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);


var formatIndex = function formatIndex(index) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* commaFormatString */])(String(index));
};

var formatRating = function formatRating(rating) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* commaFormatString */])(String(rating.toFixed(3)));
};

var formatAudienceSize = function formatAudienceSize(size) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* commaFormatString */])(size);
};

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Viewership_vue___default.a);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_popover__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showUEHoverOver: function showUEHoverOver(e) {
      if (!this.hoverOverPopover && this.hasHoverOverMessage) {
        this.hoverOverPopover = __WEBPACK_IMPORTED_MODULE_0__components_common_popover__["a" /* PopoverFactory */].createListBoxWithHoverOver({
          direction: 'top',
          list: [{ value: true, name: 'Path: ' + this.attribute.dataset + ' / ' + this.attribute.path + ' /' }, { value: true, name: this.hoverOverMessage }],
          parent: e.currentTarget,
          hoverOver: this.$el
        });
        this.popover = this.hoverOverPopover;
      }
    },
    hideUEHoverOver: function hideUEHoverOver(e) {
      if (this.hoverOverPopover) {
        this.hoverOverPopover = null;
      }
    }
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: {
    definition: {
      type: Array,
      required: true
    },
    enableDragAndDrop: {
      type: Boolean,
      default: false
    },
    enableNot: {
      type: Boolean,
      default: true
    },
    enableMinus: {
      type: Boolean,
      default: true
    },
    isDraggingPart: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h, context) {
    var p = context.props;
    var renderThis = flattenedDefinitionComponents(h, p.definition, p.enableDragAndDrop, p.disabled, p.enableNot, p.enableMinus);
    if (p.enableDragAndDrop && p.isDraggingPart) {
      renderThis.push(h(__WEBPACK_IMPORTED_MODULE_3__DefinitionNodeDropZone_vue___default.a));
    }
    return h('div', {
      attrs: {
        id: 'target-definition-statement',
        class: 'target-definition-statement'
      },
      style: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
      }
    }, renderThis);
  }
});

function flattenedDefinitionComponents(h, definition, enableDragAndDrop, disabled, enableNot, enableMinus) {
  var level = 0;
  var reducer = function reducer(acc, attr, index, arr) {
    if (attr.type || attr.id && attr.value) {
      acc.push(h(__WEBPACK_IMPORTED_MODULE_1__DefinitionNode_vue___default.a, {
        props: {
          definitionId: attr.definitionId,
          attribute: attr,
          inGroup: level > 0,
          isFirst: index === 0,
          isLast: index === arr.length - 1,
          isDraggable: enableDragAndDrop,
          disabled: disabled,
          level: level
        }
      }));
    }

    if (attr.children) {
      level++;
      var isSuperGroup = attr.children.filter(function (a) {
        return a.children;
      }).length;

      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.left,
        bracketType: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        disabled: disabled,
        level: level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.left,
        isDraggable: enableDragAndDrop,
        attribute: attr,
        disabled: disabled,
        level: level
      }));

      acc.concat(attr.children.reduce(reducer, acc));

      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.right,
        bracketType: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        disabled: disabled,
        level: level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.DIRECTION.right,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        disabled: disabled,
        level: level
      }));
      level--;
    }

    if (attr.operator) {
      acc.push(h(__WEBPACK_IMPORTED_MODULE_2__DefinitionOperator_vue___default.a, {
        props: {
          definitionId: attr.definitionId,
          operator: attr,
          isDraggable: enableDragAndDrop,
          disabled: disabled,
          level: level,
          enableNot: enableNot,
          enableMinus: enableMinus
        }
      }));
    }

    return acc;
  };
  return definition.reduce(reducer, []);
}

function createBracketIcon(h, _ref) {
  var definitionId = _ref.definitionId,
      direction = _ref.direction,
      _ref$bracketType = _ref.bracketType,
      bracketType = _ref$bracketType === undefined ? __WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a.BRACKET_TYPE.normal : _ref$bracketType,
      attribute = _ref.attribute,
      isDraggable = _ref.isDraggable,
      disabled = _ref.disabled,
      level = _ref.level;

  return h(__WEBPACK_IMPORTED_MODULE_0__DefinitionBracket_vue___default.a, {
    props: {
      definitionId: definitionId,
      direction: direction,
      bracketType: bracketType,
      attribute: attribute,
      isDraggable: isDraggable,
      disabled: disabled,
      level: level
    }
  });
}

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_serializer__ = __webpack_require__(205);




var MAX_NESTING_LEVEL = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  canNotUndo: function canNotUndo(state, getters) {
    return getters['undoHistory/canNotUndo'];
  },
  canNotRedo: function canNotRedo(state, getters) {
    return getters['undoHistory/canNotRedo'];
  },
  getDefinition: function getDefinition(state) {
    return state.definition.children;
  },
  aDefinition: function aDefinition(state) {
    return state.definition;
  },
  selected: function selected(state) {
    return state.selected;
  },
  targetDefinitionLastAttributeCommand: function targetDefinitionLastAttributeCommand(state) {
    return state.lastAttributeCommand;
  },
  selectedCount: function selectedCount(state) {
    return state.selected.length;
  },
  hasDefinition: function hasDefinition(state) {
    return state.definition.children.length > 0;
  },
  serializedDefinition: function serializedDefinition(state) {
    return __WEBPACK_IMPORTED_MODULE_2__services_serializer__["a" /* default */].serialize(state.definition);
  },
  lastTimeTargetWasChanged: function lastTimeTargetWasChanged(state) {
    return state.lastTimeTargetWasChanged;
  },
  selectedCanBeGrouped: function selectedCanBeGrouped(state, getters) {
    return getters.hasDefinition && getters.selectedCount > 1 && findMaxDepth(state.definition.children, state.selected[0]) + Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.selected.map(function (selected) {
      return getDepthCount(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, selected));
    }))) < MAX_NESTING_LEVEL;
  },
  selectedCanBeUngrouped: function selectedCanBeUngrouped(state, getters) {
    return getters.hasDefinition && getters.selectedCount > 0 && state.selected.every(function (selectedId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, selectedId));
    });
  },
  selectedCanBecomeCountGroup: function selectedCanBecomeCountGroup(state, getters) {
    return getters.hasDefinition && getters.selectedCount === 1 && state.selected.every(function (selectedId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, selectedId));
    });
  },
  selectedCanBeDeleted: function selectedCanBeDeleted(state, getters) {
    return getters.hasDefinition && getters.selectedCount > 0;
  },
  isAttributeSelected: function isAttributeSelected(state, getters) {
    return function (attr) {
      return state.selected.some(function (selectedId) {
        return attr.definitionId === selectedId;
      }) || getters.isAttributeInSelectedGroup(attr);
    };
  },
  isAttributeInSelectedGroup: function isAttributeInSelectedGroup(state, getters) {
    return function (attr) {
      return state.selected.filter(function (selected) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(getters.getDefinitionPartById(selected));
      }).map(getters.getDefinitionPartById).some(function (group) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(group, attr.definitionId);
      });
    };
  },
  isTargetEditable: function isTargetEditable(state) {
    return !state.viewOnly;
  },
  getDefinitionPartById: function getDefinitionPartById(state) {
    return function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, id);
    };
  },
  canDraggingItemDropHere: function canDraggingItemDropHere(state, getters) {
    return function (id, depth) {
      var draggingItemId = state.dragAndDrop.draggingItem;

      if (draggingItemId === id) {
        return false;
      }
      var draggingItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, draggingItemId);
      var dropArea = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, id);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(draggingItem) && depth === MAX_NESTING_LEVEL || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["b" /* isCountGroup */])(dropArea) || getters.isInACountGroup(id)) return false;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["e" /* isGroup */])(draggingItem)) {
        var isInCurrentDraggingGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["f" /* recursiveFilter */])(draggingItem, function (def) {
          return def.definitionId === id;
        }).length > 0;
        if (isInCurrentDraggingGroup) return false;
      }
      return true;
    };
  },
  disableDefinitionPart: function disableDefinitionPart(state, getters) {
    return function (id) {
      if (!getters.isTargetEditable) return true;
      return false;
    };
  },
  isDragAndDropActive: function isDragAndDropActive(state) {
    return state.dragAndDrop.active;
  },
  isDraggingPart: function isDraggingPart(state) {
    return !!state.dragAndDrop.draggingItem;
  },
  selectedAttributes: function selectedAttributes(state) {
    if (state.selected.length > 0) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.selected)).map(function (partId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["d" /* findDefinitionPartById */])(state.definition, partId);
      });
    }
    return [];
  },
  isInACountGroup: function isInACountGroup(state, getters) {
    return function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["f" /* recursiveFilter */])(state.definition, function (part) {
        var found = false;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mutations__["b" /* isCountGroup */])(part)) {
          found = part.children.find(function (child) {
            return child.definitionId === id;
          });
        }
        return found;
      }).length > 0;
    };
  },
  updateLasTD: function updateLasTD(state) {
    return state.updateLasTD;
  }
});

function getDepthCount(node) {
  return !(node && node.children) ? 0 : Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(node.children.map(function (child) {
    return getDepthCount(child);
  }))) + 1;
}

function findMaxDepth(definition, definitionId) {
  var startingDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  for (var i = 0; i < definition.length; i++) {
    if (definition[i].definitionId === definitionId) {
      return startingDepth;
    }
    if (definition[i].children) {
      var foundDepth = findMaxDepth(definition[i].children, definitionId, startingDepth + 1);
      if (foundDepth > -1) return foundDepth;
    }
  }
  return -1;
}

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_plugins_undoHistory__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(38);









var createModule = function createModule(namespace) {
  var n = namespace ? namespace + '/' : '';
  return {
    state: function state() {
      return {
        selected: [],
        definition: {
          root: true,
          children: []
        },
        viewOnly: false,
        dragAndDrop: {
          active: false,
          draggingItem: null
        },
        lastTimeTargetWasChanged: null,
        lastAttributeCommand: null
      };
    },

    getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["c" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_5__actions__["w" /* default */],
    modules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_plugins_undoHistory__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], {
      filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_plugins_undoHistory__["c" /* isMutationType */])([n + __WEBPACK_IMPORTED_MODULE_5__actions__["k" /* ADD_ATTRIBUTE */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["c" /* REMOVE_ATTRIBUTE */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["l" /* UPDATE_ATTRIBUTE */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["g" /* UPDATE_OPERATOR */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["q" /* CLEAR_DEFINITION */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* GROUP */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["e" /* UNGROUP */], n + __WEBPACK_IMPORTED_MODULE_5__actions__["r" /* MOVE_ATTRIBUTE */]]),
      initialValue: [],
      reducer: function reducer(state) {
        return state[namespace].targetDefinition.definition.children;
      },
      restoreState: function restoreState(state) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(n + __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* SET_DEFINITION */], state);
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(n + __WEBPACK_IMPORTED_MODULE_5__actions__["f" /* CLEAR_SELECTION */]);
      }
    }, { add: true, namespace: namespace }).module)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createModule);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sumOfAgeTimesPeople */
/* unused harmony export sumOfPeople */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMeanOfAges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marketBreakAveragesGraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ageDistributionGraphData; });
/* unused harmony export ageGraphData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_datastructures_DistributionDS__ = __webpack_require__(756);




var MAX_AGE = 99;
var BREAKS = [{ begin: 1, end: 11 }, { begin: 12, end: 17 }, { begin: 18, end: 24 }, { begin: 25, end: 34 }, { begin: 35, end: 49 }, { begin: 50, end: 64 }, { begin: 65, end: MAX_AGE }];

var getMarketBreakAverages = function getMarketBreakAverages(ages) {
  var marketBreaks = [];
  var totalSum = 0;

  var _loop = function _loop(breaker) {
    var ageBreak = ages.filter(function (a) {
      return a.age >= breaker.begin && a.age <= breaker.end;
    });
    if (ageBreak.length > 0) {
      var sumPeople = sumOfPeople(ageBreak);
      totalSum += sumPeople;
      marketBreaks.push({
        break: breaker,
        label: breaker.begin + ' - ' + breaker.end,
        value: sumPeople
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(BREAKS), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var breaker = _step.value;

      _loop(breaker);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(marketBreaks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var breaker = _step2.value;

      breaker['percentage'] = breaker.value / totalSum * 100;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return marketBreaks;
};

var sumOfAgeTimesPeople = function sumOfAgeTimesPeople(ages) {
  return ages.reduce(function (acc, val) {
    if (typeof acc !== 'number') {
      acc = acc.value * acc.age;
    }
    return acc + val.age * val.value;
  });
};

var sumOfPeople = function sumOfPeople(ages) {
  if (ages.length === 0) {
    return 0;
  } else if (ages.length === 1) {
    return ages[0].value;
  } else {
    return ages.reduce(function (acc, val) {
      if (typeof acc !== 'number') {
        acc = acc.value;
      }
      return acc + val.value;
    });
  }
};

var getMeanOfAges = function getMeanOfAges(ages) {
  var totalNumberOfPeople = sumOfPeople(ages);
  var sumOfAges = sumOfAgeTimesPeople(ages);
  var mean = sumOfAges / totalNumberOfPeople;
  return parseFloat(Math.round(mean * 100) / 100).toFixed(2);
};

var ageGraphData = function ageGraphData(ages) {
  var data = ages.map(function (d) {
    return d.value;
  });

  var totalNumberOfPeople = data.reduce(function (acc, val) {
    return acc + val;
  });
  var percentages = data.map(function (d) {
    return d / totalNumberOfPeople * 100;
  });

  var sumOfAges = ages.reduce(function (acc, val) {
    if (typeof acc !== 'number') {
      acc = acc.value * acc.value;
    }
    return acc + val.age * val.value;
  });
  var meanAge = sumOfAges / totalNumberOfPeople;
  var labels = ages.map(function (d) {
    return String(d.age);
  });
  var label = 'Age Distribution';
  return {
    labels: labels,
    datasets: [{
      label: label,
      data: percentages,
      backgroundColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].DARK_BLUE,
      borderColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].BORDER_COLOR,
      addMean: {
        mean: meanAge
      }
    }]
  };
};

var marketBreakAveragesGraphData = function marketBreakAveragesGraphData(ages) {
  var marketBreakers = getMarketBreakAverages(ages);
  return {
    labels: marketBreakers.map(function (br) {
      return br.label;
    }),
    datasets: [{
      label: 'Market Breakers Ages',
      data: marketBreakers.map(function (br) {
        return br.percentage;
      }),
      backgroundColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].DARK_BLUE,
      hoverBackgroundColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].LIGHT_BLUE,
      borderColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].BORDER_COLOR
    }]
  };
};

var ageDistributionGraphData = function ageDistributionGraphData(ages) {
  var data = ages.map(function (d) {
    return d.value;
  });

  var sum = data.reduce(function (acc, val) {
    return acc + val;
  });
  var percentages = data.map(function (d) {
    return d / sum * 100;
  });

  var ds = new __WEBPACK_IMPORTED_MODULE_2__common_datastructures_DistributionDS__["a" /* default */](percentages, ages.map(function (d) {
    return String(d.age);
  }), 10);
  var label = 'Age Distribution';
  return ds.getDistribution(label, {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].DARK_BLUE,
    hoverBackgroundColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].LIGHT_BLUE,
    borderColor: __WEBPACK_IMPORTED_MODULE_1__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].BORDER_COLOR
  });
};



/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return incomeGraphData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_appConstants_ColorSchema__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);



var incomeGraphData = function incomeGraphData(income) {
  var data = income.map(function (d) {
    return d.value;
  });

  var sum = data.reduce(function (acc, val) {
    return acc + val;
  });
  var percentages = data.map(function (d) {
    return d / sum * 100;
  });

  var labels = income.map(function (d) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["i" /* formatSmallMoney */])(String(d.startIncome)) + ' - ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["i" /* formatSmallMoney */])(String(d.finishIncome));
  });
  var label = 'Income Distribution';
  return {
    labels: labels,
    datasets: [{
      label: label,
      data: percentages,
      backgroundColor: __WEBPACK_IMPORTED_MODULE_0__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].DARK_BLUE,
      hoverBackgroundColor: __WEBPACK_IMPORTED_MODULE_0__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].LIGHT_BLUE,
      borderColor: __WEBPACK_IMPORTED_MODULE_0__appLogic_appConstants_ColorSchema__["a" /* GRAPH_COLORS */].BORDER_COLOR
    }]
  };
};



/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);




var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SET_NETWORKS */], function (_ref) {
  var commit = _ref.commit,
      state = _ref.state;

  if (state.networks.length === 0) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["q" /* fetchNetworksConfig */])().then(function (networks) {
      commit(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SET_NETWORKS */], networks.networks);
      commit(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SET_NETWORKS_GROUPINGS */], networks.categories);
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(158);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SET_NETWORKS_GROUPINGS */], function (state, groupings) {
  state.groupings = groupings;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SET_NETWORKS */], function (state, networks) {
  state.networks = networks;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notificationConstants__ = __webpack_require__(159);




var NotificationEngine = function () {
  function NotificationEngine() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NotificationEngine);

    this.currentNotification = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NotificationEngine, [{
    key: 'get',
    value: function get(not) {
      this.currentNotification = not;
      switch (not.notification_type) {
        case __WEBPACK_IMPORTED_MODULE_2__notificationConstants__["b" /* TYPES */].ASSIGNED_OPEN_AP:
          return {
            title: 'Import Open AP Target',
            action: this.openAPFunction
          };
        case __WEBPACK_IMPORTED_MODULE_2__notificationConstants__["b" /* TYPES */].USER:
          return {
            title: 'Select Market Demo',
            action: this.marketDemoFunction
          };
      }
    }
  }]);

  return NotificationEngine;
}();

/* harmony default export */ __webpack_exports__["a"] = (NotificationEngine);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(730);



var state = function state() {
  return {
    notifications: {
      openAP: [],
      allUserNotifications: [],
      allTargetNotifications: [],
      targets: {},
      user: []
    }
  };
};

var getters = {
  userNotifications: function userNotifications(state) {
    return state.notifications.allUserNotifications;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notificationConstants__ = __webpack_require__(159);





var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* SET_NOTIFICATIONS */], function (state, _ref) {
  var notifications = _ref.notifications,
      user = _ref.user;

  var userNotifications = [];
  var targetNotifications = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(notifications), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var n = _step.value;

      if (n.user_id && n.user_id.toString().toLowerCase() === user.toLowerCase()) {
        userNotifications.push(n);
      } else if (n.notification_type === __WEBPACK_IMPORTED_MODULE_5__notificationConstants__["a" /* default */].TYPE_AUDIENCE_MATTERS.toLowerCase()) {
        targetNotifications.push(n);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  state.notifications.allUserNotifications = userNotifications;
  state.notifications.allTargetNotifications = targetNotifications;
  createNotification(state.notifications);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* DELETE_NOTIFICATION */], function (state, notification) {
  var nots = state.notifications;
  nots.allUserNotifications = nots.allUserNotifications.filter(function (n) {
    return n.id !== notification.id;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* UPDATE_NOTIFICATION */], function (state, notification) {
  var idx = state.notifications.findIndex(function (n) {
    return n.id === notification.id;
  });
  if (idx === -1) state.notifications.push(notification);else state.notifications[idx] = notification;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* REMOVE_NOTIFICATION */], function (state, notificationsToDelete) {
  var removeFromUsers = [];
  var removeFromTargets = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(notificationsToDelete), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var n = _step2.value;

      if (n.user_id) {
        removeFromUsers.push(n.id);
      } else if (n.target_id) {
        removeFromTargets[n.id] = n;
      } else {}
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  state.notifications.allUserNotifications = filterIdsToRemove(removeFromUsers, state.notifications.allUserNotifications);
  state.notifications.allTargetNotifications = filterIdsToRemove(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(removeFromTargets), state.notifications.allTargetNotifications);
  createUserNotifications(state.notifications);
  var targetNotifications = state.notifications.targets;
  if (targetNotifications) {
    var _loop = function _loop(_n) {
      targetNotifications[_n.target_id] = targetNotifications[_n.target_id].filter(function (tn) {
        return tn.id !== _n.id;
      });
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(removeFromTargets)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _n = _step3.value;

        _loop(_n);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  } else {
    createTargetNotifications(state.notifications);
  }
}), _mutations);

var filterIdsToRemove = function filterIdsToRemove(idsToRemove, listToRemoveFrom) {
  var setOfObjects = {};
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(listToRemoveFrom), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var n = _step4.value;

      setOfObjects[n.id] = n;
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(idsToRemove), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var id = _step5.value;

      delete setOfObjects[id];
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(setOfObjects);
};

var createUserNotifications = function createUserNotifications(notifications) {
  notifications.openAP = notifications.allUserNotifications.filter(function (n) {
    return n.notification_type === __WEBPACK_IMPORTED_MODULE_5__notificationConstants__["a" /* default */].TYPE_OPEN_AP.toLowerCase();
  });
};

var createTargetNotifications = function createTargetNotifications(notifications) {
  var targetDict = {};
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(notifications.allTargetNotifications), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var n = _step6.value;

      var targetList = targetDict[n.target_id];
      if (!targetList) {
        targetList = [];
        targetDict[n.target_id] = targetList;
      }
      targetList.push(n);
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(targetDict)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var list = _step7.value;

      list.sort(function (n1, n2) {
        return n1.id - n2.id;
      });
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  notifications.targets = targetDict;
};

var createNotification = function createNotification(notifications) {
  createUserNotifications(notifications);
  createTargetNotifications(notifications);
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(69);


var _actions;






var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* TOGGLE_PERMISSION */], function (context, _ref) {
  var permissionId = _ref.permissionId,
      categoryId = _ref.categoryId;

  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* TOGGLE_PERMISSION */], { permissionId: permissionId, categoryId: categoryId });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* TOGGLE_CATEGORY_PERMISSIONS */], function (context, _ref2) {
  var category = _ref2.category,
      setValue = _ref2.setValue;

  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* TOGGLE_CATEGORY_PERMISSIONS */], { category: category, setValue: setValue });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SET_CATEGORY_PERMISSIONS */], function (context, _ref3) {
  var categoryId = _ref3.categoryId,
      permissions = _ref3.permissions;

  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SET_CATEGORY_PERMISSIONS */], { categoryId: categoryId, permissions: permissions });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SET_CATEGORIES */], function (context) {
  __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__["a" /* default */].getCategories().then(function (resp) {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* SET_CATEGORIES */], resp.data);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* SET_PERMISSIONS */], function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["c" /* getPermissions */])().then(function (resp) {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* SET_PERMISSIONS */], resp.data);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* SET_ROLES */], function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["d" /* getRoles */])().then(function (resp) {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* SET_ROLES */], resp.data);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["j" /* SET_ROOT_CATEGORY */], function (context, category) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* SET_ROOT_CATEGORY */], category);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* SET_SELECTED_PERMISSIONS */], function (context, permissions) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* SET_SELECTED_PERMISSIONS */], permissions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SET_USERS */], function (context) {
  __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__["a" /* default */].getUsers().then(function (resp) {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SET_USERS */], resp.data);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SHOW_DELETE_USER_MODAL */], function (context) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SHOW_DELETE_USER_MODAL */]);
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(733);




var state = function state() {
  return {
    selectedPermissions: {},
    selectedCategories: {},
    rootCategory: {},
    appPermissions: [],
    categories: [],
    roles: [],
    users: [],
    showDeleteUserModal: false
  };
};

var getters = {
  allselectedPermissions: function allselectedPermissions(state) {
    var perms = [];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.selectedPermissions).forEach(function (e) {
      return perms.push.apply(perms, state.selectedPermissions[e]);
    });
    return perms;
  },
  appPermissions: function appPermissions(state) {
    return state.appPermissions;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(69);






var _mutations;



var getPermissionsFromCategory = function getPermissionsFromCategory(category) {
  var permissions = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(category.sub_categories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var subCategory = _step.value;

      permissions.push.apply(permissions, getPermissionsFromCategory(subCategory));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  permissions.push.apply(permissions, category.permissions);
  return permissions;
};

var setPermissionsFromCategory = function setPermissionsFromCategory(category, permissions, setValue) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(category.sub_categories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var subCategory = _step2.value;

      permissions = setPermissionsFromCategory(subCategory, permissions, setValue);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (!permissions[category.id]) {
    permissions[category.id] = [];
  }
  if (setValue) {
    permissions[category.id] = category.permissions.map(function (p) {
      return p.id;
    });
  } else {
    permissions[category.id] = [];
  }
  return permissions;
};

var setSelectedCategories = function setSelectedCategories(rootCategory, permissions) {
  var permissionKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(permissions);
  var listOfPerms = permissionKeys.reduce(function (prev, key) {
    permissions[key].forEach(function (el) {
      return prev.push(el);
    });
    return prev;
  }, []);
  var permissionSet = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(listOfPerms);
  var categoriesFilled = {};
  transversePermissions(rootCategory, permissionSet, categoriesFilled);
  return categoriesFilled;
};

var transversePermissions = function transversePermissions(rootCategory, permissionSet, categoriesFilled) {
  var filledChildren = true;
  var booleanList = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(rootCategory.sub_categories), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var subCat = _step3.value;

      booleanList.push(transversePermissions(subCat, permissionSet, categoriesFilled));
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  booleanList.forEach(function (b) {
    filledChildren = filledChildren && b;
  });
  var hasPerms = true;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(rootCategory.permissions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var perm = _step4.value;

      hasPerms = hasPerms && permissionSet.has(perm.id);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var filled = filledChildren && hasPerms;
  categoriesFilled[rootCategory.id] = filled;
  return filled;
};

var setPermissionsForCategories = function setPermissionsForCategories(permissions, rootCategory, categoryPermissions) {
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(rootCategory.sub_categories), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var subCat = _step5.value;

      setPermissionsForCategories(permissions, subCat, categoryPermissions);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  categoryPermissions[rootCategory.id] = rootCategory.permissions.filter(function (el) {
    return permissions.includes(el.id);
  }).map(function (el) {
    return el.id;
  });
  return categoryPermissions;
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* TOGGLE_PERMISSION */], function (state, _ref) {
  var permissionId = _ref.permissionId,
      categoryId = _ref.categoryId;

  if (!state.selectedPermissions[categoryId]) {
    state.selectedPermissions[categoryId] = [];
  }
  var perms = state.selectedPermissions[categoryId];
  var filtered = perms.filter(function (p) {
    return p === permissionId;
  });
  if (filtered.length > 0) {
    state.selectedPermissions[categoryId] = perms.filter(function (p) {
      return p !== permissionId;
    });
  } else {
    perms.push(permissionId);
  }
  state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* TOGGLE_CATEGORY_PERMISSIONS */], function (state, _ref2) {
  var category = _ref2.category,
      setValue = _ref2.setValue;

  setPermissionsFromCategory(category, state.selectedPermissions, setValue);
  state.selectedPermissions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.selectedPermissions);
  state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* SET_CATEGORY_PERMISSIONS */], function (state, _ref3) {
  var categoryId = _ref3.categoryId,
      permissions = _ref3.permissions;

  state.selectedPermissions[categoryId] = permissions;
  state.selectedPermissions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.selectedPermissions);
  state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* SET_SELECTED_PERMISSIONS */], function (state, permissions) {
  state.selectedPermissions = setPermissionsForCategories(permissions, state.rootCategory, {});
  state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* SET_CATEGORIES */], function (state, categories) {
  state.categories = categories;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* SET_PERMISSIONS */], function (state, permissions) {
  state.appPermissions = permissions.reduce(function (permission, p) {
    permission[p.name] = p.id;
    return permission;
  }, {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* SET_ROLES */], function (state, roles) {
  state.roles = roles;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* SET_ROOT_CATEGORY */], function (state, category) {
  state.rootCategory = category;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SET_USERS */], function (state, users) {
  state.users = users;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* SHOW_DELETE_USER_MODAL */], function (state) {
  state.showDeleteUserModal = state.showDeleteUserModal ? state.showDeleteUserModal + 1 : 1;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(103);



var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* SET_BRANCHES */], function (state, branches) {
  state.branches = branches;
  state.currentBranch = null;
  state.currentMove = null;
  state.primaryBranch = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* SET_PRIMARY_BRANCH */], function (state, branch) {
  state.primaryBranch = branch;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* SET_CURRENT_BRANCH */], function (state, branch) {
  state.currentBranch = branch;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SET_CURRENT_MOVE */], function (state, move) {
  state.currentMove = move;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* FORWARD_CURRENT_BRANCH */], function (state, revision) {
  if (state.currentBranch.histories.length + 1 === revision.move) {
    state.currentBranch.histories.unshift(revision);
  } else if (revision.move === 1) {
    state.currentBranch.histories = [revision];
  } else {
    var histories = state.currentBranch.histories;

    histories = histories.slice(histories.length - revision.move + 1);
    histories.unshift(revision);
    state.currentBranch.histories = histories;
  }
  state.currentBranch = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.currentBranch, {
    audience: revision.audience
  });
  state.currentMove = revision;
  var currentBranch = state.branches.find(function (b) {
    return b.id === state.currentBranch.id;
  });
  currentBranch.audience = revision.audience;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SET_CURRENT_MOVE */], function (state, revision) {
  state.currentMove = revision;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* ADD_BRANCH */], function (state, branch) {
  state.branches.push(branch);
  state.branches = [].concat(state.branches);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* DELETE_BRANCH */], function (state, branchId) {
  state.branches = state.branches.filter(function (b) {
    return b.id !== branchId;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(736);



var state = function state() {
  return {
    routeBack: 'user-audience-hub',
    routeBackOverride: null
  };
};

var getters = {};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(70);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* SET_BACK_ROUTE */], function (state, value) {
  state.routeBack = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* SET_BACK_ROUTE_OVERRIDE */], function (state, value) {
  state.routeBackOverride = value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createATTCreation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_AttAPI__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_toasts_RecurringToast__ = __webpack_require__(213);








var createATTCreation = function createATTCreation(_ref, _ref2) {
  var target = _ref.target,
      isNew = _ref.isNew,
      activate = _ref.activate,
      submitted = _ref.submitted,
      submittingOrHasSubmittedFile = _ref.submittingOrHasSubmittedFile;
  var afterSave = _ref2.afterSave,
      afterCreate = _ref2.afterCreate,
      afterUpload = _ref2.afterUpload,
      afterSubmit = _ref2.afterSubmit;

  var df = function df() {};
  var ATTCreation = {
    target: target,
    isNew: isNew,
    activate: activate,
    submitted: submitted,
    submittingFile: submittingOrHasSubmittedFile,
    afterSave: afterSave || df,
    afterCreate: afterCreate || df,
    afterUpload: afterUpload || df,
    afterSubmit: afterSubmit || df,
    run: function run() {
      if (this.activate) {
        return this.activateTarget();
      } else {
        return this.submitTarget();
      }
    },
    activateTarget: function activateTarget() {
      var _this = this;

      return this.createUpdateTarget().then(function (createdTarget) {
        var ppp = _this.uploadTargetFile(createdTarget);
        return ppp.then(function () {
          return createdTarget;
        });
      });
    },
    submitTarget: function submitTarget() {
      var _this2 = this;

      return this.activateTarget().then(function (createdTarget) {
        var submitTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(createdTarget);
        return _this2.submitTargetToATT(submitTarget).then();
      });
    },
    createUpdateTarget: function createUpdateTarget() {
      var _this3 = this;

      console.log({ targetToCreate: this.target });
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["m" /* createTarget */])(this.target).then(function (response) {
        var createdTarget = response.data;
        if (_this3.isNew) {
          adobeAnalytics.createTarget({
            username: _this3.target.username,
            target: {
              name: _this3.target.display_name,
              type: _this3.target.target,
              id: createdTarget.id
            }
          });
          _this3.afterCreate(createdTarget);
        } else {
          _this3.afterSave(createdTarget);
        }
        _this3.saveCreateNotification();
        return createdTarget;
      });
    },
    uploadTargetFile: function uploadTargetFile(createdTarget) {
      var _this4 = this;

      if (this.submittingFile && this.target.selectedFile) {
        var file = this.target.selectedFile;
        var splits = file.name.split('.');
        var extension = splits[splits.length - 1];
        var rt = new __WEBPACK_IMPORTED_MODULE_6__components_common_toasts_RecurringToast__["a" /* default */]({
          type: 'info',
          title: 'Waiting for File To Upload',
          message: 'Please do not close browser, waiting for file to upload',
          interval: 5000
        });
        rt.start();
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["F" /* uploadTargetFile */])({ target: createdTarget, file: { extension: extension } }).then(function (resUploadTargetFile) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["G" /* uploadFile */])(resUploadTargetFile.data.signedURL, file).then(function (resp) {
            rt.stop();
            _this4.uploadNotification();
            _this4.afterUpload();
            return createdTarget;
          });
        }).catch(function (ex) {
          rt.stop();
          __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].error({
            title: 'Error Uploading the File',
            message: 'There was an error uploading the file',
            timeout: 15000
          });
          throw ex;
        });
      } else {
        return new __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a(function (resolve, reject) {
          resolve(null);
        });
      }
    },
    submitTargetToATT: function submitTargetToATT(t) {
      if (this.submitted) {
        return __WEBPACK_IMPORTED_MODULE_4__api_AttAPI__["a" /* default */].updateATTCampaign({
          status: this.convertStatus(t.am_data.status),
          startDate: new Date(t.am_data.flightStartDate),
          endDate: new Date(t.am_data.AEFlightEndDate),
          cae_id: t.cae_id
        }).catch(function (err) {
          if (t.xandr_data.addressable) {
            __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].error({
              title: 'Error Updating campaign to XD',
              message: 'There was an error submitting an update to Xandr Data',
              timeout: 15000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].error({
              title: 'Error Updating target to AE',
              message: 'There was an error submitting an update to Audience Engine',
              timeout: 15000
            });
          }
          throw err;
        });
      } else {
        var selectedFile = this.target.am_data.selectedFileToUpload;
        var isAB = selectedFile && selectedFile.type === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["m" /* ATT_SELECT_TYPE_OPTIONS */].AUDIENCE_BUILDER;

        return __WEBPACK_IMPORTED_MODULE_4__api_AttAPI__["a" /* default */].submitATTCampaign({
          display_name: t.display_name,
          target_id: t.id,
          advertiserName: t.advertiser.Name,
          startDate: new Date(t.am_data.flightStartDate),
          endDate: new Date(t.am_data.AEFlightEndDate),
          cae_id: t.cae_id,
          viewing_stream: this.convertViewingStream(t.viewing_stream),
          file: {
            name: this.submittingFile ? '' : isAB ? selectedFile.stringDataId : selectedFile.file,
            action: this.submittingFile ? 'UPLOAD' : isAB ? 'AB' : 'SELECT'
          }
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].error({
            title: 'Error Submitting target to AE',
            message: 'There was an error submitting the target to Audience Engine',
            timeout: 15000
          });
          throw err;
        });
      }
    },
    saveCreateNotification: function saveCreateNotification() {
      var submitTextFirstTime = 'Successfully submitted the target: ' + this.target.display_name + ', you will be able to update it starting tomorrow.';
      var submittedText = 'Successfully updated and submitted the target: ' + this.target.display_name + '.';
      var updatedText = 'Successfully updated the target: ' + this.target.display_name + '.';
      var activateText = 'Successfully created and activated the new target: ' + this.target.display_name;
      var isActivatedorWorkingXandrTarget = (this.target.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED || this.target.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) && this.target.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT;
      var text = this.submitted ? this.isNew ? submitTextFirstTime : submittedText : activateText;
      if (isActivatedorWorkingXandrTarget) {
        text = updatedText;
      }
      var title = this.isNew ? 'Target Created' : 'Target Updated';
      __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].success({
        title: title,
        message: text,
        timeout: 15000
      });
    },
    uploadNotification: function uploadNotification() {
      __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].success({
        title: 'Uploaded File',
        message: 'The target file has successfully been uploaded',
        timeout: 15000
      });
    },
    errorNotification: function errorNotification() {
      __WEBPACK_IMPORTED_MODULE_1__components_common_toasts___["a" /* default */].error({
        title: 'Error processing target',
        message: 'There was an error while processing the target',
        timeout: 15000
      });
    },
    convertStatus: function convertStatus(s) {
      if (s === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["n" /* ATT_STATUS */].ORDERED) {
        return 'ORDERED';
      } else if (s === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["n" /* ATT_STATUS */].CANCELLED) {
        return 'CANCELLED';
      } else {
        return 'PLANNING';
      }
    },
    convertViewingStream: function convertViewingStream(vs) {
      if (vs === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LIVE3) {
        return 'C3';
      } else if (vs === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD) {
        return 'C0';
      }
    }
  };
  return ATTCreation;
};

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(739);



var state = function state() {
  return {
    appendPidOption: null,
    showStepperModal: null,
    isLoading: false,
    uploadModalOptions: null,
    initialTarget: null,
    appendType: null,
    stepperDataSourceTrigger: null,
    initialTargetAction: null,
    intents: null,
    demos: []
  };
};

var getters = {
  initialTarget: function initialTarget(state) {
    return state.initialTarget;
  },
  initialTargetAction: function initialTargetAction(state) {
    return state.initialTargetAction;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(26);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* SET_UPLOAD_MODAL_OPTIONS */], function (state, options) {
  state.uploadModalOptions = options;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* APPEND_PID */], function (state) {
  if (!state.appendPidOption) {
    state.appendPidOption = 1;
  } else {
    state.appendPidOption = state.appendPidOption + 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* SET_SHOW_MODAL_STEPPER */], function (state, payload) {
  var target = void 0;
  var step = null;
  if (payload.target) {
    target = payload.target;
  }
  if (payload.step !== undefined) {
    step = payload.step;
  }
  state.initialTarget = target;

  state.showStepperModal = step !== null ? step : 2;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* SET_INTENTS */], function (state, value) {
  state.intents = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* SET_LOADING */], function (state, value) {
  state.isLoading = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* UPLOAD_MODAL_SET_APPEND_TYPE */], function (state, appendType) {
  state.appendType = appendType;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* SET_INITIAL_TARGET_ACTION */], function (state, option) {
  state.initialTargetAction = option;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* SET_STEPPER_DATA_SOURCE */], function (state, option) {
  state.stepperDataSourceTrigger = option;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* SET_INITIAL_TARGET */], function (state, target) {
  state.initialTarget = target;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* SET_UPDATING_TARGET */], function (state, target) {
  state.initialTarget = target;
  state.initialTargetAction = target ? state.initialTargetAction : null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* IS_DIGITAL */], function (state, value) {
  state.is_digital = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* GET_DEMOS */], function (state, value) {
  state.demos = value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_graphs_LASDownloadableGraphs_vue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_graphs_LASDownloadableGraphs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appComponents_graphs_LASDownloadableGraphs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clientLogic_vue_utility__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__clientLogic_html2canvas_utility__ = __webpack_require__(752);












var downloadTarget = function downloadTarget(_ref) {
  var target = _ref.target,
      audienceSize = _ref.audienceSize,
      targetDefinition = _ref.targetDefinition,
      viewershipData = _ref.viewershipData,
      networks = _ref.networks,
      universeData = _ref.universeData,
      ageMarketData = _ref.ageMarketData,
      ageDistribution = _ref.ageDistribution,
      meanAge = _ref.meanAge,
      incomeDistribution = _ref.incomeDistribution;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__clientLogic_vue_utility__["a" /* renderComponent */])({ Component: __WEBPACK_IMPORTED_MODULE_6__appComponents_graphs_LASDownloadableGraphs_vue___default.a }, {
    propsData: {
      viewershipData: viewershipData,
      networks: networks,
      universeData: universeData,
      ageMarketBreakerData: ageMarketData,
      ageData: ageDistribution,
      incomeData: incomeDistribution,
      meanAge: meanAge
    }
  });
  return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve, reject) {
    setTimeout(function () {
      var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a({
        orientation: 'portrait',
        unit: 'in',
        format: [8.5, 11]
      });
      doc.setFontSize(11);

      doc.text(['Name: ' + target.display_name, '', 'Created by: ' + target.username + ' at ' + target.created, '', 'Audience Size: ' + audienceSize, '', 'Target:', ''].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* definitionAsString */])(targetDefinition))), 0.5, 0.5);
      __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a.join(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__clientLogic_html2canvas_utility__["a" /* toPNG */])(document.getElementById('viewership-graph-pdf')), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__clientLogic_html2canvas_utility__["a" /* toPNG */])(document.getElementById('universe-graph-pdf')), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__clientLogic_html2canvas_utility__["a" /* toPNG */])(document.getElementById('age-market-breaker-graph-pdf')), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__clientLogic_html2canvas_utility__["a" /* toPNG */])(document.getElementById('age-graph-pdf')), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__clientLogic_html2canvas_utility__["a" /* toPNG */])(document.getElementById('income-graph-pdf')), function (viewershipGraph, universeGraph, ageMarketGraph, ageGraph, incomeGraph) {
        doc.addPage();
        doc.text('Viewership:', 0.5, 0.4);
        doc.addImage(viewershipGraph, 'PNG', 0.4, 0.5, 7.5, 2.5);
        doc.text('Universe:', 0.5, 3.5);
        doc.addImage(universeGraph, 'PNG', 0.5, 3.7, 7.5, 2.5);
        doc.addPage();
        doc.addImage(ageGraph, 'PNG', 0.5, 0.7, 7.5, 2.5);
        doc.addImage(ageMarketGraph, 'PNG', 0.5, 3.7, 7.5, 2.5);
        doc.addImage(incomeGraph, 'PNG', 0.5, 6.7, 7.5, 2.5);
        var targetSummaryPDF = doc.output('blob');
        var zip = new __WEBPACK_IMPORTED_MODULE_4_jszip___default.a();
        zip.file('target-summary.pdf', targetSummaryPDF);
        zip.file('Viewership.jpeg', viewershipGraph.split(',')[1], { base64: true });
        zip.file('Universe.jpeg', universeGraph.split(',')[1], { base64: true });
        zip.file('Age-Market-Breaker.jpeg', ageMarketGraph.split(',')[1], { base64: true });
        zip.file('Age-Distribution.jpeg', ageGraph.split(',')[1], { base64: true });
        zip.file('Income-Distribution.jpeg', incomeGraph.split(',')[1], { base64: true });
        var zipFileName = target.display_name + '.zip';
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          __WEBPACK_IMPORTED_MODULE_5_file_saver___default.a.saveAs(content, zipFileName);
          resolve(zipFileName);
        });
      });
    }, 5000);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (downloadTarget);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(742);




var state = function state() {
  return {
    currentTarget: {},
    repostDates: [],
    segmentData: [],
    pidLists: [],
    currentNotification: {},
    selectedDayPartNetworks: [],
    selectedViewershipNetworks: [],
    droppedAttributes: [],
    showDeleteModal: null,
    showSelectMarketDemoModal: null,
    showAppendSegmentsModal: null,
    showDownloadPidListModal: null,
    showDroppedAttributesModal: false,
    isLoading: false,
    isDownloadingTarget: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(),
    isCompletedDownloadingTarget: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(),
    showRePostingModel: 0,
    promotedNetworks: null,
    hasChanged: false
  };
};

var getters = {
  selectedViewershipNetworks: function selectedViewershipNetworks(state) {
    return state.selectedViewershipNetworks;
  },
  currentTarget: function currentTarget(state) {
    return state.currentTarget;
  },
  currentTargetHasChanged: function currentTargetHasChanged(state) {
    return state.hasChanged;
  },
  segmentData: function segmentData(state) {
    return state.segmentData;
  },
  pidLists: function pidLists(state) {
    return state.pidLists;
  },
  isLoading: function isLoading(state) {
    return state.isLoading;
  },
  currentNotification: function currentNotification(state) {
    return state.currentNotification;
  },

  networksToShowDayParts: function networksToShowDayParts(state) {
    return state.selectedDayPartNetworks;
  },
  isDownloadingTarget: function isDownloadingTarget(state) {
    return state.isDownloadingTarget;
  },
  isCompletedDownloadingTarget: function isCompletedDownloadingTarget(state) {
    return state.isCompletedDownloadingTarget;
  }
};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(15);



var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* SET_CURRENT_TARGET */], function (state, target) {
  state.currentTarget = target;
  state.currentTarget.promotedNetworks = target.target_definition.promotedNetworks;
  state.hasChanged = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* SET_TARGET_NAME */], function (state, name) {
  if (state.currentTarget) {
    state.currentTarget.display_name = name;
    state.hasChanged = true;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* SET_TARGET_ADVERTISER */], function (state, advertiser) {
  if (state.currentTarget) {
    state.currentTarget.advertiser = advertiser;
    state.hasChanged = true;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* SET_LOADING_VALUE */], function (state, value) {
  state.isLoading = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* REMOVE_FROM_SELECTED_DAY_PART_NETWORKS */], function (state, index) {
  state.selectedDayPartNetworks.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* ADD_TO_SELECTED_DAY_PART_NETWORKS */], function (state, network) {
  state.selectedDayPartNetworks.push(network);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], function (state) {
  var networks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  state.selectedViewershipNetworks = networks;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* CLOSE_DAY_PARTS_SECTION */], function (state) {
  state.selectedDayPartNetworks = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* SHOW_DELETE_TARGET_MODAL */], function (state) {
  if (state.showDeleteModal) {
    state.showDeleteModal = state.showDeleteModal + 1;
  } else {
    state.showDeleteModal = 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* SET_SHOW_APPEND_MODAL */], function (state, target) {
  if (!target) {
    state.showAppendSegmentsModal = 0;
  } else if (state.showAppendSegmentsModal) {
    state.currentTarget = target;
    state.showAppendSegmentsModal = state.showAppendSegmentsModal + 1;
  } else {
    state.currentTarget = target;
    state.showAppendSegmentsModal = 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["n" /* SET_SHOW_PID_DOWNLOAD_MODAL */], function (state, target) {
  state.currentTarget = target;
  if (state.showDownloadPidListModal) {
    state.showDownloadPidListModal = state.showDownloadPidListModal + 1;
  } else {
    state.showDownloadPidListModal = 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["o" /* SET_TARGET_REPOST_DATES */], function (state, dateRange) {
  state.repostDates = dateRange.slice(0, -1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* SET_TARGET_SEGMENTS */], function (state, segmentData) {
  state.segmentData = segmentData.data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["q" /* SET_TARGET_PID_LISTS */], function (state, pidLists) {
  state.pidLists = pidLists;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* REMOVE_IS_DOWNLOADING_TARGET */], function (state, targetId) {
  state.isDownloadingTarget.delete(targetId);
  state.isDownloadingTarget = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(state.isDownloadingTarget.values());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["s" /* IS_COMPLETED_DOWNLOAING_TARGET */], function (state, targetId) {
  state.isCompletedDownloadingTarget.add(targetId);
  state.isCompletedDownloadingTarget = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(state.isCompletedDownloadingTarget.values());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* IS_DOWNLOADING_TARGET */], function (state, targetId) {
  state.isDownloadingTarget.add(targetId);
  state.isDownloadingTarget = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(state.isDownloadingTarget.values());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["u" /* CLEAR_TARGET_DOWNLOAD */], function (state) {
  state.isDownloadingTarget = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
  state.isCompletedDownloadingTarget = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["v" /* SET_CURRENT_TARGET_DEFINITION */], function (state, td) {
  state.currentTarget.target_definition = td;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* SHOW_REPOSSTING_MODAL */], function (state) {
  if (state.showRePostingModel) {
    state.showRePostingModel = state.showRePostingModel + 1;
  } else {
    state.showRePostingModel = 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* SET_TARGET_DROPPED_ATTRIBUTES */], function (state, droppedAttributes) {
  state.droppedAttributes = droppedAttributes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions__["y" /* SHOW_DROPPED_ATTRIBUTES_MODEL */], function (state, shouldShow) {
  state.showDroppedAttributesModal = shouldShow;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDictOfAttributes; });
/* unused harmony export getAttributes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


var getDictOfAttributes = function getDictOfAttributes(query) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (el) {
    return el;
  };

  var attributes = getAttributes(query);
  var d = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(attributes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var att = _step.value;

      if (!d[att.id]) {
        d[att.id] = [];
      }
      d[att.id].push(map(att));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return d;
};

var getAttributes = function getAttributes(query) {
  var attributes = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(query), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var seg = _step2.value;

      if (Array.isArray(seg)) {
        attributes.push.apply(attributes, getAttributes(seg));
      } else if (seg.id) {
        attributes.push(seg);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return attributes;
};



/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_toasts_RecurringToast__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__ = __webpack_require__(3);













var UploadTargetFile = function () {
  function UploadTargetFile(context, file, options, target, isAppend) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UploadTargetFile);

    this.context = context;
    this.file = file;
    this.options = options || {};
    this.target = target;
    this.isAppend = isAppend;

    this.uploadedBucket = null;
    this.uploadedKey = null;

    this.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], true);

    var splits = file.name.split('.');
    this.extension = splits[splits.length - 1];
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UploadTargetFile, [{
    key: 'run',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resUploadTargetFile;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.uploadFileAction();

              case 2:
                resUploadTargetFile = _context.sent;

                if (!this.options.staged) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', resUploadTargetFile);

              case 7:
                if (!(this.target.target === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || this.target.target === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return this.irisProcess();

              case 10:
                return _context.abrupt('return', _context.sent);

              case 13:
                if (!(this.newTarget.target === 'pid')) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return this.pidListProcess();

              case 16:
                return _context.abrupt('return', _context.sent);

              case 19:
                this.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                return _context.abrupt('return', false);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run() {
        return _ref.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: '_uploadTheFile',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(signedURL) {
        var _this = this;

        var rt;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rt = new __WEBPACK_IMPORTED_MODULE_8__components_common_toasts_RecurringToast__["a" /* default */]({
                  type: 'info',
                  title: 'Waiting for File To Upload',
                  message: 'Please do not close browser, waiting for file to upload',
                  interval: 5000
                });

                rt.start();
                this.context.dispatch(__WEBPACK_IMPORTED_MODULE_9__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
                return _context2.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["G" /* uploadFile */])(signedURL, this.file).then(function (res) {
                  rt.stop();
                  __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].success({ title: 'File Uploaded', message: 'The file ' + _this.file.name + ' has been uploaded!' });


                  try {
                    if (!_this.target.id) _this.context.dispatch(__WEBPACK_IMPORTED_MODULE_9__views_audienceHub_store_actions__["g" /* ADD_TARGET_TO_TARGET_LIST */], _this.newTarget);
                  } catch (ex) {
                    console.log(ex);
                  }
                }).catch(function (e) {
                  _this.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                  console.error(e);
                  __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].error({
                    title: 'Error Uploading File',
                    message: 'The file ' + _this.file.name + ' was not uploaded!',
                    timeout: 10000
                  });
                }));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _uploadTheFile(_x) {
        return _ref2.apply(this, arguments);
      }

      return _uploadTheFile;
    }()
  }, {
    key: 'uploadFileAction',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].info({ title: 'Uploading File', message: 'Uploading file ' + this.file.name + ' now...' });
                _context4.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["F" /* uploadTargetFile */])({ target: this.target, file: { extension: this.extension }, options: this.options }).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resUploadTargetFile) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _this2.uploadedBucket = resUploadTargetFile.data.bucket;
                            _this2.uploadedKey = resUploadTargetFile.data.key;
                            if (!_this2.target.id) __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].success({
                              title: 'New Target Created',
                              message: 'Successfully created new target: ' + _this2.target.display_name
                            });
                            _this2.newTarget = resUploadTargetFile.data.target;
                            _context3.next = 6;
                            return _this2._uploadTheFile(resUploadTargetFile.data.signedURL);

                          case 6:
                            return _context3.abrupt('return', resUploadTargetFile);

                          case 7:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  _this2.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                  console.error(e);
                  __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].error({
                    title: 'Error Uploading Target File',
                    message: 'There was an error uploading the target file.',
                    timeout: 10000
                  });
                  _this2.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                  return false;
                });

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function uploadFileAction() {
        return _ref3.apply(this, arguments);
      }

      return uploadFileAction;
    }()
  }, {
    key: 'irisProcess',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this3 = this;

        var parser, targetTypeTitle, dataprovider;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                parser = void 0;
                targetTypeTitle = void 0;
                dataprovider = void 0;

                if (!(this.target.target === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER)) {
                  _context5.next = 10;
                  break;
                }

                targetTypeTitle = 'Npower';
                __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].info({ title: 'Parsing File', message: 'Parsing NPower file ' + this.file.name + ' now...', timeout: 10000 });
                dataprovider = __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["l" /* LAS_TYPES */].NPOWER;
                parser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["O" /* parseNPowerFile */])({ bucket: this.uploadedBucket, key: this.uploadedKey });
                _context5.next = 18;
                break;

              case 10:
                if (!(this.target.target === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE)) {
                  _context5.next = 17;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].info({ title: 'Parsing File', message: 'Parsing Comscore file ' + this.file.name + ' now...', timeout: 10000 });
                targetTypeTitle = 'Comscore';
                dataprovider = __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["l" /* LAS_TYPES */].COMSCORE;
                parser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["P" /* parseComscoreFile */])({ bucket: this.uploadedBucket, key: this.uploadedKey });
                _context5.next = 18;
                break;

              case 17:
                throw new Error('Invalid target type for Iris Process');

              case 18:
                return _context5.abrupt('return', parser.then(function (res) {
                  var irisResponse = res.data;
                  var MarketDemos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["b" /* flatten */])((irisResponse.NetworkMarketDemoGroups || []).map(function (g) {
                    return g.QuarterMarketDemoGroups.map(function (q) {
                      return q.MarketDemos;
                    });
                  }));

                  if (!irisResponse.ValidationResult.IsValid) {
                    _this3.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                    __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].destroy();
                    if (irisResponse.ValidationResult.IsNoSheetsOrCorrupted) {
                      __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].error({
                        title: 'Error Parsing ' + targetTypeTitle + ' file',
                        message: 'The ' + targetTypeTitle + ' file has no sheets or is corrupted',
                        timeout: 10000
                      });
                      return { Error: 'Error Parsing ' + targetTypeTitle + ' file' };
                    } else {
                      __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].error({
                        title: 'Error Parsing ' + targetTypeTitle + ' file',
                        message: irisResponse.ValidationResult.ExcelSheetsValidationInfo.filter(function (sheetValidationInfo) {
                          return !sheetValidationInfo.IsValid;
                        }).map(function (sheetValidationInfo) {
                          return 'Sheet "' + sheetValidationInfo.SheetName + '":\n' + sheetValidationInfo.ErrorList.join('\n');
                        }).join('\n'),
                        timeout: 10000,
                        class: 'mutiline-toast'
                      });
                      return { Error: 'Error Parsing ' + targetTypeTitle + ' file' };
                    }
                  }

                  var utcDateStr = new Date().toISOString();
                  var _newTarget = _this3.newTarget,
                      cae_id = _newTarget.cae_id,
                      display_name = _newTarget.display_name,
                      advertiser = _newTarget.advertiser;


                  var segmentData = {
                    ExcelFileName: irisResponse.FileName,
                    DataProvider: dataprovider,
                    AudienceSegment: {
                      Id: parseInt(cae_id || 0),
                      Name: display_name,
                      IsActive: true,
                      Description: '',
                      Advertisers: [{
                        Id: advertiser.Advertiser_id || 0,
                        Name: advertiser.Name,
                        IsActive: true,
                        ProcessedDatetimeUTC: utcDateStr
                      }],
                      ProcessedDatetimeUTC: utcDateStr,
                      AdvertiserNames: advertiser.Name
                    },
                    MarketDemos: MarketDemos,
                    ExcelFileId: irisResponse.FileId
                  };
                  _this3.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                  return { target: _this3.newTarget, irisResponse: segmentData };
                }).catch(function (e) {
                  _this3.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                  console.error(e);
                  __WEBPACK_IMPORTED_MODULE_7__components_common_toasts___["a" /* default */].error({
                    title: 'Error Parsing ' + targetTypeTitle + ' File',
                    message: 'There was an error parsing ' + targetTypeTitle + ' file ' + _this3.file.name,
                    timeout: 10000
                  });
                }));

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function irisProcess() {
        return _ref5.apply(this, arguments);
      }

      return irisProcess;
    }()
  }, {
    key: 'pidListProcess',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var count, that, runPIDComplete;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                count = 0;
                that = this;

                runPIDComplete = function () {
                  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            count += 1;
                            return _context6.abrupt('return', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api__["Q" /* checkPIDComplete */])({ target_id: that.newTarget.id }).then(function (res) {
                              var resource = res.data.target_resource;
                              if (resource) {
                                that.context.commit(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_createTarget_store_actions__["f" /* SET_LOADING */], false);
                                if (resource.complete) {
                                  return null;
                                } else {
                                  return {
                                    data: resource.data,
                                    target: that.newTarget
                                  };
                                }
                              } else if (count < 400) {
                                var p = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                  setTimeout(function () {
                                    resolve(runPIDComplete());
                                  }, 1000);
                                });
                                return p;
                              } else {
                                return null;
                              }
                            }));

                          case 2:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));

                  return function runPIDComplete() {
                    return _ref7.apply(this, arguments);
                  };
                }();

                _context7.next = 5;
                return runPIDComplete();

              case 5:
                return _context7.abrupt('return', _context7.sent);

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function pidListProcess() {
        return _ref6.apply(this, arguments);
      }

      return pidListProcess;
    }()
  }]);

  return UploadTargetFile;
}();

/* harmony default export */ __webpack_exports__["a"] = (UploadTargetFile);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_get__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_WorkbenchInterface__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_workbench_targetDefinition_services_serializer__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appLogic_targets_conversions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__appComponents_workbench_lasGraphs_viewership_dateRange_store__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store__ = __webpack_require__(32);
























var LASInterface = function (_WorkbenchInterface) {
  __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default()(LASInterface, _WorkbenchInterface);

  function LASInterface() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, LASInterface);

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LASInterface.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(LASInterface)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(LASInterface, [{
    key: 'setInterface',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(context) {
        var _context$rootState$ap, dateRanges, minStartMonths;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context.dispatch(__WEBPACK_IMPORTED_MODULE_15__store_actions__["a" /* SET_INTERFACE */], this);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__store__["b" /* registerIfNotExist */])(["DateRange"], __WEBPACK_IMPORTED_MODULE_19__appComponents_workbench_lasGraphs_viewership_dateRange_store__["a" /* default */]);
                console.log('calling init action');
                _context$rootState$ap = context.rootState.appRes, dateRanges = _context$rootState$ap.dateRanges, minStartMonths = _context$rootState$ap.minStartMonths;

                __WEBPACK_IMPORTED_MODULE_22__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["a" /* INIT_DATE_RANGE */], dateRanges, minStartMonths.amrld);

                context.dispatch(__WEBPACK_IMPORTED_MODULE_15__store_actions__["b" /* SET_VIEWING_STREAM */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__appLogic_targets_conversions__["a" /* convertViewingStreamForES */])(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3));
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  resolve();
                }));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setInterface(_x) {
        return _ref.apply(this, arguments);
      }

      return setInterface;
    }()
  }, {
    key: 'saveTarget',
    value: function saveTarget(targetInfo) {
      var getters = targetInfo.context.getters;
      var context = targetInfo.context;

      var rhpm = getters.revisionHistoryCurrentMove;
      var lasState = context.state.las_workbench;

      var target = targetInfo.target;
      var query = targetInfo.targetDefinition;
      var broadcastQuarter = targetInfo.target.target_definition.broadcastQuarter;
      var rootGetters = context.rootGetters;
      var targetDefinition = {
        query: query,
        startDate: rootGetters.startDate.from,
        endDate: rootGetters.endDate.to,
        viewSource: lasState.viewingSource,
        networks: lasState.selectedViewershipNetworks
      };
      if (broadcastQuarter) {
        targetDefinition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, targetDefinition, { broadcastQuarter: broadcastQuarter });
      }
      var tAndTd = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_get___default()(LASInterface.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(LASInterface.prototype), 'getTargetAndDatasourceInformation', this).call(this, query);
      var dataToSave = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        id: target.id,
        username: target.username,
        display_name: target.display_name,
        target: target.target || __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS,
        target_type: target.target_type || __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS,
        target_datasource: target.target_datasource,
        target_definition: targetDefinition,
        viewing_stream: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__appLogic_targets_conversions__["b" /* convertViewingStreamForAM */])(lasState.viewingSource),
        networks: lasState.selectedViewershipNetworks,
        audience_size: lasState.audienceSize,
        universe: lasState.universe,
        metrics: lasState.metrics,
        viewership_historical: lasState.hisoricalViewership,
        advertiser: target.advertiser ? target.advertiser : context.state.workbenchTarget.advertiser,
        destinations: target.destinations && target.destinations.length > 0 ? target.destinations : [],
        metadata: target.metadata
      }, tAndTd);

      if (rhpm) {
        var td = rhpm.target_data;
        dataToSave = {
          age_data: td.age,
          income_data: td.income
        };
      }

      var workbenchDataValues = ['income_data', 'age_data', 'viewership_historical', 'metrics', 'universe', 'audience_size', 'social_affinity', 'tsp_attributes', 'activation_path', 'brand_reach', 'networks', 'activation_path'];
      var workbenchData = {};
      for (var key in dataToSave) {
        if (workbenchDataValues.includes(key)) {
          workbenchData[key] = dataToSave[key];
        }
      }
      dataToSave.workbench_data = workbenchData;
      if (!dataToSave.activation_status || dataToSave.activation_status && dataToSave.activation_status === __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
        dataToSave.activation_status = __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api__["r" /* saveTarget */])(dataToSave).then(function (res) {
        if (res && res.data) {
          context.commit(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["d" /* SET_TARGET */], res.data);
        }

        context.commit(__WEBPACK_IMPORTED_MODULE_15__store_actions__["c" /* SET_LOADING */], false);
        context.commit(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
      });
    }
  }, {
    key: 'onTargetDefinitionChange',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3) {
        var targetDefinition = _ref3.targetDefinition,
            initialLoad = _ref3.initialLoad,
            context = _ref3.context;

        var datasources, dis, getter, _context$rootState$ap2, minStartMonths, maxEndMonths, workbenchTarget, startDate, endDate, s, networks, data, currentRequestId, freshTargetDefinition, targetData;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                datasources = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(targetDefinition.flat(Infinity).filter(function (n) {
                  return n.dataset;
                }).map(function (n) {
                  return n.dataset;
                }));
                dis = context.dispatch;
                getter = context.rootGetters;
                _context$rootState$ap2 = context.rootState.appRes, minStartMonths = _context$rootState$ap2.minStartMonths, maxEndMonths = _context$rootState$ap2.maxEndMonths;
                workbenchTarget = context.rootState.workbench.workbenchTarget;
                startDate = getter.startDate || minStartMonths.amrld;
                endDate = getter.endDate || maxEndMonths.amrld;

                if (!(datasources.has('mri') && datasources.has('ncs'))) {
                  _context2.next = 21;
                  break;
                }

                if (!(minStartMonths.mri.from > minStartMonths.ncs.from)) {
                  _context2.next = 15;
                  break;
                }

                if (!(startDate.from > minStartMonths.ncs.from)) {
                  _context2.next = 13;
                  break;
                }

                startDate = minStartMonths.ncs;
                _context2.next = 13;
                return __WEBPACK_IMPORTED_MODULE_22__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["b" /* UPDATE_START_DATE */], startDate.from);

              case 13:
                _context2.next = 19;
                break;

              case 15:
                if (!(startDate.from > minStartMonths.mri.from)) {
                  _context2.next = 19;
                  break;
                }

                startDate = minStartMonths.mri;
                _context2.next = 19;
                return __WEBPACK_IMPORTED_MODULE_22__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["b" /* UPDATE_START_DATE */], startDate.from);

              case 19:
                _context2.next = 35;
                break;

              case 21:
                if (!(datasources.has('mri') && startDate.from > minStartMonths.mri.from)) {
                  _context2.next = 27;
                  break;
                }

                startDate = minStartMonths.mri;
                _context2.next = 25;
                return __WEBPACK_IMPORTED_MODULE_22__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["b" /* UPDATE_START_DATE */], startDate.from);

              case 25:
                _context2.next = 35;
                break;

              case 27:
                if (!(datasources.has('ncs') && startDate.from > minStartMonths.ncs.from)) {
                  _context2.next = 33;
                  break;
                }

                startDate = minStartMonths.ncs;
                _context2.next = 31;
                return __WEBPACK_IMPORTED_MODULE_22__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["b" /* UPDATE_START_DATE */], startDate.from);

              case 31:
                _context2.next = 35;
                break;

              case 33:
                _context2.next = 35;
                return __WEBPACK_IMPORTED_MODULE_22__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_20__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["b" /* UPDATE_START_DATE */], startDate.from);

              case 35:
                dis(__WEBPACK_IMPORTED_MODULE_15__store_actions__["c" /* SET_LOADING */], true);
                dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
                dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
                dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], false);
                context.commit(__WEBPACK_IMPORTED_MODULE_15__store_actions__["d" /* INCREMENT_REQUEST_NUMBER */]);
                s = context.rootState.workbench.las_workbench;
                networks = context.rootState.networks.networks;
                data = {
                  query: targetDefinition,
                  startDate: startDate.from,
                  endDate: endDate.to,
                  networks: s.selectedViewershipNetworks,
                  viewSource: s.viewingSource
                };
                currentRequestId = s.requestNumber;
                freshTargetDefinition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api__["s" /* fetchTargetDefinition */])(data).then(function (resp) {
                  var freshDefinition = resp.data;
                  if (currentRequestId === s.requestNumber) {
                    context.commit(__WEBPACK_IMPORTED_MODULE_17__appComponents_workbench_targetDefinition_store_actions__["j" /* SET_DROPPED_ATTRIBUTES_IN_TD */], __WEBPACK_IMPORTED_MODULE_12__appComponents_workbench_targetDefinition_services_serializer__["a" /* default */].deserialize(freshDefinition));
                  }

                  return context.getters.newTargetDefinition;
                });
                targetData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api__["t" /* fetchTargetData */])(data).then(function (resp) {
                  var targetData = {
                    metrics: resp.metrics,
                    networks: networks,
                    audienceSize: resp.audienceSize && resp.audienceSize.audience,
                    historicalViewership: resp.historicalViewership,
                    universe: resp.universe
                  };
                  return targetData;
                });

                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([freshTargetDefinition, targetData]).then(function (resp) {
                  var ftd = resp[0];
                  var td = resp[1];
                  var audienceSize = void 0;
                  if (initialLoad && workbenchTarget.audience_size && workbenchTarget.activation_status === __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE) {
                    audienceSize = Number(workbenchTarget.audience_size);
                  } else {
                    audienceSize = td.audienceSize;
                  }
                  context.dispatch(__WEBPACK_IMPORTED_MODULE_15__store_actions__["e" /* SET_TARGET_DATA */], td);
                  dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], !initialLoad);

                  context.commit(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["l" /* SET_SLOTTED_VALUE */], {
                    viewershipData: td.historicalViewership,
                    networks: networks,
                    dayPartsConfig: context.rootState.app,
                    audienceSize: audienceSize,
                    universeData: td.universe,
                    lasState: s
                  });
                }).catch(function (resp) {}).finally(function (fin) {
                  var wbTarget = context.rootState.workbench.workbenchTarget;
                  if (wbTarget && wbTarget.activation_status === 'WORKING' && context.getters.newTargetDefinition && context.getters.newTargetDefinition.length > 0) {
                    dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], initialLoad);
                  } else {
                    dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
                  }
                  dis(__WEBPACK_IMPORTED_MODULE_16__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], true);
                  dis(__WEBPACK_IMPORTED_MODULE_15__store_actions__["c" /* SET_LOADING */], false);
                });

              case 47:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onTargetDefinitionChange(_x2) {
        return _ref2.apply(this, arguments);
      }

      return onTargetDefinitionChange;
    }()
  }, {
    key: 'getTargetDefinition',
    value: function getTargetDefinition(getters) {
      return getters.serializedDefinition;
    }
  }, {
    key: 'onSetTarget',
    value: function onSetTarget(targetInfo, context) {
      console.log('Not Implemented');
    }
  }, {
    key: 'reset',
    value: function reset(context) {
      context.dispatch(__WEBPACK_IMPORTED_MODULE_15__store_actions__["f" /* RESET */]);
    }
  }, {
    key: 'submitDownstream',
    value: function submitDownstream(targetInfo) {
      throw Error('Not Implemented');
    }
  }, {
    key: 'sendDownStream',
    value: function sendDownStream() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'getStoreModules',
    value: function getStoreModules() {
      return [{
        name: __WEBPACK_IMPORTED_MODULE_15__store_actions__["g" /* STORE_NAME */],
        module: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */]
      }];
    }
  }, {
    key: 'getDefaultTarget',
    value: function getDefaultTarget(targetInfo) {
      return {};
    }
  }, {
    key: 'onDuplicate',
    value: function onDuplicate() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'onCreate',
    value: function onCreate() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'modelLAL',
    value: function modelLAL() {
      throw Error('Not Implemented');
    }
  }, {
    key: 'onSetAdvertiser',
    value: function onSetAdvertiser() {}
  }]);

  return LASInterface;
}(__WEBPACK_IMPORTED_MODULE_11__common_WorkbenchInterface__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LASInterface);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(321);





var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* SET_INTERFACE */], function (state, inter) {
  state.interface = inter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* INCREMENT_REQUEST_NUMBER */], function (state) {
  state.requestNumber = state.requestNumber + 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* SET_METRICS */], function (state, metrics) {
  state.metrics = metrics;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* SET_AUDIENCE_SIZE */], function (state, audienceSize) {
  state.audienceSize = audienceSize;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* SET_HISTORICAL_VIEWERSHIP */], function (state, historicalViewership) {
  state.hisoricalViewership = historicalViewership;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* SET_UNIVERSE */], function (state, universe) {
  state.universe = universe;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* SET_DAY_PART_NETWORKS */], function (state, networks) {
  state.selectedDayPartNetworks = networks;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], function (state, networks) {
  state.selectedViewershipNetworks = networks;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["o" /* REMOVE_FROM_SELECTED_DAY_PART_NETWORKS */], function (state, network) {
  var indexToRemove = state.selectedDayPartNetworks.findIndex(function (n) {
    return n === network;
  });
  if (indexToRemove >= 0) {
    state.selectedDayPartNetworks.splice(indexToRemove, 1);
    state.selectedDayPartNetworks = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(state.selectedDayPartNetworks));
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["p" /* REMOVE_ALL_DAY_PART_NETWORKS */], function (state) {
  state.selectedDayPartNetworks = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* SET_LOADING */], function (state, v) {
  state.loading = v;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* SET_VIEWING_STREAM */], function (state, v) {
  state.viewingSource = v;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* RESET */], function (state) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__index__["b" /* LAS_DEFAULT_STATE */])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      state[key] = __WEBPACK_IMPORTED_MODULE_5__index__["b" /* LAS_DEFAULT_STATE */][key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_WorkbenchInterface__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_attributeTransformation__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_attributes__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_U_D__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_U__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);




























var RESPONSE_TIME = 300;

var XandrInterface = function (_WorkbenchInterface) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(XandrInterface, _WorkbenchInterface);

  function XandrInterface() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, XandrInterface);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (XandrInterface.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(XandrInterface)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(XandrInterface, [{
    key: 'setInterface',
    value: function setInterface(context) {
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["a" /* SET_INTERFACE */], this);
    }
  }, {
    key: 'saveTarget',
    value: function saveTarget(targetInfo) {
      var target = targetInfo.target;
      var newTarget = !target.id;
      var query = targetInfo.targetDefinition;
      target.target_definition = { query: query };
      target.target = targetInfo.target.target && (targetInfo.target.target === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT || targetInfo.target.target === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA) ? targetInfo.target.target : __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA;
      target.target_type = targetInfo.target.target_type && (targetInfo.target.target_type === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].XANDR_SEGMENT_ADVERTISING || targetInfo.target.target_type === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].ADSTRA) ? targetInfo.target.target_type : __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].ADSTRA;
      var activationStatusesToOverwrite = [__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED];
      target.activation_status = activationStatusesToOverwrite.includes(target.activation_status) ? __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING : target.activation_status;
      if (target.xandr_data) {
        target.xandr_data.query = targetInfo.context.getters.xandrQuery;
        target.xandr_data.audienceExpansion = targetInfo.context.getters.audienceExpansion;
        if (targetInfo.context.getters.insightsRefreshed) {
          target.xandr_data.insights_refreshed = true;
        }
      } else {
        target.xandr_data = {
          addressable: false,
          audienceExpansion: targetInfo.context.getters.audienceExpansion
        };
        if (targetInfo.context.getters.insightsRefreshed) {
          target.xandr_data.insights_refreshed = true;
        }
      }
      if (!target.am_data) {
        target.am_data = {
          flightStartDate: null,
          flightEndDate: null,
          status: null,
          xdFlightOverlap: 0
        };
      }
      if (target.viewing_stream !== __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD) {
        target.viewing_stream = __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
      }
      var context = targetInfo.context;

      var tAndTd = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default()(XandrInterface.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(XandrInterface.prototype), 'getTargetAndDatasourceInformation', this).call(this, query);
      target = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, target, tAndTd);
      context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], true);
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], false);
      context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], false);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api__["r" /* saveTarget */])(target).then(function (resp) {
        if (resp && resp.data) {
          context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["d" /* SET_TARGET */], resp.data);
          context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], false);
          if (newTarget) {
            __WEBPACK_IMPORTED_MODULE_21__router__["a" /* default */].push({ name: 'XandrWorkbench', params: { id: resp.data.id } });
          }
        }
        if (resp && resp.data && resp.data.activation_status !== __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
          if (!targetInfo.ignoreSavePrompt) {
            var isLive = target.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
            var isLiveDigitalTarget = isLive && target.destinations.some(function (destination) {
              return [__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP].includes(destination);
            });
            if (isLiveDigitalTarget) {
              context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["c" /* SHOW_SAVING_LIVE_DIGITAL_PROMPT */]);
            }
          }
          __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].success({
            title: 'Save Succeeded',
            message: 'Target has been saved'
          });
          context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
          context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
        } else if (resp && resp.data && resp.data.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
          context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
        }
        context.commit(__WEBPACK_IMPORTED_MODULE_18__store_actions__["d" /* SET_ENABLE_UPDATE_TARGET_HEADER_DATA */], false);
        if (context.getters.insightsRefreshed) {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["e" /* SET_INSIGHTS_REFRESHED */], false);
        }
      }).catch(function (err) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], false);
        console.log('save failed', err);
        if (context.getters.insightsRefreshed) {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["e" /* SET_INSIGHTS_REFRESHED */], false);
        }
        __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].error({
          title: 'Save Target Error',
          message: 'Save has failed, please refresh and try again',
          timeout: 15000
        });
      }).finally(function (fin) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], true);
      });
    }
  }, {
    key: 'onTargetDefinitionChange',
    value: function onTargetDefinitionChange(info) {
      info.context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], true);
      info.context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
      info.context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);

      var targetDefinition = info.context.getters.serializedDefinition;

      var result = info.context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["f" /* CONFIGURE_AUDIENCE_EXPANSION */], targetDefinition);

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        resolve(result);
      });
    }
  }, {
    key: 'getTargetDefinition',
    value: function getTargetDefinition(getters) {
      return getters.serializedDefinition;
    }
  }, {
    key: 'getAttributes',
    value: function getAttributes(context) {
      return __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].getSegmentationTraits('Adstra').then(function (traits) {
        var transformedAttributes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__components_common_attributes__["a" /* default */])(traits, traits.id, false);
        return transformedAttributes;
      });
    }
  }, {
    key: 'submitDownstream',
    value: function submitDownstream(targetInfo) {
      var context = targetInfo.context;
      context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["d" /* SET_TARGET */], targetInfo.target);
    }
  }, {
    key: 'queryForData',
    value: function queryForData(targetInfo) {
      var dis = targetInfo.context.dispatch;
      dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["g" /* SET_QUERY_ERRORED_OUT */], false);
      dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["h" /* SET_LOADING_INSIGHTS */], true);
      dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], false);
      dis(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
      targetInfo.xandrType = 'advertising';
      targetInfo.user = targetInfo.context.rootGetters.username;
      targetInfo.audienceExpansion = targetInfo.context.getters.audienceExpansion;

      var target = targetInfo.context.getters.newWorkbenchTarget;
      var isLive = target && target.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
      var hasQueryId = target && target.xandr_data && target.xandr_data.query && target.xandr_data.query.queryId;

      if (isLive && hasQueryId) {
        targetInfo.useQueryId = true;
        targetInfo.queryId = target.xandr_data.query.queryId;
      }

      dis(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], false);
      return QueryAPI(targetInfo, targetInfo.context.getters.xandrUseMockData).then(function (resp) {
        dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["i" /* SET_QUERY */], resp);
        dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["e" /* SET_INSIGHTS_REFRESHED */], true);
        dis(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], true);
        return { slottedValue: resp };
      }).catch(function (ex) {
        dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], true);
        dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["g" /* SET_QUERY_ERRORED_OUT */], true);
        dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["i" /* SET_QUERY */], {});
        return { slottedValue: {} };
      }).finally(function (fin) {
        dis(__WEBPACK_IMPORTED_MODULE_18__store_actions__["h" /* SET_LOADING_INSIGHTS */], false);
        dis(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
        dis(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], true);
      });
    }
  }, {
    key: 'sendDownStream',
    value: function sendDownStream(_ref) {
      var context = _ref.context,
          targetId = _ref.targetId;

      __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].destroy();
      var copiedTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lodash__["cloneDeep"])(context.state.workbenchTarget);
      var C360Datasources = context.rootGetters.getC360Datasources;
      if (copiedTarget.am_data.flightStartDate) {
        console.log('user set flight start date');
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["w" /* SAVE_TARGET */], { target: copiedTarget, ignoreSavePrompt: true }).then(function (resp) {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["j" /* SEND_DOWN_STREAM */]);
        });
        return;
      }
      if (copiedTarget.destinations.find(function (destination) {
        return [__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP].includes(destination);
      }) && (copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING || copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT || copiedTarget.am_data.flightEndDate === null)) {
        var currentDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["a" /* getCurrentDate */])();
        copiedTarget.am_data.flightStartDate = currentDate.toISOString();
        copiedTarget.am_data.AEFlightStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["b" /* addDaysToDate */])(currentDate, 2).toISOString();
        var datasetsFromRootFamily = copiedTarget.target_definition.query ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__common_U__["a" /* getAllDatasetsRootFamilyFromQuery */])(copiedTarget.target_definition.query) : [];
        if ([C360Datasources.EPSILON, C360Datasources.DCR, C360Datasources.VIDEOAMP, C360Datasources.LIVERAMP].some(function (d) {
          return datasetsFromRootFamily.includes(d);
        }) && copiedTarget.destinations.includes(__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL)) {
          copiedTarget.am_data.flightEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["c" /* addMonthsToDate */])(currentDate, 6).toISOString();
          copiedTarget.am_data.AEFlightEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["c" /* addMonthsToDate */])(currentDate, 6).toISOString();
        } else if (copiedTarget.destinations.some(function (d) {
          return [__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER].includes(d);
        })) {
          copiedTarget.am_data.flightEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["c" /* addMonthsToDate */])(currentDate, 24).toISOString();
          copiedTarget.am_data.AEFlightEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["c" /* addMonthsToDate */])(currentDate, 24).toISOString();
        } else {
          copiedTarget.am_data.flightEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["b" /* addDaysToDate */])(currentDate, 98).toISOString();
          copiedTarget.am_data.AEFlightEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_U_D__["b" /* addDaysToDate */])(currentDate, 98).toISOString();
        }
      }
      context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["w" /* SAVE_TARGET */], { target: copiedTarget, ignoreSavePrompt: true }).then(function (resp) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["j" /* SEND_DOWN_STREAM */]);
      });
    }
  }, {
    key: '__sendDownStream',
    value: function __sendDownStream(info) {
      var _this2 = this;

      info.context.commit(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], false);
      info.context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
      info.context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
      info.context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], true);
      return __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].sendDownStream({
        targetId: info.targetId,
        user: info.context.rootGetters.username,
        type: 'advertising'
      }).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].success({
          title: 'Successfully Sent Downstream',
          message: 'Target has been sent Downstream',
          timeout: 100 * 1000
        });
        info.context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["d" /* SET_TARGET */], resp);
        info.context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["a" /* NOTIFY_ADCITY */], info.targetId);
        info.context.commit(__WEBPACK_IMPORTED_MODULE_18__store_actions__["d" /* SET_ENABLE_UPDATE_TARGET_HEADER_DATA */], false);
        info.context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], false);
        if (resp.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE) {
          info.context.commit(__WEBPACK_IMPORTED_MODULE_24__appComponents_workbench_targetDefinition_store_actions__["b" /* SET_VIEW_ONLY */], true);
        }
      }).catch(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resp) {
          var targetInfo;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api__["f" /* fetchSingleTarget */])({ target_id: info.targetId });

                case 2:
                  targetInfo = _context.sent;

                  info.context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["d" /* SET_TARGET */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, targetInfo.data, { activation_status: __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED }));
                  __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].error({
                    title: 'Error sending target Downstream',
                    message: 'The Target failed to send downstream, a developer has recieved information and will resolve the issue momentarily',
                    timeout: 100 * 1000
                  });
                  info.context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], true);
                  info.context.commit(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], true);
                  info.context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], true);
                  info.context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], false);

                case 9:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'onSetTarget',
    value: function onSetTarget(targetInfo, context) {
      var query = targetInfo.xandr_data.query;
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["i" /* SET_QUERY */], query);
      context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["l" /* SET_SLOTTED_VALUE */], query);
      context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);

      var targetDefinition = targetInfo.target_definition ? targetInfo.target_definition.query : [];
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["f" /* CONFIGURE_AUDIENCE_EXPANSION */], targetDefinition);

      if (query) {
        var s = targetInfo.activation_status;
        var setDownStream = s !== __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED && s !== __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE && s !== __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED || s === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE && targetInfo.destinations.some(function (destination) {
          return [__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX, __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP].includes(destination);
        }) && targetInfo.activation_date !== targetInfo.last_update || s === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED && targetInfo.xandr_data && targetInfo.xandr_data.addressable;
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], setDownStream);
        var targetIsInDraft = s === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], setDownStream && !targetIsInDraft);
      }
    }
  }, {
    key: 'reset',
    value: function reset(context) {
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["k" /* RESET */]);
    }
  }, {
    key: 'getStoreModules',
    value: function getStoreModules() {
      return [{
        name: __WEBPACK_IMPORTED_MODULE_18__store_actions__["l" /* STORE_NAME */],
        module: __WEBPACK_IMPORTED_MODULE_20__store__["a" /* default */]
      }];
    }
  }, {
    key: 'getDefaultTarget',
    value: function getDefaultTarget() {
      return {};
    }
  }, {
    key: 'onDuplicate',
    value: function onDuplicate(context) {
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], true);
    }
  }, {
    key: 'onCreate',
    value: function onCreate(context) {
      var t = context.getters.newWorkbenchTarget;
      if (t.activation_status === __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], true);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], true);
      }
      context.dispatch(__WEBPACK_IMPORTED_MODULE_18__store_actions__["m" /* SET_CONTROL_URL */]);
    }
  }, {
    key: 'modelLAL',
    value: function modelLAL(context) {
      context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
      context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], true);
      return __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].modelLAL({ target: { targetId: context.state.workbenchTarget.id } }).then(function (resp) {
        if (resp.status && resp.status === 'failed' && resp.message) {
          __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].error({
            title: 'LAL Modeling Failed',
            message: 'An unexpected error occurred during the LAL modeling process.',
            timeout: 10000,
            class: 'wrap-toast'
          });

          throw new Error('LAL Modeling Failed');
        } else {
          context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["d" /* SET_TARGET */], resp);
          __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].success({
            title: 'LAL Modeling Successful',
            message: 'LAL modeling has been completed successfully.',
            timeout: 5000
          });
          context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], false);
          return resp;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].error({
          title: 'LAL Modeling Failed',
          message: 'An unexpected error occurred during the LAL modeling process.',
          timeout: 10000,
          class: 'wrap-toast'
        });
        context.commit(__WEBPACK_IMPORTED_MODULE_19__common_store_actions__["o" /* SET_LOADING_WORKBENCH */], false);
        throw error;
      });
    }
  }, {
    key: 'onSetAdvertiser',
    value: function onSetAdvertiser(context) {}
  }]);

  return XandrInterface;
}(__WEBPACK_IMPORTED_MODULE_10__common_WorkbenchInterface__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (XandrInterface);

var QueryAPI = function QueryAPI(targetInfo, useMock) {
  if (useMock) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        var r = queries[currentEntry];
        currentEntry = currentEntry === queries.length ? 0 : currentEntry + 1;
        resolve(r);
      }, 2000);
    });
  } else {
    if (targetInfo.useQueryId && targetInfo.queryId) {
      return __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].getQueryCountFromQueryId({
        queryId: targetInfo.queryId,
        user: targetInfo.user,
        type: targetInfo.xandrType
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].error({
          title: 'Errored when Querying Segmentation',
          message: 'An error occurred when refreshing counts from queryId',
          timeout: 8000
        });
        throw err;
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].getQueryCount({
        targetDefinition: targetInfo.targetDefinition,
        user: targetInfo.user,
        type: targetInfo.xandrType,
        caeId: targetInfo.caeId,
        audienceExpansion: targetInfo.audienceExpansion
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_22__components_common_toasts__["a" /* default */].error({
          title: 'Errored when Querying Segmentation',
          message: 'An error occurred when querying Segmentation',
          timeout: 8000
        });
        throw err;
      });
    }
  }
};

var defaultTraitValues = {
  queryId: 'xxx',
  counts: {
    isUsingMockData: true,
    household: 236146,
    devices: 234712,
    persons: 951280,
    granularDevices: [{ idType: 'AnchorHHID', count: 28921442 }, { idType: 'AAID', count: 152171 }, { idType: 'IDFA', count: 225544 }, { idType: 'KRUXID', count: 187810 }, { idType: 'CTV', count: 218562 }, { idType: 'WMUKID', count: 3871610 }, { idType: 'BOLTID', count: 2982226 }]
  }
};

var currentEntry = 0;

var c = function c(num) {
  var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_lodash__["cloneDeep"])(defaultTraitValues);
  return q;
};

var queries = [c(7), c(4), c(6), c(9), c(8), c(3), c(5), c(2), c(1)];

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clientLogic_history_StayOnPageControl_js__ = __webpack_require__(751);




var _mutations;







var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["o" /* SHOW_MODELING_MODAL */], function (state) {
  state.showModelingModal = state.showModelingModal + 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* SET_INTERFACE */], function (state, inter) {
  state.interface = inter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], function (state, setValue) {
  state.enableUpdateInsights = setValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* SET_ENABLE_UPDATE_TARGET_HEADER_DATA */], function (state, setValue) {
  state.enableUpdateTargetHeaderData = setValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["p" /* SHOW_UE_MODAL */], function (state) {
  state.ueModalShower = state.ueModalShower + 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* SHOW_SAVING_LIVE_DIGITAL_PROMPT */], function (state) {
  state.liveDigitalPromptShower = state.liveDigitalPromptShower + 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* SET_LOADING_INSIGHTS */], function (state, value) {
  state.loadingInsights = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["q" /* TOGGLE_MOCK_DATA */], function (state, value) {
  state.useMockData = value || !state.useMockData;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* SET_QUERY */], function (state, query) {
  state.query = query;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* RESET */], function (state) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__index__["b" /* XANDR_DEFAULT_STATE */])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      state[key] = __WEBPACK_IMPORTED_MODULE_4__index__["b" /* XANDR_DEFAULT_STATE */][key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["r" /* LOG_XANDR_ACTION */], function (state, value) {
  console.log('logged xandr action!', value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* SET_QUERY_ERRORED_OUT */], function (state, value) {
  state.queryErroredOut = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["s" /* SET_TRAITS */], function (state, traits) {
  state.traits = traits;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["t" /* SET_AUDIENCE_EXPANSION */], function (state, value) {
  state.audienceExpansion = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["u" /* SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE */], function (state, value) {
  state.allowAudienceExpansionToggle = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* SET_INSIGHTS_REFRESHED */], function (state, value) {
  state.insightsRefreshed = value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_LAS_LASInterface__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_XandrInterface__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_attributes__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__ = __webpack_require__(3);






var _mutations;









var intersectingDatasets = function intersectingDatasets(datasetGroups) {
  var intersection = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(datasetGroups[0]));

  var _loop = function _loop(i) {
    intersection = intersection.filter(function (d) {
      return datasetGroups[i].includes(d);
    });
  };

  for (var i = 1; i < datasetGroups.length; i++) {
    _loop(i);
  }
  return intersection.sort(function (a, b) {
    if (a > b) return 1;else return -1;
  });
};

var getFamilyDatasetsFromDataset = function getFamilyDatasetsFromDataset(datasets, datasetFamilies) {
  var datasetGroups = [];
  datasets.forEach(function (dataset) {
    var relatedDatasets = datasetFamilies.datasetRelationships[dataset];
    datasetGroups.push([dataset].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(relatedDatasets)));
  });

  var result = intersectingDatasets(datasetGroups);
  return result;
};

var filterBYODDatasetByFamily = function filterBYODDatasetByFamily(byodDataset, datasetFamilies) {
  var filteredBYODDataset = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, byodDataset);
  delete filteredBYODDataset.children;

  if (byodDataset.children && byodDataset.children.length > 0) {
    var filteredChildren = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(byodDataset.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        var filteredChild = filterBYODDatasetByFamily(child, datasetFamilies);
        if (filteredChild) {
          filteredChildren.push(filteredChild);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (filteredChildren.length > 0) {
      filteredBYODDataset.children = filteredChildren;
    }
  }

  if (filteredBYODDataset.children || datasetFamilies.includes(byodDataset.rootFamily)) {
    return filteredBYODDataset;
  }

  return null;
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["d" /* SET_TARGET */], function (state, target) {
  state.workbenchTarget = target;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["e" /* SET_TARGET_CREATE_ACTION */], function (state, action) {
  state.targetCreateAction = action;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["f" /* SET_ATTRIBUTES */], function (state, attributes) {
  state.attributes = attributes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["g" /* SET_DATASET_FAMILY */], function (state, families) {
  state.datasetFamilies = families;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["h" /* SET_AVAILABLE_DESTINATIONS */], function (state, destinations) {
  state.availableDestinations = destinations;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["i" /* SET_FAMILY_ATTRIBUTES */], function (state, payload) {
  if (state.interface) {
    var modules = state.interface.getStoreModules();
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(modules), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var mod = _step2.value;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__store__["c" /* unregisterIfExists */])([__WEBPACK_IMPORTED_MODULE_8__actions__["j" /* STORE_NAME */], mod.name]);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  state.selectedFamilyDataset = payload.family ? payload.family[0] : payload.family;
  var context = payload.context;
  var byodDataset = context.rootGetters.getBYODDataset;
  if (!state.availableAttributes) {
    state.availableAttributes = state.attributes;
  }
  if (payload.family) {
    var selectedDatasets = getFamilyDatasetsFromDataset(payload.family, state.datasetFamilies);
    var newAttributes = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.availableAttributes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var attr = _step3.value;

        if (attr.data.name.toLowerCase() === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].BYOD.toLowerCase()) {
          var filteredBYODDataset = filterBYODDatasetByFamily(byodDataset, selectedDatasets);
          if (filteredBYODDataset && filteredBYODDataset.children && filteredBYODDataset.children.length > 0) {
            newAttributes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_common_attributes__["a" /* default */])(filteredBYODDataset, filteredBYODDataset.id, false));
          }
        } else if (selectedDatasets.includes(attr.data.id)) {
          newAttributes.push(attr);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var dataSetFamilyChanged = !(state.selectedDatasets && state.selectedDatasets.length === selectedDatasets.length && state.selectedDatasets.every(function (d) {
      return selectedDatasets.indexOf(d) !== -1;
    }));
    var isCDPDatasource = ['xandr', __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PRISM, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DNB, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MAX, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].TVE, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].BYOD, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON_EXPANDABLE, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DISCOVERY_PLUS, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DCR, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LIVERAMP, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].WBGAMES, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].RETARGETING, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DC_COMICS, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].CNN, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MOSAIC].includes(payload.family[0]);
    if (dataSetFamilyChanged) {
      state.selectedDatasets = selectedDatasets;
      context.commit(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* SET_ATTRIBUTES */], newAttributes);

      if (isCDPDatasource) {
        state.interface = new __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_XandrInterface__["a" /* default */]();
        if (!state.workbenchTarget.xandr_data || state.workbenchTarget.xandr_data === undefined) {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["d" /* SET_TARGET */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.workbenchTarget, { xandr_data: { frequency: null } }));
        } else if (state.workbenchTarget.activation_status !== __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["d" /* SET_TARGET */], state.workbenchTarget);
        }
      } else {
        state.interface = new __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_LAS_LASInterface__["a" /* default */]();
        state.availableDestinations = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["f" /* LAS_DESTINATIONS */]));
      }
    }

    if (payload.family.every(function (f) {
      return f === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP;
    }) || payload.family.some(function (f) {
      return f === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].RETARGETING;
    })) {
      state.availableDestinations = [__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL];
    } else if ([__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LIVERAMP, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON_EXPANDABLE, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DCR].some(function (tt) {
      return payload.family.includes(tt);
    })) {
      state.availableDestinations = [__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP];
    } else if (payload.family.some(function (f) {
      return f === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MOSAIC;
    })) {
      state.availableDestinations = [__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER];
    } else if ([__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DNB, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MAX, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].TVE, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DISCOVERY_PLUS, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].WBGAMES, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DC_COMICS, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].CNN].some(function (tt) {
      return payload.family.includes(tt);
    })) {
      state.availableDestinations = [__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP];
    } else if (isCDPDatasource) {
      state.availableDestinations = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["g" /* ADDRESSABLE_DESTINATIONS */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["h" /* DIGITAL_DESTINATIONS */]), [__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP]);
    }

    var _modules = state.interface.getStoreModules();
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_modules), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _mod = _step4.value;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__store__["b" /* registerIfNotExist */])([__WEBPACK_IMPORTED_MODULE_8__actions__["j" /* STORE_NAME */], _mod.name], _mod.module);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    state.interface.setInterface(context);
  } else {
    state.selectedDatasets = [];
    context.commit(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* SET_ATTRIBUTES */], state.availableAttributes);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["k" /* SET_INTERFACE */], function (state, inter) {
  state.interface = inter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["l" /* SET_SLOTTED_VALUE */], function (state, slottedValue) {
  state.slottedValue = slottedValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["m" /* SET_ENABLE_DOWN_STREAM */], function (state, setValue) {
  state.enableDownstream = setValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["n" /* SET_ENABLE_SAVE_BUTTON */], function (state, value) {
  state.enableSaving = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["o" /* SET_LOADING_WORKBENCH */], function (state, value) {
  state.loadingWorkbench = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["p" /* SET_TARGET_DEFINITION_DIRTY */], function (state, value) {
  state.dirty = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["q" /* RESET_STORE */], function (state) {
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_9__index__["b" /* WORKBENCH_DEFAULT_STATE */])), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var key = _step5.value;

      state[key] = __WEBPACK_IMPORTED_MODULE_9__index__["b" /* WORKBENCH_DEFAULT_STATE */][key];
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["r" /* CLEAR_ATTRIBUTES */], function (state) {
  state.attributes = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["s" /* SET_ENABLE_DEFINITION_ACTIONS */], function (state, value) {
  state.enableDefinitionActions = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["t" /* SHOW_AUP_MODAL */], function (state, value) {
  state.showAUPModal = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["u" /* SET_ADVERTISER */], function (state, advertiser) {
  state.workbenchTarget.advertiser = advertiser;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__actions__["v" /* UPDATE_TARGET_NAME */], function (state, targetName) {
  state.workbenchTarget.display_name = targetName;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);








var WebAPI = function () {
  function WebAPI(_ref) {
    var baseURL = _ref.baseURL,
        sessionFunc = _ref.sessionFunc;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, WebAPI);

    this.baseURL = baseURL;
    this.session = sessionFunc;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(WebAPI, [{
    key: '__post',
    value: function __post(_ref2) {
      var extensionURL = _ref2.extensionURL,
          payload = _ref2.payload,
          addSession = _ref2.addSession,
          _ref2$config = _ref2.config,
          config = _ref2$config === undefined ? {} : _ref2$config;

      var session = addSession ? this.__getSession() : undefined;
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* authorizedAPIs */].post('' + (this.baseURL + extensionURL), payload, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, config, session)).then(function (resp) {
        return resp.data;
      });
    }
  }, {
    key: '__get',
    value: function __get(_ref3) {
      var query = _ref3.query,
          extensionURL = _ref3.extensionURL,
          addSession = _ref3.addSession;

      var queryString = query ? this.__parseDataforQuery(query) : '';
      var session = addSession ? { headers: this.__getSession() } : undefined;
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* authorizedAPIs */].get('' + (this.baseURL + extensionURL + queryString), session);
    }
  }, {
    key: '__delete',
    value: function __delete(_ref4) {
      var extensionURL = _ref4.extensionURL,
          addSession = _ref4.addSession;

      var session = addSession ? { headers: this.__getSession() } : undefined;
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* authorizedAPIs */].delete('' + (this.baseURL + extensionURL), session);
    }
  }, {
    key: '__geturl',
    value: function __geturl(url) {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* authorizedAPIs */].get(url);
    }
  }, {
    key: '__parseDataforQuery',
    value: function __parseDataforQuery(dataToSend) {
      var filteredList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataToSend).filter(function (k) {
        return dataToSend[k];
      });
      if (filteredList.length > 0) {
        return '?' + filteredList.map(function (k) {
          var value = dataToSend[k];
          var front = encodeURIComponent(k) + '=';
          if (typeof value === 'string') {
            return front + value;
          } else {
            return front + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
          }
        }).join('&');
      } else {
        return '';
      }
    }
  }, {
    key: '__getSession',
    value: function __getSession() {
      return this.session();
    }
  }]);

  return WebAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (WebAPI);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var STATE_CONTROLLING_STATE = 'state controled url';

var StayOnPageControl = function () {
  function StayOnPageControl(urlToControl) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StayOnPageControl);

    this.enablePop = false;
    this.removeStack = false;
    this.urlToGoBackTo = urlToControl;
    this.previousState = null;
    this.hasSetOnPopState = false;
    this.onRevertURL = function () {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StayOnPageControl, [{
    key: 'setOnRevertURL',
    value: function setOnRevertURL(func) {
      this.onRevertURL = func;
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return this.enablePop && !this.removeStack;
    }
  }, {
    key: 'enable',
    value: function enable() {
      this.enablePop = true;
      this.removeStack = false;
      history.pushState(STATE_CONTROLLING_STATE, null, this.urlToGoBackTo);
      this.hasSetOnPopState = true;
      var that = this;
      window.onpopstate = function () {
        if (that.enablePop) {
          history.pushState(STATE_CONTROLLING_STATE, null, that.urlToGoBackTo);
          that.onRevertURL();
        }
        if (that.removeStack && (history.state === STATE_CONTROLLING_STATE || that.previousState === STATE_CONTROLLING_STATE)) {
          that.previousState = history.state;
          history.go(-1);
        } else if (that.removeStack) {}
      };
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enablePop = false;
      this.removeStack = true;
      this.previousState = history.state;
    }
  }]);

  return StayOnPageControl;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (StayOnPageControl);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPNG; });
/* unused harmony export toJPEG */
/* unused harmony export toPerfectImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);


var toPNG = function toPNG(element) {
  return toDataURL(element, { type: 'image/png' });
};

var toJPEG = function toJPEG(element, quality) {
  return toDataURL(element, { type: 'image/jpeg', quality: quality });
};

var toPerfectImage = function toPerfectImage(element) {
  return toDataURL(element, { type: 'image/jpeg', quality: 1 });
};

var toDataURL = function toDataURL(element, _ref) {
  var type = _ref.type,
      quality = _ref.quality;

  return __WEBPACK_IMPORTED_MODULE_0_html2canvas___default()(element, { logging: false }).then(function (canvas) {
    return canvas.toDataURL(type, quality);
  }).catch(console.error);
};



/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(32);





var renderComponent = function renderComponent(_ref, data) {
  var Component = _ref.Component,
      mixins = _ref.mixins;

  var el = document.createElement('div');
  el.id = 'created-by-vue-gems';
  document.body.appendChild(el);

  var cloned = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(Component);
  if (mixins) {
    Component.mixins.push.apply(cloned.mixins, mixins);
  }
  cloned.store = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */];
  var ExtendedComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(cloned);
  var CreatedComponent = new ExtendedComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    el: el
  }, data));
  return CreatedComponent;
};



/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sortStrings; });

var sortStrings = function sortStrings(arrayOfStrings) {
  var arrayOfLowerCaseStrings = arrayOfStrings.map(function (e) {
    return {
      original: e,
      lower: e.toLowerCase()
    };
  });
  arrayOfLowerCaseStrings.sort(function (a, b) {
    if (a.lower > b.lower) {
      return 1;
    } else if (a.lower === b.lower) {
      return 0;
    } else {
      return -1;
    }
  });
  return arrayOfLowerCaseStrings.map(function (e) {
    return e.original;
  });
};

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waitForRaceCondition; });

var waitForRaceCondition = function waitForRaceCondition(waitFunction, mainFunction) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

  if (waitFunction()) {
    mainFunction();
  } else {
    setTimeout(function () {
      waitForRaceCondition(waitFunction, mainFunction, time);
    }, time);
  }
};

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var DistributionDS = function () {
  function DistributionDS(data, labels, distributionFactor) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DistributionDS);

    this.distribution = {
      data: data,
      labels: labels
    };
    this.labels = [];
    this.data = [];
    this.distributionFactor = distributionFactor;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DistributionDS, [{
    key: 'getDistribution',
    value: function getDistribution(distributionLabel, rest) {
      var offsetFactor = this.distributionFactor - 1;
      this.dataSum = 0;
      this.dataLabel = '';
      var i = 0;
      var length = this.distribution.data.length;
      var data = null;
      var label = null;
      for (; i < length; i++) {
        data = this.distribution.data[i];
        label = this.distribution.labels[i];
        this.dataSum += data;
        if (i % this.distributionFactor === 0) {
          this.dataLabel = label;
        }
        if (i % this.distributionFactor === offsetFactor) {
          this.setData(label);
        }
      }
      if (i % this.distributionFactor !== offsetFactor - 1) {
        this.setData(label);
      }
      return {
        labels: this.labels,
        datasets: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          label: distributionLabel,
          data: this.data
        }, rest)]
      };
    }
  }, {
    key: 'setData',
    value: function setData(label) {
      this.dataLabel += ' - ' + label;
      this.data.push(this.dataSum);
      this.labels.push(this.dataLabel);
      this.dataSum = 0;
      this.dataLabel = '';
    }
  }]);

  return DistributionDS;
}();

/* harmony default export */ __webpack_exports__["a"] = (DistributionDS);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return standardDeviation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mean; });
var standardDeviation = function standardDeviation(numbersArr) {
  var meanVal = mean(numbersArr);

  var SDprep = 0;
  for (var key in numbersArr) {
    SDprep += Math.pow(parseFloat(numbersArr[key]) - meanVal, 2);
  }
  var SDresult = Math.sqrt(SDprep / numbersArr.length);
  return SDresult;
};

var mean = function mean(numbersArr) {
  var total = 0;
  for (var key in numbersArr) {
    total += numbersArr[key];
  }
  return total / numbersArr.length;
};



/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransparentControlPanel__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransparentControlPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TransparentControlPanel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TransparentControlPanel___default.a; });



/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag_vue__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Flag_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Flag_vue___default.a);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NumberInput__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NumberInput___default.a; });




/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__builderComponents_events__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__builderComponents_SelectPopover__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__builderComponents_SelectPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__builderComponents_SelectPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__builderComponents_ListPopover__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__builderComponents_ListPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__builderComponents_ListPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__builderComponents_OperatorPopover__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__builderComponents_OperatorPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__builderComponents_OperatorPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__builderComponents_NotificationPopover__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__builderComponents_NotificationPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__builderComponents_NotificationPopover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);













var Builder = function () {
  function Builder() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Builder);

    this.__popover = null;
    this.__events = [];
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Builder, [{
    key: 'makeCustom',
    value: function makeCustom(Popover) {
      this.__popover = Popover;
      return this;
    }
  }, {
    key: 'makeListPopover',
    value: function makeListPopover() {
      this.__popover = __WEBPACK_IMPORTED_MODULE_6__builderComponents_ListPopover___default.a;
      return this;
    }
  }, {
    key: 'makeOperator',
    value: function makeOperator() {
      this.__popover = __WEBPACK_IMPORTED_MODULE_7__builderComponents_OperatorPopover___default.a;
      return this;
    }
  }, {
    key: 'makeNotifiation',
    value: function makeNotifiation() {
      this.__popover = __WEBPACK_IMPORTED_MODULE_8__builderComponents_NotificationPopover___default.a;
      return this;
    }
  }, {
    key: 'makeSelect',
    value: function makeSelect() {
      this.__popover = __WEBPACK_IMPORTED_MODULE_5__builderComponents_SelectPopover___default.a;
      return this;
    }
  }, {
    key: 'addDefaultEvent',
    value: function addDefaultEvent() {
      this.addHandleScroll();
      this.addDismissOnOffClick();
      this.addDismiss();
      return this;
    }
  }, {
    key: 'addHandleScroll',
    value: function addHandleScroll() {
      this.__events.push(__WEBPACK_IMPORTED_MODULE_4__builderComponents_events__["a" /* default */].handleScroll);
      return this;
    }
  }, {
    key: 'addHoverOver',
    value: function addHoverOver(el, areaIncludeHoverOver) {
      this.__events.push(__WEBPACK_IMPORTED_MODULE_4__builderComponents_events__["a" /* default */].hoverOver(el, areaIncludeHoverOver));
      return this;
    }
  }, {
    key: 'addDismiss',
    value: function addDismiss() {
      this.__events.push(__WEBPACK_IMPORTED_MODULE_4__builderComponents_events__["a" /* default */].dismiss);
      return this;
    }
  }, {
    key: 'addDimissTimerForHover',
    value: function addDimissTimerForHover(el, areaIncludeHoverOver) {
      this.__events.push(__WEBPACK_IMPORTED_MODULE_4__builderComponents_events__["a" /* default */].dismissAfterXSecondsHover(el, areaIncludeHoverOver));
      return this;
    }
  }, {
    key: 'addDismissOnOffClick',
    value: function addDismissOnOffClick() {
      this.__events.push(__WEBPACK_IMPORTED_MODULE_4__builderComponents_events__["a" /* default */].dismissOnOffClick);
      return this;
    }
  }, {
    key: 'addDismissOnClickTimer',
    value: function addDismissOnClickTimer(miliseconds) {
      this.__events.push(__WEBPACK_IMPORTED_MODULE_4__builderComponents_events__["a" /* default */].dismissOnClickTimer(miliseconds));
      return this;
    }
  }, {
    key: 'get',
    value: function get(options) {
      var el = document.createElement('div');
      el.style.overflow = 'hidden';
      document.body.appendChild(el);

      var cloned = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(this.__popover);
      if (cloned.mixins) {
        cloned.mixins.push.apply(cloned.mixins, this.__events);
      } else {
        cloned.mixins = this.__events;
      }
      var Popover = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(cloned);
      var popoverBox = new Popover({
        el: el,
        propsData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          align: 'center'
        }, options)
      });
      return popoverBox;
    }
  }]);

  return Builder;
}();

/* harmony default export */ __webpack_exports__["a"] = (Builder);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


var events = {
  dismissOnOffClick: {
    data: function data() {
      return {
        additionalTargets: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a()
      };
    },
    methods: {
      handleDocumentClick: function handleDocumentClick(e) {
        var contiansArea = this.$el.contains(e.target);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.additionalTargets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var target = _step.value;

            contiansArea |= target.contains(e.target);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (!contiansArea) {
          this.dismiss();
        }
      },
      addClickableArea: function addClickableArea(target) {
        this.additionalTargets.add(target);
      },
      removeClickableArea: function removeClickableArea(removeTarget) {
        this.additionalTargets.delete(removeTarget);
      }
    },
    mounted: function mounted() {
      window.addEventListener('mousedown', this.handleDocumentClick, true);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('mousedown', this.handleDocumentClick, true);
    }
  },
  dismissOnClickTimer: function dismissOnClickTimer(miliseconds) {
    var createdDate = new Date(Date.now() + miliseconds);
    return {
      methods: {
        handleDismissOnClickTimer: function handleDismissOnClickTimer(e) {
          var newDate = new Date();
          var passTime = newDate > createdDate;
          if (passTime && !this.$el.contains(e.target)) {
            this.dismiss();
          }
        }
      },
      mounted: function mounted() {
        window.addEventListener('mousedown', this.handleDismissOnClickTimer, true);
      },
      beforeDestroy: function beforeDestroy() {
        window.removeEventListener('mousedown', this.handleDismissOnClickTimer, true);
      }
    };
  },
  handleScroll: {
    methods: {
      handleScroll: function handleScroll(e) {
        if (!this.$el.contains(e.target)) {
          this.dismiss();
        }
      }
    },
    mounted: function mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  },
  dismiss: {
    data: function data() {
      return {
        hasDismissed: false
      };
    },

    methods: {
      dismiss: function dismiss() {
        var _this = this;

        var timeForAnimations = 125;
        if (this && this.$el) {
          this.$emit('dismiss');
          this.hasDismissed = true;
          this.$destroy();
          setTimeout(function () {
            if (_this && _this.$el) {
              _this.$el.parentNode.removeChild(_this.$el);
            }
          }, timeForAnimations);
        }
      }
    },
    mounted: function mounted() {
      window.addEventListener('hashchange', this.dismiss, true);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('hashchange', this.dismiss, true);
    }
  },
  hoverOver: function hoverOver(el, areaIncludeHoverOver) {
    areaIncludeHoverOver = !(areaIncludeHoverOver === false);
    return {
      methods: {
        handleHover: function handleHover(e) {
          var inActivationArea = el && el.contains(e.target);
          var thePopover = this.$el.contains(e.target);
          var inArea = inActivationArea || areaIncludeHoverOver && thePopover;
          if (!inArea) {
            this.dismiss();
          }
        }
      },
      mounted: function mounted() {
        window.addEventListener('mousemove', this.handleHover, true);
      },
      beforeDestroy: function beforeDestroy() {
        window.removeEventListener('mousemove', this.handleHover, true);
      }
    };
  },
  dismissAfterXSecondsHover: function dismissAfterXSecondsHover(el, areaIncludeHoverOver) {
    areaIncludeHoverOver = !(areaIncludeHoverOver === false);
    return {
      data: function data() {
        return {
          millisecondsToAllow__dismissAfterXSeconds: 2 * 1000,
          lastTime_dismissAfterXSeconds: null,
          BUFFER_dismissAfterXSeconds: 50,
          outsideArea_dismissAfterXSeconds: true };
      },
      methods: {
        handleHover__DismissAfterXSeconds: function handleHover__DismissAfterXSeconds(e) {
          var inActivationArea = el && el.contains(e.target);
          var thePopover = this.$el.contains(e.target);
          var inArea = inActivationArea || areaIncludeHoverOver && thePopover;
          if (inArea) {
            this.setDismissAfterXTime();
            this.setOutsideArea_dismissAfterXSeconds(false);
          } else {
            this.setOutsideArea_dismissAfterXSeconds(true);
          }
        },
        setDismissAfterXTime: function setDismissAfterXTime() {
          this.lastTime_dismissAfterXSeconds = new Date().getTime();
        },
        activateTheDismissPeriod: function activateTheDismissPeriod() {
          var _this2 = this;

          setTimeout(function () {
            if (_this2.outsideArea_dismissAfterXSeconds) {
              if (_this2.pastTimeOut_dismissAfterXSeconds()) {
                _this2.dismiss();
              }
            }
            if (!_this2.hasDismissed) {
              _this2.activateTheDismissPeriod();
            }
          }, this.millisecondsSinceLastHover_dismissAfterXSeconds());
        },
        pastTimeOut_dismissAfterXSeconds: function pastTimeOut_dismissAfterXSeconds() {
          return new Date().getTime() - this.lastTime_dismissAfterXSeconds >= this.millisecondsToAllow__dismissAfterXSeconds - this.BUFFER_dismissAfterXSeconds;
        },
        millisecondsSinceLastHover_dismissAfterXSeconds: function millisecondsSinceLastHover_dismissAfterXSeconds() {
          if (this.outsideArea_dismissAfterXSeconds) {
            return this.lastTime_dismissAfterXSeconds - new Date().getTime() + this.millisecondsToAllow__dismissAfterXSeconds;
          } else {
            return this.millisecondsToAllow__dismissAfterXSeconds;
          }
        },
        setOutsideArea_dismissAfterXSeconds: function setOutsideArea_dismissAfterXSeconds(val) {
          this.outsideArea_dismissAfterXSeconds = val;
        }
      },
      mounted: function mounted() {
        window.addEventListener('mousemove', this.handleHover__DismissAfterXSeconds, true);
        this.setDismissAfterXTime();
        this.activateTheDismissPeriod();
      },
      beforeDestroy: function beforeDestroy() {
        window.removeEventListener('mousemove', this.handleHover__DismissAfterXSeconds, true);
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (events);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder__ = __webpack_require__(761);



var factory = {
  createListBox: function createListBox(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeListPopover().addHandleScroll().get(options);
  },
  createSelectableBoxOffClickDeadline: function createSelectableBoxOffClickDeadline(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeSelect().addDefaultEvent().addDismiss().addHandleScroll().addDismissOnOffClick().addDimissTimerForHover(null, true).get(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, { multiSelect: true }));
  },
  createDefaultListBox: function createDefaultListBox(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeListPopover().addDefaultEvent().get(options);
  },
  createExtendedListBox: function createExtendedListBox(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeListPopover().addDismiss().addDismissOnOffClick().get(options);
  },
  createListBoxWithHoverOver: function createListBoxWithHoverOver(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeListPopover().addHoverOver(options.hoverOver, false).addDismiss().get(options);
  },
  createOperator: function createOperator(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeOperator().addDismissOnClickTimer(options.miliseconds).addDismiss().get(options);
  },
  createNotification: function createNotification(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeNotifiation().addDefaultEvent().get(options);
  },
  createCustomPopover: function createCustomPopover(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__builder__["a" /* default */]().makeCustom(options.popover).addDefaultEvent().get(options);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (factory);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PullDownButton_vue__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PullDownButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PullDownButton_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PullDownButton_vue___default.a);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toast__ = __webpack_require__(214);






var defaultSettings = {
  position: __WEBPACK_IMPORTED_MODULE_3__Toast__["a" /* CONSTANTS */].POSITIONS.TOP_RIGHT
};

var OneToast = function () {
  function OneToast(setupOptions) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OneToast);

    this.toast = new __WEBPACK_IMPORTED_MODULE_3__Toast__["b" /* Toast */](setupOptions || defaultSettings);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OneToast, [{
    key: 'success',
    value: function success(options) {
      this.toast.destroy();
      this.toast.success(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'warning',
    value: function warning(options) {
      this.toast.destroy();
      this.toast.warning(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'error',
    value: function error(options) {
      this.toast.destroy();
      this.toast.error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'info',
    value: function info(options) {
      this.toast.destroy();
      this.toast.info(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.setupOptions, options));
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.toast.destroy();
    }
  }]);

  return OneToast;
}();

/* harmony default export */ __webpack_exports__["a"] = (OneToast);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tooltip__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip___default.a);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__XFlag_vue__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__XFlag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__XFlag_vue__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__XFlag_vue___default.a);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TARGET_CONSTANTS; });
/* unused harmony export listOfTargets */
/* unused harmony export getTargetByType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);



var TARGET_CONSTANTS = {
  las: {
    name: 'LAS',
    type: 'linear_ad_sales',
    workbench: 'las-workbench',
    create: 'create-las',
    activate: 'las-activate-target',
    confirmActivate: 'las-confirm-activation',
    duplicate: 'las-duplicate-target',
    edit: 'las-edit-target'
  },
  sd: {
    name: 'SM',
    type: 'social_digital',
    create: 'create-sm',
    edit: 'sm-edit-target',
    duplicate: 'sm-duplicate-target',
    activate: 'sm-activate-target',
    confirmActivation: 'sm-confirm-activation',
    workbench: 'sm-workbench'
  },
  ad: {
    name: 'AD',
    type: 'audience_discovery',
    duplicate: 'ad-duplicate-target',
    edit: 'ad-edit-target',
    create: 'create-ad',
    workbench: 'ad-workbench'
  }
};

var getListOfTargets = function getListOfTargets() {
  var listOfTargets = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(TARGET_CONSTANTS)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var k = _step.value;

      listOfTargets.push(TARGET_CONSTANTS[k]);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return listOfTargets;
};

var listOfTargets = getListOfTargets();

var getTargetByType = function getTargetByType(type) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(listOfTargets), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var t = _step2.value;

      if (t.type === type) {
        return t;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return null;
};

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_beautify_scrollbar_dist_index_css__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_beautify_scrollbar_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_beautify_scrollbar_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_async_validation__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_async_validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_async_validation__);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuetify_async_validation___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  vuetify: new __WEBPACK_IMPORTED_MODULE_5_vuetify___default.a(),
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  icons: {
    iconfont: 'mdi'
  },
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(771);




var DEFAULT_STATE = {
  history: null,
  current: null
};

var state = function state() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE);
};

var getters = {};

var module = {
  state: state,
  getters: getters,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(216);


var _mutations;



var appendHistory = function appendHistory(state, url) {
  if (url.name) {
    var current = state.history;
    if (current) {
      var next = {
        previous: current,
        url: url
      };
      current.next = next;
      state.history = next;
    } else {
      state.history = { url: url };
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* ADD_TO_HISTORY */], function (state, url) {
  if (url.name) {
    appendHistory(state, url);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* SET_CURRENT_URL */], function (state, url) {
  state.current = url;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* CLEAR_HISTORY */], function (state, inter) {
  state.history = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_UserAPI__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_attributeTransformation__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_ConfigAPI__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_DataCityAPI__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api__ = __webpack_require__(7);










var _actions;









var transformAmrld = function transformAmrld(datasets) {
  var AMRLDDataset = datasets.filter(function (d) {
    return d.id === 'amrld';
  })[0];
  var childrenOfAmrld = AMRLDDataset.children.map(function (d) {
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_freeze___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_attributeTransformation__["a" /* default */])(d, d.id, 'amrld'));
  });
  var combinedFlat = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(childrenOfAmrld), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var c = _step.value;

      combinedFlat.push.apply(combinedFlat, c.flat.attributes);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var newAmrldRoot = {
    data: {
      children: childrenOfAmrld.map(function (d) {
        return d.data;
      }),
      id: 'amrld',
      name: 'AMRLD'
    },
    flat: { name: 'AMRLD', attributes: combinedFlat }
  };
  return newAmrldRoot;
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["f" /* SET_USERS */], function (context) {
  if (context.state.users.length === 0) {
    __WEBPACK_IMPORTED_MODULE_10__api_UserAPI__["a" /* default */].getUsers().then(function (users) {
      context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["f" /* SET_USERS */], users);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["c" /* SET_DATASETS */], function (context) {
  var _this = this;

  var traitTypes = context.state.sourceConstants ? context.state.sourceConstants.TRAIT_TYPE : null;
  var reqs = [__WEBPACK_IMPORTED_MODULE_12__api_ConfigAPI__["a" /* default */].fetchAllWorkbenchConfigs(traitTypes), __WEBPACK_IMPORTED_MODULE_12__api_ConfigAPI__["a" /* default */].fetchDatasetFamilies(), __WEBPACK_IMPORTED_MODULE_12__api_ConfigAPI__["a" /* default */].getConfigFilesForConfigType('las').fetchConfig(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["I" /* fetchEsDateRanges */])()];
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(reqs).then(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(resp) {
      var _resp, datasets, datasetFamilies, lasConfig, dateRangeResponse, newAmrldRoot, nonAmrldDatasets, byodDataset, transformedAttributes;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _resp = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(resp, 4), datasets = _resp[0], datasetFamilies = _resp[1], lasConfig = _resp[2], dateRangeResponse = _resp[3];

              console.log('fetching target date range...');
              newAmrldRoot = transformAmrld(datasets);
              nonAmrldDatasets = datasets.filter(function (d) {
                return d.id !== 'amrld' && d.children.length > 0;
              });
              byodDataset = datasets.find(function (d) {
                return d.id === 'byod';
              });
              transformedAttributes = nonAmrldDatasets.map(function (d) {
                return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_freeze___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_attributeTransformation__["a" /* default */])(d, d.id, d.id));
              });

              transformedAttributes = [newAmrldRoot].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(transformedAttributes));
              transformedAttributes.sort(function (a, b) {
                return a.data.name.toLowerCase().localeCompare(b.data.name.toLowerCase());
              });

              context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["c" /* SET_DATASETS */], transformedAttributes);
              context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* SET_BYOD_DATASET */], byodDataset);
              context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["h" /* SET_QUICK_ADD_ATTRIBUTES */], lasConfig.quick_add);
              context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["i" /* SET_DATASET_FAMILIES */], datasetFamilies);
              context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* SET_DAY_PARTS */], lasConfig.day_parts);
              context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["k" /* SET_DATE_RANGE */], dateRangeResponse);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* SET_PRIMARY_INSIGHTS_FILTER */], function (context) {
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(context.state.primaryInsightsFilter).length === 0) {
    __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].getPrimaryInsightsConfig().then(function (primaryInsightsFilter) {
      context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* SET_PRIMARY_INSIGHTS_FILTER */], primaryInsightsFilter);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["l" /* SET_DASHBOARD_FILTER */], function (context, filter) {
  context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["l" /* SET_DASHBOARD_FILTER */], filter);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["m" /* SET_DASHBOARD_TARGET_FILTER */], function (context, value) {
  context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["m" /* SET_DASHBOARD_TARGET_FILTER */], value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* SET_SOURCE_CONSTANTS */], function (context) {
  return __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].getDatasourcesConfig().then(function (constants) {
    context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* SET_SOURCE_CONSTANTS */], constants);
  }).catch(function (err) {
    console.error('Error getting datasources config: ' + err);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["d" /* SET_MVPDS */], function (context) {
  __WEBPACK_IMPORTED_MODULE_14__api_DataCityAPI__["a" /* default */].getMVPDs().then(function (resp) {
    context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["d" /* SET_MVPDS */], resp);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_9__constants__["e" /* SET_VIDEOAMP_AUDIENCE_LIST */], function (context) {
  __WEBPACK_IMPORTED_MODULE_13__api_XandrAPI__["a" /* default */].getVideoAmpAudienceList().then(function (audienceList) {
    var formattedList = audienceList.map(function (item) {
      return {
        id: item.VA_AUDIENCE_ID,
        name: item.VA_AUDIENCE_ID + ' - ' + item.VA_AUDIENCE_NAME,
        disabled: item.selected
      };
    });
    context.commit(__WEBPACK_IMPORTED_MODULE_9__constants__["e" /* SET_VIDEOAMP_AUDIENCE_LIST */], formattedList);
  }).catch(function (err) {
    console.error('Error getting VideoAmp audience list: ' + err);
  });
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(774);



function state() {
  return {
    users: [],
    filter: null,
    targetFilter: null,
    datasets: null,
    datasetFamilies: null,
    dayParts: null,
    minStartMonths: {
      mri: null,
      ncs: null,
      amrld: null
    },
    maxEndMonths: {
      mri: null,
      ncs: null,
      amrld: null
    },
    dateRanges: [],
    primaryInsightsFilter: [],
    byodDataset: null,
    sourceConstants: null,
    mvpds: null,
    videoAmpAudienceList: null
  };
}

var getters = {
  quickAddAttributes: function quickAddAttributes(state, getters) {
    return state.quickAddAttributes ? state.quickAddAttributes.map(getters.getAttributesForIdDataset) : [];
  },
  getAttributesForIdDataset: function getAttributesForIdDataset(state) {
    return function (_ref) {
      var id = _ref.id,
          dataset = _ref.dataset;

      var amrldDataset = state.datasets.find(function (dataset) {
        return dataset.data.id === 'amrld';
      });
      var dataSetSource = amrldDataset.data.children.find(function (data) {
        return data.id === dataset;
      });
      var found = dataSetSource.children.find(function (data) {
        return data.id === id;
      });
      if (found) return found;
      return false;
    };
  },
  primaryInsightsFilter: function primaryInsightsFilter(state) {
    return state.primaryInsightsFilter;
  },
  getBYODDataset: function getBYODDataset(state) {
    return state.byodDataset;
  },
  getConstants: function getConstants(state) {
    return state.sourceConstants;
  },
  getC360Datasources: function getC360Datasources(state) {
    return state.sourceConstants && state.sourceConstants.DATASOURCES ? state.sourceConstants.DATASOURCES.C360 : {};
  },
  getNielsenDatasources: function getNielsenDatasources(state) {
    return state.sourceConstants && state.sourceConstants.DATASOURCES ? state.sourceConstants.DATASOURCES.NIELSEN : {};
  }
};

var module = {
  state: state,
  getters: getters,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(129);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* SET_DATASETS */], function (state, datasets) {
  state.datasets = datasets;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SET_PRIMARY_INSIGHTS_FILTER */], function (state, primaryInsightsFilter) {
  state.primaryInsightsFilter = primaryInsightsFilter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* SET_DATASET_FAMILIES */], function (state, families) {
  state.datasetFamilies = families;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* SET_USERS */], function (state, users) {
  state.users = users;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* SET_DASHBOARD_FILTER */], function (state, filter) {
  state.filter = filter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* SET_DAY_PARTS */], function (state, dayParts) {
  state.dayParts = dayParts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SET_DASHBOARD_TARGET_FILTER */], function (state, value) {
  state.targetFilter = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* SET_QUICK_ADD_ATTRIBUTES */], function (state, value) {
  state.quickAddAttributes = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* SET_DATE_RANGE */], function (state, value) {
  var dateRanges = value.dateRanges,
      mriLatestMonth = value.mriLatestMonth,
      ncsLatestMonth = value.ncsLatestMonth;

  var mriIdx = dateRanges.findIndex(function (d) {
    return d.name === mriLatestMonth;
  });
  var ncsIdx = dateRanges.findIndex(function (d) {
    return d.name === ncsLatestMonth;
  });

  state.dateRanges = dateRanges;

  state.maxEndMonths.amrld = dateRanges[dateRanges.length - 1];
  state.maxEndMonths.mri = dateRanges[mriIdx];
  state.maxEndMonths.ncs = dateRanges[ncsIdx];
  state.minStartMonths.amrld = dateRanges[dateRanges.length - 12];
  state.minStartMonths.mri = dateRanges[mriIdx - 11];
  state.minStartMonths.ncs = dateRanges[ncsIdx - 11];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SET_BYOD_DATASET */], function (state, value) {
  state.byodDataset = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SET_SOURCE_CONSTANTS */], function (state, value) {
  state.sourceConstants = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SET_MVPDS */], function (state, value) {
  state.mvpds = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SET_VIDEOAMP_AUDIENCE_LIST */], function (state, audienceList) {
  state.videoAmpAudienceList = audienceList;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var createRefreshInterval = function createRefreshInterval(options) {
  options.onStartInterval = options.onStartInterval ? options.onStartInterval : function () {};
  options.onShouldRefresh = options.onShouldRefresh ? options.onShouldRefresh : function () {
    return true;
  };
  options.onAfterRefreshCall = options.onAfterRefreshCall ? options.onAfterRefreshCall : function (refreshData) {};
  var refreshInterval = setInterval(function () {
    options.onStartInterval();
    var expiredTime = new Date(options.expires);
    var offsetExpiredTime = new Date(options.expires - options.timeOffsetToReset * 1000);
    var now = new Date();
    var isWithinRefreshWindow = now > offsetExpiredTime && now < expiredTime;
    var authorized = options.onShouldRefresh();
    var go = isWithinRefreshWindow && authorized;
    console.log({
      isWithinRefreshWindow: isWithinRefreshWindow,
      authorized: authorized,
      go: go,
      expiredTime: expiredTime,
      offsetExpiredTime: offsetExpiredTime,
      now: now
    });
    if (go) {
      options.refreshCall().then(function (resp) {
        options.onAfterRefreshCall(resp);
        console.log(resp);
        options.expires = new Date().getTime() + resp.expires * 1000;
        console.log('print options');
        console.log(options);
      });
    }
  }, options.intervalTime * 1000);
  return refreshInterval;
};

/* harmony default export */ __webpack_exports__["a"] = (createRefreshInterval);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);




var _actions;





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* OKTA_OIDC_INITIALIZE */], function (context, _ref) {
  var _this = this;

  var auth = _ref.auth,
      user = _ref.user;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var accessToken;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (context.state.oidcAuth) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return auth.getAccessToken();

          case 3:
            accessToken = _context.sent;

            context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* OKTA_OIDC_SIGN_IN */], { accessToken: accessToken, username: user.email });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["T" /* getUserPermissionsWithAuth */])().then(function (resp) {
              context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SET_USER_PERMISSION */], resp.data);
            });

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* SIGN_OUT */], function (context) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* SIGN_OUT */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SET_ERROR */], function (context, error) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SET_ERROR */], error);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SET_USER_PERMISSION */], function (context) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["U" /* getUserPermissions */])().then(function (resp) {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SET_USER_PERMISSION */], resp.data);
  });
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Roles__ = __webpack_require__(332);



var _mutations;








var OFFSET_FOR_EXPIRES_IN = 270;

var setExpires = function setExpires(state, expires_in) {
  var addForExpireTime = (expires_in - OFFSET_FOR_EXPIRES_IN) * 1000;
  var expires = new Date(new Date().getTime() + addForExpireTime).getTime();
  state.expires = expires;
};

var setCookie = function setCookie(state) {
  __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.set('auth', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
    username: state.username,
    token: state.token,
    refreshToken: state.refreshToken,
    expires: state.expires
  }));
};

var getAuthCookie = function getAuthCookie() {
  var cookie = __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('auth');
  var credentials = {};
  if (cookie) {
    credentials = JSON.parse(cookie);
  }
  return credentials;
};

var setStateBasedOffCookie = function setStateBasedOffCookie(state) {
  var c = getAuthCookie();
  if (c) {
    state.username = c.username;
    state.token = c.token;
    state.refreshToken = c.refreshToken;
    state.expires = c.expires;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* OKTA_OIDC_SIGN_IN */], function (state, credentials) {
  state.username = credentials.username;
  state.token = credentials.accessToken;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* SET_USER_PERMISSION */], function (state, data) {
  state.userPermissions = data.permissions;
  state.roles = new __WEBPACK_IMPORTED_MODULE_7__Roles__["a" /* default */](data.roles);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* SIGN_OUT */], function (state) {
  state.loggingOut = true;
  __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ name: 'LOGOUT' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SET_ERROR */], function (state, message) {
  console.log(message);
  state.error = message;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* SET_LOADING_VALUE */], function (state, value) {
  state.loading = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REFRESH_TOKEN */], function (state, value) {
  console.log('REFRESH_TOKEN');
  console.log(value);
  state.token = value.access_token;
  state.refreshToken = value.refresh_token;
  setExpires(state, value.expires_in);
  setCookie(state);
  console.log('AUTO_REFRESH CHECKING THE STATE');
  console.log({
    state: state
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* SET_STATE_OFF_COOKIE */], function (state) {
  setStateBasedOffCookie(state);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_INDEX_OBJECT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(779);




var DEFAULT_INDEX_OBJECT = {
  username: null,
  token: null,
  loading: false,
  refreshToken: null,
  expires: null,
  refreshInterval: null,
  loggedIn: false,
  allPermissions: null
};

function state() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_INDEX_OBJECT);
}

var getters = {
  allPermissions: function allPermissions(state) {
    return state.allPermissions ? state.allPermissions : [];
  }
};

var module = {
  state: state,
  getters: getters,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions_js__["c" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_RefreshToken__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(32);


var _mutations;






var refreshCall = function refreshCall() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["S" /* refreshIDMToken */])().then(function (resp) {
    resp.expires = resp.expires_in;
    return resp;
  });
};

var onRefreshToken = function onRefreshToken(resp) {
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_1__actions__["d" /* REFRESH_IDM_TOKEN */], resp);
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* SIGN_INTO_IDM */], function (state, auth) {
  console.log(auth);
  state.token = auth.access_token;
  state.expires = auth.expires_in;
  state.refreshToken = auth.refresh_token;
  state.loggedIn = true;
  var expiresAt = new Date().getTime() + state.expires * 1000;
  state.refreshInterval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__auth_RefreshToken__["a" /* default */])({
    expires: expiresAt,
    refreshCall: refreshCall,
    intervalTime: 30,
    timeOffsetToReset: 190,
    onAfterRefreshCall: onRefreshToken
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* REFRESH_IDM_TOKEN */], function (state, refreshInfo) {
  state.expires = refreshInfo.expires_in;
  state.refreshToken = refreshInfo.refresh_token;
  state.token = refreshInfo.access_token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* GET_ALL_PERMISSIONS */], function (state, permissions) {
  state.allPermissions = permissions;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AudienceHub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AudienceHub__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AudienceHub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AudienceHub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(32);




var AudienceHub = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store__["d" /* createStoreConnector */])('targetManager', __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */], {})(__WEBPACK_IMPORTED_MODULE_1__AudienceHub___default.a);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_eventBus__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_tableMap_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__ = __webpack_require__(3);







var _mutations;








var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["c" /* CHANGED_ON_FILTER */], function (state, previousFilter) {
  state.previousFilter = previousFilter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["d" /* POST_TARGET */], function (state, target) {
  var currentTarget = state.targets.find(function (t) {
    return t.id === target.id && t.target === target.target;
  });
  if (currentTarget) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(currentTarget, target);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["e" /* PRE_ACTIVATION_EDIT_TARGET */], function (state, _ref) {
  var originalTarget = _ref.originalTarget,
      newTarget = _ref.newTarget;

  var target = state.targets.find(function (t) {
    return t.id === originalTarget.id && t.target === originalTarget.target;
  });
  if (target) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(target, newTarget);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* targetRouteHandler */])('CONFIRM-ACTIVATION', originalTarget);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["f" /* REMOVE_TARGET_FROM_TARGET_LIST */], function (state, target) {
  var idx = state.targets.findIndex(function (t) {
    return t.id === target.id && t.target === target.target;
  });

  if (idx > -1) {
    state.targets.splice(idx, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["g" /* ADD_TARGET_TO_TARGET_LIST */], function (state, target) {
  if (target.last_update_str && target.created_str) {
    target.last_update = target.last_update_str;
    target.created = target.created_str;
  }
  target.activation_date_str && (target.activation_date = target.activation_date_str);
  target.last_posting_str && (target.last_posting = target.last_posting_str);

  try {
    target.advertiser = JSON.parse(target.advertiser);
    var brand = target.brand ? target.brand.name : null;
    target.advertiserBrand = target.advertiser ? target.advertiser.Name : brand;
  } catch (e) {
    var _brand = target.brand ? target.brand.name : null;
    target.advertiserBrand = target.advertiser ? target.advertiser.Name : _brand;
  }
  state.targets.push(target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["h" /* FORECAST_TARGET_TO_TARGET_LIST */], function (state, targetId) {
  var selected_target = state.targets.filter(function (t) {
    return t.id === targetId;
  });
  if (selected_target.length > 0) {
    var isNPower = selected_target[0].target_type === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].NPOWER;
    var isComscore = selected_target[0].target_type === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].COMSCORE;
    if (isNPower || isComscore) {
      selected_target[0].activation_status = __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
    } else {
      selected_target[0].activation_status = __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["i" /* UPDATE_TARGET_TO_TARGET_LIST */], function (state, target) {
  var selected_target = state.targets.filter(function (t) {
    return t.id === target.id;
  })[0];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(target)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      selected_target[key] = target[key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["j" /* REFRESH_TARGET_LIST */], function (state) {
  state.targets = [].concat(state.targets);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["k" /* TOGGLE_TARGET_ARCHIVE_STATE */], function (state, target) {
  target.archived = !target.archived;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["l" /* UPDATE_TARGET */], function (state, _ref2) {
  var id = _ref2.id,
      updatedTarget = _ref2.updatedTarget;

  var index = state.targets.findIndex(function (t) {
    return t.id === id;
  });
  if (index === -1) return;

  if (updatedTarget.last_update_str && updatedTarget.created_str) {
    updatedTarget.last_update = updatedTarget.last_update_str;
    updatedTarget.created = updatedTarget.created_str;
  }
  try {
    updatedTarget.advertiser = JSON.parse(updatedTarget.advertiser);
    var brand = updatedTarget.brand ? updatedTarget.brand.name : null;
    updatedTarget.advertiserBrand = updatedTarget.advertiser ? updatedTarget.advertiser.Name : brand;
  } catch (e) {
    var _brand2 = updatedTarget.brand ? updatedTarget.brand.name : null;
    updatedTarget.advertiserBrand = updatedTarget.advertiser ? updatedTarget.advertiser.Name : _brand2;
  }
  updatedTarget.activation_date_str && (updatedTarget.activation_date = updatedTarget.activation_date_str);
  updatedTarget.last_posting_str && (updatedTarget.last_posting = updatedTarget.last_posting_str);
  state.targets[index] = updatedTarget;
  state.targets = [].concat(state.targets);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["m" /* REPLACE_TARGET */], function (state, target) {
  __WEBPACK_IMPORTED_MODULE_9__api_eventBus__["a" /* EventBus */].$emit('update-target', target.id, target);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["n" /* CREATE_TARGET */], function (state, target) {
  state.targets.push(target);
  __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({ name: __WEBPACK_IMPORTED_MODULE_10__router_tableMap_js__["a" /* tableMap */][target.target], params: { id: target.id } });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["o" /* SET_LOADING_VALUE */], function (state, value) {
  state.loading = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["p" /* SET_REFRESH_TABLE_FLAG */], function (state, value) {
  state.refreshTable = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["q" /* SET_ACTIVATION_FAILED */], function (state, value) {
  state.activatedFailed = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["r" /* SET_TARGET_STATUS */], function (state, target) {
  var index = state.targets.findIndex(function (t) {
    return t.id === target.id;
  });
  if (index === -1) return;
  state.targets[index].activation_status = target.activationStatus;
  state.targets[index].last_update = new Date(target.last_update).toLocaleTimeString('en-US');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["s" /* SET_LAS_DATA_AVAILABLE */], function (state, value) {
  state.lasDataAvailable = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["t" /* SET_COLUMN_FILTERS */], function (state, value) {
  var columnFiltersFromState = state.columnFilters && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.columnFilters).length > 0 ? state.columnFilters : JSON.parse(localStorage.getItem('DASHBOARD_COLUMN_FILTER_VALUES'));
  localStorage.setItem('DASHBOARD_COLUMN_FILTER_VALUES', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, columnFiltersFromState, value)));
  state.columnFilters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, columnFiltersFromState, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions__["u" /* REMOVE_COLUMN_FILTER_VALUES */], function (state) {
  localStorage.removeItem('DASHBOARD_COLUMN_FILTER_VALUES');
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ad_vue__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ad_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Ad_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_watchers__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(32);





var unwatchers = [];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store__["d" /* createStoreConnector */])('ad', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */])('ad'), {
  onRegistered: function onRegistered(store) {
    unwatchers.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_watchers__["a" /* createTargetDefinitionWatcher */])(store));
  },
  onUnregistered: function onUnregistered() {
    unwatchers.forEach(function (unwatcher) {
      return unwatcher.call();
    });
  }
})(__WEBPACK_IMPORTED_MODULE_0__Ad_vue___default.a));

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_ConfigAPI__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_attributes__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mutations__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appComponents_oldWorkbench_dateRange_store_actions__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_plugins_undoHistory__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__appLogic_revisionHistory_store_actions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__appLogic_targetDefinition_LabelMoveGenerator__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_bluebird__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_common_toasts__ = __webpack_require__(25);





























var adConfigApi = __WEBPACK_IMPORTED_MODULE_10__api_ConfigAPI__["a" /* default */].getConfigFilesForConfigType('ad-config.json');

var WorkbenchActions = function (_WorkbenchWCanvasSlot) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(WorkbenchActions, _WorkbenchWCanvasSlot);

  function WorkbenchActions() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, WorkbenchActions);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WorkbenchActions.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(WorkbenchActions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(WorkbenchActions, [{
    key: 'initActionBody',
    value: function initActionBody(_ref, id) {
      var _this2 = this;

      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters,
          state = _ref.state;

      commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], true);
      var manuallySetDateRange = false;
      __WEBPACK_IMPORTED_MODULE_23_bluebird___default.a.props({
        revisionHistory: dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_revisionHistory_store_actions__["e" /* GET_REVISION_HISTORY */], { targetId: id }),
        config: adConfigApi.fetchConfig(),

        target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_index__["f" /* fetchSingleTarget */])({ target_id: id }).then(function (resp) {
          return resp.data;
        })
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data) {
          var config, target, esDateRanges, intents, hasMarketingIntent, hasResearchIntent;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  config = data.config, target = data.target;
                  _context.next = 3;
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_index__["I" /* fetchEsDateRanges */])();

                case 3:
                  esDateRanges = _context.sent;


                  commit(__WEBPACK_IMPORTED_MODULE_20__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], target);
                  intents = target.metadata.intents;
                  hasMarketingIntent = intents.filter(function (x) {
                    return x.IntentId === __WEBPACK_IMPORTED_MODULE_24__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.IntentId;
                  }).length > 0;
                  hasResearchIntent = intents.filter(function (x) {
                    return x.IntentId === __WEBPACK_IMPORTED_MODULE_24__appLogic_targets_Constants__["a" /* INTENTS */].Research.IntentId;
                  }).length > 0;

                  if (hasMarketingIntent) {
                    config.datasets = config.datasets.filter(function (x) {
                      return x.id === 'marketing';
                    });
                  } else if (hasResearchIntent) {
                    config.datasets = config.datasets.filter(function (x) {
                      return x.id === 'household' || x.id === 'respondent';
                    });
                  } else {
                    config.datasets = config.datasets.filter(function (x) {
                      return x.id === 'programs';
                    });
                    dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["z" /* SET_TO_VIEW_ONLY */]);
                  }

                  dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_revisionHistory_store_actions__["f" /* SET_TARGET_BRANCH */], { name: target.display_name });
                  if (!getters.revisionHistoryCurrentBranch) {
                    dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_revisionHistory_store_actions__["g" /* SET_MISSING_BRANCH */], { id: target.id, display_name: target.display_name });
                  } else {
                    dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_revisionHistory_store_actions__["h" /* SET_PRIMARY_BRANCH */], { name: target.display_name });
                  }
                  if (getters.isTargetSubmitted || getters.isTargetActivated || getters.isTargetArchived) {
                    dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["z" /* SET_TO_VIEW_ONLY */]);
                  } else {
                    dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["A" /* REMOVE_VIEW_ONLY */]);
                  }
                  return _context.abrupt('return', adConfigApi.fetchDatasets(config.datasets, target.target_datasource).then(function (datasets) {
                    return { datasets: datasets, config: config, esDateRanges: esDateRanges };
                  }));

                case 13:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).then(function (_ref3) {
        var datasets = _ref3.datasets,
            config = _ref3.config,
            esDateRanges = _ref3.esDateRanges;

        commit(__WEBPACK_IMPORTED_MODULE_15__mutations__["b" /* SET_DATA_SOURCES */], datasets.map(function (dataset) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__components_common_attributes__["a" /* default */])(dataset, dataset.id));
        }));
        if (!getters.currentTarget.metadata.intents.map(function (i) {
          return i.IntentId;
        }).includes(__WEBPACK_IMPORTED_MODULE_24__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.IntentId)) {
          commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["j" /* SET_QUICK_ADD */], config.quick_add);
        }
        commit(__WEBPACK_IMPORTED_MODULE_15__mutations__["c" /* SET_DAY_PARTS */], config.day_parts);
        dispatch(__WEBPACK_IMPORTED_MODULE_18__appComponents_oldWorkbench_dateRange_store_actions__["d" /* INIT_DATE_RANGE */], esDateRanges);

        if (getters.isValidStartDate(getters.currentTarget.target_definition.startDate)) {
          dispatch(__WEBPACK_IMPORTED_MODULE_18__appComponents_oldWorkbench_dateRange_store_actions__["a" /* UPDATE_START_DATE */], getters.currentTarget.target_definition.startDate);
          dispatch(__WEBPACK_IMPORTED_MODULE_18__appComponents_oldWorkbench_dateRange_store_actions__["b" /* UPDATE_END_DATE */], getters.currentTarget.target_definition.endDate);
        } else {
          manuallySetDateRange = true;
        }
        if (getters.currentTarget.target_definition.hasOwnProperty('viewSource')) {
          dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], getters.currentTarget.target_definition.viewSource);
        }
        commit(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(getters.currentTarget.target_definition.query, getters));

        if (getters.isTargetActivated || getters.isTargetSubmitted) {
          var currentTarget = getters.currentTarget;
          dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], {
            metrics: currentTarget.metrics || currentTarget.workbench_data.metrics,
            audienceSize: currentTarget.audience_size || currentTarget.workbench_data.audience_size,
            historicalViewership: currentTarget.viewership_historical || currentTarget.workbench_data.viewership_historical,
            universe: currentTarget.universe || currentTarget.workbench_data.universe
          });
          commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
        } else if (getters.isTargetEmpty) {
          commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
        } else {
          return dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]).then(function () {
            dispatch(__WEBPACK_IMPORTED_MODULE_19__store_plugins_undoHistory__["a" /* actions */].INITIALIZE, getters.getDefinition);
          });
        }
      }).then(function () {
        return dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], manuallySetDateRange);
      });
    }
  }, {
    key: 'targetDataToSave',
    value: function targetDataToSave(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state,
          getters = _ref4.getters;

      var rhpm = getters.revisionHistoryPrimaryMove;
      if (rhpm) {
        var td = rhpm.target_data;
        return {
          id: getters.currentTarget.id,
          username: getters.currentTarget.username,
          display_name: getters.currentTarget.display_name,
          target: getters.currentTarget.target,
          target_datasource: getters.currentTarget.target_datasource,
          target_definition: rhpm.target_definition,
          audience_size: td.audienceSize,
          universe: td.universe,
          metrics: td.metrics,
          viewership_historical: td.historicalViewership,
          networks: getters.selectedViewershipNetworks
        };
      } else {
        return {
          id: getters.currentTarget.id,
          username: getters.currentTarget.username,
          display_name: getters.currentTarget.display_name,
          target: getters.currentTarget.target,
          target_datasource: getters.currentTarget.target_datasource,
          target_definition: getters.targetDefinition,
          audience_size: getters.audienceSize,
          universe: getters.universe,
          metrics: state.metrics,
          viewership_historical: getters.historicalViewership,
          networks: getters.selectedViewershipNetworks };
      }
    }
  }, {
    key: 'fetchDataFromTargetForGraphs',
    value: function fetchDataFromTargetForGraphs(_ref5) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          state = _ref5.state,
          getters = _ref5.getters;

      if (getters.isFetchingTarget || getters.isTargetEmpty) return;
      commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], true);
      commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], true);
      var targetDefinitionToFetch = getters.targetDefinition;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_index__["_5" /* fetchAdTargetData */])(targetDefinitionToFetch).then(function (resp) {
        if (targetDefinitionToFetch !== getters.targetDefinition) {
          commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
          dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]);
          return null;
        } else {
          var targetData = {
            metrics: resp.metrics,
            audienceSize: resp.audienceSize && resp.audienceSize.audience,
            historicalViewership: resp.historicalViewership,
            universe: resp.universe
          };
          dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], targetData);
          var lastMove = getters.targetDefinitionLastAttributeCommand;
          var userHasMadeAForwardAction = lastMove;
          if (userHasMadeAForwardAction) {
            dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_revisionHistory_store_actions__["i" /* FORWARD_REVISION_HISTORY */], {
              targetData: targetData,
              targetDefinition: targetDefinitionToFetch,
              audience: targetData.audienceSize,
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__appLogic_targetDefinition_LabelMoveGenerator__["a" /* default */])(lastMove)
            });
          }
          commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
          commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
        }
      });
    }
  }, {
    key: 'dataFromTargetToSet',
    value: function dataFromTargetToSet(commit, data) {
      var metrics = data.metrics,
          audienceSize = data.audienceSize,
          historicalViewership = data.historicalViewership,
          universe = data.universe;

      commit(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["k" /* SET_METRICS */], metrics);
      commit(__WEBPACK_IMPORTED_MODULE_15__mutations__["d" /* SET_AUDIENCE_SIZE */], audienceSize);
      commit(__WEBPACK_IMPORTED_MODULE_15__mutations__["e" /* SET_HISTORICAL_VIEWERSHIP */], historicalViewership);
      commit(__WEBPACK_IMPORTED_MODULE_15__mutations__["f" /* SET_UNIVERSE */], universe);
    }
  }, {
    key: 'additionalActions',
    value: function additionalActions() {
      var _ref8;

      return _ref8 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, __WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["f" /* SET_TARGET_ENVIRONMENT */], function (context, targetData) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], true);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["k" /* SET_TARGET_DEFINITION */], targetData.targetDefinition);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], targetData.targetData);

        setTimeout(function () {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_16__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
        }, 50);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, __WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["k" /* SET_TARGET_DEFINITION */], function (context, targetDefinition) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_18__appComponents_oldWorkbench_dateRange_store_actions__["a" /* UPDATE_START_DATE */], targetDefinition.startDate);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_18__appComponents_oldWorkbench_dateRange_store_actions__["b" /* UPDATE_END_DATE */], targetDefinition.endDate);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(targetDefinition.query, context.getters));
        context.commit(__WEBPACK_IMPORTED_MODULE_20__appLogic_targets_currentTarget_store_actions__["k" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], targetDefinition.networks);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], targetDefinition.viewSource);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, __WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["g" /* SUBMIT_TO_DC */], function (_ref6) {
        var _this3 = this;

        var dispatch = _ref6.dispatch,
            commit = _ref6.commit,
            state = _ref6.state,
            getters = _ref6.getters;

        var target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lodash__["cloneDeep"])(getters.currentTarget);
        target.activation_status = __WEBPACK_IMPORTED_MODULE_24__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED;
        target.activated = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__api_index__["_6" /* submitToDC */])(target).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_25__components_common_toasts__["a" /* default */].success({
            title: 'Successfully Sent Downstream'
          });
          commit(__WEBPACK_IMPORTED_MODULE_20__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], target);
        }).catch(function () {
          var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resp) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_25__components_common_toasts__["a" /* default */].error({
                      title: 'Error sending target Downstream'
                    });

                  case 1:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this3);
          }));

          return function (_x2) {
            return _ref7.apply(this, arguments);
          };
        }());
      }), _ref8;
    }
  }]);

  return WorkbenchActions;
}(__WEBPACK_IMPORTED_MODULE_9__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["m" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (WorkbenchActions);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutations__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_oldWorkbench_dateRange__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasBaseStore__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_revisionHistory_store__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__ = __webpack_require__(3);














var StoreAD = function (_WorkbenchWCanvasBase) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(StoreAD, _WorkbenchWCanvasBase);

  function StoreAD() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StoreAD);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StoreAD.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StoreAD)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(StoreAD, [{
    key: 'additionalState',
    value: function additionalState() {
      return {
        audienceSize: null,
        dayParts: [],
        historicalViewership: null,
        universe: null
      };
    }
  }, {
    key: 'additionalGetters',
    value: function additionalGetters() {
      return {
        targetDefinition: function targetDefinition(state, getters) {
          return {
            startDate: state.dateRange.startDate ? state.dateRange.startDate.from : '',
            endDate: state.dateRange.endDate ? state.dateRange.endDate.to : '',
            query: getters.serializedDefinition,
            networks: getters.selectedViewershipNetworks,
            viewSource: getters.streamingOption,
            promotedNetworks: getters.currentTarget && getters.currentTarget.promotedNetworks
          };
        },
        audienceSize: function audienceSize(state) {
          return state.audienceSize;
        },
        universe: function universe(state) {
          return state.universe;
        },
        historicalViewership: function historicalViewership(state) {
          return state.historicalViewership;
        },
        isTargetEmpty: function isTargetEmpty(state, getters) {
          return !!getters.targetDefinition && !!getters.targetDefinition.query && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(getters.targetDefinition.query);
        },
        isTargetActivated: function isTargetActivated(state, getters) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(getters.currentTarget)) return false;
          return getters.currentTarget.activated;
        },
        isTargetArchived: function isTargetArchived(state, getters) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(getters.currentTarget)) return false;
          return getters.currentTarget.archived;
        },
        isTargetSubmitted: function isTargetSubmitted(state, getters) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(getters.currentTarget)) return false;
          return getters.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED;
        }
      };
    }
  }, {
    key: 'additionalMutations',
    value: function additionalMutations() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__mutations__["a" /* default */]);
    }
  }, {
    key: 'createActions',
    value: function createActions() {
      var WorkbenchActionsAD = new __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* default */]();
      WorkbenchActionsAD.setNamespace(this.namespace);
      return WorkbenchActionsAD.createActions();
    }
  }, {
    key: 'additionalModules',
    value: function additionalModules() {
      var modules = {
        dateRange: __WEBPACK_IMPORTED_MODULE_9__appComponents_oldWorkbench_dateRange__["b" /* module */],
        RevisionHistoryStore: __WEBPACK_IMPORTED_MODULE_11__appLogic_revisionHistory_store__["a" /* default */]
      };
      return modules;
    }
  }]);

  return StoreAD;
}(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasBaseStore__["a" /* default */]);

var module = function module(namespace) {
  return new StoreAD(namespace).create();
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTargetDefinitionWatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);


function createTargetDefinitionWatcher(store) {
  return store.watch(function () {
    return store.getters.targetDefinition;
  }, function (newVal) {
    if (newVal.startDate !== '' && store.getters.currentTarget.id && !store.getters.isTargetActivated) {
      store.dispatch(__WEBPACK_IMPORTED_MODULE_0__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]);
      store.dispatch(__WEBPACK_IMPORTED_MODULE_0__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], true);
    }
  });
}

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_DATA_FOR_AGE_AND_INCOME_GRAPHS */
/* unused harmony export SET_TARGET_DROPPED_ATTRIBUTES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TRIGGERED_ONCE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_attributes__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appLogic_targets_conversions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mutations__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__appComponents_oldWorkbench_dateRange_store_actions__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_ConfigAPI__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__appLogic_networks_store_constants__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_TargetLogic__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__appLogic_revisionHistory_store_actions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__appLogic_targetDefinition_LabelMoveGenerator__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_bluebird__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_U_T__ = __webpack_require__(755);





























var SET_DATA_FOR_AGE_AND_INCOME_GRAPHS = 'SET_DATA_FOR_AGE_AND_INCOME_GRAPHS';
var SET_TARGET_DROPPED_ATTRIBUTES = 'SET_TARGET_DROPPED_ATTRIBUTES';
var SET_TRIGGERED_ONCE = 'SET_TRIGGERED_ONCE';

var lasConfigApi = __WEBPACK_IMPORTED_MODULE_20__api_ConfigAPI__["a" /* default */].getConfigFilesForConfigType('las-config.json');

var WorkbenchActions = function (_WorkbenchWCanvasSlot) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(WorkbenchActions, _WorkbenchWCanvasSlot);

  function WorkbenchActions() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, WorkbenchActions);

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WorkbenchActions.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(WorkbenchActions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(WorkbenchActions, [{
    key: 'initActionBody',
    value: function initActionBody(_ref, id) {
      var _this2 = this;

      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters,
          state = _ref.state;


      commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], true);
      commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["i" /* SET_FETCHING_WORKBENCH_DATA */], true);

      var isDirty = false;
      __WEBPACK_IMPORTED_MODULE_26_bluebird___default.a.props({
        revisionHistory: dispatch(__WEBPACK_IMPORTED_MODULE_24__appLogic_revisionHistory_store_actions__["e" /* GET_REVISION_HISTORY */], { targetId: id }),
        config: lasConfigApi.fetchConfig(),

        target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["f" /* fetchSingleTarget */])({ target_id: id }).then(function (resp) {
          return resp.data;
        })
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(data) {
          var config, target, esDateRanges;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  config = data.config, target = data.target;
                  _context.next = 3;
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["I" /* fetchEsDateRanges */])(target.target_datasource);

                case 3:
                  esDateRanges = _context.sent;


                  commit(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], target);
                  dispatch(__WEBPACK_IMPORTED_MODULE_24__appLogic_revisionHistory_store_actions__["f" /* SET_TARGET_BRANCH */], { name: target.display_name });
                  if (!getters.isTargetActivated && !target.viewing_stream) {
                    target.viewing_stream = 'lsd';
                    commit(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["a" /* SET_TARGET_HAD_CHANGED */]);
                    isDirty = true;
                  }
                  if (!getters.revisionHistoryCurrentBranch) {
                    dispatch(__WEBPACK_IMPORTED_MODULE_24__appLogic_revisionHistory_store_actions__["g" /* SET_MISSING_BRANCH */], { id: target.id, display_name: target.display_name });
                  } else {
                    dispatch(__WEBPACK_IMPORTED_MODULE_24__appLogic_revisionHistory_store_actions__["h" /* SET_PRIMARY_BRANCH */], { name: target.display_name });
                  }
                  if (!getters.hasCreateEditPermissions) {
                    dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["z" /* SET_TO_VIEW_ONLY */]);
                  } else {
                    dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["A" /* REMOVE_VIEW_ONLY */]);
                  }
                  return _context.abrupt('return', lasConfigApi.fetchDatasets(config.datasets, target.target_datasource === 'ncs' ? 'nielsen' : target.target_datasource).then(function (datasets) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["q" /* fetchNetworksConfig */])().then(function (networks) {
                      return { networks: networks, datasets: datasets, config: config, esDateRanges: esDateRanges };
                    });
                  }));

                case 10:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).then(function (_ref3) {
        var datasets = _ref3.datasets,
            networks = _ref3.networks,
            config = _ref3.config,
            esDateRanges = _ref3.esDateRanges;

        commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["b" /* SET_DATA_SOURCES */], datasets.map(function (dataset) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__components_common_attributes__["a" /* default */])(dataset, dataset.id));
        }));
        commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["j" /* SET_QUICK_ADD */], config.quick_add);
        commit(__WEBPACK_IMPORTED_MODULE_22__appLogic_networks_store_constants__["a" /* SET_NETWORKS */], networks.networks);
        commit(__WEBPACK_IMPORTED_MODULE_22__appLogic_networks_store_constants__["b" /* SET_NETWORKS_GROUPINGS */], networks.categories);

        commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["c" /* SET_DAY_PARTS */], config.day_parts);
        dispatch(__WEBPACK_IMPORTED_MODULE_19__appComponents_oldWorkbench_dateRange_store_actions__["d" /* INIT_DATE_RANGE */], esDateRanges);

        var ct = getters.currentTarget;
        if (getters.isValidStartDate(ct.target_definition.startDate)) {
          dispatch(__WEBPACK_IMPORTED_MODULE_19__appComponents_oldWorkbench_dateRange_store_actions__["a" /* UPDATE_START_DATE */], ct.target_definition.startDate);
          dispatch(__WEBPACK_IMPORTED_MODULE_19__appComponents_oldWorkbench_dateRange_store_actions__["b" /* UPDATE_END_DATE */], ct.target_definition.endDate);
        } else {
          isDirty = true;
        }

        commit(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(ct.target_definition.query, getters));
        dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], ct.viewing_stream);

        ct.workbench_data.networks ? commit(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_currentTarget_store_actions__["k" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], ct.workbench_data.networks) : commit(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_currentTarget_store_actions__["k" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lodash__["filter"])(networks.networks, function (network) {
          return network.turner;
        }), function (network) {
          return network.id;
        }));
        if (getters.isTargetActivated) {
          dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], {
            metrics: ct.workbench_data.metrics,
            audienceSize: ct.workbench_data.audience_size,
            historicalViewership: ct.workbench_data.viewership_historical,
            universe: ct.workbench_data.universe
          });
          commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
        } else {
          return dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]).then(function () {
            dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["B" /* INITIALIZE_TARGET_DEF */], getters.getDefinition);
          });
        }
      }).then(function () {
        dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], isDirty);
      }).finally(function () {
        if (getters.isFetchingWorkbenchData) {
          commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["i" /* SET_FETCHING_WORKBENCH_DATA */], false);
          dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]);
        }
      });
    }
  }, {
    key: 'targetDataToSave',
    value: function targetDataToSave(_ref4) {
      var state = _ref4.state,
          getters = _ref4.getters;

      var rhpm = getters.revisionHistoryCurrentMove;
      if (rhpm) {
        var td = rhpm.target_data;
        return {
          id: getters.currentTarget.id,
          username: getters.currentTarget.username,
          display_name: getters.currentTarget.display_name,
          target: getters.currentTarget.target,
          target_datasource: getters.currentTarget.target_datasource,
          target_definition: getters.targetDefinition,
          audience_size: td.audienceSize,
          universe: getters.universe,
          metrics: td.metrics,
          viewership_historical: td.historicalViewership,
          networks: getters.selectedViewershipNetworks,
          age_data: td.age,
          income_data: td.income,
          viewing_stream: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__appLogic_targets_conversions__["b" /* convertViewingStreamForAM */])(state.streamingOption)
        };
      } else {
        return {
          id: getters.currentTarget.id,
          username: getters.currentTarget.username,
          display_name: getters.currentTarget.display_name,
          target: getters.currentTarget.target,
          target_datasource: getters.currentTarget.target_datasource,
          target_definition: getters.targetDefinition,
          audience_size: getters.audienceSize,
          universe: getters.universe,
          metrics: state.metrics,
          viewership_historical: getters.historicalViewership,
          networks: getters.selectedViewershipNetworks,
          age_data: getters.ageData,
          income_data: getters.incomeData,
          viewing_stream: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__appLogic_targets_conversions__["b" /* convertViewingStreamForAM */])(state.streamingOption)
        };
      }
    }
  }, {
    key: 'fetchDataFromTargetForGraphs',
    value: function fetchDataFromTargetForGraphs(_ref5) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          getters = _ref5.getters,
          state = _ref5.state;

      var theTime = new Date();
      var currentNumber = state.requestNumber;
      commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], true);
      if (getters.isFetchingWorkbenchData) {
        return;
      }
      commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], true);

      var targetDefinitionToFetch = getters.targetDefinition;
      var ageAndIncome = dispatch(SET_DATA_FOR_AGE_AND_INCOME_GRAPHS).then(function (ageAndIncome) {
        return __WEBPACK_IMPORTED_MODULE_26_bluebird___default.a.props({
          age: ageAndIncome.age,
          income: ageAndIncome.income
        });
      });

      var freshTargetDefinition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["s" /* fetchTargetDefinition */])(targetDefinitionToFetch).then(function (resp) {
        var freshDefinition = resp.data;
        if (currentNumber === state.requestNumber) {
          commit(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["n" /* SET_DROPPED_ATTRIBUTES_IN_TD */], __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(freshDefinition));
        }
        return getters.targetDefinition;
      });

      var targetData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["t" /* fetchTargetData */])(targetDefinitionToFetch).then(function (resp) {
        var targetData = {
          metrics: resp.metrics,
          audienceSize: resp.audienceSize && resp.audienceSize.audience,
          historicalViewership: resp.historicalViewership,
          universe: resp.universe
        };
        return targetData;
      }).catch(function (e) {
        return console.error(e);
      });

      return __WEBPACK_IMPORTED_MODULE_26_bluebird___default.a.props({
        ageAndIncome: ageAndIncome,
        freshTargetDefinition: freshTargetDefinition,
        targetData: targetData
      }).then(function (targetInformation) {
        if (currentNumber === state.requestNumber) {
          if (targetInformation.freshTargetDefinition !== getters.targetDefinition) {
            commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
            dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]);
            return null;
          } else {
            dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], targetInformation.targetData);
            var lastMove = getters.targetDefinitionLastAttributeCommand;
            var userHasMadeAForwardAction = lastMove;
            if (userHasMadeAForwardAction) {
              dispatch(__WEBPACK_IMPORTED_MODULE_24__appLogic_revisionHistory_store_actions__["i" /* FORWARD_REVISION_HISTORY */], {
                targetData: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, targetInformation.targetData, targetInformation.ageAndIncome),
                targetDefinition: targetInformation.freshTargetDefinition,
                audience: targetInformation.targetData.audienceSize,
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__appLogic_targetDefinition_LabelMoveGenerator__["a" /* default */])(lastMove)
              });
            }
            commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
            commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
          }
        }
      });
    }
  }, {
    key: 'dataFromTargetToSet',
    value: function dataFromTargetToSet(commit, data) {
      var metrics = data.metrics,
          audienceSize = data.audienceSize,
          historicalViewership = data.historicalViewership,
          universe = data.universe;

      commit(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["k" /* SET_METRICS */], metrics);
      commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["d" /* SET_AUDIENCE_SIZE */], audienceSize);
      commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["e" /* SET_HISTORICAL_VIEWERSHIP */], historicalViewership);
      commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["f" /* SET_UNIVERSE */], universe);
    }
  }, {
    key: 'additionalActions',
    value: function additionalActions() {
      var _ref8;

      return _ref8 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, SET_DATA_FOR_AGE_AND_INCOME_GRAPHS, function (_ref6) {
        var getters = _ref6.getters,
            commit = _ref6.commit;

        var targetDefinitionToFetch = getters.targetDefinition;
        return {
          age: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["L" /* fetchAgeDistribution */])(targetDefinitionToFetch).then(function (resp) {
            commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["g" /* SET_AGE_DISTRIBUTION */], resp.data.data);
            return resp.data.data;
          }),
          income: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["M" /* fetchIncomeDistribution */])(targetDefinitionToFetch).then(function (resp) {
            commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["h" /* SET_INCOME_DISTRIBUTION */], resp.data.data);
            return resp.data.data;
          })
        };
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["f" /* SET_TARGET_ENVIRONMENT */], function (context, targetData) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], true);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["k" /* SET_TARGET_DEFINITION */], targetData.targetDefinition);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], targetData.targetData);
        context.commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["g" /* SET_AGE_DISTRIBUTION */], targetData.targetData.age);
        context.commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["h" /* SET_INCOME_DISTRIBUTION */], targetData.targetData.income);

        setTimeout(function () {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
        }, 50);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["k" /* SET_TARGET_DEFINITION */], function (context, targetDefinition) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__appComponents_oldWorkbench_dateRange_store_actions__["a" /* UPDATE_START_DATE */], targetDefinition.startDate);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_19__appComponents_oldWorkbench_dateRange_store_actions__["b" /* UPDATE_END_DATE */], targetDefinition.endDate);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(targetDefinition.query, context.getters));
        context.commit(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_currentTarget_store_actions__["k" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], targetDefinition.networks);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], targetDefinition.viewSource);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, SET_TARGET_DROPPED_ATTRIBUTES, function (_ref7) {
        var getters = _ref7.getters,
            commit = _ref7.commit;

        var waitFunction = function waitFunction() {
          var AD = getters.dateRange.availableDates;
          return AD.length > 0;
        };
        var mainFunction = function mainFunction() {
          var AD = getters.dateRange.availableDates;
          var endDate = AD[AD.length - 1].to;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__api__["s" /* fetchTargetDefinition */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getters.currentTarget.target_definition, {
            endDate: endDate
          })).then(function (resp) {
            var freshDefinition = resp.data;
            commit(__WEBPACK_IMPORTED_MODULE_17__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_11__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(freshDefinition));
            var isDropped = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_TargetLogic__["b" /* hasRemovedAttributes */])(freshDefinition);
            commit(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["l" /* SET_IS_DROPPED */], isDropped);
            return getters.targetDefinition;
          });
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__common_U_T__["a" /* waitForRaceCondition */])(waitFunction, mainFunction);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, __WEBPACK_IMPORTED_MODULE_16__mutations__["a" /* SHOW_DROPPED_ATTRIBUTES_MODEL */], function (context) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_currentTarget_store_actions__["x" /* SET_TARGET_DROPPED_ATTRIBUTES */], context.getters.currentTarget.id);
        context.commit(__WEBPACK_IMPORTED_MODULE_16__mutations__["a" /* SHOW_DROPPED_ATTRIBUTES_MODEL */]);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref8, SET_TRIGGERED_ONCE, function (context) {
        context.commit(SET_TRIGGERED_ONCE);
      }), _ref8;
    }
  }]);

  return WorkbenchActions;
}(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["m" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (WorkbenchActions);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sm_vue__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Sm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_watchers__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(32);





var unwatchers = [];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store__["d" /* createStoreConnector */])('sm', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */])('sm'), {
  onRegistered: function onRegistered(store) {
    unwatchers.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_watchers__["a" /* createTargetDefinitionWatcher */])(store));
  },
  onUnregistered: function onUnregistered() {
    unwatchers.forEach(function (unwatcher) {
      return unwatcher.call();
    });
  }
})(__WEBPACK_IMPORTED_MODULE_0__Sm_vue___default.a));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_ConfigAPI__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_services_serializer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_attributes__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutations__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appLogic_revisionHistory_store_actions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bluebird__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appLogic_targetDefinition_LabelMoveGenerator__ = __webpack_require__(207);

























var smConfigApi = __WEBPACK_IMPORTED_MODULE_7__api_ConfigAPI__["a" /* default */].getConfigFilesForConfigType('sm-config.json');

var WorkbenchActions = function (_WorkbenchWCanvasSlot) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(WorkbenchActions, _WorkbenchWCanvasSlot);

  function WorkbenchActions() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, WorkbenchActions);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WorkbenchActions.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(WorkbenchActions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(WorkbenchActions, [{
    key: 'initActionBody',
    value: function initActionBody(_ref, id) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters,
          state = _ref.state;

      commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], true);
      __WEBPACK_IMPORTED_MODULE_17_bluebird___default.a.props({
        revisionHistory: dispatch(__WEBPACK_IMPORTED_MODULE_15__appLogic_revisionHistory_store_actions__["e" /* GET_REVISION_HISTORY */], { targetId: id }),
        config: smConfigApi.fetchConfig(),

        target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_index__["f" /* fetchSingleTarget */])({ target_id: id }).then(function (resp) {
          return resp.data;
        })
      }).then(function (data) {
        var config = data.config,
            target = data.target;

        commit(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], target);
        dispatch(__WEBPACK_IMPORTED_MODULE_15__appLogic_revisionHistory_store_actions__["f" /* SET_TARGET_BRANCH */], { name: target.display_name });
        if (!getters.revisionHistoryCurrentBranch) {
          dispatch(__WEBPACK_IMPORTED_MODULE_15__appLogic_revisionHistory_store_actions__["g" /* SET_MISSING_BRANCH */], { id: target.id, display_name: target.display_name });
        } else {
          dispatch(__WEBPACK_IMPORTED_MODULE_15__appLogic_revisionHistory_store_actions__["h" /* SET_PRIMARY_BRANCH */], { name: target.display_name });
        }
        if (getters.isTargetActivated || getters.isTargetArchived) {
          dispatch(__WEBPACK_IMPORTED_MODULE_14__appComponents_oldWorkbench_targetDefinition_store_actions__["z" /* SET_TO_VIEW_ONLY */]);
        } else {
          dispatch(__WEBPACK_IMPORTED_MODULE_14__appComponents_oldWorkbench_targetDefinition_store_actions__["A" /* REMOVE_VIEW_ONLY */]);
        }
        return smConfigApi.fetchDatasets(config.datasets).then(function (datasets) {
          return { datasets: datasets, config: config };
        });
      }).then(function (_ref2) {
        var datasets = _ref2.datasets,
            config = _ref2.config;

        commit(__WEBPACK_IMPORTED_MODULE_12__mutations__["b" /* SET_DATA_SOURCES */], datasets.filter(function (d) {
          return !d.id.startsWith('gigya');
        }).map(function (dataset) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__components_common_attributes__["a" /* default */])(dataset, dataset.id));
        }));
        commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["j" /* SET_QUICK_ADD */], config.quick_add);
        commit(__WEBPACK_IMPORTED_MODULE_14__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(getters.currentTarget.target_definition.query, getters));
        if (getters.currentTarget.target_definition.hasOwnProperty('viewSource')) {
          dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], getters.currentTarget.target_definition.viewSource);
        }
        if (getters.isTargetActivated) {
          var currentTarget = getters.currentTarget;
          dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], {
            metrics: currentTarget.metrics,
            audienceSize: currentTarget.audience_size,
            topTsp: currentTarget.tsp_attributes,
            topSocialAffinity: currentTarget.social_affinity,
            reach: currentTarget.brand_reach
          });
          commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
        } else {
          return dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]).then(function () {
            dispatch(__WEBPACK_IMPORTED_MODULE_14__appComponents_oldWorkbench_targetDefinition_store_actions__["B" /* INITIALIZE_TARGET_DEF */], getters.getDefinition);
          });
        }
      }).then(function () {
        return dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], false);
      });
    }
  }, {
    key: 'targetDataToSave',
    value: function targetDataToSave(_ref3) {
      var state = _ref3.state,
          getters = _ref3.getters;

      var rhpm = getters.revisionHistoryPrimaryMove;
      if (rhpm) {
        var td = rhpm.target_data;

        return {
          id: getters.currentTarget.id,
          username: getters.currentTarget.username,
          display_name: getters.currentTarget.display_name,
          target: getters.currentTarget.target,
          target_definition: rhpm.target_definition,
          metrics: td.metrics,
          audience_size: td.audienceSize,
          tsp_attributes: td.topTsp,
          social_affinity: td.topSocialAffinity,
          brand_reach: state.canvas.reach
        };
      } else {
        return {
          id: getters.currentTarget.id,
          username: getters.currentTarget.username,
          display_name: getters.currentTarget.display_name,
          target: getters.currentTarget.target,
          target_definition: getters.targetDefinition,
          metrics: state.metrics,
          audience_size: state.canvas.audienceSize,
          tsp_attributes: state.canvas.topTsp,
          social_affinity: state.canvas.topSocialAffinity,
          brand_reach: state.canvas.reach
        };
      }
    }
  }, {
    key: 'fetchDataFromTargetForGraphs',
    value: function fetchDataFromTargetForGraphs(_ref4) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          getters = _ref4.getters;

      if (getters.isFetchingTarget) return;
      commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], true);
      commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], true);
      var targetDefinitionToFetch = getters.targetDefinition;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_index__["_7" /* fetchSmTargetData */])(targetDefinitionToFetch).then(function (resp) {
        if (targetDefinitionToFetch !== getters.targetDefinition) {
          commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
          dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]);
        } else {
          var targetData = {
            metrics: resp.metrics,
            audienceSize: resp.audienceSize && resp.audienceSize.audience,
            topTsp: resp.topTsp && resp.topTsp.top_10_tsp,
            topSocialAffinity: resp.topSocialAffinity && resp.topSocialAffinity.top_10_social_affinity,
            reach: resp.reach && resp.reach.brand_engagement_reach
          };
          dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], targetData);
          var lastMove = getters.targetDefinitionLastAttributeCommand;
          var userHasMadeAForwardAction = lastMove;
          if (userHasMadeAForwardAction) {
            dispatch(__WEBPACK_IMPORTED_MODULE_15__appLogic_revisionHistory_store_actions__["i" /* FORWARD_REVISION_HISTORY */], {
              targetData: targetData,
              targetDefinition: targetDefinitionToFetch,
              audience: targetData.audienceSize,
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__appLogic_targetDefinition_LabelMoveGenerator__["a" /* default */])(lastMove)
            });
          }
          commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["e" /* SET_LOADING */], false);
          commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
        }
      });
    }
  }, {
    key: 'dataFromTargetToSet',
    value: function dataFromTargetToSet(commit, data) {
      var metrics = data.metrics,
          audienceSize = data.audienceSize,
          topTsp = data.topTsp,
          topSocialAffinity = data.topSocialAffinity,
          reach = data.reach;

      commit(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["k" /* SET_METRICS */], metrics);
      commit(__WEBPACK_IMPORTED_MODULE_12__mutations__["c" /* SET_AUDIENCE_SIZE */], audienceSize);
      commit(__WEBPACK_IMPORTED_MODULE_12__mutations__["d" /* SET_TOP_TSP */], topTsp);
      commit(__WEBPACK_IMPORTED_MODULE_12__mutations__["e" /* SET_TOP_SOCIAL_AFFINITY */], topSocialAffinity);
      commit(__WEBPACK_IMPORTED_MODULE_12__mutations__["f" /* SET_REACH */], reach);
    }
  }, {
    key: 'additionalActions',
    value: function additionalActions() {
      var _ref5;

      return _ref5 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref5, __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["f" /* SET_TARGET_ENVIRONMENT */], function (context, targetData) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], true);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["k" /* SET_TARGET_DEFINITION */], targetData.targetDefinition);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["h" /* SET_DATA_FROM_TARGET */], targetData.targetData);

        setTimeout(function () {
          context.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_workbenchCanvas_store_mutations__["h" /* SET_FETCHING_TARGET */], false);
        }, 50);
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref5, __WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["k" /* SET_TARGET_DEFINITION */], function (context, targetDefinition) {
        context.dispatch(__WEBPACK_IMPORTED_MODULE_14__appComponents_oldWorkbench_targetDefinition_store_actions__["m" /* SET_DEFINITION */], __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_services_serializer__["a" /* default */].deserialize(targetDefinition.query, context.getters));
        context.commit(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_currentTarget_store_actions__["k" /* SET_SELECTED_VIEWERSHIP_NETWORKS */], targetDefinition.networks);
        context.dispatch(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], targetDefinition.viewSource);
      }), _ref5;
    }
  }]);

  return WorkbenchActions;
}(__WEBPACK_IMPORTED_MODULE_10__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["m" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (WorkbenchActions);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_workbenchCanvas_store_WorkbenchWCanvasBaseStore__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_revisionHistory_store__ = __webpack_require__(318);













var StoreSM = function (_WorkbenchWCanvasBase) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(StoreSM, _WorkbenchWCanvasBase);

  function StoreSM() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StoreSM);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StoreSM.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StoreSM)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(StoreSM, [{
    key: 'additionalState',
    value: function additionalState() {
      return {
        canvas: {
          audienceSize: null,
          topSocialAffinity: [],
          topTsp: [],
          reach: null
        }
      };
    }
  }, {
    key: 'additionalGetters',
    value: function additionalGetters() {
      return {
        targetDefinition: function targetDefinition(state, getters) {
          return {
            query: getters.serializedDefinition,
            viewSource: getters.streamingOption
          };
        },
        audienceSize: function audienceSize(state) {
          return state.canvas.audienceSize;
        },

        topTsp: function topTsp(state, getters) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.canvas.topTsp) === 'object' ? state.canvas.topTsp.map(function (o) {
            var newO = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(o);
            newO.dataset = 'tsp';
            newO.attribute = getters.getAttributeForIdDataset(newO);
            return newO;
          }) : undefined;
        },
        isTargetArchived: function isTargetArchived(state, getters) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(getters.currentTarget)) return false;
          return getters.currentTarget.archived;
        },
        topSocialAffinity: function topSocialAffinity(state, getters) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.canvas.topSocialAffinity) === 'object') {
            return state.canvas.topSocialAffinity.map(function (o) {
              var newO = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(o);
              newO.dataset = 'gigya_likes';
              newO.attribute = getters.getAttributeForIdDataset(newO);

              if (!newO.attribute) {
                newO.dataset = 'gigya_favs';
                newO.attribute = getters.getAttributeForIdDataset(newO);
              }
              return newO;
            });
          } else {
            return undefined;
          }
        },
        reach: function reach(state) {
          return state.canvas.reach;
        },
        showGenerateEstimate: function showGenerateEstimate(state, getters) {
          var target = getters.currentTarget;
          if (target.display_name) {
            var activationBlocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["f" /* isActivationBlocked */])(target.target);
            var cantShow = target.activated || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["g" /* isTargetOwnedBy */])(target, getters.username) || activationBlocked;
            return !cantShow;
          } else {
            return false;
          }
        }
      };
    }
  }, {
    key: 'additionalMutations',
    value: function additionalMutations() {
      return __WEBPACK_IMPORTED_MODULE_6__mutations__["a" /* default */];
    }
  }, {
    key: 'additionalModules',
    value: function additionalModules() {
      var modules = {
        RevisionHistoryStore: __WEBPACK_IMPORTED_MODULE_11__appLogic_revisionHistory_store__["a" /* default */]
      };
      return modules;
    }
  }, {
    key: 'createActions',
    value: function createActions() {
      var WorkbenchActionsSM = new __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */]();
      WorkbenchActionsSM.setNamespace(this.namespace);
      return WorkbenchActionsSM.createActions();
    }
  }]);

  return StoreSM;
}(__WEBPACK_IMPORTED_MODULE_8__views_workbenchCanvas_store_WorkbenchWCanvasBaseStore__["a" /* default */]);

var module = function module(namespace) {
  return new StoreSM(namespace).create();
};
/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTargetDefinitionWatcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);


function createTargetDefinitionWatcher(store) {
  return store.watch(function () {
    return store.getters.targetDefinition;
  }, function (newVal) {
    if (store.getters.currentTarget.id && !store.getters.isTargetActivated) {
      store.dispatch(__WEBPACK_IMPORTED_MODULE_0__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["i" /* FETCH_DATA_FROM_TARGET_FOR_GRAPHS */]);
      store.dispatch(__WEBPACK_IMPORTED_MODULE_0__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], true);
    }
  });
}

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_WorkbenchCanvas__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_WorkbenchCanvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_WorkbenchCanvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_workbench_common_store_actions__ = __webpack_require__(31);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    WorkbenchCanvas: __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_WorkbenchCanvas___default.a
  },
  created: function created() {
    var targetId = this.$route.params.id;
    this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_1__appLogic_workbench_common_store_actions__["y" /* ON_CREATE_ACTION */], { interface: this.interface, id: targetId });
  },
  destroyed: function destroyed() {
    this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_1__appLogic_workbench_common_store_actions__["q" /* RESET_STORE */]);
  }
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_enterprise__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ag_grid_enterprise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ag_grid_enterprise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_auth_constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_applicationResources_constants__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_networks_store_constants__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_permissions_store_constants__ = __webpack_require__(69);




__WEBPACK_IMPORTED_MODULE_2_ag_grid_enterprise__["LicenseManager"].setLicenseKey('Turner_MultiApp_16Devs_2Deployment_13_August_2020__MTU5NzI3MzIwMDAwMA==d8b9dc69b582e4b67e7bd7c161d4075e');





var LOCATION_USER_WOULD_LIKE_TO_GO_TO = 'LOCATION_USER_WOULD_LIKE_TO_GO_TO';
var LOCATION_BEFORE_REDIRECT_TO_LOGIN = 'AM_LOCATION_BEFORE_REDIRECT_TO_LOGIN';

var saveLocationBeforeLogin = function saveLocationBeforeLogin() {
  var currentLocation = window.location.href;
  localStorage.setItem(LOCATION_BEFORE_REDIRECT_TO_LOGIN, currentLocation);
};

var shouldGoToLocation = function shouldGoToLocation(url) {
  var x = new URL(url);
  var isLogin = x.hash ? x.hash.includes('login') : false;
  var forwardSlashSplitsAfterHash = x.hash ? x.hash.split('/') : [];
  var forwardSlashSplits = url.split('/');
  if (isLogin && forwardSlashSplitsAfterHash.length === 2) {
    return false;
  }

  var lengthOfFSSplits = forwardSlashSplits.length;
  if (lengthOfFSSplits === 5) {
    return forwardSlashSplits[4] !== '';
  } else if (lengthOfFSSplits > 5) {
    return true;
  }
};

var dispatchUserToLocation = function dispatchUserToLocation(username, router) {
  var locationUserWasTryingToGoTo = localStorage.getItem(LOCATION_BEFORE_REDIRECT_TO_LOGIN);
  localStorage.removeItem(LOCATION_BEFORE_REDIRECT_TO_LOGIN);
  if (locationUserWasTryingToGoTo && shouldGoToLocation(locationUserWasTryingToGoTo)) {
    var splitAtHashtag = locationUserWasTryingToGoTo.split('/#/');
    router.push({ path: splitAtHashtag[1] }).catch(function (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  } else if (!shouldGoToLocation(window.location.href)) {
    router.push('/audience-hub/targets/' + username).catch(function (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  beforeCreate: function beforeCreate() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var user, isAuthenticated;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.$auth) {
                _context.next = 22;
                break;
              }

              _context.next = 3;
              return _this.$auth.handleLoginRedirect();

            case 3:
              user = null;
              _context.next = 6;
              return _this.$auth.getUser().then(function (resp) {
                user = resp;
                return true;
              }).catch(function (resp) {
                return false;
              });

            case 6:
              isAuthenticated = _context.sent;

              if (!isAuthenticated) {
                _context.next = 20;
                break;
              }

              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_modules_auth_constants__["a" /* OKTA_OIDC_INITIALIZE */], { auth: _this.$auth, user: user });
              _context.next = 11;
              return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_applicationResources_constants__["a" /* SET_SOURCE_CONSTANTS */]);

            case 11:
              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_applicationResources_constants__["b" /* SET_PRIMARY_INSIGHTS_FILTER */]);
              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_applicationResources_constants__["c" /* SET_DATASETS */]);
              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__appLogic_networks_store_constants__["a" /* SET_NETWORKS */]);
              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_permissions_store_constants__["a" /* SET_PERMISSIONS */]);
              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_applicationResources_constants__["d" /* SET_MVPDS */]);
              _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_modules_applicationResources_constants__["e" /* SET_VIDEOAMP_AUDIENCE_LIST */]);
              dispatchUserToLocation(user.email.toLowerCase(), _this.$router);
              _context.next = 22;
              break;

            case 20:
              saveLocationBeforeLogin();
              _this.$router.replace({ name: 'login' });

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      topPosition: 0,
      showStatusWidget: false,
      targetData: {}
    };
  },
  beforeMount: function beforeMount() {
    this.targetData = this.params.api.getDisplayedRowAtIndex(this.params.rowIndex).data;

    var row = document.querySelector('div[col-id="activation_status"]');
    if (row) {
      this.getTopPosition(row);
    }
  },

  computed: {
    cssProps: function cssProps() {
      return {
        'bottom': this.topPosition - 35 + 'px'
      };
    },
    title: function title() {
      if (!this.targetData) return;

      return this.targetData.activation_status;
    },
    isAddressable: function isAddressable() {
      if (!this.targetData) return;

      return this.targetData.destinations && this.targetData.destinations.some(function (destination) {
        return [__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV, __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO, __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR, __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD].includes(destination);
      });
    },
    isPlanning: function isPlanning() {
      if (!this.targetData) return;

      var planning_statuses = [__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING, __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT, __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELING];

      return planning_statuses.includes(this.targetData.activation_status);
    },
    isPlanned: function isPlanned() {
      if (!this.targetData) return;

      var planned_statuses = [__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE, __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED];

      return planned_statuses.includes(this.targetData.activation_status) && this.targetData.activation_date !== null;
    },
    planningText: function planningText() {
      return this.isPlanned ? 'Planned' : 'Planning';
    },
    isOrdered: function isOrdered() {
      if (!this.targetData || !this.isPlanned || !this.targetData.am_data || !this.targetData.am_data.order) return;

      return this.targetData.am_data.order.orderId !== null;
    },
    orderingText: function orderingText() {
      return this.isOrdered ? 'Ordered' : 'Ordering';
    },
    currentTarget: function currentTarget() {
      return this.$store.getters.currentTarget;
    }
  },
  methods: {
    getTopPosition: function getTopPosition(element) {
      var y = 0;
      while (true) {
        y += element.offsetTop;
        if (element.offsetParent === null) {
          break;
        }
        element = element.offsetParent;
      }
      this.topPosition = y;
    }
  }
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ag_grid_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ag_grid_enterprise__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ag_grid_enterprise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ag_grid_enterprise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_TargetRenderer__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_TargetRenderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__appComponents_targets_TargetRenderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_TargetNameRenderer__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_TargetNameRenderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__appComponents_targets_TargetNameRenderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_DestinationsRenderer__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_DestinationsRenderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__appComponents_targets_DestinationsRenderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_targets_AudienceDetailRenderer__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_targets_AudienceDetailRenderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__appComponents_targets_AudienceDetailRenderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appComponents_targets_components_modals_RePostingModal__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appComponents_targets_components_modals_RePostingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__appComponents_targets_components_modals_RePostingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_simpleButton__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_targets_components_DeleteTargetModal__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_targets_components_DeleteTargetModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__appComponents_targets_components_DeleteTargetModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appComponents_targets_components_DownloadPidListModal__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appComponents_targets_components_DownloadPidListModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__appComponents_targets_components_DownloadPidListModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__appComponents_targets_components_NPowerAppendTargetModal__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__appComponents_targets_components_NPowerAppendTargetModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__appComponents_targets_components_NPowerAppendTargetModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_tooltip__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_modules_applicationResources_constants__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__appLogic_route_store_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__api_eventBus__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__appComponents_audienceHubDashboard_SearchSetFilter__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__appComponents_audienceHubDashboard_SearchSetFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__appComponents_audienceHubDashboard_SearchSetFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__appComponents_audienceHubDashboard_AddressableStatusIndicator__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__appComponents_audienceHubDashboard_AddressableStatusIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__appComponents_audienceHubDashboard_AddressableStatusIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue__ = __webpack_require__(14);



































var DEFAULT_SEARCH_FIELDS = ['advertiserBrand', 'username', 'display_name', 'cae_id'];

var targetFilterOptions = [{
  name: 'My Targets',
  value: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_TARGETS
}, {
  name: 'All Targets',
  value: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].ALL_TARGETS
}, {
  name: 'Archived Targets',
  value: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].ARCHIVED_TARGETS
}, {
  name: 'My Archived Targets',
  value: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_ARCHIVED_TARGETS
}];

var OPTIONS = {
  ACTIVATE: 'ACTIVATE',
  OPEN: 'OPEN',
  DUPLICATE: 'DUPLICATE',
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  GRAPH: 'GRAPH',
  SETTINGS: 'SETTINGS',
  DELETE: 'DELETE',
  RE_POST: 'RE_FORECAST',
  DEFINITION: 'DEFINITION',
  PID_DOWNLOAD: 'PID_DOWNLOAD',
  APPEND: 'APPEND',
  UPDATE_LAS_MODAL: 'UPDATE_LAS_MODAL',
  UPDATE_CAMPAIGN_DATA_MODAL: 'UPDATE_CAMPAIGN_DATA_MODAL',
  SEND_DOWNSTREAM: 'SEND_DOWNSTREAM'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgGridVue: __WEBPACK_IMPORTED_MODULE_7_ag_grid_vue__["AgGridVue"],
    TargetRenderer: __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_TargetRenderer___default.a,
    TargetNameRenderer: __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_TargetNameRenderer___default.a,
    DestinationsRenderer: __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_DestinationsRenderer___default.a,
    SimpleButton: __WEBPACK_IMPORTED_MODULE_15__components_common_simpleButton__["a" /* default */],
    DeleteTargetModal: __WEBPACK_IMPORTED_MODULE_17__appComponents_targets_components_DeleteTargetModal___default.a,
    AppendTargetModal: __WEBPACK_IMPORTED_MODULE_19__appComponents_targets_components_NPowerAppendTargetModal___default.a,
    DownloadPidListModal: __WEBPACK_IMPORTED_MODULE_18__appComponents_targets_components_DownloadPidListModal___default.a,
    RePostingModal: __WEBPACK_IMPORTED_MODULE_13__appComponents_targets_components_modals_RePostingModal___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_20__components_common_tooltip__["a" /* default */],
    AddressableStatusIndicator: __WEBPACK_IMPORTED_MODULE_30__appComponents_audienceHubDashboard_AddressableStatusIndicator___default.a
  },
  props: {
    filters: null,
    searchFields: { type: Array, default: function _default() {
        return DEFAULT_SEARCH_FIELDS;
      } },
    routeParamsName: '',
    nielsenDatasources: {},
    C360Datasources: {}
  },
  data: function data() {
    return {
      gridApi: null,
      columnDefs: null,
      targetFilterOptions: targetFilterOptions,
      frameworkComponents: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        filterParams: { newRowsAction: 'keep' },
        tooltipComponent: 'addressableStatusIndicator'
      },
      audienceDetailRenderer: null,
      detailRowHeight: null,
      popover: null,
      activeRowId: null,
      selectedTarget: null,
      targetTypeToAbbrev: __WEBPACK_IMPORTED_MODULE_14__helpers__["j" /* targetTypeToAbbrev */],
      defaultTargetFilterOption: {
        name: 'My Targets',
        value: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_TARGETS
      },
      appliedFilters: [],
      forceUpdateFilterValues: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var columnDefs = [{
      headerName: 'Name',
      field: 'display_name',
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        suppressCount: true,
        innerRendererFramework: 'TargetNameRenderer',
        suppressEnterExpand: true
      },
      filter: 'agTextColumnFilter',
      flex: 5,
      cellClass: 'audience-hub-table__text-cell'
    }, {
      headerName: 'Source',
      field: 'datasources',
      valueGetter: function valueGetter(params) {
        if (!params.data || !params.data.datasources) return '';
        return params.data.datasources.sort(function (a, b) {
          return a > b ? 1 : -1;
        });
      },
      cellRendererFramework: 'TargetRenderer',
      filter: 'searchSetFilter',
      filterParams: {
        filterType: 'set',
        values: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */]).sort(function (a, b) {
          return a.name > b.name ? 1 : -1;
        })
      },
      flex: 2.5,
      cellClass: 'audience-hub-table__text-cell',
      autoHeight: true
    }, {
      headerName: 'AM ID',
      field: 'cae_id',
      filter: 'agNumberColumnFilter',
      flex: 1.5,
      sort: 'desc',
      cellClass: 'audience-hub-table__text-cell',
      minWidth: 76
    }, {
      headerName: 'Advertiser/Brand',
      field: 'advertiserBrand',
      valueGetter: function valueGetter(params) {
        return ((params.data || {}).advertiser || {}).Name;
      },
      filter: 'agTextColumnFilter',
      flex: 2.5,
      cellClass: 'audience-hub-table__text-cell'
    }, {
      headerName: 'UE',
      field: 'audience_size',
      valueFormatter: function valueFormatter(params) {
        return _this.formatSmallNumber(params.value);
      },
      filter: 'agNumberColumnFilter',
      flex: 1,
      cellClass: 'audience-hub-table__text-cell',
      minWidth: 76
    }, {
      headerName: 'DCR Partner',
      field: 'dcr_partner',
      valueGetter: function valueGetter(params) {
        if (!params.data || !params.data.dcr_partner) return '';
        return params.data.dcr_partner.sort(function (a, b) {
          return a > b ? 1 : -1;
        });
      },
      filter: 'agTextColumnFilter',
      flex: 2.5,
      cellClass: 'audience-hub-table__text-cell'
    }, {
      headerName: 'Created',
      field: 'created',
      filterValueGetter: function filterValueGetter(params) {
        var value = params.data[params.colDef.field];
        if (value) {
          var date = new Date(value);
          date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0);
          return date;
        }

        return '';
      },
      valueFormatter: function valueFormatter(params) {
        return _this.formatDate(params.value);
      },
      filter: 'agDateColumnFilter',
      filterParams: { debounceMs: 300 },
      flex: 1.7,
      cellClass: 'audience-hub-table__text-cell',
      minWidth: 89
    }, {
      headerName: 'Created By',
      colId: 'created_by',
      field: 'created_by',
      valueGetter: function valueGetter(params) {
        return _this.getNameFromUsername((params.data || {}).username);
      },
      filter: 'agTextColumnFilter',
      flex: 3,
      cellClass: 'audience-hub-table__text-cell'
    }, {
      headerName: 'Posted Through',
      field: 'last_posting',
      filterValueGetter: function filterValueGetter(params) {
        var value = params.data[params.colDef.field];
        if (value) {
          var date = new Date(value);
          date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0);
          return date;
        }
        return '';
      },
      valueFormatter: function valueFormatter(params) {
        var t = params.data;
        var v = params.value ? _this.formatDate(params.value) : '';
        if (!t) return v;
        if (t.target_datasource === _this.nielsenDatasources.COMSCORE || t.target_datasource === _this.nielsenDatasources.NIELSEN) {
          if (t.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED) {
            v = '';
          }
        }
        return v;
      },
      filter: 'agDateColumnFilter',
      filterParams: { debounceMs: 300 },
      flex: 1.875,
      cellClass: 'audience-hub-table__text-cell',
      minWidth: 130
    }, {
      headerName: 'Destination',
      field: 'destinations',
      valueGetter: function valueGetter(params) {
        if (!params.data || !params.data.destinations) return '';
        return params.data.destinations.sort(function (a, b) {
          return a > b ? 1 : -1;
        });
      },
      filter: 'searchSetFilter',
      filterParams: {
        filterType: 'set',
        values: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */]).sort(function (a, b) {
          return a.name > b.name ? 1 : -1;
        })
      },
      cellRendererFramework: 'DestinationsRenderer',
      flex: 2.5,
      cellClass: 'audience-hub-table__text-cell',
      autoHeight: true
    }, {
      headerName: 'C360 ID',
      field: 'c360_id',
      filter: 'agNumberColumnFilter',
      flex: 1.25,
      cellClass: 'audience-hub-table__text-cell',
      minWidth: 76
    }, {
      headerName: 'Status',
      field: 'activation_status',
      filter: 'agSetColumnFilter',
      filterParams: {
        values: function values(params) {
          var values = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */]).sort(function (a, b) {
            return a > b ? 1 : -1;
          });
          params.success(values);
        }
      },
      flex: 1.5,
      cellClass: 'audience-hub-table__text-cell',
      minWidth: 127,
      tooltipField: 'activation_status'
    }];

    this.audienceDetailRenderer = 'audienceDetailRenderer';
    this.detailRowHeight = function (params) {
      if (params.node && params.node.detail) {
        var data = params.node.data;
        var hasDestination = data.destinations && data.destinations.length > 0;
        var isAddressableAudience = hasDestination && (data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV) || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO) || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR) || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD));
        var height = 332;

        switch (data.activation_status) {
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING:
            if (isAddressableAudience) {
              height = 408;
            } else if (hasDestination) {
              height = 380;
            } else if (!hasDestination) {
              height = 296;
            }
            break;

          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED:
            if (data.am_data && data.am_data.flightStartDate && data.am_data.flightEndDate) {
              height = 408;
            } else if (data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5) || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE)) {
              height = 646;
            } else {
              height = 400;
            }
            break;

          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE:
            height = 400;
            if (data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5) && data.target !== __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP) {
              height = 582;
            } else if (data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE)) {
              height = 646;
            }
            break;

          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED:
            if (data.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS && !data.audience_size || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR) || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD)) {
              height = 464;
            } else {
              height = 400;
            }
            break;

          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED:
            height = 400;
            if (data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR) || data.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD)) {
              height = 520;
            }
            break;

          default:
            break;
        }

        return height;
      }
    };

    this.columnDefs = columnDefs.map(function (column) {
      column.hide = false;
      return column;
    });
    this.frameworkComponents = {
      searchSetFilter: __WEBPACK_IMPORTED_MODULE_29__appComponents_audienceHubDashboard_SearchSetFilter___default.a,
      addressableStatusIndicator: __WEBPACK_IMPORTED_MODULE_31_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_30__appComponents_audienceHubDashboard_AddressableStatusIndicator___default.a),
      audienceDetailRenderer: __WEBPACK_IMPORTED_MODULE_31_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_12__appComponents_targets_AudienceDetailRenderer___default.a)
    };
  },

  computed: {
    queryOption: {
      get: function get() {
        var initialValue = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_TARGETS;
        if (this.$route.params.name) {
          if (this.filters.archived && this.filters.archived.toString() === 'true') {
            initialValue = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_ARCHIVED_TARGETS;
          } else {
            initialValue = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_TARGETS;
          }
        } else if (this.filters && this.filters.archived && this.filters.archived.toString() === 'true') {
          initialValue = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].ARCHIVED_TARGETS;
        } else {
          initialValue = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].ALL_TARGETS;
        }

        return targetFilterOptions.find(function (option) {
          return option.value === initialValue;
        });
      },
      set: function set(newVal) {}
    },
    hasPublishPermissions: function hasPublishPermissions() {
      return this.$store.getters.hasPublishPermissions;
    },
    hasCreateEditPermissions: function hasCreateEditPermissions() {
      return this.$store.getters.hasCreateEditPermissions;
    },
    hasArchivePermissions: function hasArchivePermissions() {
      return this.$store.getters.hasArchivePermissions;
    },
    refreshTable: function refreshTable() {
      return this.$store.getters.refreshTable;
    },
    username: function username() {
      return this.$store.getters.username;
    },
    permissions: function permissions() {
      return this.$store.state.auth.permissions || [];
    },
    hasViewPermissions: function hasViewPermissions() {
      return this.$store.getters.hasViewPermissions || false;
    },
    filterFromState: function filterFromState() {
      return this.$store.state.appRes.filter;
    },
    targetFilterFromState: function targetFilterFromState() {
      return this.$store.state.appRes.targetFilter;
    },
    columnsFilterFromState: function columnsFilterFromState() {
      return this.$store.getters.columnFilters || {};
    }
  },
  methods: {
    setColumnFilters: function setColumnFilters(columnFilters) {
      var _this2 = this;

      var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var gridFilterModel = this.gridApi.getFilterModel();
      var updatedColumnFilters = {};

      var _loop = function _loop(c) {
        if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gridFilterModel).includes(c) || forceUpdate) {
          var setFilter = _this2.gridApi.getFilterInstance(c);
          updatedColumnFilters[c] = columnFilters[c];
          switch (c) {
            case 'datasources':
              var sourcesFilter = [];
              for (var key in __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */]) {
                if (Array.isArray(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */][key]['value'])) {
                  if (__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */][key]['value'].some(function (d) {
                    return columnFilters[c].includes(d);
                  })) {
                    sourcesFilter.push(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */][key]);
                  }
                } else if (columnFilters[c].includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */][key]['value'])) {
                  sourcesFilter.push(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["u" /* SOURCES_FILTER */][key]);
                }
              }
              setFilter.component.updateFilterValues(sourcesFilter.sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              }));
              break;
            case 'activation_status':
              setFilter.setFilterValues(columnFilters[c]);
              break;
            case 'destinations':
              var destinationsFilter = [];
              for (var _key in __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */]) {
                if (Array.isArray(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */][_key]['value'])) {
                  if (__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */][_key]['value'].some(function (d) {
                    return columnFilters[c].includes(d);
                  })) {
                    destinationsFilter.push(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */][_key]);
                  }
                } else if (columnFilters[c].includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */][_key]['value'])) {
                  destinationsFilter.push(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["v" /* DESTINATIONS_FILTER */][_key]);
                }
              }
              setFilter.component.updateFilterValues(destinationsFilter.sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              }));
              break;
          }
        }
      };

      for (var c in columnFilters) {
        _loop(c);
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["t" /* SET_COLUMN_FILTERS */], updatedColumnFilters);
    },
    setAppliedFiltersDisplay: function setAppliedFiltersDisplay(filterModel) {
      var _this3 = this;

      var gridFilterModel = filterModel || this.gridApi.getFilterModel();
      this.appliedFilters = this.columnDefs.reduce(function () {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var cv = arguments[1];

        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gridFilterModel).includes(cv.field)) {
          var f = gridFilterModel[cv.field];
          switch (f['filterType']) {
            case 'text':
              acc.push({ name: cv.headerName, value: _this3.getTextFilterValue(f), filterName: cv.field });
              break;
            case 'number':
              acc.push({ name: cv.headerName, value: _this3.getNumberFilterValue(f), filterName: cv.field });
              break;
            case 'date':
              acc.push({ name: cv.headerName, value: _this3.getDateFilterValue(f), filterName: cv.field });
              break;
            case 'set':
              acc.push({
                name: cv.headerName,
                value: _this3.getSetFilterValue(f, cv.field !== 'destinations'),
                filterName: cv.field
              });
              break;
          }
        }
        return acc;
      }, []);
    },
    getSetFilterValue: function getSetFilterValue(f) {
      var uppercase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (f['values'].length === 1) {
        return uppercase ? '= ' + f['values'][0].toUpperCase() : '= ' + f['values'][0];
      } else {
        return uppercase ? 'in (' + f['values'].join(', ').toUpperCase() + ')' : 'in (' + f['values'].join(', ') + ')';
      }
    },
    getTextFilterValue: function getTextFilterValue(filter) {
      var filterValue = function filterValue(f) {
        switch (f['type']) {
          case 'equals':
            return '= ' + f['filter'];
          case 'notEqual':
            return '!= ' + f['filter'];
          case 'contains':
            return '~ ' + f['filter'];
          case 'notContains':
            return '!~ ' + f['filter'];
          case 'startsWith':
            return 'starts with ' + f['filter'];
          case 'endsWith':
            return 'ends with ' + f['filter'];
          default:
            return f['type'] + ' ' + f['filter'];
        }
      };

      if (filter['operator']) {
        return filterValue(filter['condition1']) + ' ' + filter['operator'] + ' ' + filterValue(filter['condition2']);
      } else {
        return filterValue(filter);
      }
    },
    getNumberFilterValue: function getNumberFilterValue(filter) {
      var filterValue = function filterValue(f) {
        switch (f['type']) {
          case 'equals':
            return '= ' + f['filter'];
          case 'notEqual':
            return '!= ' + f['filter'];
          case 'lessThan':
            return '< ' + f['filter'];
          case 'lessThanOrEqual':
            return '<= ' + f['filter'];
          case 'greaterThan':
            return '> ' + f['filter'];
          case 'greaterThanOrEqual':
            return '>= ' + f['filter'];
          case 'inRange':
            return 'from ' + f['filter'] + ' to ' + f['filterTo'];
          default:
            return f['type'] + ' ' + f['filter'];
        }
      };

      if (filter['operator']) {
        return filterValue(filter['condition1']) + ' ' + filter['operator'] + ' ' + filterValue(filter['condition2']);
      } else {
        return filterValue(filter);
      }
    },
    getDateFilterValue: function getDateFilterValue(filter) {
      var that = this;
      var filterValue = function filterValue(f) {
        switch (f['type']) {
          case 'equals':
            return '= ' + that.formatDate(f['dateFrom']);
          case 'notEqual':
            return '!= ' + that.formatDate(f['dateFrom']);
          case 'lessThan':
            return '< ' + that.formatDate(f['dateFrom']);
          case 'greaterThan':
            return '> ' + that.formatDate(f['dateFrom']);
          case 'inRange':
            return 'from ' + that.formatDate(f['dateFrom']) + ' to ' + that.formatDate(f['dateTo']);
          default:
            return f['type'] + ' ' + that.formatDate(f['dateFrom']);
        }
      };

      if (filter['operator']) {
        return filterValue(filter['condition1']) + ' ' + filter['operator'] + ' ' + filterValue(filter['condition2']);
      } else {
        return filterValue(filter);
      }
    },
    clearFilter: function clearFilter(filter) {
      var gridFilterModel = this.gridApi.getFilterModel();
      var filterModel = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, gridFilterModel);
      delete filterModel[filter.filterName];
      if (filter.filterName === 'destinations') {
        this.gridApi.destroyFilter('destinations');
      }
      if (filter.filterName === 'datasources') {
        this.gridApi.destroyFilter('datasources');
      }
      this.setAppliedFiltersDisplay(filterModel);
      this.setColumnFilters(this.columnsFilterFromState, true);
      this.$router.push({ query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, filterModel) }).catch(function (err) {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err);
        }
      });
    },
    getRowNodeId: function getRowNodeId(data) {
      return data.id;
    },
    setRowData: function setRowData(id, data) {
      var rowNode = this.gridApi.getRowNode(id);
      var updatedData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, rowNode.data, data, { display_name: rowNode.data.display_name });
      rowNode.setData(updatedData);
    },
    onGridReady: function onGridReady(params) {
      var _this4 = this;

      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      var that = this;
      var datasource = {
        getRows: function getRows(params) {
          _this4.setAppliedFiltersDisplay();
          if (_this4.forceUpdateFilterValues || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(that.gridApi.getFilterModel()).length > 0 && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this4.columnsFilterFromState).length > 0) {
            _this4.setColumnFilters(_this4.columnsFilterFromState, true);
            _this4.forceUpdateFilterValues = false;
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__api__["Z" /* fetchTargets */])(params.request, _this4.routeParamsName, _this4.filters.archived && _this4.filters.archived.toString() === 'true').then(function (response) {
            if (response.data.rows.length === 0) {
              that.gridApi.showNoRowsOverlay();
            } else {
              that.gridApi.hideOverlay();
              if (response.data.filters) {
                _this4.setColumnFilters(response.data.filters);
              }
            }
            params.successCallback(response.data.rows, response.data.rowCount);
          }).catch(function (error) {
            console.error(error);
            params.failCallback();
          });
        }
      };

      this.gridApi.setServerSideDatasource(datasource);
      var query = this.getFilterModelFromQuery();
      this.gridApi.setFilterModel(query);

      __WEBPACK_IMPORTED_MODULE_28__api_eventBus__["a" /* EventBus */].$on('update-target', this.setRowData);
    },
    isExternalFilterPresent: function isExternalFilterPresent() {
      return true;
    },
    doesExternalFilterPass: function doesExternalFilterPass(node) {
      return this.filters.archived && this.filters.archived.toString() === 'true' ? node.data.archived : !node.data.archived;
    },
    onTargetFilterChange: function onTargetFilterChange(e) {
      this.gridApi.ensureIndexVisible(0);
      var value = e;
      var filterModel = this.getFilterModelFromQueryWithJSONStrings();
      this.changeFilter(value, filterModel);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_23__store_modules_applicationResources_constants__["m" /* SET_DASHBOARD_TARGET_FILTER */], value);
      this.gridApi.purgeServerSideCache();
    },
    changeFilter: function changeFilter(value, filterModel) {
      if (value === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].ALL_TARGETS) {
        adobeAnalytics.selectAllTargets({
          username: this.username
        });
        this.$router.push({ path: '/audience-hub/targets', query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, filterModel) }).catch(function (err) {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      } else if (value === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_TARGETS) {
        adobeAnalytics.selectMyTargets({
          username: this.username
        });
        this.$router.push({ path: '/audience-hub/targets/' + this.username, query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, filterModel) }).catch(function (err) {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      } else if (value === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].ARCHIVED_TARGETS) {
        adobeAnalytics.selectArchivedTargets({
          username: this.username
        });
        this.$router.push({ path: '/audience-hub/targets', query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, filterModel, { archived: true }) }).catch(function (err) {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      } else if (value === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_ARCHIVED_TARGETS) {
        adobeAnalytics.selectArchivedTargets({
          username: this.username
        });
        this.$router.push({
          path: '/audience-hub/targets/' + this.username,
          query: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, filterModel, { archived: true })
        }).catch(function (err) {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    onFilterChanged: function onFilterChanged(params) {
      var gridFilterModel = this.gridApi.getFilterModel();
      var filterModel = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, gridFilterModel);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(filterModel)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(filterModel[field]) === 'object') {
            filterModel[field] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filterModel[field]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.filters.archived === false) {
        delete filterModel.archived;
      } else if (this.filters.archived) {
        filterModel.archived = this.filters.archived;
      }

      var currentQuery = this.$route.query;
      var newQuery = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, filterModel);

      if (!this.areQueriesEqual(currentQuery, newQuery)) {
        this.$router.push({ query: newQuery }).catch(function (err) {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
      }
    },
    areQueriesEqual: function areQueriesEqual(query1, query2) {
      var keys1 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(query1 || {});
      var keys2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(query2 || {});

      if (keys1.length !== keys2.length) {
        return false;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(keys1), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (query1[key] !== query2[key]) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return true;
    },
    onColumnEverythingChanged: function onColumnEverythingChanged(e) {
      if (e.source === 'contextMenu') {
        this.setInitialColumnState();
      }
    },
    getFilterModelFromQuery: function getFilterModelFromQuery() {
      var filterModel = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.filters);
      delete filterModel.archived;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(filterModel)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var field = _step3.value;

          try {
            if (filterModel[field]) {
              filterModel[field] = JSON.parse(filterModel[field]);
            } else {
              delete filterModel[field];
            }
          } catch (err) {
            continue;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return filterModel;
    },
    getFilterModelFromQueryWithJSONStrings: function getFilterModelFromQueryWithJSONStrings() {
      var filterModel = this.getFilterModelFromQuery();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(filterModel)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var field = _step4.value;

          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(filterModel[field]) === 'object') {
            filterModel[field] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filterModel[field]);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return filterModel;
    },
    getContextMenuItems: function getContextMenuItems(params) {
      var _this5 = this;

      var target = params.node && params.node.data;
      var targetOptions = [];

      if (target) {
        var disabled = false;
        var targetActionRoutes = [{
          name: target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD ? 'Activate' : 'Generate Estimate',
          value: OPTIONS.ACTIVATE,
          disabled: disabled
        }, {
          name: 'Open',
          value: OPTIONS.OPEN,
          disabled: disabled,
          action: function action() {
            if (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].AD || target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["a" /* targetRouteHandler */])('OPEN', target);
            }
            if (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS) {
              _this5.$router.push({ name: 'NewWorkbench', params: { id: target.id } }).catch(function (err) {
                if (err.name !== 'NavigationDuplicated') {
                  console.error('Navigation error:', err);
                }
              });
            }
            if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(_this5.C360Datasources).includes(target.target_datasource)) {
              if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED) {
                _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
                  target_id: target.id,
                  option: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR,
                  targetAction: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE
                });
              } else if (target.metadata.intents && target.metadata.intents.some(function (i) {
                return i['Name'] === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["a" /* INTENTS */]['Sales']['Name'];
              })) {
                _this5.$router.push({ name: 'NewWorkbench', params: { id: target.id } }).catch(function (err) {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error('Navigation error:', err);
                  }
                });
              } else {
                _this5.$router.push({ name: 'XandrWorkbench', params: { id: target.id } }).catch(function (err) {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error('Navigation error:', err);
                  }
                });
              }
              return;
            }
          }
        }, {
          name: 'Duplicate',
          value: target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS && target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED ? null : OPTIONS.DUPLICATE,
          disabled: target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS && target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED,
          action: function action() {
            if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(_this5.C360Datasources).includes(target.target_datasource) || target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS) {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
                option: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR,
                target_id: target.id,
                targetAction: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE
              });
            } else if (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].AD && target.target_datasource === _this5.nielsenDatasources.AMRLD) {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
                option: _this5.nielsenDatasources.AUDIENCE_DISCOVERY,
                target_id: target.id,
                targetAction: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE
              });
            } else {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_24__appLogic_route_store_actions__["c" /* SET_BACK_ROUTE_OVERRIDE */], _this5.$router.currentRoute.path);
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["a" /* targetRouteHandler */])(OPTIONS.DUPLICATE, target);
            }
          }
        }, {
          name: 'Archive Target',
          value: OPTIONS.ARCHIVE,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["w" /* ARCHIVE_TARGET */], target);
          }
        }, {
          name: 'Unarchive Target',
          value: OPTIONS.UNARCHIVE,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["x" /* UNARCHIVE_TARGET */], target);
          }
        }, {
          name: 'Download Graph Package',
          value: OPTIONS.GRAPH,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["B" /* DOWNLOAD_LAS_TARGET */], target);
          }
        }, {
          name: 'Settings',
          value: OPTIONS.SETTINGS,
          disabled: disabled
        }, {
          name: 'Delete',
          value: OPTIONS.DELETE,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], target);
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["m" /* SHOW_DELETE_TARGET_MODAL */]);
          }
        }, {
          name: 'Re-Forecast Target',
          value: OPTIONS.RE_POST,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["w" /* SHOW_REPOSSTING_MODAL */], target);
          }
        }, {
          name: 'Download Target Definition',
          value: OPTIONS.DEFINITION,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["C" /* DOWNLOAD_TARGET_DEFINITION */], {
              targetId: target.id
            });
          }
        }, {
          name: 'Download PID Lists',
          value: OPTIONS.PID_DOWNLOAD,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["n" /* SET_SHOW_PID_DOWNLOAD_MODAL */], target);
          }
        }, {
          name: 'Append File',
          value: OPTIONS.APPEND,
          disabled: disabled,
          action: function action() {
            if (!target.archived && target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE) {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["b" /* SET_SHOW_APPEND_MODAL */], { target: target });
            } else if (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID) {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["b" /* SET_UPLOAD_MODAL_OPTIONS */], {
                type: '2',
                appendingOption: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID,
                target: target
              });
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["c" /* APPEND_PID */]);
            }
          }
        }, {
          name: 'Update Flight Dates',
          value: OPTIONS.UPDATE_LAS_MODAL,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
              target_id: target.id,
              option: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR,
              targetAction: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE
            });
          }
        }, {
          name: 'Update Campaign Data',
          value: OPTIONS.UPDATE_CAMPAIGN_DATA_MODAL,
          disabled: disabled,
          action: function action() {
            _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
              target_id: target.id,
              option: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR,
              targetAction: __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE_CAMPAIGN
            });
          }
        }, {
          name: 'Send Downstream',
          value: OPTIONS.SEND_DOWNSTREAM,
          disabled: disabled,
          action: function action() {
            if (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER) {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["x" /* SEND_NPOWER_DOWNSTREAM */], { target_id: target.id }).then(function (res) {
                if (res) {
                  _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], true);
                }
              });
            } else if (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE) {
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], false);
              _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_21__appLogic_targets_createTarget_store_actions__["y" /* SEND_COMSCORE_DOWNSTREAM */], { target_id: target.id }).then(function (res) {
                if (res) {
                  _this5.$store.dispatch(__WEBPACK_IMPORTED_MODULE_22__views_audienceHub_store_actions__["v" /* REFRESH_TABLE */], true);
                }
              });
            }
          }
        }];

        var included = [];
        var disableList = [];

        switch (target.target) {
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS:
            included = [OPTIONS.ACTIVATE, OPTIONS.OPEN, OPTIONS.DUPLICATE, OPTIONS.UNARCHIVE];
            if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE) {
              included = [OPTIONS.OPEN, OPTIONS.DUPLICATE, OPTIONS.GRAPH, OPTIONS.DEFINITION];
              if (this.hasPublishPermissions && target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY)) {
                included.push(OPTIONS.DELETE);
              }
              target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
            }
            if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) {
              included = [OPTIONS.OPEN, OPTIONS.DUPLICATE, OPTIONS.GRAPH, OPTIONS.DEFINITION];
              if (this.hasPublishPermissions && target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY)) {
                included.push(OPTIONS.DELETE);
                target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
              }
              if (target.destinations.length === 0 && target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["g" /* isTargetOwnedBy */])(target, this.username)) {
                included.push(OPTIONS.DELETE);
                target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
              }
            }
            if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED) {
              included = [];
              target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
            }
            if (target.activation_status !== __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE && target.target_definition && target.target_definition.query) {
              included.push(OPTIONS.DEFINITION);
              included.push(OPTIONS.GRAPH);
            }
            if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED) {
              included = [OPTIONS.OPEN, OPTIONS.DUPLICATE, OPTIONS.GRAPH, OPTIONS.DEFINITION, OPTIONS.PID_DOWNLOAD, OPTIONS.DELETE];
              target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].AD:
            var marketingIntent = target.metadata && target.metadata.intents && target.metadata.intents.length && target.metadata.intents.find(function (el) {
              return el.IntentId === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.IntentId;
            });
            var researchIntent = target.metadata && target.metadata.intents && target.metadata.intents.length && target.metadata.intents.find(function (el) {
              return el.IntentId === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["a" /* INTENTS */].Research.IntentId;
            });
            included = [OPTIONS.OPEN];
            if (marketingIntent) target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
            if (marketingIntent) {
              included.push(OPTIONS.DUPLICATE);
              target.archived ? included.push(OPTIONS.UNARCHIVE) : included.push(OPTIONS.ARCHIVE);
            } else {
              if (researchIntent) included.push(OPTIONS.DUPLICATE);
            }
            if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) included.push(OPTIONS.DELETE);
            break;
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD:
            included = [OPTIONS.ACTIVATE, OPTIONS.OPEN, OPTIONS.DUPLICATE, OPTIONS.ARCHIVE, OPTIONS.UNARCHIVE, OPTIONS.DELETE];
            if (!target.archived) included.push(OPTIONS.SETTINGS);
            break;
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE_TV:
            included = [OPTIONS.ACTIVATE, OPTIONS.UNARCHIVE];
            if (target.activation_status !== __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) included.push(OPTIONS.ARCHIVE);
            break;
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE:
            included = [OPTIONS.ARCHIVE, OPTIONS.UNARCHIVE];
            if (!target.archived && target.activation_status !== __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED && this.hasPublishPermissions) {
              included.push(OPTIONS.APPEND);
            }
            if (target.activation_status !== __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED && target.activation_status !== __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE && !target.archived && this.hasPublishPermissions) {
              included.push(OPTIONS.SEND_DOWNSTREAM);
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID:
            included = [OPTIONS.ARCHIVE, OPTIONS.UNARCHIVE];
            if (target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY)) {
              included.push(OPTIONS.PID_DOWNLOAD);
            }
            if (this.hasPublishPermissions) {
              included.push(OPTIONS.APPEND);
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].BYOD:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PRISM:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DNB:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MAX:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].TVE:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON_EXPANDABLE:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DISCOVERY_PLUS:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DCR:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LIVERAMP:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].WBGAMES:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].RETARGETING:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].FREEWHEEL:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].GOOGLE_AD_MANAGER:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAL:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DC_COMICS:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].CNN:
          case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MOSAIC:
            var isAddressableOrDigital = target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP);
            var isSDXandrTarget = target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX) || target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP);
            switch (target.activation_status) {
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED:
                included = [OPTIONS.DELETE, OPTIONS.ARCHIVE];

                if (!isAddressableOrDigital) {
                  included.push(OPTIONS.OPEN);
                }
                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING:
                included = [OPTIONS.OPEN, OPTIONS.DUPLICATE, OPTIONS.ARCHIVE];
                if (isSDXandrTarget) {
                  included.push(OPTIONS.UPDATE_CAMPAIGN_DATA_MODAL);
                }
                if (this.hasPublishPermissions || !this.hasPublishPermissions && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["g" /* isTargetOwnedBy */])(target, this.username)) {
                  included.push(OPTIONS.DELETE);
                }
                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED:
                if (target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY) || isAddressableOrDigital) {
                  included = [OPTIONS.OPEN, OPTIONS.DUPLICATE];
                }
                if (!isAddressableOrDigital) {
                  included.push(OPTIONS.UPDATE_LAS_MODAL);
                  included.push(OPTIONS.ARCHIVE);
                }

                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE:
                included = [OPTIONS.OPEN, OPTIONS.DUPLICATE];
                if (target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY)) {
                  included.push(OPTIONS.UPDATE_LAS_MODAL);
                }
                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED:
                included = [OPTIONS.ARCHIVE];
                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].CANCELLED:
                included = [OPTIONS.OPEN, OPTIONS.DUPLICATE];
                if (!isAddressableOrDigital) {
                  included.push(OPTIONS.UPDATE_LAS_MODAL);
                }
                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELING:
                included = [OPTIONS.OPEN, OPTIONS.DUPLICATE];
                break;
              case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELED:
                included = [OPTIONS.OPEN, OPTIONS.ARCHIVE, OPTIONS.DUPLICATE];
                break;
            }
            if (isAddressableOrDigital && !this.hasCreateEditPermissions) {
              var removeList = [OPTIONS.DELETE, OPTIONS.DUPLICATE, OPTIONS.UPDATE_LAS_MODAL, OPTIONS.ARCHIVE];
              included = included.filter(function (i) {
                return removeList.indexOf(i) === -1;
              });
            }
            if (isSDXandrTarget) {
              included = included.filter(function (i) {
                return i !== OPTIONS.DUPLICATE;
              });
            }
            break;
        }
        if (target.archived) {
          included = included.filter(function (option) {
            return option !== OPTIONS.ARCHIVE;
          });
        } else {
          included = included.filter(function (option) {
            return option !== OPTIONS.UNARCHIVE;
          });
        }

        var repostable = (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS && !target.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY) || target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE_TV) && target.activated;
        if (repostable && this.hasPublishPermissions) {
          included.push(OPTIONS.RE_POST);
        }

        if (!this.hasCreateEditPermissions) {
          var createEditOptions = [OPTIONS.DUPLICATE, OPTIONS.DELETE];
          included = included.filter(function (i) {
            return createEditOptions.indexOf(i) === -1;
          });
        }

        if (!this.hasArchivePermissions) {
          var archiveOptions = [OPTIONS.ARCHIVE, OPTIONS.UNARCHIVE];
          included = included.filter(function (i) {
            return archiveOptions.indexOf(i) === -1;
          });
        }

        if (!this.hasPublishPermissions) {
          var appendOption = [OPTIONS.APPEND];
          included = included.filter(function (i) {
            return appendOption.indexOf(i) === -1;
          });
        }

        targetOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lodash__["cloneDeep"])(targetActionRoutes.filter(function (r) {
          return included.includes(r.value);
        }));

        var isActivatedOrtargetIsNotUser = target.activated || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["g" /* isTargetOwnedBy */])(target, this.username);
        if (isActivatedOrtargetIsNotUser) {
          targetOptions = targetOptions.filter(function (t) {
            return ![OPTIONS.ACTIVATE, OPTIONS.SETTINGS, OPTIONS.DELETE].includes(t.value);
          });
        } else if (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED) {
          targetOptions = targetOptions.filter(function (t) {
            return ![OPTIONS.ACTIVATE, OPTIONS.SETTINGS].includes(t.value);
          });
        } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["f" /* isActivationBlocked */])(target.target)) {
          targetOptions = targetOptions.filter(function (t) {
            return t.value !== OPTIONS.ACTIVATE;
          });
        }
        var targetIsXandrAndNotSubmittedOrAbove = (target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT || target.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA) && (target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED || target.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING);
        if (targetIsXandrAndNotSubmittedOrAbove) {
          targetOptions.push(OPTIONS.DELETE);
        }

        if (disableList.length > 0) {
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(disableList), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var dis = _step5.value;
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(targetOptions), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var op = _step6.value;

                  if (op.value === dis) {
                    op.disabled = true;
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      }

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(targetOptions), ['separator', 'copy', 'copyWithHeaders', 'separator', {
        name: 'Clear All Filters',
        action: function action() {
          var query = {};
          if (_this5.filters.archived) {
            query.archived = _this5.filters.archived;
          }
          _this5.gridApi.destroyFilter('destinations');
          _this5.$router.push({ query: query }).catch(function (err) {
            if (err.name !== 'NavigationDuplicated') {
              console.error('Navigation error:', err);
            }
          });
          _this5.gridApi.setFilterModel(null);
        }
      }]);
    },
    formatDate: function formatDate(str, utc) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["k" /* dateFormatter */])(str, utc);
    },
    clearDownloadedContent: function clearDownloadedContent() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_25__appLogic_targets_currentTarget_store_actions__["u" /* CLEAR_TARGET_DOWNLOAD */]);
    },
    formatSmallNumber: function formatSmallNumber(amount) {
      if (!amount || isNaN(amount)) {
        return '';
      }
      if (amount >= 1000000) {
        var quotient = amount / 1000000;
        return (this.isDecimal(quotient) ? quotient.toFixed(quotient > 10 ? 1 : 2) : quotient) + 'M';
      } else if (amount >= 1000) {
        var _quotient = amount / 1000;
        return (this.isDecimal(_quotient) ? _quotient.toFixed(1) : _quotient) + 'K';
      } else {
        return this.isDecimal(amount) ? amount.toFixed(1) : amount;
      }
    },
    isDecimal: function isDecimal(num) {
      var isDec = num % 1 !== 0;
      return num % 1 !== 0;
    },
    getNameFromUsername: function getNameFromUsername(username) {
      if (!username) {
        return '';
      }
      var emailParts = username.split('@');
      var nameParts = emailParts[0].split(/\.|_/);
      var first = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lodash__["capitalize"])(nameParts[0]);
      var last = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_lodash__["capitalize"])(nameParts[1]);
      return first + ' ' + last;
    },
    setInitialColumnState: function setInitialColumnState() {
      var _this6 = this;

      if (this.columnApi) {
        var columnState = this.columnApi.getColumnState().map(function (column) {
          column.hide = !_this6.hasViewPermissions;
          return column;
        });
        this.columnApi.setColumnState(columnState);
      }
    },
    setFilter: function setFilter() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_23__store_modules_applicationResources_constants__["l" /* SET_DASHBOARD_FILTER */], this.filters);
    },
    redirectToFilter: function redirectToFilter() {
      var targetFilter = this.targetFilterFromState;
      this.changeFilter(targetFilter || __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["t" /* actions */].MY_TARGETS, this.filterFromState);
    },
    resizeHandler: function resizeHandler() {
      this.gridApi.purgeServerSideCache();
    }
  },
  mounted: function mounted() {
    this.clearDownloadedContent();
    var filters = this.filterFromState;
    if (!filters) {
      this.setFilter();
    } else {
      this.redirectToFilter();
      this.forceUpdateFilterValues = true;
    }
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed: function destroyed() {
    window.addEventListener('resize', this.resizeHandler);
  },

  watch: {
    filters: function filters() {
      this.setFilter();
      if (this.gridApi) {
        var filterModel = this.getFilterModelFromQuery();
        this.gridApi.setFilterModel(filterModel);
      }
    },
    refreshTable: function refreshTable(value) {
      if (value) {
        this.gridApi.purgeServerSideCache();
      }
    },
    permissions: function permissions() {
      this.setInitialColumnState();
    }
  }
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_feedbackModal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_simpleButton__ = __webpack_require__(161);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FeedbackModal: __WEBPACK_IMPORTED_MODULE_0__components_common_feedbackModal__["b" /* FeedbackModal */], SimpleButton: __WEBPACK_IMPORTED_MODULE_1__components_common_simpleButton__["a" /* default */]
  },
  props: {
    target: Object,
    buttonText: String
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('click', this.target);
      this.close();
    },
    open: function open() {
      this.$refs.feedbackModal.open();
    },
    close: function close() {
      this.$refs.feedbackModal.close();
    }
  }
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);






var FILTER_STATES = {
  init: 0,
  changed: 1,
  reset: 2
};
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend({
  data: function data() {
    return {
      filterText: '',
      selectAll: true,
      indeterminate: false,
      groups: [],
      model: {},
      values: []
    };
  },
  mounted: function mounted() {
    this.groups = this.params.values;
    this.values = this.params.values;
  },

  methods: {
    onClickIndividualFilter: function onClickIndividualFilter(name) {
      var selected = this.groups.filter(function (x) {
        return x.name === name;
      })[0];
      selected.checked = !selected.checked;
      if (Array.isArray(selected.value)) {
        var selectedGroup = selected.value;
        this.groups.forEach(function (el) {
          if (selectedGroup.includes(el.value)) {
            el.checked = selected.checked;
          }
        });
      } else {
        var checkedVals = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.model.values)));
        if (selected.checked) checkedVals.add(selected.value);else checkedVals.delete(selected.value);

        this.groups.forEach(function (el) {
          if (!Array.isArray(el.value)) return;

          el.checked = el.value.every(function (val) {
            return checkedVals.has(val);
          });
        });
      }
      this.updateGroupFilters();
    },
    toggleAllFilterGroups: function toggleAllFilterGroups() {
      var _this = this;

      this.selectAll = !this.selectAll;

      this.groups.forEach(function (group) {
        group.checked = _this.selectAll;
      });
      this.updateGroupFilters();
    },
    clearSearchFilter: function clearSearchFilter() {
      this.groups.forEach(function (group) {
        group.visible = true;

        if (group.name === 'Canoe Linear') {
          group.visible = true;
        }

        if (group.name === 'Canoe VOD') {
          group.visible = true;
        }
      });
    },
    updateGroupFilters: function updateGroupFilters() {
      this.clearSearchFilter();
      this.updateSelectAllState();
      this.params.filterChangedCallback();
    },
    updateSelectAllState: function updateSelectAllState() {
      if (this.visibleGroups.length === this.values.length && this.activeGroups.length === this.values.length) {
        this.selectAll = true;
        this.indeterminate = false;
      } else {
        if (this.visibleGroups.length === 0 || this.activeGroups.length === 0) {
          this.selectAll = false;
          this.indeterminate = false;
        } else if (this.activeGroups.length === this.values.length) {
          this.selectAll = true;
          this.indeterminate = false;
        } else {
          this.selectAll = false;
          this.indeterminate = true;
        }
      }
    },
    updateVisibleGroups: function updateVisibleGroups() {
      var searchWords = this.filterText.toLowerCase().split(' ').filter(function (word) {
        return word;
      });

      if (searchWords.length === 0) {
        this.clearSearchFilter();
      } else {
        this.groups.forEach(function (group) {
          searchWords.forEach(function (filterWord) {
            var value = group.name;

            if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
              group.visible = false;
            } else {
              group.visible = true;

              if (group.name === 'Canoe Linear') {
                group.visible = true;
              }

              if (group.name === 'Canoe VOD') {
                group.visible = true;
              }
            }
          });
        });
      }

      this.updateSelectAllState();
    },
    filterOnFirstResult: function filterOnFirstResult() {
      if (this.visibleGroups.length === 0) return;

      var firstGroup = this.visibleGroups[0];

      var index = this.groups.findIndex(function (group) {
        return group.name === firstGroup.name;
      });

      this.groups.forEach(function (group, i) {
        if (i === index) {
          group.checked = true;
        } else {
          group.checked = false;
        }
      });

      this.updateGroupFilters();
      this.filterText = '';
    },
    isFilterActive: function isFilterActive() {
      var active = this.model && this.model.values && this.model.values.length > 0;
      return active;
    },
    getModel: function getModel() {
      if (this.selectAll) {
        return null;
      }
      var models = [];

      this.visibleGroups.forEach(function (group) {
        if (group.checked) {
          if (group.value instanceof Array) {
            group.value.forEach(function (value) {
              if (models.indexOf(value) < 0) {
                models.push(value);
              }
            });
          } else {
            if (models.indexOf(group.value) < 0) {
              models.push(group.value);
            }
          }
        }
      });

      this.model = {
        filterType: 'set',
        values: models
      };
      return this.model;
    },
    updateFilterValues: function updateFilterValues(values) {
      this.groups = this.model = this.values = values;
    },
    setModel: function setModel(model) {
      this.groups.forEach(function (group) {
        group.visible = true;
        if (group.name === 'Canoe Linear') {
          group.visible = true;
        }

        if (group.name === 'Canoe VOD') {
          group.visible = true;
        }
      });
      if (model === null) {
        this.groups.forEach(function (group) {
          group.checked = true;
        });
        this.model = {};
      } else if (model === undefined) {
        return;
      } else {
        var mvalues = model.values;

        this.groups.forEach(function (group) {
          var gvalues = group.value;
          if (Array.isArray(gvalues)) {
            var selected = [];
            for (var gi = 0; gi < gvalues.length; gi++) {
              var currentGValue = gvalues[gi];
              var passed = false;
              for (var mi = 0; mi < mvalues.length; mi++) {
                var currentMValue = mvalues[mi];
                if (currentGValue === currentMValue) {
                  passed = true;
                  break;
                }
              }
              selected.push(passed);
            }
            var selectedGroupValue = selected.reduce(function (prev, curr) {
              return prev && curr;
            }, true);
            group.checked = selectedGroupValue;
          } else {
            var _passed = false;
            for (var _mi = 0; _mi < mvalues.length; _mi++) {
              var _currentMValue = mvalues[_mi];
              if (gvalues === _currentMValue) {
                _passed = true;
                break;
              }
            }
            group.checked = _passed;
          }
        });
        this.model = model;
      }
      this.updateSelectAllState();
    }
  },
  computed: {
    visibleGroups: function visibleGroups() {
      return this.groups.filter(function (group) {
        return group.visible;
      });
    },
    activeGroups: function activeGroups() {
      return this.groups.filter(function (group) {
        return group.checked;
      });
    }
  }
}));

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceMattersNotifications__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceMattersNotifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceMattersNotifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_permissions_Constants_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_stepper_StepperModal__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_stepper_StepperModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_stepper_StepperModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_sendDownstream_SendDownstream__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_sendDownstream_SendDownstream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_sendDownstream_SendDownstream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_auth_constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_AM_Logo_Final_White_AudienceMattersLogoWhite_png__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_AM_Logo_Final_White_AudienceMattersLogoWhite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_AM_Logo_Final_White_AudienceMattersLogoWhite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_videoampSegment_RequestVideoAmpSegment_vue__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_videoampSegment_RequestVideoAmpSegment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__appComponents_videoampSegment_RequestVideoAmpSegment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appComponents_common_NewItemMenu_vue__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appComponents_common_NewItemMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__appComponents_common_NewItemMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appComponents_retargeting_RetargetingRequest_vue__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appComponents_retargeting_RetargetingRequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__appComponents_retargeting_RetargetingRequest_vue__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AudienceMattersNotifications: __WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceMattersNotifications___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_3__components_common_actionButton__["a" /* default */],
    StepperModal: __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_stepper_StepperModal___default.a,
    SendDownstream: __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_sendDownstream_SendDownstream___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_8__components_common_modal__["b" /* default */],
    RequestVideoAmpSegment: __WEBPACK_IMPORTED_MODULE_14__appComponents_videoampSegment_RequestVideoAmpSegment_vue___default.a,
    NewItemMenu: __WEBPACK_IMPORTED_MODULE_15__appComponents_common_NewItemMenu_vue___default.a,
    RetargetingRequest: __WEBPACK_IMPORTED_MODULE_16__appComponents_retargeting_RetargetingRequest_vue___default.a
  },
  data: function data() {
    return {
      popover: null,
      Research: __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["a" /* INTENTS */].Research.Name,
      Marketing: __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.Name,
      Sales: __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["a" /* INTENTS */].Sales.Name,
      userPermissions: null,
      isRequestVideoAmpSegmentDialogOpen: false,
      isRetargetingRequestDialogOpen: false
    };
  },

  computed: {
    initialTargetCopy: {
      get: function get() {
        var defaultTarget = {
          destinations: [],
          display_name: '',
          target_datasource: null,
          advertiser: null,

          username: this.$store.state.auth.username,
          viewing_stream: null,
          target_definition: {}
        };
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["cloneDeep"])(this.initialTarget) || defaultTarget;
      },
      set: function set(newVal) {}
    },
    username: function username() {
      return this.$store.getters.username;
    },
    userRoles: function userRoles() {
      var userRoles = this.$store.getters.userRoles.roles;
      var userProfiles = [];

      var _loop = function _loop(userRole) {
        if (userRoles.hasOwnProperty(userRole) && userRoles[userRole]) {
          var role = __WEBPACK_IMPORTED_MODULE_2__appLogic_permissions_Constants_js__["a" /* ROLES */].find(function (role) {
            return role.value === parseInt(userRole);
          });
          if (role) {
            userProfiles.push(role['name']);
          }
        }
      };

      for (var userRole in userRoles) {
        _loop(userRole);
      }
      return userProfiles.join(', ');
    },
    showUserProfile: function showUserProfile() {
      return __webpack_require__.i({"NODE_ENV":"production","CONFIG_BUCKET":"audiencematters-config-prod","API_V2_ROOT":"https://api.audiencematters.turnerapps.com/v2","API_ROOT":"https://api.audiencematters.turnerapps.com/workbench","API_ROOT_NODE":"https://api.audiencematters.turnerapps.com/node","API_ROOT_LAS":"https://api.audiencematters.turnerapps.com/las","API_ROOT_SM":"https://api.audiencematters.turnerapps.com/sm","API_ROOT_XANDR_NODE":"https://api.audiencematters.turnerapps.com/xandr","API_ROOT_OPEN_AP":"https://api.audiencematters.turnerapps.com/workbench","API_ROOT_ES":"https://api.audiencematters.turnerapps.com/v2/es","API_LOAD_BALANCER":"https://prod.lb.api.audiencematters.turnerapps.com","ES_URL":"https://vpc-audiencematters-prod-7x-vsdtcn2yueq4telfnekg4i3ntq.us-east-1.es.amazonaws.com","ES_AUTH":"","LAS_INDEX":"linearadsales","UE_INDEX":"universe_estimate","OKTA_ISSUER_URL":"https://sso.wbd.com","OKTA_CLIENT_ID":"0oarr68epfFF3IoGY0x7","IDENTITY_POOL_ID":"us-east-1:86716e1a-6193-47c6-97fd-d8bb1dc1abf8","ENABLE_AUTHORIZATION":true,"ENABLE_XANDR_MOCK_DATA_BUTTON":false,"ENABLE_FREQUENCIES":false,"ENABLE_ADDRESSABLE":true,"CONVERT_TO_TURNER_EMAIL":false,"ENABLE_XD_FLIGHT_OVERLAP":false,"ENABLE_CANOE_LINEAR":true,"ENABLE_CANOE_VOD":true}).DISPLAY_PROFILE;
    },
    authPermissions: function authPermissions() {
      return this.$store.state.auth.permissions || [];
    },
    intents: function intents() {
      var intents = [];
      this.hasCreateEditPermissions && intents.push(this.Sales);

      return intents;
    },
    doesUserHaveAdminPermissions: function doesUserHaveAdminPermissions() {
      return this.$store.getters.hasAdminPagePermission;
    },
    initialTarget: function initialTarget() {
      return this.$store.getters.initialTarget;
    },
    showActivationModalTrigger: function showActivationModalTrigger() {
      return this.$store.state.createTarget.initialTargetAction;
    },
    hasCreateEditPermissions: function hasCreateEditPermissions() {
      return this.$store.getters.hasCreateEditPermissions;
    }
  },
  methods: {
    amHeader: function amHeader() {
      return __WEBPACK_IMPORTED_MODULE_13__assets_AM_Logo_Final_White_AudienceMattersLogoWhite_png___default.a;
    },
    intentSelected: function intentSelected(v) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["e" /* SET_INTENTS */], [v]);
      if (v === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["a" /* INTENTS */].Sales.Name) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["d" /* SET_SHOW_MODAL_STEPPER */], { step: 3 });
      } else {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["d" /* SET_SHOW_MODAL_STEPPER */]);
      }
      this.$refs.modal.close();
    },
    open: function open() {
      this.$refs.modal.open();
    },
    handleNewItemMenuClick: function handleNewItemMenuClick(index) {
      switch (index) {
        case 0:
          this.createNewTarget();
          break;
        case 1:
          this.toggleRequestVideoAmpSegmentModal();
          break;
        case 2:
          this.toggleRetargetingRequestModal();
          break;
        default:
          console.log('Invalid index');
      }
    },
    toggleRetargetingRequestModal: function toggleRetargetingRequestModal() {
      this.isRetargetingRequestDialogOpen = !this.isRetargetingRequestDialogOpen;
    },
    toggleRequestVideoAmpSegmentModal: function toggleRequestVideoAmpSegmentModal() {
      this.isRequestVideoAmpSegmentDialogOpen = !this.isRequestVideoAmpSegmentDialogOpen;
    },
    createNewTarget: function createNewTarget() {
      console.log(this.intents);
      if (this.intents.length > 1) {
        this.open();
      } else if (this.intents[0]) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["e" /* SET_INTENTS */], this.intents);
        if (this.hasCreateEditPermissions) {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["d" /* SET_SHOW_MODAL_STEPPER */], { step: 3 });
        } else {
          __WEBPACK_IMPORTED_MODULE_12__components_common_toasts__["a" /* default */].info({
            title: 'Permission Denied',
            message: 'You do not have the permissions to create new segment. Please reach out to AM team to request permissions'
          });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_12__components_common_toasts__["a" /* default */].info({
          title: 'Permission Denied',
          message: 'You do not have the permissions to create new segment. Please reach out to AM team to request permissions'
        });
      }
    },
    expandHeaderMenu: function expandHeaderMenu(e) {
      var _this = this;

      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_common_popover__["b" /* createPopover */])({
        parent: e.currentTarget,
        list: this.popoverMenuOptions(),
        type: __WEBPACK_IMPORTED_MODULE_1__components_common_popover__["c" /* popoverTypes */].TEXTLIST,
        direction: 'bottom',
        align: 'left'
      });

      this.popover.$on('select', function (option) {
        return _this.handlePopoverMenuOptions(option);
      });
    },
    handlePopoverMenuOptions: function handlePopoverMenuOptions(option) {
      if (option === 'ADMIN' && this.doesUserHaveAdminPermissions) {
        var route = this.$router.resolve({ name: 'Permissions', path: '/admin/permissions' });
        window.open(route.href, '_blank');
      } else if (option === 'SIGN_OUT') {
        __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_10__store_modules_auth_constants__["e" /* SIGN_OUT */]);
      } else {
        return;
      }
    },
    popoverMenuOptions: function popoverMenuOptions() {
      if (this.doesUserHaveAdminPermissions) {
        return [{
          name: 'Admin',
          value: 'ADMIN'
        }, {
          name: 'Sign Out',
          value: 'SIGN_OUT'
        }];
      } else {
        return [{
          name: 'Sign Out',
          value: 'SIGN_OUT'
        }];
      }
    }
  },
  watch: {
    showActivationModalTrigger: function showActivationModalTrigger() {
      if (this.showActivationModalTrigger === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].ACTIVATE) {
        this.$refs.sendDownstreamModal.open();
      }
    },
    initialTarget: function initialTarget() {
      this.initialTargetCopy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["cloneDeep"])(this.initialTarget);
    }
  }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_notifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_notifications_store_actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_notifications_NotificationEngine__ = __webpack_require__(728);






var webSocketClient = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    NotificationBell: __WEBPACK_IMPORTED_MODULE_0__components_common_notifications__["b" /* NotificationBell */]
  },
  data: function data() {
    return {
      engine: new __WEBPACK_IMPORTED_MODULE_2__appLogic_notifications_NotificationEngine__["a" /* default */]()
    };
  },
  beforeMount: function beforeMount() {},

  computed: {
    userNotifications: function userNotifications() {
      return this.$store.getters.userNotifications;
    },
    username: function username() {
      return this.$store.getters.username;
    }
  },
  methods: {
    deleteNotification: function deleteNotification(notification) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_notifications_store_actions__["c" /* DELETE_NOTIFICATION */], notification);
    },
    loadNotifications: function loadNotifications() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_notifications_store_actions__["b" /* SET_NOTIFICATIONS */], this.username);
    },
    updateNotification: function updateNotification(notification) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_notifications_store_actions__["d" /* UPDATE_NOTIFICATION */], notification);
    },
    initializeWebsocket: function initializeWebsocket() {
      var _this = this;

      if (!webSocketClient) return;

      webSocketClient.on('connect', function () {
        console.log('connected to iot endpoint!');
        webSocketClient.subscribe('/' + _this.username + '/notifications');
      });
      webSocketClient.on('message', function (topic, message) {
        var msg = message.toString();
        try {
          msg = JSON.parse(msg);
          console.log(topic, 'lambda message received!', msg);

          switch (msg.msgType) {
            case 'new':
              _this.loadNotifications();
              break;
            case 'update':
              _this.updateNotification(msg.notification);
              break;
            default:
              _this.loadNotifications();
          }
        } catch (e) {}
      });
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      menuItems: [{ name: 'New Segment' }, { name: 'VideoAmp Audience' }, { name: 'Retargeting Request' }]
    };
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BarGraph: __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__["a" /* default */],
    ChartLayout: __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout___default.a
  },
  props: {
    chartIdOverride: {
      type: String,
      default: 'age-graph'
    },
    data: {
      type: Object
    },
    meanAge: {
      type: String
    }
  },
  data: function data() {
    return {
      yAxis: 'Viewship %',
      xAxis: 'Age Groups',
      type: __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__["b" /* types */].PERCENTAGE
    };
  },

  computed: {
    title: function title() {
      return 'Age Distribution (10 year ranges) (Mean Age ' + this.meanAge + ')';
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BarGraph: __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__["a" /* default */],
    ChartLayout: __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout___default.a
  },
  props: {
    chartIdOverride: {
      type: String,
      default: 'age-market-breaker-graph'
    },
    data: {
      type: Object
    },
    meanAge: {
      type: String
    }
  },
  data: function data() {
    return {
      yAxis: 'Viewship %',
      xAxis: 'Age Market Breakers',
      type: __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__["b" /* types */].PERCENTAGE
    };
  },

  computed: {
    title: function title() {
      return 'Market Age Breakers Distribution (Mean Age ' + this.meanAge + ')';
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    chartIdOverride: {
      type: String,
      default: 'income-graph'
    },
    data: {
      type: Object
    }
  },
  components: {
    BarGraph: __WEBPACK_IMPORTED_MODULE_0__components_graphs_BarGraph__["a" /* default */],
    ChartLayout: __WEBPACK_IMPORTED_MODULE_1__components_layouts_ChartLayout___default.a
  },
  data: function data() {
    return {
      title: 'Income Distribution',
      yAxis: 'Viewship %',
      xAxis: 'Income Ranges'
    };
  },

  methods: {
    displayLabel: function displayLabel(tooltip, data) {
      return data.datasets[tooltip.datasetIndex].label + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* commaFormatString */])(String(tooltip.yLabel)) + ' %';
    }
  }
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgeMarketBreakerGraph__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgeMarketBreakerGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AgeMarketBreakerGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AgeDistributionGraph__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AgeDistributionGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AgeDistributionGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IncomeGraph__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IncomeGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__IncomeGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UniverseStabilityGraph__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewership__ = __webpack_require__(305);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgeMarketBreakerGraph: __WEBPACK_IMPORTED_MODULE_0__AgeMarketBreakerGraph___default.a,
    AgeGraph: __WEBPACK_IMPORTED_MODULE_1__AgeDistributionGraph___default.a,
    IncomeGraph: __WEBPACK_IMPORTED_MODULE_2__IncomeGraph___default.a,
    UniverseStabilityGraph: __WEBPACK_IMPORTED_MODULE_3__UniverseStabilityGraph__["a" /* default */],
    ViewershipGraph: __WEBPACK_IMPORTED_MODULE_4__viewership__["a" /* default */]
  },
  props: {
    viewershipData: {
      type: Object
    },
    networks: {
      type: Array,
      required: true
    },
    universeData: {
      type: Object
    },
    ageMarketBreakerData: {
      type: Object
    },
    ageData: {
      type: Object
    },
    incomeData: {
      type: Object
    },
    meanAge: {
      type: String
    }
  },
  mounted: function mounted() {
    console.log({
      networks: this.networks,
      viewershipData: this.viewershipData,
      universeData: this.universeData,
      ageMarketBreakerData: this.ageMarketBreakerData,
      ageData: this.ageData,
      incomeData: this.incomeData,
      meanAge: this.meanAge
    });
  }
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ViewershipGraph__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_toggleButton__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_tables__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_dateRange__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bubbleLabelPlugin__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);

















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ViewershipFilter: __WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue___default.a,
    ViewershipGraph: __WEBPACK_IMPORTED_MODULE_1__ViewershipGraph__["a" /* default */],
    DateRange: __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_dateRange__["a" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_5__components_common_actionButton__["a" /* default */],
    ApiErrorMessage: __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default.a,
    ToggleButton: __WEBPACK_IMPORTED_MODULE_2__components_common_toggleButton__["a" /* default */],
    StyledTable: __WEBPACK_IMPORTED_MODULE_3__components_common_tables__["a" /* StyledTable */]
  },
  props: {
    viewershipData: {
      type: Object
    },
    networks: {
      type: Array,
      required: true
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    isGraphOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      changeToTable: true,
      tableSorting: {
        prop: 'size',
        order: 'desc'
      },
      networksToHide: [],
      overRideBubble: {
        min: 15,
        max: 90
      },
      tableHeaders: [{
        text: 'Network',
        value: 'name',
        align: 'left',
        sortable: true
      }, {
        text: 'Audience Size',
        value: 'size',
        align: 'left',
        sortable: true
      }],

      allowViewershipToRender: false
    };
  },

  computed: {
    networksToHighlight: function networksToHighlight() {
      return this.$store.getters.networksToShowDayParts || [];
    },
    selectedViewershipNetworks: function selectedViewershipNetworks() {
      return this.$store.getters.selectedViewershipNetworks;
    },
    dataForGraph: function dataForGraph() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_lasGraphs_chartDataHelpers__["b" /* transformHistoricalViewershipGraphData */])(this.networks, this.viewershipData, this.networksToHighlight, this.overRideBubble);
    },
    dataForTable: function dataForTable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["map"])(this.viewershipData, function (value, key) {
        return {
          name: key,
          index: value.index,
          rating: value.rating,
          size: value.size
        };
      }), this.tableSorting.prop, this.tableSorting.order);
    },
    axises: function axises() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_lasGraphs_chartDataHelpers__["c" /* historicalViewershipGraphAxises */])(this.viewershipData);
    },
    isTargetActivated: function isTargetActivated() {
      return this.$store.getters.isTargetActivated;
    }
  },
  methods: {
    formatIndex: __WEBPACK_IMPORTED_MODULE_8__helpers__["a" /* formatIndex */],
    formatRating: __WEBPACK_IMPORTED_MODULE_8__helpers__["b" /* formatRating */],
    formatAudienceSize: __WEBPACK_IMPORTED_MODULE_8__helpers__["c" /* formatAudienceSize */],
    toggleDisplayOfData: function toggleDisplayOfData() {
      this.changeToTable = !this.changeToTable;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      this.tableSorting.prop = prop;
      this.tableSorting.order = order === 'descending' ? 'desc' : 'asc';
    },
    toggleNetworksModal: function toggleNetworksModal() {
      this.$refs.filter.open();
    },
    resizeBubbleToWidth: function resizeBubbleToWidth(updatedWidth) {
      if (updatedWidth < 1281) {
        this.overRideBubble.max = 40;
        this.overRideBubble.min = 8;
      } else if (updatedWidth < 1400) {
        this.overRideBubble.max = 60;
        this.overRideBubble.min = 12;
      } else if (updatedWidth >= 1700) {
        this.overRideBubble.max = 90;
        this.overRideBubble.min = 16;
      }
    },
    initResizeOneGraph: function initResizeOneGraph() {
      if (!this.allowViewershipToRender) {
        this.allowViewershipToRender = true;
        this.$nextTick(function () {
          var _this = this;

          if (this.$refs && this.$refs.viewershipGraph && this.$refs.viewershipGraph.$el) {
            var viewershipGraph = this.$refs.viewershipGraph.$el;
            this.resizeBubbleToWidth(viewershipGraph.clientWidth);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"])(viewershipGraph, function () {
              var updatedWidth = viewershipGraph.clientWidth;
              _this.resizeBubbleToWidth(updatedWidth);
            });
          }
        });
      }
    },
    viwershipOnClick: function viwershipOnClick(network) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_12__appLogic_targets_currentTarget_store_actions__["c" /* SELECT_NETWORK_DAY_PART */], network);
    },
    resetBubbles: function resetBubbles() {
      if (!this.dataForGraph) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__bubbleLabelPlugin__["a" /* setDataForBubblesPlugin */])(this.dataForGraph.datasets);
      this.$nextTick(function () {
        this.initResizeOneGraph();
      });
    }
  },
  mounted: function mounted() {
    this.resetBubbles();
  },

  watch: {
    'viewershipData': function viewershipData() {
      this.allowViewershipToRender = true;
      this.resetBubbles();
    },
    'dataForGraph': function dataForGraph() {
      this.resetBubbles();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var viewership = this.$refs.ViewershipGraph;
    if (viewership && viewership.$el) {
      __WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"].detach(this.$refs.viewershipGraph.$el);
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tabs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__ = __webpack_require__(17);






var Tabs = __WEBPACK_IMPORTED_MODULE_2__components_common_tabs__["a" /* default */].Tabs,
    Tab = __WEBPACK_IMPORTED_MODULE_2__components_common_tabs__["a" /* default */].Tab;


var MAX_LIMIT_OF_NETWORKS = 15;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue___default.a,
    Tabs: Tabs,
    Tab: Tab,
    ActionButton: __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__["a" /* default */]
  },
  props: {
    networks: {
      type: Array,
      required: true
    },
    selectedNetworks: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      copyOfSelectedNetworks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.selectedNetworks),
      maxNumberOfNetworks: MAX_LIMIT_OF_NETWORKS
    };
  },

  computed: {
    turnerNetworks: function turnerNetworks() {
      return this.networks.filter(function (net) {
        return net.turner;
      });
    },
    nonTurnerNetworks: function nonTurnerNetworks() {
      return this.networks.filter(function (net) {
        return net.turner === false;
      });
    },
    currentLength: function currentLength() {
      return this.copyOfSelectedNetworks.length;
    },
    errorNoNetworks: function errorNoNetworks() {
      return this.currentLength === 0;
    },
    errorToManySelected: function errorToManySelected() {
      return this.currentLength > MAX_LIMIT_OF_NETWORKS;
    },
    disableSubmit: function disableSubmit() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"])(this.copyOfSelectedNetworks, this.selectedNetworks) || this.errorNoNetworks || this.errorToManySelected;
    }
  },
  methods: {
    hasUrl: function hasUrl(network) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(network.url);
    },
    isSelected: function isSelected(id) {
      return this.copyOfSelectedNetworks.indexOf(id) > -1;
    },
    selectNetwork: function selectNetwork(id) {
      this.$emit('select', id);
      var selected = this.copyOfSelectedNetworks.indexOf(id);
      selected > -1 ? this.copyOfSelectedNetworks.splice(selected, 1) : this.copyOfSelectedNetworks.push(id);
    },
    open: function open() {
      this.copyOfSelectedNetworks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.selectedNetworks);
      this.$refs.networksFilterModal.open();
    },
    close: function close() {
      this.$refs.networksFilterModal.close();
      this.$emit('close');
    },
    submitNewSelection: function submitNewSelection() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_currentTarget_store_actions__["d" /* UPDATE_SELECTED_VIEWERSHIP_NETWORKS */], this.copyOfSelectedNetworks);
      this.$emit('newSelection', this.copyOfSelectedNetworks);
      this.close();
    }
  }
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_workbench_LAS_store_mutations__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_searchInput__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResults_vue__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResults_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchResults_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapseButton_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CollapseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelSizeBtn__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelSizeBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PanelSizeBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BackButton_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BackButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BackButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadCrumbs_vue__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadCrumbs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BreadCrumbs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__List_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SmallText_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SmallText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SmallText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_search__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_attributeTree__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_workbench_attributePanel_assets_EditIcon__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_workbench_attributePanel_assets_EditIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__appComponents_workbench_attributePanel_assets_EditIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appComponents_workbench_newSelect_AdvertiserSelectNew_vue__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appComponents_workbench_newSelect_AdvertiserSelectNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__appComponents_workbench_newSelect_AdvertiserSelectNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appComponents_targets_createTarget_components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appComponents_targets_createTarget_components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__appComponents_targets_createTarget_components_TargetName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appLogic_targets_currentTarget_store_actions_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CollapseBtn: __WEBPACK_IMPORTED_MODULE_4__CollapseButton_vue___default.a,
    PanelSizeBtn: __WEBPACK_IMPORTED_MODULE_5__PanelSizeBtn___default.a,
    BackBtn: __WEBPACK_IMPORTED_MODULE_6__BackButton_vue___default.a,
    SearchInput: __WEBPACK_IMPORTED_MODULE_2__components_common_searchInput__["a" /* default */],
    SearchResults: __WEBPACK_IMPORTED_MODULE_3__SearchResults_vue___default.a,
    List: __WEBPACK_IMPORTED_MODULE_8__List_vue___default.a,
    SmallText: __WEBPACK_IMPORTED_MODULE_9__SmallText_vue___default.a,
    BreadCrumbs: __WEBPACK_IMPORTED_MODULE_7__BreadCrumbs_vue___default.a,
    EditIcon: __WEBPACK_IMPORTED_MODULE_12__appComponents_workbench_attributePanel_assets_EditIcon___default.a,
    AdvertiserSelectNew: __WEBPACK_IMPORTED_MODULE_13__appComponents_workbench_newSelect_AdvertiserSelectNew_vue___default.a,
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_AdvertiserSelect___default.a,
    TargetName: __WEBPACK_IMPORTED_MODULE_15__appComponents_targets_createTarget_components_TargetName___default.a
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isExpandedView: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currentList: null,
      searchTerm: '',
      searchResults: [],
      editModeActive: false,
      originalDisplayName: null,
      originalAdvertiserId: null,
      nameIsValid: null,
      newNameOfTarget: null,
      previousDirtyState: false
    };
  },

  computed: {
    crumbs: function crumbs() {
      return this.currentList && this.currentList.getPath().map(function (node) {
        return {
          name: node.model.name,
          node: node
        };
      });
    },
    tooManySearchResults: function tooManySearchResults() {
      return this.searchResultsCount > 500;
    },
    searchResultsCount: function searchResultsCount() {
      return this.searchResults.reduce(function (currValue, resultSet) {
        return resultSet.results.length + currValue;
      }, 0);
    },
    isSearchActive: function isSearchActive() {
      return this.searchTerm.length > 0;
    },
    currentTarget: function currentTarget() {
      return this.$store.getters.currentTarget;
    },
    isDraft: function isDraft() {
      return this.currentTarget && this.currentTarget.activation_status && this.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
    },
    isWorking: function isWorking() {
      return this.currentTarget && this.currentTarget.activation_status && this.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
    },
    targetEditable: function targetEditable() {
      return this.currentTarget && this.currentTarget.activation_status && (this.isDraft || this.isWorking);
    },
    isAdvertiserEditable: function isAdvertiserEditable() {
      var marketingIntent = this.currentTarget && this.currentTarget.metadata && (this.currentTarget.metadata.intents || []).find(function (i) {
        return i.Name === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.Name;
      });
      return this.currentTarget && this.currentTarget.advertiser && this.currentTarget.advertiser.Name && this.editModeActive && !marketingIntent;
    }
  },
  watch: {
    searchTerm: function searchTerm(newValue) {
      if (newValue.length < 1) {
        this.searchResults = [];
      } else {
        this.searchResults = this.searchService.search(newValue);
      }
    },
    currentTarget: function currentTarget() {
      this.editModeActive = false;
    }
  },
  methods: {
    itemSelectedHandler: function itemSelectedHandler(item) {
      this.currentList = item;
    },
    crumbClickHandler: function crumbClickHandler(crumb) {
      this.currentList = crumb.node;
    },
    clearSearch: function clearSearch() {
      this.$refs.searchInput.clearSearch();
    },
    panelClickHandler: function panelClickHandler(e) {
      if (this.isCollapsed) this.toggleCollapse(e);
    },
    toggleCollapse: function toggleCollapse(e) {
      e.stopPropagation();
      this.$emit('collapse-clicked');
    },
    togglePanelSize: function togglePanelSize() {
      this.$emit('change-size-click');
    },
    toggleEditMode: function toggleEditMode() {
      if (this.editModeActive) {
        var changedName = this.originalDisplayName !== this.currentTarget.display_name;
        var changedAdvertiser = this.currentTarget.advertiser && this.originalAdvertiserId !== this.currentTarget.advertiser.Advertiser_id;
        if (changedName || changedAdvertiser) {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], true);
          this.previousDirtyState = true;
        } else if (this.previousDirtyState) {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], true);
        }
      } else {
        if (this.previousDirtyState) {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], false);
        }
      }
      this.originalDisplayName = this.currentTarget.display_name;
      this.originalAdvertiserId = this.currentTarget.advertiser && this.currentTarget.advertiser.Advertiser_id;
      this.editModeActive = !this.editModeActive;
    },
    updateName: function updateName(name) {
      this.newNameOfTarget = name;
    },
    validateName: function validateName(isValid) {
      this.nameIsValid = isValid;
      var validAndNameIsDiff = this.nameIsValid && this.newNameOfTarget && this.newNameOfTarget !== this.originalDisplayName;
      if (validAndNameIsDiff) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_currentTarget_store_actions_js__["f" /* SET_TARGET_NAME */], this.newNameOfTarget);
      } else {
        this.currentTarget.display_name = this.originalDisplayName;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["j" /* SET_TARGET_DEFINITION_DIRTY */], false);
      }
    },
    changeAdvertiser: function changeAdvertiser(ad) {
      if (ad && ad.Advertiser_id) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_17__appLogic_targets_currentTarget_store_actions_js__["g" /* SET_TARGET_ADVERTISER */], ad);
      }
    }
  },
  created: function created() {
    var _this = this;

    this.searchService = new __WEBPACK_IMPORTED_MODULE_10__services_search__["a" /* default */]();
    this.attributesTree = new __WEBPACK_IMPORTED_MODULE_11__models_attributeTree__["a" /* default */]();
    this.unsubscribe = this.$store.subscribe(function (_ref, state) {
      var type = _ref.type,
          payload = _ref.payload;

      if (type !== __WEBPACK_IMPORTED_MODULE_1__views_workbench_LAS_store_mutations__["b" /* SET_DATA_SOURCES */]) return;
      payload.forEach(function (dataSource) {
        _this.searchService.addDataSource(dataSource.flat);
        _this.attributesTree.addDataSource(dataSource.data);
      });
      _this.currentList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(_this.attributesTree.root);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  }
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]
    };
  }
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_home_outline_svg__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_svg__ = __webpack_require__(45);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: ['crumbs'],
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_svg__["a" /* default */],
      homeOutline: __WEBPACK_IMPORTED_MODULE_1__assets_svg_home_outline_svg__["a" /* default */]
    };
  },

  methods: {
    hasSeparator: function hasSeparator(index) {
      return index < this.crumbs.length - 1;
    },
    crumbClickHandler: function crumbClickHandler(crumb, index) {
      this.$emit('click', crumb, index);
    }
  }
});

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    hideText: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]
    };
  }
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelItem_vue__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PanelItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_virtualScrollList__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PanelItem: __WEBPACK_IMPORTED_MODULE_1__PanelItem_vue___default.a,
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_4__components_common_scrollPanel__["a" /* default */],
    VirtualList: __WEBPACK_IMPORTED_MODULE_5__components_common_virtualScrollList__["a" /* default */]
  },
  props: {
    scrollable: {
      type: Boolean,
      default: true
    },
    listGroup: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      currentSelectedItem: null,
      currentAttributePopover: null,
      scrollPositionMap: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default.a()
    };
  },

  methods: {
    selectItem: function selectItem(item, event) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_attributePanel_services_attributeType__["b" /* isAttribute */])(item.model)) {
        this.attributeSelectedHandler(item.model, item, event);
      } else {
        this.scrollPositionMap.set(this.listGroup, this.$refs.virtualList.getScrollTop());
        this.$emit('item-selected', item);
      }
    },
    attributeSelectedHandler: function attributeSelectedHandler(attribute, panelItem, event) {
      if (attribute.type === __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN) {
        this.addAttributeToDefinition(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(attribute));
      } else {
        this.currentSelectedItem = panelItem;
        this.currentAttributePopover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_common_popover__["b" /* createPopover */])({
          attribute: attribute,
          direction: 'right',
          parent: event.target,
          type: __WEBPACK_IMPORTED_MODULE_6__components_common_popover__["c" /* popoverTypes */].ATTRIBUTE
        });
        this.currentAttributePopover.$on('select', this.addAttributeToDefinition);
        this.currentAttributePopover.$on('dismiss', this.deselectCurrentSelectedItem);
      }
    },
    addAttributeToDefinition: function addAttributeToDefinition(attribute) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__["o" /* ADD_ATTRIBUTE */], attribute);
    },
    deselectCurrentSelectedItem: function deselectCurrentSelectedItem() {
      this.currentAttributePopover = null;
      this.currentSelectedItem = null;
    },
    dismissCurrentAttributePopover: function dismissCurrentAttributePopover() {
      this.currentAttributePopover && this.currentAttributePopover.deleteSelf();
    }
  },
  watch: {
    listGroup: function listGroup(newValue) {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.virtualList.scrollTo(_this.scrollPositionMap.get(newValue) || 0);

        _this.scrollPositionMap.delete(newValue);
      });
    }
  }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SmallText_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SmallText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SmallText_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__["a" /* default */],
    SmallText: __WEBPACK_IMPORTED_MODULE_3__SmallText_vue___default.a
  },
  props: {
    name: String,
    path: {
      type: String
    },
    hasChildren: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]),
      shouldDisplayTitleTooltip: false
    };
  },

  computed: {
    titleAttribute: function titleAttribute() {
      return this.shouldDisplayTitleTooltip ? this.name : null;
    },
    hasPath: function hasPath() {
      return !!this.path;
    }
  },
  mounted: function mounted() {
    var nameEl = this.$refs.name;
    this.shouldDisplayTitleTooltip = nameEl.scrollWidth > nameEl.offsetWidth;
  }
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    isExpandedView: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]
    };
  },

  computed: {
    buttonText: function buttonText() {
      return this.isExpandedView ? 'Show Less' : 'Show More';
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmallText_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmallText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SmallText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_scrollPanel__ = __webpack_require__(41);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_2__components_common_scrollPanel__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a,
    SmallText: __WEBPACK_IMPORTED_MODULE_1__SmallText_vue___default.a
  },
  props: ['results', 'count'],
  computed: {
    searchResultsFormatted: function searchResultsFormatted() {
      return this.results.map(function (results) {
        return {
          model: {
            name: results.name
          },
          children: results.results.map(function (result) {
            return {
              model: result,
              hasChildren: function hasChildren() {
                return false;
              }
            };
          })
        };
      });
    }
  },
  methods: {
    hasNoResults: function hasNoResults(results) {
      return results.children.length === 0;
    },
    itemSelectedHandler: function itemSelectedHandler(item) {
      this.$emit('item-selected', item);
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    light: Boolean,
    default: false
  }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_audience_svg__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_truncateAmount__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon_index__["a" /* default */],
    ViewershipTimeFrame: __WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame___default.a
  },
  filters: {
    truncateAmount: __WEBPACK_IMPORTED_MODULE_2__filters_truncateAmount__["a" /* default */]
  },
  props: {
    size: Number
  },
  data: function data() {
    return {
      audience: __WEBPACK_IMPORTED_MODULE_1__assets_svg_audience_svg__["a" /* default */]
    };
  },

  computed: {
    displaySize: function displaySize() {
      return this.size || this.size === 0 ? this.size : null;
    }
  }
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);









var viewershipOptions = [{
  name: 'Live',
  value: 'aalive'
}, {
  name: 'LSD',
  value: 'aalivesd'
}, {
  name: 'C3',
  value: 'aalive3'
}, {
  name: 'C7',
  value: 'aalive7'
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */],
      popover: null
    };
  },

  computed: {
    streamingOption: function streamingOption() {
      return this.$store.getters.streamingOption;
    },
    validStreamingOptions: function validStreamingOptions() {
      return this.$store.state.las && this.$store.state.las.validStreamingOptions || ['LSD'];
    },
    selectedText: function selectedText() {
      var _this = this;

      return viewershipOptions.find(function (option) {
        return option.value === _this.streamingOption;
      }).name;
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      var _this2 = this;

      if (this.$store.state.currentTarget.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_common_popover__["b" /* createPopover */])({
        direction: 'bottom',
        list: viewershipOptions.filter(function (v) {
          return _this2.validStreamingOptions.includes(v.name);
        }),
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_2__components_common_popover__["c" /* popoverTypes */].TEXTLIST
      });
      this.popover.$on('select', function (selected) {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["d" /* UPDATE_STREAMING_OPTION */], selected);
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["e" /* SET_STREAMING_CHANGED */]);
      });
    }
  }
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    currentSize: {
      type: String,
      required: true
    }
  },
  methods: {
    isActive: function isActive(size) {
      return size === this.currentSize;
    },
    setSizeTo: function setSizeTo(size) {
      this.$emit('new-size', size);
    }
  }
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);








var SAVE = 'Save';
var KEEP_WORKING = 'Keep Working';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_common_modal__["b" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__["a" /* default */]
  },
  data: function data() {
    return {
      next: null,
      saveButton: SAVE,
      continueWithoutSave: true
    };
  },

  computed: {
    currentTarget: function currentTarget() {
      return this.$store.getters.currentTarget;
    }
  },
  methods: {
    open: function open(next) {
      if (next == null) {
        throw Error('You must pass the next function into this open function in order to continue on the route');
      }
      this.next = next;
      this.$refs.confirm.open();
    },
    cancelHandler: function cancelHandler() {
      if (this.saveButton === SAVE) {
        this.saveButton = KEEP_WORKING;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["c" /* SAVE_TARGET */]);
        this.continueWithoutSave = false;
      } else {
        this.$refs.confirm.close();
      }
    },
    continueHandler: function continueHandler() {
      if (this.continueWithoutSave && this.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["j" /* deleteTarget */])(this.currentTarget).then(function (response) {
          console.log(response);
        }).catch(function (err) {
          console.log(err);
        });
      }
      this.next();
    }
  }
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_svg__ = __webpack_require__(45);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_svg__["a" /* default */],
      popover: null
    };
  },

  computed: {
    isActivated: function isActivated() {
      return this.$store.getters.isTargetActivated;
    },
    startDate: function startDate() {
      return this.$store.getters.dateRange.startDate;
    },
    startDateName: function startDateName() {
      return this.startDate ? this.startDate.name : '----';
    },
    endDate: function endDate() {
      return this.$store.getters.dateRange.endDate;
    },
    endDateName: function endDateName() {
      return this.endDate ? this.endDate.name : '----';
    },
    availableDates: function availableDates() {
      return this.$store.getters.dateRange.availableDates;
    },
    popoverStartList: function popoverStartList() {
      return this.availableDates.slice(0, this.availableDates.indexOf(this.endDate) + 1).map(function (date) {
        return {
          name: date.name,
          value: date.from
        };
      });
    },
    popoverEndList: function popoverEndList() {
      return this.availableDates.slice(this.availableDates.indexOf(this.startDate), this.availableDates.length).map(function (date) {
        return {
          name: date.name,
          value: date.to
        };
      }).reverse();
    }
  },
  methods: {
    createStartPopover: function createStartPopover(e) {
      var _this = this;

      if (this.isActivated) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_common_popover__["b" /* createPopover */])({
        direction: 'bottom',
        list: this.popoverStartList,
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_1__components_common_popover__["c" /* popoverTypes */].TEXTLIST
      });
      this.popover.$on('select', function (selected) {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_actions__["a" /* UPDATE_START_DATE */], selected);
      });
    },
    createEndPopover: function createEndPopover(e) {
      var _this2 = this;

      if (this.isActivated) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_common_popover__["b" /* createPopover */])({
        direction: 'bottom',
        list: this.popoverEndList,
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_1__components_common_popover__["c" /* popoverTypes */].TEXTLIST
      });
      this.popover.$on('select', function (selected) {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_actions__["b" /* UPDATE_END_DATE */], selected);
      });
    }
  }
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DayPartsGraph__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_cancel_svg__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DayPartsGraph: __WEBPACK_IMPORTED_MODULE_0__DayPartsGraph__["a" /* default */],
    DayPartsLegend: __WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue___default.a,
    SvgIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__["a" /* default */]
  },
  props: {
    selectedNetworks: {
      type: Array,
      required: true
    },
    viewershipData: {
      type: Object,
      required: true
    },
    networks: {
      type: Array,
      required: true
    },
    dayPartsConfig: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      closeIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_cancel_svg__["a" /* default */],
      selectedDayParts: []
    };
  },

  methods: {
    clickHandler: function clickHandler() {
      this.$emit('close');
    },
    dayPartSelected: function dayPartSelected(id) {
      var alreadySelected = this.selectedDayParts.indexOf(id);
      if (alreadySelected > -1) {
        this.selectedDayParts.splice(alreadySelected, 1);
        return;
      }
      this.selectedDayParts.push(id);
    },
    removeHiddenDayParts: function removeHiddenDayParts(chartData) {
      var _this = this;

      var filteredData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(chartData.datasets, function (dataset) {
        return _this.selectedDayParts.indexOf(dataset.title) === -1;
      });
      var data = {
        datasets: filteredData
      };
      return data;
    },
    deSelectNetwork: function deSelectNetwork(network) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["c" /* SELECT_NETWORK_DAY_PART */], network);
    }
  },
  computed: {
    dayPartAxises: function dayPartAxises() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__["c" /* historicalViewershipGraphAxises */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__["d" /* extractDayPartsData */])(this.viewershipData));
    },
    hydratedSelectedNetworks: function hydratedSelectedNetworks() {
      var _this2 = this;

      return this.selectedNetworks.map(function (networkId) {
        var network = _this2.networks.find(function (dayPart) {
          return dayPart.id === networkId;
        });
        return network || {
          id: networkId,
          name: networkId
        };
      });
    },
    networksToShow: function networksToShow() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__["e" /* transformViewershipDataForDayParts */])(this.viewershipData, this.hydratedSelectedNetworks, this.dayPartsConfig);
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    parts: {
      type: Array,
      required: true
    },
    selectedParts: {
      type: Array,
      required: true
    }
  },
  computed: {
    sortedDayParts: function sortedDayParts() {
      return this.sortDayParts(this.parts);
    }
  },
  methods: {
    emitDayPart: function emitDayPart(id) {
      this.$emit('day-part-click', id);
    },
    isSelected: function isSelected(id) {
      return this.selectedParts.indexOf(id) > -1;
    },
    sortDayParts: function sortDayParts(dayparts) {
      var sortedOrder = [];
      var sortOrder = ['Weekday Morning', 'Weekend Daytime', 'Weekday Daytime', 'Early Fringe', 'Prime Time', 'Late Fringe'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sortOrder), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var so = _step.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dayparts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _dp = _step3.value;

              if (_dp.name === so) {
                sortedOrder.push(_dp);
                break;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dayparts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var dp = _step2.value;

          var accepted = false;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sortedOrder), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var sd = _step4.value;

              if (dp.name === sd.name) {
                accepted = true;
                break;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          if (!accepted) {
            sortedOrder.push(dp);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return sortedOrder;
    }
  }
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    allowDownloadBtn: {
      type: Boolean
    }
  },
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_0__components_common_actionButton__["a" /* default */]
  },
  computed: {
    activateLabel: function activateLabel() {
      return this.currentTarget.target === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["c" /* TARGET_TYPE */].SD ? 'Activate' : 'Generate Estimates';
    },
    isEpsilonTargetAndHasEpsilonPermissions: function isEpsilonTargetAndHasEpsilonPermissions() {
      var C360Datasources = this.$store.getters.getC360Datasources;
      return this.currentTarget.target_datasource === C360Datasources.EPSILON;
    },
    isLASTargetAndHasLASPermissions: function isLASTargetAndHasLASPermissions() {
      return this.$store.getters.hasCreateEditPermissions && this.currentTarget.target === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS;
    },
    isADTargetAndHasADPermissions: function isADTargetAndHasADPermissions() {
      return this.currentTarget.target_type === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].AD;
    },
    currentTargetHasChanged: function currentTargetHasChanged() {
      return this.$store.getters.currentTargetHasChanged;
    },
    isSaveEnabled: function isSaveEnabled() {
      var hasPermissions = this.isEpsilonTargetAndHasEpsilonPermissions || this.isLASTargetAndHasLASPermissions || this.isADTargetAndHasADPermissions;
      var canMakeASave = (this.$store.getters.targetDefinitionHasChanged || this.currentTargetHasChanged) && this.$store.getters.isSaveEnabled;
      console.log({ hasPermissions: hasPermissions, canMakeASave: canMakeASave });
      console.log({
        targetHasChanged: this.$store.getters.targetDefinitionHasChanged,
        isSavedEnabled: this.$store.getters.isSaveEnabled
      });
      return hasPermissions && (canMakeASave || this.isDraft) && !this.$store.getters.loading;
    },
    isSendDownStreamEnabled: function isSendDownStreamEnabled() {
      return this.isEpsilonTargetAndHasEpsilonPermissions || this.isLASTargetAndHasLASPermissions || this.isADTargetAndHasADPermissions && !this.isTargetSubmitted && this.currentTarget && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(this.currentTarget.target_definition) && this.currentTarget.target_definition.query && this.currentTarget.target_definition.query.length;
    },
    isClearAllDisabled: function isClearAllDisabled() {
      return !this.$store.getters.hasDefinition || this.$store.state.viewOnly || this.$store.getters.isTargetSubmitted;
    },
    fetchingTarget: function fetchingTarget() {
      return this.$store.getters.isFetchingTarget;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    saveLabel: function saveLabel() {
      return this.$store.getters.isSaving ? 'Saving' : this.isSaveEnabled ? 'Save' : 'Saved';
    },
    canNotUndo: function canNotUndo() {
      return this.$store.getters.canNotUndo;
    },
    canNotRedo: function canNotRedo() {
      return this.$store.getters.canNotRedo;
    },
    currentTarget: function currentTarget() {
      return this.$store.getters.currentTarget;
    },
    showGenerateEstimate: function showGenerateEstimate() {
      return this.$store.getters.showGenerateEstimate && this.hasCreateEditPermissions;
    },
    showDuplicate: function showDuplicate() {
      return this.hasCreateEditPermissions;
    },
    showSendDownStream: function showSendDownStream() {
      return this.$store.getters.currentTarget.target === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["c" /* TARGET_TYPE */].AD && !this.hasResearchIntent;
    },
    hasResearchIntent: function hasResearchIntent() {
      return this.currentTarget && this.currentTarget.metadata && (this.currentTarget.metadata.intents || []).some(function (el) {
        return el.IntentId === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["a" /* INTENTS */].Research.IntentId;
      });
    },
    hasCreateEditPermissions: function hasCreateEditPermissions() {
      return this.$store.getters.hasCreateEditPermissions;
    },
    isDraft: function isDraft() {
      return this.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
    },
    isTargetSubmitted: function isTargetSubmitted() {
      return this.$store.getters.isTargetSubmitted;
    }
  },
  methods: {
    clear: function clear() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_actions__["b" /* CLEAR_DEFINITION */]);
    },
    generateEstimate: function generateEstimate() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* targetRouteHandler */])('ACTIVATE', this.currentTarget);
    },
    duplicate: function duplicate() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* targetRouteHandler */])('DUPLICATE', this.currentTarget);
    },
    save: function save() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["c" /* SAVE_TARGET */]);
    },
    undo: function undo() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_actions__["c" /* UNDO_TARGET_DEF */]);
    },
    redo: function redo() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_actions__["d" /* REDO_TARGET_DEF */]);
    },
    downloadTargetPackage: function downloadTargetPackage() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_currentTarget_store_actions__["C" /* DOWNLOAD_TARGET_DEFINITION */], {
        targetId: this.currentTarget.id,
        targetDefinition: this.$store.getters.targetDefinition,
        audienceSize: this.$store.getters.audienceSize
      });
    },
    submitToDC: function submitToDC() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["g" /* SUBMIT_TO_DC */]);
    }
  }
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_graphs_AgeMarketBreakerGraph__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_graphs_AgeMarketBreakerGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_graphs_AgeMarketBreakerGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_graphs_AgeDistributionGraph__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_graphs_AgeDistributionGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_graphs_AgeDistributionGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_IncomeGraph__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_IncomeGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_IncomeGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_pullDownButton__ = __webpack_require__(764);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgeMarketBreakerGraph: __WEBPACK_IMPORTED_MODULE_0__appComponents_graphs_AgeMarketBreakerGraph___default.a,
    AgeDistributionGraph: __WEBPACK_IMPORTED_MODULE_1__appComponents_graphs_AgeDistributionGraph___default.a,
    IncomeGraph: __WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_IncomeGraph___default.a,
    PullDownButton: __WEBPACK_IMPORTED_MODULE_3__components_common_pullDownButton__["a" /* default */]
  },
  data: function data() {
    return {
      incomeGraphText: 'Income',
      ageGraphText: 'Age Market Breaker',
      ageDistributionText: 'Age (10 years)',
      MAX_WIDTH_OF_GRAPH_AREA: 1200,
      DISTANCE_BETWEEN_BUTTONS: 25,
      widthOfGraph: 400
    };
  },

  computed: {
    ageData: function ageData() {
      return this.$store.getters.ageDistribution;
    },
    ageMarketBreakerData: function ageMarketBreakerData() {
      return this.$store.getters.ageBreakers;
    },
    meanAge: function meanAge() {
      return this.$store.getters.ageMean;
    },
    incomeData: function incomeData() {
      return this.$store.getters.incomeData;
    }
  },
  methods: {
    recomputeWidthOfGraph: function recomputeWidthOfGraph(dontTryAgain) {
      var _this = this;

      var NUMBER_OF_BUTTONS = 3;
      var MARGIN_OFF_WALLS = 25;
      var screenWidth = window.outerWidth;
      var extendedArea = (NUMBER_OF_BUTTONS - 1) * this.DISTANCE_BETWEEN_BUTTONS + 2 * MARGIN_OFF_WALLS;
      var button1 = this.$refs.button1;
      var button2 = this.$refs.button2;
      var button3 = this.$refs.button3;
      var listOfSizes = [button1.getButtonSize(), button2.getButtonSize(), button3.getButtonSize()];
      var distances = [MARGIN_OFF_WALLS];
      var last = MARGIN_OFF_WALLS;
      for (var i = 0; i < listOfSizes.length - 1; i++) {
        var first = listOfSizes[i] / 2;
        var second = listOfSizes[i + 1] / 2;
        last = first + second + this.DISTANCE_BETWEEN_BUTTONS + last;
        extendedArea += last;
        distances.push(last);
      }
      button1.$el.style.left = distances[0] + 'px';
      button2.$el.style.left = distances[1] + 'px';
      button3.$el.style.left = distances[2] + 'px';
      var widthToWorkWith = screenWidth - extendedArea;
      this.widthOfGraph = Math.min(widthToWorkWith, this.MAX_WIDTH_OF_GRAPH_AREA);
      if (!dontTryAgain) {
        setTimeout(function () {
          return _this.recomputeWidthOfGraph(true);
        }, 10);
      }
    }
  },
  mounted: function mounted() {
    this.recomputeWidthOfGraph();
    window.addEventListener('resize', this.recomputeWidthOfGraph);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.recomputeWidthOfGraph);
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    graphKeyItems: {
      type: Array,
      required: true
    },
    flex: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PropertyEngagementReachGraph__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_graphKey_GraphKey__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_graphKey_GraphKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_graphKey_GraphKey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








var sorts = [{
  name: 'Alphabetical',
  sortByKeys: [['name'], ['asc']]
}, {
  name: 'Engagement',
  sortByKeys: [['engagement', 'name'], ['desc', 'asc']]
}, {
  name: 'Reach',
  sortByKeys: [['reach', 'name'], ['desc', 'asc']]
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PropertyEngagementGraph: __WEBPACK_IMPORTED_MODULE_1__PropertyEngagementReachGraph__["a" /* default */],
    GraphKey: __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_graphKey_GraphKey___default.a
  },
  props: ['brands'],
  data: function data() {
    return {
      sorts: sorts,
      currentSort: sorts[0],
      keyItems: [{
        color: 'rgba(0, 82, 231, 0.4)',
        body: 'Engagement'
      }, {
        color: 'rgba(0, 82, 231, 1)',
        body: 'Reach'
      }]
    };
  },

  computed: {
    chartData: function chartData() {
      var sortedData = __WEBPACK_IMPORTED_MODULE_4_lodash__["orderBy"].apply(undefined, [this.brands].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.currentSort.sortByKeys)));
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_chartDataHelpers__["h" /* transformReachDataForGraph */])(sortedData);
    }
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







var PRETTY_NAME_MAP = {
  'headofhouseholdagebreak': 'Age',
  'homestructuretype': 'Dwelling Type',
  'headofhouseholdeducation': 'Education',
  'gender': 'Gender',
  'HasChildren': 'Has Children',
  'homeownershipstatus': 'Home Ownership',
  'householdsize': 'Household Size',
  'householdincome': 'Income'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      popover: null,
      currentActiveAttribute: null
    };
  },

  computed: {
    quickAddAttributes: function quickAddAttributes() {
      return this.$store.getters.quickAddAttributes;
    }
  },
  methods: {
    add: function add(attribute) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_actions__["o" /* ADD_ATTRIBUTE */], attribute);
    },
    isActive: function isActive(attribute) {
      return this.currentActiveAttribute === attribute;
    },
    getPrettyName: function getPrettyName(attribute) {
      return PRETTY_NAME_MAP[attribute.id] ? PRETTY_NAME_MAP[attribute.id] : attribute.name;
    },
    attributeClickedHandler: function attributeClickedHandler(attribute, e) {
      if (attribute.type === __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN) {
        this.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(attribute));
      } else {
        this.createPopover(attribute, e);
      }
    },
    createPopover: function createPopover(attribute, e) {
      var _this = this;

      this.currentActiveAttribute = attribute;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_common_popover__["b" /* createPopover */])({
        direction: 'top',
        attribute: attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_0__components_common_popover__["c" /* popoverTypes */].ATTRIBUTE
      });
      this.popover.$on('select', function (attr) {
        _this.add(attr);
      }).$on('dismiss', function () {
        _this.currentActiveAttribute = null;
      });
    }
  }
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_group_svg__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_ungroup_svg__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_trash_svg__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrows_svg__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_count_group_svg__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_remove_count_group_svg__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_history_svg__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_store_mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_7__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      group: __WEBPACK_IMPORTED_MODULE_0__assets_svg_group_svg__["a" /* default */],
      ungroup: __WEBPACK_IMPORTED_MODULE_1__assets_svg_ungroup_svg__["a" /* default */],
      trash: __WEBPACK_IMPORTED_MODULE_2__assets_svg_trash_svg__["a" /* default */],
      arrows: __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrows_svg__["a" /* default */],
      countGroup: __WEBPACK_IMPORTED_MODULE_4__assets_svg_count_group_svg__["a" /* default */],
      removeCountGroupIcon: __WEBPACK_IMPORTED_MODULE_5__assets_svg_remove_count_group_svg__["a" /* default */],
      history: __WEBPACK_IMPORTED_MODULE_6__assets_svg_history_svg__["a" /* default */]
    };
  },

  computed: {
    groupDisable: function groupDisable() {
      return !this.$store.getters.selectedCanBeGrouped;
    },
    ungroupDisable: function ungroupDisable() {
      return !this.$store.getters.selectedCanBeUngrouped;
    },
    deleteDisable: function deleteDisable() {
      return !this.$store.getters.selectedCanBeDeleted;
    },
    isDragAndDropActive: function isDragAndDropActive() {
      return this.$store.getters.isDragAndDropActive;
    },
    countGroupDisable: function countGroupDisable() {
      return !this.$store.getters.selectedCanBecomeCountGroup;
    },
    isSelectedACountGroup: function isSelectedACountGroup() {
      if (!this.$store.getters.hasOwnProperty('selectedAttributes')) return;
      var attribute = this.$store.getters.selectedAttributes[0];
      if (!attribute) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_store_mutations__["b" /* isCountGroup */])(attribute);
    },
    countGroupIcon: function countGroupIcon() {
      return this.isSelectedACountGroup ? __WEBPACK_IMPORTED_MODULE_5__assets_svg_remove_count_group_svg__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__assets_svg_count_group_svg__["a" /* default */];
    }
  },
  methods: {
    groupAttributes: function groupAttributes() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["f" /* GROUP */]);
    },
    ungroupAttributes: function ungroupAttributes() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["g" /* UNGROUP */]);
    },
    deleteAttributes: function deleteAttributes() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["e" /* REMOVE_ATTRIBUTE */]);
    },
    dragAndDropModeToggle: function dragAndDropModeToggle() {
      this.isDragAndDropActive ? this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["w" /* DEACTIVATE_DRAG_DROP */]) : this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["x" /* ACTIVATE_DRAG_DROP */]);
    },
    countGroupHandler: function countGroupHandler(e) {
      var attribute = this.$store.getters.selectedAttributes[0];
      this.isSelectedACountGroup ? this.removeCountGroup(attribute.definitionId) : this.createCountGroup(e, attribute);
    },
    createCountGroup: function createCountGroup(e, attribute) {
      var _this = this;

      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__components_common_popover__["b" /* createPopover */])({
        direction: 'left',
        attribute: attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_9__components_common_popover__["c" /* popoverTypes */].COUNT_GROUP
      });
      this.popover.$on('select', function (value) {
        var details = {
          groupId: attribute.definitionId,
          mustMatch: value
        };
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["r" /* CREATE_COUNT_GROUP */], details);
      });
    },
    removeCountGroup: function removeCountGroup(groupId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["s" /* REMOVE_COUNT_GROUP */], groupId);
    },
    showHistory: function showHistory() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_11__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["a" /* SHOW_TARGET_HISTORY_PANEL */], true);
    }
  }
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__targetDefinitionStatement__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DefinitionControls: __WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue___default.a,
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__["a" /* default */],
    TargetDefinitionStatement: __WEBPACK_IMPORTED_MODULE_2__targetDefinitionStatement__["a" /* default */]
  },
  computed: {
    definition: function definition() {
      return this.$store.getters.getDefinition;
    },
    selected: function selected() {
      return this.$store.getters.selected;
    },
    isTargetEditable: function isTargetEditable() {
      return this.$store.getters.isTargetEditable;
    },
    isDragAndDropActive: function isDragAndDropActive() {
      return this.$store.getters.isDragAndDropActive;
    },
    isDraggingPart: function isDraggingPart() {
      return this.$store.getters.isDraggingPart;
    },
    updateTD: function updateTD() {
      return this.$store.getters.updateLasTD;
    }
  },
  methods: {
    handleKeyboardShortcut: function handleKeyboardShortcut(e) {
      switch (e.keyCode) {
        case 8:
        case 46:
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__["e" /* REMOVE_ATTRIBUTE */]);
          break;

        case 71:
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__["f" /* GROUP */]);
          break;

        case 85:
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__["g" /* UNGROUP */]);
          break;

        case 27:
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__["h" /* CLEAR_SELECTION */]);
      }
    }
  },
  mounted: function mounted() {
    this.boundHandleKeyboardShortcut = this.handleKeyboardShortcut.bind(this);
    window.addEventListener('keyup', this.boundHandleKeyboardShortcut);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.boundHandleKeyboardShortcut);
  },

  watch: {
    updateTD: function updateTD() {
      this.$forceUpdate();
    }
  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_left_bracket_svg__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_right_bracket_svg__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_left_parenthesis_svg__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_right_parenthesis_svg__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableMixin__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_store_mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);


var _BRACKET_MAP;













var DIRECTION = {
  left: 0,
  right: 1 << 0
};

var BRACKET_TYPE = {
  square: 1 << 1,
  normal: 1 << 2
};

var BRACKET_MAP = (_BRACKET_MAP = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.left | BRACKET_TYPE.square, __WEBPACK_IMPORTED_MODULE_2__assets_svg_left_bracket_svg__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.right | BRACKET_TYPE.square, __WEBPACK_IMPORTED_MODULE_3__assets_svg_right_bracket_svg__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.left | BRACKET_TYPE.normal, __WEBPACK_IMPORTED_MODULE_4__assets_svg_left_parenthesis_svg__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.right | BRACKET_TYPE.normal, __WEBPACK_IMPORTED_MODULE_5__assets_svg_right_parenthesis_svg__["a" /* default */]), _BRACKET_MAP);

/* harmony default export */ __webpack_exports__["default"] = ({
  DIRECTION: DIRECTION,
  BRACKET_TYPE: BRACKET_TYPE,
  mixins: [__WEBPACK_IMPORTED_MODULE_6__SelectableMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__["a" /* default */]],
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__["a" /* default */]
  },
  props: {
    direction: {
      type: Number,
      required: true
    },
    bracketType: {
      type: Number,
      default: BRACKET_TYPE.normal
    },
    level: {
      type: Number,
      default: 0
    },
    definitionId: {
      type: String
    },
    attribute: {
      type: Object
    }
  },
  computed: {
    icon: function icon() {
      return BRACKET_MAP[this.direction | this.bracketType];
    },
    isCountGroup: function isCountGroup() {
      return !!this.attribute.mustMatch;
    },
    showMustMatch: function showMustMatch() {
      return this.isCountGroup && this.direction === 0;
    },
    classes: function classes() {
      return [{
        'definition-bracket--left': this.direction === DIRECTION.left,
        'definition-bracket--right': this.direction === DIRECTION.right,
        'selected': this.isSelected,
        'definition-bracket--square': this.bracketType === BRACKET_TYPE.square,
        'cant-drop-here': !this.canDropHere
      }, this.levelClass()];
    },
    defType: function defType() {
      return this.direction === 0 ? __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_store_mutations__["a" /* definitionPartTypes */].GROUP_BEGINNING : __WEBPACK_IMPORTED_MODULE_8__appComponents_oldWorkbench_targetDefinition_store_mutations__["a" /* definitionPartTypes */].GROUP_ENDING;
    },
    hoverOverMessage: function hoverOverMessage() {
      return 'Grouping-UE : ' + '1234223';
    }
  },
  methods: {
    levelClass: function levelClass() {
      return 'level-' + this.level;
    },
    clickHandler: function clickHandler(e) {
      var _this = this;

      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__components_common_popover__["b" /* createPopover */])({
        direction: 'top',
        attribute: this.attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_9__components_common_popover__["c" /* popoverTypes */].COUNT_GROUP
      });
      this.popover.$on('select', function (mustMatch) {
        var details = {
          groupId: _this.attribute.definitionId,
          mustMatch: mustMatch
        };
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appComponents_oldWorkbench_targetDefinition_store_actions__["r" /* CREATE_COUNT_GROUP */], details);
      });
    }
  }
});

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectableMixin__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_oldWorkbench_targetDefinition_store_mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_targetDefinition_mixins_HoverOver__ = __webpack_require__(706);








var BOOLEAN = __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN;




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__SelectableMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_targetDefinition_mixins_HoverOver__["a" /* default */]],
  props: {
    inGroup: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    },
    definitionId: {
      type: String
    },
    attribute: {
      type: Object
    }
  },
  data: function data() {
    return {
      defType: __WEBPACK_IMPORTED_MODULE_6__appComponents_oldWorkbench_targetDefinition_store_mutations__["a" /* definitionPartTypes */].ATTRIBUTE,
      hoverOverPopover: null
    };
  },

  computed: {
    displayName: function displayName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* createDisplayName */])(this.attribute);
    },
    disableDefinitionPart: function disableDefinitionPart() {
      return this.$store.getters.hasOwnProperty('disableDefinitionPart') ? this.$store.getters.disableDefinitionPart(this.definitionId) : false;
    },
    isRemoved: function isRemoved() {
      return this.attribute.removed;
    },
    levelClass: function levelClass() {
      return 'level-' + this.level;
    },
    thisPartIsInACountGroup: function thisPartIsInACountGroup() {
      return this.$store.getters.hasOwnProperty('isInACountGroup') ? this.$store.getters.isInACountGroup(this.definitionId) : false;
    },
    hoverOverMessage: function hoverOverMessage() {
      var ue = this.hasHoverOverMessage ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(Math.floor(Number(this.attribute.ue))) : 'NO DATA';
      return this.attribute.name + ' - UE : ' + ue;
    },
    hasHoverOverMessage: function hasHoverOverMessage() {
      return this.attribute.ue || this.attribute.ue === 0;
    }
  },
  methods: {
    clickHandler: function clickHandler() {
      if (this.thisPartIsInACountGroup) return;
      this.select(this.attribute);
    },
    updateAttribute: function updateAttribute(updatedAttribute) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_store_actions__["p" /* UPDATE_ATTRIBUTE */], { attribute: this.attribute, update: updatedAttribute });
    },
    editAttribute: function editAttribute(e) {
      var _this = this;

      if (this.attribute.type === BOOLEAN) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_common_popover__["b" /* createPopover */])({
        direction: 'top',
        attribute: this.attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_3__components_common_popover__["c" /* popoverTypes */].ATTRIBUTE
      });
      this.popover.$on('select', function (attr) {
        _this.updateAttribute(attr);
      });
    }
  }
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_mutations__ = __webpack_require__(85);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__["a" /* default */]],
  props: {
    level: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      defType: __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_targetDefinition_store_mutations__["a" /* definitionPartTypes */].DROP_ZONE,
      definitionId: 'drop-zone'
    };
  }
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_models_operators__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_targetDefinition_store_mutations__ = __webpack_require__(85);









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition_mixins_DragAndDropHandlers__["a" /* default */]],
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    definitionId: {
      type: String
    },
    operator: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      defType: __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_targetDefinition_store_mutations__["a" /* definitionPartTypes */].OPERATOR
    };
  },

  computed: {
    levelClass: function levelClass() {
      return 'level-' + this.level;
    },
    operatorConfig: function operatorConfig() {
      return __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_models_operators__["a" /* default */][this.operator.value];
    },
    disableDefinitionPart: function disableDefinitionPart() {
      return this.$store.getters.hasOwnProperty('disableDefinitionPart') ? this.$store.getters.disableDefinitionPart(this.definitionId) : false;
    },
    thisPartIsInACountGroup: function thisPartIsInACountGroup() {
      return this.$store.getters.hasOwnProperty('isInACountGroup') ? this.$store.getters.isInACountGroup(this.definitionId) : false;
    }
  },
  methods: {
    updateOperator: function updateOperator(updatedOperator) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_targetDefinition_store_actions__["i" /* UPDATE_OPERATOR */], { operator: this.operator, update: updatedOperator });
    },
    editOperator: function editOperator(e) {
      var _this = this;

      if (this.thisPartIsInACountGroup) return;
      this.popover = __WEBPACK_IMPORTED_MODULE_4__components_common_popover__["a" /* PopoverFactory */].createOperator({
        direction: 'top',
        operatorSelector: true,
        parent: e.currentTarget,
        miliseconds: 200
      });
      this.popover.$on('select', function (operator) {
        _this.updateOperator(operator);
      });
    }
  }
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_graphs_TopAttributesBubbleGraph__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_bubbleLabelPlugin__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TopAttributesBubbleGraph: __WEBPACK_IMPORTED_MODULE_1__appComponents_graphs_TopAttributesBubbleGraph__["a" /* default */]
  },
  props: {
    attributes: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      overRideBubble: {
        min: 15,
        max: 90
      }
    };
  },

  computed: {
    dataForGraph: function dataForGraph() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_chartDataHelpers__["f" /* transformTopAttributesForGraph */])(this.attributes, this.overRideBubble);
    },
    axises: function axises() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_chartDataHelpers__["g" /* topAttributesAxises */])(this.attributes);
    }
  },
  methods: {
    resizeBubbleToWidth: function resizeBubbleToWidth(updatedWidth) {
      if (updatedWidth < 1281) {
        this.overRideBubble.max = 20;
        this.overRideBubble.min = 19;
      } else if (updatedWidth >= 1281) {
        this.overRideBubble.max = 35;
        this.overRideBubble.min = 34;
      }
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_bubbleLabelPlugin__["a" /* setDataForBubblesPlugin */])(this.dataForGraph.datasets);
  },
  mounted: function mounted() {
    var _this = this;

    var graph = this.$refs.graph.$el;
    this.resizeBubbleToWidth(graph.clientWidth);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"])(graph, function () {
      var updatedWidth = graph.clientWidth;
      _this.resizeBubbleToWidth(updatedWidth);
    });
  },

  watch: {
    'dataForGraph': function dataForGraph() {
      if (!this.dataForGraph) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__appComponents_graphs_bubbleLabelPlugin__["a" /* setDataForBubblesPlugin */])(this.dataForGraph.datasets);
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"].detach(this.$refs.graph.$el);
  }
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_children_svg__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_marriage_svg__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_home_svg__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_male_svg__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_female_svg__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_dollar_sign_svg__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters_truncateAmount__ = __webpack_require__(128);











var iconArray = [{ icon: __WEBPACK_IMPORTED_MODULE_4__assets_svg_male_svg__["a" /* default */], key: 'male' }, { icon: __WEBPACK_IMPORTED_MODULE_5__assets_svg_female_svg__["a" /* default */], key: 'female' }, { icon: __WEBPACK_IMPORTED_MODULE_1__assets_svg_children_svg__["a" /* default */], key: 'kids' }, { icon: __WEBPACK_IMPORTED_MODULE_3__assets_svg_home_svg__["a" /* default */], key: 'house' }, { icon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_marriage_svg__["a" /* default */], key: 'marriage' }, { icon: __WEBPACK_IMPORTED_MODULE_6__assets_svg_dollar_sign_svg__["a" /* default */], key: 'income', truncateAmount: true }];

function percentageString(num) {
  return num.toFixed(1) + '%';
}

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    metrics: {
      type: Object | null,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    metricsArray: function metricsArray() {
      var _this = this;

      if (!this.metrics) return [];
      return iconArray.reduce(function (arr, obj) {
        if (_this.metrics.hasOwnProperty(obj.key)) {
          var text = obj.truncateAmount ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__filters_truncateAmount__["a" /* default */])(_this.metrics[obj.key]) : percentageString(_this.metrics[obj.key]);
          var newMetric = { icon: obj.icon, text: text };
          return arr.concat([newMetric]);
        } else {
          return arr;
        }
      }, []);
    }
  }
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_attributePanel_BackButton__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_attributePanel_BackButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_attributePanel_BackButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_flag__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricsBanner__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricsBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MetricsBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_junk_drawer_svg__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_distributionGraphs_DistributionGraphArea__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_distributionGraphs_DistributionGraphArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_distributionGraphs_DistributionGraphArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_workbench_LAS_store_mutations__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_modals_DroppedAttributesModal__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_modals_DroppedAttributesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_modals_DroppedAttributesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_route_store_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MetricsBanner: __WEBPACK_IMPORTED_MODULE_2__MetricsBanner___default.a,
    SvgIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__["a" /* default */],
    Flag: __WEBPACK_IMPORTED_MODULE_1__components_common_flag__["a" /* default */],
    BackButton: __WEBPACK_IMPORTED_MODULE_0__appComponents_oldWorkbench_attributePanel_BackButton___default.a,
    DistributionGraphArea: __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_distributionGraphs_DistributionGraphArea___default.a,
    DroppedAttributesModal: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_modals_DroppedAttributesModal___default.a
  },
  props: {
    name: String,
    metrics: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    activated: {
      type: Boolean,
      default: false
    },
    showGraphs: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      junkDrawerIcon: __WEBPACK_IMPORTED_MODULE_4__assets_svg_junk_drawer_svg__["a" /* default */],
      audienceDiscoveryTargetType: __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].AD,
      lasTargetType: __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS,
      sdTargetType: __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].SD
    };
  },

  computed: {
    username: function username() {
      return this.$store.getters.username;
    },
    dropped: function dropped() {
      return this.$store.state.las && this.$store.state.las.isDropped;
    },
    currentTarget: function currentTarget() {
      return this.$store.getters.currentTarget;
    }
  },
  methods: {
    navigateToDashboard: function navigateToDashboard() {
      if (this.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["j" /* deleteTarget */])(this.currentTarget).then(function (response) {
          console.log(response);
        }).catch(function (err) {
          console.log(err);
        });
      }
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], { target_definition: { promotedNetworks: '' } });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__appLogic_route_store_actions__["d" /* ROUTE_BACK */]);
    },
    clickedDropped: function clickedDropped() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__views_workbench_LAS_store_mutations__["a" /* SHOW_DROPPED_ATTRIBUTES_MODEL */]);
    }
  }
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_enterprise__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_enterprise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ag_grid_enterprise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_permissions_components_EditPermissions__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_permissions_components_EditPermissions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_permissions_components_EditPermissions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgGridVue: __WEBPACK_IMPORTED_MODULE_1_ag_grid_vue__["AgGridVue"],
    EditPermissions: __WEBPACK_IMPORTED_MODULE_2__appComponents_permissions_components_EditPermissions___default.a
  },
  props: {},
  data: function data() {
    return {
      columnDefs: null,
      rowData: null,
      gridApi: null,
      frameworkComponents: null,
      context: null
    };
  },
  beforeMount: function beforeMount() {
    this.columnDefs = [{ headerName: 'Role', field: 'name', filter: 'agTextColumnFilter', sortable: true, flex: 1, resizable: true }, {
      headerName: 'Permissions',
      field: 'value',
      cellRendererFramework: 'EditPermissions',
      colId: 'params',
      flex: 1,
      autoHeight: true
    }];

    this.frameworkComponents = {
      editPermissionsRenderer: __WEBPACK_IMPORTED_MODULE_2__appComponents_permissions_components_EditPermissions___default.a
    };
    this.context = { componentParent: this };
    this.updateRoles();
  },

  methods: {
    updateRoles: function updateRoles() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["d" /* getRoles */])().then(function (resp) {
        _this.rowData = resp.data.sort(function (a, b) {
          return a.id > b.id ? 1 : -1;
        });
      });
    }
  }
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_permissions_store_constants__ = __webpack_require__(69);





/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {},
  methods: {
    confirmDeleteUser: function confirmDeleteUser() {
      this.params.context.componentParent.setUserToDelete(this.params.data);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_permissions_store_constants__["d" /* SHOW_DELETE_USER_MODAL */]);
    }
  }
}));

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__ = __webpack_require__(17);








/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  components: {
    PermissionsAPI: __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__["a" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__["a" /* default */]
  },
  props: {},
  data: function data() {
    return {
      headers: [{
        text: 'Name',
        align: 'start',
        value: 'name',
        groupable: false
      }, { text: 'Actions', value: 'actions', align: 'right', groupable: false }, { text: 'Description', value: 'description', groupable: false }],
      permissionsList: [],
      selected: [],
      dialog: null,
      overlay: false
    };
  },
  mounted: function mounted() {
    this.permissionsList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(this.$store.getters.allPermissions);
  },

  computed: {
    titleText: function titleText() {
      return this.params.data.name + ' Permissions';
    }
  },
  methods: {
    editPermissions: function editPermissions() {
      this.permissionsList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(this.$store.getters.allPermissions);
      var profilePermissions = this.params.data.permissions;
      this.selected = this.$store.getters.allPermissions.filter(function (permission) {
        if (profilePermissions.includes(permission.id)) {
          return permission;
        }
      });
      this.overlay = false;
    },
    saveChanges: function saveChanges() {
      var _this = this;

      this.overlay = true;
      var updatedPermissionsIds = this.selected.map(function (p) {
        return p.id;
      }).sort(function (a, b) {
        return a > b ? 1 : -1;
      });
      var updatedRole = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(this.params.data);
      updatedRole.permissions = updatedPermissionsIds;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["e" /* updateRolePermissions */])(updatedRole).then(function (resp) {
        _this.params.context.componentParent.updateRoles();
        _this.overlay = false;
        _this.dialog = false;
      });
    }
  }
}));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(58);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      routes: [__WEBPACK_IMPORTED_MODULE_0__router__["b" /* ROUTES */].USERS, __WEBPACK_IMPORTED_MODULE_0__router__["b" /* ROUTES */].PERMISSIONS]
    };
  },

  methods: {
    navigateToDashboard: function navigateToDashboard() {
      this.$router.push({ path: '/login' });
    }
  }
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_enterprise__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ag_grid_enterprise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ag_grid_enterprise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs_AgGridRoleSelect__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inputs_AgGridRoleSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__inputs_AgGridRoleSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_PermissionsAPI__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AgGridButtonRenderer__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AgGridButtonRenderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AgGridButtonRenderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_permissions_store_constants__ = __webpack_require__(69);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgGridVue: __WEBPACK_IMPORTED_MODULE_0_ag_grid_vue__["AgGridVue"],
    AgGridButtonRenderer: __WEBPACK_IMPORTED_MODULE_4__AgGridButtonRenderer___default.a
  },
  props: {
    copiedUserList: {
      type: Array
    },
    rolesList: {
      type: Array
    }
  },
  data: function data() {
    return {
      rowData: null,
      columnDefs: null,
      frameworkComponents: null,
      context: null
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.columnDefs = [{
      headerName: '',
      field: 'value',
      cellRendererFramework: 'AgGridButtonRenderer',
      colId: 'params',
      width: 80,
      autoHeight: true
    }, {
      headerName: 'First Name',
      field: 'first_name',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true
    }, { headerName: 'Last Name', field: 'last_name', filter: 'agTextColumnFilter', sortable: true, resizable: true }, { headerName: 'Email', field: 'email', filter: 'agTextColumnFilter', sortable: true, resizable: true }, {
      headerName: 'Roles',
      field: 'roles',
      cellEditorFramework: __WEBPACK_IMPORTED_MODULE_2__inputs_AgGridRoleSelect___default.a,
      cellEditorPopup: true,
      editable: true,
      width: 300,
      minWidth: 300,
      valueGetter: function valueGetter(params) {
        return _this.getRoles(params);
      },
      sortable: true,
      resizable: true,
      filter: 'agTextColumnFilter'
    }];
    this.context = { componentParent: this };
    this.frameworkComponents = {
      agGridButtonRenderer: __WEBPACK_IMPORTED_MODULE_4__AgGridButtonRenderer___default.a
    };
    this.rowData = this.copiedUserList ? this.copiedUserList : null;

    this.autoGroupColumnDef = {
      headerName: '',
      cellRendererParams: { suppressCount: true }
    };
  },
  mounted: function mounted() {
    this.rowData = this.copiedUserList && this.copiedUserList.length ? this.copiedUserList : null;
  },

  computed: {},
  watch: {
    copiedUserList: function copiedUserList() {
      if (this.copiedUserList && this.copiedUserList.length) {
        this.rowData = this.copiedUserList;
      }
    }
  },
  methods: {
    setUserToDelete: function setUserToDelete(user) {
      this.$parent.setUserToDelete(user);
    },
    getDataPath: function getDataPath(data) {
      return data.categoryTree;
    },
    onGridReady: function onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    getRoles: function getRoles(params) {
      var _this2 = this;

      if (params) {
        var roleIds = params.data.roles;
        if (!roleIds) {
          return '';
        } else {
          var roleNamesArray = roleIds.map(function (roleId) {
            var rn = _this2.rolesList.filter(function (el) {
              return el.id === roleId;
            })[0];
            return rn && rn.name ? '\xa0' + rn.name : '';
          });
          return roleNamesArray ? roleNamesArray : '';
        }
      }
    },
    getContextMenuItems: function getContextMenuItems(params) {
      var _this3 = this;

      return ['copy', 'copyWithHeaders', 'separator', {
        name: 'Clear All Filters',
        action: function action() {
          _this3.$router.push({});
          params.api.setFilterModel(null);
        }
      }];
    }
  }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_permissions_store_constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_0__components_common_actionButton__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          id: undefined,
          first_name: null,
          last_name: null,
          email: null
        };
      }
    }
  },
  methods: {
    formSubmitHandler: function formSubmitHandler() {
      if (!this.value || !this.value.first_name || !this.value.last_name || !this.value.email) {
        __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({
          title: 'Missing User Information',
          message: 'Please make sure you have entered a first name, last name and email address before submitting'
        });
        return;
      }
      this.createUser();
    },
    createUser: function createUser() {
      var _this = this;

      this.value.email = this.value.email.toLowerCase();
      __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__["a" /* default */].upsertUser(this.value).then(function (resp) {
        if (resp) {
          _this.resetUserForm();
          __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].success({
            title: 'Create User Succeeded',
            message: 'User ' + resp.first_name + ' ' + resp.last_name + ' has been created'
          });
          __WEBPACK_IMPORTED_MODULE_1__api_PermissionsAPI__["a" /* default */].getUsers().then(function (res) {
            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_permissions_store_constants__["b" /* SET_USERS */], res);
          });
        }
      }).catch(function (err) {
        console.log('Save User has failed', err);
        __WEBPACK_IMPORTED_MODULE_3__components_common_toasts__["a" /* default */].error({
          title: 'Create User Error',
          message: 'Create User has failed, please refresh and try again',
          timeout: 15000
        });
      });
    },
    resetUserForm: function resetUserForm() {
      this.value.id = null;
      this.value.first_name = '';
      this.value.last_name = '';
      this.value.email = '';
    }
  }
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_PermissionsAPI__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_permissions_store_constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_permissions_Constants__ = __webpack_require__(317);










/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend({
  components: {},
  data: function data() {
    return {
      params: null,
      selectedRoles: [],
      rolesOptions: null
    };
  },

  computed: {
    roles: function roles() {
      return this.$store.state.permissions.roles;
    },

    selectedRole: {
      get: function get() {
        return this.initialRole();
      },
      set: function set(newVal) {}
    }
  },
  mounted: function mounted() {
    this.setRolesOptions();
  },

  methods: {
    initialRole: function initialRole() {
      var v = this.params.data.roles;
      if (v && v.length > 0) {
        var role = __WEBPACK_IMPORTED_MODULE_6__appLogic_permissions_Constants__["a" /* ROLES */].find(function (r) {
          return r.value === v[0];
        });
        return role;
      } else {
        ;'';
      }
    },
    updateUserRole: function updateUserRole(role) {
      var updatedUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.params.data, { roles: [role] });
      if (this.initialRole.length !== role.length || this.initialRole.every(function (element, index) {
        return element === role[index];
      })) {
        this.updateUser(updatedUser);
      }
    },
    setRolesOptions: function setRolesOptions() {
      this.rolesOptions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__appLogic_permissions_Constants__["a" /* ROLES */]));
    },
    updateUser: function updateUser(updatedUser) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api_PermissionsAPI__["a" /* default */].upsertUser(updatedUser).then(function (resp) {
        if (resp) {
          __WEBPACK_IMPORTED_MODULE_5__components_common_toasts__["a" /* default */].success({
            title: 'User Role Updated',
            message: 'Role for ' + resp.first_name + ' ' + resp.last_name + ' has been updated'
          });
          __WEBPACK_IMPORTED_MODULE_3__api_PermissionsAPI__["a" /* default */].getUsers().then(function (res) {
            _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_permissions_store_constants__["b" /* SET_USERS */], res);
          });
        }
      }).catch(function (err) {
        console.log('Update user has failed', err);
        __WEBPACK_IMPORTED_MODULE_5__components_common_toasts__["a" /* default */].error({
          title: 'Update User Error',
          message: 'Update User has an error, please refresh and try again'
        });
      });
    }
  }
}));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_dateRange_DateFromTo__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_dateRange_DateFromTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_dateRange_DateFromTo__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__["a" /* default */],
    DateFromTo: __WEBPACK_IMPORTED_MODULE_3__components_common_dateRange_DateFromTo___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: this.value,
      FWPlacementID: null,
      requestName: null,
      buttonClicked: false,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      valid: true,
      retargetingRequestNameRules: [function (v) {
        return !!v || 'Name is required';
      }, function (v) {
        return (/^[A-Za-z0-9_]+$/.test(v) || 'Allowed characters are A-Z, a-z, 0-9, _'
        );
      }, function (v) {
        return v && v.length >= 6 || 'Name must be at least 6 characters';
      }],
      placementIdRules: [function (v) {
        return !!v || 'Placement ID is required';
      }, function (v) {
        return (/^\d+$/.test(v) || 'Only numbers are allowed'
        );
      }]
    };
  },

  computed: {
    isFormValid: function isFormValid() {
      var _this = this;

      return this.retargetingRequestNameRules.every(function (rule) {
        return rule(_this.requestName) === true;
      }) && this.placementIdRules.every(function (rule) {
        return rule(_this.FWPlacementID) === true;
      });
    }
  },
  methods: {
    handleStartDateChange: function handleStartDateChange(value) {
      this.startDate = value;
      this.startDateMenu = false;
      if (this.endDate < value) {
        this.endDate = null;
      }
    },
    handleEndDateChange: function handleEndDateChange(value) {
      this.endDate = value;
      this.endDateMenu = false;
    },
    modifyDates: function modifyDates(val) {
      this.startDate = val.from;
      this.endDate = val.to;
    },
    retargetingRequest: function retargetingRequest() {
      var _this2 = this;

      this.buttonClicked = true;
      __WEBPACK_IMPORTED_MODULE_0__api_XandrAPI__["a" /* default */].retargetingRequest({
        placementId: this.FWPlacementID,
        requestName: this.requestName,
        startDate: this.startDate,
        endDate: this.endDate
      }).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__["a" /* default */].success({
          title: 'Retargeting Audience',
          message: 'Retargeting Audience Creation Request Succeeded'
        });
        _this2.close();
      }).catch(function (err) {
        console.log('Retargeting Audience Creation Request Failed');
        __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__["a" /* default */].error({
          title: 'Retargeting Audience',
          message: 'Retargeting Audience Creation Request Failed: ' + err.message
        });
        _this2.close();
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.buttonClicked = false;
      this.resetForm();
      this.isOpen = false;
    },
    resetForm: function resetForm() {
      this.FWPlacementID = null;
      this.requestName = null;
      this.startDate = null;
      this.endDate = null;
      this.startDateMenu = false;
      this.endDateMenu = false;
      this.$refs.requestName.resetValidation();
      this.$refs.placementId.resetValidation();
    }
  },
  watch: {
    value: function value(val) {
      this.isOpen = val;
    },
    isOpen: function isOpen(newVal) {
      if (newVal) {
        this.open();
      }
      this.$emit('input', newVal);
    }
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_positiveityIndicator__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_xFlag__ = __webpack_require__(767);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PositiveityIndicator: __WEBPACK_IMPORTED_MODULE_1__components_common_positiveityIndicator__["b" /* PositiveityIndicator */],
    OvalButton: __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__["a" /* OvalButton */],
    XFlag: __WEBPACK_IMPORTED_MODULE_3__components_common_xFlag__["a" /* default */]
  },
  props: {
    label: {
      type: String,
      required: true
    },
    audience: {
      type: Number,
      required: true
    },
    currentAudience: {
      type: Number,
      required: true
    },
    isCurrentBranch: {
      type: Boolean,
      default: false
    },
    goto: {
      type: Function,
      default: function _default() {}
    },
    deleteBranch: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    totalAudience: function totalAudience() {
      return 'Total Audience: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["p" /* formatSmallNumber */])(String(this.audience));
    },
    changeInAudience: function changeInAudience() {
      return this.audience - this.currentAudience;
    },
    changeInAudienceMessage: function changeInAudienceMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["p" /* formatSmallNumber */])(String(Math.abs(this.changeInAudience)));
    }
  }
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_positiveityIndicator__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__ = __webpack_require__(126);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PositiveityIndicator: __WEBPACK_IMPORTED_MODULE_0__components_common_positiveityIndicator__["b" /* PositiveityIndicator */],
    OvalButton: __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__["a" /* OvalButton */]
  },
  props: {
    move: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    target_data: {
      type: Object,
      required: true
    },
    currentAudience: {
      type: Number,
      default: 0
    },
    isCurrentRevision: {
      type: Boolean,
      default: false
    },
    goto: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    audience: function audience() {
      return this.target_data.audienceSize;
    },
    totalAudience: function totalAudience() {
      return 'Total Audience: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["m" /* smallNumber */])(String(this.audience));
    },
    revisionText: function revisionText() {
      return 'Move ' + String(this.move) + ': ' + this.label;
    },
    changeInAudience: function changeInAudience() {
      return this.audience - this.currentAudience;
    },
    changeInAudienceMessage: function changeInAudienceMessage() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["m" /* smallNumber */])(String(Math.abs(this.changeInAudience)));
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RevisionHistory__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RevisionHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RevisionHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Branch__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_positiveityIndicator__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_scrollPanel__ = __webpack_require__(41);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RevisionHistory: __WEBPACK_IMPORTED_MODULE_0__RevisionHistory___default.a,
    Branch: __WEBPACK_IMPORTED_MODULE_1__Branch___default.a,
    OvalLabel: __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__["b" /* OvalLabel */],
    PositiveCircle: __WEBPACK_IMPORTED_MODULE_3__components_common_positiveityIndicator__["a" /* PositiveCircle */],
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_4__components_common_scrollPanel__["a" /* default */]
  },
  props: {
    branches: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    revisionHistories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedBranch: {
      type: String
    },
    selectedRevision: {
      type: String
    },
    onClickRevisionHistory: {
      type: Function,
      default: function _default() {}
    },
    onClickBranch: {
      type: Function,
      default: function _default() {}
    },
    currentAudience: {
      type: Number,
      default: 0
    },
    createNewBranch: {
      type: Function,
      required: true
    },
    heightOfBranches: {
      type: Number,
      default: 200
    },
    heightOfRevisions: {
      type: Number,
      default: 300
    },
    deleteBranch: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    currentBranch: function currentBranch() {
      var _this = this;

      return this.branches.find(function (b) {
        return b.id === _this.selectedBranch;
      });
    },
    currentBranchLabel: function currentBranchLabel() {
      return 'Current Version: ' + this.currentBranch.label;
    }
  }
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RevisionHistoryPanel__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RevisionHistoryPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RevisionHistoryPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_revisionHistory_store_actions__ = __webpack_require__(103);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RevisionHistoryPanel: __WEBPACK_IMPORTED_MODULE_0__RevisionHistoryPanel___default.a
  },
  props: {
    onSetCurrentMove: {
      type: Function,
      default: function _default() {}
    },
    heightOfBranches: {
      type: Number,
      default: 300
    },
    heightOfRevisions: {
      type: Number,
      default: 300
    }
  },
  data: function data() {
    return {
      createBranchPopover: null
    };
  },
  computed: {
    show: function show() {
      return this.branches.length > 0 && this.currentRevisionHistories.length > 0;
    },
    currentBranch: function currentBranch() {
      return this.$store.getters.revisionHistoryCurrentBranch;
    },
    currentBranchId: function currentBranchId() {
      return this.currentBranch ? this.currentBranch.id : null;
    },
    currentRevision: function currentRevision() {
      return this.$store.getters.revisionHistoryCurrentMove;
    },
    currentRevisionHistoryId: function currentRevisionHistoryId() {
      return this.currentRevision ? this.currentRevision.id : null;
    },
    currentRevisionHistories: function currentRevisionHistories() {
      return this.currentBranch ? this.currentBranch.histories : [];
    },
    branches: function branches() {
      return this.$store.getters.revisionHistoryBranches;
    },
    currentAudience: function currentAudience() {
      return this.$store.getters.audienceSize ? this.$store.getters.audienceSize : 0;
    }
  },
  methods: {
    clickRevisionHistory: function clickRevisionHistory(rh) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_revisionHistory_store_actions__["a" /* SET_CURRENT_MOVE */], rh);
      this.onSetCurrentMove(rh);
    },
    clickBranch: function clickBranch(branch) {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_revisionHistory_store_actions__["b" /* SET_CURRENT_BRANCH */], branch).then(function (revision) {
        _this.onSetCurrentMove(revision);
      });
    },
    createNewBranch: function createNewBranch(label) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_revisionHistory_store_actions__["c" /* CREATE_NEW_BRANCH */], {
        label: label,
        targetId: this.$store.getters.currentTarget.id,
        audience: this.currentAudience
      });
    },
    createNewBranchPopover: function createNewBranchPopover(e) {
      var popoverIsDestroyed = this.createBranchPopover ? this.createBranchPopover._isDestroyed : true;
      if (popoverIsDestroyed) {
        this.createBranchPopover = __WEBPACK_IMPORTED_MODULE_1__components_common_popover__["a" /* PopoverFactory */].createCustomPopover({
          direction: 'bottom',
          parent: e.currentTarget,
          colorTheme: 'black',
          popover: __WEBPACK_IMPORTED_MODULE_1__components_common_popover__["d" /* Forms */].InputForm,
          onSubmit: this.createNewBranch,
          formLabel: 'Version Label'
        });
      }
    },
    deleteBranch: function deleteBranch(b) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_revisionHistory_store_actions__["d" /* DELETE_BRANCH */], b);
    }
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_CampaignQuarterSelect__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_CampaignQuarterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_CampaignQuarterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_DemoId__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_DemoId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_DemoId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_conversions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_U_D__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__ = __webpack_require__(3);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MVPD: __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD___default.a,
    CampaignQuarterSelect: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_CampaignQuarterSelect___default.a,
    DemoId: __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_DemoId___default.a
  },
  data: function data() {
    return {
      audience: {},
      destinations: [],
      isLoading: true,
      destinationWidth: '76px',
      height: 445,
      MVPDs: [],
      ue: null,
      mrm_id: null,
      isMounted: false,
      fetchPromise: null,
      UERules: [function (value) {
        return value && !isNaN(value) || value === '' || 'Enter only numeric values';
      }, function (value) {
        return value && value >= 1000000 || 'Min value 1000000';
      }, function (value) {
        return value && value <= 310000000 || 'Max value 310000000';
      }],
      mrmIdRules: [function (value) {
        return value && !isNaN(value) || value === '' || 'Enter only numeric values';
      }],
      isMrmIdUpdated: false,
      isUeUpdated: false,
      showUpdate: false,
      digitalDestinations: [__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP],
      foresiteMetadata: {
        pid_file_name: null,
        demo_id: null,
        flight_from: null,
        flight_to: null,
        lake5_name: null,
        quarter_matched_to: null,
        campaign_quarter: null,
        lake5_notes: null
      },
      demoIdRules: [function (value) {
        return value && !isNaN(value) || value === '' || 'Numeric values only';
      }],
      notesRules: [function (value) {
        return (value || '').length <= 100 || 'Description must be 100 characters or less';
      }],
      isForesiteMetadataUpdated: false,
      videoampMetadata: {
        campaign_quarter: null,
        advertiser: null,
        videoamp_id: null,
        currency: 'VideoAmp',
        deal_number: null,
        demo_id: null
      }
    };
  },
  beforeMount: function beforeMount() {
    this.initializeMVPDs();
  },
  mounted: function mounted() {
    if (this.isMounted || this.fetchPromise) {
      return;
    }

    this.isMounted = true;
    this.fetchAudienceData();
  },
  beforeDestroy: function beforeDestroy() {
    this.isMounted = false;
  },

  computed: {
    buttonLabel: function buttonLabel() {
      return this.showForesiteMetadata ? 'submit' : 'update';
    },
    advertiserName: function advertiserName() {
      return this.audience.advertiser && this.audience.advertiser.Name || '';
    },
    viewingStream: function viewingStream() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__appLogic_targets_conversions__["d" /* convertViewingStreamFullName */])(this.audience.viewing_stream || '');
    },
    frequency: function frequency() {
      return this.audience.xandr_data && this.audience.xandr_data.frequency || null;
    },
    exportDayOfWeek: function exportDayOfWeek() {
      if (this.audience.xandr_data && this.audience.xandr_data.exportDayOfWeek !== undefined) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["s" /* EXPORT_DAY_OF_WEEK */]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var d = _step.value;

            if (d.value === this.audience.xandr_data.exportDayOfWeek) {
              return d.Name;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return null;
    },
    campaignName: function campaignName() {
      return this.audience.xandr_data && this.audience.xandr_data.campaign && this.audience.xandr_data.campaign.campaignName || null;
    },
    showDestinations: function showDestinations() {
      return this.destinations && this.destinations.length > 0;
    },
    isFlightDatesNotNull: function isFlightDatesNotNull() {
      return this.audience.am_data && this.audience.am_data.flightStartDate && this.audience.am_data.flightEndDate;
    },
    flightStartDate: function flightStartDate() {
      if (this.audience.am_data && this.audience.am_data.flightStartDate) {
        return this.audience.am_data.flightStartDate.split('T')[0];
      }
      return '';
    },
    flightEndDate: function flightEndDate() {
      if (this.audience.am_data && this.audience.am_data.flightEndDate) {
        return this.audience.am_data.flightEndDate.split('T')[0];
      }
      return '';
    },
    isLasActivatedAndNoUE: function isLasActivatedAndNoUE() {
      return this.audience.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS && this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED && !this.audience.audience_size;
    },
    hasDigitalDestinations: function hasDigitalDestinations() {
      var _this = this;

      return this.audience && this.digitalDestinations.some(function (a) {
        return _this.audience.destinations.includes(a);
      });
    },
    isDigitalTarget: function isDigitalTarget() {
      return this.audience && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.$store.getters.getC360Datasources).includes(this.audience.target_datasource);
    },
    showForesiteMetadata: function showForesiteMetadata() {
      return this.hasForesiteDestination && (this.isLiveStatus || this.isFailedStatus);
    },
    hasForesiteDestination: function hasForesiteDestination() {
      return this.audience && this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE);
    },
    hasLake5Destination: function hasLake5Destination() {
      return this.audience && this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5);
    },
    hasDemoId: function hasDemoId() {
      return this.audience && this.audience.metadata && this.audience.metadata.foresite && this.audience.metadata.foresite.demo_id;
    },
    showVideoampMetadata: function showVideoampMetadata() {
      return this.audience && this.audience.metadata.videoamp;
    },
    isLiveStatus: function isLiveStatus() {
      return this.audience && this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    },
    isWorkingStatus: function isWorkingStatus() {
      return this.audience && this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
    },
    isFailedStatus: function isFailedStatus() {
      return this.audience && this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED;
    },

    universeEstimate: {
      get: function get() {
        return this.ue;
      },
      set: function set(newValue) {
        if (!isNaN(newValue) && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(parseFloat(newValue)) && newValue >= 1000000 && newValue <= 310000000) {
          this.ue = newValue;
          this.isUeUpdated = true;
        } else {
          this.ue = newValue;
          this.isUeUpdated = false;
        }
      }
    },
    showUEHoverOver: function showUEHoverOver() {
      return this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED || this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED || this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE || this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED;
    },
    originalMrmId: function originalMrmId() {
      if (!this.audience.xandr_data.external) {
        return null;
      }
      var canoeExternal = this.audience.xandr_data.external.find(function (dest) {
        return dest.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_LINEAR || dest.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_VOD;
      });
      return canoeExternal ? canoeExternal.externalID : '';
    },

    mrmId: {
      get: function get() {
        return this.mrm_id;
      },
      set: function set(newValue) {
        if (this.originalMrmId !== newValue && !isNaN(newValue) && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(parseFloat(newValue))) {
          this.mrm_id = newValue;
          this.isMrmIdUpdated = true;
        } else {
          this.mrm_id = newValue;
          this.isMrmIdUpdated = false;
        }
      }
    },
    showMrmId: function showMrmId() {
      return this.hasCanoeDestination && (this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED || this.audience.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED);
    },
    showBroadcastQuarter: function showBroadcastQuarter() {
      return (this.audience.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID || this.audience.target === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS) && this.audience.target_definition && this.audience.target_definition.broadcastQuarter;
    },
    broadcastQuarter: function broadcastQuarter() {
      return this.audience.target_definition && this.audience.target_definition.broadcastQuarter ? this.audience.target_definition.broadcastQuarter.replace('_', ' ') : '';
    },
    demoQualifier: function demoQualifier() {
      return this.audience.metadata && this.audience.metadata.foresite && this.audience.metadata.foresite.demoQualifier ? this.audience.metadata.foresite.demoQualifier : '';
    },
    isEveryForesiteMetadataUpdated: function isEveryForesiteMetadataUpdated() {
      var _this2 = this;

      var foresiteMetaDataKeys = ['demo_id', 'flight_from', 'flight_to', 'lake5_name', 'campaign_quarter'];
      return foresiteMetaDataKeys.every(function (key) {
        return _this2.foresiteMetadata.hasOwnProperty(key) && _this2.foresiteMetadata[key] !== null && _this2.foresiteMetadata[key] !== '';
      });
    },
    isEveryVideoampMetadataUpdated: function isEveryVideoampMetadataUpdated() {
      var _this3 = this;

      var videoampMetaDataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.videoampMetadata);
      return videoampMetaDataKeys.every(function (key) {
        return _this3.videoampMetadata.hasOwnProperty(key) && _this3.videoampMetadata[key] !== null && _this3.videoampMetadata[key] !== '';
      });
    },
    isVideoampMetadataUpdated: function isVideoampMetadataUpdated() {
      var _this4 = this;

      var videoampMetaDataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.videoampMetadata);
      var isVideoampMetadataUpdated = videoampMetaDataKeys.find(function (key) {
        return _this4.videoampMetadata[key] !== null && _this4.audience.metadata.videoamp && _this4.audience.metadata.videoamp[key] !== null && _this4.videoampMetadata[key] !== _this4.audience.metadata.videoamp[key];
      });
      return isVideoampMetadataUpdated;
    },
    pidFileName: function pidFileName() {
      return this.audience.metadata && this.audience.metadata.foresite && this.audience.metadata.foresite.pid_file_name || null;
    },
    campaignQuarterOptions: function campaignQuarterOptions() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_U_D__["f" /* getCampaignQuarters */])();
    },
    flightToOptions: function flightToOptions() {
      var flightFrom = this.foresiteMetadata.flight_from;
      var flightTo = this.foresiteMetadata.flight_to;
      if (!flightFrom) {
        return;
      }
      if (flightTo) {
        if (flightFrom.substring(2).localeCompare(flightTo.substring(2)) > 0 || flightFrom.substring(2).localeCompare(flightTo.substring(2)) === 0 && flightFrom.substring(0, 2).localeCompare(flightTo.substring(0, 2)) > 0) {
          this.foresiteMetadata.flight_to = '';
        }
      }
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_U_D__["f" /* getCampaignQuarters */])().filter(function (x) {
        var yearDiff = x.value.substring(2).localeCompare(flightFrom.substring(2));
        if (yearDiff === 0) {
          if (x.value.substring(0, 2).localeCompare(flightFrom.substring(0, 2)) >= 0) {
            return true;
          }
        } else if (yearDiff > 0) {
          return true;
        }
      });
      return options;
    },
    hasPublishPermissions: function hasPublishPermissions() {
      return this.$store.getters.hasPublishPermissions;
    },
    canUpdate: function canUpdate() {
      if (this.foresiteMetadata && this.foresiteMetadata.lake5_notes && this.foresiteMetadata.lake5_notes.length > 100) {
        return false;
      }
      if (this.isFailedStatus) return false;
      return this.hasPublishPermissions && (this.isMrmIdUpdated || this.isUeUpdated || this.isForesiteMetadataUpdated || this.isVideoampMetadataUpdated);
    },
    hasCanoeDestination: function hasCanoeDestination() {
      return this.audience && (this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR) || this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD));
    },
    oarUE: function oarUE() {
      if (this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO)) {
        var vizioDestination = this.audience.xandr_data && this.audience.xandr_data.icd38 && this.audience.xandr_data.icd38.find(function (x) {
          return x.destinationID === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["w" /* DESTINATIONS_ID */].VIZIO;
        });
        return vizioDestination && vizioDestination['ueSize'] || 0;
      }
    },
    dtvUE: function dtvUE() {
      if (this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV)) {
        var dtvExternal = this.audience.xandr_data && this.audience.xandr_data.external ? this.audience.xandr_data.external.find(function (dest) {
          return dest.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].DIRECTV;
        }) : null;
        return dtvExternal && dtvExternal.universeEstimates || 0;
      }
    },
    canoeVodUE: function canoeVodUE() {
      if (this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD)) {
        var canoeVodExternal = this.audience.xandr_data && this.audience.xandr_data.external ? this.audience.xandr_data.external.find(function (dest) {
          return dest.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_VOD;
        }) : null;
        return canoeVodExternal && canoeVodExternal['universeEstimates'] || 0;
      }
    },
    canoeLinearUE: function canoeLinearUE() {
      if (this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR)) {
        var canoeLinearExternal = this.audience.xandr_data && this.audience.xandr_data.external ? this.audience.xandr_data.external.find(function (dest) {
          return dest.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_LINEAR;
        }) : null;
        return canoeLinearExternal && canoeLinearExternal['universeEstimates'] || 0;
      }
    }
  },
  methods: {
    initializeMVPDs: function initializeMVPDs() {
      try {
        if (this.$store && this.$store.state && this.$store.state.createTarget) {
          this.MVPDs = this.$store.state.createTarget.mvpds || [];
        } else {
          this.MVPDs = [];
        }
      } catch (error) {
        console.warn('Failed to initialize MVPDs:', error);
        this.MVPDs = [];
      }
    },
    fetchAudienceData: function fetchAudienceData() {
      var _this5 = this;

      this.fetchPromise = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__["y" /* FETCH_SINGLE_AUDIENCE */], this.params.data).then(this.handleAudienceDataSuccess).catch(this.handleAudienceDataError).finally(function () {
        _this5.fetchPromise = null;
      });
    },
    handleAudienceDataSuccess: function handleAudienceDataSuccess(audienceData) {
      if (!this.isMounted) {
        return;
      }

      try {
        this.audience = Array.isArray(audienceData) ? audienceData[0] : audienceData;
        this.destinationWidth = '76px';

        this.setupDestinations();
        this.setupMVPDData();
        this.setupMetadata();
        this.setupUpdateFlags();

        this.ue = this.audience.audience_size;
        this.isLoading = false;
      } catch (error) {
        console.error('Error processing audience data:', error);
        this.isLoading = false;
      }
    },
    handleAudienceDataError: function handleAudienceDataError(error) {
      if (this.isMounted) {
        console.error('Error fetching audience data:', error);
        this.isLoading = false;
      }
    },
    setupDestinations: function setupDestinations() {
      var _this6 = this;

      this.destinations = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["q" /* DESTINATION_OBJECTS */].filter(function (d) {
        if (_this6.audience.destinations && _this6.audience.destinations.includes(d.id)) {
          return d.id;
        }
      });
    },
    setupMVPDData: function setupMVPDData() {
      var _this7 = this;

      if (!this.MVPDs || this.MVPDs.length === 0) {
        this.initializeMVPDs();
      }

      if (this.audience.xandr_data && this.audience.xandr_data.external && this.MVPDs.length > 0) {
        var canoeLinearMVPD = this.MVPDs.find(function (mvpd) {
          return mvpd && mvpd.Name === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_LINEAR;
        });
        var canoeVodMVPD = this.MVPDs.find(function (mvpd) {
          return mvpd && mvpd.Name === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_VOD;
        });

        if (this.audience.xandr_data.external) {
          this.audience.xandr_data.external.forEach(function (destination) {
            if (canoeLinearMVPD && destination.endpointID === canoeLinearMVPD.Id) {
              _this7.mrm_id = destination.externalID;
            } else if (canoeVodMVPD && destination.endpointID === canoeVodMVPD.Id) {
              _this7.mrm_id = destination.externalID;
            }
          });
        }
      }
    },
    setupMetadata: function setupMetadata() {
      if (this.pidFileName && this.audience.metadata && this.audience.metadata.foresite) {
        this.foresiteMetadata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.audience.metadata.foresite);
      }
      if (this.showVideoampMetadata && this.audience.metadata && this.audience.metadata.videoamp) {
        this.videoampMetadata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.audience.metadata.videoamp);
      }
    },
    setupUpdateFlags: function setupUpdateFlags() {
      if (this.isLasActivatedAndNoUE || this.showMrmId || (this.showForesiteMetadata || this.showVideoampMetadata) && !this.hasLake5Destination) {
        this.showUpdate = true;
      }
    },
    updateAudience: function updateAudience() {
      var _this8 = this;

      if (this.isMrmIdUpdated) {
        this.isMrmIdUpdated = false;

        var externalCopy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["cloneDeep"])(this.audience.xandr_data.external);
        externalCopy.forEach(function (destination) {
          if (destination.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_LINEAR || destination.endpointName === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_VOD) {
            destination.externalID = _this8.mrm_id;
          }
        });
        this.audience.xandr_data.external = externalCopy;
        var updatedTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["cloneDeep"])(this.audience);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["r" /* saveTarget */])(updatedTarget).then(function (resp) {
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], updatedTarget);
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__["m" /* REPLACE_TARGET */], updatedTarget);
        });
      }

      if (this.isForesiteMetadataUpdated && !this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5)) {
        this.isForesiteMetadataUpdated = false;
        this.audience.metadata.foresite = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.audience.metadata.foresite, this.foresiteMetadata);
        this.audience.destinations.push(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5);
        var _updatedTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["cloneDeep"])(this.audience);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["r" /* saveTarget */])(_updatedTarget).then(function (resp) {
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], _updatedTarget);
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__["m" /* REPLACE_TARGET */], _updatedTarget);
          _this8.destinations = __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["q" /* DESTINATION_OBJECTS */].filter(function (d) {
            if (_this8.audience.destinations.includes(d.id)) {
              return d.id;
            }
          });
        }).then(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["_0" /* sendToLake5 */])(_updatedTarget);
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_15__components_common_toasts__["a" /* default */].success({
            title: 'Audience Updated',
            message: 'Audience info sent to Lake5'
          });
        });
      }

      if (this.isVideoampMetadataUpdated && !this.audience.destinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5)) {
        this.audience.metadata.videoamp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.audience.metadata.videoamp, this.videoampMetadata);

        var _updatedTarget2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["cloneDeep"])(this.audience);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["r" /* saveTarget */])(_updatedTarget2).then(function (resp) {
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_14__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], _updatedTarget2);
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__["m" /* REPLACE_TARGET */], _updatedTarget2);
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_15__components_common_toasts__["a" /* default */].success({
            title: 'Audience Updated',
            message: 'Videoamp Metadata for Audience updated'
          });
        });
      }

      if (this.isUeUpdated) {
        this.isUeUpdated = false;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__["p" /* SET_REFRESH_TABLE_FLAG */], false);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["_1" /* updateTargetUE */])({ targetId: this.audience.id, ue: this.ue }).then(function (resp) {
          __WEBPACK_IMPORTED_MODULE_15__components_common_toasts__["a" /* default */].success({
            title: 'Audience Updated',
            message: 'UE updated successfully'
          });
          _this8.$store.dispatch(__WEBPACK_IMPORTED_MODULE_13__views_audienceHub_store_actions__["p" /* SET_REFRESH_TABLE_FLAG */], true);
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_15__components_common_toasts__["a" /* default */].error({ title: 'Error updating target UE', message: err.message });
          console.log(err);
        });
      }
    },
    updateMrmID: function updateMrmID(mrmId) {
      console.log(mrmId);
    },
    canUpdateUE: function canUpdateUE() {
      return false;
    },
    getUE: function getUE(destination) {
      switch (destination.id) {
        case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV:
          return this.dtvUE;
        case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO:
          return this.oarUE;
        case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR:
          return this.canoeLinearUE;
        case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD:
          return this.canoeVodUE;
        case __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY:
          return Number(this.audience.audience_size);
        default:
          return null;
      }
    },
    getmrmId: function getmrmId(destination) {
      return '';
    }
  },
  watch: {
    isEveryForesiteMetadataUpdated: function isEveryForesiteMetadataUpdated(value) {
      this.isForesiteMetadataUpdated = value;
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_destinations_Symphony_Selected_png__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_destinations_Symphony_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_destinations_Symphony_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_destinations_Foresite_Selected_png__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_destinations_Foresite_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_destinations_Foresite_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_destinations_Lake5_Selected_png__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_destinations_Lake5_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_destinations_Lake5_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_destinations_Krux_Selected_png__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_destinations_Krux_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_destinations_Krux_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_destinations_LiveRamp_Selected_png__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_destinations_LiveRamp_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_destinations_LiveRamp_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_destinations_DirecTV_Selected_png__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_destinations_DirecTV_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_destinations_DirecTV_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_destinations_Vizio_Selected_png__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_destinations_Vizio_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_destinations_Vizio_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_destinations_Canoe_Selected_png__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_destinations_Canoe_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_destinations_Canoe_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_destinations_Canoe_VOD_Selected_png__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_destinations_Canoe_VOD_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_destinations_Canoe_VOD_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_destinations_Freewheel_Selected_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_destinations_Freewheel_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_destinations_Freewheel_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_destinations_GAM_Selected_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_destinations_GAM_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_destinations_GAM_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_destinations_Videoamp_Selected_png__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_destinations_Videoamp_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_destinations_Videoamp_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__ = __webpack_require__(3);
















/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    destinationImage: function destinationImage(destination) {
      switch (destination) {
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY:
          return __WEBPACK_IMPORTED_MODULE_0__assets_destinations_Symphony_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE:
          return __WEBPACK_IMPORTED_MODULE_1__assets_destinations_Foresite_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].LAKE5:
          return __WEBPACK_IMPORTED_MODULE_2__assets_destinations_Lake5_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX:
          return __WEBPACK_IMPORTED_MODULE_3__assets_destinations_Krux_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP:
          return __WEBPACK_IMPORTED_MODULE_4__assets_destinations_LiveRamp_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV:
          return __WEBPACK_IMPORTED_MODULE_5__assets_destinations_DirecTV_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].ATT_TV:
          return __WEBPACK_IMPORTED_MODULE_5__assets_destinations_DirecTV_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO:
          return __WEBPACK_IMPORTED_MODULE_6__assets_destinations_Vizio_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR:
          return __WEBPACK_IMPORTED_MODULE_7__assets_destinations_Canoe_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD:
          return __WEBPACK_IMPORTED_MODULE_8__assets_destinations_Canoe_VOD_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL:
          return __WEBPACK_IMPORTED_MODULE_9__assets_destinations_Freewheel_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER:
          return __WEBPACK_IMPORTED_MODULE_10__assets_destinations_GAM_Selected_png___default.a;
        case __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP:
          return __WEBPACK_IMPORTED_MODULE_11__assets_destinations_Videoamp_Selected_png___default.a;
      }
    }
  },
  computed: {
    isDestinationBlank: function isDestinationBlank() {
      return this.destination === __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants__["e" /* DESTINATIONS */].BLANK;
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_route_store_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default.a
  },
  data: function data() {
    return {
      targetTypeToAbbrev: __WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* targetTypeToAbbrev */]
    };
  },
  computed: {
    hrefURL: function hrefURL() {
      if (!this.isLASAndActivated) {
        if (this.isSalesIntent) {
          return '/#/aw/' + this.params.data.id;
        } else {
          return '/#/workbench/' + this.targetTypeToAbbrev[this.params.data.target] + '/' + this.params.data.id;
        }
      }
    },
    actionLinkClass: function actionLinkClass() {
      if (this.isCDPDatasource) {
        return 'target_name__xandr';
      } else {
        return;
      }
    },
    isNew: function isNew() {
      return this.params.data.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].NEW;
    },
    isActivated: function isActivated() {
      return this.params.data.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED;
    },
    isSubmitted: function isSubmitted() {
      return this.params.data.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED;
    },
    isPID: function isPID() {
      return this.params.data.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID;
    },
    isNpower: function isNpower() {
      return this.params.data.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER;
    },
    isComscore: function isComscore() {
      return this.params.data.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE;
    },
    isLASAndActivated: function isLASAndActivated() {
      return this.params.data.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS && this.isActivated;
    },
    isSalesIntent: function isSalesIntent() {
      return this.params.data.metadata.intents && this.params.data.metadata.intents.some(function (i) {
        return i['Name'] === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["a" /* INTENTS */]['Sales']['Name'];
      });
    },
    isLive: function isLive() {
      return this.params.data.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    },
    isATTAMNativeLAS: function isATTAMNativeLAS() {
      return this.params.data.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ATT && [__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED, __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED, __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED, __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE].includes(this.params.data.activation_status);
    },
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    C360Datasources: function C360Datasources() {
      return this.$store.getters.getC360Datasources;
    },
    isNcs: function isNcs() {
      return this.params.data.target_datasource === this.nielsenDatasources.NCS;
    },
    username: function username() {
      return this.$store.state.auth.username;
    },
    justDisplayNameOfTarget: function justDisplayNameOfTarget() {
      return [__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE_TV].includes(this.params.data.target) || [__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER, __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE, __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID].includes(this.params.data.target) && !this.isActivated;
    },
    showPostSymbol: function showPostSymbol() {
      return this.isNew && !this.isNcs && !this.isATTAMNativeLAS;
    },
    isActivatedPID: function isActivatedPID() {
      return this.isActivated && this.isPID;
    },
    isActivatedNPower: function isActivatedNPower() {
      return this.isActivated && this.isNpower;
    },
    isActivatedComscore: function isActivatedComscore() {
      return this.isActivated && this.isComscore;
    },
    isDropped: function isDropped() {
      return this.params.data.dropped;
    },
    isCDPDatasource: function isCDPDatasource() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.C360Datasources).includes(this.params.data.target_datasource);
    },
    isAddressableOrDigitalTarget: function isAddressableOrDigitalTarget() {
      return this.isCDPDatasource && (this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV) || this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO) || this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR) || this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD) || this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL) || this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER) || this.params.data.destinations.includes(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP));
    }
  },
  methods: {
    hasTargetAction: function hasTargetAction(target) {
      switch (target.target) {
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PRISM:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DNB:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MAX:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].TVE:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].EPSILON_EXPANDABLE:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DISCOVERY_PLUS:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DCR:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LIVERAMP:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].WBGAMES:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].RETARGETING:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].FREEWHEEL:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].GOOGLE_AD_MANAGER:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAL:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].DC_COMICS:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].CNN:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].MOSAIC:
          return this.isActivated;
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ATT:
          return true;
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER:
        case __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE:
          return this.isActivated;
        default:
          return false;
      }
    },
    setBackRoute: function setBackRoute() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_route_store_actions__["c" /* SET_BACK_ROUTE_OVERRIDE */], this.$router.currentRoute.path);
    },
    openWorkbench: function openWorkbench() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_route_store_actions__["c" /* SET_BACK_ROUTE_OVERRIDE */], this.$router.currentRoute.path);
      if (!this.isLASAndActivated) {
        if (this.isSalesIntent) {
          this.$router.push({ path: '/aw/' + this.params.data.id });
        } else {
          this.$router.push({
            path: '/workbench/' + this.targetTypeToAbbrev[this.params.data.target] + '/' + this.params.data.id
          });
        }
      }
    },
    openTarget: function openTarget() {
      if (this.params.data.target === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS) {
        if (!this.isActivated) {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
            target_id: this.params.data.id,
            option: this.params.data.target_datasource,
            targetAction: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE
          });
        }
      } else if (this.isATTAMNativeLAS) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
          target_id: this.params.data.id,
          option: this.nielsenDatasources.FILE,
          targetAction: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE
        });
      } else if (this.isActivatedPID) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
          target_id: this.params.data.id,
          option: this.nielsenDatasources.FILE,
          targetAction: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE
        });
      } else if (this.isActivatedNPower || this.isActivatedComscore) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_currentTarget_store_actions__["b" /* SET_SHOW_APPEND_MODAL */], { target: this.params.data });
      } else if (this.isCDPDatasource) {
        if (this.isActivated) {
          if (!this.isAddressableOrDigitalTarget) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], {
              target_id: this.params.data.id,
              option: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["l" /* LAS_TYPES */].XANDR,
              targetAction: __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE
            });
          }
        } else {
          this.$router.push({ name: 'XandrWorkbench', params: { id: this.params.data.id } });
        }
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* targetRouteHandler */])('OPEN', this.params.data);
      }
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_dataSources_AMRLD_Selected_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_dataSources_AMRLD_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_dataSources_AMRLD_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_MRI_Selected_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_MRI_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_dataSources_MRI_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Ncs_Selected_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Ncs_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Ncs_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Epsilon_Selected_png__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Epsilon_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Epsilon_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_targetImages_Audience_Matters_Target_png__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_targetImages_Audience_Matters_Target_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_targetImages_Audience_Matters_Target_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_targetImages_XandrIcon_png__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_targetImages_XandrIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_targetImages_XandrIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_targetImages_AdstraIcon_png__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_targetImages_AdstraIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_targetImages_AdstraIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_fileTypes_PID_Selected_png__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_fileTypes_PID_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_fileTypes_PID_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_fileTypes_NPower_Selected_png__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_fileTypes_NPower_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_fileTypes_NPower_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_fileTypes_Comscore_Selected_png__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_fileTypes_Comscore_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_fileTypes_Comscore_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_dataSources_Prism_Selected_png__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_dataSources_Prism_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_dataSources_Prism_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_dataSources_BYOD_Selected_png__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_dataSources_BYOD_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_dataSources_BYOD_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_dataSources_DNB_Selected_png__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_dataSources_DNB_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_dataSources_DNB_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_dataSources_Max_Selected_png__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_dataSources_Max_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_dataSources_Max_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Videoamp_Selected_png__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Videoamp_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Videoamp_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_dataSources_TVE_Selected_png__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_dataSources_TVE_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_dataSources_TVE_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_dataSources_DiscoveryPlus_Selected_png__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_dataSources_DiscoveryPlus_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_dataSources_DiscoveryPlus_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_dataSources_DCR_Selected_png__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_dataSources_DCR_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_dataSources_DCR_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_dataSources_DC_Comics_Selected_png__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_dataSources_DC_Comics_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_dataSources_DC_Comics_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_dataSources_LiveRamp_Selected_png__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_dataSources_LiveRamp_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_dataSources_LiveRamp_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_dataSources_WBGames_Selected_png__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_dataSources_WBGames_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_dataSources_WBGames_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_dataSources_Retargeting_Selected_png__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_dataSources_Retargeting_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_dataSources_Retargeting_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_destinations_Freewheel_Selected_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_destinations_Freewheel_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_destinations_Freewheel_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_destinations_GAM_Selected_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_destinations_GAM_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_destinations_GAM_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_dataSources_LAL_Selected_png__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_dataSources_LAL_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_dataSources_LAL_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_dataSources_CNN_Selected_png__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_dataSources_CNN_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_dataSources_CNN_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_dataSources_Mosaic_Selected_png__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_dataSources_Mosaic_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_dataSources_Mosaic_Selected_png__);
































/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    nielsenDatasources: function nielsenDatasources() {
      return this.$parent.$parent.nielsenDatasources;
    },
    C360Datasources: function C360Datasources() {
      return this.$parent.$parent.C360Datasources;
    }
  },
  methods: {
    targetImage: function targetImage(source) {
      var _imageMap;

      var imageMap = (_imageMap = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.AMRLD, __WEBPACK_IMPORTED_MODULE_2__assets_dataSources_AMRLD_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.MRI, __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_MRI_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.NCS, __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Ncs_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.EPSILON, __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Epsilon_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.EPSILON_EXPANDABLE, __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Epsilon_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.COMSCORE_TV, __WEBPACK_IMPORTED_MODULE_11__assets_fileTypes_Comscore_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.NIELSEN, __WEBPACK_IMPORTED_MODULE_10__assets_fileTypes_NPower_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.PID, __WEBPACK_IMPORTED_MODULE_9__assets_fileTypes_PID_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.COMSCORE, __WEBPACK_IMPORTED_MODULE_11__assets_fileTypes_Comscore_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.XANDR, __WEBPACK_IMPORTED_MODULE_7__assets_targetImages_XandrIcon_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.nielsenDatasources.FILE, __WEBPACK_IMPORTED_MODULE_7__assets_targetImages_XandrIcon_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.ADSTRA, __WEBPACK_IMPORTED_MODULE_8__assets_targetImages_AdstraIcon_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.PRISM, __WEBPACK_IMPORTED_MODULE_12__assets_dataSources_Prism_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.BYOD, __WEBPACK_IMPORTED_MODULE_13__assets_dataSources_BYOD_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.DNB, __WEBPACK_IMPORTED_MODULE_14__assets_dataSources_DNB_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.MAX, __WEBPACK_IMPORTED_MODULE_15__assets_dataSources_Max_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.VIDEOAMP, __WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Videoamp_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.TVE, __WEBPACK_IMPORTED_MODULE_17__assets_dataSources_TVE_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.DISCOVERY_PLUS, __WEBPACK_IMPORTED_MODULE_18__assets_dataSources_DiscoveryPlus_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.DCR, __WEBPACK_IMPORTED_MODULE_19__assets_dataSources_DCR_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.DC_COMICS, __WEBPACK_IMPORTED_MODULE_20__assets_dataSources_DC_Comics_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.LIVERAMP, __WEBPACK_IMPORTED_MODULE_21__assets_dataSources_LiveRamp_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.WBGAMES, __WEBPACK_IMPORTED_MODULE_22__assets_dataSources_WBGames_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.RETARGETING, __WEBPACK_IMPORTED_MODULE_23__assets_dataSources_Retargeting_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.FREEWHEEL, __WEBPACK_IMPORTED_MODULE_24__assets_destinations_Freewheel_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_25__assets_destinations_GAM_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.LAL, __WEBPACK_IMPORTED_MODULE_26__assets_dataSources_LAL_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.CNN, __WEBPACK_IMPORTED_MODULE_27__assets_dataSources_CNN_Selected_png___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_imageMap, this.C360Datasources.MOSAIC, __WEBPACK_IMPORTED_MODULE_28__assets_dataSources_Mosaic_Selected_png___default.a), _imageMap);

      if (this.params.value === __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT) {
        return __WEBPACK_IMPORTED_MODULE_7__assets_targetImages_XandrIcon_png___default.a;
      }

      return imageMap[source] || __WEBPACK_IMPORTED_MODULE_6__assets_targetImages_Audience_Matters_Target_png___default.a;
    }
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelect__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StyledSelect: __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelect___default.a
  },
  props: {
    initialValue: null,
    disabled: {
      type: Boolean,
      default: false
    },
    attributePanel: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 1
    },
    showAdvertiserId: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Advertiser'
    }
  },
  data: function data() {
    return {
      options: [],
      isLoading: false,
      search: null,
      value: null,
      isSelected: false
    };
  },
  mounted: function mounted() {
    this.setInitialValue(this.initialValue);
  },

  methods: {
    update: function update(val) {
      if (!val) {
        this.isSelected = false;
      } else {
        this.isSelected = true;
        this.$emit('update', val.Value);
      }
    },
    setInitialValue: function setInitialValue(val) {
      if (val != null && val.Advertiser_id) {
        this.value = this.showAdvertiserId ? { Name: val.Advertiser_id + ' ' + val.Name, Value: val } : { Name: val.Name, Value: val };
        this.options = [this.value];
      }
    }
  },
  watch: {
    initialValue: function initialValue(val) {
      this.setInitialValue(val);
    },
    search: function search(val) {
      var _this = this;

      if (typeof val === 'string' && val.length >= 2) {
        if (this.isLoading || this.isSelected) return;

        if (this.value && this.value.Name === val) return;

        this.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["V" /* searchAdvertisers */])(val).then(function (resp) {
          var sortedResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(resp.data, function (obj) {
            return obj.Name;
          }).filter(function (obj) {
            return !!obj.Advertiser_id;
          }).map(function (obj) {
            if (obj.Advertiser_id) {
              return _this.showAdvertiserId ? { Name: obj.Advertiser_id + ' ' + obj.Name, Value: obj } : { Name: obj.Name, Value: obj };
            }
          });
          _this.options = sortedResults;
        }).catch(function (resp) {
          _this.options = [];
        }).finally(function () {
          return _this.isLoading = false;
        });
      } else if (this.initialValue) {
        this.options = [this.initialValue];
      } else {
        this.options = [];
      }
    }
  }
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selected: {
      get: function get() {
        if (this.options) {
          this.$emit('input', this.options[0].value);
          return this.options[0];
        }
        return '';
      },
      set: function set(newVal) {
        this.$emit('input', newVal);
      }
    },
    options: function options() {
      var dateRanges = this.$store.state.appRes.dateRanges;
      var availableQuarters = [];
      var quartersMap = dateRanges.map(function (broadcastMonth) {
        var _broadcastMonth$name$ = broadcastMonth['name'].split('-'),
            _broadcastMonth$name$2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_broadcastMonth$name$, 2),
            year = _broadcastMonth$name$2[0],
            month = _broadcastMonth$name$2[1];

        return year + '_Q' + Math.ceil(month / 3);
      });

      var quarterValuesCount = this.countSameValues(quartersMap);

      for (var q in quarterValuesCount) {
        if (quarterValuesCount[q] === 3) {
          availableQuarters.push({ name: q, value: q });
        }
      }
      availableQuarters.sort(function (a, b) {
        return a.name > b.name ? -1 : 1;
      });
      return availableQuarters;
    }
  },
  methods: {
    countSameValues: function countSameValues(arr) {
      var count = {};

      for (var i = 0; i < arr.length; i++) {
        var value = arr[i];

        if (!count.hasOwnProperty(value)) {
          count[value] = 1;
        } else {
          count[value]++;
        }
      }

      return count;
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StyledSelect: __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel___default.a
  },
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionSet: {
      type: Array,
      default: null
    }
  },
  computed: {
    options: function options() {
      var optionValues = [{ Name: 'Create New Campaign', value: 'newCampaign' }];
      if (this.optionSet) {
        this.optionSet.forEach(function (campaign) {
          if (campaign) {
            optionValues.push({ Name: campaign.campaignName, value: campaign.campaignId });
          }
        });
      }
      return optionValues;
    }
  },
  methods: {
    clear: function clear() {
      this.$refs.select.clear();
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: null,
    size: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: this.initialValue || '',
      isLoading: false,
      isSelected: false,
      search: null,
      sortedOptions: []
    };
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_createTarget_store_actions__["m" /* GET_DEMOS */]);
  },

  computed: {
    comscoreOptions: function comscoreOptions() {
      var demos = this.$store.state.createTarget.demos;
      var options = [];
      demos.forEach(function (d) {
        options.push({ Name: d.demo_name, value: d });
      });
      return options.sort(function (a, b) {
        if (a.Name < b.Name) return -1;
        if (a.Name > b.Name) return 1;
        return 0;
      });
    }
  },
  methods: {
    clear: function clear() {
      this.$refs.select.clear();
    }
  },
  watch: {
    search: function search(val) {
      if (typeof val === 'string') {
        if (this.isLoading || this.isSelected) return;

        this.isLoading = true;
        var sortedResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["sortBy"])(this.comscoreOptions, function (obj) {
          return obj.Name;
        });
        this.sortedOptions = sortedResults;
        this.isLoading = false;
      }
    },
    comscoreOptions: function comscoreOptions() {
      var sortedResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["sortBy"])(this.comscoreOptions, function (obj) {
        return obj.Name;
      });
      this.sortedOptions = sortedResults;
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StyledSelect: __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel___default.a
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: this.value || 0
    };
  },

  computed: {
    options: function options() {
      return __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["s" /* EXPORT_DAY_OF_WEEK */];
    }
  },
  methods: {
    clear: function clear() {
      this.$refs.select.clear();
    }
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionModal: __WEBPACK_IMPORTED_MODULE_0__components_common_modal__["a" /* ActionModal */]
  },
  computed: {
    currentTarget: function currentTarget() {
      return this.$store.state.currentTarget.currentTarget;
    },
    showModal: function showModal() {
      return this.$store.state.currentTarget.showDeleteModal;
    }
  },
  methods: {
    open: function open() {
      this.$refs.modal.open();
    },
    close: function close() {
      this.$refs.modal.close();
    },
    deleteTarget: function deleteTarget() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_targets_currentTarget_store_actions__["F" /* DELETE_CURRENT_TARGET */]);
    }
  },
  watch: {
    showModal: function showModal(value) {
      if (value) {
        this.open();
      }
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var MIN_AGE = 18;
var MAX_AGE = 99;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      genderOptions: ["M", "F"],
      gender: null,
      ageFrom: MIN_AGE,
      ageTo: MAX_AGE,
      errorMessage: null,
      valid: true,
      info: false,
      infoMessage: null,
      infoMessageCounter: 100,
      infoMessageInterval: null
    };
  },
  mounted: function mounted() {
    this.setDemoQualifier();
  },

  computed: {
    validAgeRange: function validAgeRange() {
      if (this.ageFrom && this.ageTo) {
        if (this.ageFrom > this.ageTo) {
          this.errorMessage = 'Invalid Age range';
          this.valid = false;
        } else {
          this.valid = true;
        }
      } else {
        this.errorMessage = 'Age is mandatory';
        this.valid = false;
      }
      return this.valid;
    }
  },
  methods: {
    setDemoQualifier: function setDemoQualifier() {
      if (this.validAgeRange) {
        var demoQualifier = "" + (this.gender ? this.gender : 'A') + this.ageFrom + (Number(this.ageTo) === 99 ? '+' : this.ageTo);
        this.$emit('demoQualifier', demoQualifier);
      } else {
        this.$emit('demoQualifier', null);
      }
    },
    setAgeFrom: function setAgeFrom() {
      if (Number(this.ageFrom) < Number(MIN_AGE)) {
        this.ageFrom = MIN_AGE;
        this.showInfoMessage("Value reset to " + MIN_AGE);
        this.info = true;
      } else if (Number(this.ageFrom) > Number(MAX_AGE)) {
        this.ageFrom = MAX_AGE;
        this.showInfoMessage("Value reset to " + MAX_AGE);
      } else {
        this.resetInfoMessage();
      }
      this.setDemoQualifier();
    },
    setAgeTo: function setAgeTo() {
      if (Number(this.ageTo) > Number(MAX_AGE)) {
        this.ageTo = MAX_AGE;
        this.showInfoMessage("Value reset to " + MAX_AGE);
      } else if (Number(this.ageTo) < Number(MIN_AGE)) {
        this.ageTo = MIN_AGE;
        this.showInfoMessage("Value reset to " + MIN_AGE);
      } else {
        this.resetInfoMessage();
      }
      this.setDemoQualifier();
    },
    resetInfoMessage: function resetInfoMessage() {
      this.infoMessage = null;
      this.info = false;
    },
    showInfoMessage: function showInfoMessage(msg) {
      var _this = this;

      this.info = true;
      this.infoMessage = "" + msg;
      this.infoMessageCounter = 100;
      this.infoMessageInterval = setInterval(function () {
        _this.infoMessageCountdown();
      }, 50);
    },
    infoMessageCountdown: function infoMessageCountdown() {
      if (this.infoMessageCounter === 0) {
        this.infoMessage = null;
        this.info = false;
        clearInterval(this.infoMessageInterval);
      } else {
        this.infoMessageCounter -= 2;
      }
    }
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_common_modal__["b" /* default */],
    SvgIcon: __WEBPACK_IMPORTED_MODULE_5__components_common_svgIcon__["a" /* default */],
    LoadingDots: __WEBPACK_IMPORTED_MODULE_6__components_common_loaderDots__["a" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_7__components_common_actionButton__["a" /* default */]
  },
  props: {
    title: String,
    svg: Object
  },
  data: function data() {
    return {
      load: false,
      localPidLists: []
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.currentTarget.isLoading;
    },
    pidLists: function pidLists() {
      return this.$store.getters.pidLists;
    },
    target: function target() {
      return this.$store.getters.currentTarget;
    },
    showModal: function showModal() {
      return this.$store.state.currentTarget.showDownloadPidListModal;
    },
    hasPidLists: function hasPidLists() {
      return this.pidLists > [];
    },
    buttonClickable: function buttonClickable() {
      return this.localPidLists.findIndex(function (l) {
        return l.selected;
      }) > -1;
    },
    selectedPidLists: function selectedPidLists() {
      return this.localPidLists.filter(function (l) {
        return l.selected;
      });
    }
  },
  methods: {
    close: function close() {
      this.$refs.modal.close();
    },
    open: function open() {
      this.$refs.modal.open();
    },
    onClose: function onClose() {
      this.localPidLists = [];
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__["E" /* RESET_TARGET_PID_LISTS */]);
      this.close();
    },
    onSelectAll: function onSelectAll(e) {
      this.localPidLists = this.localPidLists.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, l, { selected: e.target.checked });
      });
    },
    getFileExtension: function getFileExtension(filename) {
      return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
    },
    download: function download() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, l;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.selectedPidLists);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 12;
                  break;
                }

                l = _step.value;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api__["_2" /* downloadFile */])(l.downloadUrl, _this.target.display_name + '_' + l.suffix);

              case 9:
                _iteratorNormalCompletion = true;
                _context.next = 5;
                break;

              case 12:
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
                _this.onClose();

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
      }))();
    }
  },
  watch: {
    showModal: function showModal(value) {
      if (value) {
        this.open();
      }
    },
    pidLists: function pidLists(value) {
      var _this2 = this;

      if (value > []) {
        this.localPidLists = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["cloneDeep"])(value);
      }
      this.localPidLists.forEach(function (l) {
        try {
          var regex = /year_month=([^&]+)(?=\/)/;
          var expected = /^\d{4}_\d{2}./;
          var fileExt = _this2.getFileExtension(l.name);
          l.suffix = expected.test(l.name) ? l.name : l.key.match(regex)[1] + '.' + fileExt;
        } catch (e) {
          l.suffix = l.name;
        }
      });
    },
    loading: function loading(value) {
      this.load = value;
    }
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__ = __webpack_require__(3);





var ONE_TIME = { Name: 'One Time', value: __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["o" /* FREQUENCIES */].ONE_TIME };
var WEEKLY = { Name: 'Weekly', value: __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["o" /* FREQUENCIES */].WEEKLY };
var MONTHLY = { Name: 'Monthly', value: __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY };
var QUARTERLY = { Name: 'Quarterly', value: __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["o" /* FREQUENCIES */].QUARTERLY };

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StyledSelect: __WEBPACK_IMPORTED_MODULE_0__components_common_dropDownList_StyledSelectVModel___default.a
  },
  props: {
    initialValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionSet: {
      type: Number,
      default: null
    }
  },
  computed: {
    selected: {
      get: function get() {
        return this.initialValue || '';
      },
      set: function set(newVal) {}
    },
    options: function options() {
      switch (this.optionSet) {
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].ADSTRA:
          return [MONTHLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].DIGITAL:
          return [WEEKLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].VIZIO:
          return [WEEKLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].DIRECTV:
          return [ONE_TIME];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].CANOE_LINEAR:
          return [WEEKLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].CANOE_VOD:
          return [WEEKLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].LINEAR:
          return [ONE_TIME, QUARTERLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].XANDR_SOCIAL_DIGITAL:
          return [WEEKLY];
        case __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].VIDEOAMP:
          return [ONE_TIME];
        default:
          return [ONE_TIME, WEEKLY, MONTHLY, QUARTERLY];
      }
    }
  },
  methods: {
    clear: function clear() {
      this.$refs.select.clear();
    }
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    initialValue: null,
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      optionSet: [],
      selected: this.initialValue || ''
    };
  },
  created: function created() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["W" /* fetchMarketingNetworks */])().then(function (resp) {
      _this.optionSet = resp;
    });
  },

  computed: {
    options: function options() {
      var optionValues = [];
      if (this.optionSet) {
        this.optionSet.forEach(function (network) {
          optionValues.push({ Name: network.network, value: network.network });
        });
        return optionValues;
      } else {
        return [];
      }
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_forms_AppendNPowerForm__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_forms_AppendNPowerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_forms_AppendNPowerForm__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_common_modal__["b" /* default */],
    AppendNPowerForm: __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_forms_AppendNPowerForm___default.a
  },
  computed: {
    showModal: function showModal() {
      return this.$store.state.currentTarget.showAppendSegmentsModal;
    }
  },
  methods: {
    close: function close() {
      this.onClose();
      this.$refs.modal.close();
    },
    onClose: function onClose() {
      this.$refs.form.onClose();
    },
    open: function open() {
      this.$refs.modal.open();
    }
  },
  watch: {
    showModal: function showModal(value) {
      if (value) {
        this.open();
      } else {
        this.close();
      }
    }
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__ = __webpack_require__(3);




var LIVE = { Name: 'Live', value: __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LIVE };
var LSD = { Name: 'Live Same Day', value: __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD };
var C7 = { Name: 'C7', value: __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C7 };
var C3 = { Name: 'C3', value: __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3 };
var LIVE3 = { Name: 'Live + 3', value: __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LIVE3 };


var VIEWING_OPTIONS = {
  DEFAULT: 1,
  XANDR: 2,
  PID: 3,
  NPOWER: 4,
  LAS: 5,
  DIRECTV: 6,
  ALL: 7,
  NEW_AUDIENCE: 8
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    initialValue: null,
    size: {
      type: Number,
      default: 1
    },
    viewingOption: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selected: {
      get: function get() {
        return this.initialValue || '';
      },
      set: function set(newVal) {}
    },
    options: function options() {
      if (this.viewingOption === VIEWING_OPTIONS.DEFAULT || this.viewingOption === VIEWING_OPTIONS.NPOWER) {
        return [LIVE, LSD, C3, C7];
      } else if (this.viewingOption === VIEWING_OPTIONS.XANDR) {
        return [LSD, LIVE3];
      } else if (this.viewingOption === VIEWING_OPTIONS.PID) {
        return [LSD, LIVE, C3];
      } else if (this.viewingOption === VIEWING_OPTIONS.LAS) {
        return [LSD, C3, C7];
      } else if (this.viewingOption === VIEWING_OPTIONS.DIRECTV) {
        return [LSD];
      } else if (this.viewingOption === VIEWING_OPTIONS.ALL) {
        return [LIVE, LSD, LIVE3, C3, C7];
      } else if (this.viewingOption === VIEWING_OPTIONS.NEW_AUDIENCE) {
        return [LSD, C3];
      }
    }
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    initialValue: null,
    targetType: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      options: [],
      sortedOptions: [],
      isLoading: false,
      isSelected: false,
      selected: null,
      search: null
    };
  },
  mounted: function mounted() {
    this.setOptions();
  },

  methods: {
    setOptions: function setOptions() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["Y" /* getTargetsByTargetType */])({ target_type: this.targetType }).then(function (data) {
        _this.options = data.data.map(function (d) {
          return { Name: d.display_name, Value: d };
        });
      });
    },
    update: function update(val) {
      if (!val) {
        this.isSelected = false;
        var sortedResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["sortBy"])(this.options, function (obj) {
          return obj.Name;
        });
        this.sortedOptions = sortedResults;
      } else {
        this.isSelected = true;
        this.$emit('input', val ? val.Value : null);
      }
    },
    clear: function clear() {
      this.$refs.select.clear();
    }
  },
  watch: {
    targetType: function targetType() {
      this.setOptions();
    },
    initialValue: function initialValue() {
      if (this.initialValue != null) {
        this.selected = { Name: this.initialValue.display_name, Value: this.initialValue };
        this.isSelected = true;
        this.sortedOptions = [this.selected];
      }
    },
    search: function search(val) {
      if (typeof val === 'string' && val.length >= 2) {
        if (this.isLoading || this.isSelected) return;

        this.isLoading = true;
        var sortedResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["sortBy"])(this.options, function (obj) {
          return obj.Name;
        });
        this.sortedOptions = sortedResults;
        this.isLoading = false;
      }
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    target: {
      type: Object,
      default: {}
    }
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_U_D__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_U_SORT__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal__["b" /* default */],
    OvalLabel: __WEBPACK_IMPORTED_MODULE_2__components_common_ovalLabel__["b" /* OvalLabel */],
    LoaderDots: __WEBPACK_IMPORTED_MODULE_4__components_common_loaderDots__["a" /* default */]
  },
  data: function data() {
    return {
      getQuarterString: __WEBPACK_IMPORTED_MODULE_3__common_U_D__["h" /* getQuarterString */]
    };
  },

  computed: {
    showModal: function showModal() {
      return this.$store.state.currentTarget.showDroppedAttributesModal;
    },
    currentTarget: function currentTarget() {
      return this.$store.state.workbench.workbenchTarget;
    },
    droppedAttributes: function droppedAttributes() {
      var attributes = this.$store.state.currentTarget.droppedAttributes;
      var dataAttributes = attributes.map(function (qa) {
        return {
          quarter: qa.quarter.start,
          attributes: qa.attributes.map(function (a) {
            return a.parent + ' - ' + a.name;
          })
        };
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dataAttributes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var da = _step.value;

          da.attributes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_U_SORT__["a" /* sortStrings */])(da.attributes);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return dataAttributes;
    },
    loading: function loading() {
      return this.$store.state.currentTarget.isLoading;
    }
  },
  methods: {
    open: function open() {
      this.$refs.modal.open();
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["x" /* SET_TARGET_DROPPED_ATTRIBUTES */], this.currentTarget);
    },
    onClose: function onClose() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["y" /* SHOW_DROPPED_ATTRIBUTES_MODEL */], false);
      this.close();
    },
    close: function close() {
      this.$refs.modal.close();
    }
  },
  watch: {
    showModal: function showModal() {
      if (this.showModal) {
        this.open();
      }
    }
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDetails__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_common_modal__["b" /* default */],
    TargetDetails: __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDetails___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__["a" /* default */]
  },
  data: function data() {
    return {
      selectedDate: null
    };
  },

  computed: {
    showModal: function showModal() {
      return this.$store.state.currentTarget.showRePostingModel;
    },
    currentTarget: function currentTarget() {
      return this.$store.state.currentTarget.currentTarget;
    },
    hasSelectedDate: function hasSelectedDate() {
      return !this.selectedDate;
    },
    dateRanges: function dateRanges() {
      return this.$store.state.currentTarget.repostDates;
    },
    options: function options() {
      return this.dateRanges.map(function (el) {
        return {
          "name": el.name,
          "value": el.from
        };
      });
    }
  },
  methods: {
    open: function open() {
      this.$refs.modal.open();
    },
    close: function close() {
      this.$refs.modal.close();
    },
    rePostTarget: function rePostTarget() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__appLogic_targets_currentTarget_store_actions__["D" /* REPOST_TARGET */], this.selectedDate);
      this.close();
    }
  },
  watch: {
    showModal: function showModal() {
      if (this.showModal) {
        this.open();
      }
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_U_D__ = __webpack_require__(72);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    initialValue: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selected: {
      get: function get() {
        return this.initialValue || '';
      },
      set: function set(newVal) {}
    },
    campaignQuarterOptions: function campaignQuarterOptions() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_U_D__["f" /* getCampaignQuarters */])();
    }
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    initialValue: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      demoIdRules: [function (value) {
        return value && !isNaN(value) || value === '' || 'Numeric values only';
      }]
    };
  },
  computed: {
    selected: {
      get: function get() {
        return this.initialValue || '';
      },
      set: function set(newVal) {
        this.$emit('updatedDemoId', newVal);
      }
    }
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dateRange_DateFromTo__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_dateRange_DateFromTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_dateRange_DateFromTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_U_D__ = __webpack_require__(72);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DateFromTo: __WEBPACK_IMPORTED_MODULE_0__components_common_dateRange_DateFromTo___default.a
  },
  props: {
    value: {
      flightStartDate: {
        type: Date,
        default: null
      },
      flightEndDate: {
        type: Date,
        default: null
      },
      AEFlightEndDate: {
        type: Date,
        default: null
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    startIsInFuture: {
      type: Boolean,
      default: false
    },
    endIsInFuture: {
      type: Boolean,
      default: false
    },
    endIsWithin45Days: {
      type: Boolean,
      default: false
    },
    attStatus: {
      type: String,
      default: undefined
    },
    submittionDate: {
      type: Date,
      default: undefined
    },
    isSubmitted: {
      type: Boolean,
      default: false
    },
    isLive: {
      type: Boolean,
      default: false
    },
    isWorking: {
      type: Boolean,
      default: false
    },
    isActivatedStatus: {
      type: Boolean,
      default: false
    },
    originalFlightEndDate: {
      type: Date,
      default: null
    }
  },
  computed: {
    isPlanned: function isPlanned() {
      return this.isNew ? true : this.attStatus === __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["n" /* ATT_STATUS */].PLANNING;
    },
    isNew: function isNew() {
      return !this.attStatus;
    },
    isOrdered: function isOrdered() {
      return this.attStatus === __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["n" /* ATT_STATUS */].ORDERED;
    },
    startingFromDate: function startingFromDate() {
      var nextDay = new Date();
      nextDay.setDate(nextDay.getDate() + 1);
      return nextDay;
    },
    submittedAtLeastOneDayAgo: function submittedAtLeastOneDayAgo() {
      if (this.submittionDate) {
        var DAYS_OLD = 1;
        return this.submittionDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_U_D__["g" /* isAtLeastDaysOld */])(this.submittionDate, DAYS_OLD) : null;
      } else {
        return false;
      }
    },
    startDateDisable: function startDateDisable() {
      return this.disableStartDate || this.disabled;
    },
    disableStartDate: function disableStartDate() {
      if (!this.attStatus) {
        if (this.isActivatedStatus || this.isWorking) {
          return false;
        } else if ((this.isSubmitted || this.isLive) && !this.startIsInFuture) {
          return true;
        }
      } else if (this.isPlanned) {
        if (this.isNew) {
          return false;
        } else {
          if (this.submittedAtLeastOneDayAgo) {
            if (this.value.flightStartDate) {
              return !this.beforeStartFlightDate;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      } else if (this.isOrdered) {
        if (this.beforeStartFlightDate) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    beforeStartFlightDate: function beforeStartFlightDate() {
      if (this.isNew) {
        return true;
      } else {
        var today = new Date();
        return this.value.flightStartDate ? this.value.flightStartDate > today : false;
      }
    },
    endDateDisable: function endDateDisable() {
      return this.disableEndDate || this.disabled;
    },
    disableEndDate: function disableEndDate() {
      if (!this.attStatus) {
        if (this.isActivatedStatus || this.isWorking) {
          return false;
        } else if ((this.isSubmitted || this.isLive) && !(this.endIsInFuture || !this.endIsInFuture && this.endIsWithin45Days)) {
          return true;
        }
      } else if (this.isOrdered || this.isPlanned) {
        return !(this.beforeEndFlightDate || !this.endIsInFuture && this.endIsWithin45Days);
      } else {
        return true;
      }
    },
    beforeEndFlightDate: function beforeEndFlightDate() {
      if (this.isNew) {
        return true;
      } else {
        var today = new Date();
        if (!this.originalFlightEndDate) {
          return true;
        }
        return this.originalFlightEndDate ? this.originalFlightEndDate > today : false;
      }
    },
    isDisabled: function isDisabled() {
      return this.startDateDisable && this.endDateDisable;
    }
  },
  methods: {
    modifyDates: function modifyDates(val) {
      this.$emit('input', {
        flightStartDate: val.from,
        flightEndDate: val.to,
        AEFlightEndDate: val.to
      });
    }
  }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_inputs_NumberInput_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_inputs_NumberInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_inputs_NumberInput_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    NumberInput: __WEBPACK_IMPORTED_MODULE_1__components_common_inputs_NumberInput_vue___default.a
  },
  props: {
    destination: {
      type: Object,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    canUpdate: {
      type: Boolean,
      default: false
    },
    showUE: {
      type: Boolean,
      default: false
    },
    UE: {
      type: Number,
      default: 0
    },
    MRM_ID: {
      type: String,
      default: ''
    },
    minWidth: {
      type: String,
      default: '120px'
    },
    showMRM_ID: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showPopup: false,
      timer: '',
      cursorOnPopover: false,
      audience_size: 0,
      mrmId: ''
    };
  },

  methods: {
    hover: function hover() {
      var vm = this;
      this.timer = setTimeout(function () {
        vm.showPopover();
      }, 200);
    },
    hoverOut: function hoverOut() {
      var vm = this;
      clearTimeout(vm.timer);
      this.timer = setTimeout(function () {
        if (!vm.cursorOnPopover) {
          vm.closePopover();
        }
      }, 200);
    },
    hoverOnPopover: function hoverOnPopover() {
      this.cursorOnPopover = true;
    },
    hoverOffPopover: function hoverOffPopover() {
      this.cursorOnPopover = false;
      this.hoverOut();
    },
    showPopover: function showPopover() {
      this.showPopup = true;
    },
    closePopover: function closePopover() {
      this.showPopup = false;
    },
    validateNumber: function validateNumber(event) {
      var keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  },
  computed: {
    destinationImage: function destinationImage() {
      return this.selected && !this.destination.isDisabled ? this.destination.img.selected : this.destination.img.default;
    },
    UEText: function UEText() {
      return this.audience_size !== null ? 'UE: ' + Number(this.audience_size).toLocaleString('en') : 'UE: 0';
    },
    isVizio: function isVizio() {
      return this.destination.id === __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO;
    },
    isDTV: function isDTV() {
      return this.destination.id === __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV;
    },
    isCanoeLinear: function isCanoeLinear() {
      return this.destination.id === __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR;
    },
    isCanoeVOD: function isCanoeVOD() {
      return this.destination.id === __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD;
    },
    showInput: function showInput() {
      return this.selected && this.isCanoeLinear && (this.canUpdate || this.showUE);
    }
  },
  mounted: function mounted() {
    this.audience_size = this.UE;
    this.mrmId = this.MRM_ID;
  },

  watch: {
    audience_size: function audience_size(newVal, oldVal) {
      if (oldVal !== newVal && this.isCanoeLinear) {
        this.$emit('UEChanged', this.audience_size);
      }
    },
    mrmId: function mrmId(newVal, oldVal) {
      if (oldVal !== newVal && this.isCanoeLinear) {
        this.$emit('MRMIDChanged', this.mrmId);
      }
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_createTarget_components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_createTarget_components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__appComponents_targets_createTarget_components_TargetName__);






var MIN_PCT = 1;
var MAX_PCT = 99;
var TOTAL = 100;
var VALID_REGEX = /^[A-Za-z][A-Za-z0-9_]*$/;

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  components: {
    TargetName: __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_createTarget_components_TargetName___default.a
  },
  data: function data() {
    return {
      valid: false,
      segmentSplit: [],
      totalPercentage: 0,
      alert: {
        type: 'error',
        message: 'Total percentage must equal 100%'
      },
      splitNameValid: []
    };
  },

  validations: {
    segmentSplit: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2),
      $each: {
        name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], regex: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].regex('nameRegex', VALID_REGEX) },
        percentage: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["between"])(MIN_PCT, MAX_PCT) }
      }
    }
  },
  computed: {
    showSplitSegment: function showSplitSegment() {
      return this.segmentSplit.length === 0;
    },
    isTotalValid: function isTotalValid() {
      return this.segmentSplit.length > 0 ? this.totalPercentage === TOTAL : true;
    },
    isSplitSegmentsValid: function isSplitSegmentsValid() {
      return this.segmentSplit.length > 0 ? this.alert.type === 'success' && this.valid && !this.$v.$invalid && this.isTotalValid : true;
    }
  },
  methods: {
    splitSegment: function splitSegment() {
      this.segmentSplit = [{ name: '', percentage: MIN_PCT }];
      this.calculateTotal();
    },
    addSplit: function addSplit() {
      var remainingPercentage = TOTAL - this.totalPercentage;
      this.segmentSplit.push({
        name: '',
        percentage: remainingPercentage
      });
      this.calculateTotal();
    },
    removeSplit: function removeSplit(index) {
      this.segmentSplit.splice(index, 1);
      this.calculateTotal();
    },
    calculateTotal: function calculateTotal() {
      this.totalPercentage = this.segmentSplit.reduce(function (total, split) {
        return total + Number(split.percentage);
      }, 0);
    },
    setAlertMessage: function setAlertMessage() {
      var validName = this.segmentSplit.every(function (split) {
        return VALID_REGEX.test(split.name);
      });
      if (this.segmentSplit.some(function (split) {
        return split.percentage < MIN_PCT || split.percentage > MAX_PCT;
      })) {
        this.alert = { type: 'error', message: 'Percentage must be between ' + MIN_PCT + ' and ' + MAX_PCT };
      } else if (this.totalPercentage !== TOTAL) {
        this.alert = { type: 'error', message: 'Total percentage: ' + this.totalPercentage + '%' };
      } else if (this.segmentSplit.some(function (split) {
        return split.name === null || split.name === '';
      }) || !validName) {
        this.alert = { type: 'error', message: 'Invalid Name' };
      } else if (this.checkForDuplicateSplitSegmentNames()) {
        this.alert = { type: 'error', message: 'Duplicate Name' };
      } else if (this.totalPercentage === TOTAL) {
        this.alert = { type: 'success', message: 'Total percentage: ' + this.totalPercentage + '%' };
      }
    },
    checkForDuplicateSplitSegmentNames: function checkForDuplicateSplitSegmentNames() {
      var nameCounts = this.segmentSplit.reduce(function (acc, segment) {
        acc[segment.name] = (acc[segment.name] || 0) + 1;
        return acc;
      }, {});

      var duplicateNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(nameCounts).filter(function (name) {
        return nameCounts[name] > 1;
      });
      return duplicateNames.length > 0;
    },
    updateSplitNameValid: function updateSplitNameValid(index, isValid) {
      this.$set(this.splitNameValid, index, isValid);
      this.valid = this.splitNameValid.every(function (isValid) {
        return isValid;
      });
    }
  },
  watch: {
    segmentSplit: {
      deep: true,
      handler: function handler() {
        this.setAlertMessage();
        this.$emit('segmentSplit', this.segmentSplit);
      }
    },
    isSplitSegmentsValid: {
      immediate: true,
      handler: function handler(val) {
        this.$emit('valid', val);
      }
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_toasts_OneToast__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__ = __webpack_require__(3);




var _this2 = this;






var MAX_NAME_LENGTH = 100;
var MIN_NAME_LENGTH = 6;
var Toast = new __WEBPACK_IMPORTED_MODULE_5__components_common_toasts_OneToast__["a" /* default */]();

var debounce = function debounce(fn, delay) {
  var timeoutId = void 0;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fn.apply(undefined, args);

              case 3:
                result = _context.sent;

                resolve(result);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                reject(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      })), delay);
    });
  };
};

var debouncedValidateTargetName = debounce(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["p" /* validateTargetName */])({ display_name: value });

          case 2:
            response = _context2.sent;
            return _context2.abrupt('return', response);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}(), 500);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    classOverride: {
      type: String,
      default: ''
    },
    isNewTarget: {
      type: Boolean,
      default: false
    },
    attributePanel: {
      type: Boolean,
      default: false
    },
    splitSegmentName: {
      type: Boolean,
      default: false
    },
    initialValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: false
    },
    validRegex: {
      default: function _default() {
        return (/^[A-Za-z0-9_]*$/
        );
      }
    },
    validFirstCharRegex: {
      default: function _default() {
        return (/^[A-Za-z][A-Za-z0-9_]*$/
        );
      }
    },
    initialTargetAction: {
      type: String,
      default: ''
    },
    displayOverride: {
      type: String,
      default: null
    },
    validateAllNames: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      duplicateToast: null,
      display_name: this.displayOverride !== null ? this.displayOverride || '' : this.initialValue,
      nameIsValid: null,
      nameClass: null,
      isDigitalSocialDestination: false,
      currentValueFromResp: '',
      valid: false,
      outOfFocus: false,
      label: this.splitSegmentName ? 'Name' : this.attributePanel ? '' : 'Audience Name',
      dense: this.attributePanel || this.splitSegmentName,
      textClass: this.attributePanel || this.splitSegmentName ? 'left-text' : 'centered-text',
      errorMessages: [],
      lastValidatedValue: null,
      validationCache: {}
    };
  },
  mounted: function mounted() {
    this.isDigitalSocialDestination = this.$parent.isDigitalSocialDestination;
    if (this.display_name) {
      this.errorMessages = [];
      this.valid = false;
      this.validateAndEmit();
    }
  },

  computed: {
    originalTargetName: function originalTargetName() {
      return this.$store.state.currentTarget.currentTarget.display_name;
    }
  },
  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_3_vue_focus__["focus"]
  },
  watch: {
    initialValue: {
      immediate: true,
      handler: function handler(value) {
        if (this.initialTargetAction === __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE) {
          this.display_name = this.initialValue + '_COPY';
          this.$emit('updateName', this.display_name);
        } else {
          this.display_name = this.initialValue;
        }
      }
    },
    '$parent.value.destinations': function $parentValueDestinations() {
      this.isDigitalSocialDestination = this.$parent.isDigitalSocialDestination;
    }
  },
  methods: {
    handleInput: function handleInput() {
      this.errorMessages = [];
      this.valid = false;
      this.validateAndEmit();
    },
    targetNameFocusHandler: function targetNameFocusHandler(e) {
      this.outOfFocus = false;
      if (this.isNewTarget && this.display_name === this.initialValue) {
        if (this.initialTargetAction === __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE) {
          e.target.select();
        } else {
          this.$emit('updateName', this.display_name);
        }
      }
    },
    targetNameOutOfFocusHandler: function targetNameOutOfFocusHandler(e) {
      this.outOfFocus = true;
      if (this.display_name === this.lastValidatedValue && this.validationCache[this.display_name] !== undefined) {
        return;
      }
      this.errorMessages = [];
      this.valid = false;
      this.validateAndEmit();
    },
    validateAndEmit: function validateAndEmit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var validationResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$emit('updateNameIsValid', false);
                _context3.next = 3;
                return _this3.validateDisplayName(_this3.display_name);

              case 3:
                validationResult = _context3.sent;

                if (validationResult !== true) {
                  _this3.valid = false;
                  _this3.errorMessages = [validationResult];
                } else {
                  _this3.valid = true;
                  _this3.errorMessages = [];
                }
                _this3.emitInput();

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    validateDisplayName: function validateDisplayName(value) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, validationResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.disabled) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return', true);

              case 2:
                if (!(value === _this4.lastValidatedValue && _this4.validationCache[value] !== undefined)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return', _this4.validationCache[value]);

              case 4:
                if (!(!value && _this4.outOfFocus)) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt('return', 'Required');

              case 8:
                if (!(value.length > MAX_NAME_LENGTH)) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt('return', 'Max ' + MAX_NAME_LENGTH + ' characters');

              case 12:
                if (!(value.length < MIN_NAME_LENGTH)) {
                  _context4.next = 16;
                  break;
                }

                return _context4.abrupt('return', 'Must be at least ' + MIN_NAME_LENGTH + ' characters');

              case 16:
                if (!(value.length > 0 && !_this4.validRegex.test(value))) {
                  _context4.next = 20;
                  break;
                }

                return _context4.abrupt('return', 'Allowed characters are A-Z, a-z, 0-9, _');

              case 20:
                if (!(value.length > 0 && !_this4.validFirstCharRegex.test(value))) {
                  _context4.next = 24;
                  break;
                }

                return _context4.abrupt('return', 'Must start with an alphabet');

              case 24:
                if (!(value === _this4.originalTargetName && _this4.isNewTarget)) {
                  _context4.next = 28;
                  break;
                }

                return _context4.abrupt('return', '');

              case 28:
                if (!(value === _this4.initialValue && !_this4.isNewTarget && _this4.initialTargetAction !== __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE)) {
                  _context4.next = 32;
                  break;
                }

                return _context4.abrupt('return', true);

              case 32:
                if (!(value.length >= MIN_NAME_LENGTH)) {
                  _context4.next = 41;
                  break;
                }

                _context4.next = 35;
                return debouncedValidateTargetName(value);

              case 35:
                response = _context4.sent;
                validationResult = void 0;

                if (!response.data.passNameLookup) {
                  validationResult = 'Duplicate Audience Name';
                } else if (!response.data.passedPruning) {
                  validationResult = 'Invalid Characters in Audience Name';
                } else {
                  validationResult = true;
                }

                _this4.lastValidatedValue = value;
                _this4.validationCache[value] = validationResult;
                return _context4.abrupt('return', validationResult);

              case 41:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    emitInput: function emitInput() {
      this.$emit('updateNameIsValid', this.valid);
      this.$emit('updateName', this.display_name);
    }
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_radioButtons__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__ = __webpack_require__(3);





var UPLOAD_TARGET_TYPES = [{
  value: __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID,
  name: 'PID'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RadioButtons: __WEBPACK_IMPORTED_MODULE_0__components_common_radioButtons__["a" /* default */]
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onSelect: {
      type: Function,
      default: function _default() {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      targetTypes: UPLOAD_TARGET_TYPES
    };
  },

  watch: {
    value: function value() {
      this.onSelect();
    }
  }
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UploadTargetRadioButtons__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UploadTargetRadioButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UploadTargetRadioButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDDL__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDDL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDDL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TargetFormStyles__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TargetFormStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TargetFormStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_conversions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_pid_PidLogic__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_toasts__ = __webpack_require__(25);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UploadTargetRadioButtons: __WEBPACK_IMPORTED_MODULE_0__components_UploadTargetRadioButtons___default.a,
    TargetDDL: __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_components_TargetDDL___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__["a" /* default */],
    TargetFormStyles: __WEBPACK_IMPORTED_MODULE_3__TargetFormStyles___default.a
  },
  props: {
    defaultAppendOption: {
      type: String,
      default: null
    },
    defaultSelectedTarget: {
      type: Object,
      default: null
    },
    onCompleteUpload: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      target: null,
      targetTypeSelected: __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID,
      uploadFileOptions: '.csv',
      selectedFiles: null,
      uploadedFile: []
    };
  },

  computed: {
    targetType: function targetType() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__appLogic_targets_conversions__["c" /* convertTargetToTargetType */])(this.targetTypeSelected);
    },
    buttonClickable: function buttonClickable() {
      if (this.targetTypeSelected === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID && this.selectedFiles === null) {
        return false;
      }
      return this.target;
    },
    buttonClass: function buttonClass() {
      return this.buttonClickable ? 'target-form__button--active' : 'target-form__button--inactive';
    },
    isUploadDisabled: function isUploadDisabled() {
      return !this.targetTypeSelected;
    },
    isPid: function isPid() {
      return this.targetTypeSelected === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID;
    }
  },
  methods: {
    selectTargetType: function selectTargetType() {
      if (this.targetTypeSelected === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || this.targetTypeSelected === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE) {
        this.uploadFileOptions = '.xlsx,.xls';
      } else if (this.targetTypeSelected === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID) {
        this.uploadFileOptions = '.csv';
      }
    },
    onFileChange: function onFileChange(event) {
      var _this = this;

      if (event instanceof File) {
        this.selectedFiles = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_pid_PidLogic__["a" /* validatePidFile */])(event, function (valid) {
          if (valid) {
            _this.selectedFiles = [event];
          } else {
            __WEBPACK_IMPORTED_MODULE_9__components_common_toasts__["a" /* default */].error({ title: 'Error has occurred', message: 'Error: File has invalid values' });
          }
        });
      }
    },
    submitHandler: function submitHandler() {
      var _this2 = this;

      if (this.isPid) {
        var targetInfo = {
          target: this.target,
          file: this.selectedFiles[0]
        };
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["s" /* UPLOAD_TARGET_FILE */], targetInfo).then(function (res) {
          if (!res || !res.Error) {
            _this2.onCompleteUpload(_this2.target, res);
          }
        });
      } else {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_7__appLogic_targets_currentTarget_store_actions__["b" /* SET_SHOW_APPEND_MODAL */], { target: this.target, showModal: false });
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["g" /* UPLOAD_MODAL_SET_APPEND_TYPE */], __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER);
      }
    },
    refresh: function refresh() {
      this.target = null;
      this.targetTypeSelected = __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID;
      this.uploadFileOptions = '.csv';
      this.selectedFiles = null;
    }
  },
  mounted: function mounted() {
    this.targetTypeSelected = this.defaultAppendOption || this.targetTypeSelected;
    this.target = this.defaultSelectedTarget || this.target;
  },

  watch: {
    targetType: function targetType() {
      this.$refs.targetDDL.clear();
      this.selectedFiles = null;
    },
    defaultAppendOption: function defaultAppendOption() {
      this.targetTypeSelected = this.defaultAppendOption;
    },
    defaultSelectedTarget: function defaultSelectedTarget() {
      this.target = this.defaultSelectedTarget;
    }
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_radioButtons__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_targetImages_upload_svg__ = __webpack_require__(598);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */],
    LoadingDots: __WEBPACK_IMPORTED_MODULE_1__components_common_loaderDots__["a" /* default */],
    SelectSegmentModal: __WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal___default.a,
    RadioButtons: __WEBPACK_IMPORTED_MODULE_3__components_common_radioButtons__["a" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      selectedFiles: null,
      newSegmentData: null,
      isLoadingNewSegments: false,
      svg: __WEBPACK_IMPORTED_MODULE_9__assets_targetImages_upload_svg__["a" /* default */],
      fileLastUploaded: null,
      uploadedFile: null
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.state.currentTarget.isLoading || this.$store.state.createTarget.isLoading;
    },
    segments: function segments() {
      return this.$store.getters.segmentData;
    },
    target: function target() {
      return this.$store.getters.currentTarget;
    },
    acceptedFileFormat: function acceptedFileFormat() {
      if (this.target.target === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || this.target.target === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE) {
        return '.xlsx,.xls';
      } else if (this.target.target === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID) {
        return '.xlsx,.xls,.csv';
      }
    },
    buttonClickable: function buttonClickable() {
      return this.selectedFiles !== null;
    },
    buttonClass: function buttonClass() {
      return this.buttonClickable ? 'target-form__button--active' : 'target-form__button--inactive';
    }
  },
  methods: {
    clearSelectedFile: function clearSelectedFile() {
      this.uploadedFile = null;
      this.selectedFiles = null;
    },
    onFileChange: function onFileChange(event) {
      if (event instanceof File) {
        this.selectedFiles = [event];
      }
    },
    onClose: function onClose() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__["z" /* RESET_TARGET_SEGMENTS */]);
      this.clearSelectedFile();
      this.newSegmentData = null;
    },
    scrollToFileInput: function scrollToFileInput() {
      var element = this.$refs.fileUploadInput;
    },
    uploadFile: function uploadFile() {
      var _this = this;

      var file = this.selectedFiles[0];
      this.fileLastUploaded = file.name;
      var target = this.target;
      this.isLoadingNewSegments = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_createTarget_store_actions__["s" /* UPLOAD_TARGET_FILE */], { target: target, file: file, isAppend: true }).then(function (res) {
        _this.isLoadingNewSegments = false;
        if (res.Error) {
          _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__["A" /* NPOWER_TARGET_UPLOAD_FAILED */], target.id);
        } else {
          _this.newSegmentData = res.irisResponse;
        }
      });
    }
  },
  watch: {
    segments: function segments(value) {
      if (value > []) this.scrollToFileInput();
    },
    newSegmentData: function newSegmentData(value) {
      if (value) this.scrollToFileInput();
    }
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TargetName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TargetFormStyles__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TargetFormStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TargetFormStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_MarketingNetworkSelect__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_MarketingNetworkSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_MarketingNetworkSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_3__components_common_actionButton__["a" /* default */],
    TargetFormStyles: __WEBPACK_IMPORTED_MODULE_4__TargetFormStyles___default.a,
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_AdvertiserSelect___default.a,
    StreamingSelect: __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect___default.a,
    MarketingNetworkSelect: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_MarketingNetworkSelect___default.a,
    TargetName: __WEBPACK_IMPORTED_MODULE_1__components_TargetName___default.a
  },
  props: {
    targetName: {
      type: String,
      default: ''
    },
    onComplete: {
      type: Function,
      default: function _default() {
        return console.log('You lose...');
      }
    }
  },
  data: function data() {
    return {
      target: {
        destinations: [__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY],
        display_name: this.targetName,
        advertiser: null,
        target: 'audience_discovery',
        target_datasource: 'amrld',
        target_definition: {
          promotedNetworks: []
        },
        intents: []
      },
      nameIsValid: false,
      initialNetwork: null
    };
  },
  created: function created() {
    this.target.advertiser = this.$store.state.createTarget.intents && this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Marketing']['Name']) ? { Advertiser_id: '11532', Name: 'TURNER PROMOTIONS' } : null;
  },

  computed: {
    buttonClickable: function buttonClickable() {
      return this.nameIsValid && (this.hasResearchIntent || this.hasMarketingIntent && this.target.target_definition.promotedNetworks.length > 0);
    },
    buttonClass: function buttonClass() {
      return this.buttonClickable ? 'target-form__button--active' : 'target-form__button--inactive';
    },
    buttonLabel: function buttonLabel() {
      return this.isDuplicate ? 'Duplicate' : this.hasMarketingIntent ? 'Build Audience' : 'Get Started';
    },
    userPermissions: function userPermissions() {
      return this.$store.state.auth.permissions;
    },
    advertiserDropDownClass: function advertiserDropDownClass() {
      return this.hasResearchIntent ? 'create-target-form__advertiser-dropdown' : 'evenly-distributed__target-form-dropdown-select';
    },
    hasMarketingIntent: function hasMarketingIntent() {
      return this.isDuplicate ? this.target.intents && this.target.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Marketing']['Name']) : this.$store.state.createTarget.intents && this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Marketing']['Name']);
    },
    hasResearchIntent: function hasResearchIntent() {
      return this.isDuplicate ? this.target.intents && this.target.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Research']['Name']) : this.$store.state.createTarget.intents && this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Research']['Name']);
    },
    hasSalesIntent: function hasSalesIntent() {
      return this.isDuplicate ? this.target.intents && this.target.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Sales']['Name']) : this.$store.state.createTarget.intents && this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Sales']['Name']);
    },
    targetNameInitialValue: function targetNameInitialValue() {
      if (this.isDuplicate) {
        return this.originalTarget.display_name + ' COPY';
      } else {
        return '';
      }
    },
    isDuplicate: function isDuplicate() {
      return this.initialTargetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE;
    },
    initialTargetAction: function initialTargetAction() {
      return this.$store.state.createTarget.initialTargetAction;
    },
    originalTarget: function originalTarget() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$store.state.createTarget.initialTarget || this.$store.state.createTarget || {}, {
        display_name: this.targetName || (this.$store.state.createTarget.initialTarget || {}).display_name || ''
      });
    }
  },
  watch: {
    originalTarget: function originalTarget() {
      if (this.originalTarget) {
        var cp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["cloneDeep"])(this.originalTarget);
        if (this.isDuplicate) {
          cp.id = undefined;
          cp.cae_id = undefined;
          cp.activated = false;
          cp.auto_post = false;
          cp.activation_status = __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
          cp.audience_size = cp.audience_size ? cp.audience_size : 0;
          cp.intents = cp.metadata.intents ? cp.metadata.intents.map(function (intent) {
            return intent['Name'];
          }) : [];
          cp.last_posting = null;
          delete cp.created;
          delete cp.last_update;

          this.target = cp;
          if (this.target.target_definition.promotedNetworks) {
            var network = this.target.target_definition.promotedNetworks[0];
            this.initialNetwork = { Name: network, value: network };
          }
        }
      }
    }
  },
  methods: {
    handleSubmit: function handleSubmit() {
      this.target.username = this.$store.state.auth.username;
      this.target.metadata = {
        intents: this.target.intents && this.target.intents.length > 0 ? this.target.intents.map(function (i) {
          return __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */][i];
        }) : this.$store.state.createTarget.intents.map(function (i) {
          return __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */][i];
        })
      };
      if (typeof this.target.viewing_stream === 'undefined') {
        this.target.viewing_stream = __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
      }
      this.target.advertiser = this.target.advertiser ? this.target.advertiser : { Name: null };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__["q" /* CREATE_TARGET */], this.target);
    },
    selectedNetwork: function selectedNetwork(val) {
      if (val) {
        this.target.target_definition.promotedNetworks = [val];
      } else {
        this.target.target_definition.promotedNetworks = [];
      }
    }
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_components_TargetName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_StreamingSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_StreamingSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_StreamingSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__(8);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TargetName: __WEBPACK_IMPORTED_MODULE_2__appComponents_targets_createTarget_components_TargetName___default.a,
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect___default.a,
    StreamingSelect: __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_StreamingSelect___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_7__components_common_actionButton__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_common_modal__["b" /* default */],
    LoadingDots: __WEBPACK_IMPORTED_MODULE_6__components_common_loaderDots__["a" /* default */]
  },
  props: {
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    onAudienceActivation: {
      type: Function,
      default: function _default() {}
    },
    targetName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      errorMessage: '',
      modalTitle: 'New Audience',
      target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["cloneDeep"])(this.initialTarget),
      nameIsValid: false,
      buttonClicked: false,
      isLoading: false
    };
  },
  created: function created() {
    this.target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["cloneDeep"])(this.initialTarget);
  },

  computed: {
    initialTarget: function initialTarget() {
      var defaultTarget = {
        destinations: [],
        display_name: this.targetName,
        target_datasource: null,
        advertiser: null,
        target: __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS,
        username: this.$store.state.auth.username,
        viewing_stream: null,
        target_definition: {},
        metadata: {
          intents: this.$store.state.createTarget && this.$store.state.createTarget.intents ? this.$store.state.createTarget.intents.map(function (i) {
            return __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["a" /* INTENTS */][i];
          }) : []
        }
      };
      var target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultTarget, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["cloneDeep"])(this.$store.state.createTarget.initialTarget));
      return target;
    },
    originalTarget: function originalTarget() {
      return this.$store.state.createTarget.initialTarget;
    },
    initialTargetAction: function initialTargetAction() {
      return this.$store.state.createTarget.initialTargetAction;
    },
    targetCreated: function targetCreated() {
      return this.initialTarget.id !== 'undefined' && this.initialTarget.id !== null;
    },
    isNewTarget: function isNewTarget() {
      return !this.initialTarget.id;
    },
    viewingOption: function viewingOption() {
      return 8;
    },
    canActivate: function canActivate() {
      return this.nameIsValid && this.target.advertiser && !this.isDuplicating && this.$store.getters.hasPublishPermissions;
    },
    canBuildAudience: function canBuildAudience() {
      return this.nameIsValid;
    },
    isDuplicating: function isDuplicating() {
      return this.initialTargetAction === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE;
    },
    isDigitalSocialDestination: function isDigitalSocialDestination() {
      return this.target.destinations && this.target.destinations.some(function (destination) {
        return [__WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX, __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP].includes(destination);
      });
    }
  },
  methods: {
    onFile: function onFile() {
      if (this.target.display_name) {
        var initialTarget = this.$store.getters.initialTarget;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["j" /* SET_INITIAL_TARGET */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, initialTarget, { display_name: this.target.display_name }));
      }
      var nielsenDatasources = this.$store.getters.getNielsenDatasources;
      var v = nielsenDatasources.FILE;
      this.$emit('input', {
        completed: Boolean(v),
        selectedDataSource: v
      });
    },
    setAvailableDestinations: function setAvailableDestinations() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_store_actions__["h" /* SET_AVAILABLE_DESTINATIONS */], [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["g" /* ADDRESSABLE_DESTINATIONS */])));
    },
    onActivate: function onActivate() {
      this.buttonClicked = true;
      this.target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.target, { target: __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA, xandr_data: { frequency: null } });
      this.onAudienceActivation();
      this.setAvailableDestinations();
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["j" /* SET_INITIAL_TARGET */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.target));
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["h" /* SET_INITIAL_TARGET_ACTION */], __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].ACTIVATE);
    },
    onBuild: function onBuild() {
      var _this = this;

      this.buttonClicked = true;
      this.target.activation_status = this.target.activation_status && !this.isDuplicating ? this.target.activation_status : __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
      this.target.username = this.$store.state.auth.username;
      this.target.advertiser = this.target.advertiser ? this.target.advertiser : { Name: null };
      this.isLoading = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["q" /* CREATE_TARGET */], this.target).then(function (resp) {
        _this.moveToNewWorkbench(resp);
      }).catch(function (err) {
        console.error(err);
        _this.isLoading = false;
        _this.onComplete();
      });
    },
    resetAmData: function resetAmData() {
      this.target.am_data.status && (this.target.am_data.status = null);
      this.target.am_data.AEFlightEndDate && (this.target.am_data.AEFlightEndDate = null);
      this.target.am_data.AEFlightStartDate && (this.target.am_data.AEFlightStartDate = null);
      this.target.am_data.effectiveUEDate && (this.target.am_data.effectiveUEDate = null);
      this.target.am_data.submitted_timestamp && (this.target.am_data.submitted_timestamp = null);
      this.target.am_data.flightStartDate && (this.target.am_data.flightStartDate = null);
      this.target.am_data.flightEndDate && (this.target.am_data.flightEndDate = null);
      this.target.am_data.xdFlightOverlap && (this.target.am_data.xdFlightOverlap = 0);
      this.target.am_data.order && delete this.target.am_data.order;
    },
    resetXandrData: function resetXandrData() {
      delete this.target.xandr_data.campaign;
      delete this.target.xandr_data.segment;
      this.target.xandr_data.hasOwnProperty('exportDayOfWeek') && delete this.target.xandr_data.exportDayOfWeek;

      if (this.target.xandr_data.external) {
        if (this.target.xandr_data.external[0]) {
          this.target.xandr_data.external[0].externalID = '';
        }
        var newXandrExternal = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.target.xandr_data.external));
        newXandrExternal.forEach(function (endpoint) {
          if (endpoint.universeEstimates) {
            endpoint.universeEstimates = null;
          }
        });
        this.target.xandr_data.external = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newXandrExternal));
      }
    },
    onDuplicate: function onDuplicate() {
      var _this2 = this;

      this.buttonClicked = true;
      if (this.isDigitalSocialDestination) {
        this.target.viewing_stream = undefined;
      }
      this.target.id = undefined;
      this.target.cae_id = undefined;
      this.target.activated = false;
      this.target.activation_status = __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
      this.target.audience_size = 0;
      this.target.destinations = [];
      if (this.target.xandr_data) {
        this.resetXandrData();
      }
      if (this.target.am_data) {
        this.resetAmData();
      }
      this.target.username = this.$store.state.auth.username;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["r" /* DUPLICATE_TARGET */], { target: this.target, duplicate_id: this.originalTarget.id }).then(function (resp) {
        _this2.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_store_actions__["e" /* SET_TARGET_CREATE_ACTION */], __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE);
        _this2.moveToNewWorkbench(resp);
      }).catch(function (err) {
        console.error(err);
        _this2.onComplete();
      });
    },
    moveToNewWorkbench: function moveToNewWorkbench(resp) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_11__appLogic_workbench_common_store_actions__["d" /* SET_TARGET */], resp);
      this.isLoading = false;
      this.onComplete();
      this.$router.push({ name: 'NewWorkbench', params: { id: resp.id } });
    }
  },
  watch: {
    initialTarget: function initialTarget() {
      this.target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["cloneDeep"])(this.initialTarget);
    }
  }
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TargetFormUpload__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TargetFormUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TargetFormUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_audienceHub_store_actions__ = __webpack_require__(46);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TargetFormUpload: __WEBPACK_IMPORTED_MODULE_1__TargetFormUpload___default.a
  },
  props: {
    onCompleteUpload: {
      type: Function,
      default: function _default() {}
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    defaultSelectedUpload: {
      type: String,
      default: null
    },
    originalTarget: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      errorMessage: ''
    };
  },

  computed: {
    target: function target() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        display_name: '',
        target_datasource: null,
        advertiser: null,
        viewing_stream: null,
        target: this.defaultSelectedUpload,
        username: this.$store.state.auth.username,
        metadata: { intents: this.$store.state.createTarget && (this.$store.state.createTarget.intents || []).map(function (i) {
            return __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["a" /* INTENTS */][i];
          }) }
      }, this.originalTarget || {});
    }
  },
  methods: {
    handleActivateTarget: function handleActivateTarget(targetInfo) {
      var _this = this;

      var file = targetInfo.file,
          target = targetInfo.target;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__["u" /* ACTIVATE_PID_NPOWER */], { target: target, file: file }).then(function (createdTarget) {
        _this.onCompleteUpload(createdTarget);
      });
    },
    handleUpload: function handleUpload(target_info) {
      var _this2 = this;

      var file = target_info.file,
          target = target_info.target;

      if (file) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__["v" /* SUBMITTING_PID_NPOWER */], { target: target, file: file, onComplete: this.onCompleteUpload });
        this.$emit('submittedUploadFile');
      } else {
        target.target = __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE_TV;
        target.target_datasource = __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE_TV;
        target.target_type = __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].COMSCORE_TV;
        target.activation_status = __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__views_audienceHub_store_actions__["p" /* SET_REFRESH_TABLE_FLAG */], false);
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__["q" /* CREATE_TARGET */], target).then(function (createdTarget) {
          _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__views_audienceHub_store_actions__["p" /* SET_REFRESH_TABLE_FLAG */], true);
        });
        this.$emit('sentDownstream');
      }
    }
  }
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_times_circle__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_warning__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_8__components_common_actionButton__["a" /* default */]
  },
  props: {
    onCompleteSegmentUpload: {
      type: Function,
      default: function _default() {}
    },
    segmentData: { type: Object, default: function _default() {
        return { MarketDemos: [] };
      } },
    currentSegments: { type: Array, default: function _default() {
        return [];
      } },
    uploadedTargetId: String,
    uploadedTargetViewingStream: String,
    fileUploaded: String
  },
  data: function data() {
    return {
      errorMessage: 'The chosen audience segments overlap on this network(s) and quarter(s). Please see the table below for the overlaps.',
      warningMessage: ' records already exist for this audience segment on these network(s) and quarter(s). Any records in this file which overlap on a half hour will be overwritten.',
      selectedFile: null,
      marketDemoOptions: []
    };
  },
  mounted: function mounted() {
    this.setMarketDemoOptions();
  },

  computed: {
    target: function target() {
      return {
        display_name: '',
        target_datasource: null,
        advertiser: null,
        target: null,
        username: this.$store.state.auth.username
      };
    },
    marketDemoSegments: function marketDemoSegments() {
      var selected = this.marketDemoOptions.filter(function (d) {
        return d.isSelected;
      });
      var marketDemos = this.segmentData.MarketDemos;

      var segments = selected.map(function (s) {
        return marketDemos.filter(function (md) {
          return md.MarketBreak === s.marketBreak && md.Demographic === s.demographic;
        }).map(function (md) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ index: s.index }, md);
        });
      });
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* flatten */])(segments);
    },
    selectedQuarterNetworks: function selectedQuarterNetworks() {
      var quarterNetworks = {};
      this.marketDemoSegments.forEach(function (md) {
        var key = md.NetworkName + md.QuarterName;
        var quarterNet = quarterNetworks[key];
        if (!quarterNet) quarterNetworks[key] = [md.index];else {
          if (!quarterNet.includes(md.index)) quarterNet.push(md.index);
        }
      });
      return quarterNetworks;
    },
    existingQuarterNetworks: function existingQuarterNetworks() {
      var quarterNetworks = {};
      this.currentSegments.forEach(function (segment) {
        var key = segment.NetworkName + segment.QuarterName;
        quarterNetworks[key] = segment.NumberOfRecords;
      });
      return quarterNetworks;
    },
    hasDataCollisions: function hasDataCollisions() {
      var selected = this.selectedQuarterNetworks;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(selected).findIndex(function (qn) {
        return selected[qn].length > 1;
      }) > -1;
    },
    hasOverwrites: function hasOverwrites() {
      var _this = this;

      var selected = this.selectedQuarterNetworks;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(selected).findIndex(function (qn) {
        return _this.existingQuarterNetworks[qn];
      }) > -1;
    },
    overwriteCount: function overwriteCount() {
      var _this2 = this;

      var selected = this.selectedQuarterNetworks;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(selected).reduce(function (prev, curr) {
        return prev + (_this2.existingQuarterNetworks[curr] || 0);
      }, 0);
    },
    allowUpload: function allowUpload() {
      return this.marketDemoSegments > [] && !this.hasDataCollisions;
    },
    isNpower: function isNpower() {
      return this.segmentData.DataProvider === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["l" /* LAS_TYPES */].NPOWER;
    }
  },
  methods: {
    setMarketDemoOptions: function setMarketDemoOptions() {
      var marketDemoOptions = [];
      var marketDemos = this.segmentData.MarketDemos;
      marketDemos.forEach(function (demo) {
        demo.TargetAudience = true;
        if (marketDemoOptions.findIndex(function (d) {
          return d.marketBreak === demo.MarketBreak && d.demographic === demo.Demographic;
        }) > -1) return;

        marketDemoOptions.push({ marketBreak: demo.MarketBreak, demographic: demo.Demographic });
      });

      marketDemoOptions.sort(function (a, b) {
        var marketBreakA = a.marketBreak.toUpperCase();
        var marketBreakB = b.marketBreak.toUpperCase();

        if (marketBreakA < marketBreakB) return -1;
        if (marketBreakA > marketBreakB) return 1;

        var demoA = a.demographic.toUpperCase();
        var demoB = b.demographic.toUpperCase();

        if (demoA < demoB) return -1;
        if (demoA > demoB) return 1;
        return 0;
      });
      this.marketDemoOptions = marketDemoOptions.map(function (md, idx) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ index: idx }, md);
      });
    },
    uploadSegments: function uploadSegments() {
      var _this3 = this;

      var username = this.$store.state.auth.username;
      var UploadedDateTime = new Date().toISOString();

      var remainingCurrentMarketDemos = this.currentSegments.filter(function (md) {
        var key = md.NetworkName + md.QuarterName;
        return _this3.selectedQuarterNetworks[key] === undefined;
      });

      var newMarketDemos = this.marketDemoSegments.map(function (_ref) {
        var index = _ref.index,
            marketDemo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ username: username }, marketDemo, { UploadedDateTime: UploadedDateTime });
      });
      var allMarketDemos = newMarketDemos.concat(remainingCurrentMarketDemos);

      var MarketDemos = newMarketDemos.map(function (_ref2) {
        var username = _ref2.username,
            marketDemo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['username']);

        return marketDemo;
      });

      var segmentData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.segmentData, { MarketDemos: MarketDemos, ViewingStream: this.uploadedTargetViewingStream.toUpperCase() });
      var payload = { segmentData: segmentData, marketDemos: allMarketDemos, target_id: this.uploadedTargetId, username: username };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__appLogic_targets_createTarget_store_actions__["w" /* UPLOAD_NPOWER_SEGMENTS */], payload).then(function (res) {
        return _this3.onCompleteSegmentUpload();
      });
    },
    getRecordCompletionPercent: function getRecordCompletionPercent(records, expected) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["round"])(records / expected, 2) * 100 + '%';
    }
  },
  watch: {
    segmentData: function segmentData() {
      this.setMarketDemoOptions();
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_0__components_common_actionButton__["a" /* default */]
  },
  props: {
    overwrites: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    targetId: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      data: []
    };
  },
  mounted: function mounted() {
    this.setData();
  },

  methods: {
    overwriteFiles: function overwriteFiles() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_targets_createTarget_store_actions__["t" /* OVERWRITE_PID */], {
        targetId: this.targetId,
        overwrites: this.data
      }).then(function (res) {
        _this.onComplete();
      });
    },
    setData: function setData() {
      var overwrites = this.overwrites.map(function (o) {
        o.title = o.quarter;
        o.override = !o.exists;
        var year = Number(o.title.split('Q ')[0]);
        var quarter = Number(o.title.split('Q ')[1]);
        o.number = year * 100 + quarter;
        return o;
      });
      this.data = overwrites;
    }
  },
  watch: {
    overwrites: function overwrites() {
      this.setData();
    }
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_feedbackModal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TargetName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_ComscoreSelect__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_ComscoreSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_ComscoreSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_BroadcastQuarterSelect__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_BroadcastQuarterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_BroadcastQuarterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_DemoQualifier__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_DemoQualifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_DemoQualifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_pid_PidLogic__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_inputs__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_svg_cancel_svg__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_fileTypes_PID_Default_png__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_fileTypes_PID_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_fileTypes_PID_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_fileTypes_PID_Selected_png__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_fileTypes_PID_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_fileTypes_PID_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_fileTypes_NPower_Default_png__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_fileTypes_NPower_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_fileTypes_NPower_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_fileTypes_NPower_Selected_png__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_fileTypes_NPower_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_fileTypes_NPower_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_dataSources_Xandr_Default_png__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_dataSources_Xandr_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_dataSources_Xandr_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_dataSources_Xandr_Selected_png__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_dataSources_Xandr_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_dataSources_Xandr_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_fileTypes_Comscore_Default_png__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_fileTypes_Comscore_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_fileTypes_Comscore_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_fileTypes_Comscore_Selected_png__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_fileTypes_Comscore_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_fileTypes_Comscore_Selected_png__);




























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__["a" /* default */],
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect___default.a,
    StreamingSelect: __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_components_StreamingSelect___default.a,
    ComscoreSelect: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_components_ComscoreSelect___default.a,
    BroadcastQuarterSelect: __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_BroadcastQuarterSelect___default.a,
    DemoQualifier: __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_DemoQualifier___default.a,
    ErrorModal: __WEBPACK_IMPORTED_MODULE_3__components_common_feedbackModal__["a" /* ErrorModal */],
    TargetName: __WEBPACK_IMPORTED_MODULE_5__components_TargetName___default.a,
    NumberInput: __WEBPACK_IMPORTED_MODULE_13__components_common_inputs__["a" /* NumberInput */],
    SvgIcon: __WEBPACK_IMPORTED_MODULE_14__components_common_svgIcon__["a" /* default */]
  },
  directives: {
    focus: focus
  },
  props: {
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    initialTarget: {
      type: Object,
      default: null
    },
    errorMessage: {
      type: String,
      default: ''
    },
    originalTarget: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var newTarget = this.initialTarget ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.initialTarget) : {};
    var target = newTarget;
    target.target_datasource = newTarget.target_datasource || null;
    target.am_data = newTarget.am_data || {};
    target.am_data.flightStartDate = newTarget.am_data.flightStartDate || null;
    target.am_data.flightEndDate = newTarget.am_data.flightEndDate || null;
    target.am_data.status = newTarget.am_data.status || null;
    target.am_data.xdFlightOverlap = newTarget.am_data.xdFlightOverlap || 0;
    target.destinations = [__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY];

    return {
      target: target,
      selectedFiles: null,
      uploadedFile: [],
      nameIsValid: null,
      isXandrUpload: false,
      isIrisUpload: false,
      comscoreSelection: null,
      cancel: __WEBPACK_IMPORTED_MODULE_15__assets_svg_cancel_svg__["a" /* default */],
      broadcastQuarter: null,
      demoQualifier: null
    };
  },

  computed: {
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    acceptedFileFormat: function acceptedFileFormat() {
      if (this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE) {
        return '.xlsx,.xls';
      } else if (this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID) {
        return '.csv';
      }
    },
    fileTypes: function fileTypes() {
      var FILE_TYPE_OBJECTS = [{
        id: this.nielsenDatasources.PID,
        title: 'PID',
        target: __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID,
        targetType: __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].PID,
        img: {
          default: __WEBPACK_IMPORTED_MODULE_16__assets_fileTypes_PID_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_17__assets_fileTypes_PID_Selected_png___default.a
        },
        isDisabled: false
      }];
      return FILE_TYPE_OBJECTS;
    },
    isNewTarget: function isNewTarget() {
      return !this.target.id;
    },
    uploadButtonClickable: function uploadButtonClickable() {
      if (!this.$store.getters.hasPublishPermissions) {
        return false;
      }
      if (this.isComscoreDataSource && this.comscoreSelection != null) {
        return this.haveReceivedValues;
      }
      if (!this.hadStagedFile && this.selectedFiles === null) {
        return false;
      }
      if (this.isPIDDataSource && (this.broadcastQuarter === null || this.demoQualifier === null)) {
        return false;
      }
      return this.haveReceivedValues;
    },
    activateButtonClickable: function activateButtonClickable() {
      if (this.isComscoreDataSource && this.comscoreSelection != null) {
        return this.haveReceivedValues;
      }
      return false;
    },
    haveReceivedValues: function haveReceivedValues() {
      return this.target.advertiser && this.nameIsValid && this.target.target_datasource && this.target.viewing_stream;
    },
    isUploadDisabled: function isUploadDisabled() {
      return !this.target.target;
    },
    defaultTargetType: function defaultTargetType() {
      return __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS;
    },
    disableActivationButton: function disableActivationButton() {
      var hasRequiredFields = this.target.advertiser && this.target.viewing_stream && this.nameIsValid && this.target.target;
      var isPIDAndQuarterSelected = this.isPIDDataSource && this.broadcastQuarter && this.demoQualifier;
      return !hasRequiredFields || this.wasActivated || !isPIDAndQuarterSelected || !this.$store.getters.hasPublishPermissions;
    },
    wasActivated: function wasActivated() {
      return Boolean((this.initialTarget || {}).activation_status);
    },
    hadStagedFile: function hadStagedFile() {
      return Boolean((this.initialTarget || {}).has_staged_file);
    },
    viewingOptions: function viewingOptions() {
      return this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID ? 3 : 4;
    },
    showActivationButton: function showActivationButton() {
      return this.target.target_datasource && !(this.isNeilsenDatasource || this.isComscoreDataSource) && !this.hadStagedFile && !this.wasActivated;
    },
    isNeilsenDatasource: function isNeilsenDatasource() {
      return this.target.target_datasource === this.nielsenDatasources.NIELSEN;
    },
    isComscoreDataSource: function isComscoreDataSource() {
      return this.target.target_datasource === this.nielsenDatasources.COMSCORE;
    },
    isPIDDataSource: function isPIDDataSource() {
      return this.target.target_datasource === this.nielsenDatasources.PID;
    },
    clearBtnVisibility: function clearBtnVisibility() {
      return this.selectedFiles ? 'visible' : 'hidden';
    }
  },
  methods: {
    clearSelectedFile: function clearSelectedFile() {
      if (!this.isXandrUpload) {
        if (this.$refs.fileUploadInput) {
          this.$refs.fileUploadInput.reset();
        }
      }
      this.selectedFiles = null;
    },
    clickedActivate: function clickedActivate() {
      if (this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID) {
        this.target.target_definition = { broadcastQuarter: this.broadcastQuarter };
        this.target.metadata.foresite = { demoQualifier: this.demoQualifier };
        this.target.destinations = [__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE];
      }
      this.$emit('activate', {
        target: this.target,
        file: this.selectedFiles ? this.selectedFiles[0] : null
      });
    },
    getDestinationImage: function getDestinationImage(fileType) {
      return this.target.target_datasource === fileType.id && !fileType.isDisabled ? fileType.img.selected : fileType.img.default;
    },
    shouldHideOption: function shouldHideOption(fileType) {
      return this.isNewTarget && [this.nielsenDatasources.ATTDIRECTTV, this.nielsenDatasources.NIELSEN, this.nielsenDatasources.COMSCORE].includes(fileType.id);
    },
    selectDestination: function selectDestination(fileType) {
      if (!this.wasActivated) {
        this.clearSelectedFile();
        this.onComscoreChange();
        if (this.target.target_datasource === fileType.id) {
          this.target.target_datasource = null;
          this.target.target_type = null;
          this.target.target = null;
          this.target.am_data.status = null;
        } else {
          this.target.target_datasource = fileType.id;
          this.target.target_type = fileType.targetType;
          this.target.target = fileType.target;
          this.target.am_data.status = fileType.id === this.nielsenDatasources.ATTDIRECTTV ? __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["n" /* ATT_STATUS */].PLANNING : null;
        }
      }
    },
    clickedSubmit: function clickedSubmit() {
      if (this.feedbackMessage) {
        this.$refs.errorModal.open();
      } else {
        if (this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID) {
          this.target.activation_status = __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
          this.target.target_definition = { broadcastQuarter: this.broadcastQuarter };
          var foresiteMetadata = this.target.metadata.foresite || {};
          this.target.metadata.foresite = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, foresiteMetadata, { demoQualifier: this.demoQualifier });
          this.target.destinations = [__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE];
        }
        if (!this.isIrisUpload) {
          this.onComplete();
        }
        this.$emit('submit', {
          target: this.target,
          file: this.hadStagedFile || !this.selectedFiles ? null : this.selectedFiles[0]
        });
      }
    },
    onFileChange: function onFileChange(event) {
      var _this = this;

      if (event instanceof File) {
        if (this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || this.target.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE) {
          this.selectedFiles = [event];
        } else {
          this.selectedFiles = null;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_pid_PidLogic__["a" /* validatePidFile */])(event, function (valid) {
            if (valid) {
              _this.selectedFiles = [event];
            } else {
              __WEBPACK_IMPORTED_MODULE_12__components_common_toasts__["a" /* default */].error({ title: 'Error has occurred', message: 'Error: File has invalid values' });
            }
          });
        }
      }
    },
    onViewingStreamChange: function onViewingStreamChange(val) {
      this.target.viewing_stream = val;
    },
    theinputrecieved: function theinputrecieved(val) {
      this.target = val;
    },
    onComscoreChange: function onComscoreChange(val) {
      if (val != null) {
        this.target.target_definition = { target: '' + val.value.demo_no };
        this.target.audience_size = '' + val.value.national_demo_universe;
        this.comscoreSelection = val;
        this.clearSelectedFile();
      } else {
        this.target.target_definition = null;
        this.comscoreSelection = null;
      }
    }
  },
  mounted: function mounted() {
    if (this.fileTypes.length === 1) {
      this.selectDestination(this.fileTypes[0]);
    }
  },

  watch: {
    initialTarget: function initialTarget(newTarget) {
      this.target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(newTarget);
    },

    'target.target_datasource': function targetTarget_datasource() {
      this.isXandrUpload = this.target.target_datasource === this.nielsenDatasources.ATTDIRECTTV;
      this.isIrisUpload = this.target.target_datasource === this.nielsenDatasources.NIELSEN || this.target.target_datasource === this.nielsenDatasources.COMSCORE;
      if (this.isPIDDataSource) {
        this.target.viewing_stream = __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3;
      } else {
        this.broadcastQuarter = null;
        this.demoQualifier = null;
      }
    }
  }
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectDataSource__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectDataSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SelectDataSource__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SelectDataSource: __WEBPACK_IMPORTED_MODULE_0__SelectDataSource___default.a
  },
  props: {
    value: {
      completed: {
        type: Boolean,
        default: false
      },
      selectedDataSource: {
        default: null
      }
    },
    targetName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      selectedDataSource: null
    };
  },
  created: function created() {
    this.selectedDataSource = this.value.selectedDataSource;
  },

  methods: {
    emit: function emit(v) {
      this.$emit('input', {
        completed: Boolean(v),
        selectedDataSource: v
      });
    }
  },
  watch: {
    selectedDataSource: function selectedDataSource(value) {
      this.emit(value);
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_targets_createTarget_targetSlots_UploadTargetSlot__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_targets_createTarget_targetSlots_UploadTargetSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_targets_createTarget_targetSlots_UploadTargetSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_targetSlots_CreateADTargetSlot__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_targetSlots_CreateADTargetSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_targetSlots_CreateADTargetSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Selected_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_MRI_Selected_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_MRI_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_dataSources_MRI_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Ncs_Selected_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Ncs_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Ncs_Selected_png__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UploadTargetSlot: __WEBPACK_IMPORTED_MODULE_0__appComponents_targets_createTarget_targetSlots_UploadTargetSlot___default.a,
    ADSlot: __WEBPACK_IMPORTED_MODULE_1__appComponents_targets_createTarget_targetSlots_CreateADTargetSlot___default.a
  },
  props: {
    value: {
      completed: {
        type: Boolean,
        default: false
      }
    },
    selectedDataSource: {
      type: String,
      default: null
    },
    targetName: {
      type: String,
      default: ''
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    hideBackButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      overrideBackButton: false,
      title: {
        type: String,
        default: ''
      },
      dataSourceIcon: {
        type: String,
        default: null
      }
    };
  },

  computed: {
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    isLASTarget: function isLASTarget() {
      if (this.isAMRLD || this.isNCS || this.isMRI) {
        if (this.isMRI) {
          this.title = 'New MRI Target';
          this.dataSourceIcon = __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_MRI_Selected_png___default.a;
        } else if (this.isAMRLD) {
          this.title = 'New AMRLD Target';
          this.dataSourceIcon = __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Selected_png___default.a;
        } else if (this.isNCS) {
          this.title = 'New NCS Target';
          this.dataSourceIcon = __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_Ncs_Selected_png___default.a;
        }
        return true;
      }
    },
    isAudienceDiscovery: function isAudienceDiscovery() {
      if (this.selectedDataSource === this.nielsenDatasources.AUDIENCE_DISCOVERY) {
        var intentName = this.initialTarget && this.initialTarget.metadata && this.initialTarget.metadata.intents && this.initialTarget.metadata.intents && this.initialTarget.metadata.intents.length > 0 && this.initialTarget.metadata.intents[0].Name;
        this.title = this.isDuplicate ? 'Copy ' + (intentName || 'AMRLD') + ' Target' : 'New AMRLD Target';
        this.dataSourceIcon = __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Selected_png___default.a;
        return true;
      }
    },
    isAMRLD: function isAMRLD() {
      return this.selectedDataSource === this.nielsenDatasources.AMRLD;
    },
    isNCS: function isNCS() {
      return this.selectedDataSource === this.nielsenDatasources.NCS;
    },
    isMRI: function isMRI() {
      return this.selectedDataSource === this.nielsenDatasources.MRI;
    },
    isPidListOrNPower: function isPidListOrNPower() {
      return this.selectedDataSource === this.nielsenDatasources.FILE;
    },
    showBackButton: function showBackButton() {
      var dontShow = this.hideBackButton || this.overrideBackButton;
      return !dontShow;
    },
    isDuplicate: function isDuplicate() {
      return this.initialTargetAction === __WEBPACK_IMPORTED_MODULE_2__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE;
    },
    initialTargetAction: function initialTargetAction() {
      return this.$store.state.createTarget.initialTargetAction;
    },
    initialTarget: function initialTarget() {
      return this.$store.state.createTarget.initialTarget;
    }
  },
  methods: {
    finishOnComplete: function finishOnComplete() {
      this.onComplete();
    },
    setOverrideBackButton: function setOverrideBackButton() {
      this.overrideBackButton = true;
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_dataSources_adstra_Default_png__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_dataSources_adstra_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_dataSources_adstra_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_dataSources_adstra_Selected_png__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_dataSources_adstra_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_dataSources_adstra_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Default_png__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_AMRLD_Selected_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_AMRLD_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_dataSources_AMRLD_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_MRI_Default_png__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_MRI_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_dataSources_MRI_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_dataSources_MRI_Selected_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_dataSources_MRI_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_dataSources_MRI_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_dataSources_Ncs_Default_png__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_dataSources_Ncs_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_dataSources_Ncs_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_dataSources_Ncs_Selected_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_dataSources_Ncs_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_dataSources_Ncs_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_actionButton_ActionButton_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_actionButton_ActionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_actionButton_ActionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_dataSources_Epsilon_Default_png__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_dataSources_Epsilon_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_dataSources_Epsilon_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_dataSources_Epsilon_Selected_png__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_dataSources_Epsilon_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_dataSources_Epsilon_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_dataSources_DC_Comics_Default_png__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_dataSources_DC_Comics_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_dataSources_DC_Comics_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_dataSources_DC_Comics_Selected_png__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_dataSources_DC_Comics_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_dataSources_DC_Comics_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_dataSources_CNN_Default_png__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_dataSources_CNN_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_dataSources_CNN_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_dataSources_CNN_Selected_png__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_dataSources_CNN_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_dataSources_CNN_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Mosaic_Default_png__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Mosaic_Default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Mosaic_Default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_dataSources_Mosaic_Selected_png__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_dataSources_Mosaic_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_dataSources_Mosaic_Selected_png__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_9__components_common_actionButton_ActionButton_vue___default.a
  },
  props: {
    value: {
      default: null
    }
  },
  computed: {
    C360Datasources: function C360Datasources() {
      return this.$store.getters.getC360Datasources;
    },
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    dataTypes: function dataTypes() {
      return {
        NONE: null,
        ADSTRA: this.C360Datasources.ADSTRA,
        AMRLD: this.nielsenDatasources.AMRLD,
        MRI: this.nielsenDatasources.MRI,
        NCS: this.nielsenDatasources.NCS,
        FILE: this.nielsenDatasources.FILE,
        EPSILON: this.C360Datasources.EPSILON,
        EPSILON_EXPANDABLE: this.C360Datasources.EPSILON_EXPANDABLE,
        DC_COMICS: this.C360Datasources.DC_COMICS,
        CNN: this.C360Datasources.CNN,
        MOSAIC: this.C360Datasources.MOSAIC
      };
    },
    dataSourceImages: function dataSourceImages() {
      return [{
        id: this.dataTypes.ADSTRA,
        title: 'Adstra',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_1__assets_dataSources_adstra_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_2__assets_dataSources_adstra_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.AMRLD,
        title: 'AMRLD',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_3__assets_dataSources_AMRLD_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_AMRLD_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.MRI,
        title: 'MRI',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_5__assets_dataSources_MRI_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_6__assets_dataSources_MRI_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.NCS,
        title: 'NCS',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_7__assets_dataSources_Ncs_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_8__assets_dataSources_Ncs_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.EPSILON_EXPANDABLE,
        title: 'Epsilon',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_10__assets_dataSources_Epsilon_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_11__assets_dataSources_Epsilon_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.EPSILON,
        title: 'Epsilon Legacy',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_10__assets_dataSources_Epsilon_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_11__assets_dataSources_Epsilon_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.DC_COMICS,
        title: 'DC Comics',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_12__assets_dataSources_DC_Comics_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_13__assets_dataSources_DC_Comics_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.CNN,
        title: 'CNN',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_14__assets_dataSources_CNN_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_15__assets_dataSources_CNN_Selected_png___default.a
        }
      }, {
        id: this.dataTypes.MOSAIC,
        title: 'Mosaic',
        img: {
          default: __WEBPACK_IMPORTED_MODULE_16__assets_dataSources_Mosaic_Default_png___default.a,
          selected: __WEBPACK_IMPORTED_MODULE_17__assets_dataSources_Mosaic_Selected_png___default.a
        }
      }];
    },
    availableDatasources: function availableDatasources() {
      var _this = this;

      if (this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.Name)) {
        return this.dataSourceImages.filter(function (d) {
          return [_this.dataTypes.AMRLD].includes(d.id);
        });
      }
      if (this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["a" /* INTENTS */].Research.Name)) {
        return this.dataSourceImages.filter(function (d) {
          return [_this.dataTypes.AMRLD].includes(d.id);
        });
      }
      if (this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["a" /* INTENTS */].Sales.Name)) {

        return this.dataSourceImages;
      }
    },
    selectedOnFile: function selectedOnFile() {
      return this.dataTypes.FILE === this.value;
    },
    attachFileEnabled: function attachFileEnabled() {
      return this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_0__appLogic_targets_Constants__["a" /* INTENTS */].Sales.Name) && this.$store.getters.hasPublishPermissions;
    }
  },
  methods: {
    onFile: function onFile() {
      this.emit(this.dataTypes.FILE);
    },
    emit: function emit(v) {
      var sameValue = this.value === v;
      if (sameValue) {
        this.$emit('input', this.dataTypes.NONE);
      } else {
        this.$emit('input', v);
      }
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSourceStep__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSourceStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DataSourceStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FinishStep__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FinishStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FinishStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_forms_CreateAudience__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_forms_CreateAudience___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_forms_CreateAudience__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_simpleButton_InteractiveSimpleButton__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_simpleButton_InteractiveSimpleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_simpleButton_InteractiveSimpleButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_actionButton_ActionButton__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_actionButton_ActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_actionButton_ActionButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_modal_DialogModal__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_modal_DialogModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_modal_DialogModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_backArrowNav_BackArrowNav__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_backArrowNav_BackArrowNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_backArrowNav_BackArrowNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);














var STEPS = {
  TITLE: 1,
  DATA: 2,
  NEW_AUDIENCE: 3,
  FINISH: 4
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal__["b" /* default */],
    DataSourceStep: __WEBPACK_IMPORTED_MODULE_2__DataSourceStep___default.a,
    FinishStep: __WEBPACK_IMPORTED_MODULE_3__FinishStep___default.a,
    InteractiveButton: __WEBPACK_IMPORTED_MODULE_5__components_common_simpleButton_InteractiveSimpleButton___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_6__components_common_actionButton_ActionButton___default.a,
    DialogModal: __WEBPACK_IMPORTED_MODULE_7__components_common_modal_DialogModal___default.a,
    BackArrowNav: __WEBPACK_IMPORTED_MODULE_9__components_common_backArrowNav_BackArrowNav___default.a,
    CreateAudience: __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_createTarget_forms_CreateAudience___default.a
  },
  props: {
    showOnCreate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentStep: 0,
      previousStep: 0,
      modalTitle: '',
      titleInfo: {},
      dataInfo: {},
      finishInfo: {},
      audienceInfo: {},
      selectedDataSource: null,
      isActivatingAudience: false
    };
  },
  mounted: function mounted() {
    this.registerWithDataSource();
  },

  computed: {
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    showStepperModalTrigger: function showStepperModalTrigger() {
      return this.$store.state.createTarget.showStepperModal;
    },
    isTitleStep: function isTitleStep() {
      return this.currentStep === STEPS.TITLE;
    },
    isDataStep: function isDataStep() {
      return this.currentStep === STEPS.DATA;
    },
    isFinishStep: function isFinishStep() {
      return this.currentStep === STEPS.FINISH;
    },
    isNewAudienceStep: function isNewAudienceStep() {
      return this.currentStep === STEPS.NEW_AUDIENCE;
    },
    completedCurrentStep: function completedCurrentStep() {
      if (this.isTitleStep) {
        return this.titleInfo.completed;
      } else if (this.isDataStep) {
        return this.dataInfo.completed;
      } else {
        return this.finishInfo.completed;
      }
    },
    disableBackButton: function disableBackButton() {
      return STEPS.TITLE === this.currentStep;
    },
    showButtons: function showButtons() {
      return this.currentStep < STEPS.NEW_AUDIENCE;
    },
    selectedDataSourceTrigger: function selectedDataSourceTrigger() {
      return this.$store.state.createTarget.stepperDataSourceTrigger;
    },
    isDuplicate: function isDuplicate() {
      return this.$store.state.createTarget.initialTargetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].DUPLICATE;
    },
    isUpdate: function isUpdate() {
      return this.$store.state.createTarget.initialTargetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE;
    },
    isUpdateCampaign: function isUpdateCampaign() {
      return this.$store.state.createTarget.initialTargetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].UPDATE_CAMPAIGN;
    },
    isViewingSegmentInfo: function isViewingSegmentInfo() {
      return this.$store.state.createTarget.initialTargetAction === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].SEGMENT_INFO;
    },
    userPermissions: function userPermissions() {
      return this.$store.state.auth.permissions;
    },
    hasAudienceDiscoveryAccess: function hasAudienceDiscoveryAccess() {
      return this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Marketing']['Name']) || this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Research']['Name']);
    },
    hasLASWorkbenchAccess: function hasLASWorkbenchAccess() {
      return this.$store.state.createTarget.intents.includes(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["a" /* INTENTS */]['Sales']['Name']);
    },
    showBackButton: function showBackButton() {
      return this.selectedDataSourceTrigger !== this.nielsenDatasources.FILE;
    }
  },
  methods: {
    open: function open() {
      this.$refs.modal.open();
    },
    close: function close() {
      if (this.$refs.modal) {
        this.$refs.modal.close();
      }
    },
    destroySetup: function destroySetup() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["d" /* SET_SHOW_MODAL_STEPPER */], { step: 0 });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["i" /* SET_STEPPER_DATA_SOURCE */], { option: null });
      if (!this.isActivatingAudience) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["k" /* SET_UPDATING_TARGET */], null);
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["g" /* UPLOAD_MODAL_SET_APPEND_TYPE */], null);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["b" /* SET_UPLOAD_MODAL_OPTIONS */], null);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_10__appLogic_targets_createTarget_store_actions__["e" /* SET_INTENTS */], null);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.apply(this));
    },
    goBack: function goBack() {
      this.decrementStep();
    },
    incrementStep: function incrementStep() {
      this.previousStep = this.currentStep;
      if (this.isDataStep || this.isNewAudienceStep) {
        this.currentStep = STEPS.FINISH;
      } else {
        this.currentStep = this.currentStep + 1;
      }
    },
    decrementStep: function decrementStep() {
      if (this.currentStep !== this.previousStep) {
        this.currentStep = this.previousStep;
      } else {
        this.currentStep = this.currentStep - 1;
      }
      this.previousStep = this.currentStep - 1;
    },
    backButton: function backButton() {
      this.decrementStep();
    },
    cancelButton: function cancelButton() {
      this.close();
    },
    nextButton: function nextButton() {
      if (this.isDataStep && this.dataInfo.selectedDataSource === this.nielsenDatasources.AMRLD && this.hasAudienceDiscoveryAccess) {
        this.selectedDataSource = this.nielsenDatasources.AUDIENCE_DISCOVERY;
      } else if (this.isDataStep && this.dataInfo.selectedDataSource === this.nielsenDatasources.AMRLD && this.hasLASWorkbenchAccess) {
        this.dataInfo.selectedDataSource = this.nielsenDatasources.AMRLD;
        this.selectedDataSource = this.nielsenDatasources.AMRLD;
      }
      this.incrementStep();
    },
    registerWithDataSource: function registerWithDataSource() {
      if (this.selectedDataSourceTrigger === this.nielsenDatasources.SELECT_A_NEW_DATA_SOURCE || this.selectedDataSourceTrigger === null) {
        this.currentStep = STEPS.DATA;
      } else {
        this.currentStep = STEPS.FINISH;
        this.selectedDataSource = this.selectedDataSourceTrigger;
      }
      this.showedADprompt = false;
    },
    stepperOnComplete: function stepperOnComplete() {
      this.close();
      this.$emit('onComplete');
    },
    onAudienceActivation: function onAudienceActivation() {
      this.isActivatingAudience = true;
      this.stepperOnComplete();
    }
  },
  watch: {
    showStepperModalTrigger: function showStepperModalTrigger() {
      this.currentStep = this.showStepperModalTrigger;
      if (this.showStepperModalTrigger) {
        if (this.showStepperModalTrigger === STEPS.FINISH) {
          this.registerWithDataSource();
        }
        this.open();
      }
    },
    selectedDataSourceTrigger: function selectedDataSourceTrigger() {
      this.registerWithDataSource();
    },
    'dataInfo.selectedDataSource': function dataInfoSelectedDataSource() {
      this.selectedDataSource = this.dataInfo.selectedDataSource;
    },
    'audienceInfo.selectedDataSource': function audienceInfoSelectedDataSource() {
      if (this.audienceInfo.selectedDataSource === this.nielsenDatasources.FILE) {
        this.selectedDataSource = this.audienceInfo.selectedDataSource;
        this.incrementStep();
      }
    },
    currentStep: function currentStep(step) {
      switch (step) {
        case STEPS.TITLE:
          this.modalTitle = 'Enter a title';
          break;
        case STEPS.DATA:
          this.modalTitle = 'Select Data Source To Build A Target';
          break;
        case STEPS.FINISH:
          this.modalTitle = '';
          break;
        case STEPS.NEW_AUDIENCE:
          this.modalTitle = 'New Audience';
          this.audienceInfo = {};
          break;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroySetup();
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateTargetSlot__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateTargetSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CreateTargetSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_CreateAd__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_CreateAd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forms_CreateAd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_targetImages_Audience_svg__ = __webpack_require__(1560);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CreateTargetSlot: __WEBPACK_IMPORTED_MODULE_0__CreateTargetSlot___default.a,
    CreateAd: __WEBPACK_IMPORTED_MODULE_1__forms_CreateAd___default.a
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: false
    },
    targetName: {
      type: String,
      default: ''
    },
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    dataSourceIcon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'New Audience Discovery Target'
    }
  },
  data: function data() {
    return {
      svg: __WEBPACK_IMPORTED_MODULE_2__assets_targetImages_Audience_svg__["a" /* default */]
    };
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_loaderDots__ = __webpack_require__(53);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */],
    LoadingDots: __WEBPACK_IMPORTED_MODULE_1__components_common_loaderDots__["a" /* default */]
  },
  props: {
    title: String,
    svg: Object,
    png: String,
    overrideLoad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loading: function loading() {
      return this.$store.state.createTarget.isLoading && !this.overrideLoad;
    }
  }
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_CreateUpload__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_CreateUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forms_CreateUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_AppendFileUploader__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms_AppendFileUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__forms_AppendFileUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_targetImages_upload_svg__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Xandr_Selected_png__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Xandr_Selected_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Xandr_Selected_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_forms_PidOverwriteForm__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_forms_PidOverwriteForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_forms_PidOverwriteForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_forms_AppendNPowerForm__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_forms_AppendNPowerForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_forms_AppendNPowerForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_radioButtons__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CreateTargetSlot__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CreateTargetSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CreateTargetSlot__);
















var UPLOAD_OPTIONS = [{
  value: '1',
  name: 'Create New Target'
}, {
  value: '2',
  name: 'Append File'
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SelectSegmentModal: __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_createTarget_forms_NpowerSelectSegmentModal___default.a,
    CreateUpload: __WEBPACK_IMPORTED_MODULE_1__forms_CreateUpload___default.a,
    RadioButtons: __WEBPACK_IMPORTED_MODULE_10__components_common_radioButtons__["a" /* default */],
    AppendFileUploader: __WEBPACK_IMPORTED_MODULE_2__forms_AppendFileUploader___default.a,
    OverwriteForm: __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_forms_PidOverwriteForm___default.a,
    CreateTargetSlot: __WEBPACK_IMPORTED_MODULE_12__CreateTargetSlot___default.a,
    AppendNPowerForm: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_forms_AppendNPowerForm___default.a
  },
  props: {
    onComplete: {
      type: Function,
      default: function _default() {}
    },
    defaultSelectedUpload: {
      type: String,
      default: null
    },
    showBackButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var fff = JSON.parse('{"bucket":"am-target-files-dev","existing_files":[{"exists":true,"year_month":"year_month=2017_12"},{"exists":true,"year_month":"year_month=2018_02"},{"exists":true,"year_month":"year_month=2018_01"},{"exists":true,"year_month":"year_month=2017_04"},{"exists":true,"year_month":"year_month=2017_05"},{"exists":true,"year_month":"year_month=2017_08"},{"exists":true,"year_month":"year_month=2017_06"},{"exists":true,"year_month":"year_month=2017_09"},{"exists":true,"year_month":"year_month=2017_07"},{"exists":true,"year_month":"year_month=2017_10"},{"exists":true,"year_month":"year_month=2018_03"},{"exists":true,"year_month":"year_month=2017_11"}],"key":"PIDFiles/e2203af3-e808-477f-a7cc-60f8eb533dfb/stuff__2018-10-10-003624____13994.csv"}');
    return {
      segmentData: null,

      uploadedTargetId: null,
      uploadedTargetViewingStream: null,
      uploadOptions: UPLOAD_OPTIONS,
      uploadOption: UPLOAD_OPTIONS[0].value,
      appendingPID: null,
      defaultAppendingOption: null,
      defaultSelectedAppendingTarget: null,

      overwrites: null
    };
  },

  computed: {
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    text: function text() {
      if (this.originalTarget && this.initialTargetAction) {
        if (this.originalTarget.target_datasource === this.nielsenDatasources.ATTDIRECTTV) {
          return this.initialTargetAction + ' Xandr-File Target';
        }
        return this.initialTargetAction + ' File Upload Target';
      } else {
        return 'New File Upload Target';
      }
    },
    svg: function svg() {
      if (this.originalTarget && this.originalTarget.target_datasource === this.nielsenDatasources.ATTDIRECTTV) {
        return undefined;
      }
      return __WEBPACK_IMPORTED_MODULE_3__assets_targetImages_upload_svg__["a" /* default */];
    },
    png: function png() {
      if (this.originalTarget && this.originalTarget.target_datasource === this.nielsenDatasources.ATTDIRECTTV) {
        return __WEBPACK_IMPORTED_MODULE_4__assets_dataSources_Xandr_Selected_png___default.a;
      }
      return undefined;
    },
    defaultCreateUploadModalOptions: function defaultCreateUploadModalOptions() {
      return this.$store.state.createTarget.uploadModalOptions;
    },
    showCreateNewUpload: function showCreateNewUpload() {
      return UPLOAD_OPTIONS[0].value === this.uploadOption;
    },
    showAppendNewFile: function showAppendNewFile() {
      return UPLOAD_OPTIONS[1].value === this.uploadOption;
    },
    showUploads: function showUploads() {
      return !(this.segmentData || this.overwrites);
    },
    showSelectSegment: function showSelectSegment() {
      return Boolean(this.segmentData);
    },
    showOverwrites: function showOverwrites() {
      return this.overwrites;
    },
    appendType: function appendType() {
      return this.$store.state.createTarget.appendType;
    },
    appendTypeIsNpowerOrComscore: function appendTypeIsNpowerOrComscore() {
      return this.appendType === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER || this.appendType === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE;
    },
    originalTarget: function originalTarget() {
      if (this.$store.state.createTarget.initialTarget) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$store.state.createTarget.initialTarget || {}, {
          display_name: this.targetName || (this.$store.state.createTarget.initialTarget || {}).display_name || ''
        });
      }

      return undefined;
    },
    initialTargetAction: function initialTargetAction() {
      return this.$store.state.createTarget.initialTargetAction;
    }
  },
  methods: {
    finish: function finish() {
      if (this.overwrites) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api__["X" /* deleteTargetResource */])({ target_id: this.uploadedTargetId });
      }
      this.onComplete();
      this.segmentData = null;
      this.uploadedTargetId = null;
      this.uploadedTargetViewingStream = null;
      this.overwrites = null;
      this.appendingPID = null;
      this.defaultSelectedAppendingTarget = null;
      this.defaultAppendingOption = null;
      this.uploadOption = UPLOAD_OPTIONS[0].value;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__appLogic_targets_createTarget_store_actions__["g" /* UPLOAD_MODAL_SET_APPEND_TYPE */], null);
    },
    onCompleteUpload: function onCompleteUpload(target, uploadResult) {
      var isNpower = target.target === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].NPOWER;
      var isComscore = target.target === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].COMSCORE;
      var isNpowerWithUploadResults = isNpower && Boolean(uploadResult);
      var isComscoreWithUploadResults = isComscore && Boolean(uploadResult);
      var isPidTargetWithOverwrites = target.target === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PID && uploadResult;
      if (!isNpowerWithUploadResults && !isComscoreWithUploadResults && !isPidTargetWithOverwrites) {
        this.finish();
      } else if (isNpowerWithUploadResults || isComscoreWithUploadResults) {
        this.segmentData = uploadResult.irisResponse;
        this.uploadedTargetId = uploadResult.target.id;
        this.uploadedTargetViewingStream = uploadResult.target.viewing_stream;
        this.$forceUpdate();
      } else if (isPidTargetWithOverwrites) {
        this.overwrites = uploadResult.data.existing_files;
        this.appendingPID = uploadResult;
        this.uploadedTargetId = uploadResult.target.id;
        this.uploadedTargetViewingStream = uploadResult.target.viewing_stream;
      }
    },
    setUploadOptions: function setUploadOptions() {
      this.uploadOption = this.defaultCreateUploadModalOptions.type;
      this.defaultAppendingOption = this.defaultCreateUploadModalOptions.appendingOption;
      this.defaultSelectedAppendingTarget = this.defaultCreateUploadModalOptions.target;
    },
    submittedUploadFile: function submittedUploadFile() {
      this.$emit('submittedUploadFile');
    },
    sentDownstream: function sentDownstream() {
      this.finish();
    }
  },
  mounted: function mounted() {
    if (this.defaultSelectedUpload) {
      this.defaultAppendingOption = this.defaultSelectedUpload;
    }
    if (this.defaultCreateUploadModalOptions) {
      this.setUploadOptions();
    }
  },

  watch: {
    defaultCreateUploadModalOptions: function defaultCreateUploadModalOptions() {
      this.setUploadOptions();
    },
    defaultSelectedUpload: function defaultSelectedUpload() {
      this.defaultAppendingOption = this.defaultSelectedUpload;
      this.defaultSelectedAppendingTarget = this.defaultSelectedUpload;
    }
  }
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__ = __webpack_require__(25);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: this.value,
      search: null,
      selectedValue: null,
      buttonClicked: false
    };
  },

  computed: {
    disableRequestAudience: function disableRequestAudience() {
      return this.selectedValue === null || this.buttonClicked;
    },
    items: function items() {
      return this.$store.state.appRes.videoAmpAudienceList || [];
    }
  },
  methods: {
    requestAudience: function requestAudience() {
      var _this = this;

      this.buttonClicked = true;
      __WEBPACK_IMPORTED_MODULE_0__api_XandrAPI__["a" /* default */].requestVideoAmpAudienceIntake(this.selectedValue).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__["a" /* default */].success({
          title: 'VideoAmp Audience',
          message: 'VideoAmp Audience Intake Request Succeeded'
        });
        _this.close();
      }).catch(function (err) {
        console.log('VideoAmp Audience Request Failed');
        __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__["a" /* default */].error({
          title: 'VideoAmp Audience',
          message: 'VideoAmp Audience Intake Request Failed: ' + err.message
        });
        _this.close();
      });
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.selectedValue = null;
      this.isOpen = false;
      this.buttonClicked = false;
    }
  },
  watch: {
    value: function value(val) {
      this.isOpen = val;
    },
    isOpen: function isOpen(newVal) {
      if (newVal) {
        this.open();
      }
      this.$emit('input', newVal);
    }
  }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attributePanel__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AttributePanel: __WEBPACK_IMPORTED_MODULE_0__attributePanel__["a" /* default */]
  },
  props: {
    copiedTarget: {
      type: Object
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentBottomPaneSize: 'medium',
      firstAttempt: true
    };
  },
  mounted: function mounted() {
    document.querySelector('html').style.overflow = 'hidden';
  },
  destroyed: function destroyed() {
    document.querySelector('html').style.overflow = '';
    this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["q" /* RESET_STORE */]);
    this.firstAttempt = true;
  },

  computed: {
    datasetFilter: function datasetFilter() {
      return this.$store.getters['workbench/datasetFilter'];
    },
    selectedXandrAttributes: function selectedXandrAttributes() {
      return this.$store.getters['workbench/newDictOfTargetAttributes'];
    },
    attributes: function attributes() {
      var attrs = this.$store.getters['workbench/workbenchAttributes'];
      if (attrs) {
        return attrs;
      } else {
        return null;
      }
    },
    targetDefinition: function targetDefinition() {
      return this.$store.getters['workbench/newTargetDefinition'];
    },
    sizeClass: function sizeClass() {
      return 'is-' + this.currentBottomPaneSize;
    },
    workbenchSlottedValue: function workbenchSlottedValue() {
      return this.$store.state.workbench.slottedValue;
    },
    canEditTargetHeaderData: function canEditTargetHeaderData() {
      return true;
    },
    workbenchTarget: function workbenchTarget() {
      return this.$store.getters['workbench/newWorkbenchTarget'];
    }
  },
  methods: {
    selectAttribute: function selectAttribute(_ref) {
      var item = _ref.item,
          event = _ref.event;

      if ([__WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING, __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT, __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED].indexOf(this.workbenchTarget.activation_status) > -1) {
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_store_actions__["k" /* ADD_ATTRIBUTE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(item));
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["b" /* RESET_FAMILY_DATASETS */]);
      }
    },
    changeBottomPaneSize: function changeBottomPaneSize(size) {
      this.currentBottomPaneSize = size;
    },
    fetchTargetDefinitionInfo: function fetchTargetDefinitionInfo(td) {
      if (!this.firstAttempt && this.copiedTarget && (this.copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING || this.copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_4__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT)) {
        if (td.length > 0) {
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], true);
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], true);
        } else {
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], false);
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
        }
      }
      if (!this.firstAttempt) {
        if (td.length > 0) {
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["z" /* UPDATE_TARGET_DEFINITION_RELATED_INFORMATION */]);
        }
      } else {
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appLogic_workbench_common_store_actions__["A" /* INITIALIZE_TARGET_DEF */], this.$store.getters['workbench/getDefinition']);
      }
      this.firstAttempt = false;
    }
  },
  watch: {
    targetDefinition: function targetDefinition() {
      if (this.workbenchTarget) {
        this.fetchTargetDefinitionInfo(this.targetDefinition);
      }
    },
    workbenchTarget: function workbenchTarget() {
      if (!this.workbenchTarget) {
        this.firstAttempt = true;
      }
    }
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_StreamingSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_StreamingSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_StreamingSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_FlightDates__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_FlightDates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_FlightDates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_FrequencyDDL__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_FrequencyDDL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_FrequencyDDL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_BroadcastQuarterSelect__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_BroadcastQuarterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_BroadcastQuarterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_components_DemoQualifier__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_components_DemoQualifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__appComponents_targets_components_DemoQualifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_createTarget_components_SegmentSplit__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_createTarget_components_SegmentSplit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__appComponents_targets_createTarget_components_SegmentSplit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_conversions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_U__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuelidate__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jszip__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_jszip__);


























/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_19_vuelidate__["validationMixin"]],
  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_3__components_common_actionButton__["a" /* default */],
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_4__appComponents_targets_components_AdvertiserSelect___default.a,
    StreamingSelect: __WEBPACK_IMPORTED_MODULE_5__appComponents_targets_components_StreamingSelect___default.a,
    MVPD: __WEBPACK_IMPORTED_MODULE_6__appComponents_targets_createTarget_components_MVPD_vue___default.a,
    FlightDates: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_FlightDates___default.a,
    FrequencyDDL: __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_FrequencyDDL___default.a,
    BroadcastQuarterSelect: __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_BroadcastQuarterSelect___default.a,
    DemoQualifier: __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_components_DemoQualifier___default.a,
    SegmentSplit: __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_createTarget_components_SegmentSplit___default.a
  },
  props: {
    segment: {
      default: function _default() {
        return {
          display_name: '',
          destinations: [],
          xandr_data: {
            frequency: __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY
          },
          viewing_stream: null,
          am_data: {
            flightStartDate: null,
            flightEndDate: null,
            status: null,
            xdFlightOverlap: 0
          }
        };
      },
      display_name: {
        type: String,
        required: true,
        default: ''
      },
      destinations: {
        type: Array,
        required: true,
        default: []
      },
      advertiser: {
        type: Object,
        required: true,
        default: null
      },
      viewing_stream: {
        type: String,
        required: true,
        default: null
      },
      xandr_data: {
        frequency: {
          type: Number,
          default: null
        }
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: this.isActivationDialogOpen,
      next: null,
      modalTitle: 'Activation Window',
      disableViewingStream: true,
      disableAdvertiser: true,
      destinations: [],
      MVPDs: [],
      frequency: null,
      frequencyOptionSet: this.selectedAdstraDatasetFamily ? __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].MONTHLY : 0,
      isLoading: true,
      buttonClicked: false,
      broadcastQuarter: null,
      demoQualifier: null,
      foresiteDestinationSelected: false,
      isSplitValid: true,
      segmentSplit: []
    };
  },
  validations: function validations() {
    return {
      segment: {
        display_name: { required: __WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__["required"] },
        advertiser: {
          Name: {
            required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__["requiredIf"])(function () {
              return this.advertiserRequired;
            })
          }
        },
        viewing_stream: { required: __WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__["required"] },
        destinations: { required: __WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuelidate_lib_validators__["minLength"])(1) }
      }
    };
  },
  created: function created() {
    if (this.activatingAudience) {
      this.segment.xandr_data = { frequency: null };
    }
    this.setDestinations();
  },
  mounted: function mounted() {
    if (this.activatingAudience) {
      this.segment.xandr_data = { frequency: null };
    }
    this.isLoading = false;
  },

  computed: {
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    C360Datasources: function C360Datasources() {
      return this.$store.getters.getC360Datasources;
    },
    advertiserRequired: function advertiserRequired() {
      return this.isAddressableDestination || this.isLASDestination;
    },
    advertiser: function advertiser() {
      return this.segment.advertiser.Advertiser_id + ' ' + this.segment.advertiser.Name;
    },
    activatingAudience: function activatingAudience() {
      return this.$store.state.createTarget.initialTargetAction === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].ACTIVATE;
    },
    showAdvertiserRequiredMessage: function showAdvertiserRequiredMessage() {
      if (!this.segment.destinations || this.segment.destinations.length === 0) return false;
      return !(this.segment.advertiser && this.segment.advertiser.Name) && (this.isAddressableDestination || this.segment.destinations.includes(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE));
    },
    disableFrequency: function disableFrequency() {
      return false;
    },
    showViewingStream: function showViewingStream() {
      var _this = this;

      return this.selectedLasDatasetFamily || __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["g" /* ADDRESSABLE_DESTINATIONS */].some(function (d) {
        return _this.availableDestinations.includes;
      }) && this.isAddressableDestination;
    },
    showFrequency: function showFrequency() {
      return this.isAddressableDestination;
    },
    selectedLasDatasetFamily: function selectedLasDatasetFamily() {
      var df = this.selectedDatasetFamily;
      return df === 'amrld' || df === 'mri' || df === 'ncs';
    },
    selectedDatasetFamily: function selectedDatasetFamily() {
      return this.$store.getters['workbench/selectedFamilyDataset'];
    },
    noSelectedDatasetFamily: function noSelectedDatasetFamily() {
      return !this.selectedDatasetFamily;
    },
    selectedAdstraDatasetFamily: function selectedAdstraDatasetFamily() {
      return this.selectedDatasetFamily === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA || this.selectedDatasetFamily === 'xandr';
    },
    nielsenDatasource: function nielsenDatasource() {
      var _this2 = this;

      var rootFamilies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__common_U__["a" /* getAllDatasetsRootFamilyFromQuery */])(this.segment.target_definition.query);
      return rootFamilies.every(function (d) {
        return [_this2.nielsenDatasources.AMRLD, _this2.nielsenDatasources.MRI, _this2.nielsenDatasources.NCS].includes(d);
      });
    },
    newWorkbenchTarget: function newWorkbenchTarget() {
      return this.$store.getters['workbench/newWorkbenchTarget'];
    },
    disableSendDownstream: function disableSendDownstream() {
      return this.advertiserRequired && !(this.segment.advertiser && this.segment.advertiser.Name) || this.foresiteDestinationSelected && !this.demoQualifier || this.$v.$invalid || this.buttonClicked || !this.$store.getters.hasPublishPermissions || this.isFreeWheelOrGAMDestination && !this.isSplitValid;
    },
    availableDestinations: function availableDestinations() {
      return this.$store.getters['workbench/availableDestinations'];
    },
    viewingOption: function viewingOption() {
      return this.selectedAdstraDatasetFamily || this.isAddressableDestination ? 6 : 5;
    },
    isAddressableDestination: function isAddressableDestination() {
      var _this3 = this;

      return this.segment.destinations && __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["g" /* ADDRESSABLE_DESTINATIONS */].some(function (a) {
        return _this3.segment.destinations.includes(a);
      });
    },
    isDigitalDestination: function isDigitalDestination() {
      var _this4 = this;

      return this.segment.destinations && __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["h" /* DIGITAL_DESTINATIONS */].some(function (a) {
        return _this4.segment.destinations.includes(a);
      });
    },
    isDDLDestination: function isDDLDestination() {
      var _this5 = this;

      return this.segment.destinations && __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["x" /* DDL_DESTINATIONS */].some(function (a) {
        return _this5.segment.destinations.includes(a);
      });
    },
    isLASDestination: function isLASDestination() {
      var _this6 = this;

      return this.segment.destinations && __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["f" /* LAS_DESTINATIONS */].some(function (a) {
        return _this6.segment.destinations.includes(a);
      });
    },
    isFreeWheelOrGAMDestination: function isFreeWheelOrGAMDestination() {
      return this.segment.destinations && this.segment.destinations.length > 0 && this.segment.destinations.every(function (d) {
        return d === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL || d === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER;
      });
    },
    hasNotBeenPreviouslyModeled: function hasNotBeenPreviouslyModeled() {
      return this.segment && this.segment.xandr_data && this.segment.xandr_data.isModeled !== true;
    }
  },
  methods: {
    open: function open() {
      this.buttonClicked = false;
      this.getMVPDS();
      if (this.selectedLasDatasetFamily) {
        if (this.segment.destinations.length === 0) {
          this.segment.destinations = [__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE];
        }
        this.segment.viewing_stream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__appLogic_targets_conversions__["b" /* convertViewingStreamForAM */])(this.$store.getters['workbench/viewingStream']);
      }
      this.setDestinations();
      if (this.destinations.length === 1) {
        this.selectDestination(this.destinations[0]);
      }
    },
    close: function close() {
      if (this.activatingAudience) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__appLogic_targets_createTarget_store_actions__["k" /* SET_UPDATING_TARGET */], null);
      }
      this.isOpen = false;
    },
    getMVPDS: function getMVPDS() {
      this.MVPDs = this.$store.state.appRes.mvpds;
    },
    setDestinations: function setDestinations() {
      var _this7 = this;

      var newVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.segment.destinations || [];

      if (this.selectedLasDatasetFamily && this.segment.destinations && this.segment.destinations.length === 0) {
        this.segment.destinations = [__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE];
        return;
      }

      this.foresiteDestinationSelected = this.segment.destinations.includes(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE);

      this.destinations = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["q" /* DESTINATION_OBJECTS */].filter(function (d) {
        if (_this7.availableDestinations.includes(d.id)) {
          return d.id;
        }
      });
    },
    setExportFrequency: function setExportFrequency() {
      if (this.isAddressableDestination) {
        this.frequency = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY;
        this.segment.xandr_data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.segment.xandr_data, { frequency: __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY });
        delete this.segment.xandr_data.exportDayOfWeek;
      } else if (this.segment.destinations.length > 0 && this.segment.destinations.every(function (d) {
        return d === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP;
      })) {
        this.segment.xandr_data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.segment.xandr_data, { frequency: __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["o" /* FREQUENCIES */].ONE_TIME, exportDayOfWeek: 0 });
      } else if (this.isDigitalDestination) {
        this.segment.xandr_data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.segment.xandr_data, { frequency: __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["o" /* FREQUENCIES */].WEEKLY, exportDayOfWeek: 0 });
      }
    },
    setXandrExternal: function setXandrExternal() {
      if (!this.activatingAudience && (this.noSelectedDatasetFamily || this.selectedLasDatasetFamily)) return;

      this.segment.xandr_data.external = undefined;
      this.segment.xandr_data.addressable = undefined;

      if (this.isAddressableDestination) {
        if (!this.MVPDs) {
          this.getMVPDS();
        }
        this.setExportFrequency();
        this.segment.xandr_data.external = [];
        this.segment.xandr_data.addressable = true;
        this.segment.viewing_stream = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
        if (this.activatingAudience) {
          this.segment.target = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA;
          this.segment.target_datasource = this.C360Datasources.ADSTRA;
          this.segment.target_type = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].ADSTRA;
          this.segment.am_data = { flightStartDate: null, flightEndDate: null, status: null, xdFlightOverlap: 0 };
        }

        if (this.segment.destinations.includes(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR)) {
          var canoe_mvpd = this.MVPDs.find(function (mvpd) {
            return mvpd.Name === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_LINEAR;
          });
          this.segment.xandr_data.external.push({
            endpointID: canoe_mvpd.Id,
            endpointName: canoe_mvpd.Name,
            externalID: '',
            universeEstimates: null
          });
        }

        if (this.segment.destinations.includes(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD)) {
          var canoe_vod_mvpd = this.MVPDs.find(function (mvpd) {
            return mvpd.Name === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_VOD;
          });
          this.segment.xandr_data.external.push({
            endpointID: canoe_vod_mvpd.Id,
            endpointName: canoe_vod_mvpd.Name,
            externalID: '',
            universeEstimates: null
          });
        }

        if (this.segment.destinations.includes(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO)) {
          var vizio_mvpd = this.MVPDs.find(function (mvpd) {
            return mvpd.Name === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].VIZIO;
          });
          this.segment.xandr_data.external.push({
            endpointID: vizio_mvpd.Id,
            endpointName: vizio_mvpd.Name,
            externalID: '',
            universeEstimates: null
          });

          this.segment.am_data.xdFlightOverlap = 0;
        }

        if (this.segment.destinations.includes(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV)) {
          var atttv_mvpd = this.MVPDs.find(function (mvpd) {
            return mvpd.Name === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].DIRECTV;
          });
          this.segment.xandr_data.external.push({
            endpointID: atttv_mvpd.Id,
            endpointName: atttv_mvpd.Name,
            externalID: '',
            universeEstimates: null
          });
        }
      } else {
        this.segment.xandr_data.addressable = false;
        if (this.segment.destinations.find(function (destination) {
          return [__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER].includes(destination);
        })) {
          if (this.activatingAudience) {
            this.segment.target = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PRISM;
            this.segment.target_datasource = this.C360Datasources.PRISM;
            this.segment.target_type = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].PRISM;
            this.segment.am_data = { flightStartDate: null, flightEndDate: null, status: null, xdFlightOverlap: 0 };
          }
        } else if (this.segment.destinations.find(function (destination) {
          return [__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE].includes(destination);
        })) {
          if (this.segment.xandr_data.frequency === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["o" /* FREQUENCIES */].WEEKLY) {
            this.frequency = null;
          }
          this.frequencyOptionSet =  false ? FREQUENCY_OPTION_SET.LINEAR : 0;
          if (this.activatingAudience) {
            this.segment.target = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS;
            this.segment.target_datasource = this.nielsenDatasources.MRI;
            this.segment.target_type = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS;
          }
        }
      }
    },
    selectDestination: function selectDestination(destination) {
      var targetDestinations = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.segment.destinations);
      if (destination.isDisabled || this.isActivated && !this.isDuplicating) return;
      var isDestinationAlreadySelected = targetDestinations.has(destination.id);
      var isAddressableDestinationFound = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["g" /* ADDRESSABLE_DESTINATIONS */].some(function (a) {
        return targetDestinations.has(a);
      });
      var isDigitalDestinationFound = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["h" /* DIGITAL_DESTINATIONS */].some(function (a) {
        return targetDestinations.has(a);
      });
      var isVideoAmpDestinationFound = targetDestinations.has(__WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP);
      var that = this;
      var clearSelectedDestinations = function clearSelectedDestinations() {
        that.segment.destinations = [];
        targetDestinations.clear();
      };

      if (destination.id === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE && isDestinationAlreadySelected) {
        this.segment.viewing_stream = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3;
        return;
      }
      if (isDestinationAlreadySelected) {
        targetDestinations.delete(destination.id);
      } else {
        targetDestinations.add(destination.id);

        switch (destination.id) {
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE:
            if (isAddressableDestinationFound || isDigitalDestinationFound || isVideoAmpDestinationFound) {
              clearSelectedDestinations();
            }
            targetDestinations.add(destination.id);
            this.segment.viewing_stream = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3;
            break;
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV:
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO:
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR:
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD:
            if (!isAddressableDestinationFound) {
              clearSelectedDestinations();
            }
            targetDestinations.add(destination.id);
            this.segment.viewing_stream = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            break;
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL:
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER:
            if (!isDigitalDestinationFound && !isVideoAmpDestinationFound) {
              clearSelectedDestinations();
            }
            targetDestinations.add(destination.id);
            this.segment.viewing_stream = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            break;
          case __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP:
            if (!isDigitalDestinationFound) {
              clearSelectedDestinations();
            }
            targetDestinations.add(destination.id);
            this.segment.viewing_stream = __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            break;
        }
      }
      this.segment.destinations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(targetDestinations);

      this.setXandrExternal();
    },
    setSegmentSplit: function setSegmentSplit() {
      var _this8 = this;

      if (this.isFreeWheelOrGAMDestination && this.segmentSplit.length > 0) {
        var segment = {
          segment: {
            segmentSplit: this.segmentSplit.map(function (split) {
              return { name: split.name, split: split.percentage / 100, externalId: _this8.segment.cae_id };
            })
          }
        };
        this.segment.xandr_data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lodash__["merge"])(this.segment.xandr_data, segment);
      }
    },
    submitDownstream: function submitDownstream() {
      var _this9 = this;

      this.buttonClicked = true;
      if (this.foresiteDestinationSelected) {
        this.segment.target_definition = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.segment.target_definition, {
          broadcastQuarter: this.broadcastQuarter
        });
        this.segment.metadata.foresite = { demoQualifier: this.demoQualifier };
      } else {
        delete this.segment.target_definition.broadcastQuarter;
        if (this.segment.metadata.foresite) delete this.segment.metadata.foresite;
      }
      this.setExportFrequency();
      this.setSegmentSplit();
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_16__appLogic_workbench_common_store_actions__["w" /* SAVE_TARGET */], { target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lodash__["cloneDeep"])(this.segment), ignoreSavePrompt: true }).then(function (resp) {
        if (_this9.nielsenDatasource) {
          var copiedTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_lodash__["cloneDeep"])(_this9.newWorkbenchTarget);
          _this9.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_16__appLogic_workbench_common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
          _this9.$store.dispatch(__WEBPACK_IMPORTED_MODULE_17__views_audienceHub_store_actions__["d" /* POST_TARGET */], copiedTarget).then(function (resp) {
            _this9.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_16__appLogic_workbench_common_store_actions__["d" /* SET_TARGET */], copiedTarget);
            _this9.$router.push({ name: 'NewWorkbench', params: { id: _this9.segment.id } });
          });
        } else {
          _this9.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_16__appLogic_workbench_common_store_actions__["x" /* SUBMIT_DOWNSTREAM */]);
        }
        _this9.close();
      });
    },
    destroySetup: function destroySetup() {
      if (this.segment.activation_status === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT || this.segment.activation_status === __WEBPACK_IMPORTED_MODULE_15__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) {
        this.segment.destinations = [];
      }
      if (this.activatingAudience) {
        this.segment.destinations = [];
        if (this.segment.xandr_data) {
          delete this.segment.xandr_data.frequency;
          delete this.segment.xandr_data.exportDayOfWeek;
        }
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__appLogic_targets_createTarget_store_actions__["p" /* RESET_THE_LAS_MODAL */]);
      }
      this.close();
    }
  },
  watch: {
    value: function value(val) {
      this.isOpen = val;
    },
    isOpen: function isOpen(newVal) {
      if (newVal) {
        this.open();
      } else {
        this.close();
      }
      this.$emit('input', newVal);
    }
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    apiName: {
      type: String,
      default: 'this graphs API endpoint'
    }
  },
  computed: {
    doneLoading: function doneLoading() {
      return !this.$store.getters.loading;
    }
  }
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    editModeActive: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_attributeTree__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BackButton_vue__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BackButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BackButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BreadCrumbs_vue__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BreadCrumbs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BreadCrumbs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollapseButton_vue__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollapseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CollapseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_TargetName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_modals_DroppedAttributesModal__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_modals_DroppedAttributesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_modals_DroppedAttributesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PanelSizeBtn__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PanelSizeBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__PanelSizeBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_searchInput__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchResults_vue__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchResults_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SearchResults_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_search__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SmallText_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SmallText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SmallText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appLogic_route_store_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_3__appComponents_targets_components_AdvertiserSelect___default.a,
    BackBtn: __WEBPACK_IMPORTED_MODULE_5__BackButton_vue___default.a,
    BreadCrumbs: __WEBPACK_IMPORTED_MODULE_6__BreadCrumbs_vue___default.a,
    CollapseBtn: __WEBPACK_IMPORTED_MODULE_7__CollapseButton_vue___default.a,
    DroppedAttributesModal: __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_modals_DroppedAttributesModal___default.a,
    TargetName: __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_createTarget_components_TargetName___default.a,
    List: __WEBPACK_IMPORTED_MODULE_10__List_vue___default.a,
    PanelSizeBtn: __WEBPACK_IMPORTED_MODULE_11__PanelSizeBtn___default.a,
    SearchInput: __WEBPACK_IMPORTED_MODULE_12__components_common_searchInput__["a" /* default */],
    SearchResults: __WEBPACK_IMPORTED_MODULE_13__SearchResults_vue___default.a,
    SmallText: __WEBPACK_IMPORTED_MODULE_15__SmallText_vue___default.a
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isExpandedView: {
      type: Boolean,
      default: false
    },
    setOfAttributes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onSelect: {
      type: Function,
      default: function _default(_ref) {
        var item = _ref.item,
            event = _ref.event;
      }
    },
    workbenchHeaderData: {
      type: Object
    },
    canEditTargetHeaderData: {
      type: Boolean
    },
    selectedValues: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    datasetFilter: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      searchService: new __WEBPACK_IMPORTED_MODULE_14__services_search__["a" /* default */](),
      attributesTree: new __WEBPACK_IMPORTED_MODULE_4__models_attributeTree__["a" /* default */](),
      editModeActive: false,
      currentList: null,
      searchResults: [],
      searchTerm: '',
      nameIsValid: null,
      originalDisplayName: null,
      originalAdvertiserId: null,
      campaignName: null,
      targetName: '',
      savingEnabledWhenToggled: false
    };
  },

  computed: {
    hasSelectedAdvertiser: function hasSelectedAdvertiser() {
      var wb = this.workbenchHeaderData;
      if (wb) {
        if (wb.advertiser) {
          if (wb.advertiser.Name) {
            return true;
          }
        }
      }
      return false;
    },
    crumbs: function crumbs() {
      return this.currentList && this.currentList.getPath().map(function (node) {
        return {
          name: node.model.name,
          node: node
        };
      });
    },
    tooManySearchResults: function tooManySearchResults() {
      return this.searchResultsCount > 500;
    },
    searchResultsCount: function searchResultsCount() {
      return this.searchResults.reduce(function (currValue, resultSet) {
        return resultSet.results.length + currValue;
      }, 0);
    },
    isSearchActive: function isSearchActive() {
      return this.searchTerm.length > 0;
    },
    isAddressable: function isAddressable() {
      var destinations = this.workbenchHeaderData && this.workbenchHeaderData.destinations || [];
      return destinations.some(function (d) {
        return [__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV, __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO, __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR, __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD].includes(d);
      });
    },
    isLive: function isLive() {
      return this.workbenchHeaderData && this.workbenchHeaderData.activation_status && this.workbenchHeaderData.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    },
    isDraft: function isDraft() {
      return this.workbenchHeaderData.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT || this.workbenchHeaderData.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].NEW;
    },
    isWorking: function isWorking() {
      return this.workbenchHeaderData.activation_status === __WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
    },
    targetInfoEditable: function targetInfoEditable() {
      return !this.viewOnly;
    },
    availableDestinations: function availableDestinations() {
      return this.$store.getters['workbench/availableDestinations'];
    },
    selectedDatasetFamily: function selectedDatasetFamily() {
      return this.$store.getters['workbench/selectedFamilyDataset'];
    }
  },
  methods: {
    clickedDropped: function clickedDropped() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_20__appLogic_targets_currentTarget_store_actions__["y" /* SHOW_DROPPED_ATTRIBUTES_MODEL */], true);
    },
    onTargetNameIsValid: function onTargetNameIsValid(valid) {
      if (valid && this.targetName) {
        this.workbenchHeaderData.display_name = this.targetName;
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_17__appLogic_workbench_common_store_actions__["v" /* UPDATE_TARGET_NAME */], this.targetName);
      } else {
        this.workbenchHeaderData.display_name = this.originalDisplayName;
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_17__appLogic_workbench_common_store_actions__["v" /* UPDATE_TARGET_NAME */], this.workbenchHeaderData.display_name);
      }
    },
    navigateToDashboard: function navigateToDashboard() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_18__appLogic_route_store_actions__["d" /* ROUTE_BACK */]);
    },
    toggleEditMode: function toggleEditMode() {
      this.editModeActive = !this.editModeActive;
      this.savingEnabledWhenToggled = this.$store.state.workbench.enableSaving;
      if (this.editModeActive) {
        this.originalDisplayName = this.workbenchHeaderData.display_name;
        if (this.workbenchHeaderData.advertiser && this.workbenchHeaderData.advertiser.Advertiser_id) {
          this.originalAdvertiserId = this.workbenchHeaderData.advertiser.Advertiser_id;
        }
      }
      if (!this.editModeActive) {
        this.setSaveButtonState();
      }
    },
    itemSelectedHandler: function itemSelectedHandler(obj) {
      this.currentList = obj.item;
    },
    crumbClickHandler: function crumbClickHandler(crumb) {
      this.currentList = crumb.node;
    },
    clearSearch: function clearSearch() {
      this.$refs.searchInput.clearSearch();
    },
    panelClickHandler: function panelClickHandler(e) {
      if (this.isCollapsed) this.toggleCollapse(e);
    },
    toggleCollapse: function toggleCollapse(e) {
      e.stopPropagation();
      this.$emit('collapse-clicked');
    },
    togglePanelSize: function togglePanelSize() {
      this.$emit('change-size-click');
    },
    dropNonMatchingDatasets: function dropNonMatchingDatasets(datasets) {
      this.attributesTree.dropNodes(datasets);
      this.showOnlyMatchingDatasets(datasets);
      var namesOfDatasetsToDrop = this.attributesTree.droppedNodes.map(function (x) {
        return x.model.name;
      });
      this.searchService.filterDatasets(namesOfDatasetsToDrop);
    },
    showOnlyMatchingDatasets: function showOnlyMatchingDatasets(datasets) {
      var current = this.currentList;
      while (current.children.length > 0) {
        current = current.children[0];
      }
      var currentDatasetViewing = current.model.dataset;
      var currentRootFamily = current.model.rootFamily;
      if (!datasets.includes(currentDatasetViewing) && !datasets.includes(currentRootFamily)) {
        this.currentList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()(this.attributesTree.root);
      }
    },
    addBackDroppedDatasets: function addBackDroppedDatasets() {
      this.attributesTree.addBackDroppedDatasets();
      this.searchService.resetDatasets();
    },
    createSearchEngine: function createSearchEngine() {
      var _this = this;

      if (this.setOfAttributes && this.setOfAttributes.length > 0) {
        this.searchService = new __WEBPACK_IMPORTED_MODULE_14__services_search__["a" /* default */]();
        this.attributesTree = new __WEBPACK_IMPORTED_MODULE_4__models_attributeTree__["a" /* default */]();
        this.setOfAttributes.forEach(function (attributes) {
          _this.searchService.addDataSource(attributes.flat);
          _this.attributesTree.addDataSource(attributes.data);
        });
        this.currentList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()(this.attributesTree.root);
      }
    },
    getDestinations: function getDestinations() {
      var _this2 = this;

      var destinations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (destinations.length > 0) {
        var orderedArr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */]);
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(destinations)).sort(function (a, b) {
          return orderedArr.indexOf(a) - orderedArr.indexOf(b);
        }).join(', ');
      } else if (this.availableDestinations && this.availableDestinations.length > 0 && this.availableDestinations.includes(__WEBPACK_IMPORTED_MODULE_16__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY)) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.availableDestinations)).sort(function (a, b) {
          return _this2.availableDestinations.indexOf(a) - _this2.availableDestinations.indexOf(b);
        }).join(', ');
      } else {
        return '';
      }
    },
    setSaveButtonState: function setSaveButtonState() {
      var enableSave = false;
      if (this.savingEnabledWhenToggled) {
        enableSave = this.workbenchHeaderData.display_name && this.workbenchHeaderData.advertiser.Advertiser_id && this.selectedDatasetFamily;
      } else {
        var hasDisplayName = this.workbenchHeaderData.display_name !== this.originalDisplayName;
        var hasAdvertiser = (this.workbenchHeaderData.advertiser.Advertiser_id || '') !== (this.originalAdvertiserId || '');
        enableSave = this.selectedDatasetFamily && (hasDisplayName || hasAdvertiser);
      }
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_17__appLogic_workbench_common_store_actions__["n" /* SET_ENABLE_SAVE_BUTTON */], enableSave);
      if (enableSave) {
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_17__appLogic_workbench_common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], !enableSave);
      }
    },
    getCampaignName: function getCampaignName() {
      var xandr_data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (xandr_data && xandr_data.createdCampaignName) {
        return xandr_data.createdCampaignName + '  |';
      } else if (xandr_data && xandr_data.selectedCampaignId) {
        return xandr_data.campaign ? xandr_data.campaign.campaignName + '  |' : '';
      }
      return '';
    },
    onUpdateAdvertiser: function onUpdateAdvertiser(val) {
      this.workbenchHeaderData.advertiser = val;
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_17__appLogic_workbench_common_store_actions__["u" /* SET_ADVERTISER */], this.workbenchHeaderData.advertiser);
    },
    setCurrentListToRoot: function setCurrentListToRoot() {
      this.currentList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_freeze___default()(this.attributesTree.root);
    }
  },
  beforeMount: function beforeMount() {
    this.createSearchEngine();
  },

  watch: {
    canEditTargetHeaderData: function canEditTargetHeaderData() {
      if (!this.canEditTargetHeaderData) {
        this.editModeActive = false;
      }
    },
    setOfAttributes: function setOfAttributes() {
      this.createSearchEngine();
    },
    searchTerm: function searchTerm(newValue) {
      if (newValue.length < 1) {
        this.searchResults = [];
      } else {
        this.searchResults = this.searchService.search(newValue);
      }
    },
    workbenchHeaderData: function workbenchHeaderData() {
      if (this.viewOnly) {
        this.$refs.searchInput && this.$refs.searchInput.clearSearch();
      }
    }
  }
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]
    };
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_home_outline_svg__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_svg__ = __webpack_require__(45);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: ['crumbs'],
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_svg__["a" /* default */],
      homeOutline: __WEBPACK_IMPORTED_MODULE_1__assets_svg_home_outline_svg__["a" /* default */]
    };
  },

  methods: {
    hasSeparator: function hasSeparator(index) {
      return index < this.crumbs.length - 1;
    },
    crumbClickHandler: function crumbClickHandler(crumb, index) {
      this.$emit('click', crumb, index);
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    hideText: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]
    };
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelItem_vue__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PanelItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PanelItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_virtualScrollList__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PanelItem: __WEBPACK_IMPORTED_MODULE_1__PanelItem_vue___default.a,
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_3__components_common_scrollPanel__["a" /* default */],
    VirtualList: __WEBPACK_IMPORTED_MODULE_4__components_common_virtualScrollList__["a" /* default */]
  },
  props: {
    scrollable: {
      type: Boolean,
      default: true
    },
    listGroup: {
      type: Object,
      required: true
    },
    advertiser: {
      type: Object,
      required: true
    },
    locked: {
      type: Boolean,
      default: false
    },
    selectedValues: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentSelectedItem: null,
      currentAttributePopover: null,
      scrollPositionMap: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_weak_map___default.a()
    };
  },

  methods: {
    selectItem: function selectItem(item, event) {
      if (this.locked) {
        return;
      }
      if (item.model.type && item.model.type !== 'boolean') {
        this.selectOptionableItem(item, event);
      } else if (!item.children || item.children.length === 0) {
        var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(item.model);
        this.onSelect(i, event);
      } else {
        if (this.scrollable) {
          this.scrollPositionMap.set(this.listGroup, this.$refs.virtualList.getScrollTop());
        }
        if (item.children && item.children.length > 0) {
          this.$emit('expandNode', { item: item, event: event });
        }
      }
    },
    selectOptionableItem: function selectOptionableItem(item, event) {
      var attribute = item.model;
      if (attribute.type === __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN) {
        this.onSelect(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(attribute));
      } else {
        this.currentSelectedItem = item;

        var attributes = this.selectedValues;
        if (attribute.traitId) {
          var values = attributes ? attributes[item.model.traitId] : attributes;
          this.currentAttributePopover = __WEBPACK_IMPORTED_MODULE_5__components_common_popover__["a" /* PopoverFactory */].createSelectableBoxOffClickDeadline({
            attribute: item.model,
            values: values,
            direction: 'right',
            parent: event.target
          });
        } else {
          this.currentAttributePopover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_common_popover__["b" /* createPopover */])({
            attribute: attribute,
            direction: 'right',
            parent: event.target,
            type: __WEBPACK_IMPORTED_MODULE_5__components_common_popover__["c" /* popoverTypes */].ATTRIBUTE
          });
        }
        this.currentAttributePopover.$on('select', this.onSelect);
        this.currentAttributePopover.$on('dismiss', this.deselectCurrentSelectedItem);
      }
    },
    deselectCurrentSelectedItem: function deselectCurrentSelectedItem() {
      this.currentAttributePopover = null;
      this.currentSelectedItem = null;
    },
    onSelect: function onSelect(item, event) {
      this.$emit('onSelect', { item: item, event: event });
    }
  },
  watch: {
    listGroup: function listGroup(newValue) {
      var _this = this;

      if (this.scrollable) {
        this.$nextTick(function () {
          _this.$refs.virtualList.scrollTo(_this.scrollPositionMap.get(newValue) || 0);

          _this.scrollPositionMap.delete(newValue);
        });
      }
    }
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_copy_svg__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_svg__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SmallText_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SmallText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SmallText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__["a" /* default */],
    SmallText: __WEBPACK_IMPORTED_MODULE_4__SmallText_vue___default.a
  },
  props: {
    name: String,
    path: {
      type: String
    },
    hasChildren: {
      type: Boolean,
      default: false
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    description: String
  },
  data: function data() {
    return {
      copy: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_1__assets_svg_copy_svg__["a" /* default */]),
      arrow: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_2__assets_svg_arrow_svg__["a" /* default */]),
      shouldDisplayTitleTooltip: true
    };
  },

  computed: {
    titleAttribute: function titleAttribute() {
      return this.shouldDisplayTitleTooltip && this.description && this.description.trim().length > 1 ? this.description : null;
    },
    hasPath: function hasPath() {
      return !!this.path;
    }
  },
  methods: {
    copyDescription: function copyDescription(e) {
      e.stopPropagation();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["l" /* copyTextToClipboard */])(this.name);
    }
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    isExpandedView: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */]
    };
  },

  computed: {
    buttonText: function buttonText() {
      return this.isExpandedView ? 'Show Less' : 'Show More';
    }
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmallText_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmallText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SmallText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_scrollPanel__ = __webpack_require__(41);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_2__components_common_scrollPanel__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a,
    SmallText: __WEBPACK_IMPORTED_MODULE_1__SmallText_vue___default.a
  },
  props: ['results', 'count', 'locked', 'selectedValues', 'advertiser'],
  computed: {
    searchResultsFormatted: function searchResultsFormatted() {
      return this.results.map(function (results) {
        return {
          model: {
            name: results.name
          },
          children: results.results.map(function (result) {
            return {
              model: result,
              hasChildren: function hasChildren() {
                return false;
              }
            };
          })
        };
      });
    }
  },
  methods: {
    hasNoResults: function hasNoResults(results) {
      return results.children.length === 0;
    },
    itemSelectedHandler: function itemSelectedHandler(item) {
      this.$emit('item-selected', item);
    }
  }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    light: Boolean,
    default: false
  }
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    currentSize: {
      type: String,
      required: true
    }
  },
  methods: {
    isActive: function isActive(size) {
      return size === this.currentSize;
    },
    setSizeTo: function setSizeTo(size) {
      this.$emit('new-size', size);
    }
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__targetDefinition__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quickAddAttributes_QuickAddAttributes_vue__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quickAddAttributes_QuickAddAttributes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__quickAddAttributes_QuickAddAttributes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bottomPaneSizer_BottomPaneSizer_vue__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bottomPaneSizer_BottomPaneSizer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bottomPaneSizer_BottomPaneSizer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__definitionActions_DefinitionActions_vue__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__definitionActions_DefinitionActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__definitionActions_DefinitionActions_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TargetDefinition: __WEBPACK_IMPORTED_MODULE_0__targetDefinition__["b" /* default */],
    QuickAddAttributes: __WEBPACK_IMPORTED_MODULE_1__quickAddAttributes_QuickAddAttributes_vue___default.a,
    BottomPaneSizer: __WEBPACK_IMPORTED_MODULE_2__bottomPaneSizer_BottomPaneSizer_vue___default.a,
    DefinitionActions: __WEBPACK_IMPORTED_MODULE_3__definitionActions_DefinitionActions_vue___default.a
  },
  props: {
    targetData: {
      type: Object
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    lasActions: {
      type: Boolean
    },
    xandrActions: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      currentBottomPaneSize: 'medium'
    };
  },

  computed: {
    sizeClass: function sizeClass() {
      return 'is-' + this.currentBottomPaneSize;
    },
    enableSaving: function enableSaving() {
      return this.$store.state.workbench.enableSaving;
    },
    hideQuickAddAttributes: function hideQuickAddAttributes() {
      return this.xandrActions;
    }
  },
  methods: {
    changeBottomPaneSize: function changeBottomPaneSize(size) {
      this.currentBottomPaneSize = size;
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_activation_ActivationModal__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_activation_ActivationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_activation_ActivationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_store_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    allowDownloadBtn: {
      type: Boolean
    },
    targetData: {
      type: Object
    },
    lasActions: {
      type: Boolean
    },
    xandrActions: {
      type: Boolean
    },
    viewOnly: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      useMockData: this.$store.getters['workbench/xandrUseMockData'],
      hover: false,
      isActivationDialogOpen: false,
      isComponentInitialized: false };
  },

  components: {
    ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__["a" /* default */],
    ActivationModal: __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_activation_ActivationModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var unWatch = this.$watch(function () {
      return _this.$store.getters['workbench/newWorkbenchTarget'];
    }, function (wbTarget) {
      if (wbTarget) {
        if (_this.isDraft) {
          _this.useMockData = _this.$store.getters['workbench/xandrUseMockData'];
        } else if (wbTarget.xandr_data && wbTarget.xandr_data.query && wbTarget.xandr_data.query.counts.isUsingMockData) {
          _this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_store_actions__["q" /* TOGGLE_MOCK_DATA */], true);
          _this.useMockData = wbTarget.xandr_data.query.counts.isUsingMockData;
        } else {
          _this.useMockData = false;
          if (_this.isUsingMockData) {
            _this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_store_actions__["q" /* TOGGLE_MOCK_DATA */], false);
          }
        }
        unWatch();

        _this.$nextTick(function () {
          setTimeout(function () {
            _this.isComponentInitialized = true;
          }, 100);
        });
      }
    });

    setTimeout(function () {
      if (!_this.isComponentInitialized) {
        _this.isComponentInitialized = true;
      }
    }, 2000);
  },

  computed: {
    has12monthsOfData: function has12monthsOfData() {
      var workbenchData = this.targetData && this.targetData.workbench_data;
      var universe = workbenchData.universe && workbenchData.universe.universe;
      return universe.length >= 12;
    },
    sendDownstreamLabel: function sendDownstreamLabel() {
      return this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED ? 'Retry Activation' : 'Activate';
    },
    enableDownStream: function enableDownStream() {
      var eds = this.$store.state.workbench.enableDownstream;
      return (eds === 'undefined' ? true : eds) && this.targetData && this.targetData.target_definition && this.targetData.target_definition.query && this.targetData.target_definition.query.length > 0;
    },
    enableSaving: function enableSaving() {
      return this.$store.state.workbench.enableSaving;
    },
    isClearAllDisabled: function isClearAllDisabled() {
      return this.enableDefinitionActions ? !this.$store.getters['workbench/hasDefinition'] : true;
    },
    fetchingTarget: function fetchingTarget() {
      return this.$store.getters['workbench/isFetchingTarget'];
    },
    loading: function loading() {
      return this.$store.getters['workbench/loading'];
    },
    enableDefinitionActions: function enableDefinitionActions() {
      return this.$store.getters['workbench/enableDefinitionActions'];
    },
    canNotUndo: function canNotUndo() {
      return this.enableDefinitionActions ? this.$store.getters['workbench/canNotUndo'] : true;
    },
    canNotRedo: function canNotRedo() {
      return this.enableDefinitionActions ? this.$store.getters['workbench/canNotRedo'] : true;
    },
    canNotCancel: function canNotCancel() {
      if (this.targetData && this.targetData.activation_status && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT || this.targetData && this.targetData.activation_status && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].NEW) {
        return false;
      } else if (this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING || this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ASSIGNED || this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED || this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].POSTED || this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED || this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED || this.targetData && this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE || this.fetchingTarget || this.loading) {
        return true;
      }
    },
    currentTarget: function currentTarget() {
      return this.$store.getters['workbench/currentTarget'];
    },
    isModelLALDataReady: function isModelLALDataReady() {
      if (!this.isComponentInitialized) {
        return false;
      }

      var target = this.targetData || this.$store.getters['workbench/newWorkbenchTarget'];
      if (!target) {
        return false;
      }

      if (!target.activation_status) {
        return false;
      }

      if (this.$store.state.workbench.enableSaving === null || this.$store.state.workbench.enableSaving === undefined) {
        return false;
      }

      var hasPermissions = this.$store.getters.hasPublishPermissions;
      if (hasPermissions === null || hasPermissions === undefined) {
        return false;
      }

      return true;
    },
    disableModelLALButton: function disableModelLALButton() {
      return !this.isModelLALDataReady || !(this.isWorking || this.isLive) || this.isWorking && this.disableDownStreamButton || this.enableSaving || !this.$store.getters.hasPublishPermissions || this.hasBeenPreviouslyModeled || this.$store.state.workbench.loadingWorkbench;
    },
    hasBeenPreviouslyModeled: function hasBeenPreviouslyModeled() {
      var target = this.targetData || this.$store.getters['workbench/newWorkbenchTarget'];

      return target && target.xandr_data && target.xandr_data.isModeled === true;
    },
    disableDownStreamButton: function disableDownStreamButton() {
      if (this.isModeled) {
        return false;
      }

      return !this.enableDownStream || this.isDraft || !this.$store.getters.hasPublishPermissions || !this.$store.state.workbench.enableDownstream || !this.$store.getters.hasPublishPermissions || this.viewOnly || this.$store.state.workbench.loadingWorkbench;
    },
    showGenerateEstimate: function showGenerateEstimate() {
      return this.lasActions;
    },
    isUsingMockData: function isUsingMockData() {
      return this.$store.getters['workbench/xandrUseMockData'];
    },
    as: function as() {
      return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status;
    },
    isWorking: function isWorking() {
      return this.as === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
    },
    isDraft: function isDraft() {
      return this.as === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
    },
    isLive: function isLive() {
      return this.as === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    },
    isModeled: function isModeled() {
      return this.as === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELED;
    },
    isModeling: function isModeling() {
      return this.as === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELING;
    },
    isFailed: function isFailed() {
      return this.as === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED;
    },
    showMockData: function showMockData() {
      return this.xandrActions && false;
    },
    showSendDownstream: function showSendDownstream() {
      return this.xandrActions || this.lasActions;
    },
    showModelLAL: function showModelLAL() {
      return this.xandrActions;
    },
    disableSave: function disableSave() {
      return !this.enableSaving;
    },
    saveButtonTitle: function saveButtonTitle() {
      return this.xandrActions && !this.enableDownStream ? 'Please click the Update Insights button before saving' : null;
    },
    disableToolTip: function disableToolTip() {
      return !this.saveButtonTitle || !this.disableSave;
    },
    modelLALButtonLabel: function modelLALButtonLabel() {
      if (this.disableModelLALButton && this.isModelLALDataReady && this.hasBeenPreviouslyModeled) {
        return 'Modeled';
      }
      return 'Model LAL';
    }
  },
  methods: {
    clear: function clear() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_targetDefinition_store_actions__["q" /* CLEAR_DEFINITION */]);
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_common_store_actions__["b" /* RESET_FAMILY_DATASETS */]);
    },
    generateEstimate: function generateEstimate() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* targetRouteHandler */])('ACTIVATE', this.currentTarget);
    },
    save: function save() {
      var user = this.$store.getters['workbench/username'];
      var status = void 0;
      if (this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT || this.targetData.activation_status === __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED) {
        status = __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
      } else {
        status = this.targetData.activation_status;
      }
      var target = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.targetData, { username: user, activation_status: status });
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_common_store_actions__["w" /* SAVE_TARGET */], { target: target });
    },
    undo: function undo() {
      this.$store.dispatch('workbench/undoHistory/UNDO');
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_common_store_actions__["b" /* RESET_FAMILY_DATASETS */]);
    },
    redo: function redo() {
      this.$store.dispatch('workbench/undoHistory/REDO');
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_common_store_actions__["b" /* RESET_FAMILY_DATASETS */]);
    },
    cancel: function cancel() {
      if (!this.canNotCancel) {
        this.$router.go(-1);
      }
    },
    downloadTargetPackage: function downloadTargetPackage() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__["C" /* DOWNLOAD_TARGET_DEFINITION */], {
        targetId: this.currentTarget.id
      });
    },
    toggleMockData: function toggleMockData() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_store_actions__["q" /* TOGGLE_MOCK_DATA */]);
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_Xandr_store_actions__["b" /* SET_ENABLE_UPDATE_INSIGHTS */], true);
      this.useMockData = !this.useMockData;
    },
    submitDownstream: function submitDownstream() {
      if (this.lasActions && !this.has12monthsOfData) {
        __WEBPACK_IMPORTED_MODULE_2__components_common_toasts__["a" /* default */].error({
          title: 'Validation Error',
          message: 'Target must have at least 12 months of data, please update the target and try again.',
          timeout: 5000
        });
      } else {
        this.toggleActivationModal();
      }
    },
    toggleActivationModal: function toggleActivationModal() {
      this.isActivationDialogOpen = !this.isActivationDialogOpen;
    },
    modelLAL: function modelLAL() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_5__appLogic_workbench_common_store_actions__["B" /* MODEL_LAL */]);
    }
  }
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_tabs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__primary__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__primary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__primary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__secondary__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__secondary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__secondary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appLogic_workbench_Xandr_store_actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_simpleButton__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_Xandr_newMoreIcon_sm_png__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_Xandr_newMoreIcon_sm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_Xandr_newMoreIcon_sm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(649);
















var Tabs = __WEBPACK_IMPORTED_MODULE_3__components_common_tabs__["a" /* default */].Tabs,
    Tab = __WEBPACK_IMPORTED_MODULE_3__components_common_tabs__["a" /* default */].Tab;


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_2__components_common_scrollPanel__["a" /* default */],
    Tabs: Tabs,
    Tab: Tab,
    Primary: __WEBPACK_IMPORTED_MODULE_4__primary___default.a,
    Secondary: __WEBPACK_IMPORTED_MODULE_5__secondary___default.a,
    InteractiveSimpleButton: __WEBPACK_IMPORTED_MODULE_9__components_common_simpleButton__["b" /* InteractiveSimpleButton */]
  },
  props: {
    workbenchSlottedValue: {
      type: Object,
      default: undefined
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      moreIcon: __WEBPACK_IMPORTED_MODULE_10__assets_Xandr_newMoreIcon_sm_png___default.a,
      insightsUpdated: false,
      insightsHeaderText: 'Primary Insights',
      useMockData: this.$store.getters['workbench/xandrUseMockData'],
      audienceExpansionChanged: false,

      audienceExpansionEnabled: false,
      allowAudienceExpansionToggle: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.audienceExpansionEnabled = this.audienceExpansionValue;
    this.allowAudienceExpansionToggle = this.allowToggle;

    var isDuplicateTargetAction = this.$store.getters['workbench/targetCreateAction'];
    if (isDuplicateTargetAction) {
      this.configureAudienceExpansionForDuplicate();
      this.updateInsights();
    }
    var unWatch = this.$watch(function () {
      return _this.newWorkbenchTarget;
    }, function (wbTarget) {
      if (wbTarget) {
        _this.audienceExpansionChanged = false;
        if (wbTarget.xandr_data && wbTarget.xandr_data.audienceExpansion != null) {
          _this.audienceExpansionEnabled = wbTarget.xandr_data.audienceExpansion;
          _this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_7__appLogic_workbench_Xandr_store_actions__["t" /* SET_AUDIENCE_EXPANSION */], _this.audienceExpansionEnabled);
        }

        if (wbTarget.activation_status === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
          _this.useMockData = _this.$store.getters['workbench/xandrUseMockData'];
          _this.setInsightsHeaderText(_this.useMockData);
        } else if (wbTarget.xandr_data && wbTarget.xandr_data.query && wbTarget.xandr_data.query.counts.isUsingMockData) {
          _this.setInsightsHeaderText(true);
        } else {
          _this.setInsightsHeaderText(false);
        }
        unWatch();
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapGetters */])({
    isUsingMockData: 'workbench/xandrUseMockData',
    audienceExpansionValue: 'workbench/audienceExpansion',
    allowToggle: 'workbench/allowAudienceExpansionToggle'
  }), {
    audienceExpansion: {
      get: function get() {
        return this.audienceExpansionEnabled;
      },
      set: function set() {}
    },
    disableUpdateInsights: function disableUpdateInsights() {
      if (this.audienceExpansionChanged) {
        return false;
      }

      if ((this.isLive || this.isWorking) && this.insightsLastRefreshedMoreThanWeekAgo) {
        return false;
      }

      var td = this.$store.getters['workbench/newTargetDefinition'];
      return (!this.insightsUpdated && this.isDraft && td.length > 0 ? false : td && td.length === 0 || !this.$store.getters['workbench/xandrUpdateInsightsEnabled']) || this.viewOnly || (this.isLive || this.isFailed && !this.$store.getters['workbench/xandrUpdateInsightsEnabled']) && !this.isDigitalSocialDestination;
    },
    buttonText: function buttonText() {
      return 'Update Insights';
    },
    newWorkbenchTarget: function newWorkbenchTarget() {
      return this.$store.getters['workbench/newWorkbenchTarget'];
    },
    loadingInsights: function loadingInsights() {
      return this.$store.getters['workbench/xandrLoadingInsights'];
    },
    loadingWorkbench: function loadingWorkbench() {
      return this.$store.state.workbench.loadingWorkbench;
    },
    isLive: function isLive() {
      return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    },
    isFailed: function isFailed() {
      return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED;
    },
    isDraft: function isDraft() {
      return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT;
    },
    isWorking: function isWorking() {
      return (this.$store.getters['workbench/newWorkbenchTarget'] || {}).activation_status === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING;
    },
    isDigitalSocialDestination: function isDigitalSocialDestination() {
      return ((this.$store.getters['workbench/newWorkbenchTarget'] || {}).destinations || []).some(function (destination) {
        return [__WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX, __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP].includes(destination);
      });
    },
    insightsLastRefreshedMoreThanWeekAgo: function insightsLastRefreshedMoreThanWeekAgo() {
      var target = this.$store.getters['workbench/newWorkbenchTarget'] || {};
      if (!target.xandr_data || !target.xandr_data.insights_last_updated_at) {
        return true;
      }
      var lastRefreshed = new Date(target.xandr_data.insights_last_updated_at);
      var oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      return lastRefreshed < oneWeekAgo;
    }
  }),
  methods: {
    updateInsights: function updateInsights() {
      var _this2 = this;

      this.insightsUpdated = true;

      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_7__appLogic_workbench_Xandr_store_actions__["t" /* SET_AUDIENCE_EXPANSION */], this.audienceExpansionEnabled);

      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_common_store_actions__["C" /* QUERY_FOR_DATA */]).then(function (resp) {
        if (_this2.isLive && resp && resp.slottedValue && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(resp.slottedValue).length > 0) {
          _this2.autoSaveAfterInsightsUpdate();
        }
      }).catch(function (err) {
        console.error('Error updating insights:', err);
      });

      this.audienceExpansionChanged = false;
    },
    autoSaveAfterInsightsUpdate: function autoSaveAfterInsightsUpdate() {
      var target = this.$store.getters['workbench/newWorkbenchTarget'];
      if (!target || !target.id) {
        console.warn('Cannot auto-save: target not found or missing id');
        return;
      }

      __WEBPACK_IMPORTED_MODULE_8__components_common_toasts__["a" /* default */].info({
        title: 'Auto-saving Target',
        message: 'Automatically saving target after insights update...',
        timeout: 3000
      });

      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_common_store_actions__["w" /* SAVE_TARGET */], {
        target: target,
        ignoreSavePrompt: true
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_8__components_common_toasts__["a" /* default */].success({
          title: 'Auto-save Complete',
          message: 'Target has been automatically saved after insights update.',
          timeout: 4000
        });
      }).catch(function (err) {
        console.error('Auto-save failed:', err);
        __WEBPACK_IMPORTED_MODULE_8__components_common_toasts__["a" /* default */].error({
          title: 'Auto-save Failed',
          message: 'Failed to automatically save target. Please save manually.',
          timeout: 6000
        });
      });
    },
    setInsightsHeaderText: function setInsightsHeaderText() {
      var mockData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.insightsHeaderText = mockData ? 'Primary Insights (Using Mock Data)' : 'Primary Insights';
    },
    onAudienceExpansionToggle: function onAudienceExpansionToggle(value) {
      this.audienceExpansionEnabled = value;

      this.audienceExpansionChanged = true;
    },
    configureAudienceExpansionForDuplicate: function configureAudienceExpansionForDuplicate() {
      var targetDefinition = this.$store.getters['workbench/newTargetDefinition'];
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_7__appLogic_workbench_Xandr_store_actions__["f" /* CONFIGURE_AUDIENCE_EXPANSION */], targetDefinition);
      this.audienceExpansionEnabled = this.audienceExpansionValue;
      this.allowAudienceExpansionToggle = this.allowToggle;
    }
  },
  watch: {
    isUsingMockData: function isUsingMockData() {
      this.insightsHeaderText = this.isUsingMockData ? 'Primary Insights (Using Mock Data)' : 'Primary Insights';
    },
    audienceExpansionValue: function audienceExpansionValue(newValue) {
      this.audienceExpansionEnabled = newValue;
    },
    allowToggle: function allowToggle(newValue) {
      this.allowAudienceExpansionToggle = newValue;
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_Xandr_devicesIcon_png__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_Xandr_devicesIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_Xandr_devicesIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_Xandr_householdIcon_png__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_Xandr_householdIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_Xandr_householdIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_Xandr_peopleIcon_png__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_Xandr_peopleIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_Xandr_peopleIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__ = __webpack_require__(3);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_3__components_common_scrollPanel__["a" /* default */]
  },
  props: {
    loadingInsights: {
      type: Boolean
    },
    loadingWorkbench: {
      type: Boolean,
      default: false
    },
    primaryInsights: {
      type: Object,
      default: function _default() {
        return {
          queryId: 'xxxx-xxxx-xxxx',
          counts: {}
        };
      }
    }
  },
  data: function data() {
    return {
      houseIcon: __WEBPACK_IMPORTED_MODULE_6__assets_Xandr_householdIcon_png___default.a,
      peopleIcon: __WEBPACK_IMPORTED_MODULE_7__assets_Xandr_peopleIcon_png___default.a,
      deviceIcon: __WEBPACK_IMPORTED_MODULE_5__assets_Xandr_devicesIcon_png___default.a,
      deviceCardData: [],
      householdCardData: [],
      insights: {},
      overlayMessage: '',
      peopleCardData: [],
      initialOverlay: true,
      insightUpdateError: false,
      loopOverlayMessageInterval: null,
      loadingMessages: ['Computing the secret to life, the universe, and everything.', "Let's take a mindfulness minute...", "Don't break your screen yet!", "We're making you a cookie.", 'Spinning the wheel of fortune...', 'Loading the enchanted bunny...', 'Computing chance of success', 'I feel like I am supposed to be loading something. . .', "We're testing your patience", 'Swapping time and space...', 'Looking for exact change', 'Granting wishes...', 'Time flies when you are having fun.', 'How did you get here?', 'Please hold on as we reheat our coffee', 'Ordering 1s and 0s...', "Help, I'm trapped in a loader!", 'Pushing pixels...', 'How about this weather, eh?', 'Time flies like an arrow; fruit flies like a banana', 'Doing the heavy lifting', "We're working very Hard .... Really", "No, I'm awake. I was just resting my eyes.", 'One mississippi, two mississippi...', 'TODO: Insert elevator music', 'Brewing potions with Snape...', 'Waiting for the Hogwarts Express at platform 9¾...', 'Playing a quick game of Quidditch...', 'Consulting the Sorting Hat...', 'Summoning a Patronus to chase the Dementors away...', 'Casting Lumos to light up your screen...', 'Looking for the Golden Snitch...', 'Sending owls with your message...', 'Conjuring some Butterbeer in the Three Broomsticks...', 'Tuning the strings on the Weird Sisters’ guitars...', 'Trying to find the Room of Requirement...', 'Fetching ingredients for a Felix Felicis...', 'Asking Nearly Headless Nick for directions...', 'Perfecting our swish and flick for Wingardium Leviosa...', 'Checking in with Dumbledore’s Army...', 'Sneaking through the Forbidden Forest...', 'Reading tea leaves with Professor Trelawney...', 'Visiting Gringotts for some extra gold...', 'Charging up with a Gillyweed snack...', 'Waiting for Madam Pomfrey in the infirmary...', 'Crafting wands at Ollivanders...', 'Fetching a book from the Restricted Section of the library...', 'Gathering the house elves for a kitchen raid...', 'Negotiating with Peeves for a smoother site loading...', 'Summoning dragons…', 'Hiring minions to speed things up...', 'Warming up the hamsters...', 'Feel free to daydream...', 'Knitting socks for kittens...', 'Digging the garden of data...', 'Cranking up the awesome oscillator...', "Herding cats, it's harder than it looks...", 'Looking under the couch for the remote...', 'Reticulating splines, whatever that means...', 'Trying to feel quantum entangled...', 'Counting infinity, just give us a sec...', 'Whispering to clouds for better weather...', 'Polishing the moon boots...', 'Rolling the magic dice...', 'Brewing a fresh pot of internet...', 'Procrastinating on loading procrastination message...', 'Deciding what to eat for lunch...', 'Charging our psychic powers...', "Sharpening our unicorn's horn...", 'Dusting off the cobwebs in the server room...', 'Unfolding origami bytes...', 'Playing rock-paper-scissors to determine load order...', 'Holding a purring contest with the neighborhood cats...', 'Fetching the laser pointer...', 'Distracting the cats with shiny objects...', 'Building a cardboard fortress...', 'Knitting tiny cat sweaters...', 'Deciding on the purrfect nap spot...', 'Opening a fresh can of tuna...', 'Paw-painting the masterpieces...', 'Searching for the lost toy under the couch...', 'Catching the dot. Finally almost there...', 'Unraveling the mysteries of the red dot...', 'Recording purrs for stress relief...', 'Negotiating with the cat for more keyboard space...', 'Calling on Batman to secure the Batcave...', 'Assembling the Justice League...', "Charging the Green Lantern's power ring...", 'Tuning the Lasso of Truth...', 'Synchronizing the multiverse...', 'Tracking down The Flash to speed things up...', 'Designing new suits at Wayne Enterprises...', "Fetching water from Aquaman's kingdom...", "Aligning the planets with Superman's help...", 'Decrypting codes with Cyborg...', "Harley Quinn's causing a little mischief...", "Activating Wonder Woman's Amazonian strength...", "Testing Joker's latest prank gadgets...", 'Calibrating the Bat-Signal...', 'Ironing capes in the Batcave...', 'Gathering Martian Manhunter from the shadows...', 'Consulting with Alfred Pennyworth for advice...', 'Polishing the Batmobile, almost ready for a spin...', 'Preparing Poison Ivy’s botanical specimens...', "Checking durability of Black Canary's sonic devices...", 'Crafting arrows with Green Arrow...', 'Refueling the Invisible Jet for Wonder Woman...']
    };
  },

  computed: {
    queryErrored: function queryErrored() {
      return this.$store.state.workbench.xandr_workbench.queryErroredOut;
    },
    showOverlay: function showOverlay() {
      return this.queryErrored || this.loadingInsights || this.initialOverlay || this.loadingWorkbench;
    },
    isHouseholdDataAvailable: function isHouseholdDataAvailable() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.householdCardData).length > 0;
    },
    isDeviceDataAvailable: function isDeviceDataAvailable() {
      return this.deviceCardData.length > 0;
    },
    newWorkbenchTarget: function newWorkbenchTarget() {
      return this.$store.getters['workbench/newWorkbenchTarget'];
    },
    isUsingMockData: function isUsingMockData() {
      return this.$store.getters['workbench/xandrUseMockData'];
    },
    primaryInsightsFilter: function primaryInsightsFilter() {
      return this.$store.getters.primaryInsightsFilter;
    },
    deviceIdCardsClass: function deviceIdCardsClass() {
      return this.deviceCardData.length < 3 ? 'justify-center d-flex flex-wrap mb-2' : 'justify-start d-flex flex-wrap mb-2';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.insights = this.primaryInsights;

    var unWatch = this.$watch(function () {
      return _this.newWorkbenchTarget;
    }, function (wbTarget) {
      if (wbTarget) {
        if (wbTarget.activation_status === __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
          if (_this.insights && _this.insights.counts) {
            _this.insights.counts.isUsingMockData = _this.$store.getters['workbench/xandrUseMockData'];
          }
        } else if (wbTarget.xandr_data && wbTarget.xandr_data.query && wbTarget.xandr_data.query.counts.isUsingMockData) {
          if (_this.insights && _this.insights.counts) {
            _this.insights.counts.isUsingMockData = true;
          }
        } else {
          if (_this.insights.counts.hasOwnProperty('isUsingMockData')) {
            delete _this.insights.counts.isUsingMockData;
          }
        }
        unWatch();
      }
    });
    this.draw();
    this.showInitialOverlayMessage();
  },

  methods: {
    draw: function draw() {
      if (this.insights.counts) {
        var granularDevices = Array.isArray(this.insights.counts.granularDevices) ? this.insights.counts.granularDevices : null;
        this.resetCardData();
        if (granularDevices) {
          this.findHouseholdData(granularDevices);
          this.findDeviceData(granularDevices);
        }
      }
    },
    findDeviceData: function findDeviceData(granularDevices) {
      var deviceIdsFilter = this.primaryInsightsFilter.deviceIds;
      this.deviceCardData = granularDevices.filter(function (device) {
        if (deviceIdsFilter.show.length > 0) {
          return deviceIdsFilter.show.includes(device.idType);
        } else if (deviceIdsFilter.hide.length > 0) {
          return !deviceIdsFilter.hide.includes(device.idType);
        }
        return true;
      }).map(function (device) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(deviceIdsFilter.rename) === 'object' && deviceIdsFilter.rename.hasOwnProperty(device.idType)) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, device, { idType: deviceIdsFilter.rename[device.idType] });
        } else {
          return device;
        }
      });
    },
    findHouseholdData: function findHouseholdData(granularDevices) {
      var householdIdsFilter = this.primaryInsightsFilter.houseHoldIds;
      this.householdCardData = granularDevices.filter(function (device) {
        if (householdIdsFilter.show.length > 0) {
          return householdIdsFilter.show.includes(device.idType);
        } else if (householdIdsFilter.hide.length > 0) {
          return !householdIdsFilter.hide.includes(device.idType);
        }
        return true;
      }).map(function (device) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(householdIdsFilter.rename) === 'object' && householdIdsFilter.rename.hasOwnProperty(device.idType)) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, device, { idType: householdIdsFilter.rename[device.idType] });
        } else {
          return device;
        }
      });
    },
    formattedCount: function formattedCount(count, idType) {
      if (!count && count !== 0) {
        return 'N/A';
      }
      var formattedCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["n" /* newSmallNumber */])(count, 1);
      return formattedCount;
    },
    showInitialOverlayMessage: function showInitialOverlayMessage() {
      this.insightUpdateError = false;
      this.overlayMessage = 'Stats will be available when you have \n added at least one target attribute \n and select Update Insights.';
    },
    showLoadingOverlayMessage: function showLoadingOverlayMessage() {
      var _this2 = this;

      this.insightUpdateError = false;
      this.overlayMessage = 'Your information is loading, please stand by while we retrieve your target attribute stats...';
      this.loopOverlayMessageInterval = setInterval(function () {
        _this2.overlayMessage = _this2.loadingMessages[Math.floor(Math.random() * _this2.loadingMessages.length)];
      }, 10000);
    },
    showLoadingWorkbenchOverlayMessage: function showLoadingWorkbenchOverlayMessage() {
      var _this3 = this;

      this.insightUpdateError = false;
      this.overlayMessage = 'Updating segment and loading workbench...';
      this.loopOverlayMessageInterval = setInterval(function () {
        _this3.overlayMessage = _this3.loadingMessages[Math.floor(Math.random() * _this3.loadingMessages.length)];
      }, 10000);
    },
    showLoadErrMessage: function showLoadErrMessage() {
      this.insightUpdateError = true;
      this.overlayMessage = 'Insights were unable to be updated.';
    },
    resetCardData: function resetCardData() {
      this.householdCardData = [];
      this.deviceCardData = [];
    }
  },
  watch: {
    loadingInsights: function loadingInsights() {
      if (this.loadingInsights) {
        if (this.loadingInsights) {
          this.initialOverlay = false;
          this.showLoadingOverlayMessage();
        } else {
          this.showInitialOverlayMessage();
        }
      } else {
        clearInterval(this.loopOverlayMessageInterval);
      }
    },
    loadingWorkbench: function loadingWorkbench() {
      if (this.loadingWorkbench) {
        this.initialOverlay = false;
        this.showLoadingWorkbenchOverlayMessage();
      } else {
        clearInterval(this.loopOverlayMessageInterval);
      }
    },
    primaryInsights: function primaryInsights() {
      this.initialOverlay = false;
      this.insights = this.primaryInsights;
      this.draw();
    },
    isUsingMockData: function isUsingMockData() {
      if (this.isUsingMockData) {
        this.insights.counts.isUsingMockData = true;
      } else {
        if (this.insights.counts.hasOwnProperty('isUsingMockData')) {
          delete this.insights.counts.isUsingMockData;
        }
      }
    },
    queryErrored: function queryErrored() {
      if (this.queryErrored) {
        this.showLoadErrMessage();
      }
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      secondaryInsightViewershipMockData: {
        segmentAffinities: [{
          segment: 'Luxury Traveler',
          value: '1.5x'
        }, {
          segment: 'Millenial',
          value: '2.5x'
        }, {
          segment: 'Insurance Seeker',
          value: '3.2x'
        }, {
          segment: 'Sports Fan',
          value: '4.7x'
        }, {
          segment: 'C-Suite',
          value: '4.7x'
        }],
        digitalAffinities: [{
          property: 'TNT',
          monthlyUnique: 17500000
        }, {
          property: 'NCAA',
          monthlyUnique: 17000000
        }, {
          property: 'ADULT SWIM',
          monthlyUnique: 16.700000
        }, {
          property: 'PGA',
          monthlyUnique: 15900000
        }, {
          property: 'BLEACHER REPORT',
          monthlyUnique: 15000000
        }, {
          property: 'TCM',
          monthlyUnique: 12200000
        }, {
          property: 'NBA',
          monthlyUnique: 9000000
        }, {
          property: 'TBS',
          monthlyUnique: 5500000
        }, {
          property: 'FILMSTRUCK',
          monthlyUnique: 2300000
        }, {
          property: 'TRUE TV',
          monthlyUnique: 907000
        }],
        viewership: [{
          id: 1,
          network: 'CNN',
          comp: '63%',
          reach: '22M',
          indexVal: '109'
        }, {
          id: 2,
          network: 'TBS',
          comp: '16%',
          reach: '60M',
          indexVal: '103'
        }, {
          id: 3,
          network: 'TNT',
          comp: '38%',
          reach: '83M',
          indexVal: '103'
        }, {
          id: 4,
          network: 'TOON',
          comp: '45%',
          reach: '3M',
          indexVal: '99'
        }, {
          id: 5,
          network: 'TRU TV',
          comp: '32%',
          reach: '23.4M',
          indexVal: '112'
        }, {
          id: 6,
          network: 'BOOM',
          comp: '5%',
          reach: '5M',
          indexVal: '91'
        }, {
          id: 7,
          network: 'HLN',
          comp: '20%',
          reach: '21M',
          indexVal: '102'
        }, {
          id: 8,
          network: 'AS',
          comp: '50%',
          reach: '100M',
          indexVal: '155'
        }, {
          id: 9,
          network: 'TCM',
          comp: '34%',
          reach: '13.8M',
          indexVal: '91'
        }, {
          id: 10,
          network: 'GSN',
          comp: '32%',
          reach: '23.4M',
          indexVal: '112'
        }]
      }
    };
  },

  methods: {
    formattedCount: function formattedCount(count) {
      if (!count) {
        return 'N/A';
      }
      var formattedCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["m" /* smallNumber */])(count, 1);
      return formattedCount;
    }
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_WorkbenchRow__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_WorkbenchRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_WorkbenchRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audienceSize__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dayParts__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__viewership__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__universeStability__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_workbench_LAS_store_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__ = __webpack_require__(3);


var DEFAULT_VIEWERSHIP = 'aalive3';














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AudienceSize: __WEBPACK_IMPORTED_MODULE_3__audienceSize__["a" /* default */],
    DayParts: __WEBPACK_IMPORTED_MODULE_4__dayParts__["a" /* default */],
    Viewership: __WEBPACK_IMPORTED_MODULE_5__viewership__["a" /* default */],
    WorkbenchRow: __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_WorkbenchRow___default.a,
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__["a" /* default */],
    LoaderDots: __WEBPACK_IMPORTED_MODULE_7__components_common_loaderDots__["a" /* default */],
    UniverseStability: __WEBPACK_IMPORTED_MODULE_6__universeStability__["a" /* default */]
  },
  props: {
    workbenchSlottedValue: {
      type: Object,
      default: undefined
    }
  },
  data: function data() {
    return {
      viewershipRowHeight: null,
      universeRowHeight: null
    };
  },

  computed: {
    wsv: function wsv() {
      return this.workbenchSlottedValue;
    },
    w: function w() {
      return this.$store.state.workbench;
    },
    las: function las() {
      return this.w ? this.w.las_workbench : {};
    },
    lasState: function lasState() {
      return this.wsv ? this.wsv.lasState : null;
    },
    viewershipData: function viewershipData() {
      return this.wsv ? this.wsv.viewershipData : {};
    },
    networks: function networks() {
      return this.wsv && this.wsv.networks ? this.wsv.networks : [];
    },
    audienceSize: function audienceSize() {
      return this.wsv ? this.wsv.audienceSize : 0;
    },
    viewership: function viewership() {
      return this.wsv && this.wsv.lasState ? this.wsv.lasState.viewingSource : DEFAULT_VIEWERSHIP;
    },
    universeData: function universeData() {
      return this.wsv ? this.wsv.universeData : {};
    },
    dayPartsCofig: function dayPartsCofig() {
      return this.$store.state.appRes.dayParts;
    },
    validStreamingOptions: function validStreamingOptions() {
      return this.las.validStreamingOptions || ['C3'];
    },
    selectedViewershipNetworks: function selectedViewershipNetworks() {
      return this.lasState ? this.lasState.selectedViewershipNetworks : [];
    },
    selectedDayPartNetworks: function selectedDayPartNetworks() {
      return this.lasState ? this.lasState.selectedDayPartNetworks : [];
    },
    loading: function loading() {
      return this.las && this.las.loading !== undefined ? this.las.loading : true;
    },
    targetDefinition: function targetDefinition() {
      return this.$store.getters['workbench/newTargetDefinition'];
    }
  },
  methods: {
    setRowSizes: function setRowSizes() {
      if (this.canvasEl && this.canvasEl.clientHeight) {
        var canvasHeight = this.canvasEl.clientHeight;
        var vp = 0.7;
        var up = 0.3;

        if (canvasHeight < 480) {
          canvasHeight = 480;
        }

        if (canvasHeight < 650) {
          vp = 0.6;
          up = 0.4;
        }
        this.viewershipRowHeight = canvasHeight * vp - 15 + 'px';
        this.universeRowHeight = canvasHeight * up - 15 + 'px';
      }
    },
    onSelectedViewingStream: function onSelectedViewingStream(selected) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appLogic_workbench_LAS_store_actions__["b" /* SET_VIEWING_STREAM */], selected);
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_8__appLogic_workbench_common_store_actions__["z" /* UPDATE_TARGET_DEFINITION_RELATED_INFORMATION */]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.canvasEl = document.querySelector('#canvas');
    document.querySelector('html').classList.add('workbench-resize');
    this.setRowSizes();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"])(this.canvasEl, function () {
      _this.setRowSizes();
    });
    var initialLoad = false;
    if (this.w.workbenchTarget.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS) {
      initialLoad = !(this.w.workbenchTarget.activation_status === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT);
    }
    this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_8__appLogic_workbench_common_store_actions__["z" /* UPDATE_TARGET_DEFINITION_RELATED_INFORMATION */], initialLoad);
  },

  watch: {
    targetDefinition: {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== undefined && this.w && this.w.workbenchTarget && this.w.workbenchTarget.target === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS) {
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appLogic_workbench_LAS_store_actions__["c" /* SET_LOADING */], true);
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_audience_svg__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_truncateAmount__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon_index__["a" /* default */],
    ViewershipTimeFrame: __WEBPACK_IMPORTED_MODULE_3__ViewershipTimeFrame___default.a
  },
  filters: {
    truncateAmount: __WEBPACK_IMPORTED_MODULE_2__filters_truncateAmount__["a" /* default */]
  },
  props: {
    size: Number,
    viewershipOption: String,
    validStreamingOptions: Array,
    onSelectedViewingStream: Function
  },
  data: function data() {
    return {
      audience: __WEBPACK_IMPORTED_MODULE_1__assets_svg_audience_svg__["a" /* default */]
    };
  },

  computed: {
    displaySize: function displaySize() {
      return this.size || this.size === 0 ? this.size : null;
    }
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__ = __webpack_require__(3);







var viewershipOptions = [{
  name: 'Live',
  value: 'aalive'
}, {
  name: 'LSD',
  value: 'aalivesd'
}, {
  name: 'C3',
  value: 'aalive3'
}, {
  name: 'C7',
  value: 'aalive7'
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    selectedViewshipOption: String,
    validStreamingOptions: Array
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_1__assets_svg_arrow_svg__["a" /* default */],
      popover: null
    };
  },

  computed: {
    selectedText: function selectedText() {
      var _this = this;

      return viewershipOptions.find(function (option) {
        return option.value === _this.selectedViewshipOption;
      }).name;
    }
  },
  methods: {
    clickHandler: function clickHandler(e) {
      var _this2 = this;

      if (this.$store.state.currentTarget.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_3__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_common_popover__["b" /* createPopover */])({
        direction: 'bottom',
        list: viewershipOptions.filter(function (v) {
          return _this2.validStreamingOptions.includes(v.name);
        }),
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_2__components_common_popover__["c" /* popoverTypes */].TEXTLIST
      });
      this.popover.$on('select', function (selected) {
        _this2.$emit('selected', selected);
      });
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DayPartsGraph__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_cancel_svg__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_LAS_store_actions__ = __webpack_require__(104);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DayPartsGraph: __WEBPACK_IMPORTED_MODULE_0__DayPartsGraph__["a" /* default */],
    DayPartsLegend: __WEBPACK_IMPORTED_MODULE_1__DayPartsLegend_vue___default.a,
    SvgIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__["a" /* default */]
  },
  props: {
    selectedNetworks: {
      type: Array,
      required: true
    },
    viewershipData: {
      type: Object,
      required: true
    },
    networks: {
      type: Array,
      required: true
    },
    dayPartsConfig: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      closeIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_cancel_svg__["a" /* default */],
      selectedDayParts: []
    };
  },

  methods: {
    clickHandler: function clickHandler() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_LAS_store_actions__["p" /* REMOVE_ALL_DAY_PART_NETWORKS */]);
    },
    dayPartSelected: function dayPartSelected(id) {
      var alreadySelected = this.selectedDayParts.indexOf(id);
      if (alreadySelected > -1) {
        this.selectedDayParts.splice(alreadySelected, 1);
        return;
      }
      this.selectedDayParts.push(id);
    },
    removeHiddenDayParts: function removeHiddenDayParts(chartData) {
      var _this = this;

      var filteredData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(chartData.datasets, function (dataset) {
        return _this.selectedDayParts.indexOf(dataset.title) === -1;
      });
      var data = {
        datasets: filteredData
      };
      return data;
    },
    deSelectNetwork: function deSelectNetwork(network) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_6__appLogic_workbench_LAS_store_actions__["o" /* REMOVE_FROM_SELECTED_DAY_PART_NETWORKS */], network);
    }
  },
  computed: {
    dayPartAxises: function dayPartAxises() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__["c" /* historicalViewershipGraphAxises */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__["d" /* extractDayPartsData */])(this.viewershipData));
    },
    hydratedSelectedNetworks: function hydratedSelectedNetworks() {
      var _this2 = this;

      return this.selectedNetworks.map(function (networkId) {
        var network = _this2.networks.find(function (dayPart) {
          return dayPart.id === networkId;
        });
        return network || {
          id: networkId,
          name: networkId
        };
      });
    },
    networksToShow: function networksToShow() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_lasGraphs_chartDataHelpers__["e" /* transformViewershipDataForDayParts */])(this.viewershipData, this.hydratedSelectedNetworks, this.dayPartsConfig);
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    parts: {
      type: Array,
      required: true
    },
    selectedParts: {
      type: Array,
      required: true
    }
  },
  computed: {
    sortedDayParts: function sortedDayParts() {
      return this.sortDayParts(this.parts);
    }
  },
  methods: {
    emitDayPart: function emitDayPart(id) {
      this.$emit('day-part-click', id);
    },
    isSelected: function isSelected(id) {
      return this.selectedParts.indexOf(id) > -1;
    },
    sortDayParts: function sortDayParts(dayparts) {
      var sortedOrder = [];
      var sortOrder = ['Weekday Morning', 'Weekend Daytime', 'Weekday Daytime', 'Early Fringe', 'Prime Time', 'Late Fringe'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sortOrder), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var so = _step.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dayparts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _dp = _step3.value;

              if (_dp.name === so) {
                sortedOrder.push(_dp);
                break;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(dayparts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var dp = _step2.value;

          var accepted = false;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sortedOrder), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var sd = _step4.value;

              if (dp.name === sd.name) {
                accepted = true;
                break;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          if (!accepted) {
            sortedOrder.push(dp);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return sortedOrder;
    }
  }
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_graphs_UniverseStabilityGraph__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_apiErrorMessage_ApiErrorMessage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_apiErrorMessage_ApiErrorMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_circle_error_svg__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_circle_check_svg__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_math_utility__ = __webpack_require__(757);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UniverseStabilityGraph: __WEBPACK_IMPORTED_MODULE_0__appComponents_graphs_UniverseStabilityGraph__["a" /* default */],
    SvgIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__["a" /* default */],
    ApiErrorMessage: __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default.a
  },
  props: {
    universe: {
      type: Object
    },
    hideStabilityFlag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      stableText: 'Looking good! This universe is stable.',
      unstableText: 'This universe is not stable. It is too volatile.',
      error: __WEBPACK_IMPORTED_MODULE_3__assets_svg_circle_error_svg__["a" /* default */],
      pass: __WEBPACK_IMPORTED_MODULE_4__assets_svg_circle_check_svg__["a" /* default */]
    };
  },

  computed: {
    universeChartData: function universeChartData() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_lasGraphs_chartDataHelpers__["a" /* transformUniverseDataForGraph */])(this.universe);
    },
    universeIsStable: function universeIsStable() {
      var result = false;
      var hasUniverse = this.universe && this.universe.universe && this.universe.universe.length > 0;
      if (hasUniverse) {
        var universeValues = this.universe.universe.map(function (u) {
          return u.size;
        });
        var stability = null;
        if (universeValues.length < 2) {
          stability = 1;
        } else {
          stability = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_math_utility__["a" /* standardDeviation */])(universeValues) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_math_utility__["b" /* mean */])(universeValues);
        }
        if (stability < 1 && this.universe.audience > 10000000) {
          result = true;
        }
      }
      return result;
    }
  }
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ViewershipGraph__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_toggleButton__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_tables__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dateRange__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_graphs_bubbleLabelPlugin__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_lasGraphs_chartDataHelpers__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ViewershipFilter: __WEBPACK_IMPORTED_MODULE_6__ViewershipFilter_vue___default.a,
    ViewershipGraph: __WEBPACK_IMPORTED_MODULE_1__ViewershipGraph__["a" /* default */],
    DateRange: __WEBPACK_IMPORTED_MODULE_4__dateRange__["a" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_5__components_common_actionButton__["a" /* default */],
    ApiErrorMessage: __WEBPACK_IMPORTED_MODULE_7__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default.a,
    ToggleButton: __WEBPACK_IMPORTED_MODULE_2__components_common_toggleButton__["a" /* default */],
    StyledTable: __WEBPACK_IMPORTED_MODULE_3__components_common_tables__["a" /* StyledTable */]
  },
  props: {
    viewershipData: {
      type: Object
    },
    selectedNetworks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    networks: {
      type: Array,
      required: true
    },
    selectedDayPartNetworks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    isGraphOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      changeToTable: true,
      tableSorting: {
        prop: 'size',
        order: 'desc'
      },
      networksToHide: [],
      overRideBubble: {
        min: 15,
        max: 60
      },
      tableHeaders: [{
        text: 'Network',
        value: 'name',
        align: 'left',
        sortable: true
      }, {
        text: 'Audience Size',
        value: 'size',
        align: 'left',
        sortable: true
      }],

      allowViewershipToRender: false
    };
  },

  computed: {
    dataForGraph: function dataForGraph() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_lasGraphs_chartDataHelpers__["b" /* transformHistoricalViewershipGraphData */])(this.networks, this.viewershipData, this.selectedDayPartNetworks, this.overRideBubble);
    },
    dataForTable: function dataForTable() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["map"])(this.viewershipData, function (value, key) {
        return {
          name: key,
          index: value.index,
          rating: value.rating,
          size: value.size
        };
      }), this.tableSorting.prop, this.tableSorting.order);
    },
    axises: function axises() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_lasGraphs_chartDataHelpers__["c" /* historicalViewershipGraphAxises */])(this.viewershipData);
    },
    isTargetActivated: function isTargetActivated() {
      return this.$store.getters.isTargetActivated;
    }
  },
  methods: {
    formatIndex: __WEBPACK_IMPORTED_MODULE_8__helpers__["a" /* formatIndex */],
    formatRating: __WEBPACK_IMPORTED_MODULE_8__helpers__["b" /* formatRating */],
    formatAudienceSize: __WEBPACK_IMPORTED_MODULE_8__helpers__["c" /* formatAudienceSize */],
    toggleDisplayOfData: function toggleDisplayOfData() {
      this.changeToTable = !this.changeToTable;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      this.tableSorting.prop = prop;
      this.tableSorting.order = order === 'descending' ? 'desc' : 'asc';
    },
    toggleNetworksModal: function toggleNetworksModal() {
      this.$refs.filter.open();
    },
    resizeBubbleToWidth: function resizeBubbleToWidth(updatedWidth) {
      if (updatedWidth < 1281) {
        this.overRideBubble.max = 32;
        this.overRideBubble.min = 8;
      } else if (updatedWidth < 1400) {
        this.overRideBubble.max = 48;
        this.overRideBubble.min = 12;
      } else if (updatedWidth >= 1700) {
        this.overRideBubble.max = 60;
        this.overRideBubble.min = 15;
      }
    },
    initResizeOneGraph: function initResizeOneGraph() {
      if (!this.allowViewershipToRender) {
        this.allowViewershipToRender = true;
        this.$nextTick(function () {
          var _this = this;

          if (this.$refs && this.$refs.viewershipGraph && this.$refs.viewershipGraph.$el) {
            var viewershipGraph = this.$refs.viewershipGraph.$el;
            this.resizeBubbleToWidth(viewershipGraph.clientWidth);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"])(viewershipGraph, function () {
              var updatedWidth = viewershipGraph.clientWidth;
              _this.resizeBubbleToWidth(updatedWidth);
            });
          }
        });
      }
    },
    viwershipOnClick: function viwershipOnClick(network) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_12__appLogic_targets_currentTarget_store_actions__["c" /* SELECT_NETWORK_DAY_PART */], network);
    },
    resetBubbles: function resetBubbles() {
      if (!this.dataForGraph) return;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__appComponents_graphs_bubbleLabelPlugin__["a" /* setDataForBubblesPlugin */])(this.dataForGraph.datasets);
      this.$nextTick(function () {
        this.initResizeOneGraph();
      });
    }
  },
  mounted: function mounted() {
    this.resetBubbles();
  },

  watch: {
    'viewershipData': function viewershipData() {
      this.allowViewershipToRender = true;
      this.resetBubbles();
    },
    'dataForGraph': function dataForGraph() {
      this.resetBubbles();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var viewership = this.$refs.ViewershipGraph;
    if (viewership && viewership.$el) {
      __WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"].detach(this.$refs.viewershipGraph.$el);
    }
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appLogic_workbench_LAS_store_actions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tabs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__ = __webpack_require__(17);






var Tabs = __WEBPACK_IMPORTED_MODULE_2__components_common_tabs__["a" /* default */].Tabs,
    Tab = __WEBPACK_IMPORTED_MODULE_2__components_common_tabs__["a" /* default */].Tab;


var MAX_LIMIT_OF_NETWORKS = 15;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_common_modal_Modal_vue___default.a,
    Tabs: Tabs,
    Tab: Tab,
    ActionButton: __WEBPACK_IMPORTED_MODULE_4__components_common_actionButton__["a" /* default */]
  },
  props: {
    networks: {
      type: Array,
      required: true
    },
    selectedNetworks: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      copyOfSelectedNetworks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.selectedNetworks),
      maxNumberOfNetworks: MAX_LIMIT_OF_NETWORKS
    };
  },

  computed: {
    turnerNetworks: function turnerNetworks() {
      return this.networks.filter(function (net) {
        return net.turner;
      });
    },
    nonTurnerNetworks: function nonTurnerNetworks() {
      return this.networks.filter(function (net) {
        return net.turner === false;
      });
    },
    currentLength: function currentLength() {
      return this.copyOfSelectedNetworks.length;
    },
    errorNoNetworks: function errorNoNetworks() {
      return this.currentLength === 0;
    },
    errorToManySelected: function errorToManySelected() {
      return this.currentLength > MAX_LIMIT_OF_NETWORKS;
    },
    disableSubmit: function disableSubmit() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"])(this.copyOfSelectedNetworks, this.selectedNetworks) || this.errorNoNetworks || this.errorToManySelected;
    }
  },
  methods: {
    hasUrl: function hasUrl(network) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(network.url);
    },
    isSelected: function isSelected(id) {
      return this.copyOfSelectedNetworks.indexOf(id) > -1;
    },
    selectNetwork: function selectNetwork(id) {
      this.$emit('select', id);
      var selected = this.copyOfSelectedNetworks.indexOf(id);
      selected > -1 ? this.copyOfSelectedNetworks.splice(selected, 1) : this.copyOfSelectedNetworks.push(id);
    },
    open: function open() {
      this.copyOfSelectedNetworks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.selectedNetworks);
      this.$refs.networksFilterModal.open();
    },
    close: function close() {
      this.$refs.networksFilterModal.close();
      this.$emit('close');
    },
    submitNewSelection: function submitNewSelection() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_0__appLogic_workbench_LAS_store_actions__["q" /* SET_SELECTED_NETWORKS */], this.copyOfSelectedNetworks);
      this.$emit('newSelection', this.copyOfSelectedNetworks);
      this.close();
    }
  }
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_arrow_svg__ = __webpack_require__(45);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      arrow: __WEBPACK_IMPORTED_MODULE_4__assets_svg_arrow_svg__["a" /* default */],
      popover: null
    };
  },

  computed: {
    isActivated: function isActivated() {
      return this.$store.getters.isTargetActivated;
    },
    startDate: function startDate() {
      return this.$store.getters.dateRange.startDate;
    },
    startDateName: function startDateName() {
      return this.startDate ? this.startDate.name : '----';
    },
    endDate: function endDate() {
      return this.$store.getters.dateRange.endDate;
    },
    endDateName: function endDateName() {
      return this.endDate ? this.endDate.name : '----';
    },
    availableDates: function availableDates() {
      return this.$store.getters.dateRange.availableDates;
    },
    popoverStartList: function popoverStartList() {
      return this.availableDates.slice(0, this.availableDates.indexOf(this.endDate) + 1).map(function (date) {
        return {
          name: date.name,
          value: date.from
        };
      });
    },
    popoverEndList: function popoverEndList() {
      return this.availableDates.slice(this.availableDates.indexOf(this.startDate), this.availableDates.length).map(function (date) {
        return {
          name: date.name,
          value: date.to
        };
      }).reverse();
    }
  },
  methods: {
    createStartPopover: function createStartPopover(e) {
      var _this = this;

      if (this.isActivated) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_common_popover__["b" /* createPopover */])({
        direction: 'bottom',
        list: this.popoverStartList,
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_2__components_common_popover__["c" /* popoverTypes */].TEXTLIST
      });
      this.popover.$on('select', function (selected) {
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["b" /* UPDATE_START_DATE */], selected);
        _this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_1__appLogic_workbench_common_store_actions__["z" /* UPDATE_TARGET_DEFINITION_RELATED_INFORMATION */]);
      });
    },
    createEndPopover: function createEndPopover(e) {
      var _this2 = this;

      if (this.isActivated) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_common_popover__["b" /* createPopover */])({
        direction: 'bottom',
        list: this.popoverEndList,
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_2__components_common_popover__["c" /* popoverTypes */].TEXTLIST
      });
      this.popover.$on('select', function (selected) {
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_lasGraphs_viewership_dateRange_store_actions__["d" /* UPDATE_END_DATE */], selected);
        _this2.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_1__appLogic_workbench_common_store_actions__["z" /* UPDATE_TARGET_DEFINITION_RELATED_INFORMATION */]);
      });
    }
  }
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyledSelectNew__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyledSelectNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StyledSelectNew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StyledSelectNew: __WEBPACK_IMPORTED_MODULE_0__StyledSelectNew___default.a
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      options: []
    };
  },

  methods: {
    searchOptions: function searchOptions(search, loading) {
      var _this = this;

      if (search.length >= 2) {
        loading(true);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["V" /* searchAdvertisers */])(search).then(function (resp) {
          var sortedResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(resp.data, function (obj) {
            return obj.Name;
          });
          _this.options = sortedResults;
          loading(false);
        }).catch(function (resp) {
          _this.options = [];
          loading(false);
        });
      } else {
        this.options = [];
      }
    },
    emitInput: function emitInput(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




var SIZE = {
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    value: {
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    searchOptions: {
      type: Function,
      default: undefined
    },
    label: {
      type: String,
      default: 'Name'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    returnLabelAsValue: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: SIZE.LARGE
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedValue: null
    };
  },

  computed: {
    showPlaceholder: function showPlaceholder() {
      return !this.fullValue;
    },
    fullValue: function fullValue() {
      var _this = this;

      if (this.value && this.returnLabelAsValue && this.options.length) {
        return this.options.filter(function (v) {
          return v[_this.label] === _this.value;
        })[0];
      } else if (this.value && this.returnLabelAsValue) {
        return this.value;
      } else {
        return this.value;
      }
    },
    isMedium: function isMedium() {
      return this.size === SIZE.MEDIUM;
    }
  },
  methods: {
    preventTheDefault: function preventTheDefault(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    },
    clear: function clear() {
      this.selectedValue = null;
      this.$emity('input', null);
    },
    emitInput: function emitInput(val) {
      if (!val) {} else if (this.returnLabelAsValue && val[this.label]) {
        this.$emit('input', this.returnLabelAsValue ? val ? val[this.label] : val : val);
      } else {
        this.$emit('input', val);
      }
    }
  },
  watch: {},
  mounted: function mounted() {
    this.searchInput = this.$el.querySelector('input[type=search]');
    this.searchInput.addEventListener('keypress', this.preventTheDefault);
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







var PRETTY_NAME_MAP = {
  'headofhouseholdagebreak': 'Age',
  'homestructuretype': 'Dwelling Type',
  'headofhouseholdeducation': 'Education',
  'gender': 'Gender',
  'HasChildren': 'Has Children',
  'homeownershipstatus': 'Home Ownership',
  'householdsize': 'Household Size',
  'householdincome': 'Income'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    viewOnly: Boolean
  },
  data: function data() {
    return {
      popover: null,
      currentActiveAttribute: null
    };
  },

  computed: {
    quickAddAttributes: function quickAddAttributes() {
      return this.$store.getters.quickAddAttributes;
    }
  },
  methods: {
    add: function add(attribute) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_store_actions__["k" /* ADD_ATTRIBUTE */], attribute);
    },
    isActive: function isActive(attribute) {
      return this.currentActiveAttribute === attribute;
    },
    getPrettyName: function getPrettyName(attribute) {
      return PRETTY_NAME_MAP[attribute.id] ? PRETTY_NAME_MAP[attribute.id] : attribute.name;
    },
    attributeClickedHandler: function attributeClickedHandler(attribute, e) {
      if (attribute.type === __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN) {
        this.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(attribute));
      } else {
        this.createPopover(attribute, e);
      }
    },
    createPopover: function createPopover(attribute, e) {
      var _this = this;

      this.currentActiveAttribute = attribute;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_common_popover__["b" /* createPopover */])({
        direction: 'top',
        attribute: attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_0__components_common_popover__["c" /* popoverTypes */].ATTRIBUTE
      });
      this.popover.$on('select', function (attr) {
        _this.add(attr);
      }).$on('dismiss', function () {
        _this.currentActiveAttribute = null;
      });
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);











var SAVE = 'Save';
var KEEP_WORKING = 'Keep Working';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal__["b" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__["a" /* default */]
  },
  props: {
    newXandrTarget: {
      type: Object
    }
  },
  data: function data() {
    return {
      next: null,
      saveButton: SAVE,
      continueWithoutSave: true
    };
  },

  methods: {
    open: function open(next) {
      if (next == null) {
        throw Error('You must pass the next function into this open function in order to continue on the route');
      }
      this.next = next;
      this.$refs.confirm.open();
    },
    cancelHandler: function cancelHandler() {
      if (this.saveButton === SAVE) {
        this.saveButton = KEEP_WORKING;
        var activation_status = this.newXandrTarget.activation_status === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT ? __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING : this.newXandrTarget.activation_status;
        var target = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.newXandrTarget, { activation_status: activation_status });
        this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_3__appLogic_workbench_common_store_actions__["w" /* SAVE_TARGET */], { target: target });
        this.continueWithoutSave = false;
      } else {
        this.$refs.confirm.close();
        this.saveButton = SAVE;
      }
    },
    continueHandler: function continueHandler() {
      if (this.continueWithoutSave && this.newXandrTarget.activation_status === __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
        this.deleteTarget();
      }
      this.next();
    },
    continueAfterSaveHandler: function continueAfterSaveHandler() {
      this.next();
    },
    deleteTarget: function deleteTarget() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(this.newXandrTarget));
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__appLogic_targets_currentTarget_store_actions__["F" /* DELETE_CURRENT_TARGET */], this.newXandrTarget);
    }
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_actionButton__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_TargetName__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_TargetName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_TargetName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_AdvertiserSelect__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_AdvertiserSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_AdvertiserSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_StreamingSelect__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_StreamingSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_StreamingSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_createTarget_components_MVPD_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_createTarget_components_MVPD_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__appComponents_targets_createTarget_components_MVPD_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_components_CampaignDDL__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_components_CampaignDDL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__appComponents_targets_components_CampaignDDL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_targets_components_DayOfWeekDDL__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appComponents_targets_components_DayOfWeekDDL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__appComponents_targets_components_DayOfWeekDDL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appComponents_targets_createTarget_components_FlightDates__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__appComponents_targets_createTarget_components_FlightDates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__appComponents_targets_createTarget_components_FlightDates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_FrequencyDDL__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_FrequencyDDL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_FrequencyDDL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appComponents_targets_components_BroadcastQuarterSelect__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__appComponents_targets_components_BroadcastQuarterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__appComponents_targets_components_BroadcastQuarterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appComponents_targets_components_DemoQualifier__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appComponents_targets_components_DemoQualifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__appComponents_targets_components_DemoQualifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_targets_createTarget_components_CampaignQuarterSelect__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__appComponents_targets_createTarget_components_CampaignQuarterSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__appComponents_targets_createTarget_components_CampaignQuarterSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appComponents_targets_createTarget_components_DemoId__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__appComponents_targets_createTarget_components_DemoId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__appComponents_targets_createTarget_components_DemoId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__appLogic_targets_conversions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_U__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__api_XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_audienceHub_store_actions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuelidate__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__);



































var TAB_NAME = {
  VIDEOAMP: 'VIDEOAMP',
  ADDRESSABLE: 'ADDRESSABLE'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_28_vuelidate__["validationMixin"]],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_common_modal__["b" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_6__components_common_actionButton__["a" /* default */],
    TargetName: __WEBPACK_IMPORTED_MODULE_7__appComponents_targets_createTarget_components_TargetName___default.a,
    AdvertiserSelect: __WEBPACK_IMPORTED_MODULE_8__appComponents_targets_components_AdvertiserSelect___default.a,
    StreamingSelect: __WEBPACK_IMPORTED_MODULE_9__appComponents_targets_components_StreamingSelect___default.a,
    MVPD: __WEBPACK_IMPORTED_MODULE_10__appComponents_targets_createTarget_components_MVPD_vue___default.a,
    CampaignDDL: __WEBPACK_IMPORTED_MODULE_11__appComponents_targets_components_CampaignDDL___default.a,
    DayOfWeekDDL: __WEBPACK_IMPORTED_MODULE_12__appComponents_targets_components_DayOfWeekDDL___default.a,
    FlightDates: __WEBPACK_IMPORTED_MODULE_13__appComponents_targets_createTarget_components_FlightDates___default.a,
    FrequencyDDL: __WEBPACK_IMPORTED_MODULE_14__appComponents_targets_components_FrequencyDDL___default.a,
    BroadcastQuarterSelect: __WEBPACK_IMPORTED_MODULE_15__appComponents_targets_components_BroadcastQuarterSelect___default.a,
    DemoQualifier: __WEBPACK_IMPORTED_MODULE_16__appComponents_targets_components_DemoQualifier___default.a,
    CampaignQuarterSelect: __WEBPACK_IMPORTED_MODULE_17__appComponents_targets_createTarget_components_CampaignQuarterSelect___default.a,
    DemoId: __WEBPACK_IMPORTED_MODULE_18__appComponents_targets_createTarget_components_DemoId___default.a,
    LoadingDots: __WEBPACK_IMPORTED_MODULE_19__components_common_loaderDots__["a" /* default */]
  },
  props: {
    value: {
      default: function _default() {
        return {
          display_name: '',
          destinations: [],
          xandr_data: {
            frequency: __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY
          },
          viewing_stream: null,
          am_data: {
            flightStartDate: null,
            flightEndDate: null,
            status: null,
            xdFlightOverlap: 0
          }
        };
      },
      display_name: {
        type: String,
        required: true,
        default: ''
      },
      destinations: {
        type: Array,
        required: true,
        default: []
      },
      advertiser: {
        type: Object,
        required: true,
        default: null
      },
      viewing_stream: {
        type: String,
        required: true,
        default: null
      },
      xandr_data: {
        frequency: {
          type: Number,
          default: null
        }
      }
    }
  },
  data: function data() {
    return {
      next: null,
      modalTitle: 'Activation Window',
      targetNameDisabled: true,
      disableViewingStream: true,
      disableAdvertiser: true,
      destinations: [],
      selectedDestinationIds: [],
      MVPDs: [],
      frequency: null,
      frequencyOptionSet: this.selectedAdstraDatasetFamily ? __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].MONTHLY : 0,
      selectedCampaignId: null,
      filteredCampaigns: [],
      creatingAddressableAudience: this.selectedAdstraDatasetFamily || false,
      mvpdsReceived: false,
      campaignsReceived: false,
      isLoading: true,
      buttonClicked: false,
      addressableDestinations: [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV, __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO, __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR, __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD],
      broadcastQuarter: null,
      demoQualifier: null,
      foresiteDestinationSelected: false,
      digitalDestinations: [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER, __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP],
      LAS_DESTINATIONS: [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE],
      tab: 0,
      tabs: [{ name: TAB_NAME.VIDEOAMP }, { name: TAB_NAME.ADDRESSABLE }],
      videoampMetadata: {
        campaign_quarter: null,
        advertiser: null,
        videoamp_id: null,
        currency: 'VideoAmp',
        deal_number: null,
        demo_id: null
      },
      isVideoampMetadataUpdated: false
    };
  },
  validations: function validations() {
    return {
      value: {
        display_name: { required: __WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__["required"] },
        advertiser: {
          Name: { requiredIfRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__["requiredIf"])(this.selectedLasDatasetFamily) }
        },
        viewing_stream: { required: __WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__["required"] },
        destinations: { required: __WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_vuelidate_lib_validators__["minLength"])(1) }
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getMVPDS().then(function () {
      if (_this.activatingAudience) {
        _this.value.xandr_data = { frequency: null };
      }
      _this.setFrequencyOption();
      _this.setDestinations();
      _this.setXandrExternal();
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var that = this;
    this.getMVPDS().then(function () {
      if (_this2.activatingAudience) {
        _this2.value.xandr_data = { frequency: null };
      }
      _this2.setFrequencyOption();
    }).finally(function () {
      that.isLoading = false;
    });
  },

  computed: {
    C360Datasources: function C360Datasources() {
      return this.$store.getters.getC360Datasources;
    },
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    creatingDigitalAudience: function creatingDigitalAudience() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.C360Datasources).includes(this.selectedDatasetFamily);
    },
    activatingAudience: function activatingAudience() {
      return this.$store.state.createTarget.initialTargetAction === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["k" /* TARGET_ACTIONS */].ACTIVATE;
    },
    showAdvertiserRequiredMessage: function showAdvertiserRequiredMessage() {
      if (!this.value.destinations || this.value.destinations.length === 0) return false;
      return !(this.value.advertiser && this.value.advertiser.Name) && !this.isDigitalDestination && !this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP) && !this.selectedLasDatasetFamily;
    },
    disableFrequency: function disableFrequency() {
      return false;
    },
    showViewingStream: function showViewingStream() {
      return this.isLASDestination || this.foresiteDestinationSelected || !this.activatingAudience && !this.creatingDigitalAudience && !this.selectedDNBDatasetFamily || this.activatingAudience && this.isAddressableTab;
    },
    showFrequency: function showFrequency() {
      return this.creatingAddressableAudience;
    },
    selectedLasDatasetFamily: function selectedLasDatasetFamily() {
      var df = this.selectedDatasetFamily;
      return df === 'amrld' || df === 'mri' || df === 'ncs';
    },
    selectedDatasetFamily: function selectedDatasetFamily() {
      return this.$store.getters['workbench/selectedFamilyDataset'];
    },
    noSelectedDatasetFamily: function noSelectedDatasetFamily() {
      return !this.selectedDatasetFamily;
    },
    selectedAdstraDatasetFamily: function selectedAdstraDatasetFamily() {
      return this.selectedDatasetFamily === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA || this.selectedDatasetFamily === 'xandr';
    },
    selectedDNBDatasetFamily: function selectedDNBDatasetFamily() {
      return this.selectedDatasetFamily === this.C360Datasources.DNB;
    },
    nielsenDatasource: function nielsenDatasource() {
      var _this3 = this;

      var rootFamilies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__common_U__["a" /* getAllDatasetsRootFamilyFromQuery */])(this.value.target_definition.query);
      return rootFamilies.every(function (d) {
        return [_this3.nielsenDatasources.AMRLD, _this3.nielsenDatasources.MRI, _this3.nielsenDatasources.NCS].includes(d);
      });
    },
    newWorkbenchTarget: function newWorkbenchTarget() {
      return this.$store.getters['workbench/newWorkbenchTarget'];
    },
    disableSendDownstream: function disableSendDownstream() {
      return !this.isDigitalDestination && this.$v.$invalid || this.buttonClicked || !this.$store.getters.hasPublishPermissions;
    },
    disableActivate: function disableActivate() {
      return !this.$store.getters.hasPublishPermissions || this.buttonClicked || this.isAddressableTab && this.selectedDestinationIds.length < 1 || this.isVideoampTab && !this.isVideoampMetadataUpdated;
    },
    availableDestinations: function availableDestinations() {
      return this.$store.getters['workbench/availableDestinations'];
    },
    viewingOption: function viewingOption() {
      return this.selectedAdstraDatasetFamily || this.creatingAddressableAudience ? 6 : 5;
    },
    isAddressableDestination: function isAddressableDestination() {
      var _this4 = this;

      return this.value.destinations && this.addressableDestinations.some(function (a) {
        return _this4.value.destinations.includes(a);
      });
    },
    isDigitalDestination: function isDigitalDestination() {
      var _this5 = this;

      return this.value.destinations && this.digitalDestinations.some(function (a) {
        return _this5.value.destinations.includes(a);
      });
    },
    isLASDestination: function isLASDestination() {
      var _this6 = this;

      return this.value.destinations && this.LAS_DESTINATIONS.some(function (a) {
        return _this6.value.destinations.includes(a);
      });
    },
    isEveryVideoampMetadataUpdated: function isEveryVideoampMetadataUpdated() {
      var _this7 = this;

      var videoampMetaDataKeys = ['demo_id', 'deal_number', 'videoamp_id', 'advertiser', 'currency', 'campaign_quarter'];
      return videoampMetaDataKeys.every(function (key) {
        return _this7.videoampMetadata.hasOwnProperty(key) && _this7.videoampMetadata[key] !== null && _this7.videoampMetadata[key] !== '';
      });
    },
    isVideoampTab: function isVideoampTab() {
      return this.tabs[this.tab].name === TAB_NAME.VIDEOAMP;
    },
    isAddressableTab: function isAddressableTab() {
      return this.tabs[this.tab].name === TAB_NAME.ADDRESSABLE;
    }
  },
  methods: {
    open: function open() {
      var _this8 = this;

      this.buttonClicked = false;
      if (this.selectedLasDatasetFamily) {
        if (this.value.destinations.length === 0) {
          this.value.destinations = [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE];
        }
        this.value.viewing_stream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__appLogic_targets_conversions__["b" /* convertViewingStreamForAM */])(this.$store.getters['workbench/viewingStream']);
      }
      this.setFrequencyOption();
      this.setDestinations();
      if (this.destinations.length === 1) {
        this.selectDestination(this.destinations[0]);
      }
      if (!this.activatingAudience) {
        this.tab = 1;
      }
      this.getMVPDS().then(function () {
        _this8.$refs.sendDownstream.open();
      });
    },
    close: function close() {
      this.$refs.sendDownstream.close();
      if (this.activatingAudience) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_27__appLogic_targets_createTarget_store_actions__["k" /* SET_UPDATING_TARGET */], null);
      }
    },
    getMVPDS: function getMVPDS() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this9.MVPDs = _this9.$store.state.appRes.mvpds;
        _this9.mvpdsReceived = true;
        resolve();
      });
    },
    setDestinations: function setDestinations() {
      var _this10 = this;

      var newVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value.destinations || [];

      if (this.selectedLasDatasetFamily && this.value.destinations && this.value.destinations.length === 0) {
        this.value.destinations = [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE];
        return;
      }

      if (this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE)) {
        this.foresiteDestinationSelected = true;
      } else {
        this.foresiteDestinationSelected = false;
      }

      this.destinations = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["q" /* DESTINATION_OBJECTS */].filter(function (d) {
        if (_this10.availableDestinations.includes(d.id)) {
          return d.id;
        }
      });
    },
    setFrequencyOption: function setFrequencyOption() {
      if (this.creatingAddressableAudience) {
        this.frequencyOptionSet = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].ADSTRA;

        this.frequency = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY;
        delete this.value.xandr_data.exportDayOfWeek;
      } else if (this.value.destinations.length > 0 && this.value.destinations.every(function (d) {
        return d === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP;
      })) {
        this.frequencyOptionSet = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].VIDEOAMP;
        this.$set(this.value.xandr_data, 'frequency', __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].ONE_TIME);
        this.value.xandr_data.exportDayOfWeek = 0;
      } else if (this.creatingDigitalAudience) {
        this.frequencyOptionSet = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["p" /* FREQUENCY_OPTION_SET */].DIGITAL;

        this.frequency = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].WEEKLY;
        this.value.xandr_data.exportDayOfWeek = 0;
      }
    },
    setExportFrequency: function setExportFrequency() {
      if (this.isAddressableDestination) {
        this.value.xandr_data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.xandr_data, { frequency: __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].MONTHLY });
      } else if (this.isDigitalDestination) {
        this.value.xandr_data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.xandr_data, { frequency: __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].WEEKLY, exportDayOfWeek: 0 });
      }
    },
    setXandrExternal: function setXandrExternal() {
      if (!this.activatingAudience && (this.noSelectedDatasetFamily || this.selectedLasDatasetFamily)) return;

      this.value.xandr_data.external = undefined;
      this.value.xandr_data.addressable = undefined;
      if (this.MVPDs && this.MVPDs.length) {
        if (this.creatingAddressableAudience) {
          this.setFrequencyOption();
          this.value.xandr_data.external = [];
          this.value.xandr_data.addressable = true;
          if (this.activatingAudience) {
            this.value.target = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA;
            this.value.target_datasource = this.C360Datasources.ADSTRA;
            this.value.target_type = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].ADSTRA;
            this.value.am_data = { flightStartDate: null, flightEndDate: null, status: null, xdFlightOverlap: 0 };
          }

          if (this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR)) {
            var canoe_mvpd = this.MVPDs.find(function (mvpd) {
              return mvpd.Name === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_LINEAR;
            });
            this.value.xandr_data.external.push({
              endpointID: canoe_mvpd.Id,
              endpointName: canoe_mvpd.Name,
              externalID: '',
              universeEstimates: null
            });

            if (this.value.viewing_stream !== __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD) {
              this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            }
          }

          if (this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD)) {
            var canoe_vod_mvpd = this.MVPDs.find(function (mvpd) {
              return mvpd.Name === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].CANOE_VOD;
            });
            this.value.xandr_data.external.push({
              endpointID: canoe_vod_mvpd.Id,
              endpointName: canoe_vod_mvpd.Name,
              externalID: '',
              universeEstimates: null
            });

            if (this.value.viewing_stream !== __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD) {
              this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            }
          }

          if (this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO)) {
            var vizio_mvpd = this.MVPDs.find(function (mvpd) {
              return mvpd.Name === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].VIZIO;
            });
            this.value.xandr_data.external.push({
              endpointID: vizio_mvpd.Id,
              endpointName: vizio_mvpd.Name,
              externalID: '',
              universeEstimates: null
            });

            this.value.am_data.xdFlightOverlap = 0;

            if (this.value.viewing_stream !== __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD) {
              this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            }
          }

          if (this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV)) {
            var atttv_mvpd = this.MVPDs.find(function (mvpd) {
              return mvpd.Name === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["r" /* MARKETPLACE_ENDPOINTS */].DIRECTV;
            });
            this.value.xandr_data.external.push({
              endpointID: atttv_mvpd.Id,
              endpointName: atttv_mvpd.Name,
              externalID: '',
              universeEstimates: null
            });

            if (this.value.viewing_stream !== __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD) {
              this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
            }
          }
        } else {
          this.value.xandr_data.addressable = false;
          if (this.value.destinations.find(function (destination) {
            return [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL, __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER].includes(destination);
          })) {
            this.setFrequencyOption();
            if (this.activatingAudience) {
              this.value.target = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["c" /* TARGET_TYPE */].PRISM;
              this.value.target_datasource = this.C360Datasources.PRISM;
              this.value.target_type = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].PRISM;
              this.value.am_data = { flightStartDate: null, flightEndDate: null, status: null, xdFlightOverlap: 0 };
            }
          } else if (this.value.destinations.find(function (destination) {
            return [__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE].includes(destination);
          }) && this.selectedLasDatasetFamily) {
            if (this.value.xandr_data.frequency === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["o" /* FREQUENCIES */].WEEKLY) {
              this.frequency = null;
            }
            this.frequencyOptionSet =  false ? FREQUENCY_OPTION_SET.LINEAR : 0;
            if (this.activatingAudience) {
              this.value.target = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["c" /* TARGET_TYPE */].LAS;
              this.value.target_datasource = this.nielsenDatasources.MRI;
              this.value.target_type = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].LAS;
            }
          } else if (this.value.destinations.every(function (destination) {
            return destination === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP;
          })) {
            this.setFrequencyOption();
          }
        }
      }
    },
    selectDestination: function selectDestination(destination) {
      var targetDestinations = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.value.destinations);
      if (destination.isDisabled || this.isActivated && !this.isDuplicating) return;
      var isDestinationAlreadySelected = targetDestinations.has(destination.id);
      var isAddressableDestinationFound = this.addressableDestinations.some(function (a) {
        return targetDestinations.has(a);
      });
      var isDigitalDestinationFound = this.digitalDestinations.some(function (a) {
        return targetDestinations.has(a);
      });
      var isVideoAmpDestinationFound = targetDestinations.has(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP);
      if (isDestinationAlreadySelected) targetDestinations.delete(destination.id);else targetDestinations.add(destination.id);

      var that = this;
      var clearSelectedDestinations = function clearSelectedDestinations() {
        that.value.destinations = [];
        targetDestinations.clear();
      };

      switch (destination.id) {
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE:
          if (isAddressableDestinationFound || isDigitalDestinationFound) {
            clearSelectedDestinations();
            targetDestinations.add(destination.id);
          }
          if (!isDestinationAlreadySelected) {
            this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3;
            this.selectedCampaignId = null;
            this.creatingAddressableAudience = false;
          }
          break;
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX:
          {
            if (isAddressableDestinationFound) {
              clearSelectedDestinations();
              targetDestinations.add(destination.id);
            }
            if (!isDestinationAlreadySelected) {
              var isLiverampDestinationFound = targetDestinations.has(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP);
              if (isLiverampDestinationFound) targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX);
              this.creatingAddressableAudience = false;
              this.creatingDigitalAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP:
          {
            if (isAddressableDestinationFound) {
              clearSelectedDestinations();
              targetDestinations.add(destination.id);
            }
            if (!isDestinationAlreadySelected) {
              var hasKruxDest = this.value.destinations.includes(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX);
              if (hasKruxDest) targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP);
              this.creatingAddressableAudience = false;
              this.creatingDigitalAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV:
          {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV);
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations();
                targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV);
              }
              this.selectedCampaignId = null;
              this.creatingAddressableAudience = true;
              this.creatingDigitalAudience = false;
            }
            break;
          }

        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO:
          {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO);
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations();
                targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO);
              }
              this.selectedCampaignId = null;
              this.creatingAddressableAudience = true;
              this.creatingDigitalAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR:
          {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR);
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations();
                targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR);
              }
              this.selectedCampaignId = null;
              this.creatingAddressableAudience = true;
              this.creatingDigitalAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD:
          {
            if (!isDestinationAlreadySelected) {
              if (isAddressableDestinationFound) targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD);
              if (!isAddressableDestinationFound) {
                clearSelectedDestinations();
                targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD);
              }
              this.selectedCampaignId = null;
              this.creatingAddressableAudience = true;
              this.creatingDigitalAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL:
          {
            if (!isDestinationAlreadySelected) {
              if (!isDigitalDestinationFound && !isVideoAmpDestinationFound) {
                clearSelectedDestinations();
              }
              targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL);
              this.selectedCampaignId = null;
              this.creatingDigitalAudience = true;
              this.creatingAddressableAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER:
          {
            if (!isDestinationAlreadySelected) {
              if (!isDigitalDestinationFound && !isVideoAmpDestinationFound) {
                clearSelectedDestinations();
              }
              targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER);
              this.selectedCampaignId = null;
              this.creatingDigitalAudience = true;
              this.creatingAddressableAudience = false;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP:
          if (!isDestinationAlreadySelected) {
            if (!isDigitalDestinationFound) {
              clearSelectedDestinations();
            }
            targetDestinations.add(__WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP);
            this.selectedCampaignId = null;
            this.creatingDigitalAudience = true;
            this.creatingAddressableAudience = false;
          }
          break;
      }
      if (this.creatingAddressableAudience) {
        this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].LSD;
      }
      if (this.creatingDigitalAudience) {
        this.value.xandr_data.exportDayOfWeek = 0;
      }
      this.value.destinations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(targetDestinations);

      this.setDestinations();
      this.setXandrExternal();
      this.selectedDestinationIds = this.value.destinations.map(function (id) {
        return id;
      });
    },
    submitDownstream: function submitDownstream() {
      var _this11 = this;

      this.buttonClicked = true;
      if (this.foresiteDestinationSelected && this.selectedLasDatasetFamily) {
        this.value.target_definition = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.target_definition, { broadcastQuarter: this.broadcastQuarter });
        this.value.metadata.foresite = { demoQualifier: this.demoQualifier };
      } else {
        delete this.value.target_definition.broadcastQuarter;
        if (this.value.metadata.foresite) delete this.value.metadata.foresite;
      }
      this.setExportFrequency();
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_24__appLogic_workbench_common_store_actions__["w" /* SAVE_TARGET */], { target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["cloneDeep"])(this.value), ignoreSavePrompt: true }).then(function (resp) {
        if (_this11.nielsenDatasource) {
          var copiedTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["cloneDeep"])(_this11.newWorkbenchTarget);
          _this11.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_24__appLogic_workbench_common_store_actions__["m" /* SET_ENABLE_DOWN_STREAM */], false);
          _this11.$store.dispatch(__WEBPACK_IMPORTED_MODULE_26__views_audienceHub_store_actions__["d" /* POST_TARGET */], copiedTarget).then(function (resp) {
            _this11.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_24__appLogic_workbench_common_store_actions__["d" /* SET_TARGET */], copiedTarget);
            _this11.$router.push({ name: 'NewWorkbench', params: { id: _this11.value.id } });
          });
        } else {
          _this11.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_24__appLogic_workbench_common_store_actions__["x" /* SUBMIT_DOWNSTREAM */]);
        }
        _this11.close();
      });
    },
    activateAudience: function activateAudience() {
      var _this12 = this;

      this.buttonClicked = true;
      this.value.activation_status = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED;
      this.value.username = this.$store.state.auth.username;
      if (this.foresiteDestinationSelected && this.isAddressableTab) {
        this.value.target_definition = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value.target_definition, { broadcastQuarter: this.broadcastQuarter });
        this.value.metadata.foresite = { demoQualifier: this.demoQualifier };
      } else {
        delete this.value.target_definition.broadcastQuarter;
        if (this.value.metadata.foresite) delete this.value.metadata.foresite;
      }
      if (this.isVideoampTab) {
        this.value.activation_status = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
        this.value.target = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["c" /* TARGET_TYPE */].VIDEOAMP;
        this.value.target_datasource = this.C360Datasources.VIDEOAMP;
        this.value.target_type = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["d" /* TARGET_TYPES_INTEGERS */].VIDEOAMP;
        this.value.viewing_stream = __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["i" /* VIEWING_STREAMS */].C3;
        this.value.metadata.videoamp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.videoampMetadata);
        if (this.value.xandr_data) delete this.value.xandr_data;
        if (this.value.advertiser && this.value.advertiser.Name) {
          this.value.advertiser = { Name: null };
        }
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_26__views_audienceHub_store_actions__["p" /* SET_REFRESH_TABLE_FLAG */], false);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_27__appLogic_targets_createTarget_store_actions__["o" /* CREATE_TARGET_NO_ACTUALS */], this.value).then(function (resp) {
        _this12.$store.dispatch(__WEBPACK_IMPORTED_MODULE_27__appLogic_targets_createTarget_store_actions__["p" /* RESET_THE_LAS_MODAL */]);
        _this12.$refs.sendDownstream.close();
        _this12.$store.dispatch(__WEBPACK_IMPORTED_MODULE_26__views_audienceHub_store_actions__["p" /* SET_REFRESH_TABLE_FLAG */], true);
      });
    },
    destroySetup: function destroySetup() {
      this.$refs.sendDownstream.close();
      if (this.value.activation_status === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT || this.value.activation_status === __WEBPACK_IMPORTED_MODULE_23__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING) {
        this.value.destinations = [];
        this.creatingDigitalAudience = false;
        this.creatingAddressableAudience = false;
      }
      if (this.activatingAudience) {
        this.value.destinations = [];
        this.creatingDigitalAudience = false;
        this.creatingAddressableAudience = false;
        this.videoampMetadata = {
          campaign_quarter: null,
          advertiser: null,
          videoamp_id: null,
          currency: 'VideoAmp',
          deal_number: null,
          demo_id: null
        };
        if (this.value.xandr_data) {
          delete this.value.xandr_data.frequency;
          delete this.value.xandr_data.exportDayOfWeek;
        }
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_27__appLogic_targets_createTarget_store_actions__["p" /* RESET_THE_LAS_MODAL */]);
      }
    },
    updateCanoeUE: function updateCanoeUE(ue) {},
    updateMrmID: function updateMrmID(mrmId) {},
    canUpdateUE: function canUpdateUE() {
      return false;
    },
    mrmID: function mrmID() {
      return 'todo';
    }
  },
  watch: {
    isEveryVideoampMetadataUpdated: function isEveryVideoampMetadataUpdated(value) {
      this.isVideoampMetadataUpdated = value;
    },
    tab: function tab(value) {}
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_svg_group_svg__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_ungroup_svg__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_trash_svg__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrows_svg__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_count_group_svg__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_remove_count_group_svg__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_6__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      group: __WEBPACK_IMPORTED_MODULE_0__assets_svg_group_svg__["a" /* default */],
      ungroup: __WEBPACK_IMPORTED_MODULE_1__assets_svg_ungroup_svg__["a" /* default */],
      trash: __WEBPACK_IMPORTED_MODULE_2__assets_svg_trash_svg__["a" /* default */],
      arrows: __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrows_svg__["a" /* default */],
      countGroup: __WEBPACK_IMPORTED_MODULE_4__assets_svg_count_group_svg__["a" /* default */],
      removeCountGroupIcon: __WEBPACK_IMPORTED_MODULE_5__assets_svg_remove_count_group_svg__["a" /* default */]
    };
  },

  computed: {
    groupDisable: function groupDisable() {
      return !this.$store.getters['workbench/selectedCanBeGrouped'];
    },
    ungroupDisable: function ungroupDisable() {
      return !this.$store.getters['workbench/selectedCanBeUngrouped'];
    },
    deleteDisable: function deleteDisable() {
      return !this.$store.getters['workbench/selectedCanBeDeleted'];
    },
    isDragAndDropActive: function isDragAndDropActive() {
      return this.$store.getters['workbench/isDragAndDropActive'];
    },
    countGroupDisable: function countGroupDisable() {
      return !this.$store.getters['workbench/selectedCanBecomeCountGroup'] || (this.$store.getters['workbench/newWorkbenchTarget'] || {}).target === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].XANDR_SEGMENT || (this.$store.getters['workbench/newWorkbenchTarget'] || {}).target === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["c" /* TARGET_TYPE */].ADSTRA;
    },
    isSelectedACountGroup: function isSelectedACountGroup() {
      var selectedAttributes = this.$store.getters['workbench/selectedAttributes'];
      if (selectedAttributes) {
        var attribute = selectedAttributes[0];
        if (!attribute) {
          return false;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__store_mutations__["b" /* isCountGroup */])(attribute);
      }
    },
    countGroupIcon: function countGroupIcon() {
      return this.isSelectedACountGroup ? __WEBPACK_IMPORTED_MODULE_5__assets_svg_remove_count_group_svg__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__assets_svg_count_group_svg__["a" /* default */];
    }
  },
  methods: {
    groupAttributes: function groupAttributes() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["d" /* GROUP */]);
    },
    ungroupAttributes: function ungroupAttributes() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["e" /* UNGROUP */]);
    },
    deleteAttributes: function deleteAttributes() {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["c" /* REMOVE_ATTRIBUTE */]);
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_10__appLogic_workbench_common_store_actions__["b" /* RESET_FAMILY_DATASETS */]);
    },
    dragAndDropModeToggle: function dragAndDropModeToggle() {
      this.isDragAndDropActive ? this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["u" /* DEACTIVATE_DRAG_DROP */]) : this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["v" /* ACTIVATE_DRAG_DROP */]);
    },
    countGroupHandler: function countGroupHandler(e) {
      var attribute = this.$store.getters['workbench/selectedAttributes'][0];
      this.isSelectedACountGroup ? this.removeCountGroup(attribute.definitionId) : this.createCountGroup(e, attribute);
    },
    createCountGroup: function createCountGroup(e, attribute) {
      var _this = this;

      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__components_common_popover__["b" /* createPopover */])({
        direction: 'left',
        attribute: attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_8__components_common_popover__["c" /* popoverTypes */].COUNT_GROUP
      });
      this.popover.$on('select', function (value) {
        var details = {
          groupId: attribute.definitionId,
          mustMatch: value
        };
        _this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["o" /* CREATE_COUNT_GROUP */], details);
      });
    },
    removeCountGroup: function removeCountGroup(groupId) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_9__appComponents_workbench_targetDefinition_store_actions__["p" /* REMOVE_COUNT_GROUP */], groupId);
    }
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__targetDefinitionStatement__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_workbench_common_store_actions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appLogic_targets_Constants__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    DefinitionControls: __WEBPACK_IMPORTED_MODULE_0__DefinitionControls_vue___default.a,
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__["a" /* default */],
    TargetDefinitionStatement: __WEBPACK_IMPORTED_MODULE_2__targetDefinitionStatement__["a" /* default */]
  },
  props: {
    enableNot: {
      type: Boolean,
      default: true
    },
    enableMinus: {
      type: Boolean,
      default: true
    },
    viewOnly: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    definition: function definition() {
      return this.$store.getters['workbench/getDefinition'];
    },
    selected: function selected() {
      return this.$store.getters['workbench/selected'];
    },
    isTargetEditable: function isTargetEditable() {
      return this.$store.getters['workbench/isTargetEditable'] && !this.viewOnly;
    },
    isDragAndDropActive: function isDragAndDropActive() {
      return this.$store.getters['workbench/isDragAndDropActive'];
    },
    isDraggingPart: function isDraggingPart() {
      return this.$store.getters['workbench/isDraggingPart'];
    }
  },
  methods: {
    handleKeyboardShortcut: function handleKeyboardShortcut(e) {
      switch (e.keyCode) {
        case 8:
        case 46:
          var hasSelected = this.$store.getters['workbench/selectedCount'] > 0;
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__["c" /* REMOVE_ATTRIBUTE */]);
          if (hasSelected) {
            this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_4__appLogic_workbench_common_store_actions__["b" /* RESET_FAMILY_DATASETS */]);
          }
          break;

        case 71:
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__["d" /* GROUP */]);
          break;

        case 85:
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__["e" /* UNGROUP */]);
          break;

        case 27:
          this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__["f" /* CLEAR_SELECTION */]);
      }
    }
  },
  mounted: function mounted() {
    this.boundHandleKeyboardShortcut = this.handleKeyboardShortcut.bind(this);
    window.addEventListener('keyup', this.boundHandleKeyboardShortcut);
  },
  destroyed: function destroyed() {
    window.removeEventListener('keyup', this.boundHandleKeyboardShortcut);
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_left_bracket_svg__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_right_bracket_svg__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_left_parenthesis_svg__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_right_parenthesis_svg__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableMixin__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_DragAndDropHandlers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);


var _BRACKET_MAP;













var DIRECTION = {
  left: 0,
  right: 1 << 0
};

var BRACKET_TYPE = {
  square: 1 << 1,
  normal: 1 << 2
};

var BRACKET_MAP = (_BRACKET_MAP = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.left | BRACKET_TYPE.square, __WEBPACK_IMPORTED_MODULE_2__assets_svg_left_bracket_svg__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.right | BRACKET_TYPE.square, __WEBPACK_IMPORTED_MODULE_3__assets_svg_right_bracket_svg__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.left | BRACKET_TYPE.normal, __WEBPACK_IMPORTED_MODULE_4__assets_svg_left_parenthesis_svg__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_BRACKET_MAP, DIRECTION.right | BRACKET_TYPE.normal, __WEBPACK_IMPORTED_MODULE_5__assets_svg_right_parenthesis_svg__["a" /* default */]), _BRACKET_MAP);

/* harmony default export */ __webpack_exports__["default"] = ({
  DIRECTION: DIRECTION,
  BRACKET_TYPE: BRACKET_TYPE,
  mixins: [__WEBPACK_IMPORTED_MODULE_6__SelectableMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_DragAndDropHandlers__["a" /* default */]],
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__["a" /* default */]
  },
  props: {
    direction: {
      type: Number,
      required: true
    },
    bracketType: {
      type: Number,
      default: BRACKET_TYPE.normal
    },
    level: {
      type: Number,
      default: 0
    },
    definitionId: {
      type: String
    },
    attribute: {
      type: Object
    }
  },
  computed: {
    icon: function icon() {
      return BRACKET_MAP[this.direction | this.bracketType];
    },
    isCountGroup: function isCountGroup() {
      return !!this.attribute.mustMatch;
    },
    showMustMatch: function showMustMatch() {
      return this.isCountGroup && this.direction === 0;
    },
    classes: function classes() {
      return [{
        'definition-bracket--left': this.direction === DIRECTION.left,
        'definition-bracket--right': this.direction === DIRECTION.right,
        'selected': this.isSelected,
        'definition-bracket--square': this.bracketType === BRACKET_TYPE.square,
        'cant-drop-here': !this.canDropHere
      }, this.levelClass()];
    },
    defType: function defType() {
      return this.direction === 0 ? __WEBPACK_IMPORTED_MODULE_8__store_mutations__["a" /* definitionPartTypes */].GROUP_BEGINNING : __WEBPACK_IMPORTED_MODULE_8__store_mutations__["a" /* definitionPartTypes */].GROUP_ENDING;
    },
    hoverOverMessage: function hoverOverMessage() {
      return 'Grouping-UE : ' + '1234223';
    }
  },
  methods: {
    levelClass: function levelClass() {
      return 'level-' + this.level;
    },
    clickHandler: function clickHandler(e) {
      var _this = this;

      if (!this.disabled) {
        this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__components_common_popover__["b" /* createPopover */])({
          direction: 'top',
          attribute: this.attribute,
          parent: e.target,
          root: document.getElementById('app'),
          type: __WEBPACK_IMPORTED_MODULE_9__components_common_popover__["c" /* popoverTypes */].COUNT_GROUP
        });
        this.popover.$on('select', function (mustMatch) {
          var details = {
            groupId: _this.attribute.definitionId,
            mustMatch: mustMatch
          };
          _this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_10__appComponents_workbench_targetDefinition_store_actions__["o" /* CREATE_COUNT_GROUP */], details);
        });
      }
    }
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_attributePanel_services_attributeType__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectableMixin__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_DragAndDropHandlers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_HoverOver__ = __webpack_require__(720);







var BOOLEAN = __WEBPACK_IMPORTED_MODULE_0__appComponents_workbench_attributePanel_services_attributeType__["a" /* default */].BOOLEAN;




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__SelectableMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_DragAndDropHandlers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_HoverOver__["a" /* default */]],
  props: {
    inGroup: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    },
    definitionId: {
      type: String
    }
  },
  data: function data() {
    return {
      defType: __WEBPACK_IMPORTED_MODULE_6__store_mutations__["a" /* definitionPartTypes */].ATTRIBUTE,
      hoverOverPopover: null
    };
  },

  computed: {
    displayName: function displayName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* createDisplayName */])(this.attribute);
    },
    disableDefinitionPart: function disableDefinitionPart() {
      var disabled = this.$store.getters['workbench/disableDefinitionPart'];
      return disabled ? disabled(this.definitionId) : false;
    },
    isRemoved: function isRemoved() {
      return this.attribute.removed;
    },
    levelClass: function levelClass() {
      return 'level-' + this.level;
    },
    thisPartIsInACountGroup: function thisPartIsInACountGroup() {
      var inCountGroup = this.$store.getters['workbench/isInACountGroup'];
      return inCountGroup ? inCountGroup(this.definitionId) : false;
    },
    hoverOverMessage: function hoverOverMessage() {
      var ue = this.hasHoverOverMessage ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* commaFormatString */])(Math.floor(Number(this.attribute.ue))) : 'NO DATA';
      return this.attribute.name + ' - UE : ' + ue;
    },
    hasHoverOverMessage: function hasHoverOverMessage() {
      return this.attribute.ue || this.attribute.ue === 0;
    }
  },
  methods: {
    clickHandler: function clickHandler() {
      if (this.thisPartIsInACountGroup) return;
      this.select(this.attribute);
    },
    updateAttribute: function updateAttribute(updatedAttribute) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_targetDefinition_store_actions__["l" /* UPDATE_ATTRIBUTE */], { attribute: this.attribute, update: updatedAttribute });
    },
    editAttribute: function editAttribute(e) {
      var _this = this;

      if (this.attribute.type === BOOLEAN || this.disabled) return;
      this.popover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_common_popover__["b" /* createPopover */])({
        direction: 'top',
        attribute: this.attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: __WEBPACK_IMPORTED_MODULE_3__components_common_popover__["c" /* popoverTypes */].ATTRIBUTE
      });
      this.popover.$on('select', function (attr) {
        _this.updateAttribute(attr);
      });
    }
  }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_DragAndDropHandlers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutations__ = __webpack_require__(86);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_DragAndDropHandlers__["a" /* default */]],
  props: {
    level: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      defType: __WEBPACK_IMPORTED_MODULE_1__store_mutations__["a" /* definitionPartTypes */].DROP_ZONE,
      definitionId: 'drop-zone'
    };
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_operators__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_DragAndDropHandlers__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutations__ = __webpack_require__(86);









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_DragAndDropHandlers__["a" /* default */]],
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    definitionId: {
      type: String
    },
    enableNot: {
      type: Boolean,
      default: true
    },
    enableMinus: {
      type: Boolean,
      default: true
    },
    operator: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      defType: __WEBPACK_IMPORTED_MODULE_5__store_mutations__["a" /* definitionPartTypes */].OPERATOR
    };
  },

  computed: {
    levelClass: function levelClass() {
      return 'level-' + this.level;
    },
    operatorConfig: function operatorConfig() {
      return __WEBPACK_IMPORTED_MODULE_1__models_operators__["a" /* default */][this.operator.value];
    },
    disableDefinitionPart: function disableDefinitionPart() {
      var disabled = this.$store.getters['workbench/disableDefinitionPart'];
      return disabled ? disabled(this.definitionId) : false;
    },
    thisPartIsInACountGroup: function thisPartIsInACountGroup() {
      var inCountGroup = this.$store.getters['workbench/isInACountGroup'];
      return inCountGroup ? inCountGroup(this.definitionId) : false;
    }
  },
  methods: {
    updateOperator: function updateOperator(updatedOperator) {
      this.$store.dispatch('workbench/' + __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_targetDefinition_store_actions__["g" /* UPDATE_OPERATOR */], { operator: this.operator, update: updatedOperator });
    },
    editOperator: function editOperator(e) {
      var _this = this;

      if (this.thisPartIsInACountGroup || this.disabled) return;
      this.popover = __WEBPACK_IMPORTED_MODULE_4__components_common_popover__["a" /* PopoverFactory */].createOperator({
        direction: 'top',
        operatorSelector: true,
        parent: e.currentTarget,
        miliseconds: 200,
        enableNot: this.enableNot,
        enableMinus: this.enableMinus
      });
      this.popover.$on('select', function (operator) {
        _this.updateOperator(operator);
      });
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "primary"
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_back_arrow_svg__ = __webpack_require__(1544);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  methods: {
    goBack: function goBack() {
      this.$emit('goBack');
    }
  },
  computed: {
    backArrowIcon: function backArrowIcon() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_svg_back_arrow_svg__["a" /* default */];
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_cancel_svg__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    minHeight: {
      type: Number,
      default: 200
    },
    minWidth: {
      type: Number,
      default: 200
    },
    maxHeight: {
      type: Number,
      default: 700
    },
    maxWidth: {
      type: Number,
      default: 700
    },
    initialPosition: {
      type: Object,
      default: {
        top: 50,
        left: 50
      }
    }
  },
  data: function data() {
    return {
      cancel: __WEBPACK_IMPORTED_MODULE_1__assets_svg_cancel_svg__["a" /* default */],
      isEntered: false,
      showExpand: true,
      draggable: false,
      draggableArea: null,
      positionArea: {},

      TIME_FOR_ENTER: 200
    };
  },
  computed: {
    canExpand: function canExpand() {
      return this.isEntered;
    },
    position: function position() {
      if (this.positionArea) {
        return {
          top: this.positionArea.top + 'px',
          left: this.positionArea.left + 'px'
        };
      }
    }
  },
  mounted: function mounted() {
    this.positionArea = this.initialPosition;
    window.addEventListener('mousemove', this.anyMouseMove);
  },
  destroyed: function destroyed() {
    window.removeEventListener('mousemove', this.anyMouseMove);
  },

  methods: {
    anyMouseMove: function anyMouseMove(e) {
      if (this.draggable) {
        this.reposition(e);
      }
    },
    mouseUp: function mouseUp(e) {
      this.draggable = false;
      this.draggableArea = null;
    },
    mouseDown: function mouseDown(e) {
      this.draggable = true;
      this.draggableArea = null;
    },
    mouseMove: function mouseMove(e) {
      if (this.draggable) {
        if (!this.draggableArea) {
          var currentLocation = this.$el.getBoundingClientRect();
          this.draggableArea = {
            left: currentLocation.x,
            top: currentLocation.y,
            startLeft: e.clientX,
            startTop: e.clientY
          };
        }
        this.reposition(e);
      }
    },
    reposition: function reposition(e) {
      if (this.draggableArea) {
        var d = this.draggableArea;
        this.positionArea = {
          top: d.top + (e.clientY - d.startTop),
          left: d.left + (e.clientX - d.startLeft)
        };
      }
    },
    mouseEnter: function mouseEnter(e) {
      var _this = this;

      this.isEntered = true;
      setTimeout(function () {
        if (_this.canExpand) {
          _this.expand();
        }
      }, this.TIME_FOR_ENTER);
    },
    mouseOut: function mouseOut(e) {
      if (this.draggable) {
        this.reposition(e);
      } else {
        this.draggableArea = null;
      }
      this.isEntered = false;
    },
    expand: function expand() {
      this.showExpand = true;
    },
    close: function close() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__views_workbenchCanvas_store_WorkbenchWCanvasSlotActionsGenerator__["a" /* SHOW_TARGET_HISTORY_PANEL */], false);
    }
  }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_datepicker__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_datepicker__);




var OPTION_SETTINGS = {
  NORMAL: 1,
  ERASE_TO_WHEN_FROM_IS_CHANGED: 2,
  KEEP_TO_WHEN_FROM_IS_CHANGED: 3,
  CANT_CHANGE_FROM_PAST_TO: 4
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vue2_datepicker___default.a
  },
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      from: Date,
      to: Date
    },
    startDate: {
      type: Date,
      default: null
    },
    fromNotBeforeDate: {
      type: Date,
      default: ''
    },
    disableFrom: {
      type: Boolean,
      default: false
    },
    disableTo: {
      type: Boolean,
      default: false
    },
    startToDateFromToday: {
      type: Boolean,
      default: true
    },
    optionSetting: {
      type: Number,
      default: 1
    }
  },
  computed: {
    toStartDate: function toStartDate() {
      if (this.value.from) {
        var today = new Date();
        today.setDate(today.getDate() + 1);
        today.setHours(0, 0, 0, 0);

        var nextFromDay = new Date(this.value.from);
        var fromDate = new Date(this.value.from).getDate();
        nextFromDay.setDate(fromDate + 1);

        if (this.startToDateFromToday) {
          if (today > this.value.from) {
            return today;
          } else if (today === this.value.from) {
            today.setDate(today.getDate() + 3);
            return today;
          } else {
            return nextFromDay;
          }
        } else if (this.isOption3) {
          if (this.value.from > this.value.to) {
            return this.value.to;
          } else {
            return nextFromDay;
          }
        }
        return today;
      } else {
        return this.value.to;
      }
    },
    fromEndDate: function fromEndDate() {
      var previousToDate = new Date(this.value.to);
      if (this.isOption4 && previousToDate.valueOf() !== 0 && this.value.to !== '') {
        var toDate = new Date(this.value.to).getDate();
        previousToDate.setDate(toDate - 1);
        return previousToDate;
      }
      return undefined;
    },
    enableTo: function enableTo() {
      return this.value.from && !this.disableTo;
    },
    isNormal: function isNormal() {
      return this.optionSetting === OPTION_SETTINGS.NORMAL;
    },
    isOption2: function isOption2() {
      return this.optionSetting === OPTION_SETTINGS.ERASE_TO_WHEN_FROM_IS_CHANGED;
    },
    isOption3: function isOption3() {
      return this.optionSetting === OPTION_SETTINGS.KEEP_TO_WHEN_FROM_IS_CHANGED;
    },
    isOption4: function isOption4() {
      return this.optionSetting === OPTION_SETTINGS.CANT_CHANGE_FROM_PAST_TO;
    }
  },
  methods: {
    changeFrom: function changeFrom(val) {
      if (this.isOption2) {
        this.$emit('input', {
          from: val,
          to: null
        });
      } else {
        this.$emit('input', {
          from: val,
          to: this.value.to
        });
      }
    },
    changeTo: function changeTo(val) {
      this.$emit('input', {
        from: this.value.from,
        to: val
      });
    }
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);






var SIZE = {
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    initialValue: {
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    searchOptions: {
      type: Function,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Name'
    },
    size: {
      type: Number,
      default: SIZE.LARGE
    },
    getOptionLabel: {
      type: Function,
      default: undefined
    }
  },
  data: function data() {
    return {
      value: this.initialValue && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.initialValue) !== 'object' || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.initialValue).length > 0) ? this.initialValue : null
    };
  },

  computed: {
    showPlaceholder: function showPlaceholder() {
      return !this.value;
    },
    isMedium: function isMedium() {
      return this.size === SIZE.MEDIUM;
    }
  },
  methods: {
    preventTheDefault: function preventTheDefault(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    },
    clear: function clear() {
      this.value = null;
    },
    clearOptionsIfEmpty: function clearOptionsIfEmpty() {
      if (!this.value) {
        this.$emit('clearOptions');
      }
    },
    checkPosition: function checkPosition() {
      var _this = this;

      setTimeout(function () {
        var windowBottom = window.innerHeight;
        var dropdownMenu = _this.$el.querySelector('.dropdown-menu');
        if (dropdownMenu) {
          var dropdownMenuBounds = dropdownMenu.getBoundingClientRect();
          var dropdownMenuBottom = dropdownMenuBounds.bottom;
          var dropdownMenuCalculatedBottom = dropdownMenuBounds.y + dropdownMenuBounds.height;
          var dropdownMenuCalculatedHeight = windowBottom - dropdownMenuBounds.y;
          if (dropdownMenuCalculatedBottom > windowBottom) {
            dropdownMenu.style.height = dropdownMenuCalculatedHeight - 5 + 'px';
          }
        }
      }, 0);
    }
  },
  mounted: function mounted() {
    this.searchInput = this.$el.querySelector('input[type=search]');
    this.searchInput.addEventListener('keypress', this.preventTheDefault);
  },

  watch: {
    value: function value(val) {
      this.$emit('update', val);
    },
    initialValue: function initialValue(val) {
      this.value = val;
    },
    options: function options() {
      this.checkPosition();
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




var SIZE = {
  LARGE: 1,
  MEDIUM: 2,
  SMALL: 3
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    value: {
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    searchOptions: {
      type: Function,
      default: undefined
    },
    label: {
      type: String,
      default: 'Name'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    returnValue: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: SIZE.LARGE
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      selectedValue: null
    };
  },

  computed: {
    showPlaceholder: function showPlaceholder() {
      return !this.fullValue;
    },
    fullValue: function fullValue() {
      var _this = this;

      return this.value && this.returnValue ? this.options.filter(function (v) {
        return v.value === _this.value;
      })[0] : this.value;
    },
    hasSameReturnValue: function hasSameReturnValue() {
      if (this.returnValue) {
        return this.value === this.selectedValue.value;
      } else {
        return this.value === this.selectedValue;
      }
    },
    isMedium: function isMedium() {
      return this.size === SIZE.MEDIUM;
    },
    isDisabled: function isDisabled() {
      return this.options.length === 1 || this.disabled;
    },
    isClearable: function isClearable() {
      return !this.isDisabled && this.clearable;
    }
  },
  methods: {
    preventTheDefault: function preventTheDefault(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    },
    clear: function clear() {
      this.selectedValue = null;
      this.$emit('input', null);
    },
    emitInput: function emitInput(val) {
      this.$emit('input', this.returnValue ? val ? val.value : val : val);
    },
    clearOptionsIfEmpty: function clearOptionsIfEmpty() {
      if (!this.value) {
        this.$emit('clearOptions');
      }
    },
    checkPosition: function checkPosition() {
      var _this2 = this;

      setTimeout(function () {
        var windowBottom = window.innerHeight;
        var dropdownMenu = _this2.$el.querySelector('.dropdown-menu');
        if (dropdownMenu) {
          var dropdownMenuBounds = dropdownMenu.getBoundingClientRect();
          var dropdownMenuBottom = dropdownMenuBounds.bottom;
          var dropdownMenuCalculatedBottom = dropdownMenuBounds.y + dropdownMenuBounds.height;
          var dropdownMenuCalculatedHeight = windowBottom - dropdownMenuBounds.y;
          if (dropdownMenuCalculatedBottom > windowBottom) {
            dropdownMenu.style.height = dropdownMenuCalculatedHeight - 5 + 'px';
          }
        }
      }, 0);
    }
  },
  watch: {
    options: function options() {
      if (this.options.length === 1) {
        this.emitInput(this.options[0]);
      }
      this.checkPosition();
    }
  },
  mounted: function mounted() {
    this.searchInput = this.$el.querySelector('input[type=search]');
    this.searchInput.addEventListener('keypress', this.preventTheDefault);
  }
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeedbackModal__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeedbackModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FeedbackModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'feedback-modal': __WEBPACK_IMPORTED_MODULE_0__FeedbackModal___default.a, ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__["a" /* default */]
  },
  props: {
    message: {
      type: String,
      default: 'Error handling your submission.'
    }
  },
  methods: {
    open: function open() {
      this.$refs.feedbackModal.open();
    },
    close: function close() {
      this.$refs.feedbackModal.close();
    },
    emitDismiss: function emitDismiss() {
      console.log('errorModalDismiss');
      this.$emit('dismiss');
    }
  }
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      style: {
        display: 'none'
      }
    };
  },

  methods: {
    open: function open() {
      document.activeElement.blur();
      this.style.display = 'block';
      window.addEventListener('click', this.handleDocumentClick, true);
    },
    close: function close() {
      this.style.display = 'none';
      window.removeEventListener('click', this.handleDocumentClick, true);
      this.$emit('dismiss');
      console.log('feedbackModal dismiss');
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.$el.getElementsByClassName('feedback-modal__content')[0].contains(e.target)) {
        this.close();
      }
    }
  }
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    color: {
      type: String,
      default: 'green'
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    colorClass: function colorClass() {
      return 'flag__' + this.color;
    }
  }
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_caret_down__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_caret_up__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon___default.a
  },
  props: {
    down: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_min_safe_integer__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VueNumeric',
  props: {
    currency: {
      type: String,
      default: '',
      required: false
    },

    max: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a || 9007199254740991,
      required: false
    },

    min: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_min_safe_integer___default.a || -9007199254740991,
      required: false
    },

    minus: {
      type: Boolean,
      default: false,
      required: false
    },

    placeholder: {
      type: String,
      default: '',
      required: false
    },

    emptyValue: {
      type: [Number, String],
      default: '',
      required: false
    },

    precision: {
      type: Number,
      default: 0,
      required: false
    },

    separator: {
      type: String,
      default: ',',
      required: false
    },

    thousandSeparator: {
      default: undefined,
      required: false,
      type: String
    },

    decimalSeparator: {
      default: undefined,
      required: false,
      type: String
    },

    outputType: {
      required: false,
      type: String,
      default: 'Number'
    },

    value: {
      validator: function validator(prop) {
        return typeof prop === 'string' || prop === null || typeof prop === 'number';
      },
      default: 0,
      required: true
    },

    readOnly: {
      type: Boolean,
      default: false,
      required: false
    },

    readOnlyClass: {
      type: String,
      default: '',
      required: false
    },

    currencySymbolPosition: {
      type: String,
      default: 'prefix',
      required: false
    },

    shouldValidate: {
      type: Boolean,
      default: true,
      required: false
    },
    text: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      amount: ''
    };
  },
  computed: {
    amountNumber: function amountNumber() {
      return this.unformat(this.amount);
    },
    valueNumber: function valueNumber() {
      return this.unformat(this.value);
    },
    decimalSeparatorSymbol: function decimalSeparatorSymbol() {
      if (typeof this.decimalSeparator !== 'undefined') return this.decimalSeparator;
      if (this.separator === ',') return '.';
      return ',';
    },
    thousandSeparatorSymbol: function thousandSeparatorSymbol() {
      if (typeof this.thousandSeparator !== 'undefined') return this.thousandSeparator;
      if (this.separator === '.') return '.';
      if (this.separator === 'space') return ' ';
      return ',';
    },
    symbolPosition: function symbolPosition() {
      if (!this.currency) return '%v';
      return this.currencySymbolPosition === 'suffix' ? '%v %s' : '%s %v';
    }
  },
  watch: {
    valueNumber: function valueNumber(newValue) {
      if (this.$refs.numeric !== document.activeElement) {
        this.amount = this.format(newValue);
      }
    },
    readOnly: function readOnly(newValue, oldValue) {
      var _this = this;

      if (oldValue === false && newValue === true) {
        this.$nextTick(function () {
          _this.$refs.readOnly.className = _this.readOnlyClass;
        });
      }
    },
    separator: function separator() {
      this.process(this.valueNumber);
      this.amount = this.format(this.valueNumber);
    },
    currency: function currency() {
      this.process(this.valueNumber);
      this.amount = this.format(this.valueNumber);
    },
    precision: function precision() {
      this.process(this.valueNumber);
      this.amount = this.format(this.valueNumber);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.process(this.valueNumber);
    this.amount = this.format(this.valueNumber);

    setTimeout(function () {
      _this2.process(_this2.valueNumber);
      _this2.amount = _this2.format(_this2.valueNumber);
    }, 500);

    if (this.readOnly) this.$refs.readOnly.className = this.readOnlyClass;
  },

  methods: {
    onBlurHandler: function onBlurHandler(e) {
      this.$emit('blur', e);
      this.amount = this.format(this.valueNumber);
    },
    onFocusHandler: function onFocusHandler(e) {
      this.$emit('focus', e);
      if (this.valueNumber === 0) {
        this.amount = null;
      } else {
        this.amount = __WEBPACK_IMPORTED_MODULE_2_accounting_js___default.a.formatMoney(this.valueNumber, {
          symbol: '',
          format: '%v',
          thousand: '',
          decimal: this.decimalSeparatorSymbol,
          precision: Number(this.precision)
        });
      }
    },
    onInputHandler: function onInputHandler() {
      this.process(this.amountNumber);
    },
    process: function process(value) {
      if (!this.shouldValidate) {
        this.update(value);
        return;
      }
      if (value >= this.max) this.update(this.max);
      if (value <= this.min) this.update(this.min);
      if (value > this.min && value < this.max) this.update(value);
      if (!this.minus && value < 0) this.min >= 0 ? this.update(this.min) : this.update(0);
    },
    update: function update(value) {
      var fixedValue = __WEBPACK_IMPORTED_MODULE_2_accounting_js___default.a.toFixed(value, this.precision);
      var output = this.outputType.toLowerCase() === 'string' ? fixedValue : Number(fixedValue);
      this.$emit('input', output);
    },
    format: function format(value) {
      return __WEBPACK_IMPORTED_MODULE_2_accounting_js___default.a.formatMoney(value, {
        symbol: this.currency,
        format: this.symbolPosition,
        precision: Number(this.precision),
        decimal: this.decimalSeparatorSymbol,
        thousand: this.thousandSeparatorSymbol
      });
    },
    unformat: function unformat(value) {
      var toUnformat = typeof value === 'string' && value === '' ? this.emptyValue : value;
      return __WEBPACK_IMPORTED_MODULE_2_accounting_js___default.a.unformat(toUnformat, this.decimalSeparatorSymbol);
    }
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_feedbackModal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FeedbackModal: __WEBPACK_IMPORTED_MODULE_0__components_common_feedbackModal__["b" /* FeedbackModal */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton__["a" /* default */]
  },
  props: {
    object: Object,
    buttonText: String
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('click', this.object);
      this.close();
    },
    open: function open() {
      this.$refs.feedbackModal.open();
    },
    close: function close() {
      this.$refs.feedbackModal.close();
    }
  }
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_cancel_svg__ = __webpack_require__(98);





var HEIGHT_OF_ACTIONS = 52;
var PADDING_OF_MODAL = 44;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__["a" /* default */]
  },
  props: {
    showOnCreate: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    },
    cssAfectsWidth: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: Number,
      default: null
    },

    enableClickClose: {
      type: Boolean,
      default: false
    },

    enableCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isVisible: this.showOnCreate,
      cancel: __WEBPACK_IMPORTED_MODULE_2__assets_svg_cancel_svg__["a" /* default */]
    };
  },

  computed: {
    modalStyle: function modalStyle() {
      var style = {};
      if (this.cssAfectsWidth) {
        style.width = this.width ? String(this.width) + 'px' : null;
      }
      if (this.autoWidth) {
        style.maxWidth = 'none';
      }
      if (this.minHeight) {
        style['min-height'] = String(this.minHeight) + 'px';
      }
      return style;
    }
  },
  methods: {
    extendScroll: function extendScroll(cssSelector) {
      var _this = this;

      setTimeout(function () {
        if (_this.$el.getElementsByClassName) {
          (function () {
            var content = _this.$el.getElementsByClassName('basic-modal__content')[0];
            var elements = content.getElementsByClassName(cssSelector);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var element = _step.value;

                element.addEventListener('click', function () {
                  setTimeout(function () {
                    content.scrollBy(0, 200);
                  }, 30);
                });
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          })();
        }
      }, 30);
    },
    open: function open() {
      this.isVisible = true;
      if (this.enableClickClose) {
        window.addEventListener('click', this.handleDocumentClick, true);
      }
    },
    clickedExit: function clickedExit() {
      this._close();
      this.$emit('exited');
    },
    close: function close() {
      this._close();
      this.$emit('closed');
    },
    _close: function _close() {
      if (!this.isVisible) return;
      this.isVisible = false;
      if (this.enableClickClose) {
        window.removeEventListener('click', this.handleDocumentClick, true);
      }
    },
    toggle: function toggle() {
      !this.isVisible ? this.open() : this.close();
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.$el.getElementsByClassName('basic-modal__container')[0].contains(e.target)) {
        this.close();
      }
    }
  }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicModal__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BasicModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton_ActionButton__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton_ActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_actionButton_ActionButton__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BasicModal: __WEBPACK_IMPORTED_MODULE_0__BasicModal___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_1__components_common_actionButton_ActionButton___default.a
  },
  props: {
    modal: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    header: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: undefined
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    yesLabel: {
      type: String,
      default: 'YES'
    },
    noLabel: {
      type: String,
      default: 'NO'
    }
  },
  computed: {
    bm: function bm() {
      return this.$refs.basicModal;
    },
    hasFooterSlot: function hasFooterSlot() {
      return this.$slots.footer;
    },
    hasHeader: function hasHeader() {
      return this.header;
    }
  },
  methods: {
    open: function open() {
      this.bm.open();
    },
    close: function close() {
      this.bm.close();
    },
    clickYes: function clickYes() {
      this.$emit('yes');
      this.close();
    },
    clickNo: function clickNo() {
      this.$emit('no');
      this.close();
    }
  }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_cancel_svg__ = __webpack_require__(98);








var HEIGHT_OF_ACTIONS = 52;
var PADDING_OF_MODAL = 44;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_2__components_common_svgIcon__["a" /* default */],
    LoadingDots: __WEBPACK_IMPORTED_MODULE_3__components_common_loaderDots__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    relativeToParent: {
      type: Boolean,
      default: false
    },
    hasBg: {
      type: Boolean,
      default: true
    },
    initiallyDisplay: {
      type: Boolean,
      default: false
    },
    removePadding: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    },
    heightOverride: {
      type: Number,
      default: null
    },

    heightRange: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: function _default() {}
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    enableBackgroundClickToClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isVisible: this.initiallyDisplay,
      cancel: __WEBPACK_IMPORTED_MODULE_4__assets_svg_cancel_svg__["a" /* default */],
      heightOfContent: null,
      setup: false
    };
  },

  computed: {
    contentHeightStyle: function contentHeightStyle() {
      var style = {};
      if (this.heightOfContent) {
        style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, { height: this.heightOfContent + 'px' });
      }
      if (this.heightRange) {
        style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, {
          'min-height': this.heightRange.min + 'px',
          'max-height': this.heightRange.max + 'px'
        });
      }
      return style;
    },
    modalWidth: function modalWidth() {
      var width = this.width ? String(this.width) + 'px' : '90%';
      return this.autoWidth ? { maxWidth: 'none', width: width } : { width: width };
    }
  },
  methods: {
    extendScroll: function extendScroll(cssSelector) {
      var _this = this;

      setTimeout(function () {
        if (_this.$el.getElementsByClassName) {
          (function () {
            var content = _this.$el.getElementsByClassName('modal__content')[0];
            var elements = content.getElementsByClassName(cssSelector);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(elements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var element = _step.value;

                element.addEventListener('click', function () {
                  setTimeout(function () {
                    content.scrollBy(0, 200);
                  }, 30);
                });
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          })();
        }
      }, 30);
    },
    open: function open() {
      this.isVisible = true;
      this.setup = true;
      window.addEventListener('click', this.handleDocumentClick, true);
    },
    close: function close() {
      if (!this.isVisible) return;
      this.isVisible = false;
      this.breakdown();
      window.removeEventListener('click', this.handleDocumentClick, true);
      this.$emit('closed');
    },
    toggle: function toggle() {
      !this.isVisible ? this.open() : this.close();
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.$el.getElementsByClassName('modal__container')[0].contains(e.target)) {
        if (!this.enableBackgroundClickToClose) {
          return;
        } else if (!this.closeButton) {
          this.close();
        }
      }
    },
    breakdown: function breakdown() {
      this.heightOfContent = null;
    }
  },
  updated: function updated() {
    var container = this.$refs.container;
    if (this.setup && container) {
      if (this.heightOverride) {
        this.heightOfContent = this.heightOverride;
      } else if (!this.autoWidth && !this.heightRange && this.autoHeight) {
        var contentHeight = container.clientHeight;
        if (contentHeight !== this.heightOfContent) {
          this.heightOfContent = contentHeight - HEIGHT_OF_ACTIONS - PADDING_OF_MODAL;
        }
      }
      this.setup = false;
    }
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationIcon__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NotificationIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_times_circle__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_ovalLabel__ = __webpack_require__(126);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    NotificationIcon: __WEBPACK_IMPORTED_MODULE_0__NotificationIcon___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default.a,
    OvalButton: __WEBPACK_IMPORTED_MODULE_4__components_common_ovalLabel__["a" /* OvalButton */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* alertLevels */]],
  props: {
    notification: Object,
    actionEngine: {
      type: Object,
      default: null
    },
    dismiss: Function
  },
  computed: {
    action: function action() {
      return this.actionEngine && this.actionEngine.get(this.notification);
    }
  },
  methods: {
    deleteNotification: function deleteNotification() {
      this.$emit('delete', this.notification);
    },
    actionCommand: function actionCommand() {
      if (this.action) {
        this.dismiss();
        this.action.action(this.notification);
      }
    }
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_info_circle__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_check_circle__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_exclamation_triangle__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_times_circle__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(326);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* alertLevels */]],
  props: {
    notification: Object
  },
  computed: {
    name: function name() {
      if (this.isInfo) {
        return 'info-circle';
      } else if (this.isSuccess) {
        return 'check-circle';
      } else if (this.isWarning) {
        return 'exclamation-triangle';
      } else if (this.isError) {
        return 'times-circle';
      } else {
        return 'info-circle';
      }
    }
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_popover__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notifications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    deleteNotificationFunc: Function,
    actionEngine: Object
  },
  computed: {
    newNotificationCount: function newNotificationCount() {
      if (this.notifications.length > 0) {
        return this.notifications.filter(function (n) {
          return n.status === 'new';
        }).length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    showNotificationsClickEvent: function showNotificationsClickEvent(e) {
      var target = e.currentTarget;
      this.showNotifications(target);
    },
    showNotifications: function showNotifications(target) {
      var _this = this;

      if (this.notifications.length > 0) {
        var popover = null;
        popover = __WEBPACK_IMPORTED_MODULE_0__components_common_popover__["a" /* PopoverFactory */].createNotification({
          direction: 'left',
          notifications: this.notifications,
          actionEngine: this.actionEngine,
          deleteNotificationFunc: function deleteNotificationFunc(n) {
            _this.deleteNotificationFunc(n);
            popover.dismiss();
            setTimeout(function () {
              return _this.showNotifications(target);
            }, 20);
          },
          parent: target
        });
      }
    }
  }
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_popover__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_bell__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon___default.a
  },
  props: {
    notifications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    deleteNotificationFunc: Function,
    actionEngine: Object
  },
  computed: {
    newNotificationCount: function newNotificationCount() {
      if (this.notifications.length > 0) {
        return this.notifications.filter(function (n) {
          return n.status === 'new';
        }).length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    showNotificationsClickEvent: function showNotificationsClickEvent(e) {
      var target = e.currentTarget;
      this.showNotifications(target);
    },
    showNotifications: function showNotifications(target) {
      var _this = this;

      if (this.notifications.length > 0) {
        var popover = null;
        popover = __WEBPACK_IMPORTED_MODULE_0__components_common_popover__["a" /* PopoverFactory */].createNotification({
          direction: 'left',
          notifications: this.notifications,
          actionEngine: this.actionEngine,
          deleteNotificationFunc: function deleteNotificationFunc(n) {
            _this.deleteNotificationFunc(n);
            popover.dismiss();
            setTimeout(function () {
              return _this.showNotifications(target);
            }, 20);
          },
          parent: target,
          colorTheme: 'white'
        });
      }
    }
  }
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popoverContainerMixin__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__popoverContainerMixin__["a" /* default */]],
  components: {
    PopoverCheckmarkBtn: __WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn___default.a,
    PopoverBox: __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default.a
  },
  props: {
    attribute: Object
  },
  data: function data() {
    return {
      selectedDate: ''
    };
  },

  computed: {
    notBefore: function notBefore() {
      return new Date(this.attribute.min);
    },
    notAfter: function notAfter() {
      return new Date(this.attribute.max);
    },
    isInvalid: function isInvalid() {
      return this.selectedDate === '';
    }
  },
  methods: {
    selectAttribute: function selectAttribute() {
      console.log(this.selectedDate);
      var chosenAttribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(this.attribute);
      chosenAttribute.value = {
        min: this.selectedDate[0].toISOString().slice(0, 10),
        max: this.selectedDate[1].toISOString().slice(0, 10)
      };

      this.$refs.popover.dismiss();
      this.$emit('select', chosenAttribute);
    }
  }
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__ = __webpack_require__(87);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__["a" /* default */]],
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default.a
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    currentValue: null,
    align: {
      type: String,
      default: 'left'
    }
  },
  computed: {
    optionStyle: function optionStyle() {
      return {
        'text-align': this.align
      };
    }
  },
  methods: {
    optionClass: function optionClass(value) {
      return this.currentValue === value ? 'is-selected' : '';
    },
    selectOption: function selectOption(value) {
      this.$refs.popover.dismiss();
      this.$emit('select', value);
    }
  }
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSelector__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OperatorSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__ = __webpack_require__(87);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__["a" /* default */]],
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default.a, OperatorSelector: __WEBPACK_IMPORTED_MODULE_1__OperatorSelector___default.a
  },
  methods: {
    selectOperator: function selectOperator(operator) {
      this.$refs.popover.dismiss();
      this.$emit('select', operator);
    }
  }
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_models_operators__ = __webpack_require__(157);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    selectedOperator: Object
  },
  data: function data() {
    return {
      operator: __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_models_operators__["a" /* default */]
    };
  },

  methods: {
    selectOperator: function selectOperator(operator) {
      this.$emit('select', operator);
    }
  }
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__ = __webpack_require__(41);





var EDGE_DISTANCE = 10;
var PROP_MAP = {
  top: {
    selectorClass: 'popover-box--selector-top',
    triangleClass: 'popover-box--triangle-down'
  },
  bottom: {
    selectorClass: 'popover-box--selector-bottom',
    triangleClass: 'popover-box--triangle-up'
  },
  left: {
    selectorClass: 'popover-box--selector-left',
    triangleClass: 'popover-box--triangle-right'
  },
  right: {
    selectorClass: 'popover-box--selector-right',
    triangleClass: 'popover-box--triangle-left'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__["a" /* default */]
  },
  props: {
    direction: {
      type: String,
      default: 'top'
    },
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    }
  },
  data: function data() {
    return {
      position: {
        top: '0px',
        left: '0px'
      },
      offset: {
        top: '0px',
        left: '0px'
      }
    };
  },

  computed: {
    selectorClass: function selectorClass() {
      return PROP_MAP[this.direction].selectorClass;
    },
    triangleFirst: function triangleFirst() {
      return ['bottom', 'right'].indexOf(this.direction) > -1;
    },
    triangleClass: function triangleClass() {
      return PROP_MAP[this.direction].triangleClass;
    }
  },
  methods: {
    computePosition: function computePosition(parent, direction) {
      var parentPos = parent.getBoundingClientRect();

      var scrollX = window.pageXOffset;
      var scrollY = window.pageYOffset;

      var positionMap = {
        left: {
          top: scrollY + parentPos.top + parentPos.height / 2 - this.$el.clientHeight / 2,
          left: scrollX + parentPos.left - this.$el.clientWidth
        },
        right: {
          top: scrollY + parentPos.top + parentPos.height / 2 - this.$el.clientHeight / 2,
          left: scrollX + parentPos.left + parentPos.width
        },
        bottom: {
          top: scrollY + parentPos.top + parentPos.height,
          left: scrollX + parentPos.left + parentPos.width / 2 - this.$el.clientWidth / 2
        },
        top: {
          top: scrollY + parentPos.top - this.$el.clientHeight,
          left: scrollX + parentPos.left + parentPos.width / 2 - this.$el.clientWidth / 2
        }
      };

      var position = positionMap[direction];

      return {
        top: Math.round(position.top),
        left: Math.round(position.left)
      };
    },
    computeOffset: function computeOffset(position, direction) {
      var offset = void 0;

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      if (direction === 'top' || direction === 'bottom') {
        var selfLeft = position.left;
        var selfRight = position.left + this.$el.clientWidth;

        var relLeft = selfLeft >= EDGE_DISTANCE ? 0 : EDGE_DISTANCE - selfLeft;
        var relRight = windowWidth - selfRight >= EDGE_DISTANCE ? 0 : selfRight + EDGE_DISTANCE - windowWidth;

        offset = {
          top: 0,
          left: relLeft > 0 ? relLeft : -1 * relRight
        };
      } else if (direction === 'left' || direction === 'right') {
        var selfTop = position.top;
        var selfBottom = position.top + this.$el.clientHeight;

        var relTop = selfTop >= EDGE_DISTANCE ? 0 : EDGE_DISTANCE - selfTop;
        var relBottom = windowHeight - selfBottom >= EDGE_DISTANCE ? 0 : windowHeight - selfBottom + EDGE_DISTANCE;

        offset = {
          top: relTop > 0 ? relTop : -1 * relBottom,
          left: 0
        };
      }

      return {
        top: Math.round(offset.top),
        left: Math.round(offset.left)
      };
    },
    reposition: function reposition() {
      var position = this.computePosition(this.parent, this.direction);
      var offset = this.computeOffset(position, this.direction);

      this.position = {
        top: position.top + offset.top + 'px',
        left: position.left + offset.left + 'px'
      };
      this.offset = {
        top: -1 * offset.top + 'px',
        left: -1 * offset.left + 'px'
      };
      this.$emit('reposition');
    },
    dismiss: function dismiss() {
      var _this = this;

      this.$emit('dismiss');
      this.$destroy();

      setTimeout(function () {
        if (_this && _this.$el) {
          _this.$el.parentNode.removeChild(_this.$el);
        }
      }, 125);
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.$el.contains(e.target)) {
        this.dismiss();
      }
    },
    handleScroll: function handleScroll(e) {
      if (!this.$el.contains(e.target)) {
        this.dismiss();
      }
    }
  },
  mounted: function mounted() {
    this.reposition();
    window.addEventListener('resize', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(this.reposition, 15));
    this.$el.classList.add('popover-box--fade-in');

    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('hashchange', this.dismiss, true);
    window.addEventListener('mousedown', this.handleDocumentClick, true);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(this.reposition, 15));
    this.$el.classList.remove('popover-box--fade-out');

    window.removeEventListener('scroll', this.handleScroll, true);
    window.removeEventListener('mousedown', this.handleDocumentClick, true);
    window.removeEventListener('hashchange', this.dismiss, true);
  }
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_Check_svg__ = __webpack_require__(272);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  data: function data() {
    return {
      Check: __WEBPACK_IMPORTED_MODULE_1__assets_svg_Check_svg__["a" /* default */]
    };
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepperRange_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepperRange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StepperRange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__["a" /* default */]],
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default.a,
    StepperRange: __WEBPACK_IMPORTED_MODULE_0__StepperRange_vue___default.a
  },
  props: {
    attribute: Object,
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    },
    currentValue: null,
    align: {
      type: String,
      default: 'left'
    },
    direction: {
      type: String,
      default: 'top'
    }
  },
  computed: {
    optionStyle: function optionStyle() {
      return {
        'text-align': this.align
      };
    },
    rangeAttribute: function rangeAttribute() {
      return this.attribute.options.range;
    },
    list: function list() {
      return this.attribute.options.select.options;
    },
    selectAttributes: function selectAttributes() {
      return this.attribute.options.select;
    }
  },
  methods: {
    selectAttribute: function selectAttribute(value) {
      var chosenAttribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.rangeAttribute);
      chosenAttribute.value = value;
      this.$refs.popover.dismiss();
      chosenAttribute.dataset = this.attribute.dataset;
      chosenAttribute.path = this.attribute.path;
      chosenAttribute.parent = this.attribute.parent;
      this.$emit('select', chosenAttribute);
    },
    selectOption: function selectOption(value) {
      var chosenAttribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.selectAttributes);
      chosenAttribute.value = value;
      this.$refs.popover.dismiss();
      this.$emit('select', chosenAttribute);
    },
    optionClass: function optionClass(value) {
      return this.currentValue === value ? 'is-selected' : '';
    }
  }
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_Check_svg__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a, SvgIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__["a" /* default */]
  },
  props: {
    attribute: Object
  },
  data: function data() {
    return {
      value: [this.attribute.value ? this.attribute.value.min : this.attribute.min, this.attribute.value ? this.attribute.value.max : this.attribute.max],
      Check: __WEBPACK_IMPORTED_MODULE_2__assets_svg_Check_svg__["a" /* default */],
      bgStyle: {
        backgroundColor: '#A0A7AC'
      },
      sliderStyle: {
        backgroundColor: 'black',
        borderColor: 'white',
        borderWidth: '3px',
        borderStyle: 'solid',
        display: 'block',
        position: 'relative'
      },
      tooltipStyle: {
        backgroundColor: 'black',
        borderWidth: '0',
        borderColor: 'black',
        position: 'absolute',
        top: '-8.5px'
      },
      processStyle: {
        backgroundColor: '#FFBD00'
      },
      labelStyle: {
        background: 'green'
      }
    };
  },

  computed: {
    interval: function interval() {
      var gap = (this.attribute.max - this.attribute.min) / 100;
      if (Math.floor(gap) === gap) {
        return gap;
      } else {
        return 1;
      }
    }
  },
  methods: {
    refreshSlider: function refreshSlider() {
      this.$refs.slider.getStaticData();
    },
    handleClick: function handleClick() {
      var newValue = {
        min: this.value[0],
        max: this.value[1]
      };
      this.$emit('select', newValue);
    },
    formatString: function formatString(val) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* commaFormatString */])('' + val);
    }
  }
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListPopover_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListPopover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ListPopover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__["a" /* default */]],
  components: {
    ListPopover: __WEBPACK_IMPORTED_MODULE_0__ListPopover_vue___default.a
  },
  props: {
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    },
    direction: {
      type: String,
      default: 'top'
    },
    attribute: {
      type: Object
    }
  },
  computed: {
    list: function list() {
      return this.attribute.options;
    }
  },
  methods: {
    selectOption: function selectOption(value) {
      var chosenAttribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(this.attribute);
      chosenAttribute.value = value;
      this.$emit('select', chosenAttribute);
    },
    dismissHandler: function dismissHandler() {
      this.$emit('dismiss');
    }
  }
});

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleStepperRange_vue__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleStepperRange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SingleStepperRange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__ = __webpack_require__(87);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__["a" /* default */]],
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default.a,
    SingleStepperRange: __WEBPACK_IMPORTED_MODULE_0__SingleStepperRange_vue___default.a
  },
  props: {
    attribute: Object
  },
  methods: {
    selectAttribute: function selectAttribute(value) {
      this.$refs.popover.dismiss();
      this.$emit('select', value);
    }
  }
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_svg_Check_svg__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    attribute: Object
  },
  data: function data() {
    return {
      Check: __WEBPACK_IMPORTED_MODULE_1__assets_svg_Check_svg__["a" /* default */],
      count: this.attribute.mustMatch ? this.attribute.mustMatch : 2,
      range: {
        min: 2,
        max: Math.round(this.attribute.children.length / 2) - 1
      }
    };
  },

  computed: {
    incorrectValue: function incorrectValue() {
      return this.count < this.range.min || this.count > this.range.max || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* isDecimal */])(this.count);
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('select', this.count);
    },
    handleEvent: function handleEvent(e) {
      e.stopPropagation();
    }
  }
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepperRange_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepperRange_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StepperRange_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__["a" /* default */]],
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_1__PopoverBox___default.a,
    StepperRange: __WEBPACK_IMPORTED_MODULE_0__StepperRange_vue___default.a
  },
  props: {
    attribute: Object
  },
  methods: {
    selectAttribute: function selectAttribute(value) {
      var chosenAttribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(this.attribute);
      chosenAttribute.value = value;
      this.$refs.popover.dismiss();
      this.$emit('select', chosenAttribute);
    }
  }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopoverCheckmarkBtn: __WEBPACK_IMPORTED_MODULE_0__PopoverCheckmarkBtn___default.a
  },
  props: {
    attribute: Object
  },
  data: function data() {
    return {
      min: this.attribute.value ? this.attribute.value.min : this.attribute.min,
      max: this.attribute.value ? this.attribute.value.max : this.attribute.max,
      range: {
        min: this.attribute.min,
        max: this.attribute.max
      }
    };
  },

  computed: {
    incorrectValue: function incorrectValue() {
      return Number(this.min) > Number(this.max) || Number(this.max) < Number(this.min) || Number(this.min) < Number(this.range.min) || Number(this.max) > Number(this.range.max);
    }
  },
  methods: {
    handleClick: function handleClick() {
      var newValue = {
        min: Number(this.min),
        max: Number(this.max)
      };
      this.$emit('select', newValue);
    },
    handleEvent: function handleEvent(e) {
      e.stopPropagation();
    }
  }
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__ = __webpack_require__(127);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__["a" /* default */]],
  props: {
    list: {
      type: Array,
      required: true
    },
    currentValue: null,
    align: {
      type: String,
      default: 'left'
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    tipColor: String,
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    optionStyle: function optionStyle() {
      return {
        'text-align': this.align
      };
    }
  },
  methods: {
    optionClass: function optionClass(op) {
      if (this.multiSelect) {
        return this.currentValue ? this.currentValue.filter(function (el) {
          return el === op.value;
        }).length > 0 ? 'is-selected' : '' : '';
      } else {
        return this.currentValue === op.value || this.currentValue === op.name ? 'is-selected' : '';
      }
    },
    selectOption: function selectOption(value, selectedOption, event) {
      this.$emit('select', value, selectedOption, event);
      if (this.dismiss && !this.multiSelect) {
        this.dismiss();
      }
    }
  }
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(325);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__["a" /* default */]],
  props: {
    notifications: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actionEngine: Object,
    deleteNotificationFunc: Function,
    maxHeight: {
      type: Number,
      default: 500
    },
    maxWidth: {
      type: Number,
      default: 500
    },
    colorTheme: {
      type: String,
      default: undefined
    }
  },
  methods: {
    deleteNotification: function deleteNotification(notification) {
      this.deleteNotificationFunc(notification);
    }
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSelector__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OperatorSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__ = __webpack_require__(127);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__popoverContainerMixin__["a" /* default */]],
  props: {
    enableNot: {
      type: Boolean,
      default: true
    },
    enableMinus: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_0__PopoverBox___default.a, OperatorSelector: __WEBPACK_IMPORTED_MODULE_1__OperatorSelector___default.a
  },
  methods: {
    selectOperator: function selectOperator(operator) {
      var _this = this;

      this.$emit('select', operator);
      setTimeout(function () {
        return _this.dismiss();
      }, 5);
    }
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_models_operators__ = __webpack_require__(157);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_0__components_common_svgIcon__["a" /* default */]
  },
  props: {
    selectedOperator: Object,
    enableNot: {
      type: Boolean,
      default: true
    },
    enableMinus: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      operator: __WEBPACK_IMPORTED_MODULE_1__appComponents_workbench_targetDefinition_models_operators__["a" /* default */]
    };
  },

  methods: {
    selectOperator: function selectOperator(operator) {
      this.$emit('select', operator);
    }
  }
});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__ = __webpack_require__(41);





var THEME = {
  WHITE: 'white',
  BLACK: 'black'
};

var EDGE_DISTANCE = 10;
var PROP_MAP = {
  top: {
    selectorClass: 'popover-box--selector-top',
    triangleClass: {
      normal: 'popover-box--triangle-down',
      white: 'popover-box--triangle-down-white',
      black: 'popover-box--triangle-down-black'
    }
  },
  bottom: {
    selectorClass: 'popover-box--selector-bottom',
    triangleClass: {
      normal: 'popover-box--triangle-up',
      white: 'popover-box--triangle-up-white',
      black: 'popover-box--triangle-up-black'
    }
  },
  left: {
    selectorClass: 'popover-box--selector-left',
    triangleClass: {
      normal: 'popover-box--triangle-right',
      white: 'popover-box--triangle-right-white',
      black: 'popover-box--triangle-right-black'
    }
  },
  right: {
    selectorClass: 'popover-box--selector-right',
    triangleClass: {
      normal: 'popover-box--triangle-left',
      white: 'popover-box--triangle-left-white',
      black: 'popover-box--triangle-left-black'
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_1__components_common_scrollPanel__["a" /* default */]
  },
  props: {
    direction: {
      type: String,
      default: 'top'
    },
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    },
    colorTheme: {
      type: String,
      default: 'black'
    },
    tipColor: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      position: {
        top: '0px',
        left: '0px'
      },
      offset: {
        top: '0px',
        left: '0px'
      }
    };
  },

  computed: {
    selectorClass: function selectorClass() {
      return PROP_MAP[this.direction].selectorClass;
    },
    triangleFirst: function triangleFirst() {
      return ['bottom', 'right'].indexOf(this.direction) > -1;
    },
    triangleClass: function triangleClass() {
      var dir = PROP_MAP[this.direction].triangleClass;
      return [dir[this.tipColor ? this.tipColor : this.colorTheme], dir.normal];
    },
    styles: function styles() {
      if (this.colorTheme === THEME.WHITE) {
        return {
          popover: { 'color': 'black' },
          content: 'popover-box__content-white'
        };
      } else {
        return {
          popover: { 'color': 'white' },
          content: 'popover-box__content-black'
        };
      }
    }
  },
  methods: {
    computePosition: function computePosition(parent, direction) {
      var parentPos = parent.getBoundingClientRect();

      var scrollX = window.pageXOffset;
      var scrollY = window.pageYOffset;

      var positionMap = {
        left: {
          top: scrollY + parentPos.top + parentPos.height / 2 - this.$el.clientHeight / 2,
          left: scrollX + parentPos.left - this.$el.clientWidth
        },
        right: {
          top: scrollY + parentPos.top + parentPos.height / 2 - this.$el.clientHeight / 2,
          left: scrollX + parentPos.left + parentPos.width
        },
        bottom: {
          top: scrollY + parentPos.top + parentPos.height,
          left: scrollX + parentPos.left + parentPos.width / 2 - this.$el.clientWidth / 2
        },
        top: {
          top: scrollY + parentPos.top - this.$el.clientHeight,
          left: scrollX + parentPos.left + parentPos.width / 2 - this.$el.clientWidth / 2
        }
      };

      var position = positionMap[direction];

      return {
        top: Math.round(position.top),
        left: Math.round(position.left)
      };
    },
    computeOffset: function computeOffset(position, direction) {
      var offset = void 0;

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      if (direction === 'top' || direction === 'bottom') {
        var selfLeft = position.left;
        var selfRight = position.left + this.$el.clientWidth;

        var relLeft = selfLeft >= EDGE_DISTANCE ? 0 : EDGE_DISTANCE - selfLeft;
        var relRight = windowWidth - selfRight >= EDGE_DISTANCE ? 0 : selfRight + EDGE_DISTANCE - windowWidth;

        offset = {
          top: 0,
          left: relLeft > 0 ? relLeft : -1 * relRight
        };
      } else if (direction === 'left' || direction === 'right') {
        var selfTop = position.top;
        var selfBottom = position.top + this.$el.clientHeight;

        var relTop = selfTop >= EDGE_DISTANCE ? 0 : EDGE_DISTANCE - selfTop;
        var relBottom = windowHeight - selfBottom >= EDGE_DISTANCE ? 0 : windowHeight - selfBottom + EDGE_DISTANCE;

        offset = {
          top: relTop > 0 ? relTop : -1 * relBottom,
          left: 0
        };
      }

      return {
        top: Math.round(offset.top),
        left: Math.round(offset.left)
      };
    },
    reposition: function reposition() {
      var position = this.computePosition(this.parent, this.direction);
      var offset = this.computeOffset(position, this.direction);

      this.position = {
        top: position.top + offset.top + 'px',
        left: position.left + offset.left + 'px'
      };
      this.offset = {
        top: -1 * offset.top + 'px',
        left: -1 * offset.left + 'px'
      };
      this.$emit('reposition');
    }
  },
  mounted: function mounted() {
    this.reposition();
    window.addEventListener('resize', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(this.reposition, 15));
    this.$el.classList.add('popover-box--fade-in');
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(this.reposition, 15));
    this.$el.classList.remove('popover-box--fade-out');
  }
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListPopover_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListPopover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ListPopover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__popoverContainerMixin__["a" /* default */]],
  components: {
    ListPopover: __WEBPACK_IMPORTED_MODULE_0__ListPopover_vue___default.a
  },
  props: {
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    },
    direction: {
      type: String,
      default: 'top'
    },
    attribute: {
      type: Object
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    values: null
  },
  data: function data() {
    return {
      selectedValues: []
    };
  },
  mounted: function mounted() {
    this.selectedValues = this.values ? this.values : [];
  },

  computed: {
    list: function list() {
      return this.attribute.options;
    },
    currentValue: function currentValue() {
      if (this.multiSelect) {
        return this.selectedValues;
      } else {
        return this.attribute.value;
      }
    }
  },
  methods: {
    selectOption: function selectOption(value) {
      var chosenAttribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(this.attribute);
      chosenAttribute.value = value;
      this.$emit('select', chosenAttribute);
      if (this.multiSelect) {
        this.selectedValues.push(chosenAttribute.value);
      }
    },
    dismissHandler: function dismissHandler() {
      this.$emit('dismiss');
    }
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builderComponents_PopoverBox__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builderComponents_PopoverBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__builderComponents_PopoverBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builderComponents_popoverContainerMixin__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__ = __webpack_require__(17);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopoverBox: __WEBPACK_IMPORTED_MODULE_0__builderComponents_PopoverBox___default.a,
    ActionButton: __WEBPACK_IMPORTED_MODULE_2__components_common_actionButton__["a" /* default */]
  },
  props: {
    parent: HTMLDivElement,
    direction: String
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__builderComponents_popoverContainerMixin__["a" /* default */]],
  methods: {
    clickedSubmit: function clickedSubmit() {
      this.$emit('submit');
    }
  }
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormPopover__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormPopover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FormPopover__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FormPopover: __WEBPACK_IMPORTED_MODULE_0__FormPopover___default.a
  },
  props: {
    direction: String,
    parent: HTMLDivElement,
    onSubmit: Function,
    formLabel: String
  },
  data: function data() {
    return {
      valueInput: ''
    };
  },
  mounted: function mounted() {
    document.getElementsByClassName('form-popover__input')[0].focus();
  },

  methods: {
    submit: function submit() {
      this.onSubmit(this.valueInput);
      this.dismiss();
    }
  }
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_plus__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__);





var DEFAULT_SIZE = 25;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default.a
  },
  props: {
    size: {
      type: Number,
      default: DEFAULT_SIZE
    }
  },
  computed: {
    sizeStyle: function sizeStyle() {
      return {
        'height': this.size + 'px',
        'width': this.size + 'px'
      };
    },
    scale: function scale() {
      return this.size / DEFAULT_SIZE;
    }
  }
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_plus__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_minus__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon___default.a
  },
  props: {
    number: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    isPositive: function isPositive() {
      return this.number > 0;
    },
    isNegative: function isNegative() {
      return this.number < 0;
    }
  }
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_caret_down__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_caret_up__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_0__components_common_scrollPanel__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default.a
  },
  props: {
    text: String,
    scrollHeight: {
      type: Number,
      default: 480
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data: function data() {
    return {
      show: false,
      buttonPosition: {},
      canvasStyle: {}
    };
  },

  methods: {
    toggleHiddenSection: function toggleHiddenSection() {
      this.show = !this.show;
      this.setCanvisStyle();
    },
    getButtonSize: function getButtonSize() {
      return this.$refs.button ? this.$refs.button.clientWidth : 0;
    },
    setButtonPosition: function setButtonPosition() {
      var centerOfPanel = this.width / 2;
      var centerOfButton = this.getButtonSize() / 2;
      this.buttonPosition = {
        left: String(centerOfPanel - centerOfButton) + 'px'
      };
    },
    setCanvisStyle: function setCanvisStyle() {
      this.canvasStyle = { 'z-index': this.show ? 109 : 110 };
    }
  },
  mounted: function mounted() {
    this.setButtonPosition();
    this.setCanvisStyle();
  },

  watch: {
    width: function width() {
      this.setButtonPosition();
    }
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


function makeid(x) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < x; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String,
      default: null
    },
    onSelect: {
      type: Function,
      default: function _default() {}
    },
    disabled: {
      type: Boolean,
      defautl: false
    }
  },
  data: function data() {
    return {
      radioButtonName: null
    };
  },
  beforeMount: function beforeMount() {
    this.radioButtonName = this.name ? this.name : makeid(15);
  },

  methods: {
    emitInput: function emitInput(e) {
      this.$emit('input', e.target.value);
      this.onSelect();
    }
  }
});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    height: {
      type: Number | String,
      default: -1
    },
    useMax: {
      type: Boolean,
      default: false
    },
    isScrollDisabled: {
      type: Boolean,
      default: false
    },
    isPinned: {
      type: Boolean,
      default: false
    },
    hasPadding: {
      type: Boolean,
      default: true
    },
    hideXOverflow: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number | String | null,
      default: null
    }
  },
  computed: {
    style: function style() {
      var style = {};
      style['height'] = this.localHeight;
      style['overflow-x'] = this.hideXOverflow ? 'hidden' : null;
      if (this.width) {
        style['width'] = this.width + 'px';
      }
      return style;
    },
    localHeight: function localHeight() {
      return this.height === -1 ? 'auto' : typeof this.height === 'string' ? this.height : this.height + 'px';
    }
  }
});

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svg_search_svg__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_cancel_svg__ = __webpack_require__(98);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SvgIcon: __WEBPACK_IMPORTED_MODULE_1__components_common_svgIcon__["a" /* default */]
  },
  props: {
    value: {
      type: String
    },
    debounce: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localValue: '',
      searchIcon: __WEBPACK_IMPORTED_MODULE_2__assets_svg_search_svg__["a" /* default */],
      cancelIcon: __WEBPACK_IMPORTED_MODULE_3__assets_svg_cancel_svg__["a" /* default */]
    };
  },

  computed: {
    isSearchInputEmpty: function isSearchInputEmpty() {
      return this.localValue.length === 0;
    }
  },
  methods: {
    clearSearch: function clearSearch() {
      this.localValue = '';
    }
  },
  beforeMount: function beforeMount() {
    if (this.value) {
      this.localValue = this.value;
    }
  },
  created: function created() {
    this._emitInputEventDebounced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function (newValue) {
      if (this.localValue === '') return;
      this.$emit('input', newValue);
    }, this.debounce);

    this.$watch('localValue', function (newValue) {
      if (newValue.length) {
        this._emitInputEventDebounced(newValue);
      } else {
        this.$emit('input', newValue);
      }
    });
  }
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleButton__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SimpleButton__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SimpleButton: __WEBPACK_IMPORTED_MODULE_0__SimpleButton___default.a
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: String,
      default: 'Submit'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['width', 'height', 'icon'],
  computed: {
    iconClass: function iconClass() {
      if (!this.icon) return '';
      return 'icon--' + this.icon.id;
    }
  }
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    emptyMessage: {
      type: String,
      default: 'There are no Rows to Display'
    },
    message: String
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyTable__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EmptyTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_tables___ = __webpack_require__(212);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LoaderDots: __WEBPACK_IMPORTED_MODULE_0__components_common_loaderDots__["a" /* default */],
    EmptyTable: __WEBPACK_IMPORTED_MODULE_1__EmptyTable___default.a,
    StyledTable: __WEBPACK_IMPORTED_MODULE_2__components_common_tables___["a" /* StyledTable */]
  },
  props: {
    loading: Boolean,
    emptyTableProps: Object,
    tableProps: Object
  },
  computed: {
    table: function table() {
      return this.$refs.table.table;
    }
  }
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    sort: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    theme: {
      type: String,
      default: 'dark'
    },
    responsive: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: -1 },

    hoverOverlayComponent: String,
    bottomOverlayComponent: String,
    externalFiltering: Function,
    overlayColumnStart: Number,
    lazyLoad: Boolean,
    tableType: Number,
    rowKey: String,
    refreshTable: Boolean
  },
  data: function data() {
    return {
      sortBy: null,
      sortDesc: false,
      columnDefinitions: []
    };
  },

  computed: {
    table: function table() {
      return this.$refs.table;
    },
    computedHeaders: function computedHeaders() {
      if (this.headers && this.headers.length > 0) {
        return this.headers;
      }

      return this.columnDefinitions;
    },
    tableClasses: function tableClasses() {
      return ['styled-data-table', 'styled-data-table--' + this.theme, {
        'styled-data-table--responsive': this.responsive
      }];
    }
  },
  mounted: function mounted() {
    if (this.sort && this.sort.prop) {
      this.sortBy = this.sort.prop;
      this.sortDesc = this.sort.order === 'descending';
    }

    this.extractColumnDefinitions();
  },

  methods: {
    themeClass: function themeClass() {
      return 'table-v2-custom--' + this.theme + '-theme';
    },
    handleSortChange: function handleSortChange(sortBy) {
      this.sortBy = sortBy;
      this.emitSortChange();
    },
    handleSortDescChange: function handleSortDescChange(sortDesc) {
      this.sortDesc = sortDesc;
      this.emitSortChange();
    },
    emitSortChange: function emitSortChange() {
      var sortData = {
        prop: this.sortBy,
        order: this.sortDesc ? 'descending' : 'ascending'
      };
      this.$emit('sort-change', sortData);
    },
    extractColumnDefinitions: function extractColumnDefinitions() {
      if (this.data && this.data.length > 0) {
        var firstItem = this.data[0];
        this.columnDefinitions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(firstItem).map(function (key) {
          return {
            text: key.charAt(0).toUpperCase() + key.slice(1),
            value: key,
            sortable: true
          };
        });
      }
    },
    formatCellValue: function formatCellValue(item, header) {
      var value = item[header.value];
      return value !== null && value !== undefined ? value : '';
    },
    getRowClass: function getRowClass(index) {
      return ['styled-table-row', {
        'styled-table-row--even': index % 2 === 0,
        'styled-table-row--odd': index % 2 === 1
      }];
    },
    getCellClass: function getCellClass(header) {
      return ['styled-table-cell', 'styled-table-cell--' + header.value];
    }
  }
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  computed: {
    id: function id() {
      return this.name.toLowerCase().replace(/ /g, '-');
    }
  }
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabs: null
    };
  },
  created: function created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab: function selectTab(id) {
      var _this = this;

      this.tabs.forEach(function (tab) {
        tab.isActive = tab.id === id;
        if (tab.isActive) {
          _this.$emit('input', tab.name);
        }
      });
    }
  },
  mounted: function mounted() {
    this.selectTab(this.tabs[0].id);
  }
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    leftLabel: {
      type: String,
      default: 'On'
    },
    rightLabel: {
      type: String,
      default: 'Off'
    },
    toggleValue: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    toggleState: function toggleState() {
      return this.toggleValue ? 'toggle-button--true' : 'toggle-button--false';
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('toggle');
    }
  }
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var DIRECTIONS = {
  LEFT: 1,
  RIGHT: 2
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: String,
      default: ''
    },
    direction: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isLeft: function isLeft() {
      return this.direction === DIRECTIONS.LEFT;
    },
    isRight: function isRight() {
      return this.direction === DIRECTIONS.RIGHT;
    }
  }
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons_times_circle__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default.a
  },
  props: {
    scale: {
      type: Number,
      default: 1
    }
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String
    },
    tip: {
      type: String,
      default: null
    },
    xAxis: {
      type: String,
      default: null
    },
    yAxis: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_ConfigAPI__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appLogic_route_store_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appLogic_targets_createTarget_store_actions__ = __webpack_require__(26);






/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    adobeAnalytics.viewHome();
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__appLogic_route_store_actions__["b" /* SET_BACK_ROUTE */], 'user-audience-hub');
  },
  updated: function updated() {
    if (this.$store.state.auth.loggingOut) {
      this.$auth.signOut();
    }
  }
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceHubDashboardHeader__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceHubDashboardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceHubDashboardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_audienceHubDashboard_AudienceHubTable__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_audienceHubDashboard_AudienceHubTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_audienceHubDashboard_AudienceHubTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_audienceHubDashboard_DashboardActionModal__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_audienceHubDashboard_DashboardActionModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_audienceHubDashboard_DashboardActionModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AudienceHubTable: __WEBPACK_IMPORTED_MODULE_1__appComponents_audienceHubDashboard_AudienceHubTable___default.a,
    DashboardActionModal: __WEBPACK_IMPORTED_MODULE_2__appComponents_audienceHubDashboard_DashboardActionModal___default.a,
    DashboardHeader: __WEBPACK_IMPORTED_MODULE_0__appComponents_common_AudienceHubDashboardHeader___default.a
  },
  props: {
    query: Object
  },
  data: function data() {
    return {
      popover: null,
      activeTarget: {}
    };
  },

  computed: {
    routeParamsName: function routeParamsName() {
      return this.$route.params.name;
    },
    whichTargets: function whichTargets() {
      return this.$store.state.targetManager.displayOptions.whichTargets;
    },
    username: function username() {
      return this.$store.state.auth.username;
    },
    nielsenDatasources: function nielsenDatasources() {
      return this.$store.getters.getNielsenDatasources;
    },
    C360Datasources: function C360Datasources() {
      return this.$store.getters.getC360Datasources;
    }
  },
  methods: {
    showDeleteModal: function showDeleteModal(target) {
      this.$refs.deleteModal.open(target);
    },
    handleTargetOption: function handleTargetOption(option, target) {
      if (option === 'DELETE') {
        this.handleDelete(target);
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* targetRouteHandler */])(option, target);
    },
    deleteTarget: function deleteTarget(target) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* targetRouteHandler */])('DELETE', target);
    },
    handleDelete: function handleDelete(target) {
      this.activeTarget = target;
      this.$refs.deleteModal.open();
    },
    newTarget: function newTarget() {
      this.$router.push({ name: 'new-target' });
    }
  }
});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_XandrAPI__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ag_grid_enterprise__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ag_grid_enterprise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ag_grid_enterprise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ag_grid_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_U_D_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_actionButton_ActionButton__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_actionButton_ActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_actionButton_ActionButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);















var CE = function CE(event, name) {
  return { event: event, name: name };
};

var STATUS = {
  XANDR_SEGMENTATION_CAMPAIGN_CREATE: 1,
  RECEIVE_TARGET_LIST_FILE: 4,
  XANDR_DATA_CREATE_CAMPAIGN: 7,
  RECEIVE_PLANNING_FILE: 9,
  RECEIVE_XANDR_DATA_UPDATE: 13,
  MAKE_XANDR_DATA_UPDATE: 16,
  CAE_CCPID: 20
};

var COLUMN_DEF = [{ headerName: 'Days Since Event', width: 150, field: 'daysSinceEvent', sortable: true }, { headerName: 'CAE ID', width: 90, field: 'data.target.cae_id', sortable: true }, { headerName: 'Target ID', width: 300, field: 'data.target.id' }, { headerName: 'Date', width: 200, valueGetter: function valueGetter(params) {
    return __WEBPACK_IMPORTED_MODULE_11_moment___default()(params.data.date).format('MM/DD/YYYY hh:mm:ss a');
  }, sortable: true }];

var HEIRARCHY_EVENTS = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a([STATUS.XANDR_SEGMENTATION_CAMPAIGN_CREATE, STATUS.RECEIVE_TARGET_LIST_FILE, STATUS.XANDR_DATA_CREATE_CAMPAIGN, STATUS.RECEIVE_PLANNING_FILE, STATUS.CAE_CCPID]);

var SPARCE_EVENTS = [[STATUS.RECEIVE_XANDR_DATA_UPDATE, STATUS.MAKE_XANDR_DATA_UPDATE], [STATUS.MAKE_XANDR_DATA_UPDATE]];

var BUTTON_STATUS = {
  TOP_LEVEL: 1,
  ALL_EVENTS: 2,
  ONE_TARGET: 3
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AgGridVue: __WEBPACK_IMPORTED_MODULE_7_ag_grid_vue__["AgGridVue"],
    ActionButton: __WEBPACK_IMPORTED_MODULE_10__components_common_actionButton_ActionButton___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker___default.a
  },
  data: function data() {
    var EVENTS = {
      XANDR_SEGMENTATION_CAMPAIGN_CREATE: CE(STATUS.XANDR_SEGMENTATION_CAMPAIGN_CREATE, 'Xandr Campaign Created'),
      RECEIVE_TARGET_LIST_FILE: CE(STATUS.RECEIVE_TARGET_LIST_FILE, 'Xandr Target List File Received'),
      XANDR_DATA_CREATE_CAMPAIGN: CE(STATUS.XANDR_DATA_CREATE_CAMPAIGN, 'Xandr Data Campaign Created'),
      RECEIVE_PLANNING_FILE: CE(STATUS.RECEIVE_PLANNING_FILE, 'Received Planning File'),
      RECEIVE_XANDR_DATA_UPDATE: CE(STATUS.RECEIVE_XANDR_DATA_UPDATE, 'Received Xandr Data Update'),
      MAKE_XANDR_DATA_UPDATE: CE(STATUS.MAKE_XANDR_DATA_UPDATE, 'Made Update to Xandr Data'),
      CAE_CCPID: CE(STATUS.CAE_CCPID, 'CAE CCPID Received')
    };
    return {
      selectedButton: 1,
      selectedTarget: '',
      selectedDate: __WEBPACK_IMPORTED_MODULE_11_moment___default()().add(-30, 'days').toDate(),
      todaysDate: new Date(),
      columnDef: COLUMN_DEF,
      traces: [],

      events: {},

      ids: {},

      heirarchyData: {},

      sparceData: [],
      eventTypes: EVENTS
    };
  },
  mounted: function mounted() {
    this.getTopEvents();
  },

  methods: {
    getTopEvents: function getTopEvents() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__api_XandrAPI__["a" /* default */].getTopLevelTracing(this.selectedDate).then(function (data) {
        _this.setEvents(data);
      });
    },
    getAllEvents: function getAllEvents() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__api_XandrAPI__["a" /* default */].getXandrTracing(this.selectedDate).then(function (data) {
        _this2.setEvents(data);
      });
    },
    getEventsOfSelectedTarget: function getEventsOfSelectedTarget() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__api_XandrAPI__["a" /* default */].getXandrTracing(this.selectedDate, this.selectedTarget).then(function (data) {
        _this3.setEvents(data);
      });
    },
    setUpEventTypes: function setUpEventTypes() {},
    setEvents: function setEvents(data) {
      this.events = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var e = _step.value;

          if (!this.events[e.event]) {
            this.events[e.event] = [];
          }
          e.daysSinceEvent = __WEBPACK_IMPORTED_MODULE_11_moment___default()().add(10, 'days').diff(__WEBPACK_IMPORTED_MODULE_11_moment___default()(e.date), 'days');
          this.events[e.event].push(e);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.ids = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _e = _step2.value;

          if (!this.ids[_e.id]) {
            this.ids[_e.id] = [];
          }
          this.ids[_e.id].push(_e);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.ids)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var i = _step3.value;

          this.ids[i] = this.ids[i].sort(function (a, b) {
            return b.event - a.event;
          });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(HEIRARCHY_EVENTS)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var eId = _step4.value;

          this.heirarchyData[eId] = [];
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.ids)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _i = _step5.value;

          var eventsOfId = this.ids[_i];
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(eventsOfId), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _e2 = _step7.value;

              if (HEIRARCHY_EVENTS.has(_e2.event)) {
                this.heirarchyData[_e2.event].push(_e2);
                break;
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.sparceData = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(SPARCE_EVENTS), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var lOfEvent = _step6.value;

          var sparceEvents = {};
          this.sparceData = sparceEvents;
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(lOfEvent), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _e3 = _step8.value;

              sparceEvents[_e3] = this.events[_e3];
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.heirarchyData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.heirarchyData);
      this.events = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.events);
    },
    setButtonTopLevel: function setButtonTopLevel() {
      this.selectedButton = BUTTON_STATUS.TOP_LEVEL;
      this.getTopEvents();
    },
    setButtonAllEvents: function setButtonAllEvents() {
      this.selectedButton = BUTTON_STATUS.ALL_EVENTS;
      this.getAllEvents();
    },
    setButtonOneTarget: function setButtonOneTarget() {
      this.selectedButton = BUTTON_STATUS.ONE_TARGET;
      this.getEventsOfSelectedTarget();
    }
  },
  computed: {
    getHeirarchyTopList: function getHeirarchyTopList() {
      return this.heirarchyData[20];
    },
    hasSelectedTarget: function hasSelectedTarget() {
      return this.selectedTarget !== '';
    },
    buttonSelectedTopLevel: function buttonSelectedTopLevel() {
      return this.selectedButton === BUTTON_STATUS.TOP_LEVEL;
    },
    buttonSelectedAllEvents: function buttonSelectedAllEvents() {
      return this.selectedButton === BUTTON_STATUS.ALL_EVENTS;
    },
    buttonSelectedOneTarget: function buttonSelectedOneTarget() {
      return this.selectedButton === BUTTON_STATUS.ONE_TARGET;
    }
  },
  watch: {
    heirarchyData: function heirarchyData() {
      console.log(this.heirarchyData);
    }
  }
});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_simpleButton__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_auth_constants__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_feedbackModal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_AM_Logo_Final_White_audience_matters_logo_white_svg__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_loaderDots__ = __webpack_require__(53);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SimpleButton: __WEBPACK_IMPORTED_MODULE_0__components_common_simpleButton__["a" /* default */], ErrorModal: __WEBPACK_IMPORTED_MODULE_2__components_common_feedbackModal__["a" /* ErrorModal */], SvgIcon: __WEBPACK_IMPORTED_MODULE_3__components_common_svgIcon__["a" /* default */], LoaderDots: __WEBPACK_IMPORTED_MODULE_5__components_common_loaderDots__["a" /* default */]
  },
  props: {
    signInEvent: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      logoIcon: __WEBPACK_IMPORTED_MODULE_4__assets_AM_Logo_Final_White_audience_matters_logo_white_svg__["a" /* default */]
    };
  },

  computed: {
    authError: function authError() {
      return this.$store.state.auth.error;
    },
    loading: function loading() {
      return this.$store.state.auth.loading;
    },
    buttonClass: function buttonClass() {
      return this.buttonClickable ? 'login__simple-button--active' : 'login__simple-button--inactive';
    },
    buttonClickable: function buttonClickable() {
      return this.username.length > 0 && this.password.length > 0 && !this.authError;
    }
  },
  methods: {
    handleSubmit: function handleSubmit() {
      this.$emit('submit', { username: this.username, password: this.password });
    },
    clearError: function clearError() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_modules_auth_constants__["b" /* SET_ERROR */], null);
    }
  },
  watch: {
    authError: function authError(message) {
      this.errorMessage = message;

      if (message) this.$refs.errorModal.open();
    }
  }
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hidePage: true
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$auth.signInWithRedirect();
    setTimeout(function () {
      _this.hidePage = false;
    }, 3000);
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login_Login__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_idmAuth_actions__ = __webpack_require__(217);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_0__login_Login___default.a
  },
  computed: {
    hasAdminRole: function hasAdminRole() {
      var r = this.$store.getters.userRoles;
      return r && r.hasAdminRole();
    },
    loggedIn: function loggedIn() {
      return this.$store.state.idmAuth.loggedIn;
    }
  },
  methods: {
    submitLogin: function submitLogin(userinfo) {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_modules_idmAuth_actions__["a" /* SIGN_INTO_IDM */], userinfo).then(function (resp) {
        if (resp) {
          _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_modules_idmAuth_actions__["b" /* GET_ALL_PERMISSIONS */]);
          _this.$router.replace({ name: 'Permissions' });
        }
      });
    }
  }
});

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_Header__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_Header__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PermissionsHeader: __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_Header___default.a
  },
  beforeMount: function beforeMount() {
    if (!this.$store.state.idmAuth.loggedIn) {
      this.$router.replace({ name: 'AdminLogin' });
    }
  },

  computed: {
    routeName: function routeName() {
      return this.$route.name;
    },
    hasAdminRole: function hasAdminRole() {
      var r = this.$store.getters.userRoles;
      return r && r.hasAdminRole();
    },
    loggedIn: function loggedIn() {
      return this.$store.state.idmAuth.loggedIn;
    }
  }
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_PermissionsTable__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_PermissionsTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_PermissionsTable__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PermissionsTable: __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_PermissionsTable___default.a
  },
  computed: {
    hasAdminRole: function hasAdminRole() {
      var r = this.$store.getters.userRoles;
      var p = this.$store.getters.hasAdminEditRolesPermission;
      return r && r.hasAdminRole() && p;
    }
  }
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_UserList__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_UserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_permissions_forms_UserForm__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_permissions_forms_UserForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_permissions_forms_UserForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modal__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_PermissionsAPI__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appLogic_permissions_store_constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_icons_CollapseArrows__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_icons_CollapseArrows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_icons_CollapseArrows__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_toasts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserList: __WEBPACK_IMPORTED_MODULE_0__appComponents_permissions_components_UserList___default.a,
    UserForm: __WEBPACK_IMPORTED_MODULE_1__appComponents_permissions_forms_UserForm___default.a,
    CollapseArrows: __WEBPACK_IMPORTED_MODULE_5__components_common_icons_CollapseArrows___default.a,
    ActionModal: __WEBPACK_IMPORTED_MODULE_2__components_common_modal__["a" /* ActionModal */]
  },
  data: function data() {
    return {
      show: true,
      userToDelete: {
        first_name: '',
        last_name: ''
      }
    };
  },
  beforeMount: function beforeMount() {
    this.setUsers();
    this.setRoles();
  },

  computed: {
    usersList: function usersList() {
      return this.$store.state.permissions.users;
    },
    rolesList: function rolesList() {
      return this.$store.state.permissions.roles;
    },
    copiedUserList: function copiedUserList() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(this.usersList);
    },
    hasAdminRole: function hasAdminRole() {
      var r = this.$store.getters.userRoles;
      return r && r.hasAdminRole();
    },
    showDeleteUserModal: function showDeleteUserModal() {
      return this.$store.state.permissions.showDeleteUserModal;
    }
  },
  methods: {
    setUsers: function setUsers() {
      if (this.usersList && this.usersList.length === 0) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_permissions_store_constants__["b" /* SET_USERS */]);
      }
    },
    setRoles: function setRoles() {
      if (this.rolesList && this.rolesList.length === 0) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_permissions_store_constants__["c" /* SET_ROLES */]);
      }
    },
    setUserToDelete: function setUserToDelete(user) {
      this.userToDelete = user;
    },
    deleteUser: function deleteUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api_PermissionsAPI__["a" /* default */].deleteUser(this.userToDelete.id).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_6__components_common_toasts__["a" /* default */].success({
          title: 'User Deleted:',
          message: _this.userToDelete.first_name + ' ' + _this.userToDelete.last_name + ' has been successfully deleted'
        });
        _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__appLogic_permissions_store_constants__["b" /* SET_USERS */]);
      }).catch(function (err) {
        console.log('error in UserList.vue, handleUserRemoval method', err);
        __WEBPACK_IMPORTED_MODULE_6__components_common_toasts__["a" /* default */].error({
          title: 'User Delete Error',
          message: 'There was an error in deleting this user, please refresh and try again'
        });
      }).finally(function () {
        _this.userToDelete = {
          first_name: '',
          last_name: ''
        };
      });
    }
  },
  watch: {
    showDeleteUserModal: function showDeleteUserModal(value) {
      if (value) {
        this.$refs.deleteUserModal.open();
      }
    }
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_lasGraphs_universeStability__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appComponents_graphs_viewership__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_dayParts_DayParts__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_dayParts_DayParts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_dayParts_DayParts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_workbench_mixins_CommonWorkbenchMixins__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    WorkbenchWCanvasSlot: __WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot___default.a,
    WorkbenchRow: __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow___default.a,
    AudienceSize: __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize___default.a,
    UniverseStability: __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_lasGraphs_universeStability__["a" /* default */],
    DayParts: __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_dayParts_DayParts___default.a,
    Viewership: __WEBPACK_IMPORTED_MODULE_6__appComponents_graphs_viewership__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_10__views_workbench_mixins_CommonWorkbenchMixins__["a" /* default */]],
  data: function data() {
    return {
      viewershipRowHeight: null,
      universeRowHeight: null,
      namespace: 'ad'
    };
  },

  computed: {
    targetDefinition: function targetDefinition() {
      return this.$store.getters.targetDefinition;
    },
    isTargetEmpty: function isTargetEmpty() {
      return !!this.targetDefinition && !!this.targetDefinition.query && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(this.targetDefinition.query);
    },
    dateRange: function dateRange() {
      return this.$store.state.ad.dateRange.availableDates;
    },
    audienceSize: function audienceSize() {
      return this.universeData && this.universeData.audienceSize ? this.universeData.audienceSize : this.$store.state.ad.audienceSize;
    },
    historicalViewership: function historicalViewership() {
      return this.$store.state.ad.historicalViewership;
    },
    networks: function networks() {
      return this.$store.getters.networks;
    },
    selectedNetworksDayParts: function selectedNetworksDayParts() {
      return this.$store.getters.networksToShowDayParts;
    },
    dayPartsConfig: function dayPartsConfig() {
      return this.$store.state.ad.dayParts;
    },
    universeData: function universeData() {
      return this.$store.state.ad.universe;
    },
    showQuickAddAttributes: function showQuickAddAttributes() {
      if (this.$store.currentTarget) {
        var intents = this.$store.currentTarget && this.$store.currentTarget.metadata && this.$store.currentTarget.metadata.intents || [];
        var hasMarketingIntent = intents.filter(function (x) {
          return x.IntentId === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["a" /* INTENTS */].Marketing.IntentId;
        }).length > 0;
        return !hasMarketingIntent;
      }
    },
    activated: function activated() {
      if (this.$store.state.currentTarget.currentTarget) {
        return this.$store.state.currentTarget.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_11__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].ACTIVATED;
      }
    }
  },
  methods: {
    clearSelectedNetworks: function clearSelectedNetworks() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__appLogic_targets_currentTarget_store_actions__["l" /* CLOSE_DAY_PARTS_SECTION */]);
    },
    setRowSizes: function setRowSizes() {
      var canvasHeight = this.canvasEl.clientHeight;
      var vp = 0.7;
      var up = 0.3;

      if (canvasHeight < 480) {
        canvasHeight = 480;
      }

      if (canvasHeight < 650) {
        vp = 0.6;
        up = 0.4;
      }
      this.viewershipRowHeight = canvasHeight * vp - 15 + 'px';
      this.universeRowHeight = canvasHeight * up - 15 + 'px';
    }
  },
  mounted: function mounted() {
    var _this = this;

    adobeAnalytics.viewADWorkbench();
    this.canvasEl = document.querySelector('#canvas');
    document.querySelector('html').classList.add('workbench-resize');
    this.setRowSizes();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"])(this.canvasEl, function () {
      _this.setRowSizes();
    });
  }
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_element_queries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_propertyEngagementReach_PropertyEngagementReach__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_propertyEngagementReach_PropertyEngagementReach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_propertyEngagementReach_PropertyEngagementReach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_tabs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_topCommonAttributes_TopCommonAttributes__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_topCommonAttributes_TopCommonAttributes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_topCommonAttributes_TopCommonAttributes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_apiErrorMessage_ApiErrorMessage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_apiErrorMessage_ApiErrorMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_workbench_mixins_CommonWorkbenchMixins__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants_js__ = __webpack_require__(3);














var Tabs = __WEBPACK_IMPORTED_MODULE_6__components_common_tabs__["a" /* default */].Tabs,
    Tab = __WEBPACK_IMPORTED_MODULE_6__components_common_tabs__["a" /* default */].Tab;


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    WorkbenchWCanvasSlot: __WEBPACK_IMPORTED_MODULE_1__views_workbenchCanvas_WorkbenchWCanvasSlot___default.a,
    WorkbenchRow: __WEBPACK_IMPORTED_MODULE_3__views_workbenchCanvas_WorkbenchRow___default.a,
    AudienceSize: __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_audienceSize_AudienceSize___default.a,
    PropertyEngagement: __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_propertyEngagementReach_PropertyEngagementReach___default.a,
    Tabs: Tabs,
    Tab: Tab,
    TopCommonAttributes: __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_topCommonAttributes_TopCommonAttributes___default.a,
    ApiErrorMessage: __WEBPACK_IMPORTED_MODULE_8__appComponents_workbench_apiErrorMessage_ApiErrorMessage___default.a,
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_confirmModal_ConfirmModal___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__views_workbench_mixins_CommonWorkbenchMixins__["a" /* default */]],
  data: function data() {
    return {
      topRow: null,
      bottomRow: null,
      namespace: 'sm'
    };
  },

  computed: {
    audienceSize: function audienceSize() {
      var currentTarget = this.$store.getters.currentTarget;
      return currentTarget && currentTarget.audience_size ? currentTarget.audience_size : this.$store.getters.audienceSize;
    },
    topTsp: function topTsp() {
      return this.$store.getters.topTsp;
    },
    topSocialAffinity: function topSocialAffinity() {
      return this.$store.getters.topSocialAffinity;
    },
    reach: function reach() {
      return this.$store.getters.reach;
    },
    activated: function activated() {
      if (this.$store.state.currentTarget.currentTarget) {
        return this.$store.state.currentTarget.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_10__appLogic_targets_Constants_js__["b" /* ACTIVATION_STATUS */].ACTIVATED;
      }
    }
  },
  methods: {
    setRowSizes: function setRowSizes() {
      var canvasHeight = this.canvasEl.clientHeight;
      var vp = 0.7;
      var up = 0.3;

      if (canvasHeight < 480) {
        canvasHeight = 480;
      }

      if (canvasHeight < 650) {
        vp = 0.85;
        up = 0.15;
      }
      this.topRow = canvasHeight * vp - 15 + 'px';
      this.bottomRow = canvasHeight * up - 15 + 'px';
    }
  },
  mounted: function mounted() {
    var _this = this;

    adobeAnalytics.viewSMWorkbench();
    this.canvasEl = document.querySelector('#canvas');
    document.querySelector('html').classList.add('workbench-resize');
    this.setRowSizes();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_element_queries__["ResizeSensor"])(this.canvasEl, function () {
      _this.setRowSizes();
    });
  }
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isSM: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_scrollPanel__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_quickAddAttributes_QuickAddAttributes__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_quickAddAttributes_QuickAddAttributes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_quickAddAttributes_QuickAddAttributes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_attributePanel_AttributePanel__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_attributePanel_AttributePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_attributePanel_AttributePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_definitionActions_DefinitionActions__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_definitionActions_DefinitionActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_definitionActions_DefinitionActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_bottomPaneSizer_BottomPaneSizer__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_bottomPaneSizer_BottomPaneSizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_bottomPaneSizer_BottomPaneSizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_loaderDots__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_workbenchToolbar_WorkbenchToolbar__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_workbenchToolbar_WorkbenchToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_workbenchToolbar_WorkbenchToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_common_AudienceHubDashboardHeader__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appComponents_common_AudienceHubDashboardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__appComponents_common_AudienceHubDashboardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_revisionHistory_VuexRevisionHistoryPanel__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__appComponents_revisionHistory_VuexRevisionHistoryPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__appComponents_revisionHistory_VuexRevisionHistoryPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_controlPanel__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_WorkbenchWCanvasSlotActionsGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants_js__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ScrollPanel: __WEBPACK_IMPORTED_MODULE_0__components_common_scrollPanel__["a" /* default */],
    AttributePanel: __WEBPACK_IMPORTED_MODULE_3__appComponents_oldWorkbench_attributePanel_AttributePanel___default.a,
    WorkbenchToolbar: __WEBPACK_IMPORTED_MODULE_7__appComponents_oldWorkbench_workbenchToolbar_WorkbenchToolbar___default.a,
    QuickAddAttributes: __WEBPACK_IMPORTED_MODULE_1__appComponents_oldWorkbench_quickAddAttributes_QuickAddAttributes___default.a,
    TargetDefinition: __WEBPACK_IMPORTED_MODULE_2__appComponents_oldWorkbench_targetDefinition__["a" /* default */],
    DefinitionActions: __WEBPACK_IMPORTED_MODULE_4__appComponents_oldWorkbench_definitionActions_DefinitionActions___default.a,
    BottomPaneSizer: __WEBPACK_IMPORTED_MODULE_5__appComponents_oldWorkbench_bottomPaneSizer_BottomPaneSizer___default.a,
    LoaderDots: __WEBPACK_IMPORTED_MODULE_6__components_common_loaderDots__["a" /* default */],
    Dashboard: __WEBPACK_IMPORTED_MODULE_8__appComponents_common_AudienceHubDashboardHeader___default.a,
    VuexRevisionHistoryPanel: __WEBPACK_IMPORTED_MODULE_9__appComponents_revisionHistory_VuexRevisionHistoryPanel___default.a,
    TransparentControlPanel: __WEBPACK_IMPORTED_MODULE_10__components_common_controlPanel__["a" /* TransparentControlPanel */]
  },
  props: {
    loading: {
      type: Boolean
    },
    showGraphs: {
      type: Boolean,
      default: false
    },
    metrics: {
      type: Object
    },
    targetName: {
      type: String
    },
    activated: {
      type: Boolean
    },
    archived: {
      type: Boolean
    },
    headerMenu: {
      type: Array,
      required: true
    },
    showQuickAddAttributes: {
      type: Boolean,
      default: true
    },
    allowDownloadBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isCollapsed: false,
      isExpandedView: false,
      currentBottomPaneSize: 'medium',
      viewershipRowHeight: null,
      universeRowHeight: null
    };
  },

  computed: {
    sizeClass: function sizeClass() {
      return 'is-' + this.currentBottomPaneSize;
    },
    showRevisionHistoryPanel: function showRevisionHistoryPanel() {
      var s = this.$store.state;
      return s.las ? s.las.showTargetHistoryPanel : s.ad ? s.ad.showTargetHistoryPanel : s.sm.showTargetHistoryPanel;
    },
    showQuickAddAttributebuttons: function showQuickAddAttributebuttons() {
      return this.showQuickAddAttributes ? !this.live : false;
    },
    live: function live() {
      if (this.$store.state.currentTarget.currentTarget) {
        return this.$store.state.currentTarget.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants_js__["b" /* ACTIVATION_STATUS */].LIVE;
      }
    },
    viewOnly: function viewOnly() {
      return this.live || this.$store.state.currentTarget.activation_status === __WEBPACK_IMPORTED_MODULE_12__appLogic_targets_Constants_js__["b" /* ACTIVATION_STATUS */].SUBMITTED;
    }
  },
  methods: {
    togglePanelCollapse: function togglePanelCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    togglePanelSize: function togglePanelSize() {
      this.isExpandedView = !this.isExpandedView;
    },
    changeBottomPaneSize: function changeBottomPaneSize(size) {
      this.currentBottomPaneSize = size;
    },
    setTargetDefinitionFromRevisionHistory: function setTargetDefinitionFromRevisionHistory(rh) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_11__store_WorkbenchWCanvasSlotActionsGenerator__["f" /* SET_TARGET_ENVIRONMENT */], {
        targetDefinition: rh.target_definition,
        targetData: rh.target_data
      });
    }
  }
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_insights_Insights__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_insights_Insights___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_insights_Insights__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_LasGraphs_vue__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_LasGraphs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_LasGraphs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_bottomPanel_BottomPanel__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_bottomPanel_BottomPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_bottomPanel_BottomPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_saveChanges_SaveWorkbenchChangesModal_vue__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_saveChanges_SaveWorkbenchChangesModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_saveChanges_SaveWorkbenchChangesModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Insights: __WEBPACK_IMPORTED_MODULE_2__appComponents_workbench_insights_Insights___default.a,
    LasGraphs: __WEBPACK_IMPORTED_MODULE_3__appComponents_workbench_lasGraphs_LasGraphs_vue___default.a,
    BottomPanel: __WEBPACK_IMPORTED_MODULE_4__appComponents_workbench_bottomPanel_BottomPanel___default.a,
    SaveWorkbenchChangesModal: __WEBPACK_IMPORTED_MODULE_5__appComponents_workbench_saveChanges_SaveWorkbenchChangesModal_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin__["a" /* default */]],
  data: function data() {
    return {
      interface: null,
      copiedTarget: undefined,
      availableDestinations: []
    };
  },

  computed: {
    advertiser: function advertiser() {
      return this.originalTarget ? this.originalTarget.advertiser : null;
    },
    targetName: function targetName() {
      return this.originalTarget ? this.originalTarget.display_name : '';
    },
    C360Datasources: function C360Datasources() {
      return this.$store.getters.getC360Datasources;
    },
    selectedLasDatasetFamily: function selectedLasDatasetFamily() {
      var df = this.selectedDatasetFamily;
      return df === 'amrld' || df === 'mri' || df === 'ncs';
    },
    selectedDatasetFamily: function selectedDatasetFamily() {
      return this.$store.getters['workbench/selectedFamilyDataset'];
    },
    noSelectedDatasetFamily: function noSelectedDatasetFamily() {
      return !this.selectedDatasetFamily;
    },
    showInsights: function showInsights() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.C360Datasources).includes(this.selectedDatasetFamily);
    },
    as: function as() {
      return this.originalTarget && this.originalTarget.activation_status ? this.originalTarget.activation_status : undefined;
    },
    viewOnly: function viewOnly() {
      var validStatus = [__WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].WORKING, __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT, __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED].indexOf(this.as) < 0;
      var isModeled = this.isModeling || this.isModeled || this.isModeledFailed;
      var isLASAndFailed = this.selectedLasDatasetFamily && this.as === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED;
      return !this.hasPermissions || this.isCancelled || isModeled || validStatus || isLASAndFailed || !this.$store.getters.hasCreateEditPermissions || this.$store.state.workbench.loadingWorkbench;
    },
    originalTarget: function originalTarget() {
      var wt = this.$store.state.workbench.workbenchTarget;
      return wt === null ? undefined : wt;
    },
    isSubmitted: function isSubmitted() {
      return this.as === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].SUBMITTED;
    },
    isFailed: function isFailed() {
      return this.as === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED;
    },
    isLive: function isLive() {
      return this.as === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE;
    },
    isModeling: function isModeling() {
      return this.as === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELING;
    },
    isModeled: function isModeled() {
      return this.as === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].MODELED;
    },
    isCancelled: function isCancelled() {
      return this.originalTarget && this.originalTarget.activation_status && this.originalTarget.activation_status === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].CANCELLED;
    },
    isSDTarget: function isSDTarget() {
      return this.originalTarget && this.originalTarget.destinations && (this.originalTarget.destinations.includes(__WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX) || this.originalTarget.destinations.includes(__WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP));
    },
    hasPermissions: function hasPermissions() {
      var _this = this;

      if (this.originalTarget && this.originalTarget.destinations) {
        return (this.originalTarget.destinations || []).every(function (destination) {
          switch (destination) {
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].KRUX:
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].LIVERAMP:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].SYMPHONY:
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].FORESITE:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].DIRECTV:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIZIO:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_LINEAR:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].CANOE_VOD:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].FREEWHEEL:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].GOOGLE_AD_MANAGER:
              return _this.$store.getters.hasCreateEditPermissions;
            case __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["e" /* DESTINATIONS */].VIDEOAMP:
              return _this.$store.getters.hasCreateEditPermissions;
            default:
              return false;
          }
        });
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    this.copyTarget();
  },
  destroyed: function destroyed() {
    this.copiedTarget = undefined;
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.copiedTarget) {
      if (this.copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].DRAFT) {
        next();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api__["j" /* deleteTarget */])(this.copiedTarget).then(function (response) {
          console.log(response);
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          return;
        });
      } else if (this.copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].LIVE || this.copiedTarget.activation_status === __WEBPACK_IMPORTED_MODULE_7__appLogic_targets_Constants__["b" /* ACTIVATION_STATUS */].FAILED || !this.$store.getters['workbench/saveXandrSegmentEnabled']) {
        next();
        return;
      } else {
        this.$refs.saveWorkbenchChangesModal.open(next);
      }
    } else {
      next();
    }
  },

  methods: {
    copyTarget: function copyTarget() {
      this.copiedTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(this.originalTarget === null || !this.originalTarget ? { advertiser: { Name: null } } : this.originalTarget);
      if (this.copiedTarget && !this.copiedTarget.advertiser) {
        this.copiedTarget.advertiser = { Name: null };
      }
      if (!this.copiedTarget.destinations) {
        this.copiedTarget.destinations = [];
      }
      if (this.showInsights && !this.copiedTarget.xandr_data) {
        this.copiedTarget.xandr_data = { frequency: null };
      }
    },
    deleteTarget: function deleteTarget() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__["a" /* SET_CURRENT_TARGET */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(this.copiedTarget));
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__appLogic_targets_currentTarget_store_actions__["F" /* DELETE_CURRENT_TARGET */]);
    },
    setViewOnly: function setViewOnly() {
      return false;
    }
  },
  watch: {
    originalTarget: function originalTarget() {
      this.copyTarget();
      this.setViewOnly();
    },
    hasPermissions: function hasPermissions() {
      this.setViewOnly();
    }
  }
});

/***/ }),
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 449,
	"./af.js": 449,
	"./ar": 456,
	"./ar-dz": 450,
	"./ar-dz.js": 450,
	"./ar-kw": 451,
	"./ar-kw.js": 451,
	"./ar-ly": 452,
	"./ar-ly.js": 452,
	"./ar-ma": 453,
	"./ar-ma.js": 453,
	"./ar-sa": 454,
	"./ar-sa.js": 454,
	"./ar-tn": 455,
	"./ar-tn.js": 455,
	"./ar.js": 456,
	"./az": 457,
	"./az.js": 457,
	"./be": 458,
	"./be.js": 458,
	"./bg": 459,
	"./bg.js": 459,
	"./bm": 460,
	"./bm.js": 460,
	"./bn": 461,
	"./bn.js": 461,
	"./bo": 462,
	"./bo.js": 462,
	"./br": 463,
	"./br.js": 463,
	"./bs": 464,
	"./bs.js": 464,
	"./ca": 465,
	"./ca.js": 465,
	"./cs": 466,
	"./cs.js": 466,
	"./cv": 467,
	"./cv.js": 467,
	"./cy": 468,
	"./cy.js": 468,
	"./da": 469,
	"./da.js": 469,
	"./de": 472,
	"./de-at": 470,
	"./de-at.js": 470,
	"./de-ch": 471,
	"./de-ch.js": 471,
	"./de.js": 472,
	"./dv": 473,
	"./dv.js": 473,
	"./el": 474,
	"./el.js": 474,
	"./en-SG": 475,
	"./en-SG.js": 475,
	"./en-au": 476,
	"./en-au.js": 476,
	"./en-ca": 477,
	"./en-ca.js": 477,
	"./en-gb": 478,
	"./en-gb.js": 478,
	"./en-ie": 479,
	"./en-ie.js": 479,
	"./en-il": 480,
	"./en-il.js": 480,
	"./en-nz": 481,
	"./en-nz.js": 481,
	"./eo": 482,
	"./eo.js": 482,
	"./es": 485,
	"./es-do": 483,
	"./es-do.js": 483,
	"./es-us": 484,
	"./es-us.js": 484,
	"./es.js": 485,
	"./et": 486,
	"./et.js": 486,
	"./eu": 487,
	"./eu.js": 487,
	"./fa": 488,
	"./fa.js": 488,
	"./fi": 489,
	"./fi.js": 489,
	"./fo": 490,
	"./fo.js": 490,
	"./fr": 493,
	"./fr-ca": 491,
	"./fr-ca.js": 491,
	"./fr-ch": 492,
	"./fr-ch.js": 492,
	"./fr.js": 493,
	"./fy": 494,
	"./fy.js": 494,
	"./ga": 495,
	"./ga.js": 495,
	"./gd": 496,
	"./gd.js": 496,
	"./gl": 497,
	"./gl.js": 497,
	"./gom-latn": 498,
	"./gom-latn.js": 498,
	"./gu": 499,
	"./gu.js": 499,
	"./he": 500,
	"./he.js": 500,
	"./hi": 501,
	"./hi.js": 501,
	"./hr": 502,
	"./hr.js": 502,
	"./hu": 503,
	"./hu.js": 503,
	"./hy-am": 504,
	"./hy-am.js": 504,
	"./id": 505,
	"./id.js": 505,
	"./is": 506,
	"./is.js": 506,
	"./it": 508,
	"./it-ch": 507,
	"./it-ch.js": 507,
	"./it.js": 508,
	"./ja": 509,
	"./ja.js": 509,
	"./jv": 510,
	"./jv.js": 510,
	"./ka": 511,
	"./ka.js": 511,
	"./kk": 512,
	"./kk.js": 512,
	"./km": 513,
	"./km.js": 513,
	"./kn": 514,
	"./kn.js": 514,
	"./ko": 515,
	"./ko.js": 515,
	"./ku": 516,
	"./ku.js": 516,
	"./ky": 517,
	"./ky.js": 517,
	"./lb": 518,
	"./lb.js": 518,
	"./lo": 519,
	"./lo.js": 519,
	"./lt": 520,
	"./lt.js": 520,
	"./lv": 521,
	"./lv.js": 521,
	"./me": 522,
	"./me.js": 522,
	"./mi": 523,
	"./mi.js": 523,
	"./mk": 524,
	"./mk.js": 524,
	"./ml": 525,
	"./ml.js": 525,
	"./mn": 526,
	"./mn.js": 526,
	"./mr": 527,
	"./mr.js": 527,
	"./ms": 529,
	"./ms-my": 528,
	"./ms-my.js": 528,
	"./ms.js": 529,
	"./mt": 530,
	"./mt.js": 530,
	"./my": 531,
	"./my.js": 531,
	"./nb": 532,
	"./nb.js": 532,
	"./ne": 533,
	"./ne.js": 533,
	"./nl": 535,
	"./nl-be": 534,
	"./nl-be.js": 534,
	"./nl.js": 535,
	"./nn": 536,
	"./nn.js": 536,
	"./pa-in": 537,
	"./pa-in.js": 537,
	"./pl": 538,
	"./pl.js": 538,
	"./pt": 540,
	"./pt-br": 539,
	"./pt-br.js": 539,
	"./pt.js": 540,
	"./ro": 541,
	"./ro.js": 541,
	"./ru": 542,
	"./ru.js": 542,
	"./sd": 543,
	"./sd.js": 543,
	"./se": 544,
	"./se.js": 544,
	"./si": 545,
	"./si.js": 545,
	"./sk": 546,
	"./sk.js": 546,
	"./sl": 547,
	"./sl.js": 547,
	"./sq": 548,
	"./sq.js": 548,
	"./sr": 550,
	"./sr-cyrl": 549,
	"./sr-cyrl.js": 549,
	"./sr.js": 550,
	"./ss": 551,
	"./ss.js": 551,
	"./sv": 552,
	"./sv.js": 552,
	"./sw": 553,
	"./sw.js": 553,
	"./ta": 554,
	"./ta.js": 554,
	"./te": 555,
	"./te.js": 555,
	"./tet": 556,
	"./tet.js": 556,
	"./tg": 557,
	"./tg.js": 557,
	"./th": 558,
	"./th.js": 558,
	"./tl-ph": 559,
	"./tl-ph.js": 559,
	"./tlh": 560,
	"./tlh.js": 560,
	"./tr": 561,
	"./tr.js": 561,
	"./tzl": 562,
	"./tzl.js": 562,
	"./tzm": 564,
	"./tzm-latn": 563,
	"./tzm-latn.js": 563,
	"./tzm.js": 564,
	"./ug-cn": 565,
	"./ug-cn.js": 565,
	"./uk": 566,
	"./uk.js": 566,
	"./ur": 567,
	"./ur.js": 567,
	"./uz": 569,
	"./uz-latn": 568,
	"./uz-latn.js": 568,
	"./uz.js": 569,
	"./vi": 570,
	"./vi.js": 570,
	"./x-pseudo": 571,
	"./x-pseudo.js": 571,
	"./yo": 572,
	"./yo.js": 572,
	"./zh-cn": 573,
	"./zh-cn.js": 573,
	"./zh-hk": 574,
	"./zh-hk.js": 574,
	"./zh-tw": 575,
	"./zh-tw.js": 575
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1520;

/***/ }),
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "audience-matters-logo-white",
  "use": "audience-matters-logo-white-usage",
  "viewBox": "0 0 315.994 145.974",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 315.994 145.974\" id=\"audience-matters-logo-white\"><g fill=\"#FFF\"><path d=\"M29.018 32.985l-3.15-8.663H11.6l-3.197 8.663H3.632L16 .557h5.42l12.369 32.428h-4.771zM18.733 4.68L12.85 20.662h11.721L18.733 4.68zM66.449.557h4.586v17.558c0 2.732-.417 5.096-1.158 7.041-1.853 4.957-5.883 8.385-12.601 8.385-6.717 0-10.747-3.428-12.601-8.385-.741-1.945-1.158-4.309-1.158-7.041V.557h4.586v17.511c0 1.807.139 3.521.603 5.003 1.065 3.567 3.706 6.439 8.57 6.439 4.864 0 7.505-2.872 8.57-6.439.463-1.482.604-3.196.604-5.003V.557zM84.47 32.985V.557h10.377c3.521 0 6.718.787 9.404 2.224 4.957 2.641 8.2 7.644 8.2 13.99s-3.243 11.35-8.2 13.99c-2.687 1.482-5.883 2.224-9.404 2.224H84.47zm10.377-4.03c2.595 0 5.003-.603 6.856-1.575 3.706-1.992 6.115-5.744 6.115-10.608s-2.409-8.616-6.115-10.608c-1.854-.973-4.262-1.575-6.856-1.575h-5.791v24.367l5.791-.001zM124.959 32.985V.557h4.586v32.428h-4.586zM143.212 32.985V.557h23.255v4.03h-18.668v9.774h16.909v4.03h-16.909v10.562h18.668v4.03h-23.255v.002zM199.915 32.985L182.774 6.764v26.221h-4.493V.557h5.696l17.142 26.267V.557h4.494v32.428h-5.698zM244.805 30.993c-2.779 1.714-6.162 2.548-9.868 2.548-9.449 0-16.814-7.412-16.814-16.77S225.487 0 234.937 0c3.706 0 7.089.834 9.868 2.549v4.539c-2.408-1.807-6.068-3.011-9.729-3.011-6.949 0-12.276 5.56-12.276 12.693s5.327 12.739 12.276 12.739c3.659 0 7.318-1.251 9.729-3.058v4.542zM257.082 32.985V.557h23.255v4.03h-18.669v9.774h16.908v4.03h-16.908v10.562h18.669v4.03h-23.255v.002z\" /></g><path fill=\"#FFF\" d=\"M0 46.69h287.888v3.309H0z\" /><g fill=\"#FFF\"><path d=\"M50.928 144.914H40.869V81.387h-.107s-1.694 10.899-2.753 17.68L30.6 144.916H20.329l-7.411-45.849a27678.51 27678.51 0 0 1-2.753-17.68h-.107v63.526H0V65.501h16.093l7.306 46.906c.847 5.717 2.011 14.932 2.011 14.932h.105s1.167-9.215 2.013-14.932l7.306-46.906h16.093v79.413h.001zM81.422 144.914l-1.799-18.315H68.717l-1.801 18.315H55.802l10.056-79.413h16.729l10.059 79.413H81.422zm-6.88-69.882h-.635l-4.235 42.14h9.107l-4.237-42.14zM107.257 144.914V75.032H94.66V65.5h37.061v9.532h-12.708v69.882h-11.756zM147.076 144.914V75.032h-12.601V65.5h37.06v9.532h-12.708v69.882h-11.751zM177.15 144.914V65.501h31.339v9.531h-19.586v24.67h17.783v9.529h-17.783v26.152h19.586v9.528l-31.339.003zM238.562 144.914l-7.413-34.729h-4.342v34.729h-11.753V65.501h17.362c10.696 0 16.623 6.033 16.623 18.001v8.783c0 7.73-2.539 13.027-7.304 15.678l9 36.949-12.173.002zm-1.166-63.321c0-4.657-1.694-6.562-5.188-6.562h-5.399v25.622h5.399c3.493 0 5.188-1.906 5.188-6.563V81.593zM271.917 145.972c-10.691 0-16.521-6.354-16.521-18.212v-11.116h11.014v12.599c0 4.557 1.692 7.2 5.188 7.2h.317c3.601 0 5.399-2.646 5.399-7.2v-5.61c0-7.2-3.916-10.483-10.062-15.99-6.354-5.715-12.07-11.538-12.07-22.34v-2.116c0-11.968 5.824-18.744 16.308-18.744h.425c10.481 0 16.198 6.458 16.198 18.322v8.47H277.1v-9.847c0-4.66-1.691-7.413-4.977-7.413h-.317c-3.176 0-4.978 2.753-4.978 7.413v3.811c0 6.354 4.345 10.164 9.215 14.611 6.986 6.354 12.915 11.539 12.915 23.823v3.599c0 11.968-6.034 18.743-16.729 18.743l-.312-.003z\" /></g><path fill=\"#FFF\" d=\"M315.994 136.257c0 4.563-3.708 8.271-8.273 8.271-4.563 0-8.271-3.705-8.271-8.271 0-4.568 3.707-8.273 8.271-8.273a8.276 8.276 0 0 1 8.273 8.273z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "and",
  "use": "and-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol viewBox=\"0 0 13 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"and\"><path d=\"M12.114 12.816H8.82l-1.188-1.26c-.936.9-2.16 1.476-3.546 1.476-2.07 0-4.086-1.314-4.086-3.78 0-1.728 1.044-2.79 2.16-3.528-.612-.774-1.08-1.566-1.08-2.61C1.08 1.17 2.664 0 4.608 0c2.088 0 3.384 1.35 3.384 3.024 0 1.332-.828 2.376-2.196 3.132l1.602 1.656c.27-.63.486-1.242.72-1.998h2.538c-.378 1.332-.954 2.682-1.548 3.816l3.006 3.186zM6.048 9.882L3.69 7.38c-.63.432-1.188 1.044-1.188 1.89 0 1.08.882 1.53 1.656 1.53a2.45 2.45 0 0 0 1.89-.918zM4.302 4.554c.792-.45 1.206-.972 1.206-1.476 0-.486-.36-.864-.936-.864-.558 0-.99.36-.99.9 0 .486.342.954.72 1.44z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "back-arrow",
  "use": "back-arrow-usage",
  "viewBox": "0 0 21 10",
  "content": "<symbol viewBox=\"0 0 21 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back-arrow\"><path d=\"M0 5l5 5V6.428H20.71V3.572H5V0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "children",
  "use": "children-usage",
  "viewBox": "0 0 27 24",
  "content": "<symbol viewBox=\"0 0 27 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"children\"><path d=\"M25.862 6.686h-3.694A.74.74 0 0 0 21.57 7l-2.416 3.4H0l1.08 4.486c.256.886 1.052 1.428 1.933 1.428h14.295c.91 0 1.705-.542 1.932-1.428l.512-2.172c.17-.714.88-1.914.966-2.057l1.79-2.514h3.297a.754.754 0 0 0 .74-.743c.056-.4-.285-.714-.683-.714zM14.608 22.514a1.849 1.849 0 0 1-1.847-1.857c0-1.028.824-1.857 1.847-1.857 1.023 0 1.847.829 1.847 1.857a1.849 1.849 0 0 1-1.847 1.857zm0-5.2a3.338 3.338 0 0 0-3.325 3.343A3.338 3.338 0 0 0 14.608 24a3.338 3.338 0 0 0 3.325-3.343 3.338 3.338 0 0 0-3.325-3.343zm-8.1 5.2a1.849 1.849 0 0 1-1.847-1.857c0-1.028.824-1.857 1.847-1.857 1.023 0 1.847.829 1.847 1.857a1.867 1.867 0 0 1-1.847 1.857zm0-5.2a3.338 3.338 0 0 0-3.325 3.343A3.32 3.32 0 0 0 6.508 24a3.32 3.32 0 0 0 3.325-3.343 3.338 3.338 0 0 0-3.325-3.343zM10.97 0L3.382 3.172.057 9.486h10.941V0h-.028z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "circle-check",
  "use": "circle-check-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle-check\"><path d=\"M11 1.486c-5.246 0-9.514 4.268-9.514 9.514 0 5.246 4.268 9.514 9.514 9.514 5.246 0 9.514-4.268 9.514-9.514 0-5.246-4.268-9.514-9.514-9.514M11 22C4.935 22 0 17.065 0 11 0 4.934 4.935 0 11 0c6.066 0 11 4.934 11 11 0 6.065-4.934 11-11 11\" /><path d=\"M15.9 7l-6.233 6.234L7.1 10.667l-1.1 1.1 3.667 3.666L17 8.1\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "circle-error",
  "use": "circle-error-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle-error\"><path d=\"M11 1.486c-5.246 0-9.514 4.268-9.514 9.514 0 5.246 4.268 9.514 9.514 9.514 5.246 0 9.514-4.268 9.514-9.514 0-5.246-4.268-9.514-9.514-9.514M11 22C4.935 22 0 17.065 0 11S4.935 0 11 0c6.066 0 11 4.935 11 11s-4.934 11-11 11\" /><path d=\"M9.625 12.99V4.74h2.75v8.25h-2.75zm0 4.278v-2.75h2.75v2.75h-2.75z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"copy\"><path d=\"M53.98 9.143h-3.97c-.082 0-.155.028-.232.047V5.023C49.778 2.253 47.473 0 44.64 0H10.217C7.384 0 5.08 2.253 5.08 5.023v46.843c0 2.77 2.305 5.023 5.138 5.023h6.037v2.268c0 2.67 2.216 4.843 4.941 4.843H53.98c2.725 0 4.942-2.173 4.942-4.843v-45.17c0-2.671-2.217-4.844-4.942-4.844zM7.11 51.866V5.023c0-1.649 1.394-2.991 3.106-2.991H44.64c1.712 0 3.106 1.342 3.106 2.99v46.844c0 1.649-1.394 2.991-3.106 2.991H10.217c-1.712 0-3.106-1.342-3.106-2.99zm49.778 7.29c0 1.551-1.306 2.812-2.91 2.812H21.195c-1.604 0-2.91-1.26-2.91-2.811v-2.268H44.64c2.833 0 5.138-2.253 5.138-5.023V11.128c.077.018.15.047.233.047h3.968c1.604 0 2.91 1.26 2.91 2.811v45.17z\" /><path d=\"M38.603 13.206H16.254a1.015 1.015 0 1 0 0 2.032h22.35a1.015 1.015 0 1 0 0-2.032zM38.603 21.333H16.254a1.015 1.015 0 1 0 0 2.032h22.35a1.015 1.015 0 1 0 0-2.032zM38.603 29.46H16.254a1.015 1.015 0 1 0 0 2.032h22.35a1.015 1.015 0 1 0 0-2.032zM28.444 37.587h-12.19a1.015 1.015 0 1 0 0 2.032h12.19a1.015 1.015 0 1 0 0-2.032z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "dollar-sign",
  "use": "dollar-sign-usage",
  "viewBox": "0 0 11 22",
  "content": "<symbol viewBox=\"0 0 11 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dollar-sign\"><title>noun_1015774</title><path d=\"M2.881 7.333c0 1.215.967 2.2 2.16 2.2 2.503.002 4.625 1.872 4.986 4.392.361 2.521-1.148 4.93-3.545 5.66V22h-2.88v-2.415C1.464 18.936 0 16.936 0 14.667h2.881c0 1.215.967 2.2 2.16 2.2 1.194 0 2.161-.985 2.161-2.2 0-1.215-.967-2.2-2.16-2.2C2.54 12.465.418 10.595.057 8.075c-.362-2.521 1.147-4.93 3.544-5.66V0h2.881v2.415c2.136.649 3.6 2.649 3.601 4.918h-2.88c0-1.215-.968-2.2-2.161-2.2-1.194 0-2.161.985-2.161 2.2z\" fill-rule=\"nonzero\" fill=\"#FFBD00\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "female",
  "use": "female-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"female\"><path d=\"M8.399 12.327c-.688.88-2.238 1.345-4.872 2.102l-.655.21c-1.695.497-2.427 1.304-2.71 2.222-.23.782-.166 1.638-.102 2.47.025.247.039.458.051.669H21.02c.012-.125.012-.273.025-.408.039-.893.078-1.85-.244-2.73h-.012c-.347-.905-1.143-1.724-2.826-2.221l-.668-.21c-2.626-.753-4.187-1.214-4.878-2.11.472-.078.82-.148.82-.148.452-.115.926-.209 1.384-.356.46-.147.916-.321 1.355-.523.443-.203.477-.525.153-.893-.644-.732-.935-1.627-1.055-2.563-.122-.95-.15-1.913-.205-2.87a4.106 4.106 0 0 0-.006-.08C14.748 2.001 12.666.07 10.686.001L10.676 0h-.531c-.18.032-.359.071-.533.119-.156.039-.307.087-.454.144-.38.14-.742.326-1.083.567-1.286.913-1.83 2.19-2.031 3.724-.098.743-.224 1.493-.287 2.24-.101 1.208-.306 2.389-1.032 3.41-.562.735-.532.915.322 1.244.675.26 1.384.434 2.08.645.113.034.23.053.328.078 0 0 .408.074.944.156z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "history",
  "use": "history-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 18\" id=\"history\"><text font-weight=\"bold\" font-family=\"Helvetica, Arial, sans-serif\" font-size=\"18\" y=\"15\" x=\"1\" stroke-width=\"0\" stroke=\"#000\" fill=\"#fff\">H</text></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol viewBox=\"0 0 23 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home\"><path d=\"M2.475 11.094v9.57c0 .174.069.347.19.47a.65.65 0 0 0 .46.193h5.24v-7.026c0-.176.068-.348.19-.471a.646.646 0 0 1 .459-.195h4.475c.172 0 .338.071.46.195.121.123.19.295.19.47v7.027h5.24a.64.64 0 0 0 .46-.193.674.674 0 0 0 .19-.47v-9.582l-8.872-7.043-8.682 7.055z\" /><path d=\"M21.996 8.13L12.045.314a1.282 1.282 0 0 0-1.587 0L5.127 4.501V2.387H2.524v4.158L.508 8.129A1.347 1.347 0 0 0 .27 9.992a1.288 1.288 0 0 0 1.455.446l9.126-7.414a.475.475 0 0 1 .599-.005l9.349 7.421c.51.17 1.089.011 1.435-.448a1.346 1.346 0 0 0-.238-1.862\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "junk-drawer",
  "use": "junk-drawer-usage",
  "viewBox": "0 0 46 16",
  "content": "<symbol viewBox=\"0 0 46 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"junk-drawer\"><path d=\"M0 2h28V0H0zM0 9h28V7H0zM0 16h28v-2H0zM36 7l5 5 5-5z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "male",
  "use": "male-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"male\"><path d=\"M21.019 20H.11c-.012-.21-.026-.422-.05-.67-.065-.831-.13-1.687.102-2.47.282-.917 1.014-1.724 2.709-2.22l.655-.211c2.979-.856 4.572-1.34 5.098-2.47l.168-.284-.013-.36a.47.47 0 0 1-.116-.112 6.27 6.27 0 0 1-.527-.594C6.982 9.13 6.16 6.849 6.16 4.964 6.16 2.556 7.933 0 10.577 0c2.068 0 4.29 2.06 4.29 5.137 0 1.96-1.014 4.391-2.401 5.819-.09.1-.193.185-.283.273l-.166.15.05.223c.36 1.414 1.978 1.898 5.227 2.828l.668.21c1.683.498 2.479 1.317 2.826 2.222h.012c.322.88.283 1.837.244 2.73-.013.135-.013.283-.025.408\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "marriage",
  "use": "marriage-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"marriage\"><path d=\"M10.99 5.16c-.74 1.142-1.193 2.365-1.221 3.354-.013.46.17.942.478 1.257.438.447 1.05.447 1.486 0 .309-.315.492-.797.479-1.257-.028-.989-.482-2.212-1.222-3.355zM5.7 1.616c-3.001 0-4.07 2.298-4.07 4.448 0 4.069 6.36 9.683 9.361 11.933 3.001-2.25 9.363-7.864 9.363-11.933 0-2.15-1.07-4.448-4.071-4.448-1.422 0-2.943.793-4.244 2.196 1.096 1.52 1.76 3.221 1.801 4.655a3.395 3.395 0 0 1-.938 2.43c-.522.534-1.2.827-1.91.827-.711 0-1.39-.293-1.91-.826a3.397 3.397 0 0 1-.94-2.43c.041-1.435.705-3.136 1.802-4.656C8.642 2.41 7.121 1.617 5.699 1.617zM10.99 20l-.475-.34C10.085 19.352 0 12.07 0 6.065 0 2.437 2.29 0 5.699 0c1.82 0 3.71.922 5.291 2.56C12.572.921 14.462 0 16.282 0c3.409 0 5.699 2.437 5.699 6.065 0 6.006-10.085 13.287-10.515 13.595l-.476.34z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"minus\"><path d=\"M6 12h12\" stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "not",
  "use": "not-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"not\"><path d=\"M2.25 9c0-1.456.462-2.806 1.249-3.91l9.41 9.41A6.719 6.719 0 0 1 9 15.75 6.758 6.758 0 0 1 2.25 9m13.5 0a6.716 6.716 0 0 1-1.25 3.91L5.09 3.5A6.72 6.72 0 0 1 9 2.25 6.758 6.758 0 0 1 15.75 9m-.387-6.364A8.937 8.937 0 0 0 9 0a8.94 8.94 0 0 0-6.364 2.636A8.936 8.936 0 0 0 0 9c0 2.404.935 4.664 2.636 6.364A8.94 8.94 0 0 0 9 18a8.937 8.937 0 0 0 6.363-2.636A8.937 8.937 0 0 0 18 9a8.937 8.937 0 0 0-2.637-6.364\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "or",
  "use": "or-usage",
  "viewBox": "0 0 18 9",
  "content": "<symbol viewBox=\"0 0 18 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"or\"><path d=\"M9.112 4.5c0 2.523-2.009 4.5-4.55 4.5C2.008 9 0 7.023 0 4.5 0 1.977 2.008 0 4.562 0c2.541 0 4.55 1.977 4.55 4.5zm-4.55 2.586c1.29 0 2.256-1.082 2.256-2.586 0-1.504-.967-2.586-2.256-2.586-1.302 0-2.256 1.082-2.256 2.586 0 1.504.954 2.586 2.256 2.586zM18 8.85h-2.579l-1.475-3.145h-1.252V8.85h-2.28V.149h3.718c.62 0 1.19.087 1.686.274 1.03.385 1.699 1.193 1.699 2.449 0 .646-.199 1.18-.546 1.603-.235.286-.52.522-.868.709L18 8.85zm-5.306-4.96h1.401c.26 0 .484-.037.67-.124.297-.137.47-.398.47-.808 0-.41-.173-.672-.47-.82a1.567 1.567 0 0 0-.67-.138h-1.4v1.89z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\"><path d=\"M5.688 9.625A3.942 3.942 0 0 1 1.75 5.687 3.942 3.942 0 0 1 5.688 1.75a3.942 3.942 0 0 1 3.937 3.938 3.942 3.942 0 0 1-3.938 3.937m0-9.625A5.694 5.694 0 0 0 0 5.688a5.694 5.694 0 0 0 5.688 5.687 5.653 5.653 0 0 0 2.983-.848l3.088 3.089c.248.248.578.384.928.384.351 0 .68-.136.929-.384.247-.248.384-.578.384-.928 0-.351-.137-.68-.384-.929l-3.089-3.088c.537-.868.848-1.89.848-2.983A5.694 5.694 0 0 0 5.687 0\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "Audience",
  "use": "Audience-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" id=\"Audience\"><defs><linearGradient id=\"Audience_b\" gradientUnits=\"userSpaceOnUse\" x1=\"50\" y1=\"98\" x2=\"50\" y2=\"2\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\".1\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".5\" /></linearGradient><linearGradient id=\"Audience_c\" gradientUnits=\"userSpaceOnUse\" x1=\"50\" y1=\"70\" x2=\"50\" y2=\"6\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\"0\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".4\" /></linearGradient><linearGradient id=\"Audience_e\" gradientUnits=\"userSpaceOnUse\" x1=\"37\" y1=\"24\" x2=\"92\" y2=\"57\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\"0\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".4\" /></linearGradient><linearGradient id=\"Audience_d\" gradientUnits=\"userSpaceOnUse\" x1=\"63\" y1=\"57\" x2=\"8\" y2=\"24\"><stop offset=\"0%\" stop-color=\"#FFF\" stop-opacity=\"0\" /><stop offset=\"100%\" stop-color=\"#FFF\" stop-opacity=\".4\" /></linearGradient><path fill=\"url(#Audience_a)\" d=\"M96.1 30.55q-3.85-8.95-10.75-15.9-6.9-6.9-15.85-10.7Q60.2 0 50.05 0q-10.2 0-19.5 3.95-9 3.8-15.9 10.7-6.9 6.95-10.7 15.9Q0 39.85 0 50.05 0 60.2 3.95 69.5q3.8 8.95 10.7 15.85 6.9 6.9 15.9 10.75 9.3 3.9 19.5 3.9 10.15 0 19.45-3.9 8.95-3.85 15.85-10.75T96.1 69.5q3.9-9.3 3.9-19.45 0-10.2-3.9-19.5z\" id=\"Audience_f\" /><path fill=\"url(#Audience_b)\" d=\"M94.1 31.45q-3.65-8.6-10.25-15.25Q77.2 9.6 68.65 6q-8.9-3.8-18.6-3.8Q40.3 2.2 31.4 6q-8.6 3.6-15.2 10.2-6.6 6.65-10.25 15.25Q2.2 40.3 2.2 50.05q0 9.7 3.75 18.6Q9.6 77.2 16.2 83.85q6.6 6.6 15.2 10.25 8.9 3.75 18.65 3.75 9.7 0 18.6-3.75 8.55-3.65 15.2-10.25 6.6-6.65 10.25-15.2 3.75-8.9 3.75-18.6 0-9.75-3.75-18.6m-11.6-13.9q6.35 6.35 9.9 14.6Q96 40.7 96 50.05q0 9.35-3.6 17.85-3.55 8.25-9.9 14.6-6.35 6.35-14.6 9.9Q59.4 96 50.05 96q-9.35 0-17.9-3.6-8.25-3.55-14.6-9.9-6.4-6.35-9.9-14.6-3.6-8.5-3.6-17.85 0-9.35 3.6-17.9 3.5-8.25 9.9-14.6 6.35-6.4 14.6-9.85 8.55-3.65 17.9-3.65 9.35 0 17.85 3.65 8.25 3.45 14.6 9.85z\" id=\"Audience_g\" /><mask id=\"Audience_h\"><path fill=\"#FFF\" d=\"M96.1 30.5q-3.85-8.95-10.75-15.85Q78.45 7.7 69.5 3.9 60.2 0 50.05 0q-10.2 0-19.5 3.9-9 3.8-15.9 10.75-6.9 6.9-10.7 15.85Q0 39.85 0 50t3.95 19.45q3.8 8.95 10.7 15.85 6.9 6.95 15.9 10.75 9.3 3.95 19.5 3.95 10.15 0 19.45-3.95 8.95-3.8 15.85-10.75 6.9-6.9 10.75-15.85Q100 60.15 100 50q0-10.15-3.9-19.5z\" /></mask><path fill=\"url(#Audience_c)\" d=\"M81.5 40.8q2.7-4.75 2.7-9.9 0-5.2-2.7-9.9-2.55-4.6-7.3-8.1-10-7.45-24.15-7.45-14.25 0-24.25 7.45t-10 18q0 10.55 10 18 10 7.45 24.25 7.45 14.15 0 24.15-7.45 4.75-3.5 7.3-8.1z\" id=\"Audience_k\" /><linearGradient id=\"Audience_a\" y2=\"1\" x2=\"0\"><stop stop-color=\"#4ADCFD\" offset=\"0%\" /><stop stop-color=\"#0634A7\" offset=\"100%\" /></linearGradient><path d=\"M57.2 52.7c-1-.5-2.2-.7-2.8-1.2-.6-.5-.7-1.5-1.5-2.2-.3-.3-1.2.1-1.3-.5-.1-.9.8-1.4 1.1-2.2.3-.8.1-.7.3-1.7 1.7-.5 2.5-4.5 1.4-4.6.5-2.9 1.1-7.4-1-8.6-.4-.2-.9-.1-1.3-.3-.2-.1-.4-.5-.6-.7-1-.8-3.6-1.2-5.1-1.2-1.5 0-3.2.5-4.1 1.2l-1.9 1c-2.1 1.2-1.5 5.6-1 8.6-1.1.1-.3 4.2 1.4 4.6.2 1 0 .9.3 1.7.3.8 1.2 1.4 1.1 2.2-.1.6-1 .2-1.3.5-.8.7-.9 1.7-1.5 2.2-.6.5-1.8.8-2.8 1.2-.4.2-.9.4-1.4.6-.5.2-1 .4-1.6.7 3.1 4.1 7.9 6.6 13.3 6.6.6 0 1.2 0 1.8-.1 4.4-.5 8.4-2.7 11.2-6.1.1-.1.2-.3.3-.5l-1.5-.6c-.7-.2-1.2-.4-1.5-.6zM20.1 35.9c-.7-.5-2.4-.8-3.4-.8s-2.1.3-2.8.8l-1.3.7c-1.4.8-1 3.8-.7 5.7-.7.1-.2 2.8.9 3.1.1.7 0 .6.2 1.1.2.5.8.9.7 1.5 0 .4-.7.1-.9.3-.5.5-.6 1.2-1 1.5-.4.3-1.2.5-1.9.8-.3.1-.6.2-.9.4-1.5.6-3.7 1.5-4 2.6V56c0 1.1 5.2 2 11.7 2 2.1 0 4.1-.1 5.9-.3-1.9-3.2-3.1-6.9-3.5-10.9-.4-3.7 0-7.4 1-10.9zm51.3 20.7l1.5 1.2c1.3.1 2.6.1 4 .1 6.5 0 12.4-.9 12.4-2v-.6c0-.6 0-1.1-.1-1.6-.4-1.1-2.5-2-4-2.6-.4-.1-.7-.3-.9-.4-.7-.3-1.5-.5-1.9-.8-.4-.3-.5-1-1-1.5-.2-.2-.8 0-.9-.3-.1-.6.5-.9.7-1.5.2-.6.1-.5.2-1.2 1.1-.3 1.7-3 .9-3.1.4-2 .7-4.9-.7-5.7-.3-.2-.6-.1-.9-.2-.1-.1-.3-.4-.4-.5-.7-.5-2.4-.8-3.4-.8s-2.1.3-2.8.8l-.8.4c.4 1.5.7 3 .9 4.6.7 5.5-.3 10.9-2.8 15.7zm22 21.3c-.1-1.1-.6-2-1.5-2.7L69.4 57c2.8-4.9 4-10.3 3.4-15.9-1.4-13.4-12.6-23.4-26.1-23.4-.9 0-1.9.1-2.8.2-7 .8-13.2 4.2-17.6 9.6-4.4 5.5-6.4 12.3-5.7 19.3C22 60.2 33.2 70.2 46.7 70.2c.9 0 1.9-.1 2.8-.2 5.6-.6 10.7-2.9 14.9-6.7l22.5 18.2c.7.6 1.6.9 2.5.9h.4c1.1-.1 2-.6 2.7-1.5.8-.9 1.1-1.9.9-3zM60.9 55.3c-3.1 3.8-7.4 6.2-12.2 6.7-.7.1-1.3.1-2 .1-9.3 0-17.1-7-18.1-16.3-.5-4.8.9-9.6 3.9-13.4 3.1-3.8 7.4-6.2 12.2-6.7.7-.1 1.3-.1 2-.1 9.3 0 17.1 7 18.1 16.3.6 4.9-.8 9.6-3.9 13.4z\" transform=\"matrix(1.12867 0 0 1.12867 -5.643 -6.49)\" id=\"Audience_i\" /><linearGradient id=\"Audience_j\" y2=\"1\" x2=\"0\"><stop stop-color=\"#fff\" offset=\"0%\" /><stop stop-color=\"#e5eff9\" offset=\"100%\" /></linearGradient></defs><use xlink:href=\"#Audience_f\" fill=\"url(#Audience_a)\" /><use xlink:href=\"#Audience_g\" /><g mask=\"url(#Audience_h)\"><use xlink:href=\"#Audience_i\" fill=\"url(#Audience_j)\" transform=\"matrix(.5 0 0 .5 25 25)\" /></g><use xlink:href=\"#Audience_k\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["a"] = (symbol);

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AudienceMattersLogoWhite.545857b.png";

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAKCAYAAADLhGwXAAAAAXNSR0IArs4c6QAAAItJREFUOBHNlYsJgDAMRIt76WC6lXM4h1v4yQODUKyJCGkPDtvmOI6SxpRu9LKchetF1px9RajPJOl24ZFxk/0o9CLUhxsiYB5a99TQWAj3oSU0ZOmLxkK4Dz1dCqznaCyE+nRWmlbrBF8c4ZrUDBL8aaJom/A40Vio4vM2xqh5UcWHG2My/P0Bhfic9nWwVHRLopgAAAAASUVORK5CYII="

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CNN-Default.be00fc3.png";

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DCR-Selected.3dedbe4.png";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DC_Comics-Default.cb2e6ac.png";

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DNB-Selected.6ec9912.png";

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DiscoveryPlus-Selected.2a0a6c3.png";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Epsilon-Default.0c8c483.png";

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LAL_Selected.6245d20.png";

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LiveRamp-Selected.eef45d9.png";

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Max-Selected.b7dd6af.png";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mosaic-Default.4df7148.png";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ncs-Default.da50826.png";

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Prism-Selected.cbad4af.png";

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Retargeting-Selected.5758230.png";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TVE-Selected.133590f.png";

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Videoamp-Selected.e189d41.png";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/WBGames-Selected.5cbd33b.png";

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Canoe-Default.db0d21e.png";

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Canoe_VOD-Default.9d0d29f.png";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DirecTV-Default.dcf9590.png";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Foresite-Default.3c97e92.png";

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Freewheel-Default.8e155ce.png";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GAM-Default.cb148f2.png";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Krux-Default.c32be1e.png";

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LiveRamp-Default.0c27c46.png";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Symphony-Default.fb76007.png";

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Videoamp-Default.b73f583.png";

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Vizio-Default.6223798.png";

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Comscore-Default.ec2d67d.png";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NPower-Default.1f575e2.png";

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Audience_Matters_Target.b89f24c.png";

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.7.2","/codebuild/output/src018207289/src/github.com/turnercode/Audience-Matters-Website"]],"_from":"vue-chartjs@2.7.2","_id":"vue-chartjs@2.7.2","_inBundle":false,"_integrity":"sha512-jo1QIez0+iNxIp9wfByRJwVlWy4uS25RV3PisFIulgbUT8rkwIX0kwdT0YXCTFqq7UjR2UMc1tMHbUYq6I7rQA==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.7.2","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.7.2","saveSpec":null,"fetchSpec":"2.7.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.7.2.tgz","_spec":"2.7.2","_where":"/codebuild/output/src018207289/src/github.com/turnercode/Audience-Matters-Website","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash":"^4.17.4"},"description":"vue.js wrapper for chart.js","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.6.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.2","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.6.0","vue":"^2.4.2"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.7.2"}

/***/ }),
/* 1626 */,
/* 1627 */,
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1228)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1919),
  /* scopeId */
  "data-v-64e36860",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1271)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1963),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1316)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(2009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1247)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1938),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1915),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1286)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1978),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1896),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1307)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(2000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1160)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1847),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1123)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1809),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1905),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1826),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1908),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1887),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1266)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1958),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1231)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1922),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1306)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1159)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1900),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1279)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1971),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1299)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1992),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1256)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1948),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1891),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1240)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1931),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1248)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1940),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1293)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1872),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1178)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1866),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1917),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1168)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1855),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1291)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1983),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1265)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1957),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1858),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1229)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1920),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1304)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1871),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1893),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1167)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1854),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1876),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1311)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(2004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1828),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1836),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1154)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1841),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1302)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1269)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1961),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1831),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1301)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1298)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(1991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1173)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1861),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1822),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(1918),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1315)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(2008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1122)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(1808),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1892),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1811),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1157)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1844),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1296)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1172)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1860),
  /* scopeId */
  "data-v-338d8716",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1257)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1949),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1923),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1310)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(2003),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1119)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1805),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1162)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1849),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1824),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1801),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1308)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(2001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1238)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1929),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1281)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1889),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1288)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1980),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1898),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1305)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1897),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1280)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1972),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1870),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1174)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1862),
  /* scopeId */
  "data-v-34ee89a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1230)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1921),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1827),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1153)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1839),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1152)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1838),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1894),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1285)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1977),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1823),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1120)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1806),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1239)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1930),
  /* scopeId */
  "data-v-6912f678",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1127)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1250)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1942),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1234)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1925),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1856),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1885),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1274)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1966),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1177)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1131)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(1817),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(1798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1180)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(1868),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(1886),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1129)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(1815),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1290)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(1982),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(1899),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1253)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(1945),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1166)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(1853),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1164)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(1851),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(1802),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(1901),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1242)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1933),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1114)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(1800),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(1904),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1237)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(1928),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(933),
  /* template */
  __webpack_require__(1880),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1261)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(1953),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(937),
  /* template */
  __webpack_require__(1910),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1317)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(939),
  /* template */
  __webpack_require__(2010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(1875),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1297)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(1989),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1156)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(1843),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1262)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1954),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1170)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1857),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1260)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(1952),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(1869),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1284)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(1976),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(1913),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1121)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(1807),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(1833),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(1916),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1171)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(1859),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(1883),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(1850),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1309)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(2002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(1912),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(962),
  /* template */
  __webpack_require__(1906),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1259)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(1951),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(1939),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1158)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1845),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(1909),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(1890),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(1990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1278)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(1970),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1303)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(1996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1255)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(974),
  /* template */
  __webpack_require__(1947),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1243)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(975),
  /* template */
  __webpack_require__(1934),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(1829),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(1888),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1155)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(978),
  /* template */
  __webpack_require__(1842),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1161)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(979),
  /* template */
  __webpack_require__(1848),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(1867),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1273)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(983),
  /* template */
  __webpack_require__(1965),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1176)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(1864),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(985),
  /* template */
  __webpack_require__(1819),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(986),
  /* template */
  __webpack_require__(1884),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1294)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(987),
  /* template */
  __webpack_require__(1986),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1249)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(988),
  /* template */
  __webpack_require__(1941),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1268)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(989),
  /* template */
  __webpack_require__(1960),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(990),
  /* template */
  __webpack_require__(1895),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1318)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(992),
  /* template */
  __webpack_require__(2011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(993),
  /* template */
  __webpack_require__(1877),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1244)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(994),
  /* template */
  __webpack_require__(1935),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1267)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(995),
  /* template */
  __webpack_require__(1959),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(996),
  /* template */
  __webpack_require__(1907),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1264)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(997),
  /* template */
  __webpack_require__(1956),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(1924),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(999),
  /* template */
  __webpack_require__(1927),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(1902),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1001),
  /* template */
  __webpack_require__(1820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1002),
  /* template */
  __webpack_require__(1881),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1272)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(1964),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-number-field"
  }, [(_vm.text) ? _c('label', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "numeric",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "tel"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "blur": _vm.onBlurHandler,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }, _vm.onInputHandler],
      "focus": _vm.onFocusHandler
    }
  }) : _c('span', {
    ref: "readOnly"
  }, [_vm._v(_vm._s(_vm.amount))])])
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'viewership-block': !_vm.isGraphOnly
    }
  }, [_c('div', {
    staticClass: "viewership-block__header"
  }, [_c('div', [_c('h4', [_vm._v("Viewership -\n         "), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('toggle-button', {
    staticClass: "viewership-block__toggle-button",
    attrs: {
      "left-label": "Graph",
      "right-label": "Table",
      "toggle-value": !_vm.changeToTable
    },
    on: {
      "toggle": _vm.toggleDisplayOfData
    }
  })] : _vm._e()], 2), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('small', {
    staticClass: "viewership-block__tip"
  }, [_vm._v("*Select networks below to see Daypart breakdowns.")])] : _vm._e()], 2), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('date-range', {
    staticClass: "viewership-block__date-range"
  }), _vm._v(" "), (!_vm.isTargetActivated && _vm.showFilter) ? _c('action-button', {
    staticClass: "viewership-block__right-button",
    attrs: {
      "color": "secondary",
      "id": "networksBtn",
      "label": "Networks"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNetworksModal.apply(null, arguments)
      }
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (!_vm.changeToTable) ? [_c('div', {
    staticClass: "viewership-block__graph-container"
  }, [_c('div', {
    staticClass: "viewership-block__y-title"
  }, [_vm._v("Index")]), _vm._v(" "), _c('div', {
    staticClass: "viewership-block__x-title"
  }, [_vm._v("Rating")]), _vm._v(" "), (_vm.allowViewershipToRender) ? _c('viewership-graph', {
    ref: "viewershipGraph",
    staticClass: "viewership-block__graph",
    attrs: {
      "chartData": _vm.dataForGraph,
      "axises": _vm.axises,
      "onClick": _vm.viwershipOnClick
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewershipData) ? _c('api-error-message', {
    attrs: {
      "api-name": "viewership graph data"
    }
  }) : _vm._e()], 1)] : [_c('div', {
    staticClass: "viewership-block__table-container"
  }, [_c('styled-table', {
    attrs: {
      "theme": "light",
      "data": _vm.dataForTable,
      "headers": _vm.tableHeaders,
      "sort": {
        prop: "size",
        order: "descending"
      }
    },
    on: {
      "sort-change": _vm.handleSortChange
    },
    scopedSlots: _vm._u([{
      key: "item.size",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n           " + _vm._s(_vm.formatAudienceSize(item.size)) + "\n         ")]
      }
    }])
  })], 1)], _vm._v(" "), (!_vm.isGraphOnly) ? [(!_vm.isTargetActivated && _vm.showFilter) ? _c('viewership-filter', {
    ref: "filter",
    attrs: {
      "networks": _vm.networks,
      "selected-networks": _vm.selectedNetworks
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "justify-center pa-5"
  }, [_c('v-card', {
    attrs: {
      "loading": _vm.isLoading,
      "height": "height"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-1 mt-2 ml-2"
  }, [_vm._v("Audience Info")])]), _vm._v(" "), _c('v-card-text', [(!_vm.isLoading) ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "pb-3",
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Name",
      "value": _vm.audience.display_name
    }
  })], 1), _vm._v(" "), (!_vm.showVideoampMetadata) ? _c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Advertiser",
      "value": _vm.advertiserName
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pb-3",
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [(
    !_vm.hasDigitalDestinations &&
    !_vm.showForesiteMetadata &&
    !_vm.showBroadcastQuarter &&
    !(_vm.isDigitalTarget && _vm.isWorkingStatus) &&
    !_vm.showVideoampMetadata
  ) ? _c('v-row', {
    staticClass: "pa-3 pb-0"
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Viewing Stream",
      "value": _vm.viewingStream
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasDigitalDestinations) ? _c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [(_vm.isLiveStatus) ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Refresh Frequency",
      "value": _vm.frequency
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLiveStatus) ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Refresh Day",
      "value": _vm.exportDayOfWeek
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showForesiteMetadata || _vm.showBroadcastQuarter) ? _c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Viewing Stream",
      "value": _vm.viewingStream
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Broadcast Quarter",
      "value": _vm.broadcastQuarter
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Demo Qualifier",
      "value": _vm.demoQualifier
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isFlightDatesNotNull) ? _c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Flight Start",
      "value": _vm.flightStartDate
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Flight End",
      "value": _vm.flightEndDate
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLasActivatedAndNoUE || _vm.showMrmId) ? _c('v-row', {
    staticClass: "pt-3 pb-3",
    attrs: {
      "justify": "space-between"
    }
  }, [(_vm.isLasActivatedAndNoUE) ? _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "UE",
      "rules": _vm.UERules,
      "readonly": !_vm.hasPublishPermissions
    },
    model: {
      value: (_vm.universeEstimate),
      callback: function($$v) {
        _vm.universeEstimate = $$v
      },
      expression: "universeEstimate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMrmId) ? _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "MRM ID",
      "rules": _vm.mrmIdRules,
      "readonly": !_vm.hasPublishPermissions
    },
    model: {
      value: (_vm.mrmId),
      callback: function($$v) {
        _vm.mrmId = $$v
      },
      expression: "mrmId"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showForesiteMetadata) ? [_c('v-row', {
    staticClass: "pa-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "File Name",
      "value": _vm.foresiteMetadata.pid_file_name
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('campaign-quarter-select', {
    attrs: {
      "initialValue": _vm.foresiteMetadata.campaign_quarter,
      "readonly": _vm.hasLake5Destination
    },
    on: {
      "updatedCampaignQuarter": function (val) { return (_vm.foresiteMetadata.campaign_quarter = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.campaignQuarterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Qtr Matched To",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.foresiteMetadata.quarter_matched_to),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "quarter_matched_to", $$v)
      },
      expression: "foresiteMetadata.quarter_matched_to"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.campaignQuarterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Flight From",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.foresiteMetadata.flight_from),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "flight_from", $$v)
      },
      expression: "foresiteMetadata.flight_from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.flightToOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Flight To",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "disabled": !_vm.foresiteMetadata.flight_from,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.foresiteMetadata.flight_to),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "flight_to", $$v)
      },
      expression: "foresiteMetadata.flight_to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "label": "Lake5 Name"
    },
    model: {
      value: (_vm.foresiteMetadata.lake5_name),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "lake5_name", $$v)
      },
      expression: "foresiteMetadata.lake5_name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('demo-id', {
    attrs: {
      "initialValue": _vm.foresiteMetadata.demo_id,
      "readonly": _vm.hasLake5Destination || _vm.hasDemoId || !_vm.hasPublishPermissions
    },
    on: {
      "updatedDemoId": function (val) { return (_vm.foresiteMetadata.demo_id = val); }
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-3 pb-0",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "outlined": "",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "label": "Notes",
      "height": "90",
      "no-resize": "",
      "rules": _vm.notesRules
    },
    model: {
      value: (_vm.foresiteMetadata.lake5_notes),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "lake5_notes", $$v)
      },
      expression: "foresiteMetadata.lake5_notes"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.showVideoampMetadata) ? [_c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('campaign-quarter-select', {
    attrs: {
      "initialValue": _vm.videoampMetadata.campaign_quarter,
      "readonly": _vm.hasLake5Destination
    },
    on: {
      "updatedCampaignQuarter": function (val) { return (_vm.videoampMetadata.campaign_quarter = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination,
      "hide-details": "auto",
      "label": "Advertiser"
    },
    model: {
      value: (_vm.videoampMetadata.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "advertiser", $$v)
      },
      expression: "videoampMetadata.advertiser"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": "",
      "hide-details": "auto",
      "label": "Currency"
    },
    model: {
      value: (_vm.videoampMetadata.currency),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "currency", $$v)
      },
      expression: "videoampMetadata.currency"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination,
      "hide-details": "auto",
      "label": "VideoAmp ID"
    },
    model: {
      value: (_vm.videoampMetadata.videoamp_id),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "videoamp_id", $$v)
      },
      expression: "videoampMetadata.videoamp_id"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination,
      "hide-details": "auto",
      "label": "Deal Number"
    },
    model: {
      value: (_vm.videoampMetadata.deal_number),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "deal_number", $$v)
      },
      expression: "videoampMetadata.deal_number"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('demo-id', {
    attrs: {
      "initialValue": _vm.videoampMetadata.demo_id,
      "readonly": _vm.hasLake5Destination
    },
    on: {
      "updatedDemoId": function (val) { return (_vm.videoampMetadata.demo_id = val); }
    }
  })], 1)], 1)] : _vm._e()], 2), _vm._v(" "), (!_vm.showDestinations) ? _c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.showDestinations) ? _c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-subheader', [_vm._v("Destinations")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "inline-flex justify-center"
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('v-col', {
      key: destination.id,
      attrs: {
        "md": "3"
      }
    }, [_c('MVPD', {
      attrs: {
        "destination": destination,
        "selected": _vm.audience.destinations.includes(destination.id),
        "canUpdate": _vm.canUpdateUE(),
        "showUE": _vm.showUEHoverOver,
        "UE": _vm.getUE(destination),
        "MRM_ID": _vm.getmrmId(destination),
        "minWidth": _vm.destinationWidth,
        "showMRM_ID": false
      }
    })], 1)
  }), 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading && _vm.showUpdate) ? _c('v-card-actions', {
    staticClass: "justify-center pt-0 pb-7"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.canUpdate,
      "color": "success"
    },
    on: {
      "click": _vm.updateAudience
    }
  }, [_vm._v(_vm._s(_vm.buttonLabel))])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "definition-node-drop-zone level-0",
    attrs: {
      "draggable": false
    },
    on: {
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler
    }
  }, [_vm._v("\n  Drop at end\n")])
},staticRenderFns: []}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "create-target-form__name-section upload"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": _vm.isNewTarget,
      "targetType": _vm.target.target || _vm.defaultTargetType,
      "initialValue": (_vm.initialTarget || {
        display_name: ''
      }).display_name,
      "disabled": _vm.wasActivated,
      "validateAllNames": !_vm.showActivationButton
    },
    on: {
      "updateName": function (val) { return (_vm.target.display_name = val); },
      "updateNameIsValid": function (isValid) { return (_vm.nameIsValid = isValid); }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "create-target-form__source-label xandr-create-target__source-label"
  }, [_vm._v("File Type")]), _vm._v(" "), _c('div', {
    staticClass: "create-target-form__source-icons xandr-create-target__source-icons"
  }, _vm._l((_vm.fileTypes), function(fileType) {
    return _c('div', {
      key: fileType.id,
      staticClass: "target-form-upload__destination"
    }, [_c('div', [_c('img', {
      staticClass: "create-target-form__mri-def target-form-upload__destination-icon create-target-form__data-icon--def",
      attrs: {
        "src": _vm.getDestinationImage(fileType)
      },
      on: {
        "click": function($event) {
          return _vm.selectDestination(fileType)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "target-form-upload__destination-title"
    }, [_vm._v(_vm._s(fileType.title))])])])
  }), 0), _vm._v(" "), (!_vm.isXandrUpload) ? [_c('div', {
    staticClass: "target-form-upload__options-area"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('advertiser-select', {
    ref: "advertiserSelect",
    staticClass: "vue-select",
    attrs: {
      "placeholder": "Select",
      "initialValue": _vm.target.advertiser,
      "disabled": _vm.wasActivated
    },
    on: {
      "update": function (val) { return (_vm.target.advertiser = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('streaming-select', {
    ref: "viewingStreamSelect",
    attrs: {
      "initialValue": _vm.target.viewing_stream,
      "viewingOption": _vm.viewingOptions
    },
    on: {
      "input": _vm.onViewingStreamChange
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.hadStagedFile) ? [_c('div', {
    staticClass: "target-form-upload__options-area",
    staticStyle: {
      "margin-top": "5px",
      "display": "block"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('v-file-input', {
    ref: "fileUploadInput",
    attrs: {
      "accept": _vm.acceptedFileFormat,
      "disabled": _vm.isUploadDisabled || _vm.comscoreSelection != null,
      "placeholder": "No file chosen",
      "prepend-icon": "mdi-microsoft-excel"
    },
    on: {
      "change": _vm.onFileChange,
      "click:clear": _vm.clearSelectedFile
    },
    model: {
      value: (_vm.uploadedFile),
      callback: function($$v) {
        _vm.uploadedFile = $$v
      },
      expression: "uploadedFile"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [(_vm.isComscoreDataSource) ? _c('div', {
    staticClass: "target-form-upload__select-area"
  }, [_c('div', {
    staticClass: "evenly-distributed__target-form-dropdown-select",
    class: {
      'absolute-input': this.comscoreSelection != null
    }
  }, [_c('comscore-select', {
    ref: "comscoreSelect",
    staticClass: "vue-select",
    attrs: {
      "disabled": _vm.hadStagedFile || _vm.selectedFiles != null
    },
    on: {
      "update": _vm.onComscoreChange
    }
  })], 1)]) : (_vm.isPIDDataSource) ? _c('div', {
    staticClass: "target-form-upload__select-area"
  }, [_c('broadcast-quarter-select', {
    on: {
      "input": function (val) { return (_vm.broadcastQuarter = val); }
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.isPIDDataSource) ? _c('v-row', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "md": "4"
    }
  }, [_c('demo-qualifier', {
    on: {
      "demoQualifier": function (val) { return (_vm.demoQualifier = val); }
    }
  })], 1)], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "target-form-upload__button-area"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "3"
    }
  }, [(_vm.showActivationButton) ? _c('action-button', {
    attrs: {
      "label": "activate",
      "id": "uploadModalActivateBtn",
      "color": "secondary",
      "disabled": _vm.disableActivationButton
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedActivate.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "3"
    }
  }, [_c('action-button', {
    attrs: {
      "label": "send downstream",
      "id": "uploadModalSendDownstreamBtn",
      "color": "secondary",
      "disabled": !_vm.uploadButtonClickable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedSubmit.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('error-modal', {
    ref: "errorModal",
    attrs: {
      "message": _vm.errorMessage
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-definition"
  }, [_c('div', {
    staticClass: "target-definition__statement-container",
    class: {
      'target-definition__drag-and-drop-mode': _vm.isDragAndDropActive
    }
  }, [_c('scroll-panel', {
    attrs: {
      "is-pinned": true
    }
  }, [(_vm.isDragAndDropActive) ? _c('div', {
    staticClass: "target-definition__drag-and-drop-message"
  }, [_c('p', [_vm._v("Drag and Drop is Active")])]) : _vm._e(), _vm._v(" "), _c('target-definition-statement', {
    staticClass: "target-definition__statement",
    attrs: {
      "disabled": _vm.viewOnly,
      "definition": _vm.definition,
      "selected": _vm.selected,
      "enableNot": _vm.enableNot,
      "enableMinus": _vm.enableMinus,
      "enable-drag-and-drop": _vm.isDragAndDropActive,
      "is-dragging-part": _vm.isDraggingPart
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "target-definition__controls"
  }, [(_vm.isTargetEditable) ? _c('definition-controls') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback-modal",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "feedback-modal__content"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "feedback-modal__x-button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "audienceNameForm",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      value: (true),
      expression: "true",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "audienceName",
    class: _vm.textClass,
    attrs: {
      "dark": _vm.attributePanel,
      "outlined": _vm.attributePanel,
      "dense": _vm.dense,
      "name": "audienceName",
      "label": _vm.label,
      "id": "audienceName",
      "autocomplete": "off",
      "disabled": _vm.disabled,
      "error-messages": _vm.errorMessages
    },
    on: {
      "focus": _vm.targetNameFocusHandler,
      "blur": _vm.targetNameOutOfFocusHandler,
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.display_name),
      callback: function($$v) {
        _vm.display_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "display_name"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "create-audience__loading"
  }, [_c('loading-dots')], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "create-target-form__name-section"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": _vm.isNewTarget,
      "targetType": _vm.target.target,
      "initialValue": _vm.initialTarget.display_name,
      "initialTargetAction": _vm.initialTargetAction,
      "disabled": !!_vm.targetName,
      "validateAllNames": _vm.targetCreated
    },
    on: {
      "updateName": function (val) { return (_vm.target.display_name = val); },
      "updateNameIsValid": function (isValid) { return (_vm.nameIsValid = isValid); }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('advertiser-select', {
    attrs: {
      "initialValue": _vm.target.advertiser,
      "showAdvertiserId": true
    },
    on: {
      "update": function (val) { return (_vm.target.advertiser = val); }
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('streaming-select', {
    attrs: {
      "initialValue": _vm.target.viewing_stream,
      "viewingOption": _vm.viewingOption
    },
    on: {
      "input": function (val) { return (_vm.target.viewing_stream = val); }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isDuplicating) ? _c('div', {
    staticClass: "create-audience__button-area justify-space-around"
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.canBuildAudience || _vm.buttonClicked,
      "label": "Duplicate Audience",
      "color": "secondary",
      "id": "duplicateAudienceBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDuplicate.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDuplicating) ? _c('div', {
    staticClass: "create-audience__button-area justify-space-around"
  }, [_c('action-button', {
    attrs: {
      "disabled": _vm.buttonClicked,
      "label": "attach a file",
      "id": "attachAFileBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFile.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": !_vm.canActivate || _vm.buttonClicked,
      "label": "activate",
      "id": "activateAudienceBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onActivate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": !_vm.canBuildAudience || _vm.buttonClicked,
      "label": "build audience",
      "id": "buildAudienceBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onBuild.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-actions"
  }, [(_vm.showMockData) ? [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": _vm.useMockData ? 'success' : 'light-blue lighten-1',
      "disabled": _vm.viewOnly,
      "id": "toggleMockDataBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMockData.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Toggle Mock Data\n    ")])] : _vm._e(), _vm._v(" "), (_vm.showSendDownstream) ? _c('action-button', {
    class: {
      enabled: _vm.isModeled
    },
    attrs: {
      "dark": "",
      "disabled": _vm.disableDownStreamButton,
      "label": _vm.sendDownstreamLabel,
      "color": "primary",
      "id": "sendDownstreamBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitDownstream.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModelLAL) ? _c('action-button', {
    class: {
      enabled: !_vm.disableModelLALButton
    },
    attrs: {
      "dark": "",
      "disabled": _vm.disableModelLALButton,
      "label": _vm.modelLALButtonLabel,
      "color": "cyan",
      "id": "modelLALBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.modelLAL.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lasActions && _vm.allowDownloadBtn) ? _c('action-button', {
    staticClass: "definition-actions__clear-btn",
    attrs: {
      "label": "download",
      "id": "downloadBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downloadTargetPackage.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.canNotUndo || _vm.viewOnly,
      "label": "undo",
      "id": "undoBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.undo.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.canNotRedo || _vm.viewOnly,
      "dark": "",
      "label": "redo",
      "id": "redoBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.redo.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.isClearAllDisabled || _vm.viewOnly,
      "dark": "",
      "label": "Clear All",
      "id": "clearAllBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clear.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.canNotCancel || _vm.viewOnly,
      "color": "secondary",
      "dark": "",
      "label": "cancel",
      "id": "cancelBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": "",
      "min-width": "300px",
      "disabled": _vm.disableToolTip
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({}, on), [_c('v-btn', _vm._g({
          staticStyle: {
            "min-width": "100px"
          },
          attrs: {
            "disabled": _vm.disableSave || _vm.viewOnly,
            "dark": "",
            "color": "success",
            "id": "saveBtn"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.save.apply(null, arguments)
            }
          }
        }, on), [_vm._v("\n          save\n        ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.hover),
      callback: function($$v) {
        _vm.hover = $$v
      },
      expression: "hover"
    }
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.saveButtonTitle))])]), _vm._v(" "), _c('activation-modal', {
    ref: "activationModal",
    attrs: {
      "segment": _vm.targetData
    },
    model: {
      value: (_vm.isActivationDialogOpen),
      callback: function($$v) {
        _vm.isActivationDialogOpen = $$v
      },
      expression: "isActivationDialogOpen"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ovalButton"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "clearable": !_vm.disabled,
      "outlined": !_vm.disabled,
      "filled": _vm.disabled,
      "dense": "",
      "hide-details": "true",
      "label": "Network",
      "id": "networkSelect",
      "disabled": _vm.disabled
    },
    on: {
      "input": function (val) { return _vm.$emit('update', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attr-panel",
    class: {
      'is-collapsed': _vm.isCollapsed,
      'is-expanded-view': _vm.isExpandedView
    },
    on: {
      "click": _vm.panelClickHandler
    }
  }, [(_vm.isCollapsed) ? _c('collapse-btn', {
    staticClass: "attr-panel__expand-btn",
    attrs: {
      "hide-text": true
    }
  }) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "attr-panel__header"
  }, [_c('div', {
    staticClass: "attr-panel__header-nav"
  }, [_c('panel-size-btn', {
    attrs: {
      "is-expanded-view": _vm.isExpandedView
    },
    nativeOn: {
      "click": function($event) {
        return _vm.togglePanelSize.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('collapse-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleCollapse.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.currentTarget) ? _c('div', {
    staticClass: "attr-panel__target-info"
  }, [_c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [(!_vm.editModeActive) ? _c('v-col', [_vm._v("\n          " + _vm._s(_vm.currentTarget.display_name) + "\n        ")]) : _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": false,
      "initialValue": _vm.originalDisplayName,
      "displayOverride": _vm.currentTarget.display_name,
      "targetType": _vm.currentTarget.target,
      "attributePanel": true
    },
    on: {
      "updateName": _vm.updateName,
      "updateNameIsValid": _vm.validateName
    }
  })], 1), _vm._v(" "), (!_vm.isAdvertiserEditable && _vm.currentTarget && _vm.currentTarget.advertiser && _vm.currentTarget.advertiser.Name) ? _c('v-col', [_vm._v("\n          " + _vm._s(_vm.currentTarget.advertiser.Name) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAdvertiserEditable && _vm.currentTarget && _vm.currentTarget.advertiser) ? _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('advertiser-select', {
    ref: "advertiserSelect",
    attrs: {
      "placeholder": "Select",
      "attributePanel": true,
      "initialValue": _vm.currentTarget.advertiser,
      "showAdvertiserId": false
    },
    on: {
      "update": function (val) { return _vm.changeAdvertiser(val); }
    },
    model: {
      value: (_vm.currentTarget.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.currentTarget, "advertiser", $$v)
      },
      expression: "currentTarget.advertiser"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.targetEditable) ? _c('div', {
    staticClass: "attr-panel__target-info__edit-icon"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditMode.apply(null, arguments)
      }
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('search-input', {
    ref: "searchInput",
    staticClass: "attr-panel__search",
    attrs: {
      "debounce": 500
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  }), _vm._v(" "), _c('bread-crumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "crumbs": _vm.crumbs
    },
    on: {
      "click": _vm.crumbClickHandler
    }
  }), _vm._v(" "), _c('back-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchActive),
      expression: "isSearchActive"
    }],
    staticClass: "attr-panel__back-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  }, [_vm._v("Back To Browse")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attr-panel__body"
  }, [(_vm.tooManySearchResults) ? _c('small-text', [_vm._v("\n      Too many results to display (" + _vm._s(_vm.searchResultsCount) + "). Please refine your search.\n    ")]) : (_vm.isSearchActive) ? _c('search-results', {
    ref: "searchResults",
    attrs: {
      "results": _vm.searchResults,
      "count": _vm.searchResultsCount
    },
    on: {
      "item-selected": _vm.itemSelectedHandler
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentList) ? _c('list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "list-group": _vm.currentList,
      "id": "attributePanelID"
    },
    on: {
      "item-selected": _vm.itemSelectedHandler
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attribute-panel",
    class: {
      'is-collapsed': _vm.isCollapsed,
      'is-expanded-view': _vm.isExpandedView
    },
    on: {
      "click": _vm.panelClickHandler
    }
  }, [(_vm.isCollapsed) ? _c('collapse-btn', {
    staticClass: "attribute-panel__expand-btn",
    attrs: {
      "hide-text": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.workbenchHeaderData) ? _c('div', {
    staticClass: "attribute-panel__header-nav"
  }, [_c('div', {
    staticClass: "attribute-panel__header-nav__dashboard",
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header-nav__dashboard_label text-button"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header-nav__status-details"
  }, [_c('div', {
    staticClass: "attribute-panel__header-nav__status-details__segment-type"
  }, [_vm._v("\n        " + _vm._s(_vm.getCampaignName(_vm.workbenchHeaderData.xandr_data)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header-nav__status-details__segment-type"
  }, [_vm._v("\n        " + _vm._s(_vm.getDestinations(_vm.workbenchHeaderData.destinations)) + "\n      ")]), _vm._v(" "), (_vm.workbenchHeaderData && _vm.workbenchHeaderData.activation_status && !_vm.workbenchHeaderData.dropped) ? _c('v-chip', {
    staticClass: "attribute-panel__header-nav__status-details__status",
    attrs: {
      "label": "",
      "dark": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.workbenchHeaderData.activation_status))]) : (_vm.workbenchHeaderData.dropped) ? _c('v-chip', {
    staticClass: "attribute-panel__header-nav__status-details__status",
    attrs: {
      "label": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.clickedDropped
    }
  }, [_vm._v("DROPPED")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "attribute-panel__header"
  }, [_c('div', {
    staticClass: "attribute-panel__header__segment-details"
  }, [(_vm.workbenchHeaderData) ? _c('div', {
    staticClass: "attribute-panel__header__segment-details__left"
  }, [_c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [(!_vm.editModeActive) ? _c('v-col', {
    staticClass: "flex-grow-1 attribute-panel__header__segment-details__left__name",
    attrs: {
      "md": "6"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.workbenchHeaderData.display_name) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editModeActive) ? _c('v-col', [_c('target-name', {
    attrs: {
      "attributePanel": true,
      "isNewTarget": false,
      "initialValue": _vm.originalDisplayName,
      "displayOverride": _vm.workbenchHeaderData.display_name,
      "targetType": _vm.workbenchHeaderData.target
    },
    on: {
      "updateName": function (val) { return (_vm.targetName = val); },
      "updateNameIsValid": _vm.onTargetNameIsValid
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.workbenchHeaderData.advertiser && _vm.workbenchHeaderData.advertiser.Name && !_vm.editModeActive) ? _c('v-col', {
    staticClass: "flex-shrink-1 attribute-panel__header__segment-details__left__name",
    attrs: {
      "md": "0"
    }
  }, [_vm._v("\n            |\n          ")]) : _vm._e(), _vm._v(" "), (_vm.workbenchHeaderData.advertiser && _vm.workbenchHeaderData.advertiser.Name && !_vm.editModeActive) ? _c('v-col', {
    staticClass: "flex-grow-1 attribute-panel__header__segment-details__left__name",
    attrs: {
      "md": "5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.workbenchHeaderData.advertiser.Name) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editModeActive) ? _c('v-col', [_c('advertiser-select', {
    ref: "advertiserSelect",
    attrs: {
      "placeholder": "Select",
      "attributePanel": true,
      "initialValue": _vm.workbenchHeaderData.advertiser,
      "showAdvertiserId": false
    },
    on: {
      "update": function (val) { return _vm.onUpdateAdvertiser(val); }
    },
    model: {
      value: (_vm.workbenchHeaderData.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.workbenchHeaderData, "advertiser", $$v)
      },
      expression: "workbenchHeaderData.advertiser"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.targetInfoEditable) ? _c('div', {
    staticClass: "attribute-panel__header__segment-details__right"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditMode.apply(null, arguments)
      }
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__header__search-section"
  }, [_c('search-input', {
    ref: "searchInput",
    staticClass: "attribute-panel__header__search-section__search",
    class: {
      'cursor-disabled': _vm.viewOnly
    },
    attrs: {
      "debounce": 500,
      "locked": _vm.viewOnly
    },
    model: {
      value: (_vm.searchTerm),
      callback: function($$v) {
        _vm.searchTerm = $$v
      },
      expression: "searchTerm"
    }
  })], 1), _vm._v(" "), _c('bread-crumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "crumbs": _vm.crumbs,
      "locked": _vm.viewOnly
    },
    on: {
      "click": _vm.crumbClickHandler
    }
  }), _vm._v(" "), _c('back-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchActive),
      expression: "isSearchActive"
    }],
    staticClass: "attribute-panel__back-btn",
    nativeOn: {
      "click": function($event) {
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  }, [_vm._v("Back To Browse")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attribute-panel__body"
  }, [(_vm.tooManySearchResults) ? _c('small-text', [_vm._v("\n      Too many results to display (" + _vm._s(_vm.searchResultsCount) + "). Please refine your search.\n    ")]) : (_vm.isSearchActive) ? _c('search-results', {
    ref: "searchResults",
    attrs: {
      "locked": _vm.viewOnly,
      "results": _vm.searchResults,
      "selectedValues": _vm.selectedValues,
      "count": _vm.searchResultsCount,
      "advertiser": _vm.workbenchHeaderData.advertiser
    },
    on: {
      "item-selected": _vm.onSelect
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentList) ? _c('list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchActive),
      expression: "!isSearchActive"
    }],
    attrs: {
      "listGroup": _vm.currentList,
      "id": "attributePanelID",
      "locked": _vm.viewOnly,
      "selectedValues": _vm.selectedValues,
      "advertiser": _vm.workbenchHeaderData.advertiser
    },
    on: {
      "expandNode": _vm.itemSelectedHandler,
      "onSelect": _vm.onSelect
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('dropped-attributes-modal')], 1)
},staticRenderFns: []}

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    staticClass: "md4",
    attrs: {
      "label": "Audience Name",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "items": _vm.sortedOptions,
      "item-text": "Name",
      "item-value": "Value",
      "id": "appendFileModalAudienceNameSelect",
      "search-input": _vm.search,
      "return-object": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.update(val); },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "append-npower-target-form"
  }, [_c('div', {
    staticClass: "append-npower-target-form__form"
  }, [_c('div', {
    staticClass: "append-target-form__header-menu center"
  }, [(_vm.title) ? [_c('svg-icon', {
    staticClass: "append-npower-target-form__svg",
    attrs: {
      "icon": _vm.svg,
      "width": 60,
      "height": 60
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-h4 font-weight-medium pt-2"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])] : _vm._e()], 2), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "append-npower-target-form__loading"
  }, [_c('loading-dots')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "append-npower-target-form__segments"
  }, [_c('h4', {
    staticClass: "center"
  }, [_vm._v("Target: " + _vm._s(_vm.target.display_name))]), _vm._v(" "), _c('table', {
    staticClass: "append-npower-target-form__table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.segments), function(s) {
    return _c('tr', [_c('td', [_c('span', [_vm._v(_vm._s(s.QuarterName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(s.NetworkName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(s.NumberOfRecords.toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(Math.floor(s.AverageUEs / 1000).toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(new Date(s.UploadedDateTime).toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(s.username))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "append-npower-target-form__upload"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('v-file-input', {
    ref: "fileUploadInput",
    attrs: {
      "accept": _vm.acceptedFileFormat,
      "placeholder": "No file chosen",
      "prepend-icon": "mdi-microsoft-excel"
    },
    on: {
      "change": _vm.onFileChange
    },
    model: {
      value: (_vm.uploadedFile),
      callback: function($$v) {
        _vm.uploadedFile = $$v
      },
      expression: "uploadedFile"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.buttonClickable,
      "color": "success",
      "id": "appendFileModalUploadBtn",
      "label": "upload file"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadFile.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.newSegmentData) ? _c('select-segment-modal', {
    attrs: {
      "fileUploaded": _vm.fileLastUploaded,
      "onCompleteSegmentUpload": _vm.onClose,
      "segmentData": _vm.newSegmentData,
      "currentSegments": _vm.segments,
      "uploadedTargetId": _vm.target.id,
      "uploadedTargetViewingStream": _vm.target.viewing_stream
    }
  }) : (_vm.isLoadingNewSegments) ? _c('div', {
    staticClass: "center"
  }, [_c('loading-dots')], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('span', [_vm._v("Quarter")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Network")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Half-Hour Records")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Average UE (000)")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Uploaded")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Last Modified By")])])])])
}]}

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insights_primary"
  }, [(_vm.loadingInsights || _vm.loadingWorkbench) ? _c('v-overlay', {
    staticClass: "insightsOverlay",
    attrs: {
      "value": _vm.showOverlay,
      "absolute": "",
      "light": ""
    }
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-h5 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.overlayMessage) + "\n        ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": "8"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.insightUpdateError) ? _c('div', {
    staticClass: "insightsMessage text-h5 red--text",
    staticStyle: {
      "margin-top": "10vh"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.overlayMessage) + "\n  ")]) : (_vm.initialOverlay) ? _c('div', {
    staticClass: "insightsMessage text-h4",
    staticStyle: {
      "margin-top": "20vh"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.overlayMessage) + "\n  ")]) : _c('div', {
    staticClass: "pa-6",
    style: (_vm.loadingInsights ? 'opacity: 0.1' : ''),
    attrs: {
      "id": "primaryInsightCardsContainer"
    }
  }, [_c('div', {
    staticClass: "insightsCard mb-4"
  }, [(_vm.isHouseholdDataAvailable) ? _c('v-card', {
    attrs: {
      "elevation": "2",
      "name": "householdIdCards",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "insightsCardTitle text-subtitle-1"
  }, [_vm._v("household id")]), _vm._v(" "), _c('div', {
    staticClass: "pl-8"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.houseIcon,
      "width": "2em"
    }
  })], 1)]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', {
    staticClass: "justify-center d-flex flex-wrap ml-10 mr-10 mb-2",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, _vm._l((_vm.householdCardData), function(data) {
    return _c('v-card', {
      key: data.idType,
      staticClass: "ml-6 mr-6",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "text-body-1 text-center"
    }, [_vm._v("\n              " + _vm._s(data.idType) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-h5 font-weight-bold text-center"
    }, [_vm._v("\n              " + _vm._s(_vm.formattedCount(data.count)) + "\n            ")])])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "insightsCard"
  }, [(_vm.isDeviceDataAvailable) ? _c('v-card', {
    staticClass: "deviceIdCards",
    attrs: {
      "elevation": "2",
      "name": "deviceIdCards",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "insightsCardTitle text-subtitle-1"
  }, [_vm._v("device id")]), _vm._v(" "), _c('div', [_c('v-img', {
    attrs: {
      "src": _vm.deviceIcon,
      "width": "4.5em"
    }
  })], 1)]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', {
    class: _vm.deviceIdCardsClass,
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.deviceCardData), function(data) {
    return _c('v-card', {
      key: data.idType,
      staticClass: "deviceIdCountCard ml-lg-6 mr-lg-6 mb-2",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "text-uppercase text-body-1 text-center"
    }, [_vm._v("\n              " + _vm._s(data.idType) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-h5 font-weight-bold text-center"
    }, [_vm._v("\n              " + _vm._s(_vm.formattedCount(data.count)) + "\n            ")])])
  }), 1)], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-list"
  }, [_c('span', {
    staticClass: "panel-list__name"
  }, [_vm._v(_vm._s(_vm.listGroup.model.name))]), _vm._v(" "), _c('div', {
    staticClass: "panel-list__items-wrap"
  }, [(_vm.scrollable) ? [_c('virtual-list', {
    ref: "virtualList",
    attrs: {
      "is-pinned": true,
      "size": 42,
      "remain": 12,
      "data-source": _vm.listGroup.children
    }
  }, _vm._l((_vm.listGroup.children), function(item) {
    return _c('panel-item', {
      key: item.model.id,
      ref: "item",
      refInFor: true,
      attrs: {
        "is-selected": _vm.currentSelectedItem == item,
        "name": item.model.name,
        "description": item.model.description,
        "is-locked": _vm.locked,
        "has-children": item.hasChildren()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem(item, $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.model.name)
      }
    })])
  }), 1)] : _vm._l((_vm.listGroup.children), function(item) {
    return _c('panel-item', {
      key: item.model.id,
      ref: "item",
      refInFor: true,
      attrs: {
        "is-selected": _vm.currentSelectedItem == item,
        "name": item.model.name,
        "description": item.model.description,
        "path": item.model.path,
        "is-locked": _vm.locked,
        "has-children": item.hasChildren()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem(item, $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.model.name)
      }
    })])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('styled-select-new', {
    ref: "select",
    staticClass: "advertiser-select-new__text_colors",
    attrs: {
      "value": _vm.value,
      "options": _vm.options,
      "disabled": _vm.disabled,
      "searchOptions": _vm.searchOptions,
      "label": "Name"
    },
    on: {
      "input": _vm.emitInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "popover-checkmark-btn"
  }, [_c('svg-icon', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "icon": _vm.Check
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "universe-stability"
  }, [_c('div', {
    staticClass: "universe-stability__header"
  }, [_c('h4', {
    ref: "header"
  }, [_vm._v("UNIVERSE STABILITY")]), _vm._v(" "), (!_vm.hideStabilityFlag) ? [(_vm.universeIsStable) ? _c('div', {
    staticClass: "universe-stability__check is-stable"
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.pass,
      "width": 22,
      "height": 22
    }
  }), _vm._v(" " + _vm._s(_vm.stableText) + "\n      ")], 1) : _vm._e(), _vm._v(" "), (!_vm.universeIsStable) ? _c('div', {
    staticClass: "universe-stability__check is-unstable"
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.error,
      "width": 22,
      "height": 22
    }
  }), _vm._v(" " + _vm._s(_vm.unstableText) + "\n      ")], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "universe-stability__graph"
  }, [_c('universe-stability-graph', {
    attrs: {
      "data": _vm.universeChartData
    }
  }), _vm._v(" "), (!_vm.universe) ? _c('api-error-message', {
    attrs: {
      "apiName": "universe stability graph data"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "back-btn"
  }, [_c('svg-icon', {
    staticClass: "back-btn__arrow",
    attrs: {
      "icon": _vm.arrow,
      "width": 6,
      "height": 10
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-v2-custom",
    class: [_vm.themeClass(), {
      'table-v2-custom--responsive': _vm.responsive
    }]
  }, [_c('div', {
    staticClass: "table-v2-inner-spacing"
  }, [(_vm.$slots.tableHeader) ? _c('div', {
    staticClass: "table-header"
  }, [_vm._t("tableHeader")], 2) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    ref: "table",
    class: _vm.tableClasses,
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.data || [],
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "loading": _vm.loading,
      "hide-default-footer": _vm.hideFooter,
      "items-per-page": _vm.itemsPerPage
    },
    on: {
      "update:sort-by": _vm.handleSortChange,
      "update:sort-desc": _vm.handleSortDescChange
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('tr', {
          class: _vm.getRowClass(index)
        }, _vm._l((_vm.computedHeaders), function(header) {
          return _c('td', {
            key: header.value,
            class: _vm.getCellClass(header)
          }, [_vm._t(("item." + (header.value)), function() {
            return [_vm._v("\n              " + _vm._s(_vm.formatCellValue(item, header)) + "\n            ")]
          }, {
            "item": item,
            "value": item[header.value]
          })], 2)
        }), 0)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._t("empty", function() {
          return [_c('div', {
            staticClass: "text-center pa-4"
          }, [_vm._v("\n            No data available\n          ")])]
        })]
      },
      proxy: true
    }, {
      key: "loading",
      fn: function() {
        return [_vm._t("loading", function() {
          return [_c('div', {
            staticClass: "text-center pa-4"
          }, [_vm._v("\n            Loading...\n          ")])]
        })]
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _vm._t("bottom")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workbench-w-canvas-slot', {
    attrs: {
      "loading": _vm.loading,
      "metrics": _vm.toolbarMetrics,
      "target-name": _vm.targetName,
      "activated": _vm.activated,
      "header-menu": _vm.dynamicHeaderMenu,
      "showQuickAddAttributes": _vm.showQuickAddAttributes
    }
  }, [(_vm.isTargetEmpty && !_vm.loading) ? [_c('div', {
    staticClass: "workbench__empty-target"
  }, [(_vm.isTargetEmpty) ? _c('h3', [_vm._v("Select a Program by Searching or Browsing from the right panel.")]) : _vm._e()])] : [_c('workbench-row', {
    ref: "viewership",
    style: ({
      height: _vm.viewershipRowHeight
    })
  }, [_c('audience-size', {
    staticClass: "workbench__audience workbench__canvas-block",
    attrs: {
      "size": _vm.audienceSize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas-block workbench__viewership"
  }, [_c('viewership', {
    attrs: {
      "networks": _vm.networks,
      "show-filter": false,
      "viewership-data": _vm.historicalViewership
    }
  })], 1)], 1), _vm._v(" "), (_vm.selectedNetworksDayParts.length > 0) ? _c('workbench-row', [_c('day-parts', {
    staticClass: "workbench__day-parts workbench__canvas-block",
    attrs: {
      "viewership-data": _vm.historicalViewership,
      "selected-networks": _vm.selectedNetworksDayParts,
      "networks": _vm.networks,
      "day-parts-config": _vm.dayPartsConfig
    },
    on: {
      "close": _vm.clearSelectedNetworks
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('workbench-row', {
    ref: "universe",
    staticClass: "workbench__universe",
    style: ({
      height: _vm.universeRowHeight
    })
  }, [_c('universe-stability', {
    staticClass: "workbench__canvas-block",
    attrs: {
      "universe": _vm.universeData,
      "hide-stability-flag": true
    }
  })], 1)], _vm._v(" "), _c('confirm-modal', {
    ref: "confirmModal"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-block"
  }, [_c('div', {
    staticClass: "graph-block__header"
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.tip) ? _c('small', {
    staticClass: "graph-block__tip"
  }, [_vm._v("\n          *" + _vm._s(_vm.tip) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "graph-block__graph-container"
  }, [(_vm.yAxis) ? _c('div', {
    staticClass: "graph-block__y-title"
  }, [_vm._v("\n        " + _vm._s(_vm.yAxis) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.xAxis) ? _c('div', {
    staticClass: "graph-block__x-title"
  }, [_vm._v("\n        " + _vm._s(_vm.xAxis) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "outlined": "",
      "hide-details": "true",
      "label": "Day",
      "id": "dayOfWeek_ddl"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "las-bottom-panel"
  }, [_c('div', [(!_vm.hideQuickAddAttributes) ? _c('quick-add-attributes', {
    attrs: {
      "viewOnly": _vm.viewOnly
    }
  }) : _vm._e(), _vm._v(" "), _c('target-definition', {
    class: [_vm.sizeClass],
    attrs: {
      "enableNot": _vm.lasActions,
      "enableMinus": _vm.xandrActions,
      "viewOnly": _vm.viewOnly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "las-bottom-panel__footer"
  }, [_c('bottom-pane-sizer', {
    staticClass: "las-bottom-panel__footer__sizer",
    attrs: {
      "current-size": _vm.currentBottomPaneSize
    },
    on: {
      "new-size": _vm.changeBottomPaneSize
    }
  }), _vm._v(" "), _c('definition-actions', {
    staticClass: "las-bottom-panel__footer__actions",
    class: {
      'viewOnly': _vm.viewOnly
    },
    attrs: {
      "enableSaving": _vm.enableSaving,
      "allowDownloadBtn": false,
      "viewOnly": _vm.viewOnly,
      "targetData": _vm.targetData,
      "lasActions": _vm.lasActions,
      "xandrActions": _vm.xandrActions
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pid-overwrite-form"
  }, [_c('div', {
    staticClass: "pid-overwrite-form__header mt-2 mb-4"
  }, [_vm._v("\n    Select the quarters you wish to include/overwrite with your new PID list\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "table-body"
  }, [_c('v-simple-table', {
    attrs: {
      "height": "500px",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("\n              Quarter\n            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("\n              Exists\n            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("\n              Include/Overwrite\n            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
          return _c('tr', {
            key: item.quarter
          }, [_c('td', [_vm._v("\n              " + _vm._s(item.quarter) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
            staticClass: "d-flex justify-center"
          }, [_c('v-checkbox', {
            attrs: {
              "disabled": ""
            },
            model: {
              value: (item.exists),
              callback: function($$v) {
                _vm.$set(item, "exists", $$v)
              },
              expression: "item.exists"
            }
          })], 1)]), _vm._v(" "), _c('td', [_c('div', {
            staticClass: "d-flex justify-center"
          }, [_c('v-checkbox', {
            model: {
              value: (item.override),
              callback: function($$v) {
                _vm.$set(item, "override", $$v)
              },
              expression: "item.override"
            }
          })], 1)])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "Process",
      "color": "secondary",
      "id": "pidAppendProcessBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.overwriteFiles.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-definition"
  }, [_c('div', {
    staticClass: "target-definition__statement-container",
    class: {
      'target-definition__drag-and-drop-mode': _vm.isDragAndDropActive
    }
  }, [_c('scroll-panel', {
    attrs: {
      "is-pinned": true
    }
  }, [(_vm.isDragAndDropActive) ? _c('div', {
    staticClass: "target-definition__drag-and-drop-message"
  }, [_c('p', [_vm._v("Drag and Drop is Active")])]) : _vm._e(), _vm._v(" "), _c('target-definition-statement', {
    staticClass: "target-definition__statement",
    attrs: {
      "definition": _vm.definition,
      "selected": _vm.selected,
      "enable-drag-and-drop": _vm.isDragAndDropActive,
      "is-dragging-part": _vm.isDraggingPart
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "target-definition__controls"
  }, [(_vm.isTargetEditable) ? _c('definition-controls') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "collapse-btn"
  }, [(!_vm.hideText) ? _c('span', [_vm._v("Collapse")]) : _vm._e(), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 7,
      "height": 11
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "collapse-btn"
  }, [(!_vm.hideText) ? _c('span', [_vm._v("Collapse")]) : _vm._e(), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 7,
      "height": 11
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-history-branch"
  }, [_c('div', {
    staticClass: "revision-history-branch__header"
  }, [_c('span', {
    staticClass: "revision-history-branch__label"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('x-flag', {
    attrs: {
      "scale": 1.2
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteBranch.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "revision-history-branch__footer"
  }, [_c('span', [_c('span', {
    staticClass: "revision-history-branch__audience"
  }, [_vm._v("\n        " + _vm._s(_vm.totalAudience) + "\n      ")]), _vm._v(" "), (!_vm.isCurrentBranch) ? [_c('positiveity-indicator', {
    attrs: {
      "number": _vm.changeInAudience,
      "message": _vm.changeInAudienceMessage
    }
  }), _vm._v(" "), _c('oval-button', {
    staticClass: "revision-history-branch__goto",
    nativeOn: {
      "click": function($event) {
        return _vm.goto.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          GOTO\n        ")])] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-down-button",
    style: (_vm.canvasStyle)
  }, [_c('div', {
    staticClass: "pull-down-button__canvas",
    style: ({
      'width': _vm.width + 'px'
    })
  }, [(_vm.show) ? _c('div', [_c('div', {
    staticClass: "pull-down-button__canvas-shown"
  }, [_c('scroll-panel', {
    attrs: {
      "height": _vm.scrollHeight
    }
  }, [_vm._t("default")], 2)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-down-button__button-area"
  }, [_c('div', {
    ref: "button",
    staticClass: "pull-down-button__button",
    style: (_vm.buttonPosition),
    on: {
      "click": _vm.toggleHiddenSection
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.show) ? _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-up",
      "scale": "1.2"
    }
  }) : _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-down",
      "scale": "1.2"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      light: _vm.light
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      target_name__dropped: _vm.isDropped
    },
    attrs: {
      "title": _vm.params.value
    }
  }, [(_vm.justDisplayNameOfTarget) ? [_c('span', [_vm._v("\n      " + _vm._s(_vm.params.value) + "\n    ")])] : (_vm.hasTargetAction(_vm.params.data)) ? [_c('span', {
    staticClass: "audience-hub-table__target-name",
    on: {
      "click": _vm.openTarget
    }
  }, [(_vm.showPostSymbol) ? _c('v-icon', {
    attrs: {
      "color": "green",
      "medium": ""
    }
  }, [_vm._v("mdi-chart-line")]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.params.value) + "\n    ")], 1)] : [_c('span', {
    staticClass: "audience-hub-table__target-name",
    on: {
      "click": _vm.openWorkbench
    }
  }, [_vm._v("\n      " + _vm._s(_vm.params.value) + "\n    ")])]], 2)
},staticRenderFns: []}

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "id": _vm.id,
      "dark": _vm.dark,
      "color": _vm.color == 'secondary' ? 'blue-grey darken-4' : _vm.color,
      "disabled": _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.label))])
},staticRenderFns: []}

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ovalLabel"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-target-form"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-target-modal__modal"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "create-target-modal__header-menu align-center"
  }, [(_vm.svg) ? [_c('svg-icon', {
    staticClass: "create-target-modal__svg",
    attrs: {
      "icon": _vm.svg,
      "width": 60,
      "height": 60
    }
  })] : (_vm.png) ? [_c('img', {
    staticClass: "create-target-modal__svg create-target-modal__png",
    attrs: {
      "src": _vm.png
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-h4 font-weight-medium"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])], 2) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "create-target-modal__loading"
  }, [_c('loading-dots')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'create-target-modal__invisible': _vm.loading
    }
  }, [_vm._t("default"), _vm._v(" "), [_vm._t("create")], _vm._v(" "), [_vm._t("select")]], 2)])
},staticRenderFns: []}

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-history-revision"
  }, [_c('div', {
    staticClass: "revision-history-revision__revision-header"
  }, [_vm._v("\n    " + _vm._s(_vm.revisionText) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "revision-history-revision__footer"
  }, [_c('span', [_c('span', {
    staticClass: "revision-history-revision__audience"
  }, [_vm._v("\n            " + _vm._s(_vm.totalAudience) + "\n            ")]), _vm._v(" "), (!_vm.isCurrentRevision) ? [_c('positiveity-indicator', {
    attrs: {
      "number": _vm.changeInAudience,
      "message": _vm.changeInAudienceMessage
    }
  }), _vm._v(" "), _c('oval-button', {
    staticClass: "revision-history-revision__goto",
    nativeOn: {
      "click": function($event) {
        return _vm.goto.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          GOTO\n        ")])] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'workbench__row': true,
      'workbench__sm_row': _vm.isSM
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "panel-size-btn",
    class: {
      'panel-size-btn--expanded': _vm.isExpandedView
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 7,
      "height": 11
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-item",
    class: {
      'is-selected': _vm.isSelected,
      'has-children': _vm.hasChildren,
      'has-path': _vm.hasPath,
      'has-description': _vm.titleAttribute,
      'cursor-disabled': _vm.isLocked
    },
    attrs: {
      "title": _vm.titleAttribute
    }
  }, [(_vm.path) ? _c('small-text', [_vm._v(_vm._s(_vm.path))]) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "name"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.titleAttribute) ? _c('svg-icon', {
    staticClass: "panel-item__copy",
    attrs: {
      "icon": _vm.copy,
      "width": 13,
      "height": 13,
      "preserveAspectRatio": "xMinYMid meet"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyDescription.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasChildren) ? _c('svg-icon', {
    staticClass: "panel-item__arrow",
    attrs: {
      "icon": _vm.arrow,
      "width": 8,
      "height": 13
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.campaignQuarterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Campaign Qtr",
      "readonly": _vm.readonly,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('updatedCampaignQuarter', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-history-panel"
  }, [_c('div', {}, [_c('div', {
    staticClass: "revision-history-panel__revisions"
  }, [_c('oval-label', {
    staticClass: "revision-history-panel__revisions-circle"
  }, [_vm._v("\n        Revisions\n      ")]), _vm._v(" "), _c('oval-label', {
    staticClass: "revision-history-panel__clear",
    nativeOn: {
      "click": function($event) {
        return _vm.clearRevisionHistory.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        CLEAR\n      ")])], 1), _vm._v(" "), _c('scroll-panel', {
    staticClass: "revision-history-panel__scroll-header",
    attrs: {
      "height": _vm.heightOfRevisions
    }
  }, _vm._l((_vm.revisionHistories), function(rh) {
    return _c('revision-history', _vm._b({
      key: rh.id,
      class: {
        'revision-history-panel__revision': true,
        'revision-history-panel__current-move': rh.id === _vm.selectedRevision
      },
      attrs: {
        "currentAudience": _vm.currentAudience,
        "isCurrentRevision": rh.id === _vm.selectedRevision,
        "goto": function () { return _vm.onClickRevisionHistory(rh); }
      }
    }, 'revision-history', rh, false))
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "revision-history-panel__dividor"
  }, [_c('oval-label', {
    staticClass: "revision-history-panel__branch-header"
  }, [_vm._v("\n      Versions\n    ")]), _vm._v(" "), _c('positive-circle', {
    staticClass: "revision-history-panel__add-branch",
    attrs: {
      "size": 21
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewBranch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(_vm.currentBranchLabel) + "\n    ")]), _vm._v(" "), _c('scroll-panel', {
    staticClass: "revision-history-panel__scroll-header",
    attrs: {
      "height": _vm.heightOfBranches
    }
  }, [_vm._l((_vm.branches), function(b) {
    return [(b.id !== _vm.selectedBranch) ? _c('branch', _vm._b({
      key: b.id,
      class: {
        'revision-history-panel__branch': true,
        'revision-history-panel__current-branch': b.id === _vm.selectedBranch
      },
      attrs: {
        "goto": function () { return _vm.onClickBranch(b); },
        "currentAudience": _vm.currentAudience,
        "isCurrentBranch": b.id === _vm.selectedBranch,
        "deleteBranch": function () { return _vm.deleteBranch(b); }
      }
    }, 'branch', b, false)) : _vm._e()]
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-panel",
    class: {
      'is-pinned': _vm.isPinned,
      'is-scroll-disabled': _vm.isScrollDisabled,
      'has-padding': _vm.hasPadding
    },
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('feedback-modal', {
    ref: "feedbackModal",
    staticClass: "action-modal"
  }, [_c('div', {
    staticClass: "action-modal__message"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-center action-modal__button"
  }, [_c('action-button', {
    attrs: {
      "label": _vm.buttonText,
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.target.id) ? [_c('div', {
    staticClass: "target-details__platform"
  }, [_c('div', [_c('div', [_c('b', [_vm._v("Target Name: ")]), _vm._v(_vm._s(_vm.target.display_name))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Advertiser: ")]), _vm._v(_vm._s(_vm.target.advertiser.Name))])])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "colorTheme": _vm.colorTheme
    }
  }, [_vm._l((_vm.notifications), function(n) {
    return [_c('notification', {
      key: n.id,
      attrs: {
        "notification": n,
        "actionEngine": _vm.actionEngine,
        "dismiss": _vm.dismiss
      },
      on: {
        "delete": _vm.deleteNotification
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-range",
    class: {
      'date-range--view-only': _vm.isActivated
    }
  }, [_c('span', {
    staticClass: "date-range__label"
  }, [_vm._v("From")]), _vm._v(" "), _c('span', {
    staticClass: "date-range__value",
    on: {
      "click": _vm.createStartPopover
    }
  }, [_vm._v(_vm._s(_vm.startDateName) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "date-range__label"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "date-range__value",
    on: {
      "click": _vm.createEndPopover
    }
  }, [_vm._v(_vm._s(_vm.endDateName) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "networksFilterModal",
    attrs: {
      "relative-to-parent": true
    }
  }, [_c('div', {
    staticClass: "viewership-filter"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Turner"
    }
  }, [_c('div', {
    staticClass: "viewership-filter__networks-container"
  }, _vm._l((_vm.turnerNetworks), function(network) {
    return _c('button', {
      key: network.id,
      staticClass: "viewership-filter__network",
      class: {
        'viewership-filter__network--selected': _vm.isSelected(network.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectNetwork(network.id)
        }
      }
    }, [(_vm.hasUrl(network)) ? _c('img', {
      attrs: {
        "src": network.url
      }
    }) : [_vm._v(_vm._s(network.name))]], 2)
  }), 0)]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Non-Turner"
    }
  }, [_c('div', {
    staticClass: "viewership-filter__networks-container"
  }, _vm._l((_vm.nonTurnerNetworks), function(network) {
    return _c('button', {
      key: network.id,
      staticClass: "viewership-filter__network__non-turner non-turner",
      class: {
        'viewership-filter__network--selected': _vm.isSelected(network.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectNetwork(network.id)
        }
      }
    }, [(_vm.hasUrl(network)) ? _c('img', {
      attrs: {
        "src": network.url
      }
    }) : [_vm._v(_vm._s(network.name))]], 2)
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "viewership-filter__actions",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [(_vm.errorNoNetworks) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("Please select at least one network")]) : _vm._e(), _vm._v(" "), (_vm.errorToManySelected) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("Please narrow your selection from " + _vm._s(_vm.currentLength) + " to " + _vm._s(_vm.maxNumberOfNetworks) + " or less")]) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "cancel",
      "id": "cancelNetworkSelection",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.disableSubmit,
      "label": "update",
      "id": "updateNetworkSelection",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitNewSelection.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue),
      expression: "localValue"
    }],
    staticClass: "search__input",
    class: {
      'viewOnly': _vm.locked
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.localValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('svg-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchInputEmpty),
      expression: "isSearchInputEmpty"
    }],
    staticClass: "search__search-icon",
    attrs: {
      "icon": _vm.searchIcon,
      "width": 14,
      "height": 14
    }
  }), _vm._v(" "), _c('svg-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchInputEmpty),
      expression: "!isSearchInputEmpty"
    }],
    staticClass: "search__cancel-icon",
    attrs: {
      "icon": _vm.cancelIcon,
      "width": 10,
      "height": 10
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('target-form-upload', {
    ref: "targetPartial",
    attrs: {
      "initialTarget": _vm.target,
      "buttonText": "Upload",
      "errorMessage": _vm.errorMessage,
      "onComplete": _vm.onComplete,
      "originalTarget": _vm.originalTarget
    },
    on: {
      "submit": _vm.handleUpload,
      "activate": _vm.handleActivateTarget
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('stepper-range', {
    attrs: {
      "attribute": _vm.rangeAttribute
    },
    on: {
      "select": _vm.selectAttribute
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(option) {
    return _c('div', {
      key: option.name,
      staticClass: "list-popover__option",
      class: _vm.optionClass(option.value),
      style: (_vm.optionStyle),
      attrs: {
        "id": ("popover-box-option-" + (option.name))
      },
      on: {
        "click": function($event) {
          return _vm.selectOption(option.value)
        }
      }
    }, [_vm._v("\n    " + _vm._s(option.name) + "\n  ")])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.groupDisable || _vm.isDragAndDropActive,
      "title": "Group (g)"
    },
    on: {
      "click": _vm.groupAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__group",
      "icon": _vm.group,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.ungroupDisable || _vm.isDragAndDropActive,
      "title": "Ungroup (u)"
    },
    on: {
      "click": _vm.ungroupAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__ungroup",
      "icon": _vm.ungroup,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.countGroupDisable || _vm.isDragAndDropActive
    },
    on: {
      "click": _vm.countGroupHandler
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.countGroupIcon,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    class: {
      active: _vm.isDragAndDropActive
    },
    attrs: {
      "title": "Drag and drop mode"
    },
    on: {
      "click": _vm.dragAndDropModeToggle
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__arrows",
      "icon": _vm.arrows
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.deleteDisable || _vm.isDragAndDropActive,
      "title": "Delete (Delete/Backspace)"
    },
    on: {
      "click": _vm.deleteAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__trash",
      "icon": _vm.trash,
      "width": 15,
      "height": 18
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workbench"
  }, [_c('workbench-toolbar', {
    attrs: {
      "name": _vm.targetName,
      "activated": _vm.activated,
      "metrics": _vm.metrics,
      "loading": _vm.loading,
      "menu": _vm.headerMenu,
      "showGraphs": _vm.showGraphs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__top-pane"
  }, [(!_vm.live) ? _c('div', {
    staticClass: "workbench__side-panel",
    class: {
      'is-collapsed': _vm.isCollapsed,
      'is-expanded-view': _vm.isExpandedView
    }
  }, [_c('attribute-panel', {
    attrs: {
      "is-expanded-view": _vm.isExpandedView,
      "is-collapsed": _vm.isCollapsed
    },
    on: {
      "collapse-clicked": _vm.togglePanelCollapse,
      "change-size-click": _vm.togglePanelSize
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas",
    attrs: {
      "id": "canvas"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "workbench__loader"
  }, [_c('loader-dots')], 1) : _vm._e(), _vm._v(" "), _c('scroll-panel', {
    staticClass: "workbench__canvas-content"
  }, [_vm._t("default")], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "workbench__bottom-pane",
    class: [_vm.sizeClass]
  }, [(_vm.showQuickAddAttributebuttons) ? _c('quick-add-attributes', {
    attrs: {
      "viewOnly": _vm.viewOnly
    }
  }) : _vm._e(), _vm._v(" "), _c('target-definition', {
    attrs: {
      "namespace": "las"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "workbench__bottom-bar"
  }, [_c('bottom-pane-sizer', {
    attrs: {
      "current-size": _vm.currentBottomPaneSize
    },
    on: {
      "new-size": _vm.changeBottomPaneSize
    }
  }), _vm._v(" "), (!_vm.live) ? _c('definition-actions', {
    attrs: {
      "allowDownloadBtn": _vm.allowDownloadBtn
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showRevisionHistoryPanel) ? _c('transparent-control-panel', {
    attrs: {
      "initialPosition": {
        top: 125,
        right: 50
      }
    }
  }, [_c('vuex-revision-history-panel', {
    attrs: {
      "onSetCurrentMove": _vm.setTargetDefinitionFromRevisionHistory
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "sendDownstream",
    attrs: {
      "title": _vm.modalTitle,
      "width": 2500,
      "closeButton": ""
    },
    on: {
      "closed": _vm.destroySetup,
      "exited": _vm.destroySetup
    }
  }, [_c('v-tabs', {
    class: {
      'activation-modal__hide-tabs': !this.activatingAudience
    },
    attrs: {
      "color": "primary",
      "slider-color": "primary",
      "centered": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('div', {
    staticClass: "activation-modal__name-container__videoamp"
  }, [_c('div', {
    staticClass: "activation-modal__name-section__videoamp"
  }, [_c('v-text-field', {
    attrs: {
      "name": "audienceName",
      "label": "Audience Name",
      "id": "activationModalAudienceName",
      "readonly": "",
      "hide-details": "true",
      "dense": "",
      "filled": ""
    },
    model: {
      value: (_vm.value.display_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "display_name", $$v)
      },
      expression: "value.display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__bottom-container"
  }, [_c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('campaign-quarter-select', {
    attrs: {
      "initialValue": _vm.videoampMetadata.campaign_quarter
    },
    on: {
      "updatedCampaignQuarter": function (val) { return (_vm.videoampMetadata.campaign_quarter = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "auto",
      "label": "Advertiser"
    },
    model: {
      value: (_vm.videoampMetadata.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "advertiser", $$v)
      },
      expression: "videoampMetadata.advertiser"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "auto",
      "label": "Videoamp ID"
    },
    model: {
      value: (_vm.videoampMetadata.videoamp_id),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "videoamp_id", $$v)
      },
      expression: "videoampMetadata.videoamp_id"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": "",
      "hide-details": "auto",
      "label": "Currency"
    },
    model: {
      value: (_vm.videoampMetadata.currency),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "currency", $$v)
      },
      expression: "videoampMetadata.currency"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "auto",
      "label": "Deal #"
    },
    model: {
      value: (_vm.videoampMetadata.deal_number),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "deal_number", $$v)
      },
      expression: "videoampMetadata.deal_number"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('demo-id', {
    attrs: {
      "initialValue": _vm.videoampMetadata.demo_id
    },
    on: {
      "updatedDemoId": function (val) { return (_vm.videoampMetadata.demo_id = val); }
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('v-tab-item', [_c('div', {
    staticClass: "activation-modal__name-container"
  }, [_c('div', {
    staticClass: "activation-modal__name-section"
  }, [_c('v-text-field', {
    attrs: {
      "name": "audienceName",
      "label": "Audience Name",
      "id": "activationModalAudienceName",
      "readonly": "",
      "hide-details": "true",
      "dense": "",
      "filled": ""
    },
    model: {
      value: (_vm.value.display_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "display_name", $$v)
      },
      expression: "value.display_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__options-area__advertiser pad"
  }, [_c('div', {
    staticClass: "activation-modal__select-area"
  }, [_c('advertiser-select', {
    attrs: {
      "initialValue": _vm.value.advertiser,
      "showAdvertiserId": true,
      "disabled": _vm.disableAdvertiser,
      "filled": true
    },
    on: {
      "update": function (val) { return (_vm.value.advertiser = val); }
    }
  })], 1)]), _vm._v(" "), (_vm.showViewingStream) ? _c('div', {
    staticClass: "activation-modal__options-area__streaming pad"
  }, [_c('div', {
    staticClass: "activation-modal__select-area"
  }, [_c('streaming-select', {
    attrs: {
      "initialValue": _vm.value.viewing_stream,
      "viewingOption": _vm.viewingOption,
      "disabled": _vm.disableViewingStream
    },
    on: {
      "input": function (val) { return (_vm.value.viewing_stream = val); }
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__bottom-container"
  }, [_c('div', {
    staticClass: "activation-modal__endpoints-area"
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('div', {
      key: destination.id,
      staticClass: "activation-modal__destinations"
    }, [_c('MVPD', {
      attrs: {
        "destination": destination,
        "selected": _vm.value.destinations.includes(destination.id),
        "canUpdate": _vm.canUpdateUE(),
        "UE": 0,
        "MRM_ID": _vm.mrmID()
      },
      on: {
        "selectedDestination": function($event) {
          return _vm.selectDestination(destination)
        },
        "UEChanged": function (ue) { return _vm.updateCanoeUE(ue); },
        "MRMIDChanged": function (mrmId) { return _vm.updateMrmID(mrmId); }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.foresiteDestinationSelected) ? _c('div', {
    staticClass: "activation-modal__campaign-area"
  }, [(_vm.isDigitalDestination) ? _c('div', {
    staticClass: "xandr-create-target__date-area"
  }, [_c('flight-dates', {
    attrs: {
      "value": {
        flightStartDate: _vm.value.am_data.flightStartDate,
        flightEndDate: _vm.value.am_data.flightEndDate,
      }
    },
    on: {
      "input": function (val) { return Object.assign(_vm.value.am_data, val); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFrequency) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('frequency-d-d-l', {
    attrs: {
      "initialValue": _vm.frequency,
      "optionSet": _vm.frequencyOptionSet,
      "disabled": _vm.disableFrequency
    },
    on: {
      "input": function (val) { return (_vm.value.xandr_data.frequency = val); }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.foresiteDestinationSelected) ? _c('div', {
    staticClass: "activation-modal__broadcast-quarter-area"
  }, [_c('broadcast-quarter-select', {
    on: {
      "input": function (val) { return (_vm.broadcastQuarter = val); }
    }
  }), _vm._v(" "), _c('demo-qualifier', {
    on: {
      "demoQualifier": function (val) { return (_vm.demoQualifier = val); }
    }
  })], 1) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__button-area",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [(_vm.showAdvertiserRequiredMessage) ? _c('div', {
    staticClass: "activation-modal__advertiser-required"
  }, [_vm._v("\n      Advertiser is required in order to send downstream\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.activatingAudience && !_vm.disableSendDownstream) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.disableSendDownstream,
      "label": "Send Downstream",
      "color": "primary",
      "id": "sendDownstreamModalBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitDownstream.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activatingAudience) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.disableActivate,
      "label": "Activate",
      "color": "primary",
      "id": "activateAudienceModalBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.activateAudience.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-container', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "firstName",
      "label": "First Name",
      "id": "firstName",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.value.first_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "first_name", $$v)
      },
      expression: "value.first_name"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "label": "Last Name",
      "id": "lastName",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.value.last_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "last_name", $$v)
      },
      expression: "value.last_name"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.value.email),
      callback: function($$v) {
        _vm.$set(_vm.value, "email", $$v)
      },
      expression: "value.email"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmitHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Create New User")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-common-attributes"
  }, [_c('p', {
    staticClass: "top-common-attributes__title"
  }, [_vm._v("Top 10 by coverage")]), _vm._v(" "), _c('div', {
    staticClass: "top-common-attributes__y-title"
  }, [_vm._v("Index to average")]), _vm._v(" "), _c('div', {
    staticClass: "top-common-attributes__x-title"
  }, [_vm._v("Coverage")]), _vm._v(" "), _c('top-attributes-bubble-graph', {
    ref: "graph",
    staticClass: "top-common-attributes__graph",
    attrs: {
      "chartData": _vm.dataForGraph,
      "axises": _vm.axises
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-size"
  }, [(_vm.displaySize || _vm.displaySize === 0) ? [_c('svg-icon', {
    attrs: {
      "icon": _vm.audience,
      "width": 56,
      "height": 33
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h2 mt-5"
  }, [_vm._v(_vm._s(_vm._f("truncateAmount")(_vm.displaySize)))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-1 audience-size__text"
  }, [_vm._v("Target Audience (Age 18+)")]), _vm._v(" "), _c('viewership-time-frame', {
    attrs: {
      "validStreamingOptions": _vm.validStreamingOptions,
      "selectedViewshipOption": _vm.viewershipOption
    },
    on: {
      "selected": _vm.onSelectedViewingStream
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('basic-modal', _vm._b({
    ref: "basicModal",
    attrs: {
      "cssAfectsWidth": false
    }
  }, 'basic-modal', _vm.modal, false), [_c('div', {
    staticClass: "dialog-modal"
  }, [(_vm.hasHeader) ? [_c('div', {
    staticClass: "dialog-modal__header"
  }, [_vm._v("\n        " + _vm._s(_vm.header) + "\n      ")])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-modal__content"
  }, [(_vm.message) ? [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")] : _vm._t("content")], 2), _vm._v(" "), (_vm.hasFooter) ? [_c('div', {
    staticClass: "dialog-modal__footer"
  }, [_c('hr'), _vm._v(" "), (!_vm.hasFooterSlot) ? [_c('div', {
    staticClass: "dialog-modal__footer__buttons"
  }, [_c('action-button', {
    attrs: {
      "color": "success",
      "label": "yesLabel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickYes.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "noLabel",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickNo.apply(null, arguments)
      }
    }
  })], 1)] : _vm._t("footer")], 2)] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-grid-vue', {
    staticClass: "ag-theme-material",
    staticStyle: {
      "width": "40vw",
      "height": "60vh"
    },
    attrs: {
      "rowHeight": "45",
      "columnDefs": _vm.columnDefs,
      "rowData": _vm.rowData,
      "frameworkComponents": _vm.frameworkComponents,
      "context": _vm.context
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('operator-selector', {
    on: {
      "select": _vm.selectOperator
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "pl-0": "",
      "pr-0": ""
    }
  }, [_c('v-form', {
    ref: "splitSegmentForm"
  }, [(_vm.showSplitSegment) ? _c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "8",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue-grey darken-1",
      "dense": "",
      "dark": ""
    },
    on: {
      "click": _vm.splitSegment
    }
  }, [_vm._v("\n          Split Segment\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.segmentSplit), function(split, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "9"
      }
    }, [_c('target-name', {
      attrs: {
        "splitSegmentName": true
      },
      on: {
        "updateName": function (val) { return (split.name = val); },
        "updateNameIsValid": function (val) { return _vm.updateSplitNameValid(index, val); }
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pl-0 pr-0",
      attrs: {
        "cols": "6",
        "md": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Split",
        "type": "number",
        "suffix": "%",
        "dense": "",
        "hide-details": "true"
      },
      on: {
        "input": _vm.calculateTotal
      },
      model: {
        value: (split.percentage),
        callback: function($$v) {
          _vm.$set(split, "percentage", $$v)
        },
        expression: "split.percentage"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pl-0 pr-0",
      attrs: {
        "cols": "12",
        "md": "1"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeSplit(index)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-trash-can-outline")])], 1)], 1)], 1)
  }), _vm._v(" "), (!_vm.showSplitSegment) ? _c('v-row', {
    attrs: {
      "justify": "end"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": _vm.alert.type,
      "dense": "",
      "text": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.alert.message))])], 1) : _vm._e(), _vm._v(" "), (!_vm.showSplitSegment) ? _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dense": "",
      "text": "",
      "disabled": _vm.totalPercentage >= 100
    },
    on: {
      "click": _vm.addSplit
    }
  }, [_c('v-icon', [_vm._v("mdi-plus-box-outline")]), _vm._v("\n          Add Split\n        ")], 1)], 1)], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    attrs: {
      "label": "Comscore File",
      "filled": _vm.disabled,
      "outlined": "",
      "disabled": _vm.disabled,
      "dense": "",
      "clearable": "",
      "items": _vm.sortedOptions,
      "item-text": "Name",
      "item-value": "value",
      "search-input": _vm.search,
      "return-object": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.$emit('update', val); },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "back-btn"
  }, [_c('svg-icon', {
    staticClass: "back-btn__arrow",
    attrs: {
      "icon": _vm.arrow,
      "width": 6,
      "height": 10
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-box",
    class: _vm.selectorClass,
    style: ([_vm.position, _vm.styles.popover])
  }, [(_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popover-box__content",
    class: _vm.styles.content
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('styled-table', _vm._b({
    ref: "table"
  }, 'styled-table', _vm.tableProps, false), [_c('template', {
    slot: "tableHeader"
  }, [_vm._t("tableHeader")], 2), _vm._v(" "), _c('template', {
    slot: "loading"
  }, [_c('loader-dots', {
    staticClass: "emptyTableLayout__loader"
  })], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [(_vm.loading) ? [(_vm.loading) ? _c('loader-dots', {
    staticClass: "emptyTableLayout__loader"
  }) : _vm._e()] : [_c('empty-table', _vm._b({}, 'empty-table', _vm.emptyTableProps, false), [_vm._t("emptyTableSlot")], 2)]], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-parts-legend"
  }, _vm._l((_vm.sortedDayParts), function(part) {
    return _c('div', {
      staticClass: "day-parts-legend__part",
      class: {
        'day-parts-legend__part--selected': _vm.isSelected(part.id)
      },
      on: {
        "click": function($event) {
          return _vm.emitDayPart(part.id)
        }
      }
    }, [_c('span', {
      staticClass: "day-parts-legend__part-color",
      style: ({
        backgroundColor: part.color
      })
    }), _vm._v("\n    " + _vm._s(part.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "definition-node-drop-zone level-0",
    attrs: {
      "draggable": false
    },
    on: {
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler
    }
  }, [_vm._v("\n  Drop at end\n")])
},staticRenderFns: []}

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.iconClass,
    attrs: {
      "viewBox": _vm.icon.viewBox,
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": ("#" + (_vm.icon.id))
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "networksFilterModal"
  }, [_c('div', {
    staticClass: "viewership-filter"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Turner"
    }
  }, [_c('div', {
    staticClass: "viewership-filter__networks-container"
  }, _vm._l((_vm.turnerNetworks), function(network) {
    return _c('button', {
      key: network.id,
      staticClass: "viewership-filter__network",
      class: {
        'viewership-filter__network--selected': _vm.isSelected(network.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectNetwork(network.id)
        }
      }
    }, [(_vm.hasUrl(network)) ? _c('img', {
      attrs: {
        "src": network.url
      }
    }) : [_vm._v(_vm._s(network.name))]], 2)
  }), 0)]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Non-Turner"
    }
  }, [_c('div', {
    staticClass: "viewership-filter__networks-container"
  }, _vm._l((_vm.nonTurnerNetworks), function(network) {
    return _c('button', {
      key: network.id,
      staticClass: "viewership-filter__network__non-turner non-turner",
      class: {
        'viewership-filter__network--selected': _vm.isSelected(network.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectNetwork(network.id)
        }
      }
    }, [(_vm.hasUrl(network)) ? _c('img', {
      attrs: {
        "src": network.url
      }
    }) : [_vm._v(_vm._s(network.name))]], 2)
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "viewership-filter__actions",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [(_vm.errorNoNetworks) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("Please select at least one network")]) : _vm._e(), _vm._v(" "), (_vm.errorToManySelected) ? _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("Please narrow your selection from " + _vm._s(_vm.currentLength) + " to " + _vm._s(_vm.maxNumberOfNetworks) + " or less")]) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "cancel",
      "id": "cancelNetworkSelection",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.disableSubmit,
      "label": "update",
      "id": "updateNetworkSelection",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitNewSelection.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('icon', {
    class: {
      'notificationsIcon': true,
      'notificationsIcon__info-blue': _vm.isInfo,
      'notificationsIcon__success-green': _vm.isSuccess,
      'notificationsIcon__warning-yellow': _vm.isWarning,
      'notificationsIcon__error-red': _vm.isError
    },
    attrs: {
      "name": _vm.name,
      "scale": "1"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "15px",
      "height": "15px",
      "viewBox": "0 0 15 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("3F00B732-1154-411E-9214-252B68E713A1")]), _vm._v(" "), _c('desc', [_vm._v("Created with sketchtool.")]), _vm._v(" "), _c('g', {
    staticClass: "defaultOpactiy",
    class: {
      'activeOpacity': _vm.editModeActive
    },
    attrs: {
      "id": "Linear",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "opacity": "0.499883743"
    }
  }, [_c('g', {
    staticClass: "default",
    class: {
      'yellow-pencil': _vm.editModeActive
    },
    attrs: {
      "id": "1-Linear-Workbench-MRI-Empty-Default",
      "transform": "translate(-678.000000, -79.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Attribute-Panel"
    }
  }, [_c('g', {
    attrs: {
      "id": "noun_Pencil_1772505",
      "transform": "translate(678.000000, 79.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.3263947,2.50796678 L12.3822923,5.58164035 L4.65818308,13.3318234 L1.62103335,10.2770067 L9.3263947,2.50796678 Z M14.7070242,1.77254795 L13.338432,0.395994754 C12.8134925,-0.131998251 11.951092,-0.131998251 11.4261525,0.395994754 L10.1138039,1.71597727 L13.1697015,4.78965084 L14.6882763,3.2622425 C15.1007288,2.82853396 15.1007288,2.1685427 14.7070242,1.77254795 Z M0.00871929689,14.5763783 C-0.0475242166,14.8215179 0.177449837,15.0478007 0.421171729,14.99123 L3.81453038,14.1615267 L0.796128486,11.10671 L0.00871929689,14.5763783 Z",
      "id": "Shape"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permission-header"
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "dense": "",
      "color": "#32383f"
    }
  }, [_c('div', {
    staticClass: "admin__header-nav__dashboard",
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "admin__header-nav__dashboard_label text-button"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "admin__header-nav__dashboard_label text-button pl-3"
  }, [_vm._v("Admin Management")])]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "color": "#32383f"
    }
  }, [_c('v-tabs', {
    attrs: {
      "background-color": "#32383f",
      "dark": ""
    }
  }, _vm._l((_vm.routes), function(route) {
    return _c('v-tab', {
      key: route.name,
      attrs: {
        "to": route.path
      }
    }, [_vm._v("\n        " + _vm._s(route.name) + "\n      ")])
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    key: _vm.attribute.definitionId,
    staticClass: "definition-node",
    class: [{
      'selected': _vm.isSelected,
      'in-group': _vm.inGroup,
      'is-first': _vm.isFirst,
      'is-last': _vm.isLast,
      'is-removed': _vm.attribute.removed,
      'cant-drop-here': !_vm.canDropHere,
    }, _vm.levelClass],
    attrs: {
      "disabled": _vm.disableDefinitionPart,
      "draggable": _vm.isDraggable && !_vm.thisPartIsInACountGroup
    },
    domProps: {
      "innerHTML": _vm._s(_vm.displayName)
    },
    on: {
      "click": _vm.clickHandler,
      "dblclick": function($event) {
        return _vm.editAttribute($event)
      },
      "dragstart": _vm.dragStartHandler,
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler,
      "mouseover": _vm.showUEHoverOver,
      "mouseout": _vm.hideUEHoverOver
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "property-engagement"
  }, [_c('div', {
    staticClass: "property-engagement__header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "property-engagement__legend"
  }, [_c('graph-key', {
    attrs: {
      "graph-key-items": _vm.keyItems,
      "flex": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "property-engagement__sort"
  }, [_vm._v("\n      Sort By:\n      "), _vm._l((_vm.sorts), function(s, index) {
    return [(index !== 0) ? _c('span', [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('a', {
      class: {
        'active': (_vm.currentSort.name === s.name)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentSort = s
        }
      }
    }, [_vm._v(_vm._s(s.name))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "property-engagement__graph-container"
  }, [_c('property-engagement-graph', {
    staticClass: "property-engagement__graph",
    attrs: {
      "chart-data": _vm.chartData
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "property-engagement__title"
  }, [_c('h4', [_vm._v("Known Consumer Reach and Engagement by Property")])])
}]}

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('chart-layout', {
    attrs: {
      "title": _vm.title,
      "yAxis": _vm.yAxis,
      "xAxis": _vm.xAxis
    }
  }, [_c('bar-graph', {
    attrs: {
      "chart-data": _vm.data,
      "chart-id": _vm.chartIdOverride,
      "type": _vm.type
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(!_vm.down) ? _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-up",
      "scale": "1.2"
    }
  }) : _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-down",
      "scale": "1.2"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rolesOptions,
      "item-text": "name",
      "item-value": "value",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.updateUserRole(val); }
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-hub-dashboard"
  }, [_c('dashboard-header'), _vm._v(" "), _c('audience-hub-table', {
    attrs: {
      "filters": _vm.query,
      "routeParamsName": _vm.routeParamsName,
      "nielsenDatasources": _vm.nielsenDatasources,
      "C360Datasources": _vm.C360Datasources
    },
    on: {
      "targetOption": _vm.handleTargetOption
    }
  }), _vm._v(" "), _c('div', [_c('dashboard-action-modal', {
    ref: "deleteModal",
    attrs: {
      "target": _vm.activeTarget,
      "buttonText": "Delete"
    },
    on: {
      "click": _vm.deleteTarget
    }
  }, [_vm._v("\n      Are you sure you want to delete target "), _c('span', {
    staticClass: "audience-hub-dashboard__delete-target-name"
  }, [_vm._v(_vm._s(_vm.activeTarget.display_name) + "?")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('simple-button', {
    class: {
      'interactive-button__button': true,
      'interactive-button__button--inactive': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled,
      "text": _vm.label
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    class: 'builder-list-popover ' + _vm.className,
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "tipColor": _vm.tipColor
    }
  }, _vm._l((_vm.list), function(option) {
    return _c('div', {
      staticClass: "builder-list-popover__option",
      class: _vm.optionClass(option),
      style: (_vm.optionStyle),
      attrs: {
        "id": ("popover-box-option-" + (option.name))
      },
      on: {
        "click": function (e) { return _vm.selectOption(option.value, option, e); }
      }
    }, [_vm._v("\n    " + _vm._s(option.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transparent_control_panel",
    style: (_vm.position),
    on: {
      "mouseover": _vm.mouseEnter,
      "mouseout": _vm.mouseOut,
      "mouseup": _vm.mouseUp,
      "mousedown": _vm.mouseDown,
      "mousemove": _vm.mouseMove
    }
  }, [_c('div', {
    staticClass: "expanded-Area"
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.cancel,
      "width": 12,
      "height": 12
    }
  })], 1), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: {
      'transparent_control_panel__non_expanded_area': !_vm.showExpand,
      'transparent_control_panel__no-display': _vm.showExpand
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workbench-w-canvas-slot', {
    attrs: {
      "loading": _vm.loading,
      "metrics": _vm.toolbarMetrics,
      "target-name": _vm.targetName,
      "activated": _vm.activated,
      "header-menu": _vm.dynamicHeaderMenu
    }
  }, [_c('workbench-row', {
    ref: "topRow",
    style: ({
      height: _vm.topRow
    })
  }, [_c('audience-size', {
    staticClass: "workbench__audience workbench__canvas-block",
    attrs: {
      "size": _vm.audienceSize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas-block workbench__additional-attributes"
  }, [_c('tabs', {
    staticClass: "workbench__stretch-canvas-block"
  }, [_c('tab', {
    attrs: {
      "name": "Additional TSP Attributes"
    }
  }, [_c('top-common-attributes', {
    attrs: {
      "attributes": _vm.topTsp
    }
  }), _vm._v(" "), (!_vm.topTsp) ? _c('api-error-message', {
    attrs: {
      "apiName": "top tsp attributes data"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('workbench-row', {
    staticClass: "workbench__property-engagement-row",
    style: ({
      height: _vm.bottomRow
    })
  }, [(!_vm.reach) ? _c('api-error-message', {
    attrs: {
      "apiName": "reach and engagement data"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('confirm-modal', {
    ref: "confirmModal"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "clearable": !_vm.disabled,
      "outlined": !_vm.disabled,
      "filled": _vm.disabled,
      "dense": "",
      "hide-details": "true",
      "label": "Viewing Stream",
      "id": "viewing_stream_select",
      "readonly": _vm.disabled
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "operator-selector"
  }, [_c('div', {
    staticClass: "operator-selector__operator-icon operator-selector__AND-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['AND'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['AND'].icon.class,
    attrs: {
      "width": _vm.operator['AND'].icon.width,
      "height": _vm.operator['AND'].icon.height,
      "icon": _vm.operator['AND'].icon.svg
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operator-selector__operator-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['OR'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['OR'].icon.class,
    attrs: {
      "width": _vm.operator['OR'].icon.width,
      "height": _vm.operator['OR'].icon.height,
      "icon": _vm.operator['OR'].icon.svg
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operator-selector__operator-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['NOT'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['NOT'].icon.class,
    attrs: {
      "width": _vm.operator['NOT'].icon.width,
      "height": _vm.operator['NOT'].icon.height,
      "icon": _vm.operator['NOT'].icon.svg
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isActive) ? _c('div', {
    staticClass: "tab"
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewership-time-frame"
  }, [_c('div', {
    staticClass: "viewership-time-frame__label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "viewership-time-frame__value",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedText) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-range",
    class: {
      'date-range--view-only': _vm.isActivated
    }
  }, [_c('span', {
    staticClass: "date-range__label"
  }, [_vm._v("From")]), _vm._v(" "), _c('span', {
    staticClass: "date-range__value",
    on: {
      "click": _vm.createStartPopover
    }
  }, [_vm._v(_vm._s(_vm.startDateName) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "date-range__label"
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "date-range__value",
    on: {
      "click": _vm.createEndPopover
    }
  }, [_vm._v(_vm._s(_vm.endDateName) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "panel-size-btn",
    class: {
      'panel-size-btn--expanded': _vm.isExpandedView
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 7,
      "height": 11
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "radio-button-custom"
  }, [_vm._l((_vm.options), function(op) {
    return [_c('span', {
      key: op.value,
      staticClass: "radio-button-custom__button"
    }, [_c('input', {
      staticClass: "radio-button-custom__radio",
      attrs: {
        "type": "radio",
        "name": _vm.radioButtonName,
        "id": op.name,
        "disabled": _vm.disabled
      },
      domProps: {
        "checked": String(_vm.value) === String(op.value),
        "value": op.value
      },
      on: {
        "input": _vm.emitInput
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": op.name
      }
    }, [_vm._v(_vm._s(op.name))])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "showOnCreate": _vm.showOnCreate,
      "title": _vm.modalTitle,
      "width": _vm.isNewAudienceStep ? 600 : 0,
      "closeButton": "",
      "hideActions": !_vm.showButtons
    },
    on: {
      "closed": _vm.destroySetup,
      "exited": _vm.destroySetup
    }
  }, [(!_vm.isDataStep && !_vm.isDuplicate && !_vm.isUpdate && !_vm.isUpdateCampaign && !_vm.isViewingSegmentInfo && _vm.showBackButton) ? _c('template', {
    slot: "header-buttons"
  }, [(!_vm.isNewAudienceStep) ? _c('back-arrow-nav', {
    staticClass: "las-back-button",
    on: {
      "goBack": _vm.goBack
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "stepper"
  }, [(_vm.isDataStep) ? _c('data-source-step', {
    attrs: {
      "targetName": _vm.titleInfo.targetName
    },
    model: {
      value: (_vm.dataInfo),
      callback: function($$v) {
        _vm.dataInfo = $$v
      },
      expression: "dataInfo"
    }
  }) : (_vm.isFinishStep) ? _c('finish-step', {
    attrs: {
      "targetName": _vm.titleInfo.targetName,
      "selectedDataSource": _vm.selectedDataSource,
      "onComplete": _vm.stepperOnComplete
    },
    on: {
      "close": _vm.close
    },
    model: {
      value: (_vm.finishInfo),
      callback: function($$v) {
        _vm.finishInfo = $$v
      },
      expression: "finishInfo"
    }
  }) : (_vm.isNewAudienceStep) ? _c('create-audience', {
    attrs: {
      "onComplete": _vm.stepperOnComplete,
      "onAudienceActivation": _vm.onAudienceActivation
    },
    model: {
      value: (_vm.audienceInfo),
      callback: function($$v) {
        _vm.audienceInfo = $$v
      },
      expression: "audienceInfo"
    }
  }) : _vm._e()], 1)], _vm._v(" "), (_vm.showButtons) ? _c('template', {
    slot: "actions"
  }, [_c('action-button', {
    attrs: {
      "disabled": _vm.disableBackButton,
      "label": "cancel",
      "color": "secondary",
      "id": "datasourceModalCancelBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelButton.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": !_vm.completedCurrentStep,
      "label": "Next",
      "color": "success",
      "id": "datasourceModalNextBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextButton.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "operator-selector"
  }, [_c('div', {
    staticClass: "operator-selector__operator-icon operator-selector__AND-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['AND'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['AND'].icon.class,
    attrs: {
      "width": _vm.operator['AND'].icon.width,
      "height": _vm.operator['AND'].icon.height,
      "icon": _vm.operator['AND'].icon.svg
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operator-selector__operator-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['OR'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['OR'].icon.class,
    attrs: {
      "width": _vm.operator['OR'].icon.width,
      "height": _vm.operator['OR'].icon.height,
      "icon": _vm.operator['OR'].icon.svg
    }
  })], 1), _vm._v(" "), (_vm.enableNot) ? _c('div', {
    staticClass: "operator-selector__operator-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['NOT'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['NOT'].icon.class,
    attrs: {
      "width": _vm.operator['NOT'].icon.width,
      "height": _vm.operator['NOT'].icon.height,
      "icon": _vm.operator['NOT'].icon.svg
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.enableMinus) ? _c('div', {
    staticClass: "operator-selector__operator-icon operator-icon",
    on: {
      "click": function($event) {
        return _vm.selectOperator(_vm.operator['-'])
      }
    }
  }, [_c('svg-icon', {
    class: _vm.operator['-'].icon.class,
    attrs: {
      "width": _vm.operator['-'].icon.width,
      "height": _vm.operator['-'].icon.height,
      "icon": _vm.operator['-'].icon.svg
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "graph-key",
    class: {
      'graph-key__flex': _vm.flex
    }
  }, _vm._l((_vm.graphKeyItems), function(item) {
    return _c('li', {
      staticClass: "graph-key__item"
    }, [(item.color) ? _c('span', {
      staticClass: "graph-key__item-color",
      style: ({
        background: item.color
      })
    }) : _vm._e(), _vm._v("\n    " + _vm._s(item.body) + "\n    "), (item.value) ? _c('span', {
      staticClass: "graph-key__item-value"
    }, [_vm._v(" " + _vm._s(item.value))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "npower-append-target-modal"
  }, [_c('modal', {
    ref: "modal",
    attrs: {
      "autoWidth": "",
      "closeButton": ""
    },
    on: {
      "closed": _vm.onClose
    }
  }, [_c('append-n-power-form', {
    ref: "form",
    attrs: {
      "title": "Append Audience Segments"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ag-grid-vue', {
    staticClass: "ag-theme-material",
    staticStyle: {
      "width": "1010px",
      "height": "100%"
    },
    attrs: {
      "rowData": _vm.rowData,
      "columnDefs": _vm.columnDefs,
      "frameworkComponents": _vm.frameworkComponents,
      "context": _vm.context,
      "getContextMenuItems": _vm.getContextMenuItems
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results"
  }, [_c('small-text', {
    staticClass: "search-results__count"
  }, [_vm._v(_vm._s(_vm.count) + " Results")]), _vm._v(" "), _c('scroll-panel', [_c('div', {
    staticClass: "search-results__list"
  }, _vm._l((_vm.searchResultsFormatted), function(results) {
    return _c('div', {
      staticClass: "search-results__result-set"
    }, [_c('list', {
      key: results.name,
      attrs: {
        "locked": _vm.locked,
        "list-group": results,
        "scrollable": false,
        "selectedValues": _vm.selectedValues,
        "advertiser": _vm.advertiser
      },
      on: {
        "onSelect": _vm.itemSelectedHandler
      }
    }), _vm._v(" "), (_vm.hasNoResults(results)) ? _c('small-text', {
      staticClass: "search-results__no-results",
      attrs: {
        "light": true
      }
    }, [_vm._v("No Results")]) : _vm._e()], 1)
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('icon', {
    staticClass: "x-flag__times-circle",
    attrs: {
      "name": "times-circle",
      "scale": _vm.scale
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "download-target__graphs",
    attrs: {
      "id": "las-downloadable-region"
    }
  }, [_c('div', {
    attrs: {
      "id": "viewership-graph-pdf"
    }
  }, [_c('viewership-graph', {
    attrs: {
      "viewershipData": _vm.viewershipData,
      "networks": _vm.networks,
      "isGraphOnly": true
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "universe-graph-pdf"
    }
  }, [_c('universe-stability-graph', {
    attrs: {
      "data": _vm.universeData
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "age-market-breaker-graph-pdf"
    }
  }, [_c('age-market-breaker-graph', {
    attrs: {
      "data": _vm.ageMarketBreakerData,
      "meanAge": _vm.meanAge
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "age-graph-pdf"
    }
  }, [_c('age-graph', {
    attrs: {
      "data": _vm.ageData,
      "meanAge": _vm.meanAge
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "income-graph-pdf"
    }
  }, [_c('income-graph', {
    attrs: {
      "data": _vm.incomeData
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workbench-app"
  }, [_c('div', {
    staticClass: "workbench-app__main-container"
  }, [_c('div', {
    staticClass: "workbench-app__attribute-panel"
  }, [_c('attribute-panel', {
    staticClass: "workbench-app__main-container__side-panel",
    attrs: {
      "setOfAttributes": _vm.attributes,
      "onSelect": _vm.selectAttribute,
      "workbenchHeaderData": _vm.copiedTarget,
      "selectedValues": _vm.selectedXandrAttributes,
      "canEditTargetHeaderData": _vm.canEditTargetHeaderData,
      "datasetFilter": _vm.datasetFilter,
      "viewOnly": _vm.viewOnly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "workbench-app__main-container__slotted"
  }, [_vm._t("main-container", null, {
    "slottedValue": _vm.workbenchSlottedValue
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "workbench-app__bottom-pane"
  }, [_vm._t("bottom-pane", null, {
    "copiedTarget": _vm.copiedTarget
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('create-target-slot', {
    attrs: {
      "title": _vm.text,
      "overrideLoad": _vm.appendTypeIsNpowerOrComscore,
      "showBackButton": _vm.showBackButton,
      "svg": _vm.svg,
      "png": _vm.png
    }
  }, [(_vm.appendTypeIsNpowerOrComscore) ? [_c('append-n-power-form', {
    staticClass: "upload-modal__upload-options"
  })] : (_vm.showSelectSegment) ? [_c('select-segment-modal', {
    attrs: {
      "slot": "select",
      "onCompleteSegmentUpload": _vm.onComplete,
      "segmentData": _vm.segmentData,
      "uploadedTargetId": _vm.uploadedTargetId,
      "uploadedTargetViewingStream": _vm.uploadedTargetViewingStream
    },
    slot: "select"
  })] : (_vm.showOverwrites) ? [_c('overwrite-form', {
    attrs: {
      "overwrites": _vm.overwrites,
      "onComplete": _vm.onComplete,
      "targetId": _vm.uploadedTargetId
    }
  })] : (_vm.showCreateNewUpload) ? [_c('create-upload', {
    attrs: {
      "defaultSelectedUpload": _vm.defaultSelectedUpload,
      "originalTarget": _vm.originalTarget,
      "onCompleteUpload": _vm.onCompleteUpload,
      "onComplete": _vm.onComplete
    },
    on: {
      "submittedUploadFile": _vm.submittedUploadFile,
      "sentDownstream": _vm.sentDownstream
    }
  })] : (_vm.showAppendNewFile) ? [_c('append-file-uploader', {
    ref: "appendFile",
    attrs: {
      "defaultAppendOption": _vm.defaultAppendingOption,
      "defaultSelectedTarget": _vm.defaultSelectedAppendingTarget,
      "onCompleteUpload": _vm.onCompleteUpload
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-add-attributes"
  }, _vm._l((_vm.quickAddAttributes), function(attribute) {
    return _c('button', {
      key: attribute.id,
      ref: "button",
      refInFor: true,
      class: {
        'is-active': _vm.isActive(attribute)
      },
      attrs: {
        "disabled": _vm.viewOnly
      },
      on: {
        "click": function($event) {
          return _vm.attributeClickedHandler(attribute, $event)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getPrettyName(attribute)) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-parts"
  }, [_c('div', {
    staticClass: "day-parts__close",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("Close "), _c('svg-icon', {
    attrs: {
      "icon": _vm.closeIcon,
      "width": 12,
      "height": 12
    }
  })], 1), _vm._v(" "), _c('day-parts-legend', {
    attrs: {
      "parts": _vm.dayPartsConfig,
      "selectedParts": _vm.selectedDayParts
    },
    on: {
      "day-part-click": _vm.dayPartSelected
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "day-parts-comparison"
  }, [_c('div', {
    staticClass: "day-parts-comparison__inner-container"
  }, _vm._l((_vm.networksToShow), function(network) {
    return _c('div', {
      staticClass: "day-parts-comparison__network"
    }, [_c('h4', [_vm._v(_vm._s(network.name))]), _vm._v(" "), _c('day-parts-graph', {
      staticClass: "workbench__day-break",
      attrs: {
        "chart-data": _vm.removeHiddenDayParts(network.data),
        "axises": _vm.dayPartAxises,
        "width": 380,
        "height": 140
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "day-parts-comparison__x-mark",
      on: {
        "click": function($event) {
          return _vm.deSelectNetwork(network.network)
        }
      }
    }, [_vm._v("\n         ✕\n       ")])], 1)
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-bracket",
    class: _vm.classes,
    attrs: {
      "draggable": _vm.isDraggable
    },
    on: {
      "dragstart": _vm.dragStartHandler,
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler
    }
  }, [_c('svg-icon', {
    key: _vm.attribute.definitionId,
    attrs: {
      "icon": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.select(_vm.attribute)
      }
    }
  }), _vm._v(" "), (_vm.showMustMatch) ? _c('span', {
    staticClass: "definition-bracket__count-group",
    on: {
      "dblclick": _vm.clickHandler
    }
  }, [_vm._v(_vm._s(_vm.attribute.mustMatch))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "user-view"
  }, [_c('div', {
    staticClass: "user-view__user-form"
  }, [_c('span', {
    on: {
      "click": function (e) { return _vm.show != _vm.show; }
    }
  }, [_c('span', {
    staticClass: "user-view__collapse-btn"
  }, [_c('collapse-arrows', {
    attrs: {
      "down": !_vm.show
    },
    nativeOn: {
      "click": function($event) {
        return (function (e) { return (_vm.show = !_vm.show); }).apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "user-view__form_label"
  }, [_vm._v("Create User Form")])], 1)]), _vm._v(" "), (_vm.show) ? _c('user-form') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "user-view__user-list"
  }, [_c('user-list', {
    attrs: {
      "copiedUserList": _vm.copiedUserList,
      "rolesList": _vm.rolesList
    }
  })], 1), _vm._v(" "), _c('action-modal', {
    ref: "deleteUserModal",
    attrs: {
      "buttonText": "Delete",
      "object": _vm.userToDelete
    },
    on: {
      "click": function($event) {
        return _vm.deleteUser()
      }
    }
  }, [_vm._v("\n    Are you sure you want to delete user\n    "), _c('span', {
    staticClass: "delete-target-modal__delete-target-name"
  }, [_vm._v("\n      " + _vm._s(this.userToDelete.first_name) + " " + _vm._s(this.userToDelete.last_name) + "\n    ")])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.readonly,
      "label": "Demo ID",
      "rules": _vm.demoIdRules,
      "hide-details": "auto"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    key: _vm.operator.definitionId,
    staticClass: "definition-operator operator-icon",
    class: [_vm.levelClass, {
      'cant-drop-here': !_vm.canDropHere,
      'not-editable': _vm.thisPartIsInACountGroup
    }],
    attrs: {
      "disabled": _vm.disableDefinitionPart,
      "draggable": false
    },
    on: {
      "dblclick": function($event) {
        return _vm.editOperator($event)
      },
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler
    }
  }, [_c('svg-icon', {
    class: _vm.operatorConfig.icon.class,
    attrs: {
      "icon": _vm.operatorConfig.icon.svg,
      "width": _vm.operatorConfig.icon.width,
      "height": _vm.operatorConfig.icon.height
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumbs"
  }, _vm._l((_vm.crumbs), function(crumb, index) {
    return _c('li', {
      staticClass: "breadcrumbs__crumb"
    }, [(index == 0) ? _c('svg-icon', {
      staticClass: "breadcrumbs__home-icon",
      attrs: {
        "icon": _vm.homeOutline,
        "width": 16,
        "height": 16
      },
      nativeOn: {
        "click": function($event) {
          return _vm.crumbClickHandler(crumb, index)
        }
      }
    }) : _c('span', {
      staticClass: "breadcrumbs__name",
      on: {
        "click": function($event) {
          return _vm.crumbClickHandler(crumb, index)
        }
      }
    }, [_vm._v(_vm._s(crumb.name))]), _vm._v(" "), (_vm.hasSeparator(index)) ? _c('svg-icon', {
      staticClass: "breadcrumbs__separator",
      attrs: {
        "icon": _vm.arrow,
        "width": 5,
        "height": 8
      }
    }) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('single-stepper-range', {
    attrs: {
      "attribute": _vm.attribute
    },
    on: {
      "select": _vm.selectAttribute
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hidePage) ? _c('div', [_c('h1', [_vm._v("Audience Matters Automatic Login Page")]), _vm._v(" "), _c('div', [_vm._v("\n    if you see this page, please contact the Audience Matters Developer team.\n    \n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-item",
    class: {
      'is-selected': _vm.isSelected,
      'has-children': _vm.hasChildren,
      'has-path': _vm.hasPath
    },
    attrs: {
      "title": _vm.titleAttribute
    }
  }, [(_vm.path) ? _c('small-text', [_vm._v(_vm._s(_vm.path))]) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "name"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.hasChildren) ? _c('svg-icon', {
    staticClass: "panel-item__arrow",
    attrs: {
      "icon": _vm.arrow,
      "width": 8,
      "height": 13
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('operator-selector', {
    attrs: {
      "enableNot": _vm.enableNot,
      "enableMinus": _vm.enableMinus
    },
    on: {
      "select": _vm.selectOperator
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('feedback-modal', {
    ref: "feedbackModal",
    staticClass: "target-modal",
    on: {
      "dismiss": _vm.emitDismiss
    }
  }, [_c('div', {
    staticClass: "target-modal__message"
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}

/***/ }),
/* 1911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-size"
  }, [(_vm.displaySize || _vm.displaySize === 0) ? [_c('svg-icon', {
    attrs: {
      "icon": _vm.audience,
      "width": 56,
      "height": 33
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("truncateAmount")(_vm.displaySize)))]), _vm._v(" "), _c('p', [_vm._v("Target Audience")]), _vm._v(" "), _c('viewership-time-frame')] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-popover', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "currentValue": _vm.attribute.value,
      "align": "center",
      "list": _vm.list
    },
    on: {
      "select": _vm.selectOption
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifiction-bell-point"
  }, [_c('span', {
    class: {
      'notifiction-bell-point__text-align': true,
      'notifiction-bell-point__text-align__color': _vm.newNotificationCount > 0
    },
    on: {
      "click": _vm.showNotificationsClickEvent
    }
  }, [_vm._v("\n    " + _vm._s(_vm.newNotificationCount) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "notifiction-bell-point__bell-dot",
    on: {
      "click": _vm.showNotificationsClickEvent
    }
  }, [_c('icon', {
    staticClass: "notifiction-bell-point__bell-outline",
    attrs: {
      "name": "bell",
      "scale": "1.3"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    attrs: {
      "label": _vm.attributePanel ? '' : _vm.label,
      "dark": _vm.attributePanel,
      "filled": _vm.filled,
      "outlined": !_vm.filled,
      "disabled": _vm.disabled && !_vm.filled,
      "dense": "",
      "clearable": !_vm.disabled,
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "Value",
      "readonly": _vm.disabled,
      "search-input": _vm.search,
      "return-object": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.update(val); },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('notification-bell', {
    attrs: {
      "notifications": _vm.userNotifications,
      "deleteNotificationFunc": _vm.deleteNotification,
      "actionEngine": _vm.engine
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    staticClass: "date-picker-popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('date-picker', {
    attrs: {
      "not-before": _vm.notBefore,
      "not-after": _vm.notAfter,
      "lang": "en",
      "range": "",
      "confirm": ""
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('popover-checkmark-btn', {
    attrs: {
      "disabled": _vm.isInvalid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAttribute.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    key: _vm.operator.definitionId,
    staticClass: "definition-operator operator-icon",
    class: [_vm.levelClass, {
      'cant-drop-here': !_vm.canDropHere,
      'not-editable': _vm.thisPartIsInACountGroup
    }],
    attrs: {
      "disabled": _vm.disableDefinitionPart,
      "draggable": false
    },
    on: {
      "dblclick": function($event) {
        return _vm.editOperator($event)
      },
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler
    }
  }, [_c('svg-icon', {
    class: _vm.operatorConfig.icon.class,
    attrs: {
      "icon": _vm.operatorConfig.icon.svg,
      "width": _vm.operatorConfig.icon.width,
      "height": _vm.operatorConfig.icon.height
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('action-modal', {
    ref: "modal",
    attrs: {
      "object": _vm.currentTarget,
      "buttonText": "Delete"
    },
    on: {
      "click": _vm.deleteTarget
    }
  }, [_vm._v("\n  Are you sure you want to delete target\n  "), _c('span', {
    staticClass: "delete-target-modal__delete-target-name",
    attrs: {
      "title": _vm.currentTarget.display_name
    }
  }, [_vm._v("\n     " + _vm._s(_vm.currentTarget.display_name) + "?\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [(_vm.isAddressable) ? _c('div', {
    staticClass: "tooltip-container",
    style: (_vm.cssProps)
  }, [_c('div', {
    staticClass: "tooltip-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "status-bar"
  }, [_c('ul', [_c('li', {
    class: {
      complete: _vm.isPlanned,
      planning: _vm.isPlanning
    }
  }, [_vm._v(_vm._s(_vm.planningText) + "\n          "), _c('div', {
    class: {
      'progress-line': true,
      complete: _vm.isPlanned
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      complete: _vm.isOrdered
    }
  }, [_vm._v(_vm._s(_vm.orderingText))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.confirmDeleteUser
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "grey darken-4"
    }
  }, [_vm._v("mdi-delete")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumbs"
  }, _vm._l((_vm.crumbs), function(crumb, index) {
    return _c('li', {
      staticClass: "breadcrumbs__crumb"
    }, [(index == 0) ? _c('svg-icon', {
      staticClass: "breadcrumbs__home-icon",
      attrs: {
        "icon": _vm.homeOutline,
        "width": 16,
        "height": 16
      },
      nativeOn: {
        "click": function($event) {
          return _vm.crumbClickHandler(crumb, index)
        }
      }
    }) : _c('span', {
      staticClass: "breadcrumbs__name",
      on: {
        "click": function($event) {
          return _vm.crumbClickHandler(crumb, index)
        }
      }
    }, [_vm._v(_vm._s(crumb.name))]), _vm._v(" "), (_vm.hasSeparator(index)) ? _c('svg-icon', {
      staticClass: "breadcrumbs__separator",
      attrs: {
        "icon": _vm.arrow,
        "width": 5,
        "height": 8
      }
    }) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewership-time-frame"
  }, [_c('div', {
    staticClass: "viewership-time-frame__label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "viewership-time-frame__value",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedText) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('target-form-styles', {
    staticClass: "appending_file_uploader__form"
  }, [_c('div', {
    staticClass: "appending_file_uploader__header"
  }, [_vm._v("\n    Choose a target to append a file to\n  ")]), _vm._v(" "), _c('upload-target-radio-buttons', {
    staticClass: "appending_file_uploader__target-selection",
    attrs: {
      "on-select": _vm.selectTargetType
    },
    model: {
      value: (_vm.targetTypeSelected),
      callback: function($$v) {
        _vm.targetTypeSelected = $$v
      },
      expression: "targetTypeSelected"
    }
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('target-d-d-l', {
    ref: "targetDDL",
    attrs: {
      "targetType": _vm.targetType,
      "initialValue": _vm.target
    },
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [(_vm.isPid) ? _c('v-file-input', {
    ref: "fileUploadInput",
    attrs: {
      "accept": _vm.uploadFileOptions,
      "disabled": _vm.isUploadDisabled,
      "placeholder": "No file chosen",
      "prepend-icon": "mdi-microsoft-excel"
    },
    on: {
      "change": _vm.onFileChange
    },
    model: {
      value: (_vm.uploadedFile),
      callback: function($$v) {
        _vm.uploadedFile = $$v
      },
      expression: "uploadedFile"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.buttonClickable,
      "color": "secondary",
      "id": "appendFileModalUploadBtn",
      "label": "upload"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitHandler.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "admin-view"
  }, [_c('permissions-header', {
    attrs: {
      "title": _vm.routeName
    }
  }), _vm._v(" "), _c('router-view')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workbench"
  }, [_c('div', {
    staticClass: "workbench__canvas",
    attrs: {
      "id": "canvas"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "workbench__loader"
  }, [_c('loader-dots')], 1) : _vm._e(), _vm._v(" "), _c('scroll-panel', {
    staticClass: "workbench__canvas-content"
  }, [_c('workbench-row', {
    ref: "viewership",
    staticClass: "workbench__canvas__las",
    style: ({
      height: _vm.viewershipRowHeight
    })
  }, [_c('audience-size', {
    staticClass: "workbench__audience workbench__canvas-block",
    attrs: {
      "validStreamingOptions": _vm.validStreamingOptions,
      "size": _vm.audienceSize,
      "onSelectedViewingStream": _vm.onSelectedViewingStream,
      "viewershipOption": _vm.viewership
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas-block workbench__viewership"
  }, [_c('viewership', {
    attrs: {
      "networks": _vm.networks,
      "selectedNetworks": _vm.selectedViewershipNetworks,
      "selectedDayPartNetworks": _vm.selectedDayPartNetworks,
      "viewership-data": _vm.viewershipData
    }
  })], 1)], 1), _vm._v(" "), (_vm.selectedDayPartNetworks.length > 0) ? _c('workbench-row', [_c('day-parts', {
    attrs: {
      "selectedNetworks": _vm.selectedDayPartNetworks,
      "viewershipData": _vm.viewershipData,
      "networks": _vm.networks,
      "dayPartsConfig": _vm.dayPartsCofig
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('workbench-row', {
    ref: "universe",
    staticClass: "workbench__universe",
    style: ({
      height: _vm.universeRowHeight
    })
  }, [_c('universe-stability', {
    staticClass: "workbench__canvas-block",
    attrs: {
      "universe": _vm.universeData
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-market-demo"
  }, [_c('div', {
    staticClass: "select-market-demo__selection-area"
  }, [_c('h5', {
    staticClass: "center"
  }, [_vm._v("Current Uploaded Market Demos Selection: " + _vm._s(_vm.fileUploaded))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [(_vm.isNpower) ? _c('th', {
    staticClass: "market-break"
  }, [_vm._v("Market Break")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "demo"
  }, [_vm._v("Demographic")]), _vm._v(" "), _c('th', [_vm._v("Target Audience")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.marketDemoOptions), function(md) {
    return _c('tr', [(_vm.isNpower) ? _c('td', [_c('span', [_vm._v(_vm._s(md.marketBreak))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.demographic))])]), _vm._v(" "), _c('td', {
      staticClass: "center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (md.isSelected),
        expression: "md.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(md.isSelected) ? _vm._i(md.isSelected, null) > -1 : (md.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = md.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(md, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(md, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(md, "isSelected", $$c)
          }
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "select-market-demo__results-area"
  }, [_c('span', [_vm._v("DATA TO UPLOAD")]), _vm._v(" "), (_vm.hasDataCollisions) ? _c('div', {
    staticClass: "select-market-demo__error"
  }, [_c('icon', {
    attrs: {
      "name": "times-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])], 1) : _vm._e(), _vm._v(" "), (_vm.hasOverwrites) ? _c('div', {
    staticClass: "select-market-demo__warning"
  }, [_c('icon', {
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.overwriteCount.toLocaleString()))]), _vm._v(_vm._s(_vm.warningMessage))])], 1) : _vm._e(), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [(_vm.isNpower) ? _c('th', {
    staticClass: "market-break"
  }, [_vm._v("Market Break")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "demo"
  }, [_vm._v("Demographic")]), _vm._v(" "), _c('th', [_vm._v("Average UE (000)")]), _vm._v(" "), _c('th', [_vm._v("New Records")]), _vm._v(" "), _c('th', [_vm._v("Existing Records")]), _vm._v(" "), _c('th', [_vm._v("% of Complete Half Hours")]), _vm._v(" "), _c('th', [_vm._v("Network")]), _vm._v(" "), _c('th', [_vm._v("Quarter")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.marketDemoSegments), function(md) {
    return _c('tr', [(_vm.isNpower) ? _c('td', [_c('span', [_vm._v(_vm._s(md.MarketBreak))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.Demographic))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(Math.floor(md.AverageUEs / 1000).toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.NumberOfRecords.toLocaleString()))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.existingQuarterNetworks[md.NetworkName + md.QuarterName] || 0))]), _vm._v(" "), (_vm.existingQuarterNetworks[md.NetworkName + md.QuarterName]) ? _c('icon', {
      staticClass: "select-market-demo__warning",
      attrs: {
        "name": "warning"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.getRecordCompletionPercent(md.NumberOfRecords, md.NumberOfExpectedRecords)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.NetworkName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(md.QuarterName))])]), _vm._v(" "), (_vm.selectedQuarterNetworks[md.NetworkName + md.QuarterName].length > 1) ? _c('td', {
      staticClass: "select-market-demo__error"
    }, [_c('icon', {
      attrs: {
        "name": "times-circle"
      }
    })], 1) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "select-market-demo__upload-segments center"
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.allowUpload,
      "label": "Upload Segments",
      "color": "success",
      "id": "uploadSegmentsBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadSegments.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-market-demo__note-area"
  }, [_c('span', [_vm._v("NOTE: Audience must have 12 months of data & must be sent downstream from the dashboard")])])
}]}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "permissions-category-upsert"
  }, [_c('permissions-table')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-arrow-nav",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg-icon', {
    staticClass: "back-arrow-nav__arrow",
    attrs: {
      "icon": _vm.backArrowIcon,
      "height": 40,
      "width": 40
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "back-arrow-nav__message"
  }, [_vm._v("Back")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finish-step"
  }, [(_vm.isPidListOrNPower) ? _c('upload-target-slot', {
    attrs: {
      "onComplete": _vm.finishOnComplete
    },
    on: {
      "submittedUploadFile": _vm.setOverrideBackButton
    }
  }) : (_vm.isAudienceDiscovery) ? _c('a-d-slot', {
    attrs: {
      "targetName": _vm.targetName,
      "onComplete": _vm.finishOnComplete,
      "title": _vm.title,
      "dataSourceIcon": _vm.dataSourceIcon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insights"
  }, [_c('div', {
    staticClass: "insights__tabs"
  }, [_c('div', {
    staticClass: "insights__headerRow"
  }, [_c('div', {
    staticClass: "insights__headerRow__tabName"
  }, [_vm._v(_vm._s(_vm.insightsHeaderText))]), _vm._v(" "), _c('div', {
    staticClass: "insights__headerRow__audienceExpansion"
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "hide-details": "",
      "dense": "",
      "inset": "",
      "disabled": _vm.viewOnly || !_vm.allowAudienceExpansionToggle
    },
    on: {
      "change": _vm.onAudienceExpansionToggle
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticClass: "audience-expansion-label",
          class: {
            'audience-expansion-label--active': _vm.audienceExpansion
          }
        }, [_vm._v("\n              Audience Expansion\n            ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.audienceExpansion),
      callback: function($$v) {
        _vm.audienceExpansion = $$v
      },
      expression: "audienceExpansion"
    }
  })], 1)]), _vm._v(" "), _c('scroll-panel', {
    staticClass: "insights__tabular-area"
  }, [_c('primary', {
    attrs: {
      "primaryInsights": _vm.workbenchSlottedValue || undefined,
      "loadingInsights": _vm.loadingInsights,
      "loadingWorkbench": _vm.loadingWorkbench
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "insights__tabs__insightButtonRow"
  }, [_c('interactive-simple-button', {
    attrs: {
      "disabled": _vm.disableUpdateInsights,
      "label": _vm.buttonText
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateInsights.apply(null, arguments)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quick-add-attributes"
  }, _vm._l((_vm.quickAddAttributes), function(attribute) {
    return _c('button', {
      key: attribute.id,
      ref: "button",
      refInFor: true,
      class: {
        'is-active': _vm.isActive(attribute)
      },
      on: {
        "click": function($event) {
          return _vm.attributeClickedHandler(attribute, $event)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getPrettyName(attribute)) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    key: _vm.attribute.definitionId,
    staticClass: "definition-node",
    class: [{
      'selected': _vm.isSelected,
      'in-group': _vm.inGroup,
      'is-first': _vm.isFirst,
      'is-last': _vm.isLast,
      'is-removed': _vm.attribute.removed,
      'cant-drop-here': !_vm.canDropHere,
    }, _vm.levelClass],
    attrs: {
      "disabled": _vm.disableDefinitionPart,
      "draggable": _vm.isDraggable && !_vm.thisPartIsInACountGroup
    },
    domProps: {
      "innerHTML": _vm._s(_vm.displayName)
    },
    on: {
      "click": _vm.clickHandler,
      "dblclick": function($event) {
        return _vm.editAttribute($event)
      },
      "dragstart": _vm.dragStartHandler,
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler,
      "mouseover": _vm.showUEHoverOver,
      "mouseout": _vm.hideUEHoverOver
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "positive-indicator"
  }, [_c('div', [(_vm.isPositive) ? _c('icon', {
    staticClass: "positive-indicator__plus",
    attrs: {
      "name": "plus",
      "scale": "1"
    }
  }) : (_vm.isNegative) ? _c('icon', {
    staticClass: "positive-indicator__minus",
    attrs: {
      "name": "minus",
      "scale": "1"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'positive-indicator__number': true,
      'positive-indicator__number__positive': _vm.isPositive,
      'positive-indicator__number__negative': _vm.isNegative,
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('action-button', {
    attrs: {
      "dark": !_vm.buttonSelectedTopLevel,
      "color": "success",
      "label": "Show Top Level Events for each target"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setButtonTopLevel.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "dark": !_vm.buttonSelectedAllEvents,
      "label": "Show All Events",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setButtonAllEvents.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "dark": !_vm.buttonSelectedOneTarget,
      "disabled": !_vm.hasSelectedTarget,
      "label": "Show Events of a Target",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setButtonOneTarget.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTarget),
      expression: "selectedTarget"
    }],
    domProps: {
      "value": (_vm.selectedTarget)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedTarget = $event.target.value
      }
    }
  }), _vm._v(" "), _c('datepicker', {
    attrs: {
      "lang": "eng",
      "value": _vm.selectedDate,
      "not-after": _vm.todaysDate,
      "clear": function (e) { return _vm.changeTo(null); },
      "input-class": "mx-input date-from-to__datepicker-input"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.eventTypes), function(eventSpace) {
    return [(_vm.events[eventSpace.event] && _vm.events[eventSpace.event].length > 0) ? _c('div', {
      key: eventSpace.event,
      staticStyle: {
        "width": "1010px",
        "height": "300px"
      }
    }, [_c('h1', [_vm._v(_vm._s(eventSpace.name))]), _vm._v(" "), _c('ag-grid-vue', {
      staticClass: "ag-theme-balham",
      staticStyle: {
        "width": "1010px",
        "height": "200px"
      },
      attrs: {
        "rowData": _vm.events[eventSpace.event],
        "columnDefs": _vm.columnDef
      }
    })], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", function() {
    return [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
      return _c('path', _vm._b({
        key: ("path-" + i)
      }, 'path', path, false))
    }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
      return _c('polygon', _vm._b({
        key: ("polygon-" + i)
      }, 'polygon', polygon, false))
    }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
      domProps: {
        "innerHTML": _vm._s(_vm.raw)
      }
    })] : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "true",
      "label": "Frequency",
      "id": "frequency_ddl"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-set",
    staticStyle: {
      "width": "100%",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "6px 6px 0 6px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "ag-input-field-input ag-text-field-input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "keyup": [function($event) {
        return _vm.updateVisibleGroups()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterOnFirstResult()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.visibleGroups.length > 0) ? _c('div', {
    class: {
      isChecked: _vm.selectAll,
    },
    staticStyle: {
      "align-items": "center",
      "height": "100%",
      "line-height": "normal",
      "font-size": "14px"
    },
    attrs: {
      "id": "search-set-select-all"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllFilterGroups()
      }
    }
  }, [_c('input', {
    staticStyle: {
      "margin": "6px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox",
      "disabled": _vm.selectAll
    },
    domProps: {
      "checked": _vm.selectAll,
      "indeterminate": _vm.indeterminate
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(" (Select All) ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0px",
      "height": "1px",
      "border-width": "0",
      "color": "lightgray",
      "background-color": "lightgray"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.visibleGroups.length > 0) ? [_vm._l((_vm.visibleGroups), function(value) {
    return [_c('div', {
      key: value.name,
      staticClass: "search-set-filter-checkbox",
      on: {
        "click": function (e) {
          _vm.onClickIndividualFilter(value.name)
        }
      }
    }, [_c('input', {
      staticStyle: {
        "margin": "6px",
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "input": value.checked
      },
      domProps: {
        "checked": value.checked
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v("\n          " + _vm._s(value.name) + "\n        ")])])]
  })] : _vm._e(), _vm._v(" "), (_vm.visibleGroups.length === 0) ? _c('div', {
    staticStyle: {
      "margin": "6px"
    }
  }, [_c('label', [_vm._v("No Results Found")])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('stepper-range', {
    attrs: {
      "attribute": _vm.attribute
    },
    on: {
      "select": _vm.selectAttribute
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.groupDisable || _vm.isDragAndDropActive,
      "title": "Group (g)"
    },
    on: {
      "click": _vm.groupAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__group",
      "icon": _vm.group,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.ungroupDisable || _vm.isDragAndDropActive,
      "title": "Ungroup (u)"
    },
    on: {
      "click": _vm.ungroupAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__ungroup",
      "icon": _vm.ungroup,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.countGroupDisable || _vm.isDragAndDropActive
    },
    on: {
      "click": _vm.countGroupHandler
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.countGroupIcon,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.isDragAndDropActive
    },
    attrs: {
      "title": "Drag and drop mode"
    },
    on: {
      "click": _vm.dragAndDropModeToggle
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__arrows",
      "icon": _vm.arrows
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.deleteDisable || _vm.isDragAndDropActive,
      "title": "Delete (Delete/Backspace)"
    },
    on: {
      "click": _vm.deleteAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__trash",
      "icon": _vm.trash,
      "width": 15,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.isDragAndDropActive
    },
    attrs: {
      "title": "History"
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__history",
      "icon": _vm.history
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "toggle-button",
    class: [_vm.toggleState],
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "toggle-button__left-label"
  }, [_vm._v(_vm._s(_vm.leftLabel))]), _vm._v(" "), _c('span', {
    staticClass: "toggle-button__right-label"
  }, [_vm._v(_vm._s(_vm.rightLabel))]), _vm._v(" "), _c('span', {
    staticClass: "toggle-button__selection"
  })])
},staticRenderFns: []}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insights_secondary"
  }, [_c('div', {
    staticClass: "insightCards"
  }, [_c('div', {
    staticClass: "topRowCards"
  }, [_c('div', {
    staticClass: "xsCard xsLong"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer"
  }, [_c('div', {
    staticClass: "viewershipGraphContainer__graph"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__rows"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.viewership.slice(0, 5)), function(v, index) {
    return _c('div', {
      key: v.id,
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail"
    }, [_c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem blue"
    }, [_vm._v(_vm._s(v.network))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.comp))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.reach))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.indexVal))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__rows"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.viewership.slice(5)), function(v, index) {
    return _c('div', {
      key: v.id,
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail"
    }, [_c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem blue"
    }, [_vm._v(_vm._s(v.network))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.comp))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.reach))]), _vm._v(" "), _c('div', {
      staticClass: "viewershipGraphContainer__graph__right__rows__rowDetail__rowItem"
    }, [_vm._v(_vm._s(v.indexVal))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottomRowCards"
  }, [_c('div', {
    staticClass: "xsCard xsShort"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v("Digital Affinities")]), _vm._v(" "), _c('div', {
    staticClass: "digitalAffinities"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "digitalAffinities__rows"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.digitalAffinities), function(da) {
    return _c('div', {
      key: da.property,
      staticClass: "digitalAffinities__rows__rowDetail"
    }, [_c('div', {
      staticClass: "rowItem"
    }, [_vm._v(_vm._s(da.property))]), _vm._v(" "), _c('div', {
      staticClass: "rowItem"
    }, [_vm._v(_vm._s(_vm.formattedCount(da.monthlyUnique)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "xsCard xsShort"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v("OTS Segment Affinities")]), _vm._v(" "), _c('div', {
    staticClass: "otsSegmentAffinities"
  }, _vm._l((_vm.secondaryInsightViewershipMockData.segmentAffinities), function(sa) {
    return _c('div', {
      key: sa.segment,
      staticClass: "otsSegmentAffinities__row"
    }, [_c('div', {
      staticClass: "otsSegmentAffinities__row__value"
    }, [_vm._v(_vm._s(sa.value) + "  - ")]), _vm._v(" "), _c('div', {
      staticClass: "otsSegmentAffinities__row__segmentName"
    }, [_vm._v(_vm._s(sa.segment))])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card__titleRow"
  }, [_c('div', {
    staticClass: "card__titleRow__name"
  }, [_vm._v("Viewership")]), _vm._v(" "), _c('div', {
    staticClass: "card__titleRow__button"
  }, [_c('div', {
    staticClass: "card__titleRow__button__text"
  }, [_vm._v("Networks")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers"
  }, [_c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__index"
  }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Network")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Comp")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Reach")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__headers__headerItem"
  }, [_vm._v("Index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers"
  }, [_c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__index"
  }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Network")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Comp")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Reach")]), _vm._v(" "), _c('div', {
    staticClass: "viewershipGraphContainer__graph__right__headers__headerItem"
  }, [_vm._v("Index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "digitalAffinities__headers"
  }, [_c('div', {
    staticClass: "headerItem"
  }, [_vm._v("Property")]), _vm._v(" "), _c('div', {
    staticClass: "headerItem"
  }, [_vm._v("Uniques/Month")])])
}]}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepper-range"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.min),
      expression: "min",
      arg: "value"
    }],
    ref: "startInput",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "min": _vm.range.min,
      "max": _vm.range.max,
      "step": "1"
    },
    domProps: {
      "value": (_vm.min)
    },
    on: {
      "keyup": _vm.handleEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.min = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "stepper-range__divider"
  }, [_vm._v("to:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.max),
      expression: "max",
      arg: "value"
    }],
    ref: "endInput",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "min": _vm.range.min,
      "max": _vm.range.max,
      "step": "1"
    },
    domProps: {
      "value": (_vm.max)
    },
    on: {
      "keyup": _vm.handleEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.max = $event.target.value
      }
    }
  }), _vm._v(" "), _c('popover-checkmark-btn', {
    attrs: {
      "disabled": _vm.incorrectValue
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    class: {
      'placeholder-not-showing': !_vm.showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': _vm.isDisabled,
      'vue-select__medium': _vm.isMedium
    },
    attrs: {
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "value": _vm.fullValue,
      "multiple": false,
      "clear-on-select": false,
      "hide-selected": true,
      "label": _vm.label,
      "track-by": "name",
      "debounce": 250,
      "disabled": _vm.isDisabled,
      "on-search": _vm.searchOptions,
      "loading": _vm.loading,
      "clearable": _vm.isClearable,
      "noDrop": _vm.options.length === 1 || !_vm.clearable
    },
    on: {
      "input": _vm.emitInput,
      "search:focus": _vm.checkPosition,
      "search:blur": _vm.clearOptionsIfEmpty
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "confirm",
    attrs: {
      "width": 500
    }
  }, [_c('div', {
    staticClass: "confirmation-modal-text"
  }, [_vm._v("\n    You have unsaved changes on your target.\n    Are you sure you would like to disregard your changes?\n  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('v-btn', {
    attrs: {
      "id": "confirmSaveBtn",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelHandler.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveButton))]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "id": "confirmGoToDashboardBtn",
      "color": "light-blue lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueHandler.apply(null, arguments)
      }
    }
  }, [_vm._v("Continue to Dashboard")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-hub-dashboard-header"
  }, [_c('v-row', {
    staticClass: "audience-hub-dashboard-header__title-area"
  }, [_c('v-col', {
    staticClass: "audience-hub-dashboard-header__title"
  }, [_c('v-img', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "max-width": "32",
      "src": _vm.amHeader()
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_vm._v("Audience Matters")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "audience-hub-dashboard-header__right-area"
  }, [(_vm.showUserProfile) ? _c('span', {
    staticClass: "audience-hub-dashboard-header__user-profile"
  }, [_vm._v("\n        " + _vm._s(_vm.userRoles) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('new-item-menu', {
    staticClass: "audience-hub-dashboard-header__new-item",
    on: {
      "select": function (val) { return _vm.handleNewItemMenuClick(val); }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "audience-hub-dashboard-header__notifications"
  }, [_c('audience-matters-notifications')], 1), _vm._v(" "), _c('span', {
    staticClass: "audience-hub-dashboard-header__username",
    class: {
      headerMenuClickable: _vm.doesUserHaveAdminPermissions
    },
    on: {
      "click": _vm.expandHeaderMenu
    }
  }, [_vm._v("\n        " + _vm._s(_vm.username) + "\n      ")])])], 1), _vm._v(" "), _c('stepper-modal'), _vm._v(" "), _c('send-downstream', {
    ref: "sendDownstreamModal",
    attrs: {
      "value": _vm.initialTargetCopy
    }
  }), _vm._v(" "), _c('request-video-amp-segment', {
    model: {
      value: (_vm.isRequestVideoAmpSegmentDialogOpen),
      callback: function($$v) {
        _vm.isRequestVideoAmpSegmentDialogOpen = $$v
      },
      expression: "isRequestVideoAmpSegmentDialogOpen"
    }
  }), _vm._v(" "), _c('retargeting-request', {
    model: {
      value: (_vm.isRetargetingRequestDialogOpen),
      callback: function($$v) {
        _vm.isRetargetingRequestDialogOpen = $$v
      },
      expression: "isRetargetingRequestDialogOpen"
    }
  }), _vm._v(" "), [_c('modal', {
    ref: "modal",
    attrs: {
      "title": "Select Intent",
      "width": 500,
      "closeButton": "",
      "hideActions": ""
    }
  }, [
    [_c('div', {
      staticClass: "audience-hub-dashboard-header__select-intent-actions"
    }, [(_vm.intents.some(function (v) { return v === _vm.Sales; })) ? _c('action-button', {
      attrs: {
        "dark": "",
        "label": "Sales",
        "color": "primary",
        "id": "salesIntent"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.intentSelected(_vm.Sales)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.intents.some(function (v) { return v === _vm.Marketing; })) ? _c('action-button', {
      attrs: {
        "dark": "",
        "label": "Marketing",
        "color": "primary",
        "id": "marketingIntent"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.intentSelected(_vm.Marketing)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.intents.some(function (v) { return v === _vm.Research; })) ? _c('action-button', {
      attrs: {
        "dark": "",
        "label": "Research",
        "color": "primary",
        "id": "researchIntent"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.intentSelected(_vm.Research)
        }
      }
    }) : _vm._e()], 1)]
  ], 2)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "positive-circle",
    style: (_vm.sizeStyle)
  }, [_c('icon', {
    staticClass: "positive-circle__plus",
    attrs: {
      "name": "plus",
      "scale": _vm.scale
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-distribution-area"
  }, [_c('div', {
    staticClass: "graph-distribution-area__income-graph"
  }, [_c('pull-down-button', {
    ref: "button1",
    attrs: {
      "text": _vm.incomeGraphText,
      "width": _vm.widthOfGraph
    }
  }, [_c('income-graph', {
    attrs: {
      "data": _vm.incomeData
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-distribution-area__age-market-breakers-graph"
  }, [_c('pull-down-button', {
    ref: "button2",
    attrs: {
      "text": _vm.ageGraphText,
      "width": _vm.widthOfGraph
    }
  }, [_c('age-market-breaker-graph', {
    attrs: {
      "data": _vm.ageMarketBreakerData,
      "meanAge": _vm.meanAge
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-distribution-area__age-distribution-graph"
  }, [_c('pull-down-button', {
    ref: "button3",
    attrs: {
      "text": _vm.ageDistributionText,
      "width": _vm.widthOfGraph
    }
  }, [_c('age-distribution-graph', {
    attrs: {
      "data": _vm.ageData,
      "meanAge": _vm.meanAge
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('radio-buttons', {
    attrs: {
      "value": _vm.value,
      "options": _vm.targetTypes,
      "on-select": _vm.onSelect,
      "disabled": _vm.disabled
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-list"
  }, [_c('span', {
    staticClass: "panel-list__name"
  }, [_vm._v(_vm._s(_vm.listGroup.model.name))]), _vm._v(" "), _c('div', {
    staticClass: "panel-list__items-wrap"
  }, [(_vm.scrollable) ? [_c('virtual-list', {
    ref: "virtualList",
    attrs: {
      "is-pinned": true,
      "size": 42,
      "remain": 12,
      "data-source": _vm.listGroup.children
    }
  }, _vm._l((_vm.listGroup.children), function(item) {
    return _c('panel-item', {
      key: item.model.id,
      ref: "item",
      refInFor: true,
      attrs: {
        "is-selected": _vm.currentSelectedItem == item,
        "name": item.model.name,
        "has-children": item.hasChildren()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem(item, $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.model.name)
      }
    })])
  }), 1)] : _vm._l((_vm.listGroup.children), function(item) {
    return _c('panel-item', {
      key: item.model.id,
      ref: "item",
      refInFor: true,
      attrs: {
        "is-selected": _vm.currentSelectedItem == item,
        "name": item.model.name,
        "path": item.model.path,
        "has-children": item.hasChildren()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectItem(item, $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.model.name)
      }
    })])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepper-range"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.count),
      expression: "count",
      arg: "value"
    }],
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "min": _vm.range.min,
      "max": _vm.range.max,
      "step": "1"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "keyup": _vm.handleEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "stepper-range__submit-button",
    attrs: {
      "disabled": _vm.incorrectValue
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('svg-icon', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "icon": _vm.Check
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    class: {
      'notification__info-border': _vm.isInfo,
      'notification__success-border': _vm.isSuccess,
      'notification__warning-border': _vm.isWarning,
      'notification__error-border': _vm.isError
    }
  }, [_c('span', [_c('notification-icon', {
    staticClass: "notification__icon",
    attrs: {
      "notification": _vm.notification
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "notification__button"
  }, [_c('icon', {
    attrs: {
      "name": "times-circle",
      "scale": "1.4"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteNotification.apply(null, arguments)
      }
    }
  })], 1), _vm._v("\n    " + _vm._s(_vm.notification.description) + "\n  ")]), _vm._v(" "), (_vm.action) ? [_c('div', {
    staticClass: "notification__action-block"
  }, [_c('oval-button', {
    staticClass: "notification__action",
    nativeOn: {
      "click": function($event) {
        return _vm.actionCommand.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.action.title) + "\n      ")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    class: {
      'placeholder-not-showing': !_vm.showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': _vm.disabled,
      'vue-select__medium': _vm.isMedium
    },
    attrs: {
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "multiple": false,
      "clear-on-select": false,
      "hide-selected": true,
      "label": _vm.label,
      "track-by": "name",
      "debounce": 250,
      "disabled": _vm.disabled,
      "on-search": _vm.searchOptions,
      "getOptionLabel": _vm.getOptionLabel
    },
    on: {
      "search:focus": _vm.checkPosition,
      "search:blur": _vm.clearOptionsIfEmpty
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "basic-modal"
  }, [_c('div', {
    ref: "container",
    staticClass: "basic-modal__container",
    style: (_vm.modalStyle)
  }, [(_vm.enableCloseButton) ? [_c('div', {
    staticClass: "basic-modal__close-btn",
    on: {
      "click": _vm.clickedExit
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.cancel,
      "width": 12,
      "height": 12
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "destination-container",
    style: ({
      'min-width': _vm.minWidth
    })
  }, [_c('img', {
    staticClass: "destination-icon",
    class: {
      'destination-icon_clickable': !_vm.canUpdate
    },
    attrs: {
      "src": _vm.destinationImage
    },
    on: {
      "click": function($event) {
        return _vm.$emit('selectedDestination', _vm.destination)
      },
      "mouseover": _vm.hover,
      "mouseout": _vm.hoverOut
    }
  })]), _vm._v(" "), (_vm.selected && (_vm.canUpdate || _vm.showUE)) ? _c('div', {
    staticClass: "inline"
  }, [(_vm.showPopup) ? _c('div', {
    staticClass: "popover",
    attrs: {
      "transition": "fade"
    },
    on: {
      "mouseover": _vm.hoverOnPopover,
      "mouseout": _vm.hoverOffPopover
    }
  }, [_c('div', {
    staticClass: "popover-text"
  }, [_vm._v(_vm._s(_vm.UEText))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showInput) ? _c('div', {
    staticClass: "inline"
  }, [(_vm.showMRM_ID) ? _c('div', {
    staticClass: "data-input"
  }, [_c('label', [_vm._v("MRM ID:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mrmId),
      expression: "mrmId"
    }],
    staticClass: "mrmId-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mrmId)
    },
    on: {
      "keypress": _vm.validateNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mrmId = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "admin-view"
  }, [_c('login', {
    on: {
      "submit": _vm.submitLogin
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "workbench-toolbar"
  }, [_c('div', {
    staticClass: "workbench-toolbar__info"
  }, [_c('div', {
    staticClass: "workbench-toolbar__info__dashboard",
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "text-button pl-1"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "workbench-toolbar__info__status_destination"
  }, [(_vm.activated && _vm.currentTarget && _vm.currentTarget.display_name) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__target_name"
  }, [_vm._v("\n          " + _vm._s(_vm.currentTarget.display_name) + "  |\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__destination text-overline"
  }, [_vm._v("\n          " + _vm._s(_vm.currentTarget.target_datasource) + "\n        ")]), _vm._v(" "), (_vm.currentTarget && _vm.currentTarget.viewing_stream) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__destination"
  }, [_vm._v("\n          " + _vm._s(_vm.currentTarget.viewing_stream) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.currentTarget && _vm.currentTarget.target_type && _vm.currentTarget.target_type === _vm.audienceDiscoveryTargetType
  ) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__destination"
  }, [_vm._v("\n          Audience Discovery\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.dropped && _vm.currentTarget && _vm.currentTarget.activation_status) ? _c('v-chip', {
    staticClass: "workbench-toolbar__info__status_destination__status",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.currentTarget.activation_status))]) : (_vm.dropped) ? _c('div', {
    staticClass: "workbench-toolbar__info__status_destination__status__dropped",
    on: {
      "click": _vm.clickedDropped
    }
  }, [_vm._v("\n          DROPPED\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('metrics-banner', {
    attrs: {
      "metrics": _vm.metrics,
      "loading": _vm.loading
    }
  })], 1), _vm._v(" "), (_vm.showGraphs) ? [_c('distribution-graph-area', {
    staticClass: "workbench-toolbar__topArea"
  })] : _vm._e(), _vm._v(" "), _c('dropped-attributes-modal')], 2)
},staticRenderFns: []}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results"
  }, [_c('small-text', {
    staticClass: "search-results__count"
  }, [_vm._v(_vm._s(_vm.count) + " Results")]), _vm._v(" "), _c('scroll-panel', [_c('div', {
    staticClass: "search-results__list"
  }, _vm._l((_vm.searchResultsFormatted), function(results) {
    return _c('div', {
      staticClass: "search-results__result-set"
    }, [_c('list', {
      key: results.name,
      attrs: {
        "list-group": results,
        "scrollable": false
      },
      on: {
        "item-selected": _vm.itemSelectedHandler
      }
    }), _vm._v(" "), (_vm.hasNoResults(results)) ? _c('small-text', {
      staticClass: "search-results__no-results",
      attrs: {
        "light": true
      }
    }, [_vm._v("No Results")]) : _vm._e()], 1)
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('svg-icon', {
    staticClass: "login__logo",
    attrs: {
      "icon": _vm.logoIcon,
      "height": 113,
      "width": 231
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "login__loader"
  }, [_c('loader-dots')], 1) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "login__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login__input login__username",
    attrs: {
      "placeholder": "Warner Media Email Address"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login__input login__password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('simple-button', {
    staticClass: "login__simple-button",
    class: _vm.buttonClass,
    attrs: {
      "text": "Sign In",
      "disabled": !_vm.buttonClickable
    }
  }), _vm._v(" "), _c('error-modal', {
    ref: "errorModal",
    attrs: {
      "message": _vm.errorMessage
    },
    on: {
      "dismiss": _vm.clearError
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "justify-center mt-12 flex"
  }, [_c('v-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://login.wbd.com/images/WBDLogo.png"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip"
  }, [_vm._t("default"), _vm._v(" "), (_vm.text) ? _c('span', {
    class: {
      'tooltip__text': true,
      'tooltip__left': _vm.isLeft,
      'tooltip__right': _vm.isRight
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isDestinationBlank) ? _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "start",
      "no-gutters": ""
    }
  }, _vm._l((_vm.params.value), function(destination) {
    return _c('v-col', {
      key: destination,
      staticClass: "pa-1",
      attrs: {
        "cols": "2",
        "sm": "3",
        "md": "7",
        "lg": "5",
        "xl": "2"
      }
    }, [_c('v-img', {
      attrs: {
        "contain": "",
        "src": _vm.destinationImage(destination),
        "aspect-ratio": "1"
      }
    })], 1)
  }), 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('date-from-to', {
    attrs: {
      "label": "Activation Dates",
      "value": {
        from: _vm.value.flightStartDate,
        to: _vm.value.flightEndDate
      },
      "fromNotBeforeDate": _vm.startingFromDate,
      "disableFrom": _vm.startDateDisable,
      "disableTo": _vm.endDateDisable,
      "startToDateFromToday": "",
      "optionSetting": 4
    },
    on: {
      "input": function (val) { return _vm.modifyDates(val); }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-hub-table"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "start",
      "dense": "",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.targetFilterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Targets",
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.onTargetFilterChange
    },
    model: {
      value: (_vm.queryOption),
      callback: function($$v) {
        _vm.queryOption = $$v
      },
      expression: "queryOption"
    }
  })], 1), _vm._v(" "), _c('v-col', _vm._l((_vm.appliedFilters), function(filter) {
    return _c('v-chip', {
      key: filter.name,
      staticClass: "ma-1",
      attrs: {
        "color": "teal",
        "text-color": "white",
        "close": ""
      },
      on: {
        "click:close": function($event) {
          return _vm.clearFilter(filter)
        }
      }
    }, [_vm._v("\n          " + _vm._s(filter.name) + " " + _vm._s(filter.value) + "\n        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-theme-material",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "defaultColDef": _vm.defaultColDef,
      "frameworkComponents": _vm.frameworkComponents,
      "columnDefs": _vm.columnDefs,
      "getRowNodeId": _vm.getRowNodeId,
      "masterDetail": true,
      "detailCellRenderer": _vm.audienceDetailRenderer,
      "getRowHeight": _vm.detailRowHeight,
      "isExternalFilterPresent": _vm.isExternalFilterPresent,
      "doesExternalFilterPass": _vm.doesExternalFilterPass,
      "tooltipShowDelay": 0,
      "rowModelType": "serverSide",
      "blockLoadDebounceMillis": 500,
      "enableRangeSelection": true,
      "allowContextMenuWithControlKey": true,
      "getContextMenuItems": _vm.getContextMenuItems,
      "overlayLoadingTemplate": "<span class='ag-overlay-loading-center'>Audiences Loading...</span>",
      "overlayNoRowsTemplate": "<div class='ag-overlay-loading-center' style='background-color: white;'><i class='far fa-frown'>0 Records Returned</i></div>",
      "rowHeight": "45"
    },
    on: {
      "gridReady": _vm.onGridReady,
      "filterChanged": _vm.onFilterChanged,
      "columnEverythingChanged": _vm.onColumnEverythingChanged
    }
  }), _vm._v(" "), _c('re-posting-modal'), _vm._v(" "), _c('delete-target-modal'), _vm._v(" "), _c('append-target-modal'), _vm._v(" "), _c('download-pid-list-modal', {
    attrs: {
      "title": "Download PID Lists"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "converged-workbench"
  }, [_c('workbench-canvas', {
    attrs: {
      "copiedTarget": _vm.copiedTarget,
      "viewOnly": _vm.viewOnly
    },
    scopedSlots: _vm._u([{
      key: "main-container",
      fn: function(workbenchSlottedValue) {
        return [(_vm.noSelectedDatasetFamily) ? [_c('div', {
          staticClass: "text-h4 text-md-center",
          staticStyle: {
            "margin-top": "20vh"
          }
        }, [_c('p', [_vm._v("Graphs will be available when you select at least one attribute")])])] : (_vm.showInsights) ? [_c('insights', {
          attrs: {
            "workbenchSlottedValue": workbenchSlottedValue.slottedValue,
            "viewOnly": _vm.viewOnly
          }
        })] : (_vm.selectedLasDatasetFamily) ? [_c('las-graphs', {
          attrs: {
            "workbenchSlottedValue": workbenchSlottedValue.slottedValue
          }
        })] : _vm._e()]
      }
    }, {
      key: "bottom-pane",
      fn: function(bottomPane) {
        return [_c('bottom-panel', {
          attrs: {
            "targetData": bottomPane.copiedTarget,
            "viewOnly": _vm.viewOnly,
            "xandrActions": _vm.noSelectedDatasetFamily || _vm.showInsights,
            "lasActions": _vm.selectedLasDatasetFamily
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('save-workbench-changes-modal', {
    ref: "saveWorkbenchChangesModal",
    attrs: {
      "newXandrTarget": _vm.copiedTarget
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-dashboard"
  }, [_c('div', {
    staticClass: "empty-dashboard__header"
  }, [_vm._v("\n    " + _vm._s(_vm.emptyMessage) + "\n  ")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "empty-dashboard__message"
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-parts"
  }, [_c('div', {
    staticClass: "day-parts__close",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("Close "), _c('svg-icon', {
    attrs: {
      "icon": _vm.closeIcon,
      "width": 12,
      "height": 12
    }
  })], 1), _vm._v(" "), _c('day-parts-legend', {
    attrs: {
      "parts": _vm.dayPartsConfig,
      "selectedParts": _vm.selectedDayParts
    },
    on: {
      "day-part-click": _vm.dayPartSelected
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "day-parts-comparison"
  }, [_c('div', {
    staticClass: "day-parts-comparison__inner-container"
  }, _vm._l((_vm.networksToShow), function(network) {
    return _c('div', {
      staticClass: "day-parts-comparison__network"
    }, [_c('h4', {
      staticStyle: {
        "position": "absolute",
        "top": "10px",
        "left": "30px"
      }
    }, [_vm._v(_vm._s(network.name))]), _vm._v(" "), _c('day-parts-graph', {
      staticClass: "workbench__day-break",
      attrs: {
        "chart-data": _vm.removeHiddenDayParts(network.data),
        "axises": _vm.dayPartAxises,
        "width": 380,
        "height": 140
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "day-parts-comparison__x-mark",
      on: {
        "click": function($event) {
          return _vm.deSelectNetwork(network.network)
        }
      }
    }, [_vm._v("\n         ✕\n       ")])], 1)
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "demoQualifierForm",
    staticClass: "d-flex pa-0",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-space-between align-center pa-0 pr-3",
    attrs: {
      "md": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "pa-0 justify-center d-flex align-end"
  }, [_vm._v(" Age Range ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "d-flex justify-space-around pa-0"
  }, [_c('v-row', {
    staticClass: "d-flex justify-space-between"
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ageDemoQualifier",
      "id": "ageDemoQualifier",
      "type": "number",
      "outlined": "",
      "dense": "",
      "hide-details": "true"
    },
    on: {
      "change": _vm.setAgeFrom
    },
    model: {
      value: (_vm.ageFrom),
      callback: function($$v) {
        _vm.ageFrom = $$v
      },
      expression: "ageFrom"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ageDemoQualifier",
      "id": "ageDemoQualifier",
      "type": "number",
      "outlined": "",
      "dense": "",
      "hide-details": "true"
    },
    on: {
      "blur": _vm.setAgeTo
    },
    model: {
      value: (_vm.ageTo),
      callback: function($$v) {
        _vm.ageTo = $$v
      },
      expression: "ageTo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "d-flex pa-0 pt-4"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "error",
      "value": !_vm.valid
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "info",
      "value": _vm.info && _vm.valid
    }
  }, [_vm._v("\n            " + _vm._s(_vm.infoMessage) + "\n            "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.infoMessageCounter
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-0 d-flex align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.genderOptions,
      "label": "Gender",
      "clearable": ""
    },
    on: {
      "change": _vm.setDemoQualifier
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-box",
    class: _vm.selectorClass,
    style: (_vm.position)
  }, [(_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popover-box__content"
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "heightOverride": 400,
      "closeButton": ""
    },
    on: {
      "closed": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "dropped_attributes_details"
  }, [(_vm.loading) ? [_c('loader-dots', {
    staticClass: "dropped_attributes_details__loading"
  })] : _vm._l((_vm.droppedAttributes), function(data) {
    return _c('div', {
      key: data.quarter
    }, [_c('div', {
      staticClass: "dropped_attributes_details__quarter-panel"
    }, [_vm._v("\n          " + _vm._s(_vm.getQuarterString(data.quarter)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "dropped_attributes_details__attribute-panel"
    }, _vm._l((data.attributes), function(attribute, i) {
      return _c('div', {
        key: i
      }, [_c('oval-label', {
        staticClass: "dropped_attributes_details__attribute"
      }, [_vm._v("\n              " + _vm._s(attribute) + "\n            ")])], 1)
    }), 0)])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    staticClass: "form-popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', [_c('action-button', {
    staticClass: "form-popover__submit-button",
    attrs: {
      "label": "Submit",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedSubmit.apply(null, arguments)
      }
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day-parts-legend"
  }, _vm._l((_vm.sortedDayParts), function(part) {
    return _c('div', {
      staticClass: "day-parts-legend__part",
      class: {
        'day-parts-legend__part--selected': _vm.isSelected(part.id)
      },
      on: {
        "click": function($event) {
          return _vm.emitDayPart(part.id)
        }
      }
    }, [_c('span', {
      staticClass: "day-parts-legend__part-color",
      style: ({
        backgroundColor: part.color
      })
    }), _vm._v("\n    " + _vm._s(part.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "1000"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 justify-end pb-0"
  }, [_c('v-icon', {
    on: {
      "click": _vm.destroySetup
    }
  }, [_vm._v("mdi-window-close")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 text-uppercase justify-center pt-0"
  }, [_vm._v("Activation Window")]), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "activation-modal__name-container"
  }, [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "audienceName",
      "label": "Audience Name",
      "id": "activationModalAudienceName",
      "readonly": "",
      "hide-details": "true",
      "dense": "",
      "filled": ""
    },
    model: {
      value: (_vm.segment.display_name),
      callback: function($$v) {
        _vm.$set(_vm.segment, "display_name", $$v)
      },
      expression: "segment.display_name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('advertiser-select', {
    attrs: {
      "initialValue": _vm.segment.advertiser,
      "showAdvertiserId": true,
      "disabled": _vm.disableAdvertiser,
      "filled": true
    },
    on: {
      "update": function (val) { return (_vm.segment.advertiser = val); }
    }
  })], 1), _vm._v(" "), (_vm.showViewingStream) ? _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('streaming-select', {
    attrs: {
      "initialValue": _vm.segment.viewing_stream,
      "viewingOption": _vm.viewingOption,
      "disabled": _vm.disableViewingStream
    },
    on: {
      "input": function (val) { return (_vm.segment.viewing_stream = val); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__bottom-container"
  }, [_c('div', {
    staticClass: "activation-modal__endpoints-area"
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('div', {
      key: destination.id,
      staticClass: "activation-modal__destinations"
    }, [_c('MVPD', {
      attrs: {
        "destination": destination,
        "selected": _vm.segment.destinations.includes(destination.id),
        "canUpdate": false,
        "UE": 0
      },
      on: {
        "selectedDestination": function($event) {
          return _vm.selectDestination(destination)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.foresiteDestinationSelected) ? _c('v-container', {
    staticClass: "activation-modal__campaign-area"
  }, [(_vm.isDigitalDestination || _vm.isDDLDestination) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('flight-dates', {
    attrs: {
      "value": {
        flightStartDate: _vm.segment.am_data.flightStartDate,
        flightEndDate: _vm.segment.am_data.flightEndDate,
      }
    },
    on: {
      "input": function (val) { return Object.assign(_vm.segment.am_data, val); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFreeWheelOrGAMDestination && _vm.hasNotBeenPreviouslyModeled) ? _c('v-divider', {
    staticClass: "mt-5 mb-5"
  }) : _vm._e(), _vm._v(" "), (_vm.isFreeWheelOrGAMDestination && _vm.hasNotBeenPreviouslyModeled) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('segment-split', {
    on: {
      "valid": function (val) { return (_vm.isSplitValid = val); },
      "segmentSplit": function (val) { return (_vm.segmentSplit = val); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFrequency) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('frequency-d-d-l', {
    attrs: {
      "initialValue": _vm.frequency,
      "optionSet": _vm.frequencyOptionSet,
      "disabled": _vm.disableFrequency
    },
    on: {
      "input": function (val) { return (_vm.segment.xandr_data.frequency = val); }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.foresiteDestinationSelected) ? _c('div', {
    staticClass: "activation-modal__broadcast-quarter-area"
  }, [_c('broadcast-quarter-select', {
    on: {
      "input": function (val) { return (_vm.broadcastQuarter = val); }
    }
  }), _vm._v(" "), _c('demo-qualifier', {
    on: {
      "demoQualifier": function (val) { return (_vm.demoQualifier = val); }
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.showAdvertiserRequiredMessage) ? _c('v-row', {
    staticClass: "justify-space-around subtitle-1 font-weight-bold"
  }, [_vm._v("\n        Advertiser is required in order to send downstream\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-6",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('v-row', {
    staticClass: "justify-space-around"
  }, [(!_vm.activatingAudience && !_vm.disableSendDownstream) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.disableSendDownstream,
      "label": "Send Downstream",
      "color": "primary",
      "id": "sendDownstreamModalBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitDownstream.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-data-source"
  }, [_c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "select-data-source__icons"
  }, [_vm._l((_vm.availableDatasources), function(dataSource) {
    return [_c('div', {
      key: dataSource.id
    }, [_c('div', [_c('img', {
      staticClass: "select-data-source__icon-def select-data-source__data-icon select-data-source__data-icon--def",
      attrs: {
        "id": ("datasource-id-" + (dataSource.id)),
        "src": _vm.value === dataSource.id ? dataSource.img.selected : dataSource.img.default
      },
      on: {
        "click": function () { return _vm.emit(dataSource.id); }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "select-data-source__title"
    }, [_vm._v(_vm._s(dataSource.title))])])]
  })], 2)])]), _vm._v(" "), (_vm.attachFileEnabled) ? _c('div', {
    staticClass: "select-data-source__atach-a-file"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "select-data-source__attach-button-area"
  }, [_c('action-button', {
    attrs: {
      "dark": _vm.selectedOnFile,
      "label": "Attach A File",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFile.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-data-source__select-data-source-area"
  }, [_c('div', [_vm._v("Select Data Source")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-data-source__or-bar"
  }, [_c('hr', {
    staticClass: "select-data-source__border-bar"
  }), _vm._v(" "), _c('span', [_vm._v("OR")]), _vm._v(" "), _c('hr', {
    staticClass: "select-data-source__border-bar"
  })])
}]}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "simple-button",
    class: _vm.disabled ? 'simple-button--disabled' : '',
    attrs: {
      "disabled": _vm.disabled,
      "id": ("simple-button-" + (_vm.text.split(/\s/g).join('')))
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.doneLoading) ? _c('div', {
    staticClass: "api-error-message"
  }, [_c('p', [_vm._v("\n    Currently " + _vm._s(_vm.apiName) + " is unavailable.\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dot",
    on: {
      "click": _vm.showNotificationsClickEvent
    }
  }, [_c('span', {
    staticClass: "dot__text-align"
  }, [_vm._v(_vm._s(_vm.newNotificationCount))])])
},staticRenderFns: []}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-pane-sizer"
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('small')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('small')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__small"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('medium')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('medium')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__medium"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('large')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('large')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__large"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": "",
      "nudge-width": 100,
      "left": "",
      "offset-x": "",
      "attach": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mx-2",
          attrs: {
            "fab": "",
            "dark": "",
            "small": "",
            "color": "primary",
            "elevation": "24"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": "",
            "dark": ""
          }
        }, [_vm._v("\n          mdi-plus-thick\n        ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-list', _vm._l((_vm.menuItems), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          return _vm.$emit('select', index)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "menu-item-name"
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('chart-layout', {
    attrs: {
      "title": _vm.title,
      "yAxis": _vm.yAxis,
      "xAxis": _vm.xAxis
    }
  }, [_c('bar-graph', {
    attrs: {
      "chart-data": _vm.data,
      "chart-id": _vm.chartIdOverride,
      "type": _vm.type
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('create-target-slot', {
    attrs: {
      "title": _vm.title,
      "showBackButton": _vm.showBackButton,
      "png": _vm.dataSourceIcon
    }
  }, [_c('create-ad', {
    attrs: {
      "targetName": _vm.targetName,
      "onComplete": _vm.onComplete
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      light: _vm.light
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    class: {
      'placeholder-not-showing': !_vm.showPlaceholder,
      'custom-select': true,
      'vue-select': true,
      'vue-select__disabled': _vm.disabled,
      'vue-select__medium': _vm.isMedium
    },
    attrs: {
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "value": _vm.fullValue,
      "multiple": false,
      "clear-on-select": false,
      "hide-selected": true,
      "label": _vm.label,
      "track-by": "name",
      "debounce": 250,
      "disabled": _vm.disabled,
      "on-search": _vm.searchOptions,
      "loading": _vm.loading
    },
    on: {
      "input": _vm.emitInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "metrics-banner"
  }, _vm._l((_vm.metricsArray), function(metric) {
    return _c('div', {
      staticClass: "metrics-banner__metric"
    }, [_c('svg-icon', {
      staticClass: "metrics-banner__icon",
      attrs: {
        "icon": metric.icon
      }
    }), _vm._v(" "), (_vm.loading) ? _c('span', {
      staticClass: "metrics-banner__loading"
    }, [_vm._v("…")]) : _c('span', [_vm._v(_vm._s(metric.text))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "modal",
    class: {
      'modal__is-relative': _vm.relativeToParent
    }
  }, [(_vm.hasBg) ? _c('div', {
    staticClass: "modal__bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "modal__container",
    style: (_vm.modalWidth)
  }, [_c('div', {
    staticClass: "modal__header-actions"
  }, [_vm._t("header-buttons"), _vm._v(" "), (_vm.closeButton) ? _c('div', {
    staticClass: "modal__close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.cancel,
      "width": 12,
      "height": 12
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (!_vm.loading) ? [_c('div', {
    ref: "content",
    staticClass: "modal__content",
    class: {
      'modal__content--no-padding': _vm.removePadding
    },
    style: (_vm.contentHeightStyle)
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.hideActions) ? _c('div', {
    staticClass: "modal__actions"
  }, [_vm._t("actions")], 2) : _vm._e()] : _c('div', {
    staticClass: "modal__loading-container"
  }, [_c('loading-dots')], 1)], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-bracket",
    class: _vm.classes,
    attrs: {
      "draggable": _vm.isDraggable
    },
    on: {
      "dragstart": _vm.dragStartHandler,
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler
    }
  }, [_c('svg-icon', {
    key: _vm.attribute.definitionId,
    attrs: {
      "icon": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.select(_vm.attribute)
      }
    }
  }), _vm._v(" "), (_vm.showMustMatch) ? _c('span', {
    staticClass: "definition-bracket__count-group",
    on: {
      "dblclick": _vm.clickHandler
    }
  }, [_vm._v(_vm._s(_vm.attribute.mustMatch))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs__list"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      staticClass: "tabs__list-item",
      class: {
        'tabs__list-item--active': tab.isActive
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(tab.id)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tabs__content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "confirm",
    attrs: {
      "width": 500
    }
  }, [_c('div', {
    staticClass: "confirmation-modal-text"
  }, [_vm._v("\n    You have unsaved changes on your target.\n    Are you sure you would like to disregard your changes?\n  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('action-button', {
    attrs: {
      "id": "confirmSaveBtn",
      "color": "success",
      "label": _vm.saveButton
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelHandler.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "id": "confirmGoToDashboardBtn",
      "color": "light-blue lighten-1",
      "label": "Continue to Dashboard"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueHandler.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "heightOverride": 300,
      "closeButton": "",
      "hideActions": ""
    }
  }, [_c('div', {
    staticClass: "re-posting-modal"
  }, [_c('div', {
    staticClass: "text-h4 font-weight-medium"
  }, [_vm._v("\n      Re-Forecast Target\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('target-details', {
    attrs: {
      "target": _vm.currentTarget
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4 mb-1 red--text text--lighten-1"
  }, [_vm._v("\n      Select the start month to re-forecast the target\n    ")]), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "item-value": "value",
      "label": "Start Month",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.selectedDate = val; }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-7"
  }, [_c('action-button', {
    attrs: {
      "disabled": _vm.hasSelectedDate,
      "color": "secondary",
      "label": "Post Target",
      "id": "rePostBtn",
      "ma-4": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.rePostTarget.apply(null, arguments)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-dots"
  }, _vm._l(([0, 1, 2]), function(idx) {
    return _c('div', {
      staticClass: "loading-dots__dot",
      class: ("loading-dots__dot--" + idx)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-popover', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "currentValue": _vm.currentValue,
      "multiSelect": _vm.multiSelect,
      "align": "center",
      "list": _vm.list
    },
    on: {
      "select": _vm.selectOption
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('styled-select', {
    ref: "select",
    staticClass: "campaign-select",
    attrs: {
      "value": _vm.value,
      "size": 2,
      "returnValue": "",
      "options": _vm.options,
      "disabled": _vm.disabled,
      "placeholder": "Select Campaign"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-actions"
  }, [(_vm.showSendDownStream) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": !_vm.isSendDownStreamEnabled,
      "color": "primary",
      "label": "send downstream"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitToDC.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGenerateEstimate) ? _c('action-button', {
    attrs: {
      "dark": "",
      "color": "primary",
      "label": _vm.activateLabel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.generateEstimate.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDuplicate) ? _c('action-button', {
    attrs: {
      "dark": "",
      "color": "secondary",
      "label": "Duplicate"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.duplicate.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.allowDownloadBtn) ? _c('action-button', {
    attrs: {
      "dark": "",
      "color": "secondary",
      "label": "download"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downloadTargetPackage.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.canNotUndo,
      "color": "secondary",
      "dark": "",
      "label": "undo"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.undo.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.canNotRedo,
      "color": "secondary",
      "dark": "",
      "label": "redo"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.redo.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.isClearAllDisabled,
      "color": "secondary",
      "dark": "",
      "label": "Clear All"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clear.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "disabled": !_vm.isSaveEnabled,
      "color": "success",
      "label": _vm.saveLabel,
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "item-value": "value",
      "label": "Broadcast Quarter"
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "start",
      "no-gutters": ""
    }
  }, _vm._l((_vm.params.value), function(source) {
    return _c('v-col', {
      key: source,
      staticClass: "pa-1",
      attrs: {
        "cols": "2",
        "sm": "3",
        "md": "6",
        "lg": "4",
        "xl": "2"
      }
    }, [_c('v-img', {
      attrs: {
        "contain": "",
        "source": source,
        "src": _vm.targetImage(source),
        "aspect-ratio": "1"
      }
    })], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('revision-history-panel', {
    attrs: {
      "revisionHistories": _vm.currentRevisionHistories,
      "branches": _vm.branches,
      "selectedBranch": _vm.currentBranchId,
      "selectedRevision": _vm.currentRevisionHistoryId,
      "onClickRevisionHistory": _vm.clickRevisionHistory,
      "onClickBranch": _vm.clickBranch,
      "currentAudience": _vm.currentAudience,
      "createNewBranch": _vm.createNewBranchPopover,
      "heightOfRevisions": _vm.heightOfRevisions,
      "heightOfBranches": _vm.heightOfBranches,
      "deleteBranch": _vm.deleteBranch
    }
  }) : _c('div', {
    staticClass: "missing_history_message"
  }, [_vm._v("No revision history")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-popover', {
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    },
    on: {
      "submit": _vm.submit
    }
  }, [_c('div', [_c('label', {
    staticClass: "form-popover__label",
    attrs: {
      "tabindex": "1"
    }
  }, [_vm._v(_vm._s(_vm.formLabel))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueInput),
      expression: "valueInput"
    }],
    staticClass: "form-popover__input",
    attrs: {
      "autofocus": "",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.valueInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueInput = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "60vw"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "dark": "",
            "small": "",
            "icon": ""
          },
          on: {
            "click": _vm.editPermissions
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "dark": "",
            "color": "info"
          }
        }, [_vm._v("mdi-account-edit")])], 1)]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-card', {
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-1 mt-2 ml-2"
  }, [_vm._v("\n        " + _vm._s(_vm.titleText) + "\n      ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "60vh"
    }
  }, [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "value": _vm.overlay
    }
  }, [_c('v-container', {
    staticStyle: {
      "width": "40vw"
    }
  }, [_c('v-row', {
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": "8"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.permissionsList,
      "item-key": "id",
      "sort-by": "id",
      "group-by": "actions",
      "checkbox-color": "blue",
      "fixed-header": "",
      "hide-default-footer": "",
      "disable-pagination": "",
      "show-select": "",
      "show-group-by": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-container', {
    staticStyle: {
      "max-width": "50%"
    },
    attrs: {
      "justify-space-around": "",
      "d-flex": ""
    }
  }, [_c('v-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('action-button', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "color": "secondary",
      "label": "Close",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('action-button', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "color": "success",
      "label": "Save",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveChanges.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 justify-end pb-0"
  }, [_c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("mdi-window-close")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 text-uppercase justify-center pt-0 pb-0"
  }, [_vm._v("Request VideoAmp Audience")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0 mb-5"
  }, [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonClicked),
      expression: "buttonClicked"
    }],
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-autocomplete', {
    staticClass: "ma-12",
    attrs: {
      "items": _vm.items,
      "item-text": "name",
      "item-value": "id",
      "label": "VideoAmp Audience",
      "menu-props": {
        maxWidth: 396
      },
      "dense": "",
      "clearable": "",
      "item-disabled": function (item) { return item.disabled; },
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function (val) { return _vm.$emit('update', val); }
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center pb-8"
  }, [_c('action-button', {
    attrs: {
      "light": "",
      "disabled": _vm.disableRequestAudience,
      "label": "Submit",
      "color": "primary",
      "id": "requestVideoAmpAudienceBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestAudience.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-pane-sizer"
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('small')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('small')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__small"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('medium')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('medium')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__medium"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-pane-sizer__button",
    class: {
      'bottom-pane-sizer__button--active': _vm.isActive('large')
    },
    on: {
      "click": function($event) {
        return _vm.setSizeTo('large')
      }
    }
  }, [_c('div', {
    staticClass: "bottom-pane-sizer__large"
  })])])
},staticRenderFns: []}

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'viewership-block': !_vm.isGraphOnly
    }
  }, [_c('div', {
    staticClass: "viewership-block__header"
  }, [_c('div', [_c('h4', [_vm._v("Viewership -\n         "), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('toggle-button', {
    staticClass: "viewership-block__toggle-button",
    attrs: {
      "left-label": "Graph",
      "right-label": "Table",
      "toggle-value": !_vm.changeToTable
    },
    on: {
      "toggle": _vm.toggleDisplayOfData
    }
  })] : _vm._e()], 2), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('small', {
    staticClass: "viewership-block__tip"
  }, [_vm._v("*Select networks below to see Daypart breakdowns.")])] : _vm._e()], 2), _vm._v(" "), (!_vm.isGraphOnly) ? [_c('date-range', {
    staticClass: "viewership-block__date-range"
  }), _vm._v(" "), (!_vm.isTargetActivated && _vm.showFilter) ? _c('action-button', {
    attrs: {
      "color": "secondary",
      "id": "networksBtn",
      "label": "Networks"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNetworksModal.apply(null, arguments)
      }
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (!_vm.changeToTable) ? [_c('div', {
    staticClass: "viewership-block__graph-container"
  }, [_c('div', {
    staticClass: "viewership-block__y-title"
  }, [_vm._v("Index")]), _vm._v(" "), _c('div', {
    staticClass: "viewership-block__x-title"
  }, [_vm._v("Rating")]), _vm._v(" "), (_vm.allowViewershipToRender) ? _c('viewership-graph', {
    ref: "viewershipGraph",
    staticClass: "viewership-block__graph",
    attrs: {
      "chartData": _vm.dataForGraph,
      "axises": _vm.axises,
      "onClick": _vm.viwershipOnClick
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewershipData) ? _c('api-error-message', {
    attrs: {
      "api-name": "viewership graph data"
    }
  }) : _vm._e()], 1)] : [_c('div', {
    staticClass: "viewership-block__table-container"
  }, [_c('styled-table', {
    attrs: {
      "theme": "light",
      "data": _vm.dataForTable,
      "headers": _vm.tableHeaders,
      "sort": {
        prop: "size",
        order: "descending"
      }
    },
    on: {
      "sort-change": _vm.handleSortChange
    },
    scopedSlots: _vm._u([{
      key: "item.size",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n           " + _vm._s(_vm.formatAudienceSize(item.size)) + "\n         ")]
      }
    }])
  })], 1)], _vm._v(" "), (!_vm.isGraphOnly) ? [(!_vm.isTargetActivated && _vm.showFilter) ? _c('viewership-filter', {
    ref: "filter",
    attrs: {
      "networks": _vm.networks,
      "selected-networks": _vm.selectedViewershipNetworks
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "data-source-step__target-name"
  }, [_vm._v("\n      " + _vm._s(_vm.targetName) + "\n    ")]), _vm._v(" "), _c('select-data-source', {
    model: {
      value: (_vm.selectedDataSource),
      callback: function($$v) {
        _vm.selectedDataSource = $$v
      },
      expression: "selectedDataSource"
    }
  })], 1), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-selector"
  }, [_c('vue-slider', {
    ref: "slider",
    staticClass: "range-selector__slider",
    attrs: {
      "piecewise": false,
      "width": "270px",
      "height": 6,
      "interval": _vm.interval,
      "dotSize": 12,
      "min": this.attribute.min,
      "max": this.attribute.max,
      "disabled": false,
      "show": true,
      "tooltip": "always",
      "tooltipDir": ['top', 'top'],
      "bgStyle": _vm.bgStyle,
      "sliderStyle": [_vm.sliderStyle, _vm.sliderStyle],
      "tooltipStyle": [_vm.tooltipStyle, _vm.tooltipStyle],
      "processStyle": _vm.processStyle,
      "labelStyle": _vm.labelStyle,
      "formatter": _vm.formatString,
      "clickable": false
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "range-selector__submit-button",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('svg-icon', {
    attrs: {
      "width": "16px",
      "height": "16px",
      "icon": _vm.Check
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('target-form-styles', [_c('div', {
    staticClass: "create-target-form__name-section"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": true,
      "targetType": _vm.target.target,
      "initialValue": _vm.targetNameInitialValue,
      "disabled": false
    },
    on: {
      "updateName": function (val) { return (_vm.target.display_name = val); },
      "updateNameIsValid": function (isValid) { return (_vm.nameIsValid = isValid); }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "create-las__options-area"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('advertiser-select', {
    ref: "advertiserSelect",
    staticClass: "vue-select",
    attrs: {
      "label": _vm.hasResearchIntent ? 'Advertiser (Optional)' : 'Advertiser',
      "initialValue": _vm.target.advertiser,
      "disabled": _vm.hasMarketingIntent
    },
    on: {
      "update": function (val) { return (_vm.target.advertiser = val); }
    }
  })], 1), _vm._v(" "), (_vm.hasMarketingIntent) ? _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('streaming-select', {
    attrs: {
      "viewingOption": 5
    },
    model: {
      value: (_vm.target.viewing_stream),
      callback: function($$v) {
        _vm.$set(_vm.target, "viewing_stream", $$v)
      },
      expression: "target.viewing_stream"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasMarketingIntent) ? _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('marketing-network-select', {
    ref: "marketingNetworkSelect",
    staticClass: "vue-select",
    attrs: {
      "placeholder": "Select",
      "initialValue": _vm.initialNetwork
    },
    on: {
      "update": function (val) { return _vm.selectedNetwork(val); }
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evenly-distributed justify-space-around"
  }, [_c('action-button', {
    attrs: {
      "label": _vm.buttonLabel,
      "id": "adBuildAudienceBtn",
      "color": "secondary",
      "disabled": !_vm.buttonClickable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 justify-end pb-0"
  }, [_c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("mdi-window-close")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 text-uppercase justify-center pt-0 pb-0"
  }, [_vm._v("Retargeting Request")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0 mb-5"
  }, [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonClicked),
      expression: "buttonClicked"
    }],
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('v-text-field', {
    ref: "requestName",
    attrs: {
      "name": "requestName",
      "label": "Name",
      "id": "RetargetingRequestName",
      "rules": _vm.retargetingRequestNameRules,
      "readonly": _vm.buttonClicked
    },
    model: {
      value: (_vm.requestName),
      callback: function($$v) {
        _vm.requestName = $$v
      },
      expression: "requestName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "placementId",
    attrs: {
      "name": "placementId",
      "label": "FW Placement ID",
      "id": "FWPlacementId",
      "rules": _vm.placementIdRules,
      "readonly": _vm.buttonClicked
    },
    model: {
      value: (_vm.FWPlacementID),
      callback: function($$v) {
        _vm.FWPlacementID = $$v
      },
      expression: "FWPlacementID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-menu', {
    ref: "startDateMenu",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Start Date",
            "prepend-inner-icon": "mdi-calendar",
            "readonly": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateMenu),
      callback: function($$v) {
        _vm.startDateMenu = $$v
      },
      expression: "startDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "max": _vm.endDate,
      "no-title": ""
    },
    on: {
      "input": _vm.handleStartDateChange
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("-")]), _vm._v(" "), _c('v-menu', {
    ref: "endDateMenu",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "End Date",
            "prepend-inner-icon": "mdi-calendar",
            "readonly": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateMenu),
      callback: function($$v) {
        _vm.endDateMenu = $$v
      },
      expression: "endDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.startDate,
      "no-title": ""
    },
    on: {
      "input": _vm.handleEndDateChange
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center pb-8"
  }, [_c('action-button', {
    attrs: {
      "light": "",
      "disabled": !_vm.isFormValid || _vm.buttonClicked,
      "label": "Submit",
      "color": "primary",
      "id": "requestVideoAmpAudienceBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.retargetingRequest.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-from-to"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "date-from-to__datepicker-container"
  }, [_c('span', {
    staticClass: "date-from-to__datepicker-seperator"
  }, [_c('datepicker', {
    attrs: {
      "lang": "eng",
      "value": _vm.value.from,
      "not-before": _vm.fromNotBeforeDate,
      "not-after": _vm.fromEndDate,
      "disabled": _vm.disableFrom || _vm.disableTo,
      "clear": function (e) { return _vm.changeFrom(null); },
      "input-class": "mx-input date-from-to__datepicker-input"
    },
    on: {
      "input": _vm.changeFrom
    }
  })], 1), _vm._v(" "), _c('span', [_c('datepicker', {
    attrs: {
      "lang": "eng",
      "value": _vm.value.to,
      "disabled": !_vm.enableTo,
      "not-before": _vm.toStartDate,
      "clear": function (e) { return _vm.changeTo(null); },
      "input-class": "mx-input date-from-to__datepicker-input"
    },
    on: {
      "input": _vm.changeTo
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('chart-layout', {
    attrs: {
      "title": _vm.title,
      "yAxis": _vm.yAxis,
      "xAxis": _vm.xAxis
    }
  }, [_c('bar-graph', {
    attrs: {
      "chart-data": _vm.data,
      "chart-id": _vm.chartIdOverride,
      "labelFunc": _vm.displayLabel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    staticClass: "list-popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, _vm._l((_vm.list), function(option) {
    return _c('div', {
      staticClass: "list-popover__option",
      class: _vm.optionClass(option.value),
      style: (_vm.optionStyle),
      attrs: {
        "id": ("popover-box-option-" + (option.name))
      },
      on: {
        "click": function($event) {
          return _vm.selectOption(option.value)
        }
      }
    }, [_vm._v("\n    " + _vm._s(option.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-pid-modal"
  }, [_c('modal', {
    ref: "modal",
    attrs: {
      "autoWidth": "",
      "closeButton": "",
      "width": 400
    },
    on: {
      "closed": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "download-pid-modal__modal center"
  }, [_c('div', {
    staticClass: "download-pid-modal__header-menu"
  }, [_c('h2', {
    staticClass: "download-pid-modal__header"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('h4', {
    staticClass: "download-pid-modal__target-name",
    attrs: {
      "title": _vm.target.display_name
    }
  }, [_vm._v(_vm._s(_vm.target.display_name))]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticClass: "center"
  }, [_c('loading-dots')], 1) : (!_vm.hasPidLists) ? _c('span', [_vm._v("No PID lists found for target!")]) : _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.onSelectAll
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Filename")]), _vm._v(" "), _c('th', {
    staticClass: "file-extension"
  }, [_vm._v("Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.localPidLists), function(list) {
    return _c('tr', [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.selected),
        expression: "list.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(list.selected) ? _vm._i(list.selected, null) > -1 : (list.selected)
      },
      on: {
        "change": function($event) {
          var $$a = list.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(list, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(list, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(list, "selected", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((_vm.target.display_name) + "_" + (list.suffix))))]), _vm._v(" "), _c('td', {
      staticClass: "file-extension"
    }, [_vm._v(_vm._s(_vm.getFileExtension(list.name)))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "download-pid-modal__button center"
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.buttonClickable,
      "color": "success",
      "label": "Download PID Lists",
      "id": "downloadPidListsBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.download.apply(null, arguments)
      }
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('feedback-modal', {
    ref: "feedbackModal",
    staticClass: "dashboard-action-modal"
  }, [_c('div', {
    staticClass: "dashboard-action-modal__message"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('simple-button', {
    staticClass: "dashboard-action-modal__button",
    attrs: {
      "text": _vm.buttonText
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "flag",
    class: [_vm.colorClass]
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[769]);


// WEBPACK FOOTER //
// static/js/app.dfa4f11603453c697a74.js